import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Decimal: { input: string; output: string; }
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

/** Accepted result format */
export type AcceptedResult = {
  __typename?: 'AcceptedResult';
  code: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

/** The Access Enum */
export enum AccessEnum {
  /** Acesso completo */
  Full = 'FULL',
  /** Sem acesso */
  NoAccess = 'NO_ACCESS',
  /** Somente leitura */
  ReadOnly = 'READ_ONLY'
}

/** An Access Group */
export type AccessGroup = {
  __typename?: 'AccessGroup';
  actor: Actor;
  allowedOperations: Array<Operation>;
  dashboardAccesses: Array<DashboardAccess>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

/** The Action Type Enum */
export enum ActionType {
  /** Cancelar */
  Cancel = 'CANCEL',
  /** Deletar */
  Delete = 'DELETE',
  /** Finalizar */
  Finish = 'FINISH',
  /** Descancelar */
  Uncancel = 'UNCANCEL',
  /** Desfinalizar */
  Unfinish = 'UNFINISH',
  /** Criar/Atualizar */
  Upsert = 'UPSERT'
}

/** An Actor */
export type Actor = {
  __typename?: 'Actor';
  addresses: Array<Address>;
  cnae: Maybe<Scalars['String']['output']>;
  documentType: Maybe<ActorDocumentTypeEnum>;
  flowlsDataCode: Maybe<Scalars['String']['output']>;
  hasCosts: Scalars['Boolean']['output'];
  holding: Maybe<Actor>;
  holdingActors: Maybe<Array<Actor>>;
  id: Scalars['Int']['output'];
  internalCode: Maybe<Scalars['String']['output']>;
  logoUrl: Maybe<Scalars['String']['output']>;
  nickname: Scalars['String']['output'];
  officialDocument: Maybe<Scalars['String']['output']>;
  officialName: Scalars['String']['output'];
  openingDate: Maybe<Scalars['Date']['output']>;
  partnershipAsPartner: Maybe<Partnership>;
  /** @deprecated Migrated logic to self partnerships */
  roles: Array<OperationHandlerEnum>;
  rootCnpjs: Array<Scalars['String']['output']>;
  subsidiaries: Array<Subsidiary>;
  tradingName: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
};

/** The Document Type Enum */
export enum ActorDocumentTypeEnum {
  /** CNPJ */
  Cnpj = 'CNPJ',
  /** CPF */
  Cpf = 'CPF',
  /** Código Interno */
  InternalCode = 'INTERNAL_CODE',
  /** TIN */
  Tin = 'TIN'
}

/** The Actor Order By Enum */
export enum ActorOrderByEnum {
  /** CNAE */
  Cnae = 'CNAE',
  /** Tipo de documento */
  DocumentType = 'DOCUMENT_TYPE',
  /** Código do Flowls Data */
  FlowlsDataCode = 'FLOWLS_DATA_CODE',
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Nickname */
  Nickname = 'NICKNAME',
  /** Documento oficial */
  OfficialDocument = 'OFFICIAL_DOCUMENT',
  /** Nome oficial */
  OfficialName = 'OFFICIAL_NAME',
  /** Data de abertura */
  OpeningDate = 'OPENING_DATE',
  /** Nome fantasia */
  TradingName = 'TRADING_NAME',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT',
  /** Verificado */
  Verified = 'VERIFIED'
}

export type ActorOrderParams = {
  field?: InputMaybe<ActorOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Actors */
export type ActorPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActorOrderParams>>;
};

/** An Address */
export type Address = {
  __typename?: 'Address';
  actor: Maybe<Actor>;
  city: Maybe<Scalars['String']['output']>;
  complement: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  fences: Array<Fence>;
  formattedAddress: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  latitude: Scalars['String']['output'];
  longitude: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  neighborhood: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['String']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
  reference: Maybe<Scalars['String']['output']>;
  routePoints: Array<RoutePoint>;
  state: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
};

/** A Agent */
export type Agent = {
  __typename?: 'Agent';
  actions: Array<AgentActionConfig>;
  canGenerateCurl: Scalars['Boolean']['output'];
  concurrencyLimit: Maybe<Scalars['Int']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  lastExecutionAt: Maybe<Scalars['DateTime']['output']>;
  maxExecutions: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  processor: Processor;
  triggerEventConfig: Maybe<EventAgentConfig>;
  triggerRecurringConfig: Maybe<RecurringAgentConfig>;
  triggerType: AgentTriggerTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
  webhookProcessorHeaders: Maybe<Array<WebhookProcessorHeader>>;
  webhookProcessorUrl: Maybe<Scalars['String']['output']>;
};

/** A Agent action config */
export type AgentActionConfig = {
  __typename?: 'AgentActionConfig';
  type: ProcessorActionTypeEnum;
};

/** Parameters for a Agent action */
export type AgentActionConfigParams = {
  type: ProcessorActionTypeEnum;
};

/** A mapping of an entity type to its allowed related entity types */
export type AgentEntityRelatedEntitiesMap = {
  __typename?: 'AgentEntityRelatedEntitiesMap';
  entity: AgentEntityTypeEnum;
  relatedEntities: Array<AgentRelatedEntityTypeEnum>;
};

/** The Agent entity type enum */
export enum AgentEntityTypeEnum {
  /** LPCO */
  Lpco = 'LPCO',
  /** Order */
  Order = 'ORDER',
  /** Process */
  Process = 'PROCESS'
}

/** A Agent execution (list view — log fields excluded) */
export type AgentExecution = {
  __typename?: 'AgentExecution';
  agent: Agent;
  callbackUrl: Maybe<Scalars['String']['output']>;
  devConfig: Maybe<AgentExecutionDevConfig>;
  devMode: Scalars['Boolean']['output'];
  executionEndAt: Maybe<Scalars['DateTime']['output']>;
  executionStartAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  lpco: Maybe<Lpco>;
  order: Maybe<Order>;
  process: Maybe<Process>;
  status: AgentExecutionStatusEnum;
  updatedAt: Scalars['DateTime']['output'];
};

/** Parameters for the agent execution callback */
export type AgentExecutionCallbackParams = {
  errors?: InputMaybe<Scalars['JSON']['input']>;
  insights?: InputMaybe<Array<UpsertInsightParams>>;
  orders?: InputMaybe<Array<UpsertOrderParams>>;
  processes?: InputMaybe<Array<UpsertProcessParams>>;
  success: Scalars['Boolean']['input'];
};

/** A Agent execution with full log detail */
export type AgentExecutionDetail = {
  __typename?: 'AgentExecutionDetail';
  actionsLog: Maybe<Scalars['JSON']['output']>;
  agent: Agent;
  callbackUrl: Maybe<Scalars['String']['output']>;
  devConfig: Maybe<AgentExecutionDevConfig>;
  devMode: Scalars['Boolean']['output'];
  executionEndAt: Maybe<Scalars['DateTime']['output']>;
  executionStartAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  inputLog: Maybe<Scalars['JSON']['output']>;
  insertedAt: Scalars['DateTime']['output'];
  lpco: Maybe<Lpco>;
  order: Maybe<Order>;
  process: Maybe<Process>;
  processorResultLog: Maybe<Scalars['JSON']['output']>;
  status: AgentExecutionStatusEnum;
  updatedAt: Scalars['DateTime']['output'];
};

/** Dev config for a dev agent execution */
export type AgentExecutionDevConfig = {
  __typename?: 'AgentExecutionDevConfig';
  callbackCurl: Maybe<Scalars['String']['output']>;
  curl: Maybe<Scalars['String']['output']>;
  runMode: AgentTestRunModeEnum;
  skipActions: Scalars['Boolean']['output'];
};

/** The Agent execution Order By Enum */
export enum AgentExecutionOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT'
}

export type AgentExecutionOrderParams = {
  field?: InputMaybe<AgentExecutionOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Pagination parameters for Agent executions */
export type AgentExecutionPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AgentExecutionOrderParams>>;
};

/** The Agent execution status enum */
export enum AgentExecutionStatusEnum {
  /** One or more actions failed to execute */
  ActionsFailed = 'ACTIONS_FAILED',
  /** Could not send to processor */
  CouldNotSendToProcessor = 'COULD_NOT_SEND_TO_PROCESSOR',
  /** Processor returned error */
  ProcessorReturnedError = 'PROCESSOR_RETURNED_ERROR',
  /** Processor returned invalid params */
  ProcessorReturnedInvalidParams = 'PROCESSOR_RETURNED_INVALID_PARAMS',
  /** Queued */
  Queued = 'QUEUED',
  /** Running */
  Running = 'RUNNING',
  /** Successful */
  Successful = 'SUCCESSFUL',
  /** Timed out */
  TimedOut = 'TIMED_OUT'
}

/** Pagination parameters for Agents */
export type AgentPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The Agent related entity type enum */
export enum AgentRelatedEntityTypeEnum {
  /** Orders */
  Orders = 'ORDERS',
  /** Processes */
  Processes = 'PROCESSES'
}

export type AgentTestInputParams = {
  entityId?: InputMaybe<Scalars['ID']['input']>;
  entityType?: InputMaybe<AgentEntityTypeEnum>;
  input?: InputMaybe<Scalars['JSON']['input']>;
};

/** Run mode for a dev agent execution */
export enum AgentTestRunModeEnum {
  /** Enqueue the execution for processing */
  Dispatch = 'DISPATCH',
  /** Generate a cURL command for manual testing */
  ManualCurl = 'MANUAL_CURL'
}

/** The Agent trigger event enum */
export enum AgentTriggerEventEnum {
  /** Created */
  Created = 'CREATED',
  /** Updated */
  Updated = 'UPDATED'
}

/** The Agent trigger type enum */
export enum AgentTriggerTypeEnum {
  /** Event trigger */
  EventTrigger = 'EVENT_TRIGGER',
  /** Received mail */
  ReceivedMail = 'RECEIVED_MAIL',
  /** Received Teams message */
  ReceivedTeamsMessage = 'RECEIVED_TEAMS_MESSAGE',
  /** Recurring schedule */
  RecurringSchedule = 'RECURRING_SCHEDULE',
  /** Webhook */
  Webhook = 'WEBHOOK'
}

/** A Cost Model Aggregated */
export type AggregatedCosts = {
  __typename?: 'AggregatedCosts';
  calculatedTotals: CostModelAggregatedTotals;
  costModel: CostModel;
  processesCount: Scalars['Int']['output'];
  rootModelExpenses: Array<CostModelExpense>;
};

/** An Air Transport Shipment */
export type AirTransportShipment = {
  __typename?: 'AirTransportShipment';
  airline: Maybe<Airline>;
  awb: Maybe<Scalars['String']['output']>;
  destinationAirport: Maybe<Airport>;
  foreignTradeShipment: ForeignTradeShipment;
  hawb: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  originAirport: Maybe<Airport>;
  type: Maybe<AirTransportTypeEnum>;
};

/** The Air Transport Type Enum */
export enum AirTransportTypeEnum {
  /** Envirotainer */
  Envirotainer = 'ENVIROTAINER',
  /** Carga Solta */
  LooseCargo = 'LOOSE_CARGO',
  /** Palete */
  Pallet = 'PALLET'
}

/** An Airline */
export type Airline = {
  __typename?: 'Airline';
  callsign: Maybe<Scalars['String']['output']>;
  country: Maybe<Country>;
  hubCode: Maybe<Scalars['String']['output']>;
  iataCode: Maybe<Scalars['String']['output']>;
  icaoCode: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** The Airline Order By Enum */
export enum AirlineOrderByEnum {
  /** Apelido */
  Callsign = 'CALLSIGN',
  /** Código Aeroportuário IATA */
  IataCode = 'IATA_CODE',
  /** Código Aeroportuário ICAO */
  IcaoCode = 'ICAO_CODE',
  /** ID */
  Id = 'ID',
  /** Nome */
  Name = 'NAME'
}

/** Available parameters to order Airlines */
export type AirlineOrderParams = {
  field?: InputMaybe<AirlineOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** An Airport */
export type Airport = {
  __typename?: 'Airport';
  cityIataCode: Maybe<Scalars['String']['output']>;
  country: Maybe<Country>;
  iataCode: Scalars['String']['output'];
  icaoCode: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  latitude: Maybe<Scalars['Float']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  timezone: Maybe<Scalars['String']['output']>;
};

/** The Airport Order By Enum */
export enum AirportOrderByEnum {
  /** Código de Localização IATA */
  CityIataCode = 'CITY_IATA_CODE',
  /** Código Aeroportuário IATA */
  IataCode = 'IATA_CODE',
  /** Código Aeroportuário ICAO */
  IcaoCode = 'ICAO_CODE',
  /** ID */
  Id = 'ID',
  /** Nome */
  Name = 'NAME'
}

/** Available parameters to order Airports */
export type AirportOrderParams = {
  field?: InputMaybe<AirportOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** AIS class enum */
export enum AisClassEnum {
  /** A */
  A = 'A',
  /** B */
  B = 'B'
}

/** The Alert Level Enum */
export enum AlertLevelEnum {
  /** Crítico */
  Danger = 'DANGER',
  /** Normal */
  Normal = 'NORMAL',
  /** Atenção */
  Warning = 'WARNING'
}

/** A Count Overview By Alert Level */
export type AlertLevelOverview = {
  __typename?: 'AlertLevelOverview';
  dangerCount: Scalars['Int']['output'];
  normalCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  warningCount: Scalars['Int']['output'];
};

/** The Analyses Category Enum */
export enum AnalysesCategoryEnum {
  /** Qualidade de Dados */
  DataQuality = 'DATA_QUALITY',
  /** Inconsistência de Documentos */
  DocumentsInconsistency = 'DOCUMENTS_INCONSISTENCY',
  /** Status de Documentos */
  DocumentStatus = 'DOCUMENT_STATUS',
  /** Integrações */
  Integrations = 'INTEGRATIONS',
  /** Oportunidades */
  Opportunities = 'OPPORTUNITIES',
  /** Outros */
  Others = 'OTHERS',
  /** Regulatório */
  Regulatory = 'REGULATORY',
  /** Temporal */
  Temporal = 'TEMPORAL',
  /** Rastreamento */
  Tracking = 'TRACKING'
}

export type Analysis = {
  __typename?: 'Analysis';
  category: AnalysesCategoryEnum;
  description: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  rules: Array<Rule>;
  slug: Scalars['String']['output'];
};

/** An API Key */
export type ApiKey = {
  __typename?: 'ApiKey';
  accessGroup: AccessGroup;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** An API Request */
export type ApiRequest = {
  __typename?: 'ApiRequest';
  apiKey: ApiKey;
  endpoint: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  itemId: Maybe<Scalars['Int']['output']>;
  itemType: ApiRequestItemTypeEnum;
  method: HttpMethodsEnum;
  operation: Maybe<Operation>;
  referenceCodes: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  request: Maybe<Scalars['JSON']['output']>;
  response: Maybe<Scalars['JSON']['output']>;
  statusCode: Scalars['Int']['output'];
};

/** Parameters to filter for an item, ID and Type must always be used together */
export type ApiRequestItemFilterParams = {
  itemId: Scalars['Int']['input'];
  itemType: ApiRequestItemTypeEnum;
};

/** The API Request Item Type enum */
export enum ApiRequestItemTypeEnum {
  /** Pedido */
  Order = 'ORDER',
  /** Processo */
  Process = 'PROCESS'
}

/** The API Request Order By Enum */
export enum ApiRequestOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT'
}

export type ApiRequestOrderParams = {
  field?: InputMaybe<ApiRequestOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** The App Type Enum */
export enum AppTypeEnum {
  /** Asia Shipping */
  Asia = 'ASIA',
  /** CCT Aéreo */
  CctAereo = 'CCT_AEREO',
  /** Siscomex */
  Siscomex = 'SISCOMEX'
}

/** An Audit Item */
export type AuditItem = {
  __typename?: 'AuditItem';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  operation: Operation;
  showObservationsWhen: AuditItemShowObservationEnum;
};

/** The Audit Item Show Observation Enum */
export enum AuditItemShowObservationEnum {
  /** Sempre */
  Always = 'ALWAYS',
  /** Nunca */
  Never = 'NEVER',
  /** Não */
  No = 'NO',
  /** Sim */
  Yes = 'YES'
}

/** An Automation */
export type Automation = {
  __typename?: 'Automation';
  action: AutomationActionEnum;
  confirmationField: Maybe<Scalars['String']['output']>;
  confirmationFieldLabel: Maybe<Scalars['String']['output']>;
  dateField: Scalars['String']['output'];
  dateFieldLabel: Scalars['String']['output'];
  dateTargetField: Maybe<Scalars['String']['output']>;
  dateTargetFieldLabel: Maybe<Scalars['String']['output']>;
  extra: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  isEnabled: Scalars['Boolean']['output'];
  mode: ModeTypeEnum;
  name: Scalars['String']['output'];
  operation: Operation;
  pathFilters: Maybe<Scalars['JSON']['output']>;
  periodAmount: Maybe<Scalars['Int']['output']>;
  periodType: Maybe<AutomationPeriodTypeEnum>;
  template: AutomationTemplateEnum;
  type: AutomationTypeEnum;
};

/** The Automation Action Enum */
export enum AutomationActionEnum {
  /** Finalizar Processo/Pedido */
  Finish = 'FINISH',
  /** Ativar farol vermelho */
  RedLight = 'RED_LIGHT',
  /** Action customizada */
  Webhook = 'WEBHOOK',
  /** Ativar farol amarelo */
  YellowLight = 'YELLOW_LIGHT'
}

/** An Automation Order */
export type AutomationOrder = {
  __typename?: 'AutomationOrder';
  action: AutomationActionEnum;
  automation: Automation;
  id: Scalars['Int']['output'];
  triggeredAt: Scalars['DateTime']['output'];
};

/** The Automation Order By Enum */
export enum AutomationOrderByEnum {
  /** Ação */
  Action = 'ACTION',
  /** Campo de Confirmação */
  ConfirmationField = 'CONFIRMATION_FIELD',
  /** Campo de Data */
  DateField = 'DATE_FIELD',
  /** Campo de Data Alvo */
  DateTargetField = 'DATE_TARGET_FIELD',
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Ativado */
  IsEnabled = 'IS_ENABLED',
  /** Nome */
  Name = 'NAME',
  /** Valor do período */
  PeriodAmount = 'PERIOD_AMOUNT',
  /** Tipo do período */
  PeriodType = 'PERIOD_TYPE',
  /** Template */
  Template = 'TEMPLATE',
  /** Tipo */
  Type = 'TYPE',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

export type AutomationOrderParams = {
  field?: InputMaybe<AutomationOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Automations */
export type AutomationPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AutomationOrderParams>>;
};

/** The Automation Period Type Enum */
export enum AutomationPeriodTypeEnum {
  /** Dias */
  Days = 'DAYS',
  /** Horas */
  Hours = 'HOURS',
  /** Minutos */
  Minutes = 'MINUTES',
  /** Meses */
  Months = 'MONTHS'
}

/** An Automation Process */
export type AutomationProcess = {
  __typename?: 'AutomationProcess';
  action: AutomationActionEnum;
  automation: Automation;
  id: Scalars['Int']['output'];
  triggeredAt: Scalars['DateTime']['output'];
};

/** The Automation Template Enum */
export enum AutomationTemplateEnum {
  /** Quando passar um período de uma data */
  AfterDate = 'AFTER_DATE',
  /** Quando passar um período de uma data sem confirmação de um campo */
  AfterDateWithField = 'AFTER_DATE_WITH_FIELD',
  /** Quando faltar um período de uma data */
  BeforeDate = 'BEFORE_DATE',
  /** Quando faltar um período de uma data sem confirmação de um campo */
  BeforeDateWithField = 'BEFORE_DATE_WITH_FIELD',
  /** Quando chegar uma data */
  OnDate = 'ON_DATE',
  /** Quando a data for maior que a data alvo por um período */
  OnDateGreaterThan = 'ON_DATE_GREATER_THAN',
  /** Quando chegar uma data sem confirmação de um campo */
  OnDateWithField = 'ON_DATE_WITH_FIELD'
}

/** The Automation Type Enum */
export enum AutomationTypeEnum {
  /** Pedido */
  Order = 'ORDER',
  /** Processo */
  Process = 'PROCESS'
}

/** A proposal submitted by a freight agent to a Booking Quotation */
export type BookingProposal = {
  __typename?: 'BookingProposal';
  attachments: Array<BookingProposalAttachment>;
  coLoader: Maybe<Scalars['String']['output']>;
  conditions: Maybe<Scalars['String']['output']>;
  destinationCosts: Maybe<Scalars['Decimal']['output']>;
  destinationInlandFreight: Maybe<Scalars['Decimal']['output']>;
  destinationSubtotal: Scalars['Decimal']['output'];
  dischargePort: Maybe<MaritimePort>;
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  internationalFreight: Maybe<Scalars['Decimal']['output']>;
  loadingPort: Maybe<MaritimePort>;
  number: Scalars['String']['output'];
  originCosts: Maybe<Scalars['Decimal']['output']>;
  originDomesticFreight: Maybe<Scalars['Decimal']['output']>;
  originFees: Maybe<Scalars['Decimal']['output']>;
  originSubtotal: Scalars['Decimal']['output'];
  partnership: Partnership;
  representativeness: Maybe<Scalars['Decimal']['output']>;
  routeNotes: Maybe<Scalars['String']['output']>;
  sealine: Maybe<Sealine>;
  serviceType: Maybe<BookingProposalServiceTypeEnum>;
  total: Maybe<Scalars['Decimal']['output']>;
  transitTimeDays: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** A file attached to a proposal by the freight agent */
export type BookingProposalAttachment = {
  __typename?: 'BookingProposalAttachment';
  downloadUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  originalFilename: Maybe<Scalars['String']['output']>;
};

/** The reply of an invited agent to a Booking Quotation */
export type BookingProposalReply = {
  __typename?: 'BookingProposalReply';
  declineReason: Maybe<Scalars['String']['output']>;
  lastUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  partnership: Partnership;
  status: BookingProposalStatusReplyEnum;
};

/** The Booking Proposal Service Type Enum */
export enum BookingProposalServiceTypeEnum {
  /** FCL */
  Fcl = 'FCL',
  /** LCL */
  Lcl = 'LCL'
}

/** The Booking Proposal Status Reply Enum */
export enum BookingProposalStatusReplyEnum {
  /** Declinou */
  Declined = 'DECLINED',
  /** Pendente */
  Pending = 'PENDING',
  /** Respondida */
  Responded = 'RESPONDED'
}

/** A Booking Quotation round of a Process */
export type BookingQuotation = {
  __typename?: 'BookingQuotation';
  agentNotes: Maybe<Scalars['String']['output']>;
  collectionNotes: Maybe<Scalars['String']['output']>;
  decidedAt: Maybe<Scalars['DateTime']['output']>;
  documentIds: Array<Scalars['Int']['output']>;
  externalPagePublication: ExternalPagePublication;
  id: Scalars['Int']['output'];
  invitedCount: Scalars['Int']['output'];
  invoicesFinalValue: Maybe<Scalars['Decimal']['output']>;
  recipientIds: Array<Scalars['Int']['output']>;
  replies: Array<BookingProposalReply>;
  respondedCount: Scalars['Int']['output'];
  round: Scalars['Int']['output'];
  snapshotChanges: Array<SnapshotChange>;
  status: BookingQuotationStatusEnum;
  winnerProposal: Maybe<BookingProposal>;
};

/** The Booking Quotation Status Enum */
export enum BookingQuotationStatusEnum {
  /** Aguardando decisão */
  AwaitingDecision = 'AWAITING_DECISION',
  /** Cancelada */
  Canceled = 'CANCELED',
  /** Encerrando */
  Closing = 'CLOSING',
  /** Rascunho */
  Draft = 'DRAFT',
  /** Sem propostas */
  NoProposals = 'NO_PROPOSALS',
  /** Aberta */
  Open = 'OPEN',
  /** Vencedor definido */
  WinnerDefined = 'WINNER_DEFINED'
}

/** A Brazilian Invoice */
export type BrazilianInvoice = {
  __typename?: 'BrazilianInvoice';
  accessKey: Scalars['String']['output'];
  cfop: Maybe<Scalars['String']['output']>;
  emittedAt: Scalars['DateTime']['output'];
  extra: Maybe<Scalars['String']['output']>;
  issuer: BrazilianInvoiceOriginator;
  number: Scalars['String']['output'];
  products: Array<BrazilianInvoiceProduct>;
  sender: BrazilianInvoiceOriginator;
  tax: BrazilianInvoiceTax;
  transport: BrazilianInvoiceTransport;
  type: Scalars['String']['output'];
};

/** A Brazilian Invoice Address */
export type BrazilianInvoiceAddress = {
  __typename?: 'BrazilianInvoiceAddress';
  city: Scalars['String']['output'];
  cityCode: Scalars['String']['output'];
  country: Maybe<Scalars['String']['output']>;
  neighborhood: Scalars['String']['output'];
  number: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zip: Maybe<Scalars['String']['output']>;
};

/** A Brazilian Invoice Originator (Issuer/Sender) */
export type BrazilianInvoiceOriginator = {
  __typename?: 'BrazilianInvoiceOriginator';
  address: Maybe<BrazilianInvoiceAddress>;
  cnpj: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  stateId: Maybe<Scalars['String']['output']>;
};

/** A Brazilian Invoice Product */
export type BrazilianInvoiceProduct = {
  __typename?: 'BrazilianInvoiceProduct';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  ncm: Scalars['String']['output'];
  quantity: Scalars['Decimal']['output'];
  totalAmount: Scalars['Decimal']['output'];
  unit: Scalars['String']['output'];
  unitValue: Scalars['Decimal']['output'];
};

/** A Brazilian Invoice Tax */
export type BrazilianInvoiceTax = {
  __typename?: 'BrazilianInvoiceTax';
  base: Scalars['Decimal']['output'];
  discount: Scalars['Decimal']['output'];
  freight: Scalars['Decimal']['output'];
  importation: Scalars['Decimal']['output'];
  insurance: Scalars['Decimal']['output'];
  ipi: Scalars['Decimal']['output'];
  other: Scalars['Decimal']['output'];
  productValue: Scalars['Decimal']['output'];
  totalAmount: Scalars['Decimal']['output'];
  value: Scalars['Decimal']['output'];
};

/** A Brazilian Invoice Transport */
export type BrazilianInvoiceTransport = {
  __typename?: 'BrazilianInvoiceTransport';
  address: Maybe<Scalars['String']['output']>;
  brand: Maybe<Scalars['String']['output']>;
  carrier: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  cnpj: Maybe<Scalars['String']['output']>;
  freightOnAccount: Scalars['String']['output'];
  grossWeight: Maybe<Scalars['Decimal']['output']>;
  netWeight: Maybe<Scalars['Decimal']['output']>;
  numeration: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['Decimal']['output']>;
  specie: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  stateId: Maybe<Scalars['String']['output']>;
  vehiclePlate: Maybe<Scalars['String']['output']>;
};

/** A Calculated Aggregated Costs */
export type CalculatedAggregatedCosts = {
  __typename?: 'CalculatedAggregatedCosts';
  deviation: Maybe<Scalars['Decimal']['output']>;
  planned: Maybe<Scalars['Decimal']['output']>;
  plannedAverage: Maybe<Scalars['Decimal']['output']>;
  realized: Maybe<Scalars['Decimal']['output']>;
  realizedAverage: Maybe<Scalars['Decimal']['output']>;
};

/** A Calculated Stage */
export type CalculatedStage = {
  __typename?: 'CalculatedStage';
  durationHours: Maybe<Scalars['Int']['output']>;
  endedAt: Maybe<Scalars['DateTime']['output']>;
  startedAt: Maybe<Scalars['DateTime']['output']>;
};

export type CancelBookingQuotationParams = {
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** The Operation Subtype Enum */
export enum CardSizeEnum {
  /** Full */
  Full = 'FULL',
  /** Mini */
  Mini = 'MINI'
}

/** A Cargo */
export type Cargo = {
  __typename?: 'Cargo';
  cubicWeight: Maybe<Scalars['String']['output']>;
  dimensions: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  measurementUnit: MeasurementUnitEnum;
  quantity: Scalars['String']['output'];
  transportable: Maybe<Transportable>;
  volumeCubicMeters: Maybe<Scalars['String']['output']>;
  weightKg: Maybe<Scalars['String']['output']>;
};

/** The Cargo Attribute Enum */
export enum CargoAttributeEnum {
  /** Baterias de lítio */
  BatteryLithium = 'BATTERY_LITHIUM',
  /** Carga perigosa (IMO) */
  DangerousGoods = 'DANGEROUS_GOODS',
  /** Grau alimentício */
  FoodGrade = 'FOOD_GRADE',
  /** Frágil */
  Fragile = 'FRAGILE',
  /** Carga pesada */
  HeavyLift = 'HEAVY_LIFT',
  /** Alto valor */
  HighValue = 'HIGH_VALUE',
  /** Animais vivos */
  LiveAnimals = 'LIVE_ANIMALS',
  /** Superdimensionada */
  Oversized = 'OVERSIZED',
  /** Perecível */
  Perishable = 'PERISHABLE',
  /** Farmacêutica */
  Pharma = 'PHARMA',
  /** Refrigerada */
  Reefer = 'REEFER',
  /** Temperatura controlada */
  TemperatureControlled = 'TEMPERATURE_CONTROLLED'
}

/** The CE Mercante Data */
export type CeMercanteData = {
  __typename?: 'CeMercanteData';
  bl: Maybe<Scalars['String']['output']>;
  cargoDescription: Maybe<Scalars['String']['output']>;
  cargoManifests: Array<CeMercanteDataCargoManifest>;
  cargoPresenceAt: Maybe<Scalars['DateTime']['output']>;
  cargoPresenceHistory: Array<CeMercanteDataCargoPresenceHistory>;
  cargoPresenceInPrimaryZoneAt: Maybe<Scalars['DateTime']['output']>;
  cargoPresenceInSecondaryZoneAt: Maybe<Scalars['DateTime']['output']>;
  cargoStatus: Maybe<Scalars['String']['output']>;
  consigneeDocument: Maybe<Scalars['String']['output']>;
  consigneeExtraInfo: Maybe<Scalars['String']['output']>;
  containerSeals: Array<CeMercanteDataContainerSeal>;
  customsPlace: Maybe<Scalars['String']['output']>;
  destinationPort: Maybe<MaritimePort>;
  diNumber: Maybe<Scalars['String']['output']>;
  dtaNumber: Maybe<Scalars['String']['output']>;
  extra: Maybe<Scalars['JSON']['output']>;
  finalDestinationArrivalAt: Maybe<Scalars['DateTime']['output']>;
  freightBasicCost: Maybe<Scalars['Decimal']['output']>;
  freightCurrency: Maybe<Currency>;
  freightPaymentType: Maybe<Scalars['String']['output']>;
  freightTotalCost: Maybe<Scalars['Decimal']['output']>;
  grossWeightKg: Maybe<Scalars['Decimal']['output']>;
  hasDta: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  manifestArrivalAt: Maybe<Scalars['DateTime']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  originPort: Maybe<MaritimePort>;
  shippingAgency: Maybe<Actor>;
  statusResponse: Maybe<StatusResponseTypeEnum>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** The CE Mercante Data Cargo Manifest */
export type CeMercanteDataCargoManifest = {
  __typename?: 'CeMercanteDataCargoManifest';
  dischargePortTerminal: Maybe<Scalars['String']['output']>;
  dischargePortUnlocode: Maybe<Scalars['String']['output']>;
  loadingPortTerminal: Maybe<Scalars['String']['output']>;
  loadingPortUnlocode: Maybe<Scalars['String']['output']>;
  manifestNumber: Maybe<Scalars['String']['output']>;
};

/** A CE Mercante cargo presence history entry */
export type CeMercanteDataCargoPresenceHistory = {
  __typename?: 'CeMercanteDataCargoPresenceHistory';
  date: Maybe<Scalars['DateTime']['output']>;
  dtaNumber: Maybe<Scalars['String']['output']>;
  ra: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  syncedAt: Maybe<Scalars['DateTime']['output']>;
};

/** A CE Mercante container seal entry */
export type CeMercanteDataContainerSeal = {
  __typename?: 'CeMercanteDataContainerSeal';
  containerCode: Maybe<Scalars['String']['output']>;
  sealCode: Maybe<Scalars['String']['output']>;
  secondarySealCode: Maybe<Scalars['String']['output']>;
};

/** The Channel Export Declaration Enum */
export enum ChannelExportDeclarationTypeEnum {
  /** Canal Verde */
  Green = 'GREEN',
  /** Canal Laranja */
  Orange = 'ORANGE',
  /** Canal Vermelho */
  Red = 'RED'
}

/** The Channel Enum */
export enum ChannelTypeEnum {
  /** Canal Cinza (Checagem de valorização da importação) */
  Gray = 'GRAY',
  /** Canal Verde (Não há conferência) */
  Green = 'GREEN',
  /** Canal Vermelho (Conferência documental e física) */
  Red = 'RED',
  /** Canal Amarelo (Conferência documental) */
  Yellow = 'YELLOW'
}

/** A Checkpoint */
export type Checkpoint = {
  __typename?: 'Checkpoint';
  label: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

/** A Checkpoint Status */
export type CheckpointStatus = {
  __typename?: 'CheckpointStatus';
  fulfilledItemsCount: Scalars['Int']['output'];
  itemsCount: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

/** A Client */
export type Client = {
  __typename?: 'Client';
  actor: Actor;
  id: Scalars['Int']['output'];
};

/** The Client Order By Enum */
export enum ClientOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

export type ClientOrderParams = {
  field?: InputMaybe<ClientOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Clients */
export type ClientPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClientOrderParams>>;
};

/** Available parameters to complete registry a user */
export type CompleteRegistrationParams = {
  countryCode: Scalars['String']['input'];
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A Component */
export type Component = {
  __typename?: 'Component';
  componentAccess: ComponentAccess;
  extraFieldsDefinition: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  phase: Maybe<Phase>;
  position: Scalars['Int']['output'];
  props: Maybe<Scalars['JSON']['output']>;
  slug: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
};

/** A Component Access */
export type ComponentAccess = {
  __typename?: 'ComponentAccess';
  component: Component;
  id: Scalars['Int']['output'];
  operationAccess: OperationAccess;
  type: AccessEnum;
};

/** A Condition */
export type Condition = {
  __typename?: 'Condition';
  mode: Maybe<ModeTypeEnum>;
  path: Scalars['String']['output'];
  slug: Maybe<Scalars['String']['output']>;
};

/** A Container */
export type Container = {
  __typename?: 'Container';
  actualReturnEmptyContainerAt: Maybe<Scalars['DateTime']['output']>;
  code: Maybe<Scalars['String']['output']>;
  cubicMeters: Maybe<Scalars['Decimal']['output']>;
  debitNotes: Array<DebitNote>;
  demurrageCalculations: Maybe<ContainerDemurrageCalculations>;
  demurrageDailyRateUsd: Maybe<Scalars['Decimal']['output']>;
  demurrageFreeTime: Maybe<Scalars['Int']['output']>;
  demurrageFreeTimeStartAt: Maybe<Scalars['DateTime']['output']>;
  dispatchNumber: Maybe<Scalars['String']['output']>;
  emptyPickupAt: Maybe<Scalars['DateTime']['output']>;
  emptyReceivedAtFactory: Maybe<Scalars['DateTime']['output']>;
  estimatedReturnEmptyContainerAt: Maybe<Scalars['DateTime']['output']>;
  estimatedStuffingAt: Maybe<Scalars['DateTime']['output']>;
  events: Array<ContainerEvent>;
  grossWeightKg: Maybe<Scalars['Decimal']['output']>;
  hidden: Scalars['Boolean']['output'];
  htTreatment: Maybe<Scalars['Boolean']['output']>;
  htTreatmentAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  internalReferenceCode: Maybe<Scalars['String']['output']>;
  invoiceDocumentNumber: Maybe<Scalars['String']['output']>;
  invoiceGrossWeight: Maybe<Scalars['Decimal']['output']>;
  invoiceNumber: Maybe<Scalars['String']['output']>;
  invoiceValue: Maybe<Scalars['Decimal']['output']>;
  isSealFromCeMercante: Maybe<Scalars['Boolean']['output']>;
  isStackable: Maybe<Scalars['Boolean']['output']>;
  loadType: Maybe<LoadTypeEnum>;
  loadingScheduleAt: Maybe<Scalars['DateTime']['output']>;
  maxWeightKg: Maybe<Scalars['Decimal']['output']>;
  ncmCodes: Maybe<Array<Scalars['String']['output']>>;
  observations: Maybe<Scalars['String']['output']>;
  oic: Maybe<Scalars['String']['output']>;
  orderNumber: Maybe<Scalars['String']['output']>;
  palletQuantity: Maybe<Scalars['Int']['output']>;
  portDepositAt: Maybe<Scalars['DateTime']['output']>;
  portDepositDeadlineAt: Maybe<Scalars['DateTime']['output']>;
  portScheduledAt: Maybe<Scalars['DateTime']['output']>;
  preStacking: Maybe<Scalars['Boolean']['output']>;
  preStackingDays: Maybe<Scalars['Int']['output']>;
  preStackingReason: Maybe<PreStackingReasonEnum>;
  preStackingWarehouse: Maybe<PreStackingWarehouseEnum>;
  quantity: Maybe<Scalars['Decimal']['output']>;
  releasedForTripAt: Maybe<Scalars['DateTime']['output']>;
  route: Maybe<Scalars['String']['output']>;
  scaleExitAt: Maybe<Scalars['DateTime']['output']>;
  sealCode: Maybe<Scalars['String']['output']>;
  secondarySealCode: Maybe<Scalars['String']['output']>;
  separationCompletedAt: Maybe<Scalars['DateTime']['output']>;
  shipmentAta: Maybe<Scalars['DateTime']['output']>;
  sizeFootType: Maybe<ContainerSizeFootTypeEnum>;
  stackingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  stackingStartedAt: Maybe<Scalars['DateTime']['output']>;
  tareWeightKg: Maybe<Scalars['Decimal']['output']>;
  trackingApi: Scalars['Boolean']['output'];
  trackingManual: Scalars['Boolean']['output'];
  transportDocument: Maybe<Scalars['String']['output']>;
  transportable: Maybe<Transportable>;
  type: Maybe<ContainerTypeEnum>;
  washingChargeReceivedAt: Maybe<Scalars['DateTime']['output']>;
  washingDamageResult: Maybe<ContainerWashingDamageResultEnum>;
  washingDamageStatus: Maybe<ContainerWashingConclusionStatusEnum>;
  washingEmptyChecklist: Maybe<Scalars['Boolean']['output']>;
  washingInspection: Maybe<Scalars['String']['output']>;
  washingPaymentAt: Maybe<Scalars['DateTime']['output']>;
  washingPaymentStatus: Maybe<ContainerWashingPaymentStatusEnum>;
  washingServiceType: Maybe<ContainerWashingServiceTypeEnum>;
  washingTermDescription: Maybe<ContainerWashingTermDescriptionEnum>;
  washingTermStatus: Maybe<ContainerWashingConclusionStatusEnum>;
  washingValue: Maybe<Scalars['Decimal']['output']>;
};

/** Demurrage calculations for a Container */
export type ContainerDemurrageCalculations = {
  __typename?: 'ContainerDemurrageCalculations';
  costPerDayBrl: Scalars['Decimal']['output'];
  costPerDayUsd: Scalars['Decimal']['output'];
  daysPaid: Scalars['Int']['output'];
  daysToPay: Scalars['Int']['output'];
  emptyReturnDeadline: Maybe<Scalars['DateTime']['output']>;
  estimatedCosts: Scalars['Decimal']['output'];
  exceedingDays: Scalars['Int']['output'];
  referenceDate: Scalars['DateTime']['output'];
  totalOwedBrl: Scalars['Decimal']['output'];
  totalOwedUsd: Scalars['Decimal']['output'];
  totalPaidBrl: Scalars['Decimal']['output'];
  totalPaidUsd: Scalars['Decimal']['output'];
  totalToPayBrl: Scalars['Decimal']['output'];
  totalToPayUsd: Scalars['Decimal']['output'];
};

/** A Container Event */
export type ContainerEvent = {
  __typename?: 'ContainerEvent';
  datetime: Maybe<Scalars['DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  emptyIndicatorCode: Maybe<ContainerEventEmptyIndicatorCodeEnum>;
  estimated: Maybe<Scalars['Boolean']['output']>;
  eventType: Maybe<ContainerEventTypeEnum>;
  eventTypeCode: Maybe<ContainerEventTypeCodeEnum>;
  facilityTypeCode: Maybe<ContainerEventFacilityTypeCodeEnum>;
  place: Maybe<Scalars['String']['output']>;
  /** @deprecated Use description */
  status: Maybe<Scalars['String']['output']>;
  /** @deprecated Use vessel or transport_mode */
  transport: Maybe<Scalars['String']['output']>;
  transportMode: Maybe<ContainerEventTransportModeEnum>;
  vessel: Maybe<Scalars['String']['output']>;
  voyage: Maybe<Scalars['String']['output']>;
};

/** The Container Event Empty Indicator Code Enum */
export enum ContainerEventEmptyIndicatorCodeEnum {
  /** EMPTY */
  Empty = 'EMPTY',
  /** LADEN */
  Laden = 'LADEN'
}

/** The Container Event Facility Type Code Enum */
export enum ContainerEventFacilityTypeCodeEnum {
  /** BOCR */
  Bocr = 'BOCR',
  /** CLOC */
  Cloc = 'CLOC',
  /** COFS */
  Cofs = 'COFS',
  /** COYA */
  Coya = 'COYA',
  /** DEPO */
  Depo = 'DEPO',
  /** INTE */
  Inte = 'INTE',
  /** OFFD */
  Offd = 'OFFD',
  /** POTE */
  Pote = 'POTE',
  /** RAMP */
  Ramp = 'RAMP'
}

/** The Container Event Transport Mode Enum */
export enum ContainerEventTransportModeEnum {
  /** BARGE */
  Barge = 'BARGE',
  /** RAIL */
  Rail = 'RAIL',
  /** TRUCK */
  Truck = 'TRUCK',
  /** VESSEL */
  Vessel = 'VESSEL'
}

/** The Container Event Type Code Enum */
export enum ContainerEventTypeCodeEnum {
  /** APPR */
  Appr = 'APPR',
  /** ARRI */
  Arri = 'ARRI',
  /** AVDO */
  Avdo = 'AVDO',
  /** AVPU */
  Avpu = 'AVPU',
  /** CANC */
  Canc = 'CANC',
  /** CMPL */
  Cmpl = 'CMPL',
  /** CONF */
  Conf = 'CONF',
  /** CUSI */
  Cusi = 'CUSI',
  /** CUSR */
  Cusr = 'CUSR',
  /** CUSS */
  Cuss = 'CUSS',
  /** DEPA */
  Depa = 'DEPA',
  /** DISC */
  Disc = 'DISC',
  /** DRFT */
  Drft = 'DRFT',
  /** DROP */
  Drop = 'DROP',
  /** GTIN */
  Gtin = 'GTIN',
  /** GTOT */
  Gtot = 'GTOT',
  /** HOLD */
  Hold = 'HOLD',
  /** INSP */
  Insp = 'INSP',
  /** ISSU */
  Issu = 'ISSU',
  /** LOAD */
  Load = 'LOAD',
  /** PENA */
  Pena = 'PENA',
  /** PENU */
  Penu = 'PENU',
  /** PICK */
  Pick = 'PICK',
  /** RECE */
  Rece = 'RECE',
  /** REJE */
  Reje = 'REJE',
  /** RELS */
  Rels = 'RELS',
  /** REQS */
  Reqs = 'REQS',
  /** RMVD */
  Rmvd = 'RMVD',
  /** RSEA */
  Rsea = 'RSEA',
  /** STRP */
  Strp = 'STRP',
  /** STUF */
  Stuf = 'STUF',
  /** SUBM */
  Subm = 'SUBM',
  /** SURR */
  Surr = 'SURR',
  /** VOID */
  Void = 'VOID',
  /** WAYP */
  Wayp = 'WAYP'
}

/** The Container Event Type Enum */
export enum ContainerEventTypeEnum {
  /** EQUIPMENT */
  Equipment = 'EQUIPMENT',
  /** SHIPMENT */
  Shipment = 'SHIPMENT',
  /** TRANSPORT */
  Transport = 'TRANSPORT'
}

/** The Container Order By Enum */
export enum ContainerOrderByEnum {
  /** Código do container */
  Code = 'CODE',
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

/** Available parameters to sort Container */
export type ContainerOrderParams = {
  field?: InputMaybe<ContainerOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Container */
export type ContainerPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContainerOrderParams>>;
};

/** A Container per Process */
export type ContainerPerProcess = {
  __typename?: 'ContainerPerProcess';
  container: Container;
  process: Process;
};

/** The Container Size Type Enum */
export enum ContainerSizeFootTypeEnum {
  /** 20 Foot High Cube */
  Hc_20 = 'HC_20',
  /** 40 Foot High Cube */
  Hc_40 = 'HC_40',
  /** 45 Foot High Cube */
  Hc_45 = 'HC_45',
  /** 40 Foot Pallet Wide */
  PalletWide_40 = 'PALLET_WIDE_40',
  /** 45 Foot Pallet Wide */
  PalletWide_45 = 'PALLET_WIDE_45',
  /** 20 Foot Reduced */
  Reduced_20 = 'REDUCED_20',
  /** 30 Foot Reduced */
  Reduced_30 = 'REDUCED_30',
  /** 40 Foot Reduced */
  Reduced_40 = 'REDUCED_40',
  /** 20 Foot Super High Cube */
  Shc_20 = 'SHC_20',
  /** 40 Foot Super High Cube */
  Shc_40 = 'SHC_40',
  /** 45 Foot Super High Cube */
  Shc_45 = 'SHC_45',
  /** 20 Foot Special */
  Special_20 = 'SPECIAL_20',
  /** 30 Foot Special */
  Special_30 = 'SPECIAL_30',
  /** 40 Foot Special */
  Special_40 = 'SPECIAL_40',
  /** 45 Foot Special */
  Special_45 = 'SPECIAL_45',
  /** 10 Foot Standard */
  Standard_10 = 'STANDARD_10',
  /** 20 Foot Standard */
  Standard_20 = 'STANDARD_20',
  /** 30 Foot Standard */
  Standard_30 = 'STANDARD_30',
  /** 40 Foot Standard */
  Standard_40 = 'STANDARD_40'
}

/** The Container Type Enum */
export enum ContainerTypeEnum {
  /** Bulk */
  Bulk = 'BULK',
  /** Double Door */
  DoubleDoor = 'DOUBLE_DOOR',
  /** Dry */
  Dry = 'DRY',
  /** Flat Rack */
  FlatRack = 'FLAT_RACK',
  /** Hard Top */
  HardTop = 'HARD_TOP',
  /** High Cube */
  HighCube = 'HIGH_CUBE',
  /** Insulated */
  Insulated = 'INSULATED',
  /** Non Operating Reefer */
  NonOperatingReefer = 'NON_OPERATING_REEFER',
  /** Open Top */
  OpenTop = 'OPEN_TOP',
  /** Pallet Wide */
  PalletWide = 'PALLET_WIDE',
  /** Platform */
  Platform = 'PLATFORM',
  /** Reefer */
  Reefer = 'REEFER',
  /** Side Door */
  SideDoor = 'SIDE_DOOR',
  /** Special */
  Special = 'SPECIAL',
  /** Standard */
  Standard = 'STANDARD',
  /** Swap Body */
  SwapBody = 'SWAP_BODY',
  /** Tank */
  Tank = 'TANK',
  /** Ventilated */
  Ventilated = 'VENTILATED'
}

/** The Container Washing Conclusion Status Enum */
export enum ContainerWashingConclusionStatusEnum {
  /** Finalizado */
  Completed = 'COMPLETED',
  /** Em Andamento */
  InProgress = 'IN_PROGRESS'
}

/** The Container Washing Damage Result Enum */
export enum ContainerWashingDamageResultEnum {
  /** Não */
  No = 'NO',
  /** Sem Checklist */
  NoChecklist = 'NO_CHECKLIST',
  /** Sem Foto */
  NoPhoto = 'NO_PHOTO',
  /** Sim */
  Yes = 'YES'
}

/** The Container Washing Payment Status Enum */
export enum ContainerWashingPaymentStatusEnum {
  /** Cost Recovery */
  CostRecovery = 'COST_RECOVERY',
  /** Isenção Aceita */
  ExemptionAccepted = 'EXEMPTION_ACCEPTED',
  /** Isenção Negada */
  ExemptionDenied = 'EXEMPTION_DENIED',
  /** Isenção Solicitada */
  ExemptionRequested = 'EXEMPTION_REQUESTED',
  /** Isenção Parcial */
  PartialExemption = 'PARTIAL_EXEMPTION'
}

/** The Container Washing Service Type Enum */
export enum ContainerWashingServiceTypeEnum {
  /** Reparo */
  Repair = 'REPAIR',
  /** Varrer */
  Sweeping = 'SWEEPING',
  /** Varrer e Reparo */
  SweepingAndRepair = 'SWEEPING_AND_REPAIR',
  /** Lavagem */
  Washing = 'WASHING',
  /** Lavagem e Reparo */
  WashingAndRepair = 'WASHING_AND_REPAIR'
}

/** The Container Washing Term Description Enum */
export enum ContainerWashingTermDescriptionEnum {
  /** Não se aplica */
  NotApplicable = 'NOT_APPLICABLE',
  /** Termo Anexado */
  TermAttached = 'TERM_ATTACHED'
}

/** A Cost Expense */
export type CostExpense = {
  __typename?: 'CostExpense';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

/** A Cost Model */
export type CostModel = {
  __typename?: 'CostModel';
  actor: Actor;
  currency: Maybe<Currency>;
  hasCostPerProduct: Scalars['Boolean']['output'];
  hasCostPerProductUnitary: Scalars['Boolean']['output'];
  hasPlannedCosts: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  operations: Array<Operation>;
  versions: Array<CostModelVersion>;
};

/** A Cost Model Aggregated Totals */
export type CostModelAggregatedTotals = {
  __typename?: 'CostModelAggregatedTotals';
  costPerItemsTotals: Array<CostPerItemTotals>;
  deviation: Maybe<Scalars['Decimal']['output']>;
  plannedCosts: Maybe<Scalars['Decimal']['output']>;
  totalCosts: Maybe<Scalars['Decimal']['output']>;
};

/** A Cost Model Expense */
export type CostModelExpense = {
  __typename?: 'CostModelExpense';
  calculatedCost: Maybe<CalculatedAggregatedCosts>;
  childrenModelExpenses: Array<CostModelExpense>;
  conditionalPath: Maybe<Scalars['String']['output']>;
  conditionalTemplate: Maybe<CostModelExpenseConditionalTemplateEnum>;
  conditionalValue: Maybe<Scalars['Decimal']['output']>;
  cost: Maybe<CostPerExpense>;
  costExpense: CostExpense;
  costModelVersion: CostModelVersion;
  fallbackPath: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  matchingRules: Maybe<Array<Maybe<MatchingRule>>>;
  maximumValue: Maybe<Scalars['Decimal']['output']>;
  minimumValue: Maybe<Scalars['Decimal']['output']>;
  parentModelExpense: Maybe<CostModelExpense>;
  precificationModel: Maybe<CostModelExpenseConditionalPrecificationModelEnum>;
  priceField: Maybe<Scalars['String']['output']>;
  reference: Maybe<CostModelExpenseReferenceEnum>;
  referenceProductProrated: Maybe<CostModelExpenseReferenceProductProratedEnum>;
  referenceValue: Maybe<Scalars['Decimal']['output']>;
};


/** A Cost Model Expense */
export type CostModelExpenseCostArgs = {
  processId: Scalars['Int']['input'];
};

export enum CostModelExpenseConditionalPrecificationModelEnum {
  /** Cópia do Realizado */
  CopyRealized = 'COPY_REALIZED',
  /** Fixo */
  Fixed = 'FIXED',
  /** Lookup */
  Lookup = 'LOOKUP',
  /** Multiplicação de Lookup */
  LookupMultiply = 'LOOKUP_MULTIPLY',
  /** Multiplicação */
  Multiply = 'MULTIPLY',
  /** Sem Modelo de Precificação */
  None = 'NONE'
}

export enum CostModelExpenseConditionalTemplateEnum {
  /** Campo maior que que Valor */
  FieldGreaterThanValue = 'FIELD_GREATER_THAN_VALUE',
  /** Campo é igual que Valor */
  FieldIsEqualValue = 'FIELD_IS_EQUAL_VALUE',
  /** Campo é Verdadeiro */
  FieldIsTrue = 'FIELD_IS_TRUE',
  /** Campo é menor que que Valor */
  FieldLessThanValue = 'FIELD_LESS_THAN_VALUE'
}

export enum CostModelExpenseReferenceEnum {
  /** Valor da Nota Fiscal */
  BrazilianInvoiceValue = 'BRAZILIAN_INVOICE_VALUE',
  /** Volume Calculado (m³) */
  CalculatedCubageCubicMeters = 'CALCULATED_CUBAGE_CUBIC_METERS',
  /** Peso Bruto Calculado (kg) */
  CalculatedGrossWeightKg = 'CALCULATED_GROSS_WEIGHT_KG',
  /** Containers */
  Containers = 'CONTAINERS',
  /** Containers * Rota */
  ContainersRoute = 'CONTAINERS_ROUTE',
  /** Custo do Frete */
  FreightCost = 'FREIGHT_COST',
  /** Quantidade Conteúdo */
  ItemsContentQuantity = 'ITEMS_CONTENT_QUANTITY',
  /** Volume (m³) */
  ItemsCubageCubicMeters = 'ITEMS_CUBAGE_CUBIC_METERS',
  /** Pallets */
  ItemsPallets = 'ITEMS_PALLETS',
  /** Quantidade */
  ItemsQuantity = 'ITEMS_QUANTITY',
  /** Quantidade Unitizada */
  ItemsUnitizedQuantity = 'ITEMS_UNITIZED_QUANTITY',
  /** Peso (kg) */
  ItemsWeightKg = 'ITEMS_WEIGHT_KG',
  /** Pedido */
  Order = 'ORDER',
  /** Embarque */
  Shipment = 'SHIPMENT',
  /** Dias Armazenagem * Container */
  StorageDaysContainer = 'STORAGE_DAYS_CONTAINER',
  /** Período de Armazenagem (dias) */
  StoragePeriod = 'STORAGE_PERIOD'
}

export enum CostModelExpenseReferenceProductProratedEnum {
  /** Valor da Nota Fiscal */
  BrazilianInvoiceValue = 'BRAZILIAN_INVOICE_VALUE',
  /** Volume Calculado (m³) */
  CalculatedCubageCubicMeters = 'CALCULATED_CUBAGE_CUBIC_METERS',
  /** Peso Bruto Calculado (kg) */
  CalculatedGrossWeightKg = 'CALCULATED_GROSS_WEIGHT_KG',
  /** Peso Bruto (kg) */
  GrossWeightKg = 'GROSS_WEIGHT_KG',
  /** Quantidade */
  Quantity = 'QUANTITY'
}

/** The Cost Model Order By Enum */
export enum CostModelOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

/** Available parameters to sort Cost Model */
export type CostModelOrderParams = {
  field?: InputMaybe<CostModelOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Cost Model */
export type CostModelPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CostModelOrderParams>>;
};

export type CostModelVersion = {
  __typename?: 'CostModelVersion';
  costModel: CostModel;
  id: Scalars['Int']['output'];
  processes: Array<Process>;
  rootModelExpenses: Array<CostModelExpense>;
  totals: Maybe<CostModelVersionTotals>;
  version: Scalars['Int']['output'];
};


export type CostModelVersionTotalsArgs = {
  processId: Scalars['Int']['input'];
};

/** A Cost Model Version Totals */
export type CostModelVersionTotals = {
  __typename?: 'CostModelVersionTotals';
  costPerItemExpenseTotals: Array<CostPerItemExpenseTotals>;
  costPerItemsTotals: Array<CostPerItemTotals>;
  deviation: Maybe<Scalars['Decimal']['output']>;
  plannedCosts: Maybe<Scalars['Decimal']['output']>;
  totalCosts: Maybe<Scalars['Decimal']['output']>;
};

/** A Cost per Expense */
export type CostPerExpense = {
  __typename?: 'CostPerExpense';
  cost: Maybe<Scalars['Decimal']['output']>;
  costModelExpense: CostModelExpense;
  costModelExpenseId: Maybe<Scalars['Int']['output']>;
  costPerItems: Array<CostPerItem>;
  deviation: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Int']['output'];
  plannedCost: Maybe<Scalars['Decimal']['output']>;
  process: Process;
};

/** A Cost per Item */
export type CostPerItem = {
  __typename?: 'CostPerItem';
  cost: Maybe<Scalars['Decimal']['output']>;
  deviation: Maybe<Scalars['Decimal']['output']>;
  itemId: Scalars['Int']['output'];
  plannedCost: Maybe<Scalars['Decimal']['output']>;
  productId: Scalars['Int']['output'];
};

/** A Cost Per Item Expense Totals */
export type CostPerItemExpenseTotals = {
  __typename?: 'CostPerItemExpenseTotals';
  deviation: Maybe<Scalars['Decimal']['output']>;
  expenseId: Scalars['Int']['output'];
  plannedCosts: Maybe<Scalars['Decimal']['output']>;
  totalCosts: Maybe<Scalars['Decimal']['output']>;
};

/** A Cost Per Item Totals */
export type CostPerItemTotals = {
  __typename?: 'CostPerItemTotals';
  deviation: Maybe<Scalars['Decimal']['output']>;
  itemId: Scalars['Int']['output'];
  plannedCosts: Maybe<Scalars['Decimal']['output']>;
  productId: Scalars['Int']['output'];
  totalCosts: Maybe<Scalars['Decimal']['output']>;
};

/** A country */
export type Country = {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  iso3: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** The Country Order By Enum */
export enum CountryOrderByEnum {
  /** Código */
  Code = 'CODE',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Código ISO3 */
  Iso3 = 'ISO3',
  /** Nome */
  Name = 'NAME',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

export type CountryOrderParams = {
  field?: InputMaybe<CountryOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Countries */
export type CountryPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CountryOrderParams>>;
};

/** A Courier */
export type Courier = {
  __typename?: 'Courier';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** The Courier Order By Enum */
export enum CourierOrderByEnum {
  /** Código */
  Code = 'CODE',
  /** ID */
  Id = 'ID',
  /** Nome */
  Name = 'NAME'
}

/** Available parameters to order Couriers */
export type CourierOrderParams = {
  field?: InputMaybe<CourierOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to create an Address */
export type CreateAddressParams = {
  actorId?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  complement?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  fences?: InputMaybe<Array<NestedCreateFenceParams>>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['String']['input'];
  longitude: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

/** Parameters to create a Agent */
export type CreateAgentParams = {
  actions: Array<AgentActionConfigParams>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  processorId: Scalars['Int']['input'];
  triggerEventConfig?: InputMaybe<EventAgentConfigParams>;
  triggerRecurringConfig?: InputMaybe<RecurringAgentConfigParams>;
  triggerType: AgentTriggerTypeEnum;
  webhookProcessorHeaders?: InputMaybe<Array<WebhookProcessorHeaderParams>>;
  webhookProcessorUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Available parameters to create an Automation */
export type CreateAutomationParams = {
  action: AutomationActionEnum;
  confirmationField?: InputMaybe<Scalars['String']['input']>;
  dateField: Scalars['String']['input'];
  dateTargetField?: InputMaybe<Scalars['String']['input']>;
  extra?: InputMaybe<Scalars['JSON']['input']>;
  /** Default to true */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default to first_record */
  mode?: InputMaybe<ModeTypeEnum>;
  name: Scalars['String']['input'];
  operationId: Scalars['Int']['input'];
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  periodAmount?: InputMaybe<Scalars['Int']['input']>;
  periodType?: InputMaybe<AutomationPeriodTypeEnum>;
  template: AutomationTemplateEnum;
  type: AutomationTypeEnum;
};

/** Available parameters to create a Client */
export type CreateClientParams = {
  actorId: Scalars['Int']['input'];
};

/** Available parameters to create a Cost per Expense */
export type CreateCostPerExpenseParams = {
  cost?: InputMaybe<Scalars['Decimal']['input']>;
  costModelExpenseId: Scalars['Int']['input'];
  plannedCost?: InputMaybe<Scalars['Decimal']['input']>;
  processId: Scalars['Int']['input'];
};

/** Available parameters to create a Credential */
export type CreateCredentialParams = {
  app: AppTypeEnum;
  credentials?: InputMaybe<Scalars['JSON']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  password?: InputMaybe<Scalars['String']['input']>;
  type: CredentialTypeEnum;
};

/** Available parameters to create a Document to an Order */
export type CreateDocumentParams = {
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  invoiceId?: InputMaybe<Scalars['Int']['input']>;
  parentDocumentId?: InputMaybe<Scalars['Int']['input']>;
  type: DocumentTypeEnum;
};

/** Available parameters to create a Driver */
export type CreateDriverParams = {
  birthday?: InputMaybe<Scalars['Date']['input']>;
  countryCode: Scalars['String']['input'];
  cpf?: InputMaybe<Scalars['String']['input']>;
  licenseCategory?: InputMaybe<Scalars['String']['input']>;
  licenseExpirationDate?: InputMaybe<Scalars['Date']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  officialDocument?: InputMaybe<Scalars['String']['input']>;
};

/** Available parameters to create a Lead Time Model */
export type CreateLeadTimeModelParams = {
  ignoreTime: Scalars['Boolean']['input'];
  markerPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  operationIds: Array<Scalars['Int']['input']>;
  referenceEvent: Scalars['String']['input'];
  stages?: InputMaybe<Array<NestedCreateLeadTimeStageModelParams>>;
};

/** Available parameters to create a Measurement */
export type CreateMeasurementParams = {
  measuredAt?: InputMaybe<Scalars['DateTime']['input']>;
  packages?: InputMaybe<Array<CreatePackagesParams>>;
};

/** Available parameters to create a Notification Group */
export type CreateNotificationGroupParams = {
  ccEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  notificationGroupRoles: Array<NestedNotificationGroupRoleParams>;
};

/** Available parameters to create a Notification Group Recipient */
export type CreateNotificationGroupRecipientParams = {
  emails: Array<Scalars['String']['input']>;
  language: LanguageEnum;
  notificationGroupRoleId: Scalars['Int']['input'];
  partnershipId: Scalars['Int']['input'];
};

/** Available parameters to create an Operation */
export type CreateOperationParams = {
  /** Defaults to the current client actor */
  actorId?: InputMaybe<Scalars['Int']['input']>;
  auditItems?: InputMaybe<Array<NestedCreateAuditItemParams>>;
  autoGenerateOrderCode?: InputMaybe<Scalars['Boolean']['input']>;
  autoGenerateProcessCode?: InputMaybe<Scalars['Boolean']['input']>;
  cargoDeadlineDefaultReference?: InputMaybe<DeadlineDateReferenceEnum>;
  configProps?: InputMaybe<NestedOperationConfigPropsParams>;
  draftDeadlineDefaultReference?: InputMaybe<DeadlineDateReferenceEnum>;
  gateOpeningDeadlineDefaultReference?: InputMaybe<GateOpeningDeadlineDateReferenceEnum>;
  isPhaseSequential?: InputMaybe<Scalars['Boolean']['input']>;
  orderCode?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  processCode?: InputMaybe<Scalars['String']['input']>;
  subType: OperationSubTypeEnum;
  subtitle?: InputMaybe<Scalars['JSON']['input']>;
  title: Scalars['JSON']['input'];
  type: OperationTypeEnum;
  vgmDeadlineDefaultReference?: InputMaybe<VgmDeadlineDateReferenceEnum>;
};

/** Available parameters to create an Order */
export type CreateOrderParams = {
  /** Defaults to NORMAL */
  alertLevel?: InputMaybe<AlertLevelEnum>;
  externalReferenceCode?: InputMaybe<Scalars['String']['input']>;
  extraFields?: InputMaybe<Scalars['JSON']['input']>;
  handlers?: InputMaybe<Array<NestedCreateHandlerParams>>;
  leadTimeDatetimeReference?: InputMaybe<Scalars['DateTime']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  operationId: Scalars['Int']['input'];
  purchaseOrder?: InputMaybe<NestedCreatePurchaseOrderParams>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  roadTransportOrder?: InputMaybe<NestedCreateRoadTransportOrderParams>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  salesOrder?: InputMaybe<NestedCreateSalesOrderParams>;
  subsidiaryId?: InputMaybe<Scalars['Int']['input']>;
};

/** Available parameters to create an Order by Rest API */
export type CreateOrderParamsByRestApi = {
  /** Defaults to NORMAL */
  alertLevel?: InputMaybe<AlertLevelEnum>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalReferenceCode?: InputMaybe<Scalars['String']['input']>;
  extraFields?: InputMaybe<Scalars['JSON']['input']>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  handler?: InputMaybe<NestedUpsertHandlersByRoleParams>;
  handlers?: InputMaybe<Array<NestedCreateHandlerParams>>;
  leadTimeDatetimeReference?: InputMaybe<Scalars['DateTime']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  purchaseOrder?: InputMaybe<NestedCreatePurchaseOrderParamsByRestApi>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  roadTransportOrder?: InputMaybe<NestedCreateRoadTransportOrderParams>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  salesOrder?: InputMaybe<NestedCreateSalesOrderParamsByRestApi>;
  subsidiaryId?: InputMaybe<Scalars['Int']['input']>;
};

/** Available parameters to create a Package */
export type CreatePackagesParams = {
  bundleOccupationPercentage: Scalars['Decimal']['input'];
  code: Scalars['String']['input'];
  extra?: InputMaybe<Scalars['JSON']['input']>;
  inboundDate: Scalars['Date']['input'];
  itemQuantity: Scalars['Int']['input'];
  locationCode: Scalars['String']['input'];
  packageBundleCode: Scalars['String']['input'];
  productSku: Scalars['String']['input'];
  productionLine: ProductionLineEnum;
  supplyOrigin: OriginTypeEnum;
  type: Scalars['String']['input'];
};

/** Available parameters to create a Partnership */
export type CreatePartnershipParams = {
  contactDetails?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<ActorDocumentTypeEnum>;
  internalCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  officialDocument?: InputMaybe<Scalars['String']['input']>;
  roles: Array<NestedCreateRoleParams>;
};

/** Available parameters to create a Planned Lead Time */
export type CreatePlannedLeadTimeParams = {
  leadTimeModelId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  stages?: InputMaybe<Array<NestedCreatePlannedLeadTimeStageParams>>;
};

/** Available parameters to create a Process */
export type CreateProcessParams = {
  /** Defaults to NORMAL */
  alertLevel?: InputMaybe<AlertLevelEnum>;
  bookingQuotation?: InputMaybe<UpsertBookingQuotationParams>;
  costModelVersionId?: InputMaybe<Scalars['Int']['input']>;
  extraFields?: InputMaybe<Scalars['JSON']['input']>;
  foreignTradeShipment?: InputMaybe<NestedCreateForeignTradeShipmentParams>;
  handlers?: InputMaybe<Array<NestedCreateHandlerParams>>;
  leadTimeDatetimeReference?: InputMaybe<Scalars['DateTime']['input']>;
  operationId: Scalars['Int']['input'];
  orderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  plannedLeadTimeId?: InputMaybe<Scalars['Int']['input']>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
};

/** Available parameters to create a Process by REST API */
export type CreateProcessParamsByRestApi = {
  /** Defaults to NORMAL */
  alertLevel?: InputMaybe<AlertLevelEnum>;
  brazilianInvoices?: InputMaybe<Array<Scalars['String']['input']>>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  costModelVersionId?: InputMaybe<Scalars['Int']['input']>;
  extraFields?: InputMaybe<Scalars['JSON']['input']>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  foreignTradeShipment?: InputMaybe<NestedCreateForeignTradeShipmentParams>;
  handler?: InputMaybe<NestedUpsertHandlersByRoleParams>;
  handlers?: InputMaybe<Array<NestedCreateHandlerParams>>;
  leadTimeDatetimeReference?: InputMaybe<Scalars['DateTime']['input']>;
  orderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderReferenceCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  plannedLeadTimeId?: InputMaybe<Scalars['Int']['input']>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
};

/** Available parameters to create a Product */
export type CreateProductParams = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  c9Ratio?: InputMaybe<Scalars['Decimal']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  contentCapacity?: InputMaybe<Scalars['Decimal']['input']>;
  contentCode?: InputMaybe<Scalars['String']['input']>;
  contentMeasurementUnit?: InputMaybe<MeasurementUnitEnum>;
  contentType?: InputMaybe<MeasurementUnitEnum>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  cubagePerPackage?: InputMaybe<Scalars['Decimal']['input']>;
  description: Scalars['String']['input'];
  dumping?: InputMaybe<Scalars['Boolean']['input']>;
  extra?: InputMaybe<Scalars['JSON']['input']>;
  family?: InputMaybe<Scalars['String']['input']>;
  grossWeightPerPackage?: InputMaybe<Scalars['Decimal']['input']>;
  hasContainerization?: InputMaybe<Scalars['Boolean']['input']>;
  hasContent?: InputMaybe<Scalars['Boolean']['input']>;
  hasPalletization?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnitization?: InputMaybe<Scalars['Boolean']['input']>;
  internalCodes?: InputMaybe<Array<NestedCreateProductInternalCodeParams>>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  mercosulCode?: InputMaybe<Scalars['String']['input']>;
  multipleCode?: InputMaybe<Scalars['String']['input']>;
  multiplePackageCapacity?: InputMaybe<Scalars['Decimal']['input']>;
  multiplePackageMeasurementUnit?: InputMaybe<MeasurementUnitEnum>;
  multiplePackagePerContainerFt20?: InputMaybe<Scalars['Int']['input']>;
  multiplePackagePerContainerFt40?: InputMaybe<Scalars['Int']['input']>;
  multiplePackageType?: InputMaybe<MeasurementUnitEnum>;
  netWeightPerPackage?: InputMaybe<Scalars['Decimal']['input']>;
  packageCapacity?: InputMaybe<Scalars['Decimal']['input']>;
  packageCode?: InputMaybe<Scalars['String']['input']>;
  packageMeasurementUnit?: InputMaybe<MeasurementUnitEnum>;
  packageType?: InputMaybe<MeasurementUnitEnum>;
  packagesPerContainerFt20?: InputMaybe<Scalars['Int']['input']>;
  packagesPerContainerFt40?: InputMaybe<Scalars['Int']['input']>;
  packagesPerPallet?: InputMaybe<Scalars['Int']['input']>;
  palletsPerContainerFt20?: InputMaybe<Scalars['Int']['input']>;
  palletsPerContainerFt40?: InputMaybe<Scalars['Int']['input']>;
  productForeignOperators?: InputMaybe<Array<Scalars['Int']['input']>>;
  translatedDescriptions?: InputMaybe<Scalars['JSON']['input']>;
};

/** Available parameters to create a Report Group */
export type CreateReportGroupParams = {
  name: Scalars['String']['input'];
  operationIds: Array<Scalars['Int']['input']>;
  position: Scalars['Int']['input'];
  reference: ReportReferenceEnum;
};

/** Available parameters to create a Report */
export type CreateReportParams = {
  columns?: InputMaybe<Scalars['JSON']['input']>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  reportGroupId: Scalars['Int']['input'];
  sorting?: InputMaybe<Scalars['JSON']['input']>;
};

/** Available parameters to create a Report Request */
export type CreateReportRequestParams = {
  columns: Scalars['JSON']['input'];
  datetimeFormat?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  orderFilters?: InputMaybe<Scalars['JSON']['input']>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<Scalars['JSON']['input']>;
  reportId: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Available parameters to create a Route */
export type CreateRouteParams = {
  name: Scalars['String']['input'];
  points?: InputMaybe<Array<NestedCreateRoutePointParams>>;
};

/** Available parameters to create a Trailer */
export type CreateTrailerParams = {
  isRefrigerated?: InputMaybe<Scalars['Boolean']['input']>;
  plate: Scalars['String']['input'];
  speedLimitDry?: InputMaybe<Scalars['Int']['input']>;
  speedLimitWet?: InputMaybe<Scalars['Int']['input']>;
  tareWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  temperatureMax?: InputMaybe<Scalars['Int']['input']>;
  temperatureMin?: InputMaybe<Scalars['Int']['input']>;
  trackerBrand?: InputMaybe<TrackerBrandEnum>;
  trackerId?: InputMaybe<Scalars['String']['input']>;
  type: TrailerTypeEnum;
};

/** Available parameters to create a user */
export type CreateUserParams = {
  accessGroupIds: Array<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
};

/** Available parameters to create a Vehicle */
export type CreateVehicleParams = {
  isRefrigerated?: InputMaybe<Scalars['Boolean']['input']>;
  plate: Scalars['String']['input'];
  speedLimitDry?: InputMaybe<Scalars['Int']['input']>;
  speedLimitWet?: InputMaybe<Scalars['Int']['input']>;
  tareWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  temperatureMax?: InputMaybe<Scalars['Int']['input']>;
  temperatureMin?: InputMaybe<Scalars['Int']['input']>;
  trackerBrand?: InputMaybe<TrackerBrandEnum>;
  trackerId?: InputMaybe<Scalars['String']['input']>;
  type: VehicleTypeEnum;
};

/** Available parameters to create a Warehouse Order Item */
export type CreateWarehouseOrderItemParams = {
  extra?: InputMaybe<Scalars['JSON']['input']>;
  isHighRunner: Scalars['Boolean']['input'];
  productSku?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Decimal']['input'];
  sector?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  supplyOrigin: OriginTypeEnum;
  type: WarehouseOrderTypeEnum;
};

/** Available parameters to create a Warehouse Order */
export type CreateWarehouseOrderParams = {
  items?: InputMaybe<Array<CreateWarehouseOrderItemParams>>;
  orderDatetime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** A Credential */
export type Credential = {
  __typename?: 'Credential';
  actor: Actor;
  app: AppTypeEnum;
  ecpf: Maybe<Ecpf>;
  filePath: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Maybe<Scalars['String']['output']>;
  originalFilename: Maybe<Scalars['String']['output']>;
  partnerships: Array<Partnership>;
  password: Maybe<Scalars['String']['output']>;
  type: CredentialTypeEnum;
};

/** The Credential Type Enum */
export enum CredentialTypeEnum {
  /** E-CPF */
  Ecpf = 'ECPF',
  /** Freight Forwarder API Credentials */
  FreightForwarderApiCredentials = 'FREIGHT_FORWARDER_API_CREDENTIALS'
}

/** A Currency */
export type Currency = {
  __typename?: 'Currency';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  symbol: Maybe<Scalars['String']['output']>;
};

/** The Currency Order By Enum */
export enum CurrencyOrderByEnum {
  /** Código */
  Code = 'CODE',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Nome */
  Name = 'NAME',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

export type CurrencyOrderParams = {
  field?: InputMaybe<CurrencyOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Currencies */
export type CurrencyPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CurrencyOrderParams>>;
};

/** A Custom Facility */
export type CustomFacility = {
  __typename?: 'CustomFacility';
  administrator: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  jurisdictionalUnit: Maybe<Scalars['String']['output']>;
  maritimePort: MaritimePort;
  state: Maybe<Scalars['String']['output']>;
  streetAddress: Maybe<Scalars['String']['output']>;
  taxRegion: Maybe<Scalars['String']['output']>;
};

/** A Dashboard */
export type Dashboard = {
  __typename?: 'Dashboard';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

/** A Dashboard Access */
export type DashboardAccess = {
  __typename?: 'DashboardAccess';
  accessGroup: AccessGroup;
  dashboard: Dashboard;
  position: Scalars['Int']['output'];
};

/** The Deadline Date Reference Enum */
export enum DeadlineDateReferenceEnum {
  /** Automatic */
  Automatic = 'AUTOMATIC',
  /** Manual */
  Manual = 'MANUAL',
  /** Port Terminal */
  PortTerminal = 'PORT_TERMINAL',
  /** Sealine */
  Sealine = 'SEALINE'
}

/** A Container Debit Note */
export type DebitNote = {
  __typename?: 'DebitNote';
  coverageEndAt: Scalars['DateTime']['output'];
  coverageStartAt: Scalars['DateTime']['output'];
  daysCovered: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  number: Scalars['String']['output'];
  payedAt: Maybe<Scalars['DateTime']['output']>;
  totalValueBrl: Maybe<Scalars['Decimal']['output']>;
  totalValueUsd: Scalars['Decimal']['output'];
  usdToBrlRate: Scalars['Decimal']['output'];
};

export type DefineBookingQuotationWinnerParams = {
  collectionNotes?: InputMaybe<Scalars['String']['input']>;
};

/** A Demurrage */
export type Demurrage = {
  __typename?: 'Demurrage';
  calculations: DemurrageCalculations;
  dailyRateUsd: Maybe<Scalars['Decimal']['output']>;
  foreignTradeShipment: Maybe<ForeignTradeShipment>;
  freeTime: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

/** Demurrage calculations */
export type DemurrageCalculations = {
  __typename?: 'DemurrageCalculations';
  averageCostPerDayUsd: Scalars['Decimal']['output'];
  totalDaysPaid: Scalars['Int']['output'];
  totalDaysToPay: Scalars['Int']['output'];
  totalEstimatedCosts: Scalars['Decimal']['output'];
  totalExceedingDays: Scalars['Int']['output'];
  totalOwedUsd: Scalars['Decimal']['output'];
  totalPaidUsd: Scalars['Decimal']['output'];
  totalToPayUsd: Scalars['Decimal']['output'];
};

/** A Vessel Dimensions */
export type Dimensions = {
  __typename?: 'Dimensions';
  a: Maybe<Scalars['Int']['output']>;
  b: Maybe<Scalars['Int']['output']>;
  c: Maybe<Scalars['Int']['output']>;
  d: Maybe<Scalars['Int']['output']>;
  length: Maybe<Scalars['Int']['output']>;
  width: Maybe<Scalars['Int']['output']>;
};

/** A Document */
export type Document = {
  __typename?: 'Document';
  brazilianInvoiceInfo: Maybe<BrazilianInvoice>;
  description: Maybe<Scalars['String']['output']>;
  documents: Array<Document>;
  externalId: Maybe<Scalars['String']['output']>;
  fileUrl: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  invoice: Maybe<Invoice>;
  order: Maybe<Order>;
  originalFilename: Scalars['String']['output'];
  parentDocument: Maybe<Document>;
  process: Maybe<Process>;
  transportAcknowledgmentInfo: Maybe<TransportAcknowledgment>;
  type: DocumentTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
};

/** The Document Type Enum */
export enum DocumentTypeEnum {
  /** Documentos Adicionais de Seguro */
  AdditionalInsuranceDocuments = 'ADDITIONAL_INSURANCE_DOCUMENTS',
  /** Certificado de Análise */
  AnalysisCertificate = 'ANALYSIS_CERTIFICATE',
  /** Documentos de Embarque Aprovados */
  ApprovedShippingDocuments = 'APPROVED_SHIPPING_DOCUMENTS',
  /** BL */
  BillOfLading = 'BILL_OF_LADING',
  /** Booking */
  Booking = 'BOOKING',
  /** Nota Fiscal (BR) */
  BrazilianInvoice = 'BRAZILIAN_INVOICE',
  /** Relatório Teste Carbendazim */
  CarbendazimTestReport = 'CARBENDAZIM_TEST_REPORT',
  /** Comprovante de Presença de Carga */
  CargoPresence = 'CARGO_PRESENCE',
  /** Ordem de Coleta */
  CollectOrder = 'COLLECT_ORDER',
  /** Nota Fiscal Comercial */
  CommercialInvoice = 'COMMERCIAL_INVOICE',
  /** Aviso de Chegada de Container */
  ContainerArrivalNotice = 'CONTAINER_ARRIVAL_NOTICE',
  /** Avarias Container */
  ContainerDamage = 'CONTAINER_DAMAGE',
  /** Comprovante Devolução Vazio */
  ContainerProofOfReturn = 'CONTAINER_PROOF_OF_RETURN',
  /** Carta de Correção */
  CorrectionLetter = 'CORRECTION_LETTER',
  /** Fechamento de Custos */
  CostClosing = 'COST_CLOSING',
  /** CRT */
  Crt = 'CRT',
  /** Declaração de Trânsito Aduaneiro (DTA) */
  CustomsTransitDeclaration = 'CUSTOMS_TRANSIT_DECLARATION',
  /** Solicitação de Mercadorias Perigosas */
  DangerousGoodsRequest = 'DANGEROUS_GOODS_REQUEST',
  /** Certificado de Data (Fabricação/Validade) */
  DateCertificate = 'DATE_CERTIFICATE',
  /** Nota de Débito */
  DebitNote = 'DEBIT_NOTE',
  /** Nota Fiscal Derivada (Filha) */
  DerivedChildInvoice = 'DERIVED_CHILD_INVOICE',
  /** Extrato de Retificação DI */
  DiRectificationStatement = 'DI_RECTIFICATION_STATEMENT',
  /** Draft BL */
  DraftBl = 'DRAFT_BL',
  /** Draft CO */
  DraftCo = 'DRAFT_CO',
  /** Laudo de Arqueação - RPA */
  DraughtReport = 'DRAUGHT_REPORT',
  /** Declaração de Exportação */
  ExportDeclaration = 'EXPORT_DECLARATION',
  /** Declaração Única de Exportação (DUE) */
  ExportDeclarationDue = 'EXPORT_DECLARATION_DUE',
  /** Contrato de Câmbio */
  ForeignExchangeContract = 'FOREIGN_EXCHANGE_CONTRACT',
  /** Cotação Frete */
  FreightQuote = 'FREIGHT_QUOTE',
  /** Comprovantes Frete */
  FreightReceipts = 'FREIGHT_RECEIPTS',
  /** Certificado de Fumigação */
  FumigationCertificate = 'FUMIGATION_CERTIFICATE',
  /** GRU Anvisa */
  GruAnvisa = 'GRU_ANVISA',
  /** HAWB */
  Hawb = 'HAWB',
  /** Certificado de saúde */
  HealthCertificate = 'HEALTH_CERTIFICATE',
  /** Guia ICMS */
  Icms = 'ICMS',
  /** Declaração de Importação */
  ImportDeclaration = 'IMPORT_DECLARATION',
  /** Declaração de Importação (DI) */
  ImportDeclarationDi = 'IMPORT_DECLARATION_DI',
  /** Declaração Única de Importação (DUIMP) */
  ImportDeclarationDuimp = 'IMPORT_DECLARATION_DUIMP',
  /** Licença de Importação */
  ImportLicense = 'IMPORT_LICENSE',
  /** Licença de Importação (LI) */
  ImportLicenseLi = 'IMPORT_LICENSE_LI',
  /** Certificado de Inspeção */
  InspectionCertificate = 'INSPECTION_CERTIFICATE',
  /** Apólice de Seguro */
  InsurancePolicy = 'INSURANCE_POLICY',
  /** Nota Fiscal */
  Invoice = 'INVOICE',
  /** ISF-5 */
  Isf_5 = 'ISF_5',
  /** ISF-10 */
  Isf_10 = 'ISF_10',
  /** Relatório de Análise Laboratorial */
  LabAnalysisReport = 'LAB_ANALYSIS_REPORT',
  /** LPCO */
  Lpco = 'LPCO',
  /** Liberação MAPA */
  MapaApproval = 'MAPA_APPROVAL',
  /** MDFe */
  Mdfe = 'MDFE',
  /** Comprovante Marinha Mercante */
  MerchantMarineDocument = 'MERCHANT_MARINE_DOCUMENT',
  /** MIC */
  Mic = 'MIC',
  /** Confirmação do Pedido */
  OrderConfirmation = 'ORDER_CONFIRMATION',
  /** Certificado de Origem */
  OriginCertificate = 'ORIGIN_CERTIFICATE',
  /** Outro */
  Other = 'OTHER',
  /** Packing List */
  PackingList = 'PACKING_LIST',
  /** Certificado Fitossanitário */
  PhytosanitaryCertificate = 'PHYTOSANITARY_CERTIFICATE',
  /** Proforma Invoice */
  ProformaInvoice = 'PROFORMA_INVOICE',
  /** Comprovante de Entrega */
  ProofOfDelivery = 'PROOF_OF_DELIVERY',
  /** Comprovante de Importação */
  ProofOfImport = 'PROOF_OF_IMPORT',
  /** Comprovante de Pagamento (Swift/ABA) */
  ProofOfPayment = 'PROOF_OF_PAYMENT',
  /** Pedido de Compra */
  PurchaseOrder = 'PURCHASE_ORDER',
  /** Certificado de Qualidade */
  QualityCertificate = 'QUALITY_CERTIFICATE',
  /** Contrato de Venda */
  SalesContract = 'SALES_CONTRACT',
  /** Pedido de Venda */
  SalesOrder = 'SALES_ORDER',
  /** Certificado Sanitário */
  SanitaryCertificate = 'SANITARY_CERTIFICATE',
  /** Conhecimento de Embarque */
  ShipmentDocument = 'SHIPMENT_DOCUMENT',
  /** Pré-Alerta de Embarque */
  ShipmentPreAlert = 'SHIPMENT_PRE_ALERT',
  /** Conselho de Envio */
  ShippingAdvice = 'SHIPPING_ADVICE',
  /** Documentos de Embarque para Aprovação */
  ShippingDocumentsForApproval = 'SHIPPING_DOCUMENTS_FOR_APPROVAL',
  /** Instruções de Transporte */
  ShippingInstructions = 'SHIPPING_INSTRUCTIONS',
  /** Plano de Estufagem */
  StuffingPlan = 'STUFFING_PLAN',
  /** Etiqueta */
  Tag = 'TAG',
  /** CTE */
  TransportAcknowledgment = 'TRANSPORT_ACKNOWLEDGMENT',
  /** Certificado Veterinário */
  VeterinaryCertificate = 'VETERINARY_CERTIFICATE',
  /** Certificado Peso e Qualidade */
  WeightAndQualityCertificate = 'WEIGHT_AND_QUALITY_CERTIFICATE',
  /** Certificado de Peso */
  WeightCertificate = 'WEIGHT_CERTIFICATE',
  /** Declaração Embalagem Madeira */
  WoodPackagingDeclaration = 'WOOD_PACKAGING_DECLARATION'
}

/** A Driver */
export type Driver = {
  __typename?: 'Driver';
  actor: Maybe<Actor>;
  birthday: Maybe<Scalars['Date']['output']>;
  country: Country;
  cpf: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  licenseCategory: Maybe<Scalars['String']['output']>;
  licenseExpirationDate: Maybe<Scalars['Date']['output']>;
  licenseNumber: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  officialDocument: Maybe<Scalars['String']['output']>;
  roadTransportShipments: Array<RoadTransportShipment>;
};

/** The Driver Order By Enum */
export enum DriverOrderByEnum {
  /** Data de nascimento */
  Birthday = 'BIRTHDAY',
  /** CPF */
  Cpf = 'CPF',
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Categoria da licença */
  LicenseCategory = 'LICENSE_CATEGORY',
  /** Data de expiração da licença */
  LicenseExpirationDate = 'LICENSE_EXPIRATION_DATE',
  /** Número de licença */
  LicenseNumber = 'LICENSE_NUMBER',
  /** Nome */
  Name = 'NAME',
  /** RG */
  Rg = 'RG',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

export type DriverOrderParams = {
  field?: InputMaybe<DriverOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Drivers */
export type DriverPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DriverOrderParams>>;
};

/** An DUIMP */
export type Duimp = {
  __typename?: 'Duimp';
  channel: Maybe<ChannelTypeEnum>;
  customsClearedAt: Maybe<Scalars['DateTime']['output']>;
  deliveredAt: Maybe<Scalars['DateTime']['output']>;
  extra: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  importer: Maybe<Actor>;
  insertedAt: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  number: Scalars['String']['output'];
  registeredAt: Maybe<Scalars['DateTime']['output']>;
  status: Maybe<DuimpStatusEnum>;
  statusResponse: StatusResponseTypeEnum;
  statusUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  version: Maybe<Scalars['Int']['output']>;
};

/** The DUIMP Status Enum */
export enum DuimpStatusEnum {
  /** Entrega antecipada aguardando entrega da carga */
  AdvanceDeliveryAwaitingCargoDelivery = 'ADVANCE_DELIVERY_AWAITING_CARGO_DELIVERY',
  /** Entrega antecipada aguardando pendência de tributos estaduais */
  AdvanceDeliveryAwaitingStateTaxPending = 'ADVANCE_DELIVERY_AWAITING_STATE_TAX_PENDING',
  /** Entrega antecipada, carga entregue */
  AdvanceDeliveryCargoDelivered = 'ADVANCE_DELIVERY_CARGO_DELIVERED',
  /** Cancelada pela Aduana */
  CanceledByCustoms = 'CANCELED_BY_CUSTOMS',
  /** Cancelada por apuração */
  CanceledByVerification = 'CANCELED_BY_VERIFICATION',
  /** Desembaraçada aguardando entrega da carga */
  ClearedAwaitingCargoDelivery = 'CLEARED_AWAITING_CARGO_DELIVERY',
  /** Desembaraçada aguardando pendência de tributos estaduais */
  ClearedAwaitingStateTaxPending = 'CLEARED_AWAITING_STATE_TAX_PENDING',
  /** Desembaraçada, carga entregue */
  ClearedCargoDelivered = 'CLEARED_CARGO_DELIVERED',
  /** Registrada aguardando canal */
  RegisteredAwaitingChannel = 'REGISTERED_AWAITING_CHANNEL',
  /** Em conferência, selecionada */
  SelectedForInspection = 'SELECTED_FOR_INSPECTION'
}

/** Result of a DUIMP Siscomex sync subscription */
export type DuimpSyncSubscriptionData = {
  __typename?: 'DuimpSyncSubscriptionData';
  data: Duimp;
  shipment: ShipmentDuimp;
};

/** A Dynamic Fields Definition */
export type DynamicFieldsDefinition = {
  __typename?: 'DynamicFieldsDefinition';
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: DynamicFieldsDefinitionTypeEnum;
  variant: Maybe<DynamicFieldsDefinitionVariantEnum>;
};

/** The Dynamic Fields Definition Type Enum */
export enum DynamicFieldsDefinitionTypeEnum {
  /** Boolean */
  Boolean = 'BOOLEAN',
  /** Date */
  Date = 'DATE',
  /** Number */
  Number = 'NUMBER',
  /** Text */
  Text = 'TEXT'
}

/** The Dynamic Fields Definition Variant Enum */
export enum DynamicFieldsDefinitionVariantEnum {
  /** Time */
  Time = 'TIME'
}

/** A Dynamic Table Data */
export type DynamicTableData = {
  __typename?: 'DynamicTableData';
  data: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** The Dynamic Table Data order by enum */
export enum DynamicTableDataOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

/** Available parameters to sort Dynamic Table Data */
export type DynamicTableDataOrderParams = {
  field?: InputMaybe<DynamicTableDataOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Dynamic Table Data */
export type DynamicTableDataPaginationParams = {
  /** Defaults to 100 and is capped at 1000 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DynamicTableDataOrderParams>>;
};

/** A Dynamic Table Definition */
export type DynamicTableDefinition = {
  __typename?: 'DynamicTableDefinition';
  actor: Actor;
  dynamicTableData: Maybe<Array<Maybe<DynamicTableData>>>;
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  schema: Maybe<Array<Maybe<DynamicFieldsDefinition>>>;
  type: DynamicTableDefinitionTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
};

/** The Dynamic Table Definition Type by Enum */
export enum DynamicTableDefinitionTypeEnum {
  /** Automations */
  Automations = 'AUTOMATIONS',
  /** Custos */
  Costs = 'COSTS',
  /** Demurrage */
  Demurrage = 'DEMURRAGE'
}

/** An E-CPF */
export type Ecpf = {
  __typename?: 'Ecpf';
  commonName: Scalars['String']['output'];
  cpf: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
};

/** An Electronic Invoice */
export type ElectronicInvoice = {
  __typename?: 'ElectronicInvoice';
  accessKey: Maybe<Scalars['String']['output']>;
  cnpj: Maybe<Scalars['String']['output']>;
  code: Maybe<Scalars['String']['output']>;
  emissionFormat: Maybe<Scalars['String']['output']>;
  model: Maybe<Scalars['String']['output']>;
  month: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['String']['output']>;
  serie: Maybe<Scalars['String']['output']>;
  ufCode: Maybe<Scalars['String']['output']>;
  verificationCode: Maybe<Scalars['String']['output']>;
  year: Maybe<Scalars['String']['output']>;
};

/** The Entity Type Enum */
export enum EntityType {
  /** Pedido */
  Order = 'ORDER',
  /** Processo */
  Process = 'PROCESS'
}

/** An event-triggered agent config */
export type EventAgentConfig = {
  __typename?: 'EventAgentConfig';
  entity: AgentEntityTypeEnum;
  event: AgentTriggerEventEnum;
  operationIds: Maybe<Array<Scalars['Int']['output']>>;
};

/** Parameters for an event-triggered agent config */
export type EventAgentConfigParams = {
  entity: AgentEntityTypeEnum;
  event: AgentTriggerEventEnum;
  operationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** An Export Declaration */
export type ExportDeclaration = {
  __typename?: 'ExportDeclaration';
  channel: Maybe<ChannelExportDeclarationTypeEnum>;
  customsClearedAt: Maybe<Scalars['DateTime']['output']>;
  endorsedAt: Maybe<Scalars['DateTime']['output']>;
  events: Array<ExportDeclarationEvent>;
  extra: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  insertedAt: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  number: Scalars['String']['output'];
  registeredAt: Maybe<Scalars['DateTime']['output']>;
  status: Maybe<ExportDeclarationStatusEnum>;
  statusResponse: StatusResponseTypeEnum;
};

/** An Export Declaration Event */
export type ExportDeclarationEvent = {
  __typename?: 'ExportDeclarationEvent';
  action: Maybe<ExportDeclarationEventActionEnum>;
  date: Maybe<Scalars['DateTime']['output']>;
  extraInfo: Maybe<Scalars['String']['output']>;
  responsible: Maybe<Scalars['String']['output']>;
};

/** The Export Declaration Event Action Enum */
export enum ExportDeclarationEventActionEnum {
  /** AS Drawback Result */
  AcDrawbackResult = 'AC_DRAWBACK_RESULT',
  /** AC Drawback Solicitation */
  AcDrawbackSolicitation = 'AC_DRAWBACK_SOLICITATION',
  /** Desvinculação de AC de Drawback isenção */
  AcDrawbackUnlink = 'AC_DRAWBACK_UNLINK',
  /** Anticipated Early Boarding Authorized */
  AnticipatedEarlyBoardingAuthorized = 'ANTICIPATED_EARLY_BOARDING_AUTHORIZED',
  /** Available for dispatch */
  AvailableForDispatch = 'AVAILABLE_FOR_DISPATCH',
  /** Blocked Boarding */
  BlockedBoarding = 'BLOCKED_BOARDING',
  /** Boarding Data Manifestation */
  BoardingDataManifestation = 'BOARDING_DATA_MANIFESTATION',
  /** Cancel Boarding Data Manifestation */
  CancelBoardingDataManifestation = 'CANCEL_BOARDING_DATA_MANIFESTATION',
  /** Cancel Rectification Request */
  CancelRectificationRequest = 'CANCEL_RECTIFICATION_REQUEST',
  /** Cancel Request Acceptance */
  CancelRequestAcceptance = 'CANCEL_REQUEST_ACCEPTANCE',
  /** Cancel Request Indeferment */
  CancelRequestIndeferment = 'CANCEL_REQUEST_INDEFERMENT',
  /** Cancel Request Registration */
  CancelRequestRegistration = 'CANCEL_REQUEST_REGISTRATION',
  /** Cancel Transit */
  CancelTransit = 'CANCEL_TRANSIT',
  /** Cargo Completely Exported */
  CargoCompletelyExported = 'CARGO_COMPLETELY_EXPORTED',
  /** Cargo Consolidation */
  CargoConsolidation = 'CARGO_CONSOLIDATION',
  /** Cargo Delivery */
  CargoDelivery = 'CARGO_DELIVERY',
  /** Cargo Deunitisation */
  CargoDeunitisation = 'CARGO_DEUNITISATION',
  /** Cargo Reception */
  CargoReception = 'CARGO_RECEPTION',
  /** Cargo Unitisation */
  CargoUnitisation = 'CARGO_UNITISATION',
  /** Clearance */
  Clearance = 'CLEARANCE',
  /** Clearance Waiting Resolution of Administrative Pendency */
  ClearanceWaitingResolutionOfAdministrativePendency = 'CLEARANCE_WAITING_RESOLUTION_OF_ADMINISTRATIVE_PENDENCY',
  /** Confirmation */
  Confirmation = 'CONFIRMATION',
  /** DAT Manifestation */
  DatManifestation = 'DAT_MANIFESTATION',
  /** Deadline Expired Cancelation */
  DeadlineExpiredCancelation = 'DEADLINE_EXPIRED_CANCELATION',
  /** Distribution for Tax Analysis */
  DistributionForTaxAnalysis = 'DISTRIBUTION_FOR_TAX_ANALYSIS',
  /** DUE Rectification */
  DueRectification = 'DUE_RECTIFICATION',
  /** Exporter Cancelation */
  ExporterCancelation = 'EXPORTER_CANCELATION',
  /** Fiscal Analysis Cancel Request Selection */
  FiscalAnalysisCancelRequestSelection = 'FISCAL_ANALYSIS_CANCEL_REQUEST_SELECTION',
  /** Fiscal Analysis Conclusion */
  FiscalAnalysisConclusion = 'FISCAL_ANALYSIS_CONCLUSION',
  /** Fiscal Analysis Team Movimentation */
  FiscalAnalysisTeamMovimentation = 'FISCAL_ANALYSIS_TEAM_MOVIMENTATION',
  /** Inclusion of Tax Requirements */
  InclusionOfTaxRequirements = 'INCLUSION_OF_TAX_REQUIREMENTS',
  /** Inclusion of Tax Requirements After Clearence */
  InclusionOfTaxRequirementsAfterClearence = 'INCLUSION_OF_TAX_REQUIREMENTS_AFTER_CLEARENCE',
  /** Load Deconsolidation */
  LoadDeconsolidation = 'LOAD_DECONSOLIDATION',
  /** LPCO Acceptance */
  LpcoAcceptance = 'LPCO_ACCEPTANCE',
  /** Rectification Boarding Data */
  RectificationBoardingData = 'RECTIFICATION_BOARDING_DATA',
  /** Rectification Manifestation */
  RectificationManifestation = 'RECTIFICATION_MANIFESTATION',
  /** Rectification Request Acceptance */
  RectificationRequestAcceptance = 'RECTIFICATION_REQUEST_ACCEPTANCE',
  /** Rectification Request Registration */
  RectificationRequestRegistration = 'RECTIFICATION_REQUEST_REGISTRATION',
  /** Rectification Solicitation Selection */
  RectificationSolicitationSelection = 'RECTIFICATION_SOLICITATION_SELECTION',
  /** Redistribution for Tax Analysis */
  RedistributionForTaxAnalysis = 'REDISTRIBUTION_FOR_TAX_ANALYSIS',
  /** Register */
  Register = 'REGISTER',
  /** Release no Customs Conference */
  ReleaseNoCustomsConference = 'RELEASE_NO_CUSTOMS_CONFERENCE',
  /** Release of Tax Requirements */
  ReleaseOfTaxRequirements = 'RELEASE_OF_TAX_REQUIREMENTS',
  /** RFB Cancel Exporter Request */
  RfbCancelExporterRequest = 'RFB_CANCEL_EXPORTER_REQUEST',
  /** RVF Conclusion */
  RvfConclusion = 'RVF_CONCLUSION',
  /** RVF Distributed */
  RvfDistributed = 'RVF_DISTRIBUTED',
  /** RFV Distribution */
  RvfDistribution = 'RVF_DISTRIBUTION',
  /** RVF Redistribution */
  RvfRedistribution = 'RVF_REDISTRIBUTION',
  /** RVF Solicitation */
  RvfSolicitation = 'RVF_SOLICITATION',
  /** Selection for Customs Conference */
  SelectionForCustomsConference = 'SELECTION_FOR_CUSTOMS_CONFERENCE',
  /** Tax Analysis */
  TaxAnalysis = 'TAX_ANALYSIS',
  /** Transit Authorization */
  TransitAuthorization = 'TRANSIT_AUTHORIZATION',
  /** Transit Authorization Request */
  TransitAuthorizationRequest = 'TRANSIT_AUTHORIZATION_REQUEST',
  /** Transit Conclusion */
  TransitConclusion = 'TRANSIT_CONCLUSION',
  /** Unblocked Boarding */
  UnblockedBoarding = 'UNBLOCKED_BOARDING'
}

/** The Export Declaration Status Enum */
export enum ExportDeclarationStatusEnum {
  /** ACD em processamento */
  AcdInProcessing = 'ACD_IN_PROCESSING',
  /** Cancelada pela Aduana */
  CanceledByCustoms = 'CANCELED_BY_CUSTOMS',
  /** Cancelada pela Aduana a pedido do exportador */
  CanceledByCustomsAtTheRequestOfTheExporter = 'CANCELED_BY_CUSTOMS_AT_THE_REQUEST_OF_THE_EXPORTER',
  /** Cancelada pelo Exportador */
  CanceledByTheExporter = 'CANCELED_BY_THE_EXPORTER',
  /** Cancelada por Expiração de Prazo */
  CanceledDueToExpirationOfDeadline = 'CANCELED_DUE_TO_EXPIRATION_OF_DEADLINE',
  /** Desembaraçada */
  Cleared = 'CLEARED',
  /** Desembaraço aguardando resolução de pendência administrativa */
  CustomsClearanceAwaitingResolutionOfAdministrativeIssues = 'CUSTOMS_CLEARANCE_AWAITING_RESOLUTION_OF_ADMINISTRATIVE_ISSUES',
  /** Declaração Apresentada para Despacho */
  DeclarationSubmittedForCustomsClearance = 'DECLARATION_SUBMITTED_FOR_CUSTOMS_CLEARANCE',
  /** Embarque antecipado autorizado */
  EarlyShipmentAuthorized = 'EARLY_SHIPMENT_AUTHORIZED',
  /** Embarque antecipado pendente de autorização */
  EarlyShipmentPendingAuthorization = 'EARLY_SHIPMENT_PENDING_AUTHORIZATION',
  /** Embarque antecipado pendente de LPCO */
  EarlyShipmentPendingLpco = 'EARLY_SHIPMENT_PENDING_LPCO',
  /** Averbada */
  Endorsed = 'ENDORSED',
  /** Concluída análise fiscal */
  FiscalAnalysisCompleted = 'FISCAL_ANALYSIS_COMPLETED',
  /** Interrompida */
  Interrupted = 'INTERRUPTED',
  /** Em elaboração */
  InPreparation = 'IN_PREPARATION',
  /** Desembaraço pendente de LPCO */
  LpcoClearancePending = 'LPCO_CLEARANCE_PENDING',
  /** Registrada */
  Registered = 'REGISTERED',
  /** Liberada sem conferência Aduaneira canal verde */
  ReleasedWithoutCustomsInspectionGreenChannel = 'RELEASED_WITHOUT_CUSTOMS_INSPECTION_GREEN_CHANNEL',
  /** Cancelada pela RFB a pedido do exportador */
  RfbCancelExporterRequest = 'RFB_CANCEL_EXPORTER_REQUEST',
  /** Selecionada para Conferência Aduaneira */
  SelectedForCustomsConference = 'SELECTED_FOR_CUSTOMS_CONFERENCE',
  /** Selecionada para conferência canal laranja ou vermelho */
  SelectedForInspectionOrangeOrRedChannel = 'SELECTED_FOR_INSPECTION_ORANGE_OR_RED_CHANNEL',
  /** Em análise fiscal */
  UnderFiscalAnalysis = 'UNDER_FISCAL_ANALYSIS'
}

/** Result of a DUE Siscomex sync subscription */
export type ExportDeclarationSyncSubscriptionData = {
  __typename?: 'ExportDeclarationSyncSubscriptionData';
  data: ExportDeclaration;
  shipment: ShipmentExportDeclaration;
};

/** An External Page configured for an Operation */
export type ExternalPage = {
  __typename?: 'ExternalPage';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  type: ExternalPageTypeEnum;
};

/** A publication of an External Page */
export type ExternalPagePublication = {
  __typename?: 'ExternalPagePublication';
  canceledAt: Maybe<Scalars['DateTime']['output']>;
  cancellationReason: Maybe<Scalars['String']['output']>;
  closesAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  lastInviteSentAt: Maybe<Scalars['DateTime']['output']>;
  publishedAt: Maybe<Scalars['DateTime']['output']>;
};

/** The kind of External Page */
export enum ExternalPageTypeEnum {
  /** Dados do Booking */
  BookingData = 'BOOKING_DATA',
  /** Cotação de Booking */
  BookingQuotation = 'BOOKING_QUOTATION'
}

/** A Feature Access With Feature Slug */
export type FeatureAccessWithSlug = {
  __typename?: 'FeatureAccessWithSlug';
  slug: Scalars['String']['output'];
  type: AccessEnum;
};

/** The LPCO Fee Payment Status Enum */
export enum FeePaymentStatusEnum {
  /** Erro sem tentativa */
  ErrorNoAttempt = 'ERROR_NO_ATTEMPT',
  /** Erro com tentativa */
  ErrorWithAttempt = 'ERROR_WITH_ATTEMPT',
  /** Sem erro */
  NoError = 'NO_ERROR'
}

/** A fence */
export type Fence = {
  __typename?: 'Fence';
  address: Address;
  fencePoints: Array<FencePoint>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** A fence point */
export type FencePoint = {
  __typename?: 'FencePoint';
  fence: Fence;
  id: Scalars['Int']['output'];
  latitude: Scalars['String']['output'];
  longitude: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

export type File = {
  __typename?: 'File';
  base64: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/** Available parameters to filter an Actor */
export type FilterActorsParams = {
  hideOwnerActor?: InputMaybe<Scalars['Boolean']['input']>;
  partnershipRole?: InputMaybe<OperationHandlerEnum>;
};

/** Available parameters to filter an Address */
export type FilterAddressesParams = {
  actorId?: InputMaybe<Scalars['Int']['input']>;
};

/** Available parameters to filter a Agent execution */
export type FilterAgentExecutionParams = {
  agentId?: InputMaybe<Scalars['Int']['input']>;
  devMode?: InputMaybe<Scalars['Boolean']['input']>;
  lpcoId?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  processId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<AgentExecutionStatusEnum>>;
};

/** Available parameters to filter a Agent */
export type FilterAgentParams = {
  actorId?: InputMaybe<Scalars['Int']['input']>;
  processorId?: InputMaybe<Scalars['Int']['input']>;
};

/** Available parameters to filter a Aggregated Lead Time */
export type FilterAggregatedLeadTimeParams = {
  endAt?: InputMaybe<Scalars['Date']['input']>;
  plannedIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
};

/** Available parameters to filter API Requests */
export type FilterApiRequestParams = {
  apiKeyId?: InputMaybe<Array<Scalars['Int']['input']>>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  item?: InputMaybe<ApiRequestItemFilterParams>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  method?: InputMaybe<HttpMethodsEnum>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  operationId?: InputMaybe<Array<Scalars['Int']['input']>>;
  statusCode?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Available parameters to filter an Automation */
export type FilterAutomationParams = {
  type?: InputMaybe<AutomationTypeEnum>;
};

/** Available parameters to filter a Container */
export type FilterContainerParams = {
  operationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Available parameters to filter a Cost Model */
export type FilterCostModelParams = {
  operationId?: InputMaybe<Scalars['Int']['input']>;
};

/** Available parameters to filter a Credential */
export type FilterCredentialParams = {
  app?: InputMaybe<AppTypeEnum>;
  type?: InputMaybe<CredentialTypeEnum>;
};

/** Available parameters to filter Insights */
export type FilterInsightParams = {
  lpcoId?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  processId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InsightStatusEnum>>;
};

/** Available parameters to filter an Invoice Item */
export type FilterInvoiceItemParams = {
  operationIds: Array<Scalars['Int']['input']>;
};

/** Available parameters to filter a Lead Time Model */
export type FilterLeadTimeModelParams = {
  name?: InputMaybe<Scalars['String']['input']>;
  operationId?: InputMaybe<Scalars['Int']['input']>;
  referenceEvent?: InputMaybe<Scalars['String']['input']>;
};

/** Available parameters to filter Maritime Ports */
export type FilterMaritimePortParams = {
  isActiveMercante?: InputMaybe<Scalars['Boolean']['input']>;
  unlocode?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Available parameters to filter Notification Groups */
export type FilterNotificationGroupParams = {
  actorId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Available parameters to filter Notification Group Recipients */
export type FilterNotificationGroupRecipientParams = {
  notificationGroupId?: InputMaybe<Scalars['Int']['input']>;
  partnershipId?: InputMaybe<Scalars['Int']['input']>;
};

/** Available parameters to filter an Operation Handler */
export type FilterOperationHandlerParams = {
  bindingType?: InputMaybe<Array<HandlerBindingTypeEnum>>;
  isListedInDynamicList?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Available parameters to filter an Operation */
export type FilterOperationParams = {
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

/** Available parameters to filter an Order Item */
export type FilterOrderItemParams = {
  operationIds: Array<Scalars['Int']['input']>;
};

/** Available parameters to filter an Order */
export type FilterOrderParams = {
  alertLevel?: InputMaybe<AlertLevelEnum>;
  handlerActorId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<Scalars['Int']['input']>>;
  operationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<StatusFilterEnum>>;
};

/** Available parameters to filter a Partnership by origin actor and partnership owner */
export type FilterPartnershipsByOriginActorParams = {
  partnershipOwnerId?: InputMaybe<Scalars['Int']['input']>;
};

/** Available parameters to filter a Partnership */
export type FilterPartnershipsParams = {
  originActor?: InputMaybe<FilterPartnershipsByOriginActorParams>;
  role?: InputMaybe<OperationHandlerEnum>;
};

/** Available parameters to filter a Planned Lead Time */
export type FilterPlannedLeadTimeParams = {
  leadTimeModelId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  operationId: Scalars['Int']['input'];
};

/** Available parameters to filter Port Schedules */
export type FilterPortScheduleParams = {
  carrierVoyage?: InputMaybe<Scalars['String']['input']>;
  endDateEtb: Scalars['Date']['input'];
  portUnlocode: Scalars['String']['input'];
  scheduleNumber?: InputMaybe<Scalars['String']['input']>;
  startDateEtb: Scalars['Date']['input'];
};

/** Available parameters to filter Port Terminals */
export type FilterPortTerminalParams = {
  id?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Available parameters to filter a Process */
export type FilterProcessParams = {
  alertLevel?: InputMaybe<AlertLevelEnum>;
  handlerActorId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<Scalars['Int']['input']>>;
  operationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<StatusFilterEnum>>;
};

/** Available parameters to filter a Product */
export type FilterProductParams = {
  leadTimeModelId?: InputMaybe<Scalars['Int']['input']>;
  operationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Available parameters to filter a National Road Transport Trip */
export type FilterRoadTransportTripParams = {
  operationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Available parameters to filter an Routes */
export type FilterRoutesParams = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Available parameters to filter an Shipment DUIMP */
export type FilterShipmentDuimpParams = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  operationIds: Array<Scalars['Int']['input']>;
  status?: InputMaybe<ShipmentDocumentAuthorizationStatusEnum>;
};

/** Available parameters to filter an Shipment Export Declaration */
export type FilterShipmentExportDeclarationParams = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  operationIds: Array<Scalars['Int']['input']>;
};

/** Available parameters to filter an Shipment Import Declaration */
export type FilterShipmentImportDeclarationParams = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  operationIds: Array<Scalars['Int']['input']>;
  status?: InputMaybe<ShipmentDocumentAuthorizationStatusEnum>;
};

/** Available parameters to filter an Shipment Import License */
export type FilterShipmentImportLicenseParams = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  operationIds: Array<Scalars['Int']['input']>;
  status?: InputMaybe<ShipmentDocumentAuthorizationStatusEnum>;
};

/** Available parameters to filter a Shipment Item */
export type FilterShipmentItemParams = {
  operationIds: Array<Scalars['Int']['input']>;
};

/** Available parameters to filter a Version */
export type FilterVersionParams = {
  event?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<VersionOriginEnum>;
  originatorId?: InputMaybe<Scalars['Int']['input']>;
};

/** Available parameters to filter Vessels */
export type FilterVesselParams = {
  isActiveMercante?: InputMaybe<Scalars['Boolean']['input']>;
  minLastPositionUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  onlyLinkedToUserProcesses?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A Foreign Trade Item Shipment */
export type ForeignTradeItemShipment = {
  __typename?: 'ForeignTradeItemShipment';
  brazilianInvoiceUnitValue: Maybe<Scalars['Decimal']['output']>;
  cubageCubicMeters: Maybe<Scalars['Decimal']['output']>;
  foreignTradeShipment: ForeignTradeShipment;
  grossWeightKg: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Int']['output'];
  netWeightKg: Maybe<Scalars['Decimal']['output']>;
  purchaseOrderItem: Maybe<PurchaseOrderItem>;
  quantity: Maybe<Scalars['Decimal']['output']>;
  salesOrderItem: Maybe<SalesOrderItem>;
  totalValue: Maybe<Scalars['Decimal']['output']>;
  transportables: Array<Transportable>;
  unitValue: Maybe<Scalars['Decimal']['output']>;
};


/** A Foreign Trade Item Shipment */
export type ForeignTradeItemShipmentTransportablesArgs = {
  containerHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A Foreign Trade Road Transport Shipment */
export type ForeignTradeRoadTransportShipment = {
  __typename?: 'ForeignTradeRoadTransportShipment';
  crt: Maybe<Scalars['String']['output']>;
  destination: Maybe<Scalars['String']['output']>;
  foreignTradeShipment: ForeignTradeShipment;
  id: Scalars['Int']['output'];
  origin: Maybe<Scalars['String']['output']>;
  type: Maybe<ForeignTradeRoadTransportTypeEnum>;
};

/** The Foreign Trade Road Transport Shipment Type Enum */
export enum ForeignTradeRoadTransportTypeEnum {
  /** FCL */
  Fcl = 'FCL',
  /** FTL */
  Ftl = 'FTL',
  /** LTL */
  Ltl = 'LTL'
}

/** A Foreign Trade Shipment */
export type ForeignTradeShipment = {
  __typename?: 'ForeignTradeShipment';
  airTransportShipment: Maybe<AirTransportShipment>;
  ata: Maybe<Scalars['DateTime']['output']>;
  ataDta: Maybe<Scalars['DateTime']['output']>;
  atd: Maybe<Scalars['DateTime']['output']>;
  atdDta: Maybe<Scalars['DateTime']['output']>;
  automaticTrackingEnabled: Scalars['Boolean']['output'];
  ceMercanteAuthorizationStatus: Maybe<ShipmentDocumentAuthorizationStatusEnum>;
  ceMercanteData: Maybe<CeMercanteData>;
  ceMercanteLastSyncErrorMessage: Maybe<Scalars['String']['output']>;
  ceMercanteLastSyncType: Maybe<SiscomexSyncTypeEnum>;
  ceMercanteNumber: Maybe<Scalars['String']['output']>;
  cubageCubicMeters: Maybe<Scalars['Decimal']['output']>;
  daysInWarehouse: Scalars['Int']['output'];
  daysLeftInWarehouse: Scalars['Int']['output'];
  deliveredAt: Maybe<Scalars['DateTime']['output']>;
  demurrage: Maybe<Demurrage>;
  departedFromWarehouseAt: Maybe<Scalars['DateTime']['output']>;
  emptyReturnDate: Maybe<Scalars['DateTime']['output']>;
  eta: Maybe<Scalars['DateTime']['output']>;
  etd: Maybe<Scalars['DateTime']['output']>;
  hawbShipmentData: Maybe<HawbShipmentData>;
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  internationalFreight: Maybe<InternationalFreight>;
  internationalTransportLegs: Array<InternationalTransportLeg>;
  invoices: Array<Invoice>;
  items: Array<ForeignTradeItemShipment>;
  lastTrackingAt: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  maritimeTransportShipment: Maybe<MaritimeTransportShipment>;
  nationalRoadTransports: Array<NationalRoadTransport>;
  pallets: Array<ShipmentPallet>;
  parcelShipments: Array<ParcelShipment>;
  process: Process;
  receivedInWarehouseAt: Maybe<Scalars['DateTime']['output']>;
  roadTransportShipment: Maybe<ForeignTradeRoadTransportShipment>;
  route: Maybe<Route>;
  shipmentDuimps: Array<ShipmentDuimp>;
  shipmentExportDeclarations: Array<ShipmentExportDeclaration>;
  shipmentImportDeclarations: Array<ShipmentImportDeclaration>;
  shipmentImportLicenses: Array<ShipmentImportLicense>;
  shipmentLpcos: Array<ShipmentLpco>;
  statusResponse: StatusResponseTypeEnum;
  totalGrossWeight: Maybe<Scalars['Decimal']['output']>;
  totalNetWeight: Maybe<Scalars['Decimal']['output']>;
  totalPallets: Scalars['Int']['output'];
  transportables: Array<Transportable>;
  type: Maybe<ShipmentTypeEnum>;
  vesselSchedule: Maybe<VesselSchedule>;
  vesselScheduleDeadlineReferences: Maybe<VesselScheduleDeadlineReferences>;
  warehouseFreeTimeDays: Scalars['Int']['output'];
};


/** A Foreign Trade Shipment */
export type ForeignTradeShipmentTransportablesArgs = {
  containerHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Result of a CE Mercante Siscomex sync subscription */
export type ForeignTradeShipmentCeMercanteSyncSubscriptionData = {
  __typename?: 'ForeignTradeShipmentCeMercanteSyncSubscriptionData';
  data: CeMercanteData;
  shipment: ForeignTradeShipment;
};

/** The Gate Opening Deadline Date Reference Enum */
export enum GateOpeningDeadlineDateReferenceEnum {
  /** Manual */
  Manual = 'MANUAL',
  /** Port Terminal */
  PortTerminal = 'PORT_TERMINAL'
}

/** A Handler */
export type Handler = {
  __typename?: 'Handler';
  actor: Actor;
  businessUnit: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  operationHandler: OperationHandler;
  partnership: Partnership;
  reference: Maybe<Scalars['String']['output']>;
  secondaryReference: Maybe<Scalars['String']['output']>;
};

/** The Handler Binding Enum */
export enum HandlerBindingTypeEnum {
  /** Handler vinculado a order */
  OrderHandler = 'ORDER_HANDLER',
  /** Handler vinculado ao processo */
  ProcessHandler = 'PROCESS_HANDLER'
}

/** A HAWB Shipment Data */
export type HawbShipmentData = {
  __typename?: 'HawbShipmentData';
  airline: Maybe<Airline>;
  arrivalPlaceDta: Maybe<Scalars['String']['output']>;
  ata: Maybe<Scalars['DateTime']['output']>;
  ataDta: Maybe<Scalars['DateTime']['output']>;
  atd: Maybe<Scalars['DateTime']['output']>;
  atdDta: Maybe<Scalars['DateTime']['output']>;
  cargoPresenceInPrimaryZoneAt: Maybe<Scalars['DateTime']['output']>;
  departurePlaceDta: Maybe<Scalars['String']['output']>;
  diNumber: Maybe<Scalars['String']['output']>;
  dtaNumber: Maybe<Scalars['String']['output']>;
  eta: Maybe<Scalars['DateTime']['output']>;
  etd: Maybe<Scalars['DateTime']['output']>;
  extra: Maybe<Scalars['JSON']['output']>;
  flight: Maybe<Scalars['String']['output']>;
  hawb: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  issuanceDate: Maybe<Scalars['DateTime']['output']>;
  loadingAirport: Airport;
  pwceCarrier: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  stopovers: Maybe<Scalars['Int']['output']>;
  unloadingAirport: Airport;
  vehiclePlateDta: Maybe<Scalars['String']['output']>;
};

/** The HTTP Methods stored in API Requests enum */
export enum HttpMethodsEnum {
  /** DELETE */
  Delete = 'DELETE',
  /** PATCH */
  Patch = 'PATCH',
  /** POST */
  Post = 'POST',
  /** PUT */
  Put = 'PUT'
}

/** An Import Declaration */
export type ImportDeclaration = {
  __typename?: 'ImportDeclaration';
  channel: Maybe<ChannelTypeEnum>;
  customsClearedAt: Maybe<Scalars['DateTime']['output']>;
  extra: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  importLicenses: Array<ImportLicense>;
  insertedAt: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  number: Scalars['String']['output'];
  registeredAt: Maybe<Scalars['DateTime']['output']>;
  status: Maybe<ImportDeclarationStatusEnum>;
  statusResponse: StatusResponseTypeEnum;
  statusUpdatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** The Import Declaration Status Enum */
export enum ImportDeclarationStatusEnum {
  /** DI Cancelada */
  Cancelled = 'CANCELLED',
  /** DI Desembaraçada */
  Cleared = 'CLEARED',
  /** Entrega Autorizada sem Prosseguimento do Despacho */
  DeliveryAuthorized = 'DELIVERY_AUTHORIZED',
  /** Interrompida Despacho Interrompido */
  DispatchInterrupted = 'DISPATCH_INTERRUPTED',
  /** DI com Mercadoria em Perdimento */
  InForfeiture = 'IN_FORFEITURE',
  /** DI não Informada */
  NotReported = 'NOT_REPORTED',
  /** Etapa Anterior Concluída Aguardando Distribuição */
  ReadyDistribution = 'READY_DISTRIBUTION',
  /** Distribuida em Análise Fiscal */
  UnderFiscalAnalysis = 'UNDER_FISCAL_ANALYSIS',
  /** DI Aguardando Desembaraço */
  WaitingClearance = 'WAITING_CLEARANCE',
  /** Documentos Recepcionados Aguardando Distribuição */
  WaitingDistribution = 'WAITING_DISTRIBUTION',
  /** Parametrizada Aguardando Recepção Documentos */
  WaitingDocument = 'WAITING_DOCUMENT',
  /** Parametrizada Aguardando Análise Fiscal */
  WaitingFiscalAnalysis = 'WAITING_FISCAL_ANALYSIS',
  /** Aguardando Parametrização */
  WaitingParameterization = 'WAITING_PARAMETERIZATION'
}

/** Result of a DI Siscomex sync subscription */
export type ImportDeclarationSyncSubscriptionData = {
  __typename?: 'ImportDeclarationSyncSubscriptionData';
  data: ImportDeclaration;
  shipment: ShipmentImportDeclaration;
};

/** An Import License */
export type ImportLicense = {
  __typename?: 'ImportLicense';
  approvedAt: Maybe<Scalars['DateTime']['output']>;
  extra: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  importDeclaration: Maybe<ImportDeclaration>;
  insertedAt: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  number: Scalars['String']['output'];
  registeredAt: Maybe<Scalars['DateTime']['output']>;
  status: Maybe<ImportLicenseStatusEnum>;
  statusResponse: StatusResponseTypeEnum;
  statusUpdatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** The Import License Status Enum */
export enum ImportLicenseStatusEnum {
  /** Embarque autorizado */
  AuthorizedBoarding = 'AUTHORIZED_BOARDING',
  /** Cancelada */
  Canceled = 'CANCELED',
  /** Desembaracada */
  Cleared = 'CLEARED',
  /** Deferida */
  Deferred = 'DEFERRED',
  /** Deferido vinculada a DI */
  DeferredLinkedToDi = 'DEFERRED_LINKED_TO_DI',
  /** Deferido reservado */
  DeferredReserved = 'DEFERRED_RESERVED',
  /** Vencida */
  Expired = 'EXPIRED',
  /** Para análise */
  ForAnalysis = 'FOR_ANALYSIS',
  /** Em análise */
  InAnalysis = 'IN_ANALYSIS',
  /** Em exigência */
  InDemanded = 'IN_DEMANDED',
  /** Deferido Judicialmente */
  JudiciallyDeferred = 'JUDICIALLY_DEFERRED',
  /** Deferido judicialmente vinculada a DI */
  JudiciallyDeferredLinkedToDi = 'JUDICIALLY_DEFERRED_LINKED_TO_DI',
  /** Deferido judicialmente reservado */
  JudiciallyDeferredReserved = 'JUDICIALLY_DEFERRED_RESERVED',
  /** Indeferida */
  Rejected = 'REJECTED'
}

/** Result of a LI Siscomex sync subscription */
export type ImportLicenseSyncSubscriptionData = {
  __typename?: 'ImportLicenseSyncSubscriptionData';
  data: ImportLicense;
  shipment: ShipmentImportLicense;
};

/** The Incoterm Enum */
export enum IncotermTypeEnum {
  /** Cost And Freight - Custo e Frete (porto de destino nomeado) */
  Cfr = 'CFR',
  /** Cost Insurance And Freight - Custo, Seguro e Frete (porto de destino nomeado) */
  Cif = 'CIF',
  /** Carriage And Insurance Paid To - Transporte e Seguro Pagos Até (local de destino nomeado) */
  Cip = 'CIP',
  /** Carriage Paid To - Transporte Pago Até (local de destino nomeado) */
  Cpt = 'CPT',
  /** Delivered At Place - Entregue no Local (local de destino nomeado) */
  Dap = 'DAP',
  /** Delivered Duty Paid - Entregue Com Direitos Pagos (local de destino nomeado) */
  Ddp = 'DDP',
  /** Delivered At Place Unloaded - Entregue no Local Desembarcado (Local de destino nomeado) */
  Dpu = 'DPU',
  /** Ex Works - Na Origem (local de entrega nomeado) */
  Exw = 'EXW',
  /** Free Alongside Ship - Livre ao Lado do Navio (porto de embarque nomeado) */
  Fas = 'FAS',
  /** Free Carrier - Livre no Transportador (local de entrega nomeado) */
  Fca = 'FCA',
  /** Free On Board - Livre a Bordo (porto de embarque nomeado) */
  Fob = 'FOB',
  /** Siscomex C + F (Cost Plus Freight) */
  SiscomexCostPlusFreight = 'SISCOMEX_COST_PLUS_FREIGHT',
  /** Siscomex C + I (Cost Plus Insurance) */
  SiscomexCostPlusInsurance = 'SISCOMEX_COST_PLUS_INSURANCE',
  /** Siscomex OCV */
  SiscomexOcv = 'SISCOMEX_OCV'
}

/** Available parameters to insert a Port Terminal Schedule */
export type InsertAllHawbShipmentDataParams = {
  airlineIataCode?: InputMaybe<Scalars['String']['input']>;
  arrivalPlaceDta?: InputMaybe<Scalars['String']['input']>;
  ata?: InputMaybe<Scalars['DateTime']['input']>;
  ataDta?: InputMaybe<Scalars['DateTime']['input']>;
  atd?: InputMaybe<Scalars['DateTime']['input']>;
  atdDta?: InputMaybe<Scalars['DateTime']['input']>;
  cargoPresenceInPrimaryZoneAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialId: Scalars['Int']['input'];
  departurePlaceDta?: InputMaybe<Scalars['String']['input']>;
  diNumber?: InputMaybe<Scalars['String']['input']>;
  dtaNumber?: InputMaybe<Scalars['String']['input']>;
  eta?: InputMaybe<Scalars['DateTime']['input']>;
  etd?: InputMaybe<Scalars['DateTime']['input']>;
  extra?: InputMaybe<Scalars['JSON']['input']>;
  flight?: InputMaybe<Scalars['String']['input']>;
  hawb: Scalars['String']['input'];
  issuanceDate?: InputMaybe<Scalars['DateTime']['input']>;
  loadingAirportCountryCode?: InputMaybe<Scalars['String']['input']>;
  loadingAirportIataCode: Scalars['String']['input'];
  loadingAirportName: Scalars['String']['input'];
  pwceCarrier?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stopovers?: InputMaybe<Scalars['Int']['input']>;
  unloadingAirportCountryCode?: InputMaybe<Scalars['String']['input']>;
  unloadingAirportIataCode: Scalars['String']['input'];
  unloadingAirportName: Scalars['String']['input'];
  vehiclePlateDta?: InputMaybe<Scalars['String']['input']>;
};

export type Insight = {
  __typename?: 'Insight';
  data: Maybe<Scalars['JSON']['output']>;
  dismissReason: Maybe<InsightDismissReasonEnum>;
  explanation: Maybe<Scalars['String']['output']>;
  feedbackAt: Maybe<Scalars['DateTime']['output']>;
  feedbackComment: Maybe<Scalars['String']['output']>;
  foreignTradeItemShipment: Maybe<ForeignTradeItemShipment>;
  foreignTradeItemShipmentId: Maybe<Scalars['Int']['output']>;
  hint: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  insertedAt: Maybe<Scalars['DateTime']['output']>;
  lastSeenAt: Maybe<Scalars['DateTime']['output']>;
  lpco: Maybe<Lpco>;
  lpcoId: Maybe<Scalars['Int']['output']>;
  order: Maybe<Order>;
  orderId: Maybe<Scalars['Int']['output']>;
  process: Maybe<Process>;
  processId: Maybe<Scalars['Int']['output']>;
  rule: Rule;
  ruleSlug: Scalars['String']['output'];
  status: InsightStatusEnum;
  translatedData: Maybe<Array<InsightTranslatedData>>;
  transportable: Maybe<Transportable>;
  transportableId: Maybe<Scalars['Int']['output']>;
};

/** Reason an insight was marked as not relevant */
export enum InsightDismissReasonEnum {
  /** Duplicado de outro insight */
  Duplicate = 'DUPLICATE',
  /** Falso positivo */
  FalsePositive = 'FALSE_POSITIVE',
  /** Informação incorreta ou desatualizada */
  IncorrectInfo = 'INCORRECT_INFO',
  /** Irrelevante para este processo */
  Irrelevant = 'IRRELEVANT'
}

/** Insight lifecycle status */
export enum InsightStatusEnum {
  /** Resolvido */
  Acknowledged = 'ACKNOWLEDGED',
  /** Não relevante */
  Dismissed = 'DISMISSED',
  /** Não classificado */
  Open = 'OPEN'
}

export type InsightTranslatedData = {
  __typename?: 'InsightTranslatedData';
  label: Scalars['String']['output'];
  path: Scalars['String']['output'];
  value: Maybe<Scalars['String']['output']>;
};

/** An International Freight */
export type InternationalFreight = {
  __typename?: 'InternationalFreight';
  bookingDischargeAirport: Maybe<Airport>;
  bookingDischargePort: Maybe<MaritimePort>;
  bookingEta: Maybe<Scalars['DateTime']['output']>;
  bookingEtd: Maybe<Scalars['DateTime']['output']>;
  bookingLoadingAirport: Maybe<Airport>;
  bookingLoadingPort: Maybe<MaritimePort>;
  cargoAttributes: Array<CargoAttributeEnum>;
  currency: Maybe<Currency>;
  expectedSeparationAt: Maybe<Scalars['DateTime']['output']>;
  foreignTradeShipment: ForeignTradeShipment;
  freightCostCollect: Maybe<Scalars['Decimal']['output']>;
  freightCostPrepaid: Maybe<Scalars['Decimal']['output']>;
  freightCostRoad: Maybe<Scalars['Decimal']['output']>;
  freightCostTotal: Maybe<Scalars['Decimal']['output']>;
  freightForwarder: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  pickupLocation: Maybe<Scalars['String']['output']>;
  plannedBoardingDate: Maybe<Scalars['DateTime']['output']>;
  portTerminal: Maybe<PortTerminal>;
  quotationNumber: Maybe<Scalars['String']['output']>;
  sealine: Maybe<Sealine>;
  type: Maybe<InternationalFreightTypeEnum>;
  vessel: Maybe<Vessel>;
  voyageNumber: Maybe<Scalars['String']['output']>;
};

/** The International Freight Type Enum */
export enum InternationalFreightTypeEnum {
  /** BID */
  Bid = 'BID',
  /** Collect */
  Collect = 'COLLECT',
  /** FAK */
  Fak = 'FAK',
  /** Negociação Spot */
  NegotiationSpot = 'NEGOTIATION_SPOT',
  /** Prepaid */
  Prepaid = 'PREPAID'
}

/** International Modal enum */
export enum InternationalModalEnum {
  /** Air */
  Air = 'AIR',
  /** Maritime */
  Maritime = 'MARITIME',
  /** Multimodal */
  Multimodal = 'MULTIMODAL',
  /** None */
  None = 'NONE',
  /** Road */
  Road = 'ROAD'
}

/** An international transport leg */
export type InternationalTransportLeg = {
  __typename?: 'InternationalTransportLeg';
  arrivalPlace: Maybe<Scalars['String']['output']>;
  ata: Maybe<Scalars['DateTime']['output']>;
  atd: Maybe<Scalars['DateTime']['output']>;
  departurePlace: Maybe<Scalars['String']['output']>;
  eta: Maybe<Scalars['DateTime']['output']>;
  etd: Maybe<Scalars['DateTime']['output']>;
  modalType: Maybe<ModalTypeEnum>;
  vessel: Maybe<Vessel>;
  voyage: Maybe<Scalars['String']['output']>;
};

/** An Invoice */
export type Invoice = {
  __typename?: 'Invoice';
  currency: Maybe<Currency>;
  discount: Maybe<Scalars['Decimal']['output']>;
  documents: Array<Document>;
  emittedAt: Scalars['DateTime']['output'];
  finalValue: Scalars['Decimal']['output'];
  foreignTradeShipment: Maybe<ForeignTradeShipment>;
  id: Scalars['Int']['output'];
  incoterm: IncotermTypeEnum;
  items: Array<InvoiceItem>;
  number: Scalars['String']['output'];
  totalAmount: Scalars['Decimal']['output'];
  totalGrossWeightKg: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** An Invoice Item */
export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  batchNumber: Maybe<Scalars['String']['output']>;
  batchValidityDate: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  invoice: Maybe<Invoice>;
  orderItemLineReference: Maybe<Scalars['String']['output']>;
  orderReferenceCode: Maybe<Scalars['String']['output']>;
  product: Maybe<Product>;
  productDescription: Maybe<Scalars['String']['output']>;
  productSku: Scalars['String']['output'];
  productionDate: Maybe<Scalars['DateTime']['output']>;
  quantity: Scalars['Decimal']['output'];
  shipmentQuantity: Scalars['Decimal']['output'];
  totalAmount: Maybe<Scalars['Decimal']['output']>;
  totalGrossWeightKg: Maybe<Scalars['Decimal']['output']>;
  transportables: Array<Transportable>;
  unitaryAmount: Maybe<Scalars['Decimal']['output']>;
};


/** An Invoice Item */
export type InvoiceItemTransportablesArgs = {
  containerHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The Invoice Item Order By Enum */
export enum InvoiceItemOrderByEnum {
  /** ID */
  Id = 'ID'
}

export type InvoiceItemOrderParams = {
  field?: InputMaybe<InvoiceItemOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Invoice Items */
export type InvoiceItemPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InvoiceItemOrderParams>>;
};

/** An Invoice Item per Process */
export type InvoiceItemPerProcess = {
  __typename?: 'InvoiceItemPerProcess';
  invoiceItem: InvoiceItem;
  process: Process;
};

/** A Item Costs per Reference */
export type ItemCostsPerReference = {
  __typename?: 'ItemCostsPerReference';
  costItems: Array<ItemsCostPerReference>;
  totals: Array<ItemsCostPerReferenceTotals>;
};

/** Order Reference enum */
export enum ItemReferenceEnum {
  /** Line Number */
  LineNumber = 'LINE_NUMBER',
  /** Line Reference */
  LineReference = 'LINE_REFERENCE'
}

/** A Items Cost per Reference */
export type ItemsCostPerReference = {
  __typename?: 'ItemsCostPerReference';
  itemId: Scalars['Int']['output'];
  measurementUnit: Maybe<MeasurementUnitEnum>;
  reference: Maybe<CostModelExpenseReferenceProductProratedEnum>;
  totalCosts: UnitaryCost;
  totalReference: Maybe<Scalars['Decimal']['output']>;
  unitaryCosts: UnitaryCost;
};

/** A Item Costs per Reference Totals */
export type ItemsCostPerReferenceTotals = {
  __typename?: 'ItemsCostPerReferenceTotals';
  measurementUnit: Maybe<MeasurementUnitEnum>;
  reference: Maybe<CostModelExpenseReferenceProductProratedEnum>;
  totalCosts: UnitaryCost;
  totalReference: Maybe<Scalars['Decimal']['output']>;
  unitaryCosts: UnitaryCost;
};

/** The Language Enum */
export enum LanguageEnum {
  /** English (US) */
  EnUs = 'EN_US',
  /** Spanish (ES) */
  EsEs = 'ES_ES',
  /** Portuguese (BR) */
  PtBr = 'PT_BR'
}

/** A Lead Time */
export type LeadTime = {
  __typename?: 'LeadTime';
  conclusionDate: Maybe<Scalars['DateTime']['output']>;
  deviationPercentage: Maybe<Scalars['Decimal']['output']>;
  differenceHours: Maybe<Scalars['Int']['output']>;
  errors: Array<LeadTimeStageError>;
  hasErrors: Scalars['Boolean']['output'];
  isRealized: Scalars['Boolean']['output'];
  plannedConclusionDate: Scalars['DateTime']['output'];
  plannedDurationHours: Maybe<Scalars['Int']['output']>;
  processRealizedDatesByEvent: Scalars['JSON']['output'];
  realizedOrEstimatedDurationHours: Maybe<Scalars['Int']['output']>;
  stages: Array<LeadTimeStage>;
  startDate: Maybe<Scalars['DateTime']['output']>;
  status: Maybe<LeadTimeStatusEnum>;
};

/** A Lead Time Aggregated By Planned */
export type LeadTimeAggregatedByPlanned = {
  __typename?: 'LeadTimeAggregatedByPlanned';
  countShipments: Scalars['Int']['output'];
  leadTime: LeadTime;
  plannedLeadTime: PlannedLeadTime;
};

/** A Lead Time Aggregated By Product */
export type LeadTimeAggregatedByProduct = {
  __typename?: 'LeadTimeAggregatedByProduct';
  countShipments: Scalars['Int']['output'];
  leadTime: LeadTime;
  product: Product;
};

/** A Lead Time Marker */
export type LeadTimeMarker = {
  __typename?: 'LeadTimeMarker';
  label: Scalars['String']['output'];
  path: Scalars['String']['output'];
  value: Scalars['DateTime']['output'];
};

/** A Lead Time Model */
export type LeadTimeModel = {
  __typename?: 'LeadTimeModel';
  actor: Actor;
  id: Scalars['Int']['output'];
  ignoreTime: Scalars['Boolean']['output'];
  markerPaths: Array<Scalars['String']['output']>;
  markerPathsLabels: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  operations: Array<Operation>;
  plannedLeadTimes: Array<PlannedLeadTime>;
  referenceEvent: Scalars['String']['output'];
  referenceEventLabel: Scalars['String']['output'];
  stages: Array<LeadTimeStageModel>;
};

/** The Lead Time Model Order By Enum */
export enum LeadTimeModelOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Nome */
  Name = 'NAME',
  /** Evento de referência */
  ReferenceEvent = 'REFERENCE_EVENT',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

/** Available parameters to sort Lead Time Models */
export type LeadTimeModelOrderParams = {
  field?: InputMaybe<LeadTimeModelOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Lead Time Models */
export type LeadTimeModelPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LeadTimeModelOrderParams>>;
};

/** A Lead Time Stage */
export type LeadTimeStage = {
  __typename?: 'LeadTimeStage';
  deviationPercentage: Maybe<Scalars['Decimal']['output']>;
  estimated: Maybe<CalculatedStage>;
  model: LeadTimeStageModel;
  planned: CalculatedStage;
  realized: Maybe<CalculatedStage>;
  realizedOrEstimated: Maybe<CalculatedStage>;
};

/** A Lead Time Stage Error */
export type LeadTimeStageError = {
  __typename?: 'LeadTimeStageError';
  date: Maybe<Scalars['DateTime']['output']>;
  path: Scalars['String']['output'];
  status: Maybe<LeadTimeStageErrorStatusEnum>;
};

/** The Lead Time Stage Error Status Enum */
export enum LeadTimeStageErrorStatusEnum {
  /** Error */
  Error = 'ERROR',
  /** Ok */
  Ok = 'OK'
}

/** A Lead Time Stage Model */
export type LeadTimeStageModel = {
  __typename?: 'LeadTimeStageModel';
  color: Scalars['String']['output'];
  endEvent: Scalars['String']['output'];
  endEventLabel: Scalars['String']['output'];
  endMode: ModeTypeEnum;
  id: Scalars['Int']['output'];
  leadTimeModel: LeadTimeModel;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  startEvent: Scalars['String']['output'];
  startEventLabel: Scalars['String']['output'];
  startMode: ModeTypeEnum;
};

/** A Lead Time Stage per Process */
export type LeadTimeStagePerProcess = {
  __typename?: 'LeadTimeStagePerProcess';
  leadTime: LeadTime;
  leadTimeStage: LeadTimeStage;
  process: Process;
};

/** Lead Time Stages per Processes Result */
export type LeadTimeStagesPerProcessesResult = {
  __typename?: 'LeadTimeStagesPerProcessesResult';
  data: Array<LeadTimeStagePerProcess>;
  totalCount: Scalars['Int']['output'];
};

/** Lead Time Status Enum */
export enum LeadTimeStatusEnum {
  /** Adiantado */
  Advanced = 'ADVANCED',
  /** Atrasada */
  Late = 'LATE',
  /** On Time */
  OnTime = 'ON_TIME'
}

/** The Load Type Enum */
export enum LoadTypeEnum {
  /** Granel */
  Bulk = 'BULK',
  /** Alimentos */
  Food = 'FOOD',
  /** Carga Geral */
  GeneralCargo = 'GENERAL_CARGO',
  /** Farmacêuticos */
  Pharmaceuticals = 'PHARMACEUTICALS',
  /** Armamentos */
  Weapons = 'WEAPONS'
}

/** A LPCO */
export type Lpco = {
  __typename?: 'Lpco';
  accessKey: Maybe<Scalars['String']['output']>;
  additionalInformation: Maybe<Scalars['String']['output']>;
  agency: Maybe<Scalars['String']['output']>;
  balances: Array<LpcoBalance>;
  billOfLadingNumber: Maybe<Scalars['String']['output']>;
  cargoAvailableAt: Maybe<Scalars['DateTime']['output']>;
  channel: Maybe<ChannelTypeEnum>;
  compatibilityPending: Maybe<Scalars['Boolean']['output']>;
  documents: Array<SiscomexDocument>;
  dossiers: Array<SiscomexDossier>;
  dueInClearance: Maybe<Scalars['String']['output']>;
  extensionPending: Maybe<Scalars['Boolean']['output']>;
  extra: Maybe<Scalars['JSON']['output']>;
  feePaymentStatus: Maybe<FeePaymentStatusEnum>;
  formFields: Array<LpcoFormField>;
  history: Array<LpcoHistory>;
  id: Scalars['Int']['output'];
  importLicenseNumber: Maybe<Scalars['String']['output']>;
  importerExporterDocument: Maybe<Scalars['String']['output']>;
  insertedAt: Maybe<Scalars['DateTime']['output']>;
  insights: Array<Insight>;
  lastSyncErrorMessage: Maybe<Scalars['String']['output']>;
  lastSyncType: Maybe<SiscomexSyncTypeEnum>;
  lastUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  linkedDeclarations: Array<LpcoLinkedDeclaration>;
  lpcoNcms: Array<LpcoNcm>;
  modelCode: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  operationType: Maybe<LpcoOperationTypeEnum>;
  rectificationPending: Maybe<Scalars['Boolean']['output']>;
  registeredAt: Maybe<Scalars['DateTime']['output']>;
  requirements: Array<LpcoRequirement>;
  shippedAt: Maybe<Scalars['DateTime']['output']>;
  status: Maybe<LpcoSituationEnum>;
  statusMessage: Maybe<Scalars['String']['output']>;
  statusResponse: Maybe<StatusResponseTypeEnum>;
  statusUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  transportMode: Maybe<LpcoTransportModeEnum>;
  validityEnd: Maybe<Scalars['Date']['output']>;
  validityStart: Maybe<Scalars['Date']['output']>;
};

/** A per-item balance entry parsed from the LPCO's raw payload */
export type LpcoBalance = {
  __typename?: 'LpcoBalance';
  commercialQuantity: Maybe<Scalars['Decimal']['output']>;
  financedValue: Maybe<Scalars['Decimal']['output']>;
  financedValueCurrency: Maybe<Scalars['String']['output']>;
  netWeight: Maybe<Scalars['Decimal']['output']>;
  saleConditionValue: Maybe<Scalars['Decimal']['output']>;
  saleConditionValueCurrency: Maybe<Scalars['String']['output']>;
  statisticalQuantity: Maybe<Scalars['Decimal']['output']>;
  title: Maybe<Scalars['String']['output']>;
  vmle: Maybe<Scalars['Decimal']['output']>;
  vmleCurrency: Maybe<Scalars['String']['output']>;
};

/** A field entry parsed from the LPCO's raw form/NCM fields */
export type LpcoFormField = {
  __typename?: 'LpcoFormField';
  code: Maybe<Scalars['String']['output']>;
  compositeValue: Maybe<Scalars['JSON']['output']>;
  interveners: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  measurementUnit: Maybe<Scalars['String']['output']>;
  parentAttributeCode: Maybe<Scalars['String']['output']>;
  siscomexAttribute: Maybe<SiscomexAttribute>;
  values: Array<Scalars['String']['output']>;
};

/** A LPCO History entry */
export type LpcoHistory = {
  __typename?: 'LpcoHistory';
  justification: Maybe<Scalars['String']['output']>;
  reason: Maybe<Scalars['String']['output']>;
  solicitation: Maybe<Scalars['String']['output']>;
  solicitationStatus: Maybe<Scalars['String']['output']>;
  status: Maybe<LpcoSituationEnum>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  updates: Array<LpcoHistoryUpdate>;
  user: Maybe<Scalars['String']['output']>;
};

/** A field update within a LPCO History entry */
export type LpcoHistoryUpdate = {
  __typename?: 'LpcoHistoryUpdate';
  code: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  origin: Maybe<Scalars['String']['output']>;
  originalValue: Maybe<Scalars['String']['output']>;
  updatedValue: Maybe<Scalars['String']['output']>;
};

/** A declaration linked to the LPCO */
export type LpcoLinkedDeclaration = {
  __typename?: 'LpcoLinkedDeclaration';
  acdAt: Maybe<Scalars['Date']['output']>;
  cceAt: Maybe<Scalars['Date']['output']>;
  clearanceAt: Maybe<Scalars['Date']['output']>;
  commercialQuantity: Maybe<Scalars['Decimal']['output']>;
  documentItem: Maybe<Scalars['Int']['output']>;
  documentNumber: Maybe<Scalars['String']['output']>;
  linkedAt: Maybe<Scalars['Date']['output']>;
  registeredAt: Maybe<Scalars['Date']['output']>;
  statisticalQuantity: Maybe<Scalars['Decimal']['output']>;
  unlinkedAt: Maybe<Scalars['Date']['output']>;
  vmle: Maybe<Scalars['Decimal']['output']>;
};

/** A NCM entry parsed from the LPCO's raw payload */
export type LpcoNcm = {
  __typename?: 'LpcoNcm';
  attributes: Array<LpcoFormField>;
  fields: Array<LpcoFormField>;
  itemNumber: Maybe<Scalars['Int']['output']>;
  ncm: Maybe<Ncm>;
  ncmCode: Maybe<Scalars['String']['output']>;
  productCode: Maybe<Scalars['String']['output']>;
  productRootCnpj: Maybe<Scalars['String']['output']>;
  productVersion: Maybe<Scalars['String']['output']>;
  quotaDistributionCriteria: Maybe<Scalars['String']['output']>;
  quotaDistributionInstallment: Maybe<Scalars['String']['output']>;
  quotaIdentifier: Maybe<Scalars['String']['output']>;
  siscomexProduct: Maybe<SiscomexProduct>;
};

/** The LPCO Operation Type Enum */
export enum LpcoOperationTypeEnum {
  /** Exportação */
  Export = 'EXPORT',
  /** Importação */
  Import = 'IMPORT'
}

/** The LPCO Order By Enum */
export enum LpcoOrderByEnum {
  /** Data de registro */
  RegisteredAt = 'REGISTERED_AT',
  /** Data de situação */
  StatusUpdatedAt = 'STATUS_UPDATED_AT',
  /** Data de expiração */
  ValidityEnd = 'VALIDITY_END'
}

/** Available parameters to order LPCOs */
export type LpcoOrderParams = {
  field?: InputMaybe<LpcoOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate LPCOs */
export type LpcoPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpcoOrderParams>>;
};

/** A LPCO Requirement */
export type LpcoRequirement = {
  __typename?: 'LpcoRequirement';
  date: Maybe<Scalars['DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  notice: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  response: Maybe<Scalars['String']['output']>;
  responseDate: Maybe<Scalars['DateTime']['output']>;
  status: StatusRequirementTypeEnum;
};

/** The LPCO Situation Enum */
export enum LpcoSituationEnum {
  /** Aguardando pagamento */
  AwaitingPayment = 'AWAITING_PAYMENT',
  /** Cancelado */
  Canceled = 'CANCELED',
  /** Anulado revogado */
  CanceledRevoked = 'CANCELED_REVOKED',
  /** Deferido */
  Deferred = 'DEFERRED',
  /** Conferência documental */
  DocumentReview = 'DOCUMENT_REVIEW',
  /** Rascunho */
  Draft = 'DRAFT',
  /** Vencido */
  Expired = 'EXPIRED',
  /** Para análise */
  ForAnalysis = 'FOR_ANALYSIS',
  /** Autorização de importação emitida */
  ImportAuthorizationIssued = 'IMPORT_AUTHORIZATION_ISSUED',
  /** Em inspeção */
  InInspection = 'IN_INSPECTION',
  /** Em exigência */
  InRequirement = 'IN_REQUIREMENT',
  /** Em verificação */
  InVerification = 'IN_VERIFICATION',
  /** Recurso diverso */
  OtherAppeal = 'OTHER_APPEAL',
  /** Parametrizado */
  Parameterized = 'PARAMETERIZED',
  /** Inspeção física */
  PhysicalInspection = 'PHYSICAL_INSPECTION',
  /** Indeferido */
  Rejected = 'REJECTED',
  /** Recurso de indeferimento */
  RejectionAppeal = 'REJECTION_APPEAL',
  /** Resposta exigência */
  ResponseRequirement = 'RESPONSE_REQUIREMENT',
  /** Em análise */
  UnderAnalysis = 'UNDER_ANALYSIS'
}

/** Result of a LPCO Siscomex sync subscription */
export type LpcoSyncSubscriptionData = {
  __typename?: 'LpcoSyncSubscriptionData';
  data: Lpco;
};

export type LpcoTotals = {
  __typename?: 'LpcoTotals';
  exportersCount: Scalars['Int']['output'];
  importersCount: Scalars['Int']['output'];
  modelsCount: Scalars['Int']['output'];
  registersCount: Scalars['Int']['output'];
};

/** The LPCO Transport Mode Enum */
export enum LpcoTransportModeEnum {
  /** Aéreo */
  Air = 'AIR',
  /** Terrestre */
  Ground = 'GROUND',
  /** Marítimo */
  Maritime = 'MARITIME',
  /** Postal */
  Postal = 'POSTAL',
  /** Ferroviário */
  Rail = 'RAIL',
  /** Fluvial */
  River = 'RIVER',
  /** Rodoviário */
  Road = 'ROAD'
}

/** A Maritime Port */
export type MaritimePort = {
  __typename?: 'MaritimePort';
  country: Maybe<Country>;
  id: Scalars['Int']['output'];
  isActiveMercante: Scalars['Boolean']['output'];
  latitude: Maybe<Scalars['Float']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  unlocode: Maybe<Scalars['String']['output']>;
};

/** The Maritime Port Order By Enum */
export enum MaritimePortOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Nome */
  Name = 'NAME',
  /** UN/LOCODE */
  Unlocode = 'UNLOCODE'
}

export type MaritimePortOrderParams = {
  field?: InputMaybe<MaritimePortOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** A Maritime Transport Shipment */
export type MaritimeTransportShipment = {
  __typename?: 'MaritimeTransportShipment';
  bl: Maybe<Scalars['String']['output']>;
  booking: Maybe<Scalars['String']['output']>;
  dischargePort: Maybe<MaritimePort>;
  foreignTradeShipment: ForeignTradeShipment;
  hbl: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  loadingPort: Maybe<MaritimePort>;
  sealine: Maybe<Sealine>;
  sealineOrigin: Maybe<SealineOriginEnum>;
  trackingDischargePort: Maybe<Scalars['String']['output']>;
  trackingKey: Maybe<TrackingKeyEnum>;
  trackingKeyInsertedAt: Maybe<Scalars['DateTime']['output']>;
  trackingLoadingPort: Maybe<Scalars['String']['output']>;
  trackingNumber: Maybe<Scalars['String']['output']>;
  type: Maybe<MaritimeTransportTypeEnum>;
  validKeys: Array<TrackingKeyEnum>;
  vessel: Maybe<Vessel>;
  voyageNumber: Maybe<Scalars['String']['output']>;
};

/** The Maritime Transport Enum */
export enum MaritimeTransportTypeEnum {
  /** BREAKBULK */
  Breakbulk = 'BREAKBULK',
  /** BULK_CARGO */
  BulkCargo = 'BULK_CARGO',
  /** FCL */
  Fcl = 'FCL',
  /** LCL */
  Lcl = 'LCL'
}

/** A Matching Rule from Dynamic Table Data */
export type MatchingRule = {
  __typename?: 'MatchingRule';
  operator: MatchingRuleOperatorEnum;
  path: Scalars['String']['output'];
  tableDefinitionField: Scalars['String']['output'];
};

/** The Matching Rule Operator Enum */
export enum MatchingRuleOperatorEnum {
  /** Igual */
  Equals = 'EQUALS'
}

/** A Matching Rule Params from Dynamic Table Data */
export type MatchingRuleParams = {
  operator: MatchingRuleOperatorEnum;
  path: Scalars['String']['input'];
  tableDefinitionField: Scalars['String']['input'];
};

/** A Measurement */
export type Measurement = {
  __typename?: 'Measurement';
  countOccupiedPackageBundlesInternational: Maybe<Scalars['Int']['output']>;
  countOccupiedPackageBundlesNational: Maybe<Scalars['Int']['output']>;
  countPackages: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  measuredAt: Scalars['DateTime']['output'];
  overview: Maybe<Overview>;
  packages: Array<Package>;
  warehouse: Warehouse;
};


/** A Measurement */
export type MeasurementCountPackagesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


/** A Measurement */
export type MeasurementPackagesArgs = {
  pagination?: InputMaybe<PackagePaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** The Measurement Order By Enum */
export enum MeasurementOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Data da medição */
  MeasuredAt = 'MEASURED_AT'
}

export type MeasurementOrderParams = {
  field?: InputMaybe<MeasurementOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Measurements */
export type MeasurementPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeasurementOrderParams>>;
};

/** The Measurement Unit Enum */
export enum MeasurementUnitEnum {
  /** Ampolas */
  Ampoules = 'AMPOULES',
  /** Sacolas */
  Bags = 'BAGS',
  /** Fardos */
  Bales = 'BALES',
  /** Vasilhames */
  Barrels = 'BARRELS',
  /** Barras */
  Bars = 'BARS',
  /** Blocos */
  Blocks = 'BLOCKS',
  /** Garrafas */
  Bottles = 'BOTTLES',
  /** Caixas */
  Boxes = 'BOXES',
  /** Baldes */
  Buckets = 'BUCKETS',
  /** Latas */
  Cans = 'CANS',
  /** Cápsulas */
  Capsules = 'CAPSULES',
  /** Quilates */
  Carats = 'CARATS',
  /** Cartelas */
  Cards = 'CARDS',
  /** Centímetros */
  Centimeters = 'CENTIMETERS',
  /** Bobinas */
  Coils = 'COILS',
  /** Containers */
  Containers = 'CONTAINERS',
  /** Metros Cúbicos */
  CubicMeters = 'CUBIC_METERS',
  /** Displays */
  Displays = 'DISPLAYS',
  /** Dúzias */
  Dozens = 'DOZENS',
  /** Tambores */
  Drums = 'DRUMS',
  /** Frascos */
  Flasks = 'FLASKS',
  /** Galões */
  Gallons = 'GALLONS',
  /** Vidros */
  Glasses = 'GLASSES',
  /** Gramas */
  Grams = 'GRAMS',
  /** Conjuntos */
  Groups = 'GROUPS',
  /** Centos */
  Hundreds = 'HUNDREDS',
  /** Isotanque */
  Isotank = 'ISOTANK',
  /** Quilogramas */
  Kilograms = 'KILOGRAMS',
  /** Kits */
  Kits = 'KITS',
  /** Litros */
  Liters = 'LITERS',
  /** Megawatt Hora */
  MegawattHour = 'MEGAWATT_HOUR',
  /** Metros */
  Meters = 'METERS',
  /** Milímetros */
  Milliliters = 'MILLILITERS',
  /** Onças */
  Ounces = 'OUNCES',
  /** Pacotes */
  Packages = 'PACKAGES',
  /** Embalagens */
  Packaging = 'PACKAGING',
  /** Pares */
  Pairs = 'PAIRS',
  /** Paletes */
  Pallets = 'PALLETS',
  /** Folhas */
  Papers = 'PAPERS',
  /** Peças */
  Pieces = 'PIECES',
  /** Canos */
  Pipes = 'PIPES',
  /** Potes */
  Pots = 'POTS',
  /** Libras */
  Pounds = 'POUNDS',
  /** Resmas */
  Ream = 'REAM',
  /** Rolos */
  Rolls = 'ROLLS',
  /** Sacos */
  Sacks = 'SACKS',
  /** Jogos */
  Sets = 'SETS',
  /** Centímetros Quadrados */
  SquareCentimeters = 'SQUARE_CENTIMETERS',
  /** Metros Quadrado */
  SquareMeters = 'SQUARE_METERS',
  /** Tanques */
  Tanks = 'TANKS',
  /** Milheiros */
  Thousand = 'THOUSAND',
  /** Toneladas */
  Tons = 'TONS',
  /** Bandejas */
  Trays = 'TRAYS',
  /** Tubos */
  Tubes = 'TUBES',
  /** Unidades */
  Units = 'UNITS'
}

/** Available parameters to upsert an Order in the Midea operations */
export type MideaOrderParams = {
  /** Defaults to NORMAL */
  alertLevel?: InputMaybe<AlertLevelEnum>;
  externalReferenceCode?: InputMaybe<Scalars['String']['input']>;
  extraFields?: InputMaybe<Scalars['JSON']['input']>;
  handler?: InputMaybe<NestedUpsertHandlersByRoleParams>;
  handlers?: InputMaybe<Array<NestedMideaCreateHandlerParams>>;
  leadTimeDatetimeReference?: InputMaybe<Scalars['DateTime']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  purchaseOrder?: InputMaybe<NestedMideaCreatePurchaseOrderParams>;
  roadTransportOrder?: InputMaybe<NestedCreateRoadTransportOrderParams>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  salesOrder?: InputMaybe<NestedCreateSalesOrderParams>;
  subsidiaryId?: InputMaybe<Scalars['Int']['input']>;
};

/** Available parameters to upsert a Process in the Midea operations */
export type MideaProcessParams = {
  alertLevel?: InputMaybe<AlertLevelEnum>;
  auditItems?: InputMaybe<Array<NestedUpdateProcessAuditItem>>;
  brazilianInvoices?: InputMaybe<Array<Scalars['String']['input']>>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  documents?: InputMaybe<Array<UpdateDocumentParams>>;
  extraFields?: InputMaybe<Scalars['JSON']['input']>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  foreignTradeShipment?: InputMaybe<NestedUpdateForeignTradeShipmentParams>;
  handler?: InputMaybe<NestedUpsertHandlersByRoleParams>;
  handlers?: InputMaybe<Array<NestedMideaCreateHandlerParams>>;
  leadTimeDatetimeReference?: InputMaybe<Scalars['DateTime']['input']>;
  orderReferenceCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  plannedLeadTimeId?: InputMaybe<Scalars['Int']['input']>;
};

/** The response from a Midea Operation */
export type MideaResponse = {
  __typename?: 'MideaResponse';
  action: ActionType;
  id: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  type: EntityType;
};

/** The Modal Type Enum */
export enum ModalTypeEnum {
  /** Transporte Fluvial */
  InlandWaterway = 'INLAND_WATERWAY',
  /** Transporte Marítimo */
  Maritime = 'MARITIME',
  /** Transporte Ferroviário */
  Railway = 'RAILWAY',
  /** Transporte Rodoviário */
  Road = 'ROAD'
}

/** The Mode Type Enum */
export enum ModeTypeEnum {
  /** Modo primeiro registro */
  FirstRecord = 'FIRST_RECORD',
  /** Modo último registro */
  LastRecord = 'LAST_RECORD'
}

/** A National Road Transport */
export type NationalRoadTransport = {
  __typename?: 'NationalRoadTransport';
  collectionScheduledAt: Maybe<Scalars['DateTime']['output']>;
  deliveryPlannedAt: Maybe<Scalars['DateTime']['output']>;
  foreignTradeShipment: ForeignTradeShipment;
  id: Scalars['Int']['output'];
  isTransportTypeDta: Scalars['Boolean']['output'];
  legSlug: Scalars['String']['output'];
  loadType: Maybe<LoadTypeEnum>;
  nationalRoadCarrier: Maybe<Handler>;
  quantityPallets: Maybe<Scalars['Int']['output']>;
  releasedForTransportAt: Maybe<Scalars['DateTime']['output']>;
  roadTransportType: Maybe<RoadTransportTypeEnum>;
  route: Maybe<Route>;
  transportCompletedAt: Maybe<Scalars['DateTime']['output']>;
  transportFeatures: Array<TransportFeatureEnum>;
  trips: Array<RoadTransportTrip>;
};

/** A NCM */
export type Ncm = {
  __typename?: 'Ncm';
  description: Maybe<Scalars['String']['output']>;
  extra: Maybe<Scalars['JSON']['output']>;
  ncm: Scalars['String']['output'];
  ncmSiscomexAttributes: Maybe<Array<NcmSiscomexAttribute>>;
};

/** A Ncm Siscomex Attribute */
export type NcmSiscomexAttribute = {
  __typename?: 'NcmSiscomexAttribute';
  isMultivalued: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  operationType: NcmSiscomexOperationTypeEnum;
  siscomexAttribute: Maybe<SiscomexAttribute>;
};

/** The Ncm Siscomex Operation Type Enum */
export enum NcmSiscomexOperationTypeEnum {
  /** Exportação */
  Export = 'EXPORT',
  /** Importação */
  Import = 'IMPORT'
}

/** Available nested parameters to create an Air Transport Shipment */
export type NestedCreateAirTransportShipmentParams = {
  airlineId?: InputMaybe<Scalars['Int']['input']>;
  awb?: InputMaybe<Scalars['String']['input']>;
  destinationAirportId?: InputMaybe<Scalars['Int']['input']>;
  hawb?: InputMaybe<Scalars['String']['input']>;
  originAirportId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<AirTransportTypeEnum>;
};

/** Available nested parameters to create an Audit Item */
export type NestedCreateAuditItemParams = {
  name: Scalars['String']['input'];
  showObservationsWhen: AuditItemShowObservationEnum;
};

/** Available nested parameters to create a cargo */
export type NestedCreateCargoParams = {
  cubicWeight?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Scalars['String']['input']>;
  measurementUnit: MeasurementUnitEnum;
  quantity: Scalars['String']['input'];
  volumeCubicMeters?: InputMaybe<Scalars['String']['input']>;
  weightKg?: InputMaybe<Scalars['String']['input']>;
};

/** Available nested parameters to create a Container */
export type NestedCreateContainerParams = {
  code?: InputMaybe<Scalars['String']['input']>;
  cubicMeters?: InputMaybe<Scalars['Decimal']['input']>;
  debitNotes?: InputMaybe<Array<NestedCreateDebitNoteParams>>;
  demurrageFreeTimeStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  dispatchNumber?: InputMaybe<Scalars['String']['input']>;
  emptyPickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  emptyReceivedAtFactory?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedStuffingAt?: InputMaybe<Scalars['DateTime']['input']>;
  grossWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  htTreatment?: InputMaybe<Scalars['Boolean']['input']>;
  htTreatmentAt?: InputMaybe<Scalars['DateTime']['input']>;
  internalReferenceCode?: InputMaybe<Scalars['String']['input']>;
  invoiceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceGrossWeight?: InputMaybe<Scalars['Decimal']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceValue?: InputMaybe<Scalars['Decimal']['input']>;
  isStackable?: InputMaybe<Scalars['Boolean']['input']>;
  loadType?: InputMaybe<LoadTypeEnum>;
  loadingScheduleAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  ncmCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  observations?: InputMaybe<Scalars['String']['input']>;
  oic?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  palletQuantity?: InputMaybe<Scalars['Int']['input']>;
  portDepositAt?: InputMaybe<Scalars['DateTime']['input']>;
  portScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  preStacking?: InputMaybe<Scalars['Boolean']['input']>;
  preStackingReason?: InputMaybe<PreStackingReasonEnum>;
  preStackingWarehouse?: InputMaybe<PreStackingWarehouseEnum>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  releasedForTripAt?: InputMaybe<Scalars['DateTime']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  scaleExitAt?: InputMaybe<Scalars['DateTime']['input']>;
  sealCode?: InputMaybe<Scalars['String']['input']>;
  secondarySealCode?: InputMaybe<Scalars['String']['input']>;
  separationCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sizeFootType?: InputMaybe<ContainerSizeFootTypeEnum>;
  stackingScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  stackingStartedAt?: InputMaybe<Scalars['DateTime']['input']>;
  tareWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  trackingManual?: InputMaybe<Scalars['Boolean']['input']>;
  transportDocument?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ContainerTypeEnum>;
  washingChargeReceivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  washingDamageResult?: InputMaybe<ContainerWashingDamageResultEnum>;
  washingDamageStatus?: InputMaybe<ContainerWashingConclusionStatusEnum>;
  washingEmptyChecklist?: InputMaybe<Scalars['Boolean']['input']>;
  washingInspection?: InputMaybe<Scalars['String']['input']>;
  washingPaymentAt?: InputMaybe<Scalars['DateTime']['input']>;
  washingPaymentStatus?: InputMaybe<ContainerWashingPaymentStatusEnum>;
  washingServiceType?: InputMaybe<ContainerWashingServiceTypeEnum>;
  washingTermDescription?: InputMaybe<ContainerWashingTermDescriptionEnum>;
  washingTermStatus?: InputMaybe<ContainerWashingConclusionStatusEnum>;
  washingValue?: InputMaybe<Scalars['Decimal']['input']>;
};

/** Available nested parameters to create a Debit Note */
export type NestedCreateDebitNoteParams = {
  coverageEndAt: Scalars['DateTime']['input'];
  coverageStartAt: Scalars['DateTime']['input'];
  number: Scalars['String']['input'];
  payedAt?: InputMaybe<Scalars['DateTime']['input']>;
  totalValueUsd: Scalars['Decimal']['input'];
  usdToBrlRate: Scalars['Decimal']['input'];
};

/** Available nested parameters to create a Demurrage */
export type NestedCreateDemurrageParams = {
  dailyRateUsd?: InputMaybe<Scalars['Decimal']['input']>;
  freeTime?: InputMaybe<Scalars['Int']['input']>;
};

/** Available nested parameters to create a fence */
export type NestedCreateFenceParams = {
  fencePoints?: InputMaybe<Array<NestedCreateFencePointParams>>;
  name: Scalars['String']['input'];
};

/** Available nested parameters to create a fence point */
export type NestedCreateFencePointParams = {
  latitude: Scalars['String']['input'];
  longitude: Scalars['String']['input'];
  position: Scalars['Int']['input'];
};

/** Available parameters to create a Foreign Trade Item Shipment */
export type NestedCreateForeignTradeItemShipmentParams = {
  brazilianInvoiceUnitValue?: InputMaybe<Scalars['Decimal']['input']>;
  cubageCubicMeters?: InputMaybe<Scalars['Decimal']['input']>;
  grossWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  lineReference?: InputMaybe<Scalars['String']['input']>;
  netWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  orderReferenceCode?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderItemId?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  salesOrderItemId?: InputMaybe<Scalars['Int']['input']>;
  transportableIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  unitValue?: InputMaybe<Scalars['Decimal']['input']>;
};

/** Available nested parameters to create a Foreign Trade Road Transport Shipment */
export type NestedCreateForeignTradeRoadTransportShipmentParams = {
  crt?: InputMaybe<Scalars['String']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ForeignTradeRoadTransportTypeEnum>;
};

/** Available parameters to create a Foreign Trade Shipment */
export type NestedCreateForeignTradeShipmentParams = {
  airTransportShipment?: InputMaybe<NestedCreateAirTransportShipmentParams>;
  /** Actual time of arrival */
  ata?: InputMaybe<Scalars['DateTime']['input']>;
  /** Actual time of departure */
  atd?: InputMaybe<Scalars['DateTime']['input']>;
  automaticTrackingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ceMercanteNumber?: InputMaybe<Scalars['String']['input']>;
  cubageCubicMeters?: InputMaybe<Scalars['Decimal']['input']>;
  deliveredAt?: InputMaybe<Scalars['DateTime']['input']>;
  demurrage?: InputMaybe<NestedCreateDemurrageParams>;
  departedFromWarehouseAt?: InputMaybe<Scalars['DateTime']['input']>;
  emptyReturnDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Estimated time of arrival */
  eta?: InputMaybe<Scalars['DateTime']['input']>;
  /** Estimated time of departure */
  etd?: InputMaybe<Scalars['DateTime']['input']>;
  internationalFreight?: InputMaybe<NestedInternationalFreightParams>;
  invoices?: InputMaybe<Array<NestedCreateInvoiceParams>>;
  items?: InputMaybe<Array<NestedCreateForeignTradeItemShipmentParams>>;
  maritimeTransportShipment?: InputMaybe<NestedCreateMaritimeTransportShipmentParams>;
  nationalRoadTransports?: InputMaybe<Array<NestedCreateNationalRoadTransportParams>>;
  pallets?: InputMaybe<Array<NestedCreateShipmentPalletParams>>;
  parcelShipments?: InputMaybe<Array<NestedCreateParcelShipmentParams>>;
  receivedInWarehouseAt?: InputMaybe<Scalars['DateTime']['input']>;
  roadTransportShipment?: InputMaybe<NestedCreateForeignTradeRoadTransportShipmentParams>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  shipmentDuimps?: InputMaybe<Array<NestedShipmentDuimpParams>>;
  shipmentExportDeclarations?: InputMaybe<Array<NestedShipmentExportDeclarationParams>>;
  shipmentImportDeclarations?: InputMaybe<Array<NestedShipmentImportDeclarationParams>>;
  shipmentImportLicenses?: InputMaybe<Array<NestedShipmentImportLicenseParams>>;
  shipmentLpcos?: InputMaybe<Array<NestedShipmentLpcoParams>>;
  totalGrossWeight?: InputMaybe<Scalars['Decimal']['input']>;
  totalNetWeight?: InputMaybe<Scalars['Decimal']['input']>;
  transportables?: InputMaybe<Array<NestedCreateTransportableParams>>;
  vesselSchedule?: InputMaybe<NestedCreateVesselScheduleParams>;
  warehouseFreeTimeDays?: InputMaybe<Scalars['Int']['input']>;
};

/** Available nested parameters to create a Handler */
export type NestedCreateHandlerParams = {
  actor?: InputMaybe<CreatePartnershipParams>;
  actorId?: InputMaybe<Scalars['Int']['input']>;
  businessUnit?: InputMaybe<Scalars['String']['input']>;
  operationHandlerId: Scalars['Int']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  secondaryReference?: InputMaybe<Scalars['String']['input']>;
};

/** Available nested parameters to create an Invoice Item */
export type NestedCreateInvoiceItemParams = {
  batchNumber?: InputMaybe<Scalars['String']['input']>;
  batchValidityDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderItemLineReference?: InputMaybe<Scalars['String']['input']>;
  orderReferenceCode?: InputMaybe<Scalars['String']['input']>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  productSku: Scalars['String']['input'];
  productionDate?: InputMaybe<Scalars['DateTime']['input']>;
  quantity: Scalars['Decimal']['input'];
  totalGrossWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  transportableIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  unitaryAmount?: InputMaybe<Scalars['Decimal']['input']>;
};

/** Available nested parameters to create an Invoice */
export type NestedCreateInvoiceParams = {
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  emittedAt: Scalars['DateTime']['input'];
  incoterm: IncotermTypeEnum;
  items?: InputMaybe<Array<NestedCreateInvoiceItemParams>>;
  number: Scalars['String']['input'];
};

/** Available nested parameters to create a Lead Time Stage Model */
export type NestedCreateLeadTimeStageModelParams = {
  color: Scalars['String']['input'];
  endEvent: Scalars['String']['input'];
  /** Default to first_record */
  endMode?: InputMaybe<ModeTypeEnum>;
  name: Scalars['String']['input'];
  startEvent: Scalars['String']['input'];
  /** Default to first_record */
  startMode?: InputMaybe<ModeTypeEnum>;
};

/** Available nested parameters to create a Maritime Transport Shipment */
export type NestedCreateMaritimeTransportShipmentParams = {
  bl?: InputMaybe<Scalars['String']['input']>;
  booking?: InputMaybe<Scalars['String']['input']>;
  dischargePortId?: InputMaybe<Scalars['Int']['input']>;
  hbl?: InputMaybe<Scalars['String']['input']>;
  loadingPortId?: InputMaybe<Scalars['Int']['input']>;
  sealineId?: InputMaybe<Scalars['Int']['input']>;
  trackingDischargePort?: InputMaybe<Scalars['String']['input']>;
  trackingLoadingPort?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MaritimeTransportTypeEnum>;
  vesselId?: InputMaybe<Scalars['Int']['input']>;
  voyageNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Nested params to create a National Road Carrier Handler. operation_handler_id is optional (inferred from the role). */
export type NestedCreateNationalRoadCarrierParams = {
  actor?: InputMaybe<UpsertPartnershipByHandlerParams>;
  actorId?: InputMaybe<Scalars['Int']['input']>;
  businessUnit?: InputMaybe<Scalars['String']['input']>;
  operationHandlerId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  secondaryReference?: InputMaybe<Scalars['String']['input']>;
};

/** Available nested parameters to create a National Road Transport */
export type NestedCreateNationalRoadTransportParams = {
  collectionScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryPlannedAt?: InputMaybe<Scalars['DateTime']['input']>;
  isTransportTypeDta?: InputMaybe<Scalars['Boolean']['input']>;
  legSlug: Scalars['String']['input'];
  loadType?: InputMaybe<LoadTypeEnum>;
  nationalRoadCarrier?: InputMaybe<NestedCreateNationalRoadCarrierParams>;
  quantityPallets?: InputMaybe<Scalars['Int']['input']>;
  releasedForTransportAt?: InputMaybe<Scalars['DateTime']['input']>;
  roadTransportType?: InputMaybe<RoadTransportTypeEnum>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  transportCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  transportFeatures?: InputMaybe<Array<TransportFeatureEnum>>;
  trips?: InputMaybe<Array<NestedCreateRoadTransportTripParams>>;
};

/** Available nested parameters to create a Parcel Shipment */
export type NestedCreateParcelShipmentParams = {
  ata?: InputMaybe<Scalars['DateTime']['input']>;
  atd?: InputMaybe<Scalars['DateTime']['input']>;
  courierId?: InputMaybe<Scalars['Int']['input']>;
  destinationAddress?: InputMaybe<Scalars['String']['input']>;
  destinationCountryCode?: InputMaybe<Scalars['String']['input']>;
  eta?: InputMaybe<Scalars['DateTime']['input']>;
  etd?: InputMaybe<Scalars['DateTime']['input']>;
  originAddress?: InputMaybe<Scalars['String']['input']>;
  originCountryCode?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  trackingNumber: Scalars['String']['input'];
};

/** Available nested parameters to create a Planned Lead Time Stage */
export type NestedCreatePlannedLeadTimeStageParams = {
  days?: InputMaybe<Scalars['Int']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  leadTimeStageModelId: Scalars['Int']['input'];
};

/** Available parameters to create a Product Internal Code */
export type NestedCreateProductInternalCodeParams = {
  code: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

/** Available nested parameters to create a Purchase Order Item */
export type NestedCreatePurchaseOrderItemParams = {
  adjustedCustomsRegisterLeadTime?: InputMaybe<Scalars['Int']['input']>;
  adjustedCustomsReleaseLeadTime?: InputMaybe<Scalars['Int']['input']>;
  adjustedFactoryDeliveryLeadTime?: InputMaybe<Scalars['Int']['input']>;
  adjustedShipmentBoardingLeadTime?: InputMaybe<Scalars['Int']['input']>;
  adjustedShipmentTransportLeadTime?: InputMaybe<Scalars['Int']['input']>;
  adjustedSupplierReadyLeadTimeDays?: InputMaybe<Scalars['Int']['input']>;
  assessmentSotd?: InputMaybe<Scalars['String']['input']>;
  cofinsTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  concessionAct?: InputMaybe<Scalars['String']['input']>;
  cubageCubicMeters?: InputMaybe<Scalars['Decimal']['input']>;
  customsEstimatedRegisterAt?: InputMaybe<Scalars['DateTime']['input']>;
  customsEstimatedReleaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  customsRegisterLeadTime?: InputMaybe<Scalars['Int']['input']>;
  customsReleaseLeadTime?: InputMaybe<Scalars['Int']['input']>;
  deliveryNote?: InputMaybe<Scalars['String']['input']>;
  deliveryNoteIssuedAt?: InputMaybe<Scalars['Date']['input']>;
  dispatchingCountryCode?: InputMaybe<Scalars['String']['input']>;
  division?: InputMaybe<Scalars['String']['input']>;
  factoryDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  factoryDeliveryLeadTime?: InputMaybe<Scalars['Int']['input']>;
  factoryEstimatedDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  factoryPlannedDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  grossWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  icmsTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  iiTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  importTypeSap?: InputMaybe<Scalars['String']['input']>;
  invoiceIssuedAt?: InputMaybe<Scalars['Date']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceType?: InputMaybe<Scalars['String']['input']>;
  invoiceValue?: InputMaybe<Scalars['Decimal']['input']>;
  ipiTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  itemForeignOperators?: InputMaybe<Array<Scalars['Int']['input']>>;
  itemStatus?: InputMaybe<Scalars['String']['input']>;
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  lineReference: Scalars['String']['input'];
  manufacturingCountryCode?: InputMaybe<Scalars['String']['input']>;
  measurementUnitSap?: InputMaybe<Scalars['String']['input']>;
  netWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderAdjustedModalType?: InputMaybe<Scalars['String']['input']>;
  orderCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  orderItemReference?: InputMaybe<Scalars['String']['input']>;
  orderModalTypeSap?: InputMaybe<Scalars['String']['input']>;
  orderRequestNumber?: InputMaybe<Scalars['String']['input']>;
  orderRequestedAt?: InputMaybe<Scalars['String']['input']>;
  orderUnitValue?: InputMaybe<Scalars['Decimal']['input']>;
  orderValue?: InputMaybe<Scalars['Decimal']['input']>;
  palletGrouping?: InputMaybe<Scalars['Decimal']['input']>;
  palletQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  pisTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  planningRequestShippingAt?: InputMaybe<Scalars['DateTime']['input']>;
  planningShippingAt?: InputMaybe<Scalars['DateTime']['input']>;
  productId: Scalars['Int']['input'];
  purchaseCountryCode?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  quotationOpeningDate?: InputMaybe<Scalars['Date']['input']>;
  sapByFactor?: InputMaybe<Scalars['Decimal']['input']>;
  shipmentBoardingLeadTime?: InputMaybe<Scalars['Int']['input']>;
  shipmentContainersQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  shipmentEquipmentType?: InputMaybe<Scalars['String']['input']>;
  shipmentEstimatedArrivalAt?: InputMaybe<Scalars['DateTime']['input']>;
  shipmentEstimatedBoardingAt?: InputMaybe<Scalars['DateTime']['input']>;
  shipmentPlannedArrivalAt?: InputMaybe<Scalars['DateTime']['input']>;
  shipmentPlannedBoardingAt?: InputMaybe<Scalars['DateTime']['input']>;
  shipmentTransportLeadTime?: InputMaybe<Scalars['Int']['input']>;
  shippingDetailsDeliveryDate?: InputMaybe<Scalars['Date']['input']>;
  specialTreatments?: InputMaybe<SpecialTreatmentsTypeEnum>;
  supplierCalculatedReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierConfirmationAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierEstimatedReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierPlannedReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierReadyLeadTimeDays?: InputMaybe<Scalars['Int']['input']>;
  supplierSentAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Available nested parameters to create a Purchase Order Item by Rest API */
export type NestedCreatePurchaseOrderItemParamsByRestApi = {
  adjustedCustomsRegisterLeadTime?: InputMaybe<Scalars['Int']['input']>;
  adjustedCustomsReleaseLeadTime?: InputMaybe<Scalars['Int']['input']>;
  adjustedFactoryDeliveryLeadTime?: InputMaybe<Scalars['Int']['input']>;
  adjustedShipmentBoardingLeadTime?: InputMaybe<Scalars['Int']['input']>;
  adjustedShipmentTransportLeadTime?: InputMaybe<Scalars['Int']['input']>;
  adjustedSupplierReadyLeadTimeDays?: InputMaybe<Scalars['Int']['input']>;
  assessmentSotd?: InputMaybe<Scalars['String']['input']>;
  cofinsTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  concessionAct?: InputMaybe<Scalars['String']['input']>;
  cubageCubicMeters?: InputMaybe<Scalars['Decimal']['input']>;
  customsEstimatedRegisterAt?: InputMaybe<Scalars['DateTime']['input']>;
  customsEstimatedReleaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  customsRegisterLeadTime?: InputMaybe<Scalars['Int']['input']>;
  customsReleaseLeadTime?: InputMaybe<Scalars['Int']['input']>;
  deliveryNote?: InputMaybe<Scalars['String']['input']>;
  deliveryNoteIssuedAt?: InputMaybe<Scalars['Date']['input']>;
  dispatchingCountryCode?: InputMaybe<Scalars['String']['input']>;
  division?: InputMaybe<Scalars['String']['input']>;
  factoryDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  factoryDeliveryLeadTime?: InputMaybe<Scalars['Int']['input']>;
  factoryEstimatedDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  factoryPlannedDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  grossWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  icmsTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  iiTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  importTypeSap?: InputMaybe<Scalars['String']['input']>;
  invoiceIssuedAt?: InputMaybe<Scalars['Date']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceType?: InputMaybe<Scalars['String']['input']>;
  invoiceValue?: InputMaybe<Scalars['Decimal']['input']>;
  ipiTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  itemForeignOperators?: InputMaybe<Array<Scalars['Int']['input']>>;
  itemStatus?: InputMaybe<Scalars['String']['input']>;
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  lineReference: Scalars['String']['input'];
  manufacturingCountryCode?: InputMaybe<Scalars['String']['input']>;
  measurementUnitSap?: InputMaybe<Scalars['String']['input']>;
  netWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderAdjustedModalType?: InputMaybe<Scalars['String']['input']>;
  orderCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  orderItemReference?: InputMaybe<Scalars['String']['input']>;
  orderModalTypeSap?: InputMaybe<Scalars['String']['input']>;
  orderRequestNumber?: InputMaybe<Scalars['String']['input']>;
  orderRequestedAt?: InputMaybe<Scalars['String']['input']>;
  orderUnitValue?: InputMaybe<Scalars['Decimal']['input']>;
  orderValue?: InputMaybe<Scalars['Decimal']['input']>;
  palletGrouping?: InputMaybe<Scalars['Decimal']['input']>;
  palletQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  pisTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  planningRequestShippingAt?: InputMaybe<Scalars['DateTime']['input']>;
  planningShippingAt?: InputMaybe<Scalars['DateTime']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  purchaseCountryCode?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  quotationOpeningDate?: InputMaybe<Scalars['Date']['input']>;
  sapByFactor?: InputMaybe<Scalars['Decimal']['input']>;
  shipmentBoardingLeadTime?: InputMaybe<Scalars['Int']['input']>;
  shipmentContainersQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  shipmentEquipmentType?: InputMaybe<Scalars['String']['input']>;
  shipmentEstimatedArrivalAt?: InputMaybe<Scalars['DateTime']['input']>;
  shipmentEstimatedBoardingAt?: InputMaybe<Scalars['DateTime']['input']>;
  shipmentPlannedArrivalAt?: InputMaybe<Scalars['DateTime']['input']>;
  shipmentPlannedBoardingAt?: InputMaybe<Scalars['DateTime']['input']>;
  shipmentTransportLeadTime?: InputMaybe<Scalars['Int']['input']>;
  shippingDetailsDeliveryDate?: InputMaybe<Scalars['Date']['input']>;
  specialTreatments?: InputMaybe<SpecialTreatmentsTypeEnum>;
  supplierCalculatedReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierConfirmationAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierEstimatedReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierPlannedReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierReadyLeadTimeDays?: InputMaybe<Scalars['Int']['input']>;
  supplierSentAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Available nested parameters to create a Purchase Order */
export type NestedCreatePurchaseOrderParams = {
  items?: InputMaybe<Array<NestedCreatePurchaseOrderItemParams>>;
  necessityDate?: InputMaybe<Scalars['DateTime']['input']>;
  supplierExpectedReadinessAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierOrderAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierOrderSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierReadinessAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<OrderTransactionTypeEnum>;
};

/** Available nested parameters to create a Purchase Order by Rest API */
export type NestedCreatePurchaseOrderParamsByRestApi = {
  items?: InputMaybe<Array<NestedCreatePurchaseOrderItemParamsByRestApi>>;
  necessityDate?: InputMaybe<Scalars['DateTime']['input']>;
  supplierExpectedReadinessAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierOrderAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierOrderSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierReadinessAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<OrderTransactionTypeEnum>;
};

/** Available nested parameters to create a Road Transport Order */
export type NestedCreateRoadTransportOrderParams = {
  bl?: InputMaybe<Scalars['String']['input']>;
  booking?: InputMaybe<Scalars['String']['input']>;
  cargoDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  destinationCountry?: InputMaybe<Scalars['String']['input']>;
  diOrDta?: InputMaybe<Scalars['String']['input']>;
  draftDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  importer?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['String']['input']>;
  releasedForTransport?: InputMaybe<Scalars['DateTime']['input']>;
  sealineId?: InputMaybe<Scalars['Int']['input']>;
  storageExpiration?: InputMaybe<Scalars['DateTime']['input']>;
  tradeType?: InputMaybe<OriginTypeEnum>;
  transportSpecifications?: InputMaybe<Array<TransportSpecificationEnum>>;
  transportables?: InputMaybe<Array<NestedCreateTransportableParams>>;
  type: RoadTransportOrderTypeEnum;
  vessel?: InputMaybe<Scalars['String']['input']>;
  voyage?: InputMaybe<Scalars['String']['input']>;
};

/** Available nested parameters to create a Road Transport Trip */
export type NestedCreateRoadTransportTripParams = {
  driverId?: InputMaybe<Scalars['Int']['input']>;
  driverName?: InputMaybe<Scalars['String']['input']>;
  phases?: InputMaybe<Array<NestedCreateRoadTransportTripPhaseParams>>;
  position: Scalars['Int']['input'];
  trailerId?: InputMaybe<Scalars['Int']['input']>;
  trailerPlate?: InputMaybe<Scalars['String']['input']>;
  transportableIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  vehicleId?: InputMaybe<Scalars['Int']['input']>;
  vehiclePlate?: InputMaybe<Scalars['String']['input']>;
};

/** Available nested parameters to create a National Road Transport Phase */
export type NestedCreateRoadTransportTripPhaseParams = {
  departureAt?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedRealizedAt?: InputMaybe<Scalars['DateTime']['input']>;
  realizedAt?: InputMaybe<Scalars['DateTime']['input']>;
  routePointId: Scalars['Int']['input'];
};

/** Available parameters to create a role */
export type NestedCreateRoleParams = {
  accessGroupId?: InputMaybe<Scalars['Int']['input']>;
  role: OperationHandlerEnum;
};

/** Available parameters to create a Route Point */
export type NestedCreateRoutePointParams = {
  addressId?: InputMaybe<Scalars['Int']['input']>;
  position: Scalars['Int']['input'];
  routeType: RouteTypeEnum;
};

/** Available nested parameters to create a Sales Order Item */
export type NestedCreateSalesOrderItemParams = {
  clientApprovedAt?: InputMaybe<Scalars['DateTime']['input']>;
  cofinsTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  cubageCubicMeters?: InputMaybe<Scalars['Decimal']['input']>;
  dispatchNumber?: InputMaybe<Scalars['String']['input']>;
  factoryDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  factoryEstimatedDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  grossWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  icmsTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  iiTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  internalContainerReference?: InputMaybe<Scalars['String']['input']>;
  ipiTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  itemStatus?: InputMaybe<Scalars['String']['input']>;
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  lineReference: Scalars['String']['input'];
  measurementUnitSap?: InputMaybe<Scalars['String']['input']>;
  necessityType?: InputMaybe<Scalars['String']['input']>;
  netWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  orderItemReference?: InputMaybe<Scalars['String']['input']>;
  orderRequestNumber?: InputMaybe<Scalars['String']['input']>;
  orderUnitValue?: InputMaybe<Scalars['Decimal']['input']>;
  orderValue?: InputMaybe<Scalars['Decimal']['input']>;
  palletGrouping?: InputMaybe<Scalars['Decimal']['input']>;
  palletQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  pisTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  preliminaryPickingStartedAt?: InputMaybe<Scalars['DateTime']['input']>;
  productId: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  reservedStockQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  shipmentContainersQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  shipmentEquipmentType?: InputMaybe<Scalars['String']['input']>;
  shipmentPlannedArrivalAt?: InputMaybe<Scalars['DateTime']['input']>;
  shipmentPlannedBoardingAt?: InputMaybe<Scalars['DateTime']['input']>;
  specialTreatments?: InputMaybe<SpecialTreatmentsTypeEnum>;
  stockQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  stockReservationAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierEstimatedReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierPlannedReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  ubc?: InputMaybe<Scalars['String']['input']>;
};

/** Available nested parameters to create a Sales Order Item by Rest API */
export type NestedCreateSalesOrderItemParamsByRestApi = {
  clientApprovedAt?: InputMaybe<Scalars['DateTime']['input']>;
  cofinsTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  cubageCubicMeters?: InputMaybe<Scalars['Decimal']['input']>;
  dispatchNumber?: InputMaybe<Scalars['String']['input']>;
  factoryDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  factoryEstimatedDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  grossWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  icmsTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  iiTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  internalContainerReference?: InputMaybe<Scalars['String']['input']>;
  ipiTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  itemStatus?: InputMaybe<Scalars['String']['input']>;
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  lineReference: Scalars['String']['input'];
  measurementUnitSap?: InputMaybe<Scalars['String']['input']>;
  necessityType?: InputMaybe<Scalars['String']['input']>;
  netWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  orderItemReference?: InputMaybe<Scalars['String']['input']>;
  orderRequestNumber?: InputMaybe<Scalars['String']['input']>;
  orderUnitValue?: InputMaybe<Scalars['Decimal']['input']>;
  orderValue?: InputMaybe<Scalars['Decimal']['input']>;
  palletGrouping?: InputMaybe<Scalars['Decimal']['input']>;
  palletQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  pisTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  preliminaryPickingStartedAt?: InputMaybe<Scalars['DateTime']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  reservedStockQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  shipmentContainersQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  shipmentEquipmentType?: InputMaybe<Scalars['String']['input']>;
  shipmentPlannedArrivalAt?: InputMaybe<Scalars['DateTime']['input']>;
  shipmentPlannedBoardingAt?: InputMaybe<Scalars['DateTime']['input']>;
  specialTreatments?: InputMaybe<SpecialTreatmentsTypeEnum>;
  stockQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  stockReservationAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierEstimatedReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierPlannedReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  ubc?: InputMaybe<Scalars['String']['input']>;
};

/** Available nested parameters to create a Sales Order */
export type NestedCreateSalesOrderParams = {
  items?: InputMaybe<Array<NestedCreateSalesOrderItemParams>>;
  orderConfirmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderReceivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<OrderTransactionTypeEnum>;
};

/** Available nested parameters to create a Sales Order by Rest API */
export type NestedCreateSalesOrderParamsByRestApi = {
  items?: InputMaybe<Array<NestedCreateSalesOrderItemParamsByRestApi>>;
  orderConfirmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderReceivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<OrderTransactionTypeEnum>;
};

/** Available nested parameters to create a Shipment Pallet */
export type NestedCreateShipmentPalletParams = {
  heightCm?: InputMaybe<Scalars['Int']['input']>;
  lengthMm?: InputMaybe<Scalars['Int']['input']>;
  palletStandardId?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
  sizeType: PalletSizeTypeEnum;
  widthMm?: InputMaybe<Scalars['Int']['input']>;
};

/** Available nested parameters to create a Transportable */
export type NestedCreateTransportableParams = {
  cargo?: InputMaybe<NestedCreateCargoParams>;
  container?: InputMaybe<NestedCreateContainerParams>;
};

/** Available nested parameters to create a Vessel Schedule */
export type NestedCreateVesselScheduleParams = {
  cargoDeadlineReference?: InputMaybe<DeadlineDateReferenceEnum>;
  draftDeadlineReference?: InputMaybe<DeadlineDateReferenceEnum>;
  gateOpeningDeadlineReference?: InputMaybe<GateOpeningDeadlineDateReferenceEnum>;
  vgmDeadlineReference?: InputMaybe<VgmDeadlineDateReferenceEnum>;
};

/** Available parameters to create or update an DUIMP */
export type NestedDuimpParams = {
  channel?: InputMaybe<ChannelTypeEnum>;
  customsClearedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deliveredAt?: InputMaybe<Scalars['DateTime']['input']>;
  extra?: InputMaybe<Scalars['JSON']['input']>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DuimpStatusEnum>;
  statusResponse?: InputMaybe<StatusResponseTypeEnum>;
  statusUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** Available parameters to create or update an Export Declaration */
export type NestedExportDeclarationParams = {
  channel?: InputMaybe<ChannelExportDeclarationTypeEnum>;
  customsClearedAt?: InputMaybe<Scalars['DateTime']['input']>;
  endorsedAt?: InputMaybe<Scalars['DateTime']['input']>;
  extra?: InputMaybe<Scalars['JSON']['input']>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ExportDeclarationStatusEnum>;
  statusResponse?: InputMaybe<StatusResponseTypeEnum>;
};

/** Available parameters to create or update an Import Declaration */
export type NestedImportDeclarationParams = {
  channel?: InputMaybe<ChannelTypeEnum>;
  customsClearedAt?: InputMaybe<Scalars['DateTime']['input']>;
  extra?: InputMaybe<Scalars['JSON']['input']>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ImportDeclarationStatusEnum>;
  statusResponse?: InputMaybe<StatusResponseTypeEnum>;
  statusUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Available parameters to create or update an Import License */
export type NestedImportLicenseParams = {
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  extra?: InputMaybe<Scalars['JSON']['input']>;
  importDeclarationId?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ImportLicenseStatusEnum>;
  statusResponse?: InputMaybe<StatusResponseTypeEnum>;
  statusUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Available parameters to create or update an International Freight */
export type NestedInternationalFreightParams = {
  bookingDischargeAirportId?: InputMaybe<Scalars['Int']['input']>;
  bookingDischargePortId?: InputMaybe<Scalars['Int']['input']>;
  bookingEta?: InputMaybe<Scalars['DateTime']['input']>;
  bookingEtd?: InputMaybe<Scalars['DateTime']['input']>;
  bookingLoadingAirportId?: InputMaybe<Scalars['Int']['input']>;
  bookingLoadingPortId?: InputMaybe<Scalars['Int']['input']>;
  cargoAttributes?: InputMaybe<Array<CargoAttributeEnum>>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  expectedSeparationAt?: InputMaybe<Scalars['DateTime']['input']>;
  freightCostCollect?: InputMaybe<Scalars['Decimal']['input']>;
  freightCostPrepaid?: InputMaybe<Scalars['Decimal']['input']>;
  freightCostRoad?: InputMaybe<Scalars['Decimal']['input']>;
  freightForwarder?: InputMaybe<Scalars['String']['input']>;
  pickupLocation?: InputMaybe<Scalars['String']['input']>;
  plannedBoardingDate?: InputMaybe<Scalars['DateTime']['input']>;
  portTerminalId?: InputMaybe<Scalars['Int']['input']>;
  quotationNumber?: InputMaybe<Scalars['String']['input']>;
  sealineId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<InternationalFreightTypeEnum>;
  vesselId?: InputMaybe<Scalars['Int']['input']>;
  voyageNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Available parameters to update a international transport leg */
export type NestedInternationalTransportLegParams = {
  arrivalPlace?: InputMaybe<Scalars['String']['input']>;
  ata?: InputMaybe<Scalars['DateTime']['input']>;
  atd?: InputMaybe<Scalars['DateTime']['input']>;
  departurePlace?: InputMaybe<Scalars['String']['input']>;
  eta?: InputMaybe<Scalars['DateTime']['input']>;
  etd?: InputMaybe<Scalars['DateTime']['input']>;
  modalType?: InputMaybe<ModalTypeEnum>;
  vesselId?: InputMaybe<Scalars['Int']['input']>;
  voyage?: InputMaybe<Scalars['String']['input']>;
};

/** Available nested parameters to create a LPCO */
export type NestedLpcoParams = {
  actorId?: InputMaybe<Scalars['Int']['input']>;
  agency?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<ChannelTypeEnum>;
  extra?: InputMaybe<Scalars['JSON']['input']>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  modelCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  operationType?: InputMaybe<LpcoOperationTypeEnum>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  requirements?: InputMaybe<Array<NestedLpcoRequirementParams>>;
  status?: InputMaybe<LpcoSituationEnum>;
  statusResponse?: InputMaybe<StatusResponseTypeEnum>;
  statusUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  transportMode?: InputMaybe<LpcoTransportModeEnum>;
  validityEnd?: InputMaybe<Scalars['Date']['input']>;
  validityStart?: InputMaybe<Scalars['Date']['input']>;
};

/** Available parameters to create or update a LPCO requirement */
export type NestedLpcoRequirementParams = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  notice?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  responseDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<StatusRequirementTypeEnum>;
};

/** Available nested parameters to create a Handler in the Midea operations */
export type NestedMideaCreateHandlerParams = {
  actor: CreatePartnershipParams;
  businessUnit?: InputMaybe<Scalars['String']['input']>;
  operationHandlerId: Scalars['Int']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  secondaryReference?: InputMaybe<Scalars['String']['input']>;
};

/** Available nested parameters to create a Purchase Order Item in the Midea operations */
export type NestedMideaCreatePurchaseOrderItemParams = {
  assessmentSotd?: InputMaybe<Scalars['String']['input']>;
  cubageCubicMeters?: InputMaybe<Scalars['Decimal']['input']>;
  customsEstimatedRegisterAt?: InputMaybe<Scalars['DateTime']['input']>;
  customsEstimatedReleaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  customsRegisterLeadTime?: InputMaybe<Scalars['Int']['input']>;
  customsReleaseLeadTime?: InputMaybe<Scalars['Int']['input']>;
  factoryDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  factoryDeliveryLeadTime?: InputMaybe<Scalars['Int']['input']>;
  factoryEstimatedDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  factoryPlannedDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  grossWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  itemForeignOperators?: InputMaybe<Array<Scalars['Int']['input']>>;
  itemStatus?: InputMaybe<Scalars['String']['input']>;
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  lineReference: Scalars['String']['input'];
  measurementUnitSap?: InputMaybe<Scalars['String']['input']>;
  netWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  orderAdjustedModalType?: InputMaybe<Scalars['String']['input']>;
  orderCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  orderItemReference?: InputMaybe<Scalars['String']['input']>;
  orderModalTypeSap?: InputMaybe<Scalars['String']['input']>;
  orderRequestNumber?: InputMaybe<Scalars['String']['input']>;
  orderRequestedAt?: InputMaybe<Scalars['String']['input']>;
  orderUnitValue?: InputMaybe<Scalars['Decimal']['input']>;
  orderValue?: InputMaybe<Scalars['Decimal']['input']>;
  planningRequestShippingAt?: InputMaybe<Scalars['DateTime']['input']>;
  planningShippingAt?: InputMaybe<Scalars['DateTime']['input']>;
  product: UpdateProductParams;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  sapByFactor?: InputMaybe<Scalars['Decimal']['input']>;
  shipmentBoardingLeadTime?: InputMaybe<Scalars['Int']['input']>;
  shipmentContainersQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  shipmentEquipmentType?: InputMaybe<Scalars['String']['input']>;
  shipmentEstimatedArrivalAt?: InputMaybe<Scalars['DateTime']['input']>;
  shipmentEstimatedBoardingAt?: InputMaybe<Scalars['DateTime']['input']>;
  shipmentPlannedArrivalAt?: InputMaybe<Scalars['DateTime']['input']>;
  shipmentPlannedBoardingAt?: InputMaybe<Scalars['DateTime']['input']>;
  shipmentTransportLeadTime?: InputMaybe<Scalars['Int']['input']>;
  supplierCalculatedReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierConfirmationAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierEstimatedReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierPlannedReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierReadyLeadTimeDays?: InputMaybe<Scalars['Int']['input']>;
  supplierSentAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Available nested parameters to create a Purchase Order in the Midea operations */
export type NestedMideaCreatePurchaseOrderParams = {
  items?: InputMaybe<Array<NestedMideaCreatePurchaseOrderItemParams>>;
  necessityDate?: InputMaybe<Scalars['DateTime']['input']>;
  supplierExpectedReadinessAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierOrderAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierOrderSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierReadinessAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<OrderTransactionTypeEnum>;
};

/** Available parameters for a nested Notification Group Role */
export type NestedNotificationGroupRoleParams = {
  id?: InputMaybe<Scalars['Int']['input']>;
  role: OperationHandlerEnum;
};

/** Available parameters to create/update Config Props */
export type NestedOperationConfigPropsParams = {
  auditorAgentId?: InputMaybe<Scalars['Int']['input']>;
  autoFinishOrders?: InputMaybe<Scalars['Boolean']['input']>;
  internationalModal?: InputMaybe<InternationalModalEnum>;
  isMultipleNationalRoadTransport?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderRequiredWhenCreatingProcess?: InputMaybe<Scalars['Boolean']['input']>;
  itemReference?: InputMaybe<ItemReferenceEnum>;
  orderItemAdditionalFields?: InputMaybe<Array<Scalars['String']['input']>>;
  showExternalReferenceCode?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Available nested parameters to create and update a Road Transport Shipment Driver */
export type NestedRoadTransportShipmentDriverParams = {
  amountPaidInAdvance?: InputMaybe<Scalars['Decimal']['input']>;
  ciot?: InputMaybe<Scalars['String']['input']>;
  driverId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Default to false */
  isFullyPaid?: InputMaybe<Scalars['Boolean']['input']>;
  totalAmountToPay?: InputMaybe<Scalars['Decimal']['input']>;
};

/** Available parameters to nested create and update a Road Transport Shipment */
export type NestedRoadTransportShipmentParams = {
  arrivalInTerminalScheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  boardingPermit?: InputMaybe<Scalars['String']['input']>;
  clientArrivalAt?: InputMaybe<Scalars['DateTime']['input']>;
  clientDepartureAt?: InputMaybe<Scalars['DateTime']['input']>;
  demurrage?: InputMaybe<NestedCreateDemurrageParams>;
  emptyContainerReturnScheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceExchangeEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceExchangeStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  roadTransportOrderId: Scalars['Int']['input'];
  shipmentDrivers?: InputMaybe<Array<NestedRoadTransportShipmentDriverParams>>;
  shipmentTrailers?: InputMaybe<Array<NestedShipmentTrailerParams>>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  transportAcknowledgment?: InputMaybe<Scalars['Upload']['input']>;
  transportableIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  vehicleId?: InputMaybe<Scalars['Int']['input']>;
};

/** Available parameters to create or update a Shipment DUIMP */
export type NestedShipmentDuimpParams = {
  comments?: InputMaybe<Scalars['String']['input']>;
  duimp?: InputMaybe<NestedDuimpParams>;
  id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ShipmentDocumentAuthorizationStatusEnum>;
};

/** Available parameters to create or update a Shipment Export Declaration */
export type NestedShipmentExportDeclarationParams = {
  comments?: InputMaybe<Scalars['String']['input']>;
  exportDeclaration?: InputMaybe<NestedExportDeclarationParams>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** Available parameters to create or update a Shipment Import Declaration */
export type NestedShipmentImportDeclarationParams = {
  comments?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  importDeclaration?: InputMaybe<NestedImportDeclarationParams>;
  status?: InputMaybe<ShipmentDocumentAuthorizationStatusEnum>;
};

/** Available parameters to create or update a Shipment Import License */
export type NestedShipmentImportLicenseParams = {
  comments?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  importLicense?: InputMaybe<NestedImportLicenseParams>;
  status?: InputMaybe<ShipmentDocumentAuthorizationStatusEnum>;
};

/** Available parameters to create or update a Shipment LPCO */
export type NestedShipmentLpcoParams = {
  comments?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lpco?: InputMaybe<NestedLpcoParams>;
};

/** Available nested parameters to create and update a shipment trailer */
export type NestedShipmentTrailerParams = {
  id?: InputMaybe<Scalars['Int']['input']>;
  trailerId?: InputMaybe<Scalars['Int']['input']>;
};

/** Available nested parameters to update an Air Transport Shipment */
export type NestedUpdateAirTransportShipmentParams = {
  airlineId?: InputMaybe<Scalars['Int']['input']>;
  awb?: InputMaybe<Scalars['String']['input']>;
  destinationAirportId?: InputMaybe<Scalars['Int']['input']>;
  hawb?: InputMaybe<Scalars['String']['input']>;
  originAirportId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<AirTransportTypeEnum>;
};

/** Available nested parameters to update an Audit Item */
export type NestedUpdateAuditItemParams = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  showObservationsWhen?: InputMaybe<AuditItemShowObservationEnum>;
};

/** Available nested parameters to update a Cargo */
export type NestedUpdateCargoParams = {
  cubicWeight?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  measurementUnit?: InputMaybe<MeasurementUnitEnum>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  volumeCubicMeters?: InputMaybe<Scalars['String']['input']>;
  weightKg?: InputMaybe<Scalars['String']['input']>;
};

/** Available nested parameters to update a Container */
export type NestedUpdateContainerParams = {
  code?: InputMaybe<Scalars['String']['input']>;
  cubicMeters?: InputMaybe<Scalars['Decimal']['input']>;
  debitNotes?: InputMaybe<Array<NestedUpdateDebitNoteParams>>;
  demurrageFreeTimeStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  dispatchNumber?: InputMaybe<Scalars['String']['input']>;
  emptyPickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  emptyReceivedAtFactory?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedStuffingAt?: InputMaybe<Scalars['DateTime']['input']>;
  grossWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  htTreatment?: InputMaybe<Scalars['Boolean']['input']>;
  htTreatmentAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  internalReferenceCode?: InputMaybe<Scalars['String']['input']>;
  invoiceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceGrossWeight?: InputMaybe<Scalars['Decimal']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceValue?: InputMaybe<Scalars['Decimal']['input']>;
  isStackable?: InputMaybe<Scalars['Boolean']['input']>;
  loadType?: InputMaybe<LoadTypeEnum>;
  loadingScheduleAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  ncmCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  observations?: InputMaybe<Scalars['String']['input']>;
  oic?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  palletQuantity?: InputMaybe<Scalars['Int']['input']>;
  portDepositAt?: InputMaybe<Scalars['DateTime']['input']>;
  portScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  preStacking?: InputMaybe<Scalars['Boolean']['input']>;
  preStackingReason?: InputMaybe<PreStackingReasonEnum>;
  preStackingWarehouse?: InputMaybe<PreStackingWarehouseEnum>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  releasedForTripAt?: InputMaybe<Scalars['DateTime']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  scaleExitAt?: InputMaybe<Scalars['DateTime']['input']>;
  sealCode?: InputMaybe<Scalars['String']['input']>;
  secondarySealCode?: InputMaybe<Scalars['String']['input']>;
  separationCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sizeFootType?: InputMaybe<ContainerSizeFootTypeEnum>;
  stackingScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  stackingStartedAt?: InputMaybe<Scalars['DateTime']['input']>;
  tareWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  trackingManual?: InputMaybe<Scalars['Boolean']['input']>;
  transportDocument?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ContainerTypeEnum>;
  washingChargeReceivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  washingDamageResult?: InputMaybe<ContainerWashingDamageResultEnum>;
  washingDamageStatus?: InputMaybe<ContainerWashingConclusionStatusEnum>;
  washingEmptyChecklist?: InputMaybe<Scalars['Boolean']['input']>;
  washingInspection?: InputMaybe<Scalars['String']['input']>;
  washingPaymentAt?: InputMaybe<Scalars['DateTime']['input']>;
  washingPaymentStatus?: InputMaybe<ContainerWashingPaymentStatusEnum>;
  washingServiceType?: InputMaybe<ContainerWashingServiceTypeEnum>;
  washingTermDescription?: InputMaybe<ContainerWashingTermDescriptionEnum>;
  washingTermStatus?: InputMaybe<ContainerWashingConclusionStatusEnum>;
  washingValue?: InputMaybe<Scalars['Decimal']['input']>;
};

/** Available nested parameters to update a Debit Note */
export type NestedUpdateDebitNoteParams = {
  coverageEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  coverageStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  payedAt?: InputMaybe<Scalars['DateTime']['input']>;
  totalValueUsd?: InputMaybe<Scalars['Decimal']['input']>;
  usdToBrlRate?: InputMaybe<Scalars['Decimal']['input']>;
};

/** Available nested parameters to update a Demurrage */
export type NestedUpdateDemurrageParams = {
  dailyRateUsd?: InputMaybe<Scalars['Decimal']['input']>;
  freeTime?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** Available parameters to update Dimensions */
export type NestedUpdateDimensionsParams = {
  a?: InputMaybe<Scalars['Int']['input']>;
  b?: InputMaybe<Scalars['Int']['input']>;
  c?: InputMaybe<Scalars['Int']['input']>;
  d?: InputMaybe<Scalars['Int']['input']>;
  length?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** Available nested parameters to update a fence */
export type NestedUpdateFenceParams = {
  fencePoints?: InputMaybe<Array<NestedCreateFencePointParams>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Available parameters to update a Foreign Trade Item Shipment */
export type NestedUpdateForeignTradeItemShipmentParams = {
  brazilianInvoiceUnitValue?: InputMaybe<Scalars['Decimal']['input']>;
  cubageCubicMeters?: InputMaybe<Scalars['Decimal']['input']>;
  grossWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lineReference?: InputMaybe<Scalars['String']['input']>;
  netWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  orderReferenceCode?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderItemId?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  salesOrderItemId?: InputMaybe<Scalars['Int']['input']>;
  transportableIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  unitValue?: InputMaybe<Scalars['Decimal']['input']>;
};

/** Available nested parameters to update a Foreign Trade Road Transport Shipment */
export type NestedUpdateForeignTradeRoadTransportShipmentParams = {
  crt?: InputMaybe<Scalars['String']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ForeignTradeRoadTransportTypeEnum>;
};

/** Available parameters to update a Foreign Trade Shipment */
export type NestedUpdateForeignTradeShipmentParams = {
  airTransportShipment?: InputMaybe<NestedUpdateAirTransportShipmentParams>;
  /** Actual time of arrival */
  ata?: InputMaybe<Scalars['DateTime']['input']>;
  /** Actual time of departure */
  atd?: InputMaybe<Scalars['DateTime']['input']>;
  automaticTrackingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ceMercanteNumber?: InputMaybe<Scalars['String']['input']>;
  cubageCubicMeters?: InputMaybe<Scalars['Decimal']['input']>;
  deliveredAt?: InputMaybe<Scalars['DateTime']['input']>;
  demurrage?: InputMaybe<NestedUpdateDemurrageParams>;
  departedFromWarehouseAt?: InputMaybe<Scalars['DateTime']['input']>;
  emptyReturnDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Estimated time of arrival */
  eta?: InputMaybe<Scalars['DateTime']['input']>;
  /** Estimated time of departure */
  etd?: InputMaybe<Scalars['DateTime']['input']>;
  internationalFreight?: InputMaybe<NestedInternationalFreightParams>;
  /** Replaces the full set of transport legs. Omitting this field preserves existing legs; sending an empty list clears all legs. */
  internationalTransportLegs?: InputMaybe<Array<NestedInternationalTransportLegParams>>;
  invoices?: InputMaybe<Array<NestedUpdateInvoiceParams>>;
  items?: InputMaybe<Array<NestedUpdateForeignTradeItemShipmentParams>>;
  maritimeTransportShipment?: InputMaybe<NestedUpdateMaritimeTransportShipmentParams>;
  nationalRoadTransport?: InputMaybe<NestedUpdateNationalRoadTransportParams>;
  nationalRoadTransports?: InputMaybe<Array<NestedUpdateNationalRoadTransportParams>>;
  /** Replaces the full set of pallets. Omitting this field keeps them; rows without `id` are created and omitted rows are removed. */
  pallets?: InputMaybe<Array<NestedUpdateShipmentPalletParams>>;
  parcelShipments?: InputMaybe<Array<NestedUpdateParcelShipmentParams>>;
  receivedInWarehouseAt?: InputMaybe<Scalars['DateTime']['input']>;
  roadTransportShipment?: InputMaybe<NestedUpdateForeignTradeRoadTransportShipmentParams>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  shipmentDuimps?: InputMaybe<Array<NestedShipmentDuimpParams>>;
  shipmentExportDeclarations?: InputMaybe<Array<NestedShipmentExportDeclarationParams>>;
  shipmentImportDeclarations?: InputMaybe<Array<NestedShipmentImportDeclarationParams>>;
  shipmentImportLicenses?: InputMaybe<Array<NestedShipmentImportLicenseParams>>;
  shipmentLpcos?: InputMaybe<Array<NestedShipmentLpcoParams>>;
  statusResponse?: InputMaybe<StatusResponseTypeEnum>;
  totalGrossWeight?: InputMaybe<Scalars['Decimal']['input']>;
  totalNetWeight?: InputMaybe<Scalars['Decimal']['input']>;
  transportables?: InputMaybe<Array<NestedUpdateTransportableParams>>;
  vesselSchedule?: InputMaybe<NestedUpdateVesselScheduleParams>;
  warehouseFreeTimeDays?: InputMaybe<Scalars['Int']['input']>;
};

/** Available nested parameters to update a Handler */
export type NestedUpdateHandlerParams = {
  actor?: InputMaybe<CreatePartnershipParams>;
  actorId?: InputMaybe<Scalars['Int']['input']>;
  businessUnit?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  operationHandlerId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  secondaryReference?: InputMaybe<Scalars['String']['input']>;
};

/** Available nested parameters to update an Invoice Item */
export type NestedUpdateInvoiceItemParams = {
  batchNumber?: InputMaybe<Scalars['String']['input']>;
  batchValidityDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderItemLineReference?: InputMaybe<Scalars['String']['input']>;
  orderReferenceCode?: InputMaybe<Scalars['String']['input']>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  productSku?: InputMaybe<Scalars['String']['input']>;
  productionDate?: InputMaybe<Scalars['DateTime']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  totalGrossWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  transportableIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  unitaryAmount?: InputMaybe<Scalars['Decimal']['input']>;
};

/** Available nested parameters to update an Invoice */
export type NestedUpdateInvoiceParams = {
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  emittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incoterm?: InputMaybe<IncotermTypeEnum>;
  items?: InputMaybe<Array<NestedUpdateInvoiceItemParams>>;
  number?: InputMaybe<Scalars['String']['input']>;
};

/** Available nested parameters to update a Lead Time Stage Model */
export type NestedUpdateLeadTimeStageModelParams = {
  color?: InputMaybe<Scalars['String']['input']>;
  endEvent?: InputMaybe<Scalars['String']['input']>;
  endMode?: InputMaybe<ModeTypeEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startEvent?: InputMaybe<Scalars['String']['input']>;
  startMode?: InputMaybe<ModeTypeEnum>;
};

/** Available nested parameters to update a Maritime Transport Shipment */
export type NestedUpdateMaritimeTransportShipmentParams = {
  bl?: InputMaybe<Scalars['String']['input']>;
  booking?: InputMaybe<Scalars['String']['input']>;
  dischargePortId?: InputMaybe<Scalars['Int']['input']>;
  hbl?: InputMaybe<Scalars['String']['input']>;
  loadingPortId?: InputMaybe<Scalars['Int']['input']>;
  sealineId?: InputMaybe<Scalars['Int']['input']>;
  trackingDischargePort?: InputMaybe<Scalars['String']['input']>;
  trackingKey?: InputMaybe<TrackingKeyEnum>;
  trackingLoadingPort?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MaritimeTransportTypeEnum>;
  vesselId?: InputMaybe<Scalars['Int']['input']>;
  voyageNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Nested params to update a National Road Carrier Handler. operation_handler_id is optional (inferred from the role). */
export type NestedUpdateNationalRoadCarrierParams = {
  actor?: InputMaybe<UpsertPartnershipByHandlerParams>;
  actorId?: InputMaybe<Scalars['Int']['input']>;
  businessUnit?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  operationHandlerId?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  secondaryReference?: InputMaybe<Scalars['String']['input']>;
};

/** Available nested parameters to update a National Road Transport */
export type NestedUpdateNationalRoadTransportParams = {
  collectionScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryPlannedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isTransportTypeDta?: InputMaybe<Scalars['Boolean']['input']>;
  legSlug?: InputMaybe<Scalars['String']['input']>;
  loadType?: InputMaybe<LoadTypeEnum>;
  nationalRoadCarrier?: InputMaybe<NestedUpdateNationalRoadCarrierParams>;
  quantityPallets?: InputMaybe<Scalars['Int']['input']>;
  releasedForTransportAt?: InputMaybe<Scalars['DateTime']['input']>;
  roadTransportType?: InputMaybe<RoadTransportTypeEnum>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  transportCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  transportFeatures?: InputMaybe<Array<TransportFeatureEnum>>;
  trips?: InputMaybe<Array<NestedUpdateRoadTransportTripParams>>;
};

/** Available nested parameters to update an Order Audit Item */
export type NestedUpdateOrderAuditItem = {
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  observations?: InputMaybe<Scalars['String']['input']>;
};

/** Available nested parameters to update a Parcel Shipment */
export type NestedUpdateParcelShipmentParams = {
  ata?: InputMaybe<Scalars['DateTime']['input']>;
  atd?: InputMaybe<Scalars['DateTime']['input']>;
  courierId?: InputMaybe<Scalars['Int']['input']>;
  destinationAddress?: InputMaybe<Scalars['String']['input']>;
  destinationCountryCode?: InputMaybe<Scalars['String']['input']>;
  eta?: InputMaybe<Scalars['DateTime']['input']>;
  etd?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  originAddress?: InputMaybe<Scalars['String']['input']>;
  originCountryCode?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Available nested parameters to update a Planned Lead Time Stage */
export type NestedUpdatePlannedLeadTimeStageParams = {
  days?: InputMaybe<Scalars['Int']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  leadTimeStageModelId?: InputMaybe<Scalars['Int']['input']>;
};

/** Available nested parameters to update a Process Audit Item */
export type NestedUpdateProcessAuditItem = {
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  observations?: InputMaybe<Scalars['String']['input']>;
};

/** Available parameters to update a Product Internal Code */
export type NestedUpdateProductInternalCodeParams = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Available nested parameters to update a Purchase Order Item */
export type NestedUpdatePurchaseOrderItemParams = {
  adjustedCustomsRegisterLeadTime?: InputMaybe<Scalars['Int']['input']>;
  adjustedCustomsReleaseLeadTime?: InputMaybe<Scalars['Int']['input']>;
  adjustedFactoryDeliveryLeadTime?: InputMaybe<Scalars['Int']['input']>;
  adjustedShipmentBoardingLeadTime?: InputMaybe<Scalars['Int']['input']>;
  adjustedShipmentTransportLeadTime?: InputMaybe<Scalars['Int']['input']>;
  adjustedSupplierReadyLeadTimeDays?: InputMaybe<Scalars['Int']['input']>;
  assessmentSotd?: InputMaybe<Scalars['String']['input']>;
  cofinsTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  concessionAct?: InputMaybe<Scalars['String']['input']>;
  cubageCubicMeters?: InputMaybe<Scalars['Decimal']['input']>;
  customsEstimatedRegisterAt?: InputMaybe<Scalars['DateTime']['input']>;
  customsEstimatedReleaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  customsRegisterLeadTime?: InputMaybe<Scalars['Int']['input']>;
  customsReleaseLeadTime?: InputMaybe<Scalars['Int']['input']>;
  deliveryNote?: InputMaybe<Scalars['String']['input']>;
  deliveryNoteIssuedAt?: InputMaybe<Scalars['Date']['input']>;
  dispatchingCountryCode?: InputMaybe<Scalars['String']['input']>;
  division?: InputMaybe<Scalars['String']['input']>;
  factoryDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  factoryDeliveryLeadTime?: InputMaybe<Scalars['Int']['input']>;
  factoryEstimatedDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  factoryPlannedDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  grossWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  icmsTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  iiTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  importTypeSap?: InputMaybe<Scalars['String']['input']>;
  invoiceIssuedAt?: InputMaybe<Scalars['Date']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceType?: InputMaybe<Scalars['String']['input']>;
  invoiceValue?: InputMaybe<Scalars['Decimal']['input']>;
  ipiTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  itemForeignOperators?: InputMaybe<Array<Scalars['Int']['input']>>;
  itemStatus?: InputMaybe<Scalars['String']['input']>;
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  lineReference: Scalars['String']['input'];
  manufacturingCountryCode?: InputMaybe<Scalars['String']['input']>;
  measurementUnitSap?: InputMaybe<Scalars['String']['input']>;
  netWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderAdjustedModalType?: InputMaybe<Scalars['String']['input']>;
  orderCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  orderItemReference?: InputMaybe<Scalars['String']['input']>;
  orderModalTypeSap?: InputMaybe<Scalars['String']['input']>;
  orderRequestNumber?: InputMaybe<Scalars['String']['input']>;
  orderRequestedAt?: InputMaybe<Scalars['String']['input']>;
  orderUnitValue?: InputMaybe<Scalars['Decimal']['input']>;
  orderValue?: InputMaybe<Scalars['Decimal']['input']>;
  palletGrouping?: InputMaybe<Scalars['Decimal']['input']>;
  palletQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  pisTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  planningRequestShippingAt?: InputMaybe<Scalars['DateTime']['input']>;
  planningShippingAt?: InputMaybe<Scalars['DateTime']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  purchaseCountryCode?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  quotationOpeningDate?: InputMaybe<Scalars['Date']['input']>;
  sapByFactor?: InputMaybe<Scalars['Decimal']['input']>;
  shipmentBoardingLeadTime?: InputMaybe<Scalars['Int']['input']>;
  shipmentContainersQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  shipmentEquipmentType?: InputMaybe<Scalars['String']['input']>;
  shipmentEstimatedArrivalAt?: InputMaybe<Scalars['DateTime']['input']>;
  shipmentEstimatedBoardingAt?: InputMaybe<Scalars['DateTime']['input']>;
  shipmentPlannedArrivalAt?: InputMaybe<Scalars['DateTime']['input']>;
  shipmentPlannedBoardingAt?: InputMaybe<Scalars['DateTime']['input']>;
  shipmentTransportLeadTime?: InputMaybe<Scalars['Int']['input']>;
  shippingDetailsDeliveryDate?: InputMaybe<Scalars['Date']['input']>;
  specialTreatments?: InputMaybe<SpecialTreatmentsTypeEnum>;
  supplierCalculatedReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierConfirmationAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierEstimatedReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierPlannedReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierReadyLeadTimeDays?: InputMaybe<Scalars['Int']['input']>;
  supplierSentAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Available nested parameters to update a Purchase Order */
export type NestedUpdatePurchaseOrderParams = {
  items?: InputMaybe<Array<NestedUpdatePurchaseOrderItemParams>>;
  necessityDate?: InputMaybe<Scalars['DateTime']['input']>;
  supplierExpectedReadinessAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierOrderAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierOrderSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierReadinessAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<OrderTransactionTypeEnum>;
};

/** Available nested parameters to update a Road Transport Order */
export type NestedUpdateRoadTransportOrderParams = {
  bl?: InputMaybe<Scalars['String']['input']>;
  booking?: InputMaybe<Scalars['String']['input']>;
  cargoDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  destinationCountry?: InputMaybe<Scalars['String']['input']>;
  diOrDta?: InputMaybe<Scalars['String']['input']>;
  draftDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  importer?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['String']['input']>;
  releasedForTransport?: InputMaybe<Scalars['DateTime']['input']>;
  roadTransportShipments?: InputMaybe<Array<NestedRoadTransportShipmentParams>>;
  sealineId?: InputMaybe<Scalars['Int']['input']>;
  storageExpiration?: InputMaybe<Scalars['DateTime']['input']>;
  tradeType?: InputMaybe<OriginTypeEnum>;
  transportSpecifications?: InputMaybe<Array<TransportSpecificationEnum>>;
  transportables?: InputMaybe<Array<NestedUpdateTransportableParams>>;
  type?: InputMaybe<RoadTransportOrderTypeEnum>;
  vessel?: InputMaybe<Scalars['String']['input']>;
  voyage?: InputMaybe<Scalars['String']['input']>;
};

/** Available nested parameters to update a Road Transport Trip */
export type NestedUpdateRoadTransportTripParams = {
  driverId?: InputMaybe<Scalars['Int']['input']>;
  driverName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  phases?: InputMaybe<Array<NestedUpdateRoadTransportTripPhaseParams>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  trailerId?: InputMaybe<Scalars['Int']['input']>;
  trailerPlate?: InputMaybe<Scalars['String']['input']>;
  transportableIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  vehicleId?: InputMaybe<Scalars['Int']['input']>;
  vehiclePlate?: InputMaybe<Scalars['String']['input']>;
};

/** Available nested parameters to update a National Road Transport Phase */
export type NestedUpdateRoadTransportTripPhaseParams = {
  departureAt?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedRealizedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  realizedAt?: InputMaybe<Scalars['DateTime']['input']>;
  routePointId?: InputMaybe<Scalars['Int']['input']>;
};

/** Available parameters to update a role */
export type NestedUpdateRoleParams = {
  accessGroupId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<OperationHandlerEnum>;
};

/** Available parameters to update a Route Point */
export type NestedUpdateRoutePointParams = {
  addressId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  routeType?: InputMaybe<RouteTypeEnum>;
};

/** Available nested parameters to update a Sales Order Item */
export type NestedUpdateSalesOrderItemParams = {
  clientApprovedAt?: InputMaybe<Scalars['DateTime']['input']>;
  cofinsTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  cubageCubicMeters?: InputMaybe<Scalars['Decimal']['input']>;
  dispatchNumber?: InputMaybe<Scalars['String']['input']>;
  factoryDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  factoryEstimatedDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  grossWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  icmsTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  iiTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  internalContainerReference?: InputMaybe<Scalars['String']['input']>;
  ipiTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  itemStatus?: InputMaybe<Scalars['String']['input']>;
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  lineReference: Scalars['String']['input'];
  measurementUnitSap?: InputMaybe<Scalars['String']['input']>;
  necessityType?: InputMaybe<Scalars['String']['input']>;
  netWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  orderItemReference?: InputMaybe<Scalars['String']['input']>;
  orderRequestNumber?: InputMaybe<Scalars['String']['input']>;
  orderUnitValue?: InputMaybe<Scalars['Decimal']['input']>;
  orderValue?: InputMaybe<Scalars['Decimal']['input']>;
  palletGrouping?: InputMaybe<Scalars['Decimal']['input']>;
  palletQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  pisTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  preliminaryPickingStartedAt?: InputMaybe<Scalars['DateTime']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  reservedStockQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  shipmentContainersQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  shipmentEquipmentType?: InputMaybe<Scalars['String']['input']>;
  shipmentPlannedArrivalAt?: InputMaybe<Scalars['DateTime']['input']>;
  shipmentPlannedBoardingAt?: InputMaybe<Scalars['DateTime']['input']>;
  specialTreatments?: InputMaybe<SpecialTreatmentsTypeEnum>;
  stockQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  stockReservationAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierEstimatedReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierPlannedReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  supplierReadyAt?: InputMaybe<Scalars['DateTime']['input']>;
  ubc?: InputMaybe<Scalars['String']['input']>;
};

/** Available nested parameters to update a Sales Order */
export type NestedUpdateSalesOrderParams = {
  items?: InputMaybe<Array<NestedUpdateSalesOrderItemParams>>;
  orderConfirmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderReceivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<OrderTransactionTypeEnum>;
};

/** Available nested parameters to update a Shipment Pallet */
export type NestedUpdateShipmentPalletParams = {
  heightCm?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lengthMm?: InputMaybe<Scalars['Int']['input']>;
  palletStandardId?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sizeType?: InputMaybe<PalletSizeTypeEnum>;
  widthMm?: InputMaybe<Scalars['Int']['input']>;
};

/** Available nested parameters to update a Transportable */
export type NestedUpdateTransportableParams = {
  cargo?: InputMaybe<NestedUpdateCargoParams>;
  container?: InputMaybe<NestedUpdateContainerParams>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** Available nested parameters to update a Vessel Schedule */
export type NestedUpdateVesselScheduleParams = {
  cargoDeadlineReference?: InputMaybe<DeadlineDateReferenceEnum>;
  draftDeadlineReference?: InputMaybe<DeadlineDateReferenceEnum>;
  gateOpeningDeadlineReference?: InputMaybe<GateOpeningDeadlineDateReferenceEnum>;
  vgmDeadlineReference?: InputMaybe<VgmDeadlineDateReferenceEnum>;
};

/** Available nested parameters to upsert a Handler */
export type NestedUpsertHandlerParams = {
  actor?: InputMaybe<UpsertPartnershipByHandlerParams>;
  actorId?: InputMaybe<Scalars['Int']['input']>;
  businessUnit?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  secondaryReference?: InputMaybe<Scalars['String']['input']>;
};

/** Available nested parameters to upsert Handlers by Role */
export type NestedUpsertHandlersByRoleParams = {
  acquirer?: InputMaybe<Array<NestedUpsertHandlerParams>>;
  agent?: InputMaybe<Array<NestedUpsertHandlerParams>>;
  bank?: InputMaybe<Array<NestedUpsertHandlerParams>>;
  bondedTerminal?: InputMaybe<Array<NestedUpsertHandlerParams>>;
  cargoOwner?: InputMaybe<Array<NestedUpsertHandlerParams>>;
  containerDepot?: InputMaybe<Array<NestedUpsertHandlerParams>>;
  customer?: InputMaybe<Array<NestedUpsertHandlerParams>>;
  customsBroker?: InputMaybe<Array<NestedUpsertHandlerParams>>;
  customsTerminal?: InputMaybe<Array<NestedUpsertHandlerParams>>;
  exporter?: InputMaybe<Array<NestedUpsertHandlerParams>>;
  freightForwarder?: InputMaybe<Array<NestedUpsertHandlerParams>>;
  funder?: InputMaybe<Array<NestedUpsertHandlerParams>>;
  importer?: InputMaybe<Array<NestedUpsertHandlerParams>>;
  integrator?: InputMaybe<Array<NestedUpsertHandlerParams>>;
  internationalRoadCarrier?: InputMaybe<Array<NestedUpsertHandlerParams>>;
  manufacturer?: InputMaybe<Array<NestedUpsertHandlerParams>>;
  nationalRoadCarrier?: InputMaybe<Array<NestedUpsertHandlerParams>>;
  supplier?: InputMaybe<Array<NestedUpsertHandlerParams>>;
  trading?: InputMaybe<Array<NestedUpsertHandlerParams>>;
  warehouse?: InputMaybe<Array<NestedUpsertHandlerParams>>;
};

/** A Notification Group */
export type NotificationGroup = {
  __typename?: 'NotificationGroup';
  actorId: Scalars['Int']['output'];
  ccEmails: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  notificationGroupRoles: Array<NotificationGroupRole>;
  updatedAt: Scalars['DateTime']['output'];
};

/** The Notification Group Order By Enum */
export enum NotificationGroupOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Insertion date */
  InsertedAt = 'INSERTED_AT',
  /** Name */
  Name = 'NAME',
  /** Updated At */
  UpdatedAt = 'UPDATED_AT'
}

export type NotificationGroupOrderParams = {
  field?: InputMaybe<NotificationGroupOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Notification Groups */
export type NotificationGroupPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationGroupOrderParams>>;
};

/** A Notification Group Recipient */
export type NotificationGroupRecipient = {
  __typename?: 'NotificationGroupRecipient';
  emails: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  language: LanguageEnum;
  notificationGroupRole: Maybe<NotificationGroupRole>;
  notificationGroupRoleId: Scalars['Int']['output'];
  partnership: Maybe<Partnership>;
  partnershipId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A Notification Group Role */
export type NotificationGroupRole = {
  __typename?: 'NotificationGroupRole';
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  notificationGroup: Maybe<NotificationGroup>;
  notificationGroupId: Scalars['Int']['output'];
  notificationGroupRecipients: Array<NotificationGroupRecipient>;
  role: OperationHandlerEnum;
  updatedAt: Scalars['DateTime']['output'];
};

/** An Operation */
export type Operation = {
  __typename?: 'Operation';
  acceptHourInNationalRoadTransports: Scalars['Boolean']['output'];
  actor: Actor;
  apiRequestsCount: Scalars['Int']['output'];
  auditItems: Array<AuditItem>;
  autoGenerateOrderCode: Scalars['Boolean']['output'];
  autoGenerateProcessCode: Scalars['Boolean']['output'];
  automations: Array<Automation>;
  automationsCount: Scalars['Int']['output'];
  availableQuickFilters: Array<QuickFilter>;
  cardConfig: OperationCardConfig;
  cargoDeadlineDefaultReference: Maybe<DeadlineDateReferenceEnum>;
  configProps: OperationConfigProps;
  costModels: Array<CostModel>;
  draftDeadlineDefaultReference: Maybe<DeadlineDateReferenceEnum>;
  gateOpeningDeadlineDefaultReference: Maybe<GateOpeningDeadlineDateReferenceEnum>;
  id: Scalars['Int']['output'];
  isAutomaticDiDuimpLinkEnabled: Scalars['Boolean']['output'];
  isCeMercanteEnabled: Scalars['Boolean']['output'];
  isPhaseSequential: Scalars['Boolean']['output'];
  isSiscomexEnabled: Scalars['Boolean']['output'];
  operationAccess: OperationAccess;
  operationHandlers: Array<OperationHandler>;
  operationPhases: Array<OperationPhase>;
  orderCode: Maybe<Scalars['String']['output']>;
  orderComponents: Array<Component>;
  orderModalHeaderConfigs: Array<OperationModalHeaderConfig>;
  orders: Array<Order>;
  ordersCount: Scalars['Int']['output'];
  ordersCountOverview: AlertLevelOverview;
  ordersFields: Array<Path>;
  position: Scalars['Int']['output'];
  processCode: Maybe<Scalars['String']['output']>;
  processModalHeaderConfigs: Array<OperationModalHeaderConfig>;
  processes: Array<Process>;
  processesCount: Scalars['Int']['output'];
  processesCountOverview: AlertLevelOverview;
  processesFields: Array<Path>;
  quickFiltersConfigs: Array<QuickFilterConfig>;
  subType: OperationSubTypeEnum;
  subtitle: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: OperationTypeEnum;
  vgmDeadlineDefaultReference: Maybe<VgmDeadlineDateReferenceEnum>;
};


/** An Operation */
export type OperationApiRequestsCountArgs = {
  filters?: InputMaybe<FilterApiRequestParams>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** An Operation */
export type OperationAutomationsArgs = {
  filters?: InputMaybe<FilterAutomationParams>;
  pagination?: InputMaybe<AutomationPaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** An Operation */
export type OperationAutomationsCountArgs = {
  filters?: InputMaybe<FilterAutomationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** An Operation */
export type OperationAvailableQuickFiltersArgs = {
  currentFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** An Operation */
export type OperationOperationHandlersArgs = {
  filters?: InputMaybe<FilterOperationHandlerParams>;
};


/** An Operation */
export type OperationOrderComponentsArgs = {
  orderId?: InputMaybe<Scalars['Int']['input']>;
};


/** An Operation */
export type OperationOrderModalHeaderConfigsArgs = {
  orderId: Scalars['Int']['input'];
};


/** An Operation */
export type OperationOrdersArgs = {
  filters?: InputMaybe<FilterOrderParams>;
  pagination?: InputMaybe<OrderPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** An Operation */
export type OperationOrdersCountArgs = {
  filters?: InputMaybe<FilterOrderParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** An Operation */
export type OperationProcessModalHeaderConfigsArgs = {
  processId: Scalars['Int']['input'];
};


/** An Operation */
export type OperationProcessesArgs = {
  filters?: InputMaybe<FilterProcessParams>;
  pagination?: InputMaybe<ProcessPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** An Operation */
export type OperationProcessesCountArgs = {
  filters?: InputMaybe<FilterProcessParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** An Operation Access */
export type OperationAccess = {
  __typename?: 'OperationAccess';
  accessGroup: AccessGroup;
  canCloseOrReopenProcessesCosts: Scalars['Boolean']['output'];
  canCreateOrders: Scalars['Boolean']['output'];
  canCreateProcesses: Scalars['Boolean']['output'];
  canSeeOrders: Scalars['Boolean']['output'];
  canUpdateCancelledOrFinishedOrders: Scalars['Boolean']['output'];
  canUpdateCancelledOrFinishedProcesses: Scalars['Boolean']['output'];
  componentAccesses: Array<ComponentAccess>;
  id: Scalars['Int']['output'];
  operation: Operation;
  pdfDocumentAccesses: Array<PdfDocumentAccess>;
  phases: Array<Phase>;
  type: AccessEnum;
};

/** An Operation Card */
export type OperationCard = {
  __typename?: 'OperationCard';
  color: Maybe<Scalars['String']['output']>;
  headerLeft: Maybe<Scalars['String']['output']>;
  headerRight: Maybe<Scalars['String']['output']>;
  panelLabel: Maybe<Scalars['String']['output']>;
  panelType: Maybe<PathConfigTypeEnum>;
  panelValue: Maybe<Scalars['String']['output']>;
  subtitle: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

/** An Operation Card Config */
export type OperationCardConfig = {
  __typename?: 'OperationCardConfig';
  color: Scalars['String']['output'];
  headerLeft: Scalars['String']['output'];
  headerRight: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  operation: Operation;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Operation Config Props */
export type OperationConfigProps = {
  __typename?: 'OperationConfigProps';
  auditorAgentId: Maybe<Scalars['Int']['output']>;
  autoFinishOrders: Scalars['Boolean']['output'];
  internationalModal: InternationalModalEnum;
  isMultipleNationalRoadTransport: Scalars['Boolean']['output'];
  isOrderRequiredWhenCreatingProcess: Scalars['Boolean']['output'];
  itemReference: ItemReferenceEnum;
  orderItemAdditionalFields: Array<Scalars['String']['output']>;
  showExternalReferenceCode: Scalars['Boolean']['output'];
};

/** An Operation Handler */
export type OperationHandler = {
  __typename?: 'OperationHandler';
  bindingType: HandlerBindingTypeEnum;
  id: Scalars['Int']['output'];
  isListedInDynamicList: Scalars['Boolean']['output'];
  isManagedByRestApi: Scalars['Boolean']['output'];
  operation: Operation;
  owner: Scalars['Boolean']['output'];
  processInheritsOrderAccess: Scalars['Boolean']['output'];
  role: OperationHandlerEnum;
  showBusinessUnit: Scalars['Boolean']['output'];
  showReference: Scalars['Boolean']['output'];
  showSecondaryReference: Scalars['Boolean']['output'];
};

/** The Operation Handler Enum */
export enum OperationHandlerEnum {
  /** Adquirente / Acquirer */
  Acquirer = 'ACQUIRER',
  /** Agente */
  Agent = 'AGENT',
  /** Banco */
  Bank = 'BANK',
  /** Terminal Alfandegado / Bonded Terminal */
  BondedTerminal = 'BONDED_TERMINAL',
  /** Embarcador / Cargo Owner */
  CargoOwner = 'CARGO_OWNER',
  /** Depósito de Containers */
  ContainerDepot = 'CONTAINER_DEPOT',
  /** Cliente */
  Customer = 'CUSTOMER',
  /** Despachante Aduaneiro */
  CustomsBroker = 'CUSTOMS_BROKER',
  /** Terminal Alfandegado (Zona Secundária) */
  CustomsTerminal = 'CUSTOMS_TERMINAL',
  /** Exporter */
  Exporter = 'EXPORTER',
  /** Agente de Cargas / Freight Forwarding */
  FreightForwarder = 'FREIGHT_FORWARDER',
  /** Financiador */
  Funder = 'FUNDER',
  /** Importer */
  Importer = 'IMPORTER',
  /** Integrador */
  Integrator = 'INTEGRATOR',
  /** Transportadora Rodoviária Internacional / Road Carrier */
  InternationalRoadCarrier = 'INTERNATIONAL_ROAD_CARRIER',
  /** Fabricante */
  Manufacturer = 'MANUFACTURER',
  /** Transportadora Rodoviária Nacional / National Road Carrier */
  NationalRoadCarrier = 'NATIONAL_ROAD_CARRIER',
  /** Fornecedor */
  Supplier = 'SUPPLIER',
  /** Trading Company */
  Trading = 'TRADING',
  /** Armazém */
  Warehouse = 'WAREHOUSE'
}

/** An Operation Modal Header Config */
export type OperationModalHeaderConfig = {
  __typename?: 'OperationModalHeaderConfig';
  label: Maybe<Scalars['String']['output']>;
  type: Maybe<PathConfigTypeEnum>;
  value: Maybe<Scalars['String']['output']>;
};

/** The Operation order by enum */
export enum OperationOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Subtítulo */
  Subtitle = 'SUBTITLE',
  /** Subtipo */
  SubType = 'SUB_TYPE',
  /** Título */
  Title = 'TITLE',
  /** Tipo */
  Type = 'TYPE',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

/** Available parameters to sort Operations */
export type OperationOrderParams = {
  field?: InputMaybe<OperationOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Operations */
export type OperationPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperationOrderParams>>;
};

/** An Operation Phase */
export type OperationPhase = {
  __typename?: 'OperationPhase';
  components: Array<Component>;
  id: Scalars['Int']['output'];
  operation: Operation;
  orders: Array<Order>;
  ordersCount: Maybe<Scalars['Int']['output']>;
  ordersCountOverview: AlertLevelOverview;
  phase: Phase;
  position: Scalars['Int']['output'];
  processes: Array<Process>;
  processesCount: Scalars['Int']['output'];
  processesCountOverview: AlertLevelOverview;
};


/** An Operation Phase */
export type OperationPhaseComponentsArgs = {
  processId?: InputMaybe<Scalars['Int']['input']>;
};


/** An Operation Phase */
export type OperationPhaseOrdersArgs = {
  filters?: InputMaybe<FilterOrderParams>;
  pagination?: InputMaybe<OrderPaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** An Operation Phase */
export type OperationPhaseOrdersCountArgs = {
  filters?: InputMaybe<FilterOrderParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** An Operation Phase */
export type OperationPhaseProcessesArgs = {
  filters?: InputMaybe<FilterProcessParams>;
  pagination?: InputMaybe<ProcessPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** An Operation Phase */
export type OperationPhaseProcessesCountArgs = {
  filters?: InputMaybe<FilterProcessParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** The Operation Subtype Enum */
export enum OperationSubTypeEnum {
  /** Exportação */
  Export = 'EXPORT',
  /** Importação */
  Import = 'IMPORT',
  /** Personalizado Baseado em Processo */
  ProcessBasedCustom = 'PROCESS_BASED_CUSTOM'
}

/** The Operation Type Enum */
export enum OperationTypeEnum {
  /** Personalizada */
  Custom = 'CUSTOM',
  /** Comércio Exterior */
  ForeignTrade = 'FOREIGN_TRADE',
  /** Transporte Rodoviário */
  RoadTransport = 'ROAD_TRANSPORT'
}

/** An Order */
export type Order = {
  __typename?: 'Order';
  alertLevel: AlertLevelEnum;
  auditApprovalInfo: Maybe<OrderAuditApprovalInfo>;
  auditItems: Array<OrderAuditItem>;
  automationOrders: Array<AutomationOrder>;
  canceledAt: Maybe<Scalars['DateTime']['output']>;
  checkpoints: Array<CheckpointStatus>;
  currentPhase: Maybe<Phase>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  documents: Array<Document>;
  externalReferenceCode: Maybe<Scalars['String']['output']>;
  extraFields: Maybe<Scalars['JSON']['output']>;
  finishedAt: Maybe<Scalars['DateTime']['output']>;
  handler: Maybe<Handler>;
  handlers: Array<Handler>;
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  leadTimeDatetimeReference: Maybe<Scalars['DateTime']['output']>;
  observations: Maybe<Scalars['String']['output']>;
  operation: Operation;
  ownerHandler: Maybe<Handler>;
  pdfDocument: Maybe<PdfDocument>;
  pdfDocuments: Array<PdfDocumentBase>;
  previousPhase: Maybe<Phase>;
  processes: Array<Process>;
  purchaseOrder: Maybe<PurchaseOrder>;
  referenceCode: Scalars['String']['output'];
  roadTransportOrder: Maybe<RoadTransportOrder>;
  route: Maybe<Route>;
  salesOrder: Maybe<SalesOrder>;
  subsidiary: Maybe<Subsidiary>;
  type: OrderTypeEnum;
  versions: Array<Version>;
  versionsCount: Scalars['Int']['output'];
};


/** An Order */
export type OrderHandlerArgs = {
  role: OperationHandlerEnum;
};


/** An Order */
export type OrderPdfDocumentArgs = {
  id: Scalars['Int']['input'];
};


/** An Order */
export type OrderProcessesArgs = {
  filters?: InputMaybe<FilterProcessParams>;
};


/** An Order */
export type OrderVersionsArgs = {
  filters?: InputMaybe<FilterVersionParams>;
  pagination?: InputMaybe<VersionPaginationParams>;
};


/** An Order */
export type OrderVersionsCountArgs = {
  filters?: InputMaybe<FilterVersionParams>;
};

/** Information about Audit approval of an Order */
export type OrderAuditApprovalInfo = {
  __typename?: 'OrderAuditApprovalInfo';
  approvedAt: Scalars['DateTime']['output'];
  approvedBy: User;
};

/** An Order Audit Item */
export type OrderAuditItem = {
  __typename?: 'OrderAuditItem';
  auditItem: AuditItem;
  checked: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  observations: Maybe<Scalars['String']['output']>;
  order: Order;
};

/** An Order Item */
export type OrderItem = {
  __typename?: 'OrderItem';
  order: Order;
  purchaseOrderItem: Maybe<PurchaseOrderItem>;
  salesOrderItem: Maybe<SalesOrderItem>;
};

/** Available parameters to paginate Order Items */
export type OrderItemPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** An Order Item with Shipment Item */
export type OrderItemWithShipmentItem = {
  __typename?: 'OrderItemWithShipmentItem';
  foreignTradeItemShipment: Maybe<ForeignTradeItemShipment>;
  order: Order;
  process: Maybe<Process>;
  purchaseOrderItem: Maybe<PurchaseOrderItem>;
  salesOrderItem: Maybe<SalesOrderItem>;
};

/** The Order By Enum */
export enum OrderOrderByEnum {
  /** Nível de Alerta */
  AlertLevel = 'ALERT_LEVEL',
  /** Código de referência externo */
  ExternalReferenceCode = 'EXTERNAL_REFERENCE_CODE',
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Código de referência */
  ReferenceCode = 'REFERENCE_CODE',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

export type OrderOrderParams = {
  field?: InputMaybe<OrderOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Orders */
export type OrderPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderOrderParams>>;
};

/** An Order Subscription */
export type OrderSubscription = {
  __typename?: 'OrderSubscription';
  data: Maybe<Order>;
  latestVersion: Maybe<Version>;
  transactionType: Maybe<TransactionTypeEnum>;
};

/** The Order Transaction Type Enum */
export enum OrderTransactionTypeEnum {
  /** DIRECT */
  Direct = 'DIRECT',
  /** INDIRECT */
  Indirect = 'INDIRECT'
}

/** The Order Type Enum */
export enum OrderTypeEnum {
  /** Pedido de Compra */
  Purchase = 'PURCHASE',
  /** Pedido de Transporte Rodoviário */
  RoadTransport = 'ROAD_TRANSPORT',
  /** Pedido de Venda */
  Sales = 'SALES'
}

/** The Origin Type Enum */
export enum OriginTypeEnum {
  /** Internacional */
  International = 'INTERNATIONAL',
  /** Nacional */
  National = 'NATIONAL'
}

/** An Overview */
export type Overview = {
  __typename?: 'Overview';
  packageBundlesByOccupation: Array<PackageBundleByOccupation>;
  packagesByProductionLine: Array<ProductionLineCount>;
  packagesBySupplyOrigin: Array<SupplyOriginCount>;
};

/** A Package */
export type Package = {
  __typename?: 'Package';
  bundleOccupationPercentage: Scalars['Decimal']['output'];
  code: Scalars['String']['output'];
  extra: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  inboundDate: Scalars['Date']['output'];
  itemQuantity: Scalars['Int']['output'];
  locationCode: Scalars['String']['output'];
  packageBundleCode: Scalars['String']['output'];
  product: Product;
  productionLine: ProductionLineEnum;
  supplyOrigin: OriginTypeEnum;
  type: Scalars['String']['output'];
  warehouse: Warehouse;
};

/** A package bundle by occupation */
export type PackageBundleByOccupation = {
  __typename?: 'PackageBundleByOccupation';
  count: Scalars['Int']['output'];
  packagesCount: Scalars['Int']['output'];
  percentage: Scalars['Decimal']['output'];
};

/** The Package Order By Enum */
export enum PackageOrderByEnum {
  /** Porcentagem de ocupação agrupada */
  BundleOccupationPercentage = 'BUNDLE_OCCUPATION_PERCENTAGE',
  /** Código */
  Code = 'CODE',
  /** ID */
  Id = 'ID',
  /** Data de entrada */
  InboundDate = 'INBOUND_DATE',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Quantidade do item */
  ItemQuantity = 'ITEM_QUANTITY',
  /** Código de localização */
  LocationCode = 'LOCATION_CODE',
  /** Código do pacote agrupado */
  PackageBundleCode = 'PACKAGE_BUNDLE_CODE',
  /** Linha de produção */
  ProductionLine = 'PRODUCTION_LINE',
  /** Origem dos suprimentos */
  SupplyOrigin = 'SUPPLY_ORIGIN',
  /** Tipo */
  Type = 'TYPE',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

export type PackageOrderParams = {
  field?: InputMaybe<PackageOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Packages */
export type PackagePaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PackageOrderParams>>;
};

/** The Package Unit Enum */
export enum PackageUnitTypeEnum {
  /** Caixa */
  Box = 'BOX',
  /** Palete */
  Pallet = 'PALLET',
  /** Bandeja */
  Tray = 'TRAY'
}

/** Available parameters to paginate Airlines */
export type PaginationAirlineParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AirlineOrderParams>>;
};

/** Available parameters to paginate Airports */
export type PaginationAirportParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AirportOrderParams>>;
};

/** Available parameters to paginate API Requests */
export type PaginationApiRequestParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiRequestOrderParams>>;
};

/** Available parameters to paginate Couriers */
export type PaginationCourierParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CourierOrderParams>>;
};

/** Available parameters to paginate Maritime Ports */
export type PaginationMaritimePortParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaritimePortOrderParams>>;
};

/** Available parameters to paginate Port Schedules */
export type PaginationPortScheduleParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortScheduleOrderParams>>;
};

/** Available parameters to paginate Port Terminals */
export type PaginationPortTerminalParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortTerminalOrderParams>>;
};

/** Available parameters to paginate Port Terminal Schedules */
export type PaginationPortTerminalScheduleParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortTerminalScheduleOrderParams>>;
};

/** Available parameters to paginate Vessels */
export type PaginationVesselParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselOrderParams>>;
};

/** The Pallet Size Type Enum */
export enum PalletSizeTypeEnum {
  /** Personalizado */
  Custom = 'CUSTOM',
  /** Não informado */
  NotInformed = 'NOT_INFORMED',
  /** Padrão */
  Standard = 'STANDARD'
}

/** A standard pallet size from the global catalog */
export type PalletStandard = {
  __typename?: 'PalletStandard';
  code: Scalars['String']['output'];
  eurCode: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isoCode: Maybe<Scalars['String']['output']>;
  lengthMm: Scalars['Int']['output'];
  name: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  widthMm: Scalars['Int']['output'];
};

/** A Parcel Shipment */
export type ParcelShipment = {
  __typename?: 'ParcelShipment';
  ata: Maybe<Scalars['DateTime']['output']>;
  atd: Maybe<Scalars['DateTime']['output']>;
  courier: Maybe<Courier>;
  destinationAddress: Maybe<Scalars['String']['output']>;
  destinationCountry: Maybe<Country>;
  destinationCountryCode: Maybe<Scalars['String']['output']>;
  eta: Maybe<Scalars['DateTime']['output']>;
  etd: Maybe<Scalars['DateTime']['output']>;
  events: Array<ParcelShipmentEvent>;
  foreignTradeShipment: ForeignTradeShipment;
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  lastTrackingAt: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  originAddress: Maybe<Scalars['String']['output']>;
  originCountry: Maybe<Country>;
  originCountryCode: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  status: ParcelShipmentStatusEnum;
  statusResponse: StatusResponseTypeEnum;
  trackingNumber: Scalars['String']['output'];
};

/** A Parcel Shipment Event */
export type ParcelShipmentEvent = {
  __typename?: 'ParcelShipmentEvent';
  address: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['DateTime']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

/** The Process Order By Enum */
export enum ParcelShipmentStatusEnum {
  /** Entregue */
  Delivered = 'DELIVERED',
  /** Em Trânsito */
  InTransit = 'IN_TRANSIT',
  /** Aguardando Retirada */
  WaitingPickUp = 'WAITING_PICK_UP'
}

/** A Partnership between actors */
export type Partnership = {
  __typename?: 'Partnership';
  contactDetails: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  internalCode: Maybe<Scalars['String']['output']>;
  nickname: Maybe<Scalars['String']['output']>;
  nicknameWithFallback: Scalars['String']['output'];
  partner: Actor;
  partnershipOwner: Actor;
  roles: Array<Role>;
};

/** The Partnership Order By Enum */
export enum PartnershipOrderByEnum {
  /** Detalhes de contato */
  ContactDetails = 'CONTACT_DETAILS',
  /** Descrição */
  Description = 'DESCRIPTION',
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Código interno */
  InternalCode = 'INTERNAL_CODE',
  /** Nickname */
  Nickname = 'NICKNAME',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

export type PartnershipOrderParams = {
  field?: InputMaybe<PartnershipOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Partnerships */
export type PartnershipPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PartnershipOrderParams>>;
};

/** A Path */
export type Path = {
  __typename?: 'Path';
  isList: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  options: Maybe<Array<PathFieldOption>>;
  path: Scalars['String']['output'];
  type: PathTypeEnum;
};

/** The Path Config Type from the Path Configs Enum */
export enum PathConfigTypeEnum {
  /** Data */
  Date = 'DATE',
  /** Data e Hora */
  Datetime = 'DATETIME',
  /** Decimal */
  Decimal = 'DECIMAL',
  /** Inteiro */
  Integer = 'INTEGER',
  /** String */
  String = 'STRING'
}

/** An option entry with value and translated label */
export type PathFieldOption = {
  __typename?: 'PathFieldOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** The Path Type Enum */
export enum PathTypeEnum {
  /** Boolean */
  Boolean = 'BOOLEAN',
  /** Date */
  Date = 'DATE',
  /** Datetime */
  Datetime = 'DATETIME',
  /** Decimal */
  Decimal = 'DECIMAL',
  /** Enum */
  Enum = 'ENUM',
  /** Float */
  Float = 'FLOAT',
  /** Integer */
  Integer = 'INTEGER',
  /** List */
  List = 'LIST',
  /** Map */
  Map = 'MAP',
  /** String */
  String = 'STRING'
}

/** A PDF Document */
export type PdfDocument = {
  __typename?: 'PdfDocument';
  header: Scalars['JSON']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['JSON']['output'];
  operation: Operation;
  props: Maybe<Scalars['JSON']['output']>;
  sections: Array<PdfSection>;
  type: PdfDocumentTypeEnum;
};

/** A Pdf Document Access */
export type PdfDocumentAccess = {
  __typename?: 'PdfDocumentAccess';
  id: Scalars['Int']['output'];
  operationAccess: OperationAccess;
  pdfDocument: PdfDocument;
  type: AccessEnum;
};

/** A PDF Document */
export type PdfDocumentBase = {
  __typename?: 'PdfDocumentBase';
  id: Scalars['Int']['output'];
  name: Scalars['JSON']['output'];
  operation: Operation;
  props: Maybe<Scalars['JSON']['output']>;
  type: PdfDocumentTypeEnum;
};

/** The PDF Document Type Enum */
export enum PdfDocumentTypeEnum {
  /** Pedido */
  Order = 'ORDER',
  /** Processo */
  Process = 'PROCESS'
}

/** A PDF Row */
export type PdfRow = {
  __typename?: 'PdfRow';
  fields: Scalars['JSON']['output'];
  id: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  props: Maybe<Scalars['JSON']['output']>;
  section: PdfSection;
};

/** A PDF Section */
export type PdfSection = {
  __typename?: 'PdfSection';
  document: PdfDocument;
  id: Scalars['Int']['output'];
  name: Scalars['JSON']['output'];
  position: Scalars['Int']['output'];
  props: Maybe<Scalars['JSON']['output']>;
  rows: Array<PdfRow>;
};

/** A Phase */
export type Phase = {
  __typename?: 'Phase';
  checkpoints: Array<Checkpoint>;
  id: Scalars['Int']['output'];
  operations: Array<Operation>;
  phase: PhaseEnum;
  sortingLabel: Maybe<Scalars['String']['output']>;
  sortingOrder: Maybe<SimpleSortingOrderEnum>;
  sortingPath: Maybe<Scalars['String']['output']>;
  trigger: Maybe<Trigger>;
};

/** The Phase Enum */
export enum PhaseEnum {
  /** Tratamento Administrativo */
  AdministrativeProcessing = 'ADMINISTRATIVE_PROCESSING',
  /** Chegada no Destino */
  ArrivalAtDestination = 'ARRIVAL_AT_DESTINATION',
  /** Atendimento */
  Attendance = 'ATTENDANCE',
  /** Planejamento Atendimento */
  AttendancePlanning = 'ATTENDANCE_PLANNING',
  /** Auditoria */
  Audit = 'AUDIT',
  /** Aguardando Prontidão */
  AwaitingReadiness = 'AWAITING_READINESS',
  /** Blending */
  Blending = 'BLENDING',
  /** Booking */
  Booking = 'BOOKING',
  /** Solicitação Booking */
  BookingRequest = 'BOOKING_REQUEST',
  /** Nota Fiscal */
  BrazilianInvoice = 'BRAZILIAN_INVOICE',
  /** Expedição */
  CargoDispatch = 'CARGO_DISPATCH',
  /** Preparação da Carga */
  CargoHandling = 'CARGO_HANDLING',
  /** Vistoria */
  CargoInspection = 'CARGO_INSPECTION',
  /** Carregamento */
  CargoLoading = 'CARGO_LOADING',
  /** Coffee Processing */
  CoffeeProcessing = 'COFFEE_PROCESSING',
  /** Levante Container */
  ContainerRelease = 'CONTAINER_RELEASE',
  /** Análise Crédito */
  CreditAnalysis = 'CREDIT_ANALYSIS',
  /** Aduana */
  Customs = 'CUSTOMS',
  /** Nacionalização */
  CustomsClearance = 'CUSTOMS_CLEARANCE',
  /** Delivered */
  Delivered = 'DELIVERED',
  /** Deposited */
  Deposited = 'DEPOSITED',
  /** Destination Warehouse */
  DestinationWarehouse = 'DESTINATION_WAREHOUSE',
  /** Desvios */
  Deviations = 'DEVIATIONS',
  /** Discharge Port */
  DischargePort = 'DISCHARGE_PORT',
  /** Documentação */
  Documentation = 'DOCUMENTATION',
  /** Solicitação Documentos */
  DocumentRequest = 'DOCUMENT_REQUEST',
  /** Conferência */
  DocumentVerification = 'DOCUMENT_VERIFICATION',
  /** Pagamento Motorista */
  DriverPayment = 'DRIVER_PAYMENT',
  /** DTA */
  Dta = 'DTA',
  /** Empty Container Pickup */
  EmptyContainerPickup = 'EMPTY_CONTAINER_PICKUP',
  /** Empty Return */
  EmptyReturn = 'EMPTY_RETURN',
  /** Inspeção Final */
  FinalInspection = 'FINAL_INSPECTION',
  /** Financeiro */
  FinancialClearance = 'FINANCIAL_CLEARANCE',
  /** Importador */
  Importer = 'IMPORTER',
  /** International Logistics */
  InternationalLogistics = 'INTERNATIONAL_LOGISTICS',
  /** Transporte Internacional */
  InternationalTransport = 'INTERNATIONAL_TRANSPORT',
  /** Inventory Analysis */
  InventoryAnalysis = 'INVENTORY_ANALYSIS',
  /** Invoice */
  Invoice = 'INVOICE',
  /** Faturamento */
  Invoicing = 'INVOICING',
  /** In Transit */
  InTransit = 'IN_TRANSIT',
  /** Loading Port */
  LoadingPort = 'LOADING_PORT',
  /** Manufacturing */
  Manufacturing = 'MANUFACTURING',
  /** National Logistics */
  NationalLogistics = 'NATIONAL_LOGISTICS',
  /** Nova Liberação */
  NewRelease = 'NEW_RELEASE',
  /** Nomeação */
  Nomination = 'NOMINATION',
  /** Origin Warehouse */
  OriginWarehouse = 'ORIGIN_WAREHOUSE',
  /** Remessa Parcial */
  PartialShipment = 'PARTIAL_SHIPMENT',
  /** Payment */
  Payment = 'PAYMENT',
  /** Pickup */
  Pickup = 'PICKUP',
  /** Post-Shipment */
  PostShipment = 'POST_SHIPMENT',
  /** Pré-embarque */
  PreBoarding = 'PRE_BOARDING',
  /** Pre Order */
  PreOrder = 'PRE_ORDER',
  /** Pré-Stacking */
  PreStacking = 'PRE_STACKING',
  /** Purchase Demand */
  PurchaseDemand = 'PURCHASE_DEMAND',
  /** Purchase Order */
  PurchaseOrder = 'PURCHASE_ORDER',
  /** Cotação */
  Quotation = 'QUOTATION',
  /** Transporte Rodoviário */
  RoadTransport = 'ROAD_TRANSPORT',
  /** Sailing */
  Sailing = 'SAILING',
  /** Sample Production */
  SampleProduction = 'SAMPLE_PRODUCTION',
  /** Sample Shipment */
  SampleShipment = 'SAMPLE_SHIPMENT',
  /** Satisfaction Survey */
  SatisfactionSurvey = 'SATISFACTION_SURVEY',
  /** Programação */
  Schedule = 'SCHEDULE',
  /** Solicitação de Embarque */
  ShipmentRequest = 'SHIPMENT_REQUEST',
  /** Programação de Embarque */
  ShipmentScheduling = 'SHIPMENT_SCHEDULING',
  /** Instrução de Embarque */
  ShippingInstructions = 'SHIPPING_INSTRUCTIONS',
  /** Stuffing */
  Stuffing = 'STUFFING',
  /** Programação Estufagem */
  StuffingScheduling = 'STUFFING_SCHEDULING',
  /** Transfer */
  Transfer = 'TRANSFER',
  /** Documento de Transporte */
  TransportDocument = 'TRANSPORT_DOCUMENT',
  /** Viagem */
  Trip = 'TRIP',
  /** Unloaded */
  Unloaded = 'UNLOADED',
  /** Armazém */
  Warehouse = 'WAREHOUSE'
}

/** A Planned Lead Time */
export type PlannedLeadTime = {
  __typename?: 'PlannedLeadTime';
  id: Scalars['Int']['output'];
  leadTimeModel: LeadTimeModel;
  name: Scalars['String']['output'];
  stages: Array<PlannedLeadTimeStage>;
};

/** The Planned Lead Time Order By Enum */
export enum PlannedLeadTimeOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Nome */
  Name = 'NAME',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

/** Available parameters to sort Planned Lead Time */
export type PlannedLeadTimeOrderParams = {
  field?: InputMaybe<PlannedLeadTimeOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Planned Lead Time */
export type PlannedLeadTimePaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PlannedLeadTimeOrderParams>>;
};

/** A Planned Lead Time Stage */
export type PlannedLeadTimeStage = {
  __typename?: 'PlannedLeadTimeStage';
  days: Scalars['Int']['output'];
  hours: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  leadTimeStageModel: LeadTimeStageModel;
  quantityHours: Scalars['Int']['output'];
};

/** A Port Schedule */
export type PortSchedule = {
  __typename?: 'PortSchedule';
  atb: Maybe<Scalars['DateTime']['output']>;
  atu: Maybe<Scalars['DateTime']['output']>;
  carrierCode: Maybe<Scalars['String']['output']>;
  carrierCountry: Maybe<Country>;
  carrierName: Maybe<Scalars['String']['output']>;
  carrierVoyage: Maybe<Scalars['String']['output']>;
  etb: Maybe<Scalars['DateTime']['output']>;
  etu: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  lastPorts: Array<PortScheduleLeg>;
  maritimePort: MaritimePort;
  nextPorts: Array<PortScheduleLeg>;
  operationType: Maybe<Scalars['String']['output']>;
  scheduleNumber: Scalars['String']['output'];
  shippingAgencyCnpj: Maybe<Scalars['String']['output']>;
  shippingAgencyName: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vessel: Vessel;
  vesselResponsible: Maybe<Scalars['String']['output']>;
};

/** A Port Schedule Leg */
export type PortScheduleLeg = {
  __typename?: 'PortScheduleLeg';
  atu: Maybe<Scalars['DateTime']['output']>;
  etb: Maybe<Scalars['DateTime']['output']>;
  portUnlocode: Scalars['String']['output'];
};

/** The Port Schedule Order By Enum */
export enum PortScheduleOrderByEnum {
  /** Nome da Empresa de Navegação */
  CarrierName = 'CARRIER_NAME',
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Número da escala */
  ScheduleNumber = 'SCHEDULE_NUMBER',
  /** Nome da Agência de Navegação */
  ShippingAgencyName = 'SHIPPING_AGENCY_NAME'
}

export type PortScheduleOrderParams = {
  field?: InputMaybe<PortScheduleOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** A Port Terminal */
export type PortTerminal = {
  __typename?: 'PortTerminal';
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** The Port Terminal Order By Enum */
export enum PortTerminalOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Nome */
  Name = 'NAME',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

export type PortTerminalOrderParams = {
  field?: InputMaybe<PortTerminalOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** A Port Terminal Schedule */
export type PortTerminalSchedule = {
  __typename?: 'PortTerminalSchedule';
  agency: Maybe<Scalars['String']['output']>;
  ata: Maybe<Scalars['DateTime']['output']>;
  atb: Maybe<Scalars['DateTime']['output']>;
  atd: Maybe<Scalars['DateTime']['output']>;
  berth: Maybe<Scalars['String']['output']>;
  cargo: Maybe<Scalars['String']['output']>;
  charterer: Maybe<Scalars['String']['output']>;
  customFacility: CustomFacility;
  dryDeadline: Maybe<Scalars['DateTime']['output']>;
  dryRelease: Maybe<Scalars['DateTime']['output']>;
  eta: Maybe<Scalars['DateTime']['output']>;
  etb: Maybe<Scalars['DateTime']['output']>;
  etd: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  operation: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['String']['output']>;
  reeferDeadline: Maybe<Scalars['DateTime']['output']>;
  reeferRelease: Maybe<Scalars['DateTime']['output']>;
  referenceDate: Maybe<Scalars['DateTime']['output']>;
  scheduleIdentifier: Maybe<Scalars['String']['output']>;
  sealine: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vessel: Scalars['String']['output'];
  voyage: Scalars['String']['output'];
};

/** The Port Terminal Schedule Order By Enum */
export enum PortTerminalScheduleOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Identificador de Cronograma */
  ScheduleIdentifier = 'SCHEDULE_IDENTIFIER',
  /** Navio */
  Vessel = 'VESSEL',
  /** Viagem */
  Voyage = 'VOYAGE'
}

export type PortTerminalScheduleOrderParams = {
  field?: InputMaybe<PortTerminalScheduleOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** A Port Terminal Vessel Schedule */
export type PortTerminalVesselSchedule = {
  __typename?: 'PortTerminalVesselSchedule';
  cargoDeadline: Maybe<Scalars['DateTime']['output']>;
  draftDeadline: Maybe<Scalars['DateTime']['output']>;
  gateOpening: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  insertedAt: Maybe<Scalars['DateTime']['output']>;
  reeferGateOpening: Maybe<Scalars['DateTime']['output']>;
};

/** The Pre-Stacking Reason Enum */
export enum PreStackingReasonEnum {
  /** Antecipação carregamento (capacidade x demanda) */
  LoadingAnticipationCapacityVsDemand = 'LOADING_ANTICIPATION_CAPACITY_VS_DEMAND',
  /** Antecipação carregamento (fechamento mês) */
  LoadingAnticipationMonthClosing = 'LOADING_ANTICIPATION_MONTH_CLOSING',
  /** Antecipação carregamento (manutenção stacking) */
  LoadingAnticipationStackingMaintenance = 'LOADING_ANTICIPATION_STACKING_MAINTENANCE',
  /** Problema operacional logística PB */
  LogisticsPbOperationalIssue = 'LOGISTICS_PB_OPERATIONAL_ISSUE',
  /** Bloqueio de gate porto */
  PortGateBlocked = 'PORT_GATE_BLOCKED',
  /** No-show porto */
  PortNoShow = 'PORT_NO_SHOW',
  /** Recusa do porto */
  PortRefusal = 'PORT_REFUSAL',
  /** Cancelamento de janela porto */
  PortWindowCancelled = 'PORT_WINDOW_CANCELLED',
  /** Falta janela porto */
  PortWindowUnavailable = 'PORT_WINDOW_UNAVAILABLE',
  /** Rodoviário - fechamento mês */
  RoadTransportMonthClosing = 'ROAD_TRANSPORT_MONTH_CLOSING',
  /** Problema lacre */
  SealIssue = 'SEAL_ISSUE',
  /** Problema operacional transporte */
  TransportOperationalIssue = 'TRANSPORT_OPERATIONAL_ISSUE',
  /** Troca de unidades (bitrem) */
  UnitSwapBitrain = 'UNIT_SWAP_BITRAIN',
  /** Transferência de navio / ajuste de DDL armador */
  VesselTransferCarrierDdlAdjustment = 'VESSEL_TRANSFER_CARRIER_DDL_ADJUSTMENT',
  /** Janela liberada para data futura */
  WindowReleasedFutureDate = 'WINDOW_RELEASED_FUTURE_DATE'
}

/** The Pre-Stacking Warehouse Enum */
export enum PreStackingWarehouseEnum {
  /** CDI */
  Cdi = 'CDI',
  /** Roatlog */
  Roatlog = 'ROATLOG',
  /** Tecadi */
  Tecadi = 'TECADI'
}

/** A Process */
export type Process = {
  __typename?: 'Process';
  alertLevel: AlertLevelEnum;
  auditApprovalInfo: Maybe<ProcessAuditApprovalInfo>;
  auditItems: Array<ProcessAuditItem>;
  automationProcesses: Array<AutomationProcess>;
  bookingDataPublication: Maybe<ExternalPagePublication>;
  bookingQuotation: Maybe<BookingQuotation>;
  bookingQuotationPage: Maybe<ExternalPage>;
  canceledAt: Maybe<Scalars['DateTime']['output']>;
  cardInfo: Maybe<OperationCard>;
  checkpoints: Array<CheckpointStatus>;
  costClosedAt: Maybe<Scalars['DateTime']['output']>;
  costModelVersion: Maybe<CostModelVersion>;
  costPerExpenses: Array<CostPerExpense>;
  currentPhase: Maybe<Phase>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  documents: Array<Document>;
  extraFields: Maybe<Scalars['JSON']['output']>;
  finishedAt: Maybe<Scalars['DateTime']['output']>;
  foreignTradeShipment: Maybe<ForeignTradeShipment>;
  handler: Maybe<Handler>;
  handlers: Array<Handler>;
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  itemCostsPerReference: Maybe<ItemCostsPerReference>;
  leadTime: Maybe<LeadTime>;
  leadTimeDatetimeReference: Maybe<Scalars['DateTime']['output']>;
  leadTimeMarkers: Maybe<Array<LeadTimeMarker>>;
  operation: Operation;
  orders: Array<Order>;
  ownerHandler: Maybe<Handler>;
  pdfDocument: Maybe<PdfDocument>;
  pdfDocuments: Array<PdfDocumentBase>;
  plannedLeadTime: Maybe<PlannedLeadTime>;
  previousPhase: Maybe<Phase>;
  referenceCode: Scalars['String']['output'];
  versions: Array<Version>;
  versionsCount: Scalars['Int']['output'];
};


/** A Process */
export type ProcessHandlerArgs = {
  role: OperationHandlerEnum;
};


/** A Process */
export type ProcessPdfDocumentArgs = {
  id: Scalars['Int']['input'];
};


/** A Process */
export type ProcessVersionsArgs = {
  filters?: InputMaybe<FilterVersionParams>;
  pagination?: InputMaybe<VersionPaginationParams>;
};


/** A Process */
export type ProcessVersionsCountArgs = {
  filters?: InputMaybe<FilterVersionParams>;
};

/** Information about Audit approval of a Process */
export type ProcessAuditApprovalInfo = {
  __typename?: 'ProcessAuditApprovalInfo';
  approvedAt: Scalars['DateTime']['output'];
  approvedBy: User;
};

/** A Process Audit Item */
export type ProcessAuditItem = {
  __typename?: 'ProcessAuditItem';
  auditItem: AuditItem;
  checked: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  observations: Maybe<Scalars['String']['output']>;
  process: Process;
};

/** Auditor agent state for a process */
export type ProcessAuditorStatus = {
  __typename?: 'ProcessAuditorStatus';
  agentExecutionId: Maybe<Scalars['ID']['output']>;
  canTrigger: Scalars['Boolean']['output'];
  cooldownUntil: Maybe<Scalars['DateTime']['output']>;
  isRunning: Scalars['Boolean']['output'];
  lastRunAt: Maybe<Scalars['DateTime']['output']>;
};

/** The Process Order By Enum */
export enum ProcessOrderByEnum {
  /** Nível de Alerta */
  AlertLevel = 'ALERT_LEVEL',
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Código de referência */
  ReferenceCode = 'REFERENCE_CODE',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

export type ProcessOrderParams = {
  field?: InputMaybe<ProcessOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Process */
export type ProcessPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProcessOrderParams>>;
};

/** A Process Subscription */
export type ProcessSubscription = {
  __typename?: 'ProcessSubscription';
  data: Maybe<Process>;
  latestVersion: Maybe<Version>;
  transactionType: Maybe<TransactionTypeEnum>;
};

/** A Processor */
export type Processor = {
  __typename?: 'Processor';
  concurrencyLimit: Maybe<Scalars['Int']['output']>;
  defaultAction: Maybe<ProcessorActionTypeEnum>;
  description: Maybe<Scalars['String']['output']>;
  icon: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  isAi: Scalars['Boolean']['output'];
  isReady: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  output: Maybe<Array<ProcessorOutputTypeEnum>>;
  processorUrl: Maybe<Scalars['String']['output']>;
  targetEntities: Maybe<Array<AgentEntityTypeEnum>>;
  updatedAt: Scalars['DateTime']['output'];
};

/** The Processor action type enum */
export enum ProcessorActionTypeEnum {
  /** Post in Teams */
  PostInTeams = 'POST_IN_TEAMS',
  /** Send email */
  SendEmail = 'SEND_EMAIL',
  /** Set insights */
  SetInsights = 'SET_INSIGHTS',
  /** Update tracking */
  UpdateTracking = 'UPDATE_TRACKING',
  /** Upload document */
  UploadDocument = 'UPLOAD_DOCUMENT',
  /** Upsert orders */
  UpsertOrders = 'UPSERT_ORDERS',
  /** Upsert processes */
  UpsertProcesses = 'UPSERT_PROCESSES',
  /** Upsert products */
  UpsertProducts = 'UPSERT_PRODUCTS'
}

/** The Processor output type enum */
export enum ProcessorOutputTypeEnum {
  /** Documents */
  Documents = 'DOCUMENTS',
  /** Insights */
  Insights = 'INSIGHTS',
  /** Orders */
  Orders = 'ORDERS',
  /** Processes */
  Processes = 'PROCESSES'
}

/** A Product */
export type Product = {
  __typename?: 'Product';
  actor: Actor;
  additionalDetails: Maybe<Scalars['String']['output']>;
  c9Ratio: Maybe<Scalars['Decimal']['output']>;
  category: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  contentCapacity: Maybe<Scalars['Decimal']['output']>;
  contentCode: Maybe<Scalars['String']['output']>;
  contentMeasurementUnit: Maybe<MeasurementUnitEnum>;
  contentPerPallet: Maybe<Scalars['Decimal']['output']>;
  contentType: Maybe<MeasurementUnitEnum>;
  country: Maybe<Country>;
  cubagePerPackage: Maybe<Scalars['Decimal']['output']>;
  description: Scalars['String']['output'];
  dumping: Maybe<Scalars['Boolean']['output']>;
  extra: Maybe<Scalars['JSON']['output']>;
  family: Maybe<Scalars['String']['output']>;
  grossWeightPerPackage: Maybe<Scalars['Decimal']['output']>;
  hasContainerization: Maybe<Scalars['Boolean']['output']>;
  hasContent: Maybe<Scalars['Boolean']['output']>;
  hasPalletization: Maybe<Scalars['Boolean']['output']>;
  hasUnitization: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  internalCodes: Array<ProductInternalCode>;
  lastSyncErrorMessage: Maybe<Scalars['String']['output']>;
  manufacturer: Maybe<Scalars['String']['output']>;
  mercosulCode: Maybe<Scalars['String']['output']>;
  multipleCode: Maybe<Scalars['String']['output']>;
  multiplePackageCapacity: Maybe<Scalars['Decimal']['output']>;
  multiplePackageMeasurementUnit: Maybe<MeasurementUnitEnum>;
  multiplePackagePerContainerFt20: Maybe<Scalars['Int']['output']>;
  multiplePackagePerContainerFt40: Maybe<Scalars['Int']['output']>;
  multiplePackagePerPallet: Maybe<Scalars['Decimal']['output']>;
  multiplePackageType: Maybe<MeasurementUnitEnum>;
  netWeightPerPackage: Maybe<Scalars['Decimal']['output']>;
  packageCapacity: Maybe<Scalars['Decimal']['output']>;
  packageCode: Maybe<Scalars['String']['output']>;
  packageMeasurementUnit: Maybe<MeasurementUnitEnum>;
  packageType: Maybe<MeasurementUnitEnum>;
  packagesPerContainerFt20: Maybe<Scalars['Int']['output']>;
  packagesPerContainerFt40: Maybe<Scalars['Int']['output']>;
  packagesPerPallet: Maybe<Scalars['Int']['output']>;
  palletsPerContainerFt20: Maybe<Scalars['Int']['output']>;
  palletsPerContainerFt40: Maybe<Scalars['Int']['output']>;
  productForeignOperators: Array<Actor>;
  siscomexLastSyncType: Maybe<SiscomexSyncTypeEnum>;
  siscomexProduct: Maybe<SiscomexProduct>;
  siscomexStatusResponse: Maybe<SiscomexStatusResponseEnum>;
  translatedDescription: Maybe<Scalars['String']['output']>;
  translatedDescriptions: Maybe<Scalars['JSON']['output']>;
};

/** A Product Internal Code */
export type ProductInternalCode = {
  __typename?: 'ProductInternalCode';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  product: Maybe<Product>;
};

/** The Product Order By Enum */
export enum ProductOrderByEnum {
  /** Razão C9 */
  C9Ratio = 'C9_RATIO',
  /** Categoria */
  Category = 'CATEGORY',
  /** Código */
  Code = 'CODE',
  /** Conteúdo - Capacidade da Embalagem */
  ContentCapacity = 'CONTENT_CAPACITY',
  /** Conteúdo - Código da Embalagem */
  ContentCode = 'CONTENT_CODE',
  /** Conteúdo - Unidade */
  ContentMeasurementUnit = 'CONTENT_MEASUREMENT_UNIT',
  /** Conteúdo - Tipo de Embalagem */
  ContentType = 'CONTENT_TYPE',
  /** Cubagem por Embalagem (m³) */
  CubagePerPackage = 'CUBAGE_PER_PACKAGE',
  /** Descrição */
  Description = 'DESCRIPTION',
  /** Família */
  Family = 'FAMILY',
  /** Peso Bruto por Embalagem (kg) */
  GrossWeightPerPackage = 'GROSS_WEIGHT_PER_PACKAGE',
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Fabricante */
  Manufacturer = 'MANUFACTURER',
  /** Código do MERCOSUL */
  MercosulCode = 'MERCOSUL_CODE',
  /** Unitização - Código da Embalagem */
  MultipleCode = 'MULTIPLE_CODE',
  /** Unitização - Capacidade da Embalagem */
  MultiplePackageCapacity = 'MULTIPLE_PACKAGE_CAPACITY',
  /** Unitização - Unidade */
  MultiplePackageMeasurementUnit = 'MULTIPLE_PACKAGE_MEASUREMENT_UNIT',
  /** Embalagens Unitizadas por Container de 20’ */
  MultiplePackagePerContainerFt20 = 'MULTIPLE_PACKAGE_PER_CONTAINER_FT20',
  /** Embalagens Unitizadas por Container de 40’ */
  MultiplePackagePerContainerFt40 = 'MULTIPLE_PACKAGE_PER_CONTAINER_FT40',
  /** Unitização - Tipo de Embalagem */
  MultiplePackageType = 'MULTIPLE_PACKAGE_TYPE',
  /** Peso Líquido por Embalagem (kg) */
  NetWeightPerPackage = 'NET_WEIGHT_PER_PACKAGE',
  /** Embalagens por Container de 20’ */
  PackagesPerContainerFt20 = 'PACKAGES_PER_CONTAINER_FT20',
  /** Embalagens por Container de 40’ */
  PackagesPerContainerFt40 = 'PACKAGES_PER_CONTAINER_FT40',
  /** Embalagens por Pallet */
  PackagesPerPallet = 'PACKAGES_PER_PALLET',
  /** Capacidade da Embalagem */
  PackageCapacity = 'PACKAGE_CAPACITY',
  /** Código da Embalagem */
  PackageCode = 'PACKAGE_CODE',
  /** Unidade */
  PackageMeasurementUnit = 'PACKAGE_MEASUREMENT_UNIT',
  /** Tipo de Embalagem */
  PackageType = 'PACKAGE_TYPE',
  /** Pallets por Container de 20’ */
  PalletsPerContainerFt20 = 'PALLETS_PER_CONTAINER_FT20',
  /** Pallets por Container de 40’ */
  PalletsPerContainerFt40 = 'PALLETS_PER_CONTAINER_FT40',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

export type ProductOrderParams = {
  field?: InputMaybe<ProductOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Products */
export type ProductPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductOrderParams>>;
};

/** A Product per Process */
export type ProductPerProcess = {
  __typename?: 'ProductPerProcess';
  process: Process;
  product: Product;
};

/** Result of a Product Siscomex sync subscription */
export type ProductSiscomexSyncSubscriptionData = {
  __typename?: 'ProductSiscomexSyncSubscriptionData';
  data: Product;
};

/** A production line count */
export type ProductionLineCount = {
  __typename?: 'ProductionLineCount';
  count: Scalars['Int']['output'];
  productionLine: ProductionLineEnum;
};

/** The Production Line Enum */
export enum ProductionLineEnum {
  /** Ônibus */
  Bus = 'BUS',
  /** POS */
  Pos = 'POS',
  /** Caminhão */
  Truck = 'TRUCK'
}

/** A Purchase Order */
export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  id: Scalars['Int']['output'];
  items: Array<PurchaseOrderItem>;
  necessityDate: Maybe<Scalars['DateTime']['output']>;
  order: Order;
  supplierExpectedReadinessAt: Maybe<Scalars['DateTime']['output']>;
  supplierOrderAcceptedAt: Maybe<Scalars['DateTime']['output']>;
  supplierOrderSentAt: Maybe<Scalars['DateTime']['output']>;
  supplierReadinessAt: Maybe<Scalars['DateTime']['output']>;
  type: OrderTransactionTypeEnum;
};

/** A Purchase Order Item */
export type PurchaseOrderItem = {
  __typename?: 'PurchaseOrderItem';
  adjustedCustomsRegisterLeadTime: Maybe<Scalars['Int']['output']>;
  adjustedCustomsReleaseLeadTime: Maybe<Scalars['Int']['output']>;
  adjustedFactoryDeliveryLeadTime: Maybe<Scalars['Int']['output']>;
  adjustedShipmentBoardingLeadTime: Maybe<Scalars['Int']['output']>;
  adjustedShipmentTransportLeadTime: Maybe<Scalars['Int']['output']>;
  adjustedSupplierReadyLeadTimeDays: Maybe<Scalars['Int']['output']>;
  assessmentSotd: Maybe<Scalars['String']['output']>;
  balance: Maybe<Scalars['Decimal']['output']>;
  balanceShipped: Maybe<Scalars['Decimal']['output']>;
  cofinsTaxRate: Maybe<Scalars['Decimal']['output']>;
  concessionAct: Maybe<Scalars['String']['output']>;
  cubageCubicMeters: Maybe<Scalars['Decimal']['output']>;
  customsEstimatedRegisterAt: Maybe<Scalars['DateTime']['output']>;
  customsEstimatedReleaseAt: Maybe<Scalars['DateTime']['output']>;
  customsRegisterLeadTime: Maybe<Scalars['Int']['output']>;
  customsReleaseLeadTime: Maybe<Scalars['Int']['output']>;
  deliveryNote: Maybe<Scalars['String']['output']>;
  deliveryNoteIssuedAt: Maybe<Scalars['Date']['output']>;
  dispatchingCountry: Maybe<Country>;
  division: Maybe<Scalars['String']['output']>;
  factoryDeliveryAt: Maybe<Scalars['DateTime']['output']>;
  factoryDeliveryLeadTime: Maybe<Scalars['Int']['output']>;
  factoryEstimatedDeliveryAt: Maybe<Scalars['DateTime']['output']>;
  factoryPlannedDeliveryAt: Maybe<Scalars['DateTime']['output']>;
  foreignOperators: Array<Actor>;
  grossWeightKg: Maybe<Scalars['Decimal']['output']>;
  icmsTaxRate: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Int']['output'];
  iiTaxRate: Maybe<Scalars['Decimal']['output']>;
  importTypeSap: Maybe<Scalars['String']['output']>;
  invoiceIssuedAt: Maybe<Scalars['Date']['output']>;
  invoiceNumber: Maybe<Scalars['String']['output']>;
  invoiceType: Maybe<Scalars['String']['output']>;
  invoiceValue: Maybe<Scalars['Decimal']['output']>;
  ipiTaxRate: Maybe<Scalars['Decimal']['output']>;
  itemCalculations: Maybe<PurchaseOrderItemCalculations>;
  itemStatus: Maybe<Scalars['String']['output']>;
  lineNumber: Maybe<Scalars['Int']['output']>;
  lineReference: Scalars['String']['output'];
  manufacturingCountry: Maybe<Country>;
  measurementUnitSap: Maybe<Scalars['String']['output']>;
  netWeightKg: Maybe<Scalars['Decimal']['output']>;
  note: Maybe<Scalars['String']['output']>;
  order: Order;
  orderAdjustedModalType: Maybe<Scalars['String']['output']>;
  orderCurrency: Maybe<Currency>;
  orderItemReference: Maybe<Scalars['String']['output']>;
  orderModalTypeSap: Maybe<Scalars['String']['output']>;
  orderRequestNumber: Maybe<Scalars['String']['output']>;
  orderRequestedAt: Maybe<Scalars['DateTime']['output']>;
  orderTotalValue: Maybe<Scalars['Decimal']['output']>;
  orderUnitValue: Maybe<Scalars['Decimal']['output']>;
  /** @deprecated Use order_total_value */
  orderValue: Maybe<Scalars['Decimal']['output']>;
  palletGrouping: Maybe<Scalars['Decimal']['output']>;
  palletQuantity: Maybe<Scalars['Decimal']['output']>;
  pisTaxRate: Maybe<Scalars['Decimal']['output']>;
  planningRequestShippingAt: Maybe<Scalars['DateTime']['output']>;
  planningShippingAt: Maybe<Scalars['DateTime']['output']>;
  product: Product;
  productDescription: Maybe<Scalars['String']['output']>;
  productMercosulCode: Maybe<Scalars['String']['output']>;
  productTranslatedDescription: Maybe<Scalars['String']['output']>;
  productTranslatedDescriptions: Maybe<Scalars['JSON']['output']>;
  purchaseCountry: Maybe<Country>;
  purchaseOrder: PurchaseOrder;
  quantity: Maybe<Scalars['Decimal']['output']>;
  quotationOpeningDate: Maybe<Scalars['Date']['output']>;
  sapByFactor: Maybe<Scalars['Decimal']['output']>;
  shipmentBoardingLeadTime: Maybe<Scalars['Int']['output']>;
  shipmentContainersQuantity: Maybe<Scalars['Decimal']['output']>;
  shipmentEquipmentType: Maybe<Scalars['String']['output']>;
  shipmentEstimatedArrivalAt: Maybe<Scalars['DateTime']['output']>;
  shipmentEstimatedBoardingAt: Maybe<Scalars['DateTime']['output']>;
  shipmentPlannedArrivalAt: Maybe<Scalars['DateTime']['output']>;
  shipmentPlannedBoardingAt: Maybe<Scalars['DateTime']['output']>;
  shipmentTransportLeadTime: Maybe<Scalars['Int']['output']>;
  shippingDetailsDeliveryDate: Maybe<Scalars['Date']['output']>;
  specialTreatments: Maybe<SpecialTreatmentsTypeEnum>;
  supplierCalculatedReadyAt: Maybe<Scalars['DateTime']['output']>;
  supplierConfirmationAt: Maybe<Scalars['DateTime']['output']>;
  supplierEstimatedReadyAt: Maybe<Scalars['DateTime']['output']>;
  supplierPlannedReadyAt: Maybe<Scalars['DateTime']['output']>;
  supplierReadyAt: Maybe<Scalars['DateTime']['output']>;
  supplierReadyDeviation: Maybe<Scalars['Int']['output']>;
  supplierReadyLeadTimeDays: Maybe<Scalars['Int']['output']>;
  supplierSentAt: Maybe<Scalars['DateTime']['output']>;
};

/** A Purchase Order Item Calculations */
export type PurchaseOrderItemCalculations = {
  __typename?: 'PurchaseOrderItemCalculations';
  cubage: Maybe<Scalars['Decimal']['output']>;
  grossWeight: Maybe<Scalars['Decimal']['output']>;
  netWeight: Maybe<Scalars['Decimal']['output']>;
  palletQuantity: Maybe<Scalars['Decimal']['output']>;
};

/** A Quick Filter */
export type QuickFilter = {
  __typename?: 'QuickFilter';
  label: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  values: Array<QuickFilterValue>;
};

/** A Quick Filter Config */
export type QuickFilterConfig = {
  __typename?: 'QuickFilterConfig';
  label: Maybe<Scalars['JSON']['output']>;
  path: Scalars['String']['output'];
  position: Maybe<Scalars['Int']['output']>;
};

/** A Quick Filter Value */
export type QuickFilterValue = {
  __typename?: 'QuickFilterValue';
  label: Scalars['String']['output'];
  value: Scalars['JSON']['output'];
};

/** A Recurring agent config */
export type RecurringAgentConfig = {
  __typename?: 'RecurringAgentConfig';
  frequencyMinutes: Scalars['Int']['output'];
  inputType: RecurringAgentInputTypeEnum;
  operationsInputConfig: Maybe<RecurringOperationsInputConfig>;
};

/** Parameters for a recurring agent config */
export type RecurringAgentConfigParams = {
  frequencyMinutes: Scalars['Int']['input'];
  inputType: RecurringAgentInputTypeEnum;
  operationsInputConfig?: InputMaybe<RecurringOperationsInputConfigParams>;
};

/** The Recurring agent input type enum */
export enum RecurringAgentInputTypeEnum {
  /** External API */
  ExternalApi = 'EXTERNAL_API',
  /** Google Drive */
  GoogleDrive = 'GOOGLE_DRIVE',
  /** No input */
  NoInput = 'NO_INPUT',
  /** Operations */
  Operations = 'OPERATIONS',
  /** SharePoint */
  Sharepoint = 'SHAREPOINT'
}

/** A Recurring operations input config */
export type RecurringOperationsInputConfig = {
  __typename?: 'RecurringOperationsInputConfig';
  entity: AgentEntityTypeEnum;
  operationIds: Array<Scalars['Int']['output']>;
  relatedEntities: Maybe<Array<AgentRelatedEntityTypeEnum>>;
};

/** Parameters for a recurring operations input config */
export type RecurringOperationsInputConfigParams = {
  entity: AgentEntityTypeEnum;
  operationIds: Array<Scalars['Int']['input']>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  relatedEntities?: InputMaybe<Array<AgentRelatedEntityTypeEnum>>;
};

/** A Report */
export type Report = {
  __typename?: 'Report';
  columns: Maybe<Scalars['JSON']['output']>;
  filters: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  reportGroup: ReportGroup;
  sorting: Maybe<Scalars['JSON']['output']>;
};

/** A Report Group */
export type ReportGroup = {
  __typename?: 'ReportGroup';
  actor: Actor;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  operations: Array<Operation>;
  position: Scalars['Int']['output'];
  reference: ReportReferenceEnum;
  reportGroupAccess: ReportGroupAccess;
  reports: Array<Report>;
};

/** A Report Group Access */
export type ReportGroupAccess = {
  __typename?: 'ReportGroupAccess';
  accessGroup: AccessGroup;
  id: Scalars['Int']['output'];
  reportGroup: ReportGroup;
  type: AccessEnum;
};

/** The possible references a Report Group can have */
export enum ReportReferenceEnum {
  /** Container */
  Container = 'CONTAINER',
  /** Declaração de Exportação (DUE) */
  ExportDeclaration = 'EXPORT_DECLARATION',
  /** Licença de Exportação (DI) */
  ImportDeclaration = 'IMPORT_DECLARATION',
  /** Licença de Importação (LI) */
  ImportLicense = 'IMPORT_LICENSE',
  /** Item de Invoice */
  InvoiceItem = 'INVOICE_ITEM',
  /** Etapas do Lead Time */
  LeadTimeStages = 'LEAD_TIME_STAGES',
  /** Viagem de Transporte Rodoviário Nacional */
  NationalRoadTransportTrip = 'NATIONAL_ROAD_TRANSPORT_TRIP',
  /** Pedido */
  Order = 'ORDER',
  /** Item do Pedido */
  OrderItem = 'ORDER_ITEM',
  /** Item do Pedido com Item do Processo */
  OrderItemWithShipmentItem = 'ORDER_ITEM_WITH_SHIPMENT_ITEM',
  /** Processo */
  Process = 'PROCESS',
  /** Custos do Processo */
  ProcessCosts = 'PROCESS_COSTS',
  /** Item do Processo */
  ShipmentItem = 'SHIPMENT_ITEM',
  /** Item do Processo com Item do Pedido */
  ShipmentItemWithOrderItem = 'SHIPMENT_ITEM_WITH_ORDER_ITEM'
}

/** A Report Request */
export type ReportRequest = {
  __typename?: 'ReportRequest';
  columns: Maybe<Scalars['JSON']['output']>;
  datetimeFormat: Maybe<Scalars['String']['output']>;
  fileUrl: Maybe<Scalars['String']['output']>;
  filterAccess: Maybe<Scalars['JSON']['output']>;
  filters: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  language: Maybe<Scalars['String']['output']>;
  orderFilters: Maybe<Scalars['JSON']['output']>;
  pathFilters: Maybe<Scalars['JSON']['output']>;
  processFilters: Maybe<Scalars['JSON']['output']>;
  report: Maybe<Report>;
  reportId: Scalars['Int']['output'];
  search: Maybe<Scalars['String']['output']>;
  status: ReportRequestStatusEnum;
  timezone: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

/** The Report Request Order By Enum */
export enum ReportRequestOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT'
}

/** Available parameters to sort Report Request */
export type ReportRequestOrderParams = {
  field?: InputMaybe<ReportRequestOrderByEnum>;
  order?: InputMaybe<SimpleSortingOrderEnum>;
};

/** The Request Status Enum */
export enum ReportRequestStatusEnum {
  /** Concluído */
  Completed = 'COMPLETED',
  /** Falhou */
  Failed = 'FAILED',
  /** Processando */
  Processing = 'PROCESSING',
  /** Requisitado */
  Requested = 'REQUESTED'
}

/** Available parameters to paginate Report Request */
export type ReportRequestsPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReportRequestOrderParams>>;
};

/** A Road Transport Order */
export type RoadTransportOrder = {
  __typename?: 'RoadTransportOrder';
  bl: Maybe<Scalars['String']['output']>;
  booking: Maybe<Scalars['String']['output']>;
  cargoDeadline: Maybe<Scalars['DateTime']['output']>;
  destinationCountry: Maybe<Scalars['String']['output']>;
  diOrDta: Maybe<Scalars['String']['output']>;
  draftDeadline: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  importer: Maybe<Scalars['String']['output']>;
  observations: Maybe<Scalars['String']['output']>;
  order: Order;
  port: Maybe<Scalars['String']['output']>;
  releasedForTransport: Maybe<Scalars['DateTime']['output']>;
  roadTransportShipments: Array<RoadTransportShipment>;
  schedulingFinishedAt: Maybe<Scalars['DateTime']['output']>;
  sealine: Maybe<Sealine>;
  storageExpiration: Maybe<Scalars['DateTime']['output']>;
  tradeType: OriginTypeEnum;
  transportSpecifications: Array<TransportSpecificationEnum>;
  transportables: Array<Transportable>;
  type: RoadTransportOrderTypeEnum;
  vessel: Maybe<Scalars['String']['output']>;
  voyage: Maybe<Scalars['String']['output']>;
};

/** The Road Transport Order Type Enum */
export enum RoadTransportOrderTypeEnum {
  /** FCL */
  Fcl = 'FCL',
  /** LCL */
  Lcl = 'LCL'
}

/** A Road Transport Shipment */
export type RoadTransportShipment = {
  __typename?: 'RoadTransportShipment';
  arrivalInTerminalScheduledDate: Maybe<Scalars['DateTime']['output']>;
  boardingPermit: Maybe<Scalars['String']['output']>;
  clientArrivalAt: Maybe<Scalars['DateTime']['output']>;
  clientDepartureAt: Maybe<Scalars['DateTime']['output']>;
  emptyContainerReturnScheduledDate: Maybe<Scalars['DateTime']['output']>;
  endAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  invoiceExchangeEndAt: Maybe<Scalars['DateTime']['output']>;
  invoiceExchangeStartAt: Maybe<Scalars['DateTime']['output']>;
  isActive: Scalars['Boolean']['output'];
  roadTransportOrder: RoadTransportOrder;
  shipmentDrivers: Array<RoadTransportShipmentDriver>;
  shipmentTrailers: Array<ShipmentTrailer>;
  startAt: Maybe<Scalars['DateTime']['output']>;
  transportables: Array<Transportable>;
  vehicle: Maybe<Vehicle>;
};

/** A Road Transport Shipment Driver */
export type RoadTransportShipmentDriver = {
  __typename?: 'RoadTransportShipmentDriver';
  amountPaidInAdvance: Maybe<Scalars['Decimal']['output']>;
  ciot: Maybe<Scalars['String']['output']>;
  driver: Driver;
  id: Scalars['Int']['output'];
  isFullyPaid: Scalars['Boolean']['output'];
  missingAmount: Maybe<Scalars['Decimal']['output']>;
  roadTransportShipment: RoadTransportShipment;
  totalAmountToPay: Maybe<Scalars['Decimal']['output']>;
};

/** A Road Transport Trip */
export type RoadTransportTrip = {
  __typename?: 'RoadTransportTrip';
  driver: Maybe<Driver>;
  driverName: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  nationalRoadTransport: NationalRoadTransport;
  phases: Array<RoadTransportTripPhase>;
  position: Scalars['Int']['output'];
  trailer: Maybe<Trailer>;
  trailerPlate: Maybe<Scalars['String']['output']>;
  transportables: Array<Transportable>;
  vehicle: Maybe<Vehicle>;
  vehiclePlate: Maybe<Scalars['String']['output']>;
};


/** A Road Transport Trip */
export type RoadTransportTripTransportablesArgs = {
  containerHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The Road Transport Trip Order By Enum */
export enum RoadTransportTripOrderByEnum {
  /** Nome do Motorista */
  DriverName = 'DRIVER_NAME',
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Placa da Carreta */
  TrailerPlate = 'TRAILER_PLATE',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT',
  /** Placa do Veículo */
  VehiclePlate = 'VEHICLE_PLATE'
}

export type RoadTransportTripOrderParams = {
  field?: InputMaybe<RoadTransportTripOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Road Transport Trip */
export type RoadTransportTripPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoadTransportTripOrderParams>>;
};

/** A National Road Transport Trip per Process */
export type RoadTransportTripPerProcess = {
  __typename?: 'RoadTransportTripPerProcess';
  process: Process;
  roadTransportTrip: RoadTransportTrip;
};

/** A Road Transport Trip Phase */
export type RoadTransportTripPhase = {
  __typename?: 'RoadTransportTripPhase';
  departureAt: Maybe<Scalars['DateTime']['output']>;
  estimatedRealizedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  realizedAt: Maybe<Scalars['DateTime']['output']>;
  roadTransportTrip: RoadTransportTrip;
  routePoint: RoutePoint;
};

/** The Road Transport Type Enum */
export enum RoadTransportTypeEnum {
  /** Bulk Cargo */
  BulkCargo = 'BULK_CARGO',
  /** Full Container Load */
  Fcl = 'FCL',
  /** Full Truckload */
  Ftl = 'FTL',
  /** Less than Truckload */
  Ltl = 'LTL'
}

/** A Role */
export type Role = {
  __typename?: 'Role';
  accessGroup: Maybe<AccessGroup>;
  id: Scalars['Int']['output'];
  partnership: Partnership;
  role: OperationHandlerEnum;
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /** Handles a agent execution callback from the processor */
  agentExecutionCallback: Maybe<AgentExecutionDetail>;
  /** Approve audit for an Order */
  approveOrderAudit: Maybe<Order>;
  /** Approve audit for a Process */
  approveProcessAudit: Maybe<Process>;
  /** Batch Update Processes */
  batchUpdateProcesses: Maybe<Scalars['Boolean']['output']>;
  /** Cancels the Process' open booking quotation and notifies the invited freight agents */
  cancelBookingQuotation: Maybe<BookingQuotation>;
  /** Cancel or un-cancel an Order */
  cancelOrUncancelOrder: Maybe<Order>;
  /** Cancel or un-cancel an Order by Reference Code - Rest API */
  cancelOrUncancelOrderByReferenceCode: Maybe<Order>;
  /** Cancel or un-cancel an Order - Rest API */
  cancelOrUncancelOrderByRestApi: Maybe<Order>;
  /** Cancel or un-cancel a Process */
  cancelOrUncancelProcess: Maybe<Process>;
  /** Cancel or un-cancel a Process by Reference Code - REST API */
  cancelOrUncancelProcessByReferenceCode: Maybe<Process>;
  /** Cancel or un-cancel a Process - REST API */
  cancelOrUncancelProcessByRestApi: Maybe<Process>;
  /** Close a cost */
  closeCost: Maybe<Process>;
  /** Close a cost by Rest API */
  closeCostByRestApi: Maybe<Process>;
  /** Complete registration a user */
  completeRegistration: Maybe<User>;
  /** Create an Address */
  createAddress: Maybe<Address>;
  /** Creates a Agent */
  createAgent: Maybe<Agent>;
  /** Create an Automation */
  createAutomation: Maybe<Automation>;
  /** Create a Client */
  createClient: Maybe<Client>;
  /** Create a Credential */
  createCredential: Maybe<Credential>;
  /** Create a Driver */
  createDriver: Maybe<Driver>;
  /** Create a Lead Time Model */
  createLeadTimeModel: Maybe<LeadTimeModel>;
  /** Create a Measurement */
  createMeasurement: Maybe<Measurement>;
  /** Create a Notification Group */
  createNotificationGroup: Maybe<NotificationGroup>;
  /** Create a Notification Group Recipient */
  createNotificationGroupRecipient: Maybe<NotificationGroupRecipient>;
  /** Create an Operation */
  createOperation: Maybe<Operation>;
  /** Create or Invite a user */
  createOrInviteUser: Maybe<User>;
  /** Create an Order */
  createOrder: Maybe<Order>;
  /** Create an Order - Rest API */
  createOrderByRestApi: Maybe<Order>;
  /** Create a partnership */
  createPartnership: Maybe<Partnership>;
  /** Create a Planned Lead Time */
  createPlannedLeadTime: Maybe<PlannedLeadTime>;
  /** Create a Process */
  createProcess: Maybe<Process>;
  /** Create a Process - REST API */
  createProcessByRestApi: Maybe<Process>;
  /** Create a Product */
  createProduct: Maybe<Product>;
  /** Create a Report */
  createReport: Maybe<Report>;
  /** Create a Report Group */
  createReportGroup: Maybe<ReportGroup>;
  /** Create a Report Request */
  createReportRequest: Maybe<ReportRequest>;
  /** Create a Route */
  createRoute: Maybe<Route>;
  /** Create a Trailer */
  createTrailer: Maybe<Trailer>;
  /** Create a Vehicle */
  createVehicle: Maybe<Vehicle>;
  /** Create a Warehouse Order */
  createWarehouseOrder: Maybe<WarehouseOrder>;
  /** Defines the winner proposal of the closed booking quotation and notifies the freight agents with submitted proposals */
  defineBookingQuotationWinner: Maybe<BookingQuotation>;
  /** Delete an Address */
  deleteAddress: Maybe<Address>;
  /** Delete an Automation */
  deleteAutomation: Maybe<Automation>;
  /** Delete a Credential */
  deleteCredential: Maybe<Credential>;
  /** Delete documents from process */
  deleteDocumentsFromProcess: Maybe<Document>;
  /** Delete documents from process by Reference Code */
  deleteDocumentsFromProcessByReferenceCode: Maybe<Document>;
  /** Delete a Driver */
  deleteDriver: Maybe<Driver>;
  /** Delete a Dynamic Table Data - REST API */
  deleteDynamicTableDataByRestApi: Maybe<DynamicTableData>;
  /** Delete a Lead Time Model */
  deleteLeadTimeModel: Maybe<LeadTimeModel>;
  /** Delete a Notification Group */
  deleteNotificationGroup: Maybe<NotificationGroup>;
  /** Delete a Notification Group Recipient */
  deleteNotificationGroupRecipient: Maybe<NotificationGroupRecipient>;
  /** Delete an Operation */
  deleteOperation: Maybe<Operation>;
  /** Delete or Remove a user from workspace */
  deleteOrRemoveUserFromWorkspace: Maybe<User>;
  /** Delete an Order */
  deleteOrder: Maybe<Order>;
  /** Delete an Order by Reference Code - Rest API */
  deleteOrderByReferenceCode: Maybe<Order>;
  /** Delete an Order - Rest API */
  deleteOrderByRestApi: Maybe<Order>;
  /** Delete a partnership */
  deletePartnership: Maybe<Partnership>;
  /** Delete a Planned Lead Time */
  deletePlannedLeadTime: Maybe<PlannedLeadTime>;
  /** Delete a Process */
  deleteProcess: Maybe<Process>;
  /** Delete a Process by Reference Code - REST API */
  deleteProcessByReferenceCode: Maybe<Process>;
  /** Delete a Process - REST API */
  deleteProcessByRestApi: Maybe<Process>;
  /** Delete a Product */
  deleteProduct: Maybe<Product>;
  deleteProductByCode: Maybe<Product>;
  /** Delete a Report */
  deleteReport: Maybe<Report>;
  /** Delete a Report Group */
  deleteReportGroup: Maybe<ReportGroup>;
  /** Delete a Route */
  deleteRoute: Maybe<Route>;
  /** Delete a Trailer */
  deleteTrailer: Maybe<Trailer>;
  /** Delete a Vehicle */
  deleteVehicle: Maybe<Vehicle>;
  /** Duplicate a Cost Model - REST API */
  duplicateCostModelByRestApi: CostModel;
  /** Executes the midea action */
  executeMideaAction: Maybe<MideaResponse>;
  /** Export items to XLSX */
  exportItemsToXlsx: Maybe<File>;
  /** Export packages to XLSX */
  exportPackagesToXlsx: Maybe<File>;
  /** Finish or Unfinish a order */
  finishOrUnfinishOrder: Maybe<Order>;
  /** Finish or Unfinish a process */
  finishOrUnfinishProcess: Maybe<Process>;
  /** Finish an Order by Reference Code - Rest API */
  finishOrderByReferenceCode: Maybe<Order>;
  /** Finish an Order - Rest API */
  finishOrderByRestApi: Maybe<Order>;
  /** Finish a Process by Reference Code - REST API */
  finishProcessByReferenceCode: Maybe<Process>;
  /** Finish a Process - REST API */
  finishProcessByRestApi: Maybe<Process>;
  /** Finish the scheduling of the road transport order */
  finishScheduling: Maybe<RoadTransportOrder>;
  /** Insert All HAWB Shipment Data */
  insertAllHawbShipmentDataByRestApi: Array<HawbShipmentData>;
  /** Reopen a cost */
  reopenCost: Maybe<Process>;
  /** Reopen a cost by Rest API */
  reopenCostByRestApi: Maybe<Process>;
  /** Resends the invites of the Process' booking data page to the winning freight agent */
  resendBookingDataInvites: Maybe<ExternalPagePublication>;
  /** Restore an Order */
  restoreOrder: Maybe<Order>;
  /** Restore a Process */
  restoreProcess: Maybe<Process>;
  /** Retries a dev agent execution */
  retryAgentTest: Maybe<AgentExecutionDetail>;
  /** Creates a dev agent execution for testing */
  runAgentTest: Maybe<AgentExecutionDetail>;
  /** Sends the Process' booking quotation draft to the selected freight agents */
  sendBookingQuotation: Maybe<BookingQuotation>;
  /** Record a user's lifecycle feedback on an insight (resolve / dismiss / reopen) */
  setInsightFeedback: Insight;
  syncMideaActiveProcessesWithSap: Maybe<AcceptedResult>;
  /** Trigger the auditor agent configured on the process' operation */
  triggerAuditAgent: ProcessAuditorStatus;
  /** Trigger manual Siscomex sync for a CE Mercante, scoped by ForeignTradeShipment */
  triggerCeMercanteSync: Maybe<SyncTriggerResult>;
  /** Trigger manual Siscomex sync for a DUIMP, scoped by ShipmentDuimp */
  triggerDuimpSync: Maybe<SyncTriggerResult>;
  /** Trigger manual Siscomex sync for a DUE, scoped by ShipmentExportDeclaration */
  triggerExportDeclarationSync: Maybe<SyncTriggerResult>;
  /** Trigger manual Siscomex sync for a DI, scoped by ShipmentImportDeclaration */
  triggerImportDeclarationSync: Maybe<SyncTriggerResult>;
  /** Trigger manual Siscomex sync for a LI, scoped by ShipmentImportLicense */
  triggerImportLicenseSync: Maybe<SyncTriggerResult>;
  /** Trigger manual Siscomex sync for a LPCO */
  triggerLpcoSync: Maybe<SyncTriggerResult>;
  /** Trigger manual Siscomex sync for a specific Product */
  triggerProductSync: Maybe<SyncTriggerResult>;
  /** Unfinish an Order by Reference Code - Rest API */
  unfinishOrderByReferenceCode: Maybe<Order>;
  /** Unfinish an Order - Rest API */
  unfinishOrderByRestApi: Maybe<Order>;
  /** Unfinish a Process by Reference Code - REST API */
  unfinishProcessByReferenceCode: Maybe<Process>;
  /** Unfinish a Process - REST API */
  unfinishProcessByRestApi: Maybe<Process>;
  /** Update an Actor */
  updateActor: Maybe<Actor>;
  /** Update an Address */
  updateAddress: Maybe<Address>;
  /** Update an Automation */
  updateAutomation: Maybe<Automation>;
  /** Update a Client */
  updateClient: Maybe<Client>;
  /** Update a Credential */
  updateCredential: Maybe<Credential>;
  /** Update a document */
  updateDocument: Maybe<Document>;
  /** Update a Driver */
  updateDriver: Maybe<Driver>;
  /** Update a Lead Time Model */
  updateLeadTimeModel: Maybe<LeadTimeModel>;
  /** Update a Measurement */
  updateMeasurement: Maybe<Measurement>;
  /** Update a Notification Group */
  updateNotificationGroup: Maybe<NotificationGroup>;
  /** Update a Notification Group Recipient */
  updateNotificationGroupRecipient: Maybe<NotificationGroupRecipient>;
  /** Update an Operation */
  updateOperation: Maybe<Operation>;
  /** Update an Order */
  updateOrder: Maybe<Order>;
  /** Update an Order by Reference Code - Rest API */
  updateOrderByReferenceCode: Maybe<Order>;
  /** Update an Order - Rest API */
  updateOrderByRestApi: Maybe<Order>;
  /** Update a partnership */
  updatePartnership: Maybe<Partnership>;
  /** Update a Planned Lead Time */
  updatePlannedLeadTime: Maybe<PlannedLeadTime>;
  /** Update a Process */
  updateProcess: Maybe<Process>;
  /** Update a Process by Reference Code - REST API */
  updateProcessByReferenceCode: Maybe<Process>;
  /** Update a Process - REST API */
  updateProcessByRestApi: Maybe<Process>;
  /** Update a Product */
  updateProduct: Maybe<Product>;
  updateProductByCode: Maybe<Product>;
  /** Update a Purchase Order Item - Rest API */
  updatePurchaseOrderItemByRestApi: Maybe<PurchaseOrderItem>;
  /** Update a Report */
  updateReport: Maybe<Report>;
  /** Update a Report Group */
  updateReportGroup: Maybe<ReportGroup>;
  /** Update a Route */
  updateRoute: Maybe<Route>;
  /** Update a Sales Order Item - Rest API */
  updateSalesOrderItemByRestApi: Maybe<SalesOrderItem>;
  /** Update a Trailer */
  updateTrailer: Maybe<Trailer>;
  updateUser: Maybe<User>;
  /** Update a user preference */
  updateUserPreference: Maybe<User>;
  /** Update a Vehicle */
  updateVehicle: Maybe<Vehicle>;
  /** Upload documents to an order */
  uploadDocumentsToOrder: Array<Document>;
  /** Upload documents to a process */
  uploadDocumentsToProcess: Array<Document>;
  /** Upsert a Cost Model Expense - REST API */
  upsertCostModelExpenseByRestApi: CostModelExpense;
  /** Upsert a Cost per Expense */
  upsertCostPerExpense: Maybe<CostPerExpense>;
  /** Upsert a Cost per Expense - REST API */
  upsertCostPerExpenseByRestApi: Array<CostPerExpense>;
  /** Upserts Drivers */
  upsertDrivers: Array<Driver>;
  /** Upsert a Dynamic Table Data - REST API */
  upsertDynamicTableDataByRestApi: Array<DynamicTableData>;
  /** Upsert a Order - Rest API */
  upsertOrdersByRestApi: Array<Order>;
  /** Create or update a partnership */
  upsertPartnership: Maybe<Partnership>;
  /** Create or update a partnership */
  upsertPartnershipOverwriteRoles: Maybe<Partnership>;
  /** Upsert Port Schedules */
  upsertPortSchedulesByRestApi: Array<PortSchedule>;
  /** Upsert Port Terminal Schedules */
  upsertPortTerminalSchedulesByRestApi: Array<PortTerminalSchedule>;
  /** Upsert a Process - REST API */
  upsertProcessesByRestApi: Array<Process>;
  /** Upserts Products based on code and description as owners */
  upsertProducts: Array<Product>;
  /** Upserts Trailers */
  upsertTrailers: Array<Trailer>;
  /** Upserts Vehicles */
  upsertVehicles: Array<Vehicle>;
  /** Upsert Vessels */
  upsertVesselsByRestApi: Array<Vessel>;
};


export type RootMutationTypeAgentExecutionCallbackArgs = {
  id: Scalars['ID']['input'];
  params: AgentExecutionCallbackParams;
};


export type RootMutationTypeApproveOrderAuditArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeApproveProcessAuditArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeBatchUpdateProcessesArgs = {
  params: UpdateProcessParams;
  processIds: Array<Scalars['Int']['input']>;
};


export type RootMutationTypeCancelBookingQuotationArgs = {
  params?: InputMaybe<CancelBookingQuotationParams>;
  processId: Scalars['Int']['input'];
};


export type RootMutationTypeCancelOrUncancelOrderArgs = {
  cancelled: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};


export type RootMutationTypeCancelOrUncancelOrderByReferenceCodeArgs = {
  cancelled: Scalars['Boolean']['input'];
  operationId: Scalars['Int']['input'];
  referenceCode: Scalars['String']['input'];
};


export type RootMutationTypeCancelOrUncancelOrderByRestApiArgs = {
  cancelled: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  operationId: Scalars['Int']['input'];
};


export type RootMutationTypeCancelOrUncancelProcessArgs = {
  cancelled: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};


export type RootMutationTypeCancelOrUncancelProcessByReferenceCodeArgs = {
  cancelled: Scalars['Boolean']['input'];
  operationId: Scalars['Int']['input'];
  referenceCode: Scalars['String']['input'];
};


export type RootMutationTypeCancelOrUncancelProcessByRestApiArgs = {
  cancelled: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  operationId: Scalars['Int']['input'];
};


export type RootMutationTypeCloseCostArgs = {
  processId: Scalars['Int']['input'];
};


export type RootMutationTypeCloseCostByRestApiArgs = {
  operationId: Scalars['Int']['input'];
  processId: Scalars['Int']['input'];
};


export type RootMutationTypeCompleteRegistrationArgs = {
  params: CompleteRegistrationParams;
};


export type RootMutationTypeCreateAddressArgs = {
  params: CreateAddressParams;
};


export type RootMutationTypeCreateAgentArgs = {
  params: CreateAgentParams;
};


export type RootMutationTypeCreateAutomationArgs = {
  params: CreateAutomationParams;
};


export type RootMutationTypeCreateClientArgs = {
  params: CreateClientParams;
};


export type RootMutationTypeCreateCredentialArgs = {
  params: CreateCredentialParams;
};


export type RootMutationTypeCreateDriverArgs = {
  params: CreateDriverParams;
};


export type RootMutationTypeCreateLeadTimeModelArgs = {
  params: CreateLeadTimeModelParams;
};


export type RootMutationTypeCreateMeasurementArgs = {
  params: CreateMeasurementParams;
  warehouseId: Scalars['Int']['input'];
};


export type RootMutationTypeCreateNotificationGroupArgs = {
  params: CreateNotificationGroupParams;
};


export type RootMutationTypeCreateNotificationGroupRecipientArgs = {
  params: CreateNotificationGroupRecipientParams;
};


export type RootMutationTypeCreateOperationArgs = {
  params: CreateOperationParams;
};


export type RootMutationTypeCreateOrInviteUserArgs = {
  params: CreateUserParams;
};


export type RootMutationTypeCreateOrderArgs = {
  params: CreateOrderParams;
};


export type RootMutationTypeCreateOrderByRestApiArgs = {
  operationId: Scalars['Int']['input'];
  params: CreateOrderParamsByRestApi;
};


export type RootMutationTypeCreatePartnershipArgs = {
  params: CreatePartnershipParams;
};


export type RootMutationTypeCreatePlannedLeadTimeArgs = {
  params: CreatePlannedLeadTimeParams;
};


export type RootMutationTypeCreateProcessArgs = {
  params: CreateProcessParams;
};


export type RootMutationTypeCreateProcessByRestApiArgs = {
  operationId: Scalars['Int']['input'];
  params: CreateProcessParamsByRestApi;
};


export type RootMutationTypeCreateProductArgs = {
  params: CreateProductParams;
};


export type RootMutationTypeCreateReportArgs = {
  params: CreateReportParams;
};


export type RootMutationTypeCreateReportGroupArgs = {
  params: CreateReportGroupParams;
};


export type RootMutationTypeCreateReportRequestArgs = {
  params: CreateReportRequestParams;
};


export type RootMutationTypeCreateRouteArgs = {
  params: CreateRouteParams;
};


export type RootMutationTypeCreateTrailerArgs = {
  params: CreateTrailerParams;
};


export type RootMutationTypeCreateVehicleArgs = {
  params: CreateVehicleParams;
};


export type RootMutationTypeCreateWarehouseOrderArgs = {
  params: CreateWarehouseOrderParams;
  warehouseId: Scalars['Int']['input'];
};


export type RootMutationTypeDefineBookingQuotationWinnerArgs = {
  params?: InputMaybe<DefineBookingQuotationWinnerParams>;
  proposalId: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteAddressArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteAutomationArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteCredentialArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteDocumentsFromProcessArgs = {
  id: Scalars['Int']['input'];
  operationId: Scalars['Int']['input'];
  processId: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteDocumentsFromProcessByReferenceCodeArgs = {
  id: Scalars['Int']['input'];
  operationId: Scalars['Int']['input'];
  referenceCode: Scalars['String']['input'];
};


export type RootMutationTypeDeleteDriverArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteDynamicTableDataByRestApiArgs = {
  dynamicTableDefinitionId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteLeadTimeModelArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteNotificationGroupArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteNotificationGroupRecipientArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteOperationArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteOrRemoveUserFromWorkspaceArgs = {
  id: Scalars['String']['input'];
};


export type RootMutationTypeDeleteOrderArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteOrderByReferenceCodeArgs = {
  operationId: Scalars['Int']['input'];
  referenceCode: Scalars['String']['input'];
};


export type RootMutationTypeDeleteOrderByRestApiArgs = {
  id: Scalars['Int']['input'];
  operationId: Scalars['Int']['input'];
};


export type RootMutationTypeDeletePartnershipArgs = {
  actorId: Scalars['Int']['input'];
};


export type RootMutationTypeDeletePlannedLeadTimeArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteProcessArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteProcessByReferenceCodeArgs = {
  operationId: Scalars['Int']['input'];
  referenceCode: Scalars['String']['input'];
};


export type RootMutationTypeDeleteProcessByRestApiArgs = {
  id: Scalars['Int']['input'];
  operationId: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteProductArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteProductByCodeArgs = {
  code: Scalars['String']['input'];
};


export type RootMutationTypeDeleteReportArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteReportGroupArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteRouteArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteTrailerArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteVehicleArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeDuplicateCostModelByRestApiArgs = {
  costModelId: Scalars['Int']['input'];
};


export type RootMutationTypeExecuteMideaActionArgs = {
  action: ActionType;
  operationId: Scalars['Int']['input'];
  orderParams?: InputMaybe<MideaOrderParams>;
  processParams?: InputMaybe<MideaProcessParams>;
  referenceCode: Scalars['String']['input'];
  type: EntityType;
};


export type RootMutationTypeExportItemsToXlsxArgs = {
  type: WarehouseOrderTypeEnum;
  warehouseOrderId: Scalars['Int']['input'];
};


export type RootMutationTypeExportPackagesToXlsxArgs = {
  measurementId: Scalars['Int']['input'];
};


export type RootMutationTypeFinishOrUnfinishOrderArgs = {
  finished: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};


export type RootMutationTypeFinishOrUnfinishProcessArgs = {
  finished: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};


export type RootMutationTypeFinishOrderByReferenceCodeArgs = {
  operationId: Scalars['Int']['input'];
  referenceCode: Scalars['String']['input'];
};


export type RootMutationTypeFinishOrderByRestApiArgs = {
  id: Scalars['Int']['input'];
  operationId: Scalars['Int']['input'];
};


export type RootMutationTypeFinishProcessByReferenceCodeArgs = {
  operationId: Scalars['Int']['input'];
  referenceCode: Scalars['String']['input'];
};


export type RootMutationTypeFinishProcessByRestApiArgs = {
  id: Scalars['Int']['input'];
  operationId: Scalars['Int']['input'];
};


export type RootMutationTypeFinishSchedulingArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeInsertAllHawbShipmentDataByRestApiArgs = {
  params: Array<InsertAllHawbShipmentDataParams>;
};


export type RootMutationTypeReopenCostArgs = {
  processId: Scalars['Int']['input'];
};


export type RootMutationTypeReopenCostByRestApiArgs = {
  operationId: Scalars['Int']['input'];
  processId: Scalars['Int']['input'];
};


export type RootMutationTypeResendBookingDataInvitesArgs = {
  processId: Scalars['Int']['input'];
};


export type RootMutationTypeRestoreOrderArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeRestoreProcessArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeRetryAgentTestArgs = {
  agentExecutionId: Scalars['ID']['input'];
};


export type RootMutationTypeRunAgentTestArgs = {
  params: RunAgentTestParams;
};


export type RootMutationTypeSendBookingQuotationArgs = {
  processId: Scalars['Int']['input'];
};


export type RootMutationTypeSetInsightFeedbackArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  dismissReason?: InputMaybe<InsightDismissReasonEnum>;
  insightId: Scalars['Int']['input'];
  status: InsightStatusEnum;
};


export type RootMutationTypeSyncMideaActiveProcessesWithSapArgs = {
  operationIds: Array<Scalars['Int']['input']>;
};


export type RootMutationTypeTriggerAuditAgentArgs = {
  processId: Scalars['Int']['input'];
};


export type RootMutationTypeTriggerCeMercanteSyncArgs = {
  foreignTradeShipmentId: Scalars['Int']['input'];
};


export type RootMutationTypeTriggerDuimpSyncArgs = {
  shipmentDuimpId: Scalars['Int']['input'];
};


export type RootMutationTypeTriggerExportDeclarationSyncArgs = {
  shipmentExportDeclarationId: Scalars['Int']['input'];
};


export type RootMutationTypeTriggerImportDeclarationSyncArgs = {
  shipmentImportDeclarationId: Scalars['Int']['input'];
};


export type RootMutationTypeTriggerImportLicenseSyncArgs = {
  shipmentImportLicenseId: Scalars['Int']['input'];
};


export type RootMutationTypeTriggerLpcoSyncArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeTriggerProductSyncArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeUnfinishOrderByReferenceCodeArgs = {
  operationId: Scalars['Int']['input'];
  referenceCode: Scalars['String']['input'];
};


export type RootMutationTypeUnfinishOrderByRestApiArgs = {
  id: Scalars['Int']['input'];
  operationId: Scalars['Int']['input'];
};


export type RootMutationTypeUnfinishProcessByReferenceCodeArgs = {
  operationId: Scalars['Int']['input'];
  referenceCode: Scalars['String']['input'];
};


export type RootMutationTypeUnfinishProcessByRestApiArgs = {
  id: Scalars['Int']['input'];
  operationId: Scalars['Int']['input'];
};


export type RootMutationTypeUpdateActorArgs = {
  id: Scalars['Int']['input'];
  params: UpdateActorParams;
};


export type RootMutationTypeUpdateAddressArgs = {
  id: Scalars['Int']['input'];
  params: UpdateAddressParams;
};


export type RootMutationTypeUpdateAutomationArgs = {
  id: Scalars['Int']['input'];
  params: UpdateAutomationParams;
};


export type RootMutationTypeUpdateClientArgs = {
  id: Scalars['Int']['input'];
  params: UpdateClientParams;
};


export type RootMutationTypeUpdateCredentialArgs = {
  id: Scalars['Int']['input'];
  params: UpdateCredentialParams;
};


export type RootMutationTypeUpdateDocumentArgs = {
  id: Scalars['Int']['input'];
  params: UpdateDocumentParams;
};


export type RootMutationTypeUpdateDriverArgs = {
  id: Scalars['Int']['input'];
  params: UpdateDriverParams;
};


export type RootMutationTypeUpdateLeadTimeModelArgs = {
  id: Scalars['Int']['input'];
  params: UpdateLeadTimeModelParams;
};


export type RootMutationTypeUpdateMeasurementArgs = {
  id: Scalars['Int']['input'];
  params: CreateMeasurementParams;
  warehouseId: Scalars['Int']['input'];
};


export type RootMutationTypeUpdateNotificationGroupArgs = {
  id: Scalars['Int']['input'];
  params: UpdateNotificationGroupParams;
};


export type RootMutationTypeUpdateNotificationGroupRecipientArgs = {
  id: Scalars['Int']['input'];
  params: UpdateNotificationGroupRecipientParams;
};


export type RootMutationTypeUpdateOperationArgs = {
  id: Scalars['Int']['input'];
  params: UpdateOperationParams;
};


export type RootMutationTypeUpdateOrderArgs = {
  id: Scalars['Int']['input'];
  params: UpdateOrderParams;
};


export type RootMutationTypeUpdateOrderByReferenceCodeArgs = {
  operationId: Scalars['Int']['input'];
  params: UpdateOrderParams;
  referenceCode: Scalars['String']['input'];
};


export type RootMutationTypeUpdateOrderByRestApiArgs = {
  id: Scalars['Int']['input'];
  operationId: Scalars['Int']['input'];
  params: UpdateOrderParams;
};


export type RootMutationTypeUpdatePartnershipArgs = {
  params: UpdatePartnershipParams;
  partnerId: Scalars['Int']['input'];
};


export type RootMutationTypeUpdatePlannedLeadTimeArgs = {
  id: Scalars['Int']['input'];
  params: UpdatePlannedLeadTimeParams;
};


export type RootMutationTypeUpdateProcessArgs = {
  id: Scalars['Int']['input'];
  params: UpdateProcessParams;
};


export type RootMutationTypeUpdateProcessByReferenceCodeArgs = {
  operationId: Scalars['Int']['input'];
  params: UpdateProcessParams;
  referenceCode: Scalars['String']['input'];
};


export type RootMutationTypeUpdateProcessByRestApiArgs = {
  id: Scalars['Int']['input'];
  operationId: Scalars['Int']['input'];
  params: UpdateProcessParamsByRestApi;
};


export type RootMutationTypeUpdateProductArgs = {
  id: Scalars['Int']['input'];
  params: UpdateProductParams;
};


export type RootMutationTypeUpdateProductByCodeArgs = {
  code: Scalars['String']['input'];
  params: UpdateProductParams;
};


export type RootMutationTypeUpdatePurchaseOrderItemByRestApiArgs = {
  lineReference: Scalars['String']['input'];
  operationId: Scalars['Int']['input'];
  params: NestedUpdatePurchaseOrderItemParams;
  referenceCode: Scalars['String']['input'];
};


export type RootMutationTypeUpdateReportArgs = {
  id: Scalars['Int']['input'];
  params: UpdateReportParams;
};


export type RootMutationTypeUpdateReportGroupArgs = {
  id: Scalars['Int']['input'];
  params: UpdateReportGroupParams;
};


export type RootMutationTypeUpdateRouteArgs = {
  id: Scalars['Int']['input'];
  params: UpdateRouteParams;
};


export type RootMutationTypeUpdateSalesOrderItemByRestApiArgs = {
  lineReference: Scalars['String']['input'];
  operationId: Scalars['Int']['input'];
  params: NestedUpdateSalesOrderItemParams;
  referenceCode: Scalars['String']['input'];
};


export type RootMutationTypeUpdateTrailerArgs = {
  id: Scalars['Int']['input'];
  params: UpdateTrailerParams;
};


export type RootMutationTypeUpdateUserArgs = {
  id: Scalars['String']['input'];
  params: UpdateUserParams;
};


export type RootMutationTypeUpdateUserPreferenceArgs = {
  params: UpdateUserPreferenceParams;
};


export type RootMutationTypeUpdateVehicleArgs = {
  id: Scalars['Int']['input'];
  params: UpdateVehicleParams;
};


export type RootMutationTypeUploadDocumentsToOrderArgs = {
  orderId: Scalars['Int']['input'];
  params: Array<CreateDocumentParams>;
};


export type RootMutationTypeUploadDocumentsToProcessArgs = {
  params: Array<CreateDocumentParams>;
  processId: Scalars['Int']['input'];
};


export type RootMutationTypeUpsertCostModelExpenseByRestApiArgs = {
  params: UpsertCostModelExpenseParamsByRestApi;
  versionId: Scalars['Int']['input'];
};


export type RootMutationTypeUpsertCostPerExpenseArgs = {
  params?: InputMaybe<CreateCostPerExpenseParams>;
};


export type RootMutationTypeUpsertCostPerExpenseByRestApiArgs = {
  operationId: Scalars['Int']['input'];
  params: Array<UpsertCostPerExpenseParamsByRestApi>;
  processId: Scalars['Int']['input'];
};


export type RootMutationTypeUpsertDriversArgs = {
  params: Array<UpsertDriverParams>;
};


export type RootMutationTypeUpsertDynamicTableDataByRestApiArgs = {
  dynamicTableDefinitionId: Scalars['Int']['input'];
  params: Array<UpsertDynamicTableDataParams>;
};


export type RootMutationTypeUpsertOrdersByRestApiArgs = {
  operationId: Scalars['Int']['input'];
  params: Array<UpsertOrderParams>;
};


export type RootMutationTypeUpsertPartnershipArgs = {
  params: CreatePartnershipParams;
};


export type RootMutationTypeUpsertPartnershipOverwriteRolesArgs = {
  params: CreatePartnershipParams;
};


export type RootMutationTypeUpsertPortSchedulesByRestApiArgs = {
  params: Array<UpdatePortScheduleParams>;
};


export type RootMutationTypeUpsertPortTerminalSchedulesByRestApiArgs = {
  params: Array<UpsertPortTerminalScheduleParams>;
};


export type RootMutationTypeUpsertProcessesByRestApiArgs = {
  operationId: Scalars['Int']['input'];
  params: Array<UpsertProcessParams>;
};


export type RootMutationTypeUpsertProductsArgs = {
  params: Array<CreateProductParams>;
};


export type RootMutationTypeUpsertTrailersArgs = {
  params: Array<UpsertTrailerParams>;
};


export type RootMutationTypeUpsertVehiclesArgs = {
  params: Array<UpsertVehicleParams>;
};


export type RootMutationTypeUpsertVesselsByRestApiArgs = {
  params: Array<UpdateVesselParams>;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /** Get an Access Group by ID */
  accessGroup: Maybe<AccessGroup>;
  /** Get a list of Access Groups */
  accessGroups: Array<AccessGroup>;
  /** Gets an Actor by ID */
  actor: Maybe<Actor>;
  /** Get a list with Actors with pagination and search */
  actors: Array<Actor>;
  /** Get the actors count with search */
  actorsCount: Maybe<Scalars['Int']['output']>;
  /** List the addresses */
  addresses: Array<Address>;
  /** Gets a Agent by ID */
  agent: Maybe<Agent>;
  /** Returns the map of entity types to their allowed related entity types */
  agentEntityRelatedEntitiesMap: Array<AgentEntityRelatedEntitiesMap>;
  /** Gets a Agent execution by ID (with full log detail) */
  agentExecution: Maybe<AgentExecutionDetail>;
  /** Lists Agent executions (without log fields) */
  agentExecutions: Array<AgentExecution>;
  /** Counts Agent executions */
  agentExecutionsCount: Scalars['Int']['output'];
  /** Lists Agents */
  agents: Array<Agent>;
  /** Counts Agents */
  agentsCount: Scalars['Int']['output'];
  /** Get a list with Cost Models with pagination and search */
  aggregatedCosts: Maybe<AggregatedCosts>;
  /** Get an Airline by ID */
  airline: Maybe<Airline>;
  /** Get a list of Airlines */
  airlines: Array<Airline>;
  /** Get the count of Airlines */
  airlinesCount: Scalars['Int']['output'];
  /** Get an Airport by ID */
  airport: Maybe<Airport>;
  /** Get a list of airports */
  airports: Array<Airport>;
  /** Get the count of airports */
  airportsCount: Scalars['Int']['output'];
  /** Get a list of API Keys */
  apiKeys: Array<ApiKey>;
  /** Get an API Request by ID */
  apiRequest: Maybe<ApiRequest>;
  /** Get a list of API Requests */
  apiRequests: Array<ApiRequest>;
  /** Get the count of API Requests */
  apiRequestsCount: Scalars['Int']['output'];
  /** Gets the application version */
  appVersion: Maybe<Scalars['String']['output']>;
  /** Gets an Automation by ID */
  automation: Maybe<Automation>;
  /** A proposal of a booking quotation, once it's closed */
  bookingProposal: BookingProposal;
  /** The freight agents that can be invited to the Process' booking quotation */
  bookingQuotationInvitableRecipients: Array<NotificationGroupRecipient>;
  /** The submitted proposals of the Process' booking quotation, once it's closed */
  bookingQuotationProposals: Array<BookingProposal>;
  /** Gets a Client by ID */
  client: Maybe<Client>;
  /** Get a list with Clients with pagination and search */
  clients: Array<Client>;
  /** Get the Clients count with search */
  clientsCount: Maybe<Scalars['Int']['output']>;
  /** Get containers per processes with pagination and search */
  containersPerProcesses: Array<ContainerPerProcess>;
  /** Get containers per processes count with search */
  containersPerProcessesCount: Scalars['Int']['output'];
  /** Get a Cost Model by ID */
  costModel: Maybe<CostModel>;
  costModelVersion: Maybe<CostModelVersion>;
  /** Get a list with Cost Models with pagination and search */
  costModels: Array<CostModel>;
  /** Get the Cost models count with search */
  costModelsCount: Scalars['Int']['output'];
  /** Get the Ship Owners count with search */
  countSealines: Maybe<Scalars['Int']['output']>;
  /** Get a list with Countries with pagination and search */
  countries: Array<Country>;
  /** Get the Countries count with search */
  countriesCount: Maybe<Scalars['Int']['output']>;
  /** Get a Courier by ID */
  courier: Maybe<Courier>;
  /** Get a list of couriers */
  couriers: Array<Courier>;
  /** Get the count of couriers */
  couriersCount: Scalars['Int']['output'];
  /** Gets a Credential by ID */
  credential: Maybe<Credential>;
  /** Get a list with credentials */
  credentials: Array<Credential>;
  /** Get a list with credentials for REST API */
  credentialsByRestApi: Array<Credential>;
  /** Get the credentials count with search */
  credentialsCount: Scalars['Int']['output'];
  /** Get a list with Currencies with pagination and search */
  currencies: Array<Currency>;
  /** Get the Currencies count with search */
  currenciesCount: Maybe<Scalars['Int']['output']>;
  /** Gets the user associated with the given token */
  currentUser: Maybe<User>;
  /** Get the current user Report Requests */
  currentUserReportRequests: Array<ReportRequest>;
  /** Gets a Driver by ID */
  driver: Maybe<Driver>;
  /** Get a list with Drivers with pagination and search */
  drivers: Array<Driver>;
  /** Get the Drivers count with search */
  driversCount: Maybe<Scalars['Int']['output']>;
  /** Get a paginated list of Dynamic Table Data from a Dynamic Table Definition - REST API */
  dynamicTableDataByRestApi: Array<DynamicTableData>;
  /** Get a Dynamic Table Definition by ID - REST API */
  dynamicTableDefinitionByRestApi: Maybe<DynamicTableDefinition>;
  /** Get a list of Dynamic Table Definitions - REST API */
  dynamicTableDefinitionsByRestApi: Array<DynamicTableDefinition>;
  /** Get an external dashboard URL to embed */
  externalDashboardUrl: Maybe<Scalars['String']['output']>;
  insights: Array<Insight>;
  /** Get invoice items per processes with pagination and search */
  invoiceItemsPerProcesses: Array<InvoiceItemPerProcess>;
  /** Get invoice items per processes count with search */
  invoiceItemsPerProcessesCount: Scalars['Int']['output'];
  /** Gets Available Quick Filters from Lead Time Aggregated By Planned Lead Time */
  leadTimeAggregatedAvailableQuickFilters: Array<QuickFilter>;
  /** Gets a Lead Time Model by ID */
  leadTimeModel: Maybe<LeadTimeModel>;
  /** Get a list with Lead Time Models with pagination and search */
  leadTimeModels: Array<LeadTimeModel>;
  /** Get the lead time models count with search */
  leadTimeModelsCount: Scalars['Int']['output'];
  /** Gets Lead Time Processes fields by Operation IDs */
  leadTimeProcessesFields: Array<Path>;
  /** Get a list with lead time stages per processes */
  leadTimeStagesPerProcesses: LeadTimeStagesPerProcessesResult;
  /** Gets a Lead Time Aggregated By Planned Lead Time */
  leadTimesAggregatedByPlanned: Array<LeadTimeAggregatedByPlanned>;
  /** Gets a Lead Time Aggregated By Product */
  leadTimesAggregatedByProduct: Array<LeadTimeAggregatedByProduct>;
  /** Gets a LPCO by ID */
  lpco: Maybe<Lpco>;
  /** Get the available LPCO quick filters */
  lpcoAvailableQuickFilters: Array<QuickFilter>;
  /** Gets a LPCO by ID - REST API */
  lpcoByRestApi: Maybe<Lpco>;
  /** Get the LPCOs totals */
  lpcoTotals: LpcoTotals;
  /** Get a list of LPCOs with pagination and search */
  lpcos: Array<Lpco>;
  /** Get the LPCOs count with search */
  lpcosCount: Maybe<Scalars['Int']['output']>;
  /** Get a Maritime Port by ID */
  maritimePort: Maybe<MaritimePort>;
  /** Get a list of maritime_ports */
  maritimePorts: Array<MaritimePort>;
  /** Get the count of maritime_ports */
  maritimePortsCount: Scalars['Int']['output'];
  /** Gets a Measurement by ID */
  measurement: Maybe<Measurement>;
  /** Get national road transport trips per processes with pagination and search */
  nationalRoadTransportTripsPerProcesses: Array<RoadTransportTripPerProcess>;
  /** Get national road transport trips per processes count with search */
  nationalRoadTransportTripsPerProcessesCount: Maybe<Scalars['Int']['output']>;
  /** Get a Notification Group by ID */
  notificationGroup: Maybe<NotificationGroup>;
  /** Get a list of Notification Group Recipients */
  notificationGroupRecipients: Array<NotificationGroupRecipient>;
  /** Get a list of Notification Groups with search, filters and pagination */
  notificationGroups: Array<NotificationGroup>;
  /** Get the Notification Groups count */
  notificationGroupsCount: Scalars['Int']['output'];
  /** Get an Open API JSON spec for the specified API Key in the context of the Operation */
  openApiSpec: Scalars['JSON']['output'];
  /** Gets an Operation by ID */
  operation: Maybe<Operation>;
  /** Gets an Operation Phase by ID */
  operationPhase: Maybe<OperationPhase>;
  /** Get a list with operations */
  operations: Array<Operation>;
  /** Get the operations count with search */
  operationsCount: Maybe<Scalars['Int']['output']>;
  /** Gets an Order by ID */
  order: Maybe<Order>;
  /** Gets an Order by Reference Code and Operation ID - Rest API */
  orderByReferenceCode: Maybe<Order>;
  /** Gets an Order by ID and Operation ID - Rest API */
  orderByRestApi: Maybe<Order>;
  /** Get order items with pagination and search */
  orderItems: Array<OrderItem>;
  /** Get order items count with search */
  orderItemsCount: Scalars['Int']['output'];
  /** Get order items with shipment items with pagination and search */
  orderItemsWithShipmentItems: Array<OrderItemWithShipmentItem>;
  /** Get order items with shipment items count with search */
  orderItemsWithShipmentItemsCount: Scalars['Int']['output'];
  /** Get a list of Orders with pagination and search */
  orders: Array<Order>;
  /** Get Orders count with search */
  ordersCount: Scalars['Int']['output'];
  /** Lists the standard pallet sizes, ordered by position */
  palletStandards: Array<PalletStandard>;
  /** List partnerships */
  partnerships: Array<Partnership>;
  /** Gets a Planned Lead Time by ID */
  plannedLeadTime: Maybe<PlannedLeadTime>;
  /** Get a list with Planned Lead Times with pagination and search */
  plannedLeadTimes: Array<PlannedLeadTime>;
  /** Get the planned lead times count with search */
  plannedLeadTimesCount: Scalars['Int']['output'];
  /** Get a list of Port Schedules */
  portSchedules: Array<PortSchedule>;
  /** Get the count of Port Schedules */
  portSchedulesCount: Scalars['Int']['output'];
  /** Get a list of Port Terminal Schedules */
  portTerminalSchedules: Array<PortTerminalSchedule>;
  /** Get the count of Port Schedules */
  portTerminalSchedulesCount: Scalars['Int']['output'];
  /** Get a list of port_terminals */
  portTerminals: Array<PortTerminal>;
  /** Get the count of port_terminals */
  portTerminalsCount: Scalars['Int']['output'];
  /** Gets a Process by ID */
  process: Maybe<Process>;
  /** Auditor agent state for a process */
  processAuditorStatus: ProcessAuditorStatus;
  /** Gets a Process by Reference Code and Operation ID - REST API */
  processByReferenceCode: Maybe<Process>;
  /** Gets a Process by ID and Operation ID - REST API */
  processByRestApi: Maybe<Process>;
  /** Get a list with processes */
  processes: Array<Process>;
  /** Get the processes count with search */
  processesCount: Scalars['Int']['output'];
  /** Lists all Processors */
  processors: Array<Processor>;
  /** Gets a Product by ID */
  product: Maybe<Product>;
  productByCode: Maybe<Product>;
  /** Get a list with all product categories */
  productCategories: Array<Scalars['String']['output']>;
  /** Get a list with all product families */
  productFamilies: Array<Scalars['String']['output']>;
  /** Get a list with all product manufacturers */
  productManufacturers: Array<Scalars['String']['output']>;
  /** Get a list of Products with pagination and search */
  products: Array<Product>;
  /** Get the Products count with search */
  productsCount: Maybe<Scalars['Int']['output']>;
  /**
   * Get products per processes with pagination and search
   * @deprecated Use new query itemsPerProcesses
   */
  productsPerProcesses: Array<ProductPerProcess>;
  /**
   * Get products per processes count with search
   * @deprecated Use new query itemsPerProcessesCount
   */
  productsPerProcessesCount: Maybe<Scalars['Int']['output']>;
  /** Get a Report Group by ID */
  reportGroup: Maybe<ReportGroup>;
  /** Get a list of Report Groups */
  reportGroups: Array<ReportGroup>;
  /** Gets an Route by ID */
  route: Maybe<Route>;
  /** List of routes */
  routes: Array<Route>;
  /** Count the routes */
  routesCount: Maybe<Scalars['Int']['output']>;
  /** Gets a Ship Order by ID */
  sealine: Maybe<Sealine>;
  /** Get a list with Ship Owners */
  sealines: Array<Sealine>;
  /** Get shipment DUIMP per processes with pagination and search */
  shipmentDuimpsPerProcesses: Array<ShipmentDuimpPerProcess>;
  /** Get shipment DUIMP per processes count with search */
  shipmentDuimpsPerProcessesCount: Scalars['Int']['output'];
  /** Get shipment import declarations per processes with pagination and search */
  shipmentExportDeclarationsPerProcesses: Array<ShipmentExportDeclarationPerProcess>;
  /** Get shipment import declarations per processes count with search */
  shipmentExportDeclarationsPerProcessesCount: Scalars['Int']['output'];
  /** Get shipment import declarations per processes with pagination and search */
  shipmentImportDeclarationsPerProcesses: Array<ShipmentImportDeclarationPerProcess>;
  /** Get shipment import declarations per processes count with search */
  shipmentImportDeclarationsPerProcessesCount: Scalars['Int']['output'];
  /** Get shipment import licenses per processes with pagination and search */
  shipmentImportLicensesPerProcesses: Array<ShipmentImportLicensePerProcess>;
  /** Get shipment import licenses per processes count with search */
  shipmentImportLicensesPerProcessesCount: Scalars['Int']['output'];
  /** Get items per processes with pagination and search */
  shipmentItems: Array<ShipmentItem>;
  /** Get items per processes count with search */
  shipmentItemsCount: Maybe<Scalars['Int']['output']>;
  /** Get shipment items with order items with pagination and search */
  shipmentItemsWithOrderItems: Array<ShipmentItemWithOrderItem>;
  /** Get shipment items with order items count with search */
  shipmentItemsWithOrderItemsCount: Scalars['Int']['output'];
  /** Downloads a Siscomex document */
  siscomexDocumentDownload: SiscomexDocumentDownload;
  /** Gets a Trailer by ID */
  trailer: Maybe<Trailer>;
  /** Get a list with Trailers with pagination and search */
  trailers: Array<Trailer>;
  /** Get the Trailers count with search */
  trailersCount: Maybe<Scalars['Int']['output']>;
  /** Get a list with users */
  usersTable: Maybe<UsersResponse>;
  /** Gets a Vehicle by ID */
  vehicle: Maybe<Vehicle>;
  /** Get a list with Vehicles with pagination and search */
  vehicles: Array<Vehicle>;
  /** Get the Vehicle count with search */
  vehiclesCount: Maybe<Scalars['Int']['output']>;
  /** Get a Vessel by ID */
  vessel: Maybe<Vessel>;
  /** Get a Vessel by MMSI */
  vesselByMmsi: Maybe<Vessel>;
  /** Get a list of Vessels */
  vessels: Array<Vessel>;
  /** Get the count of Vessels */
  vesselsCount: Scalars['Int']['output'];
  /** Gets a Warehouse by ID */
  warehouse: Maybe<Warehouse>;
  /** Get a Warehouse Order by ID */
  warehouseOrder: Maybe<WarehouseOrder>;
  /** Get a list with Warehouses */
  warehouses: Array<Warehouse>;
};


export type RootQueryTypeAccessGroupArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeActorArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeActorsArgs = {
  filters?: InputMaybe<FilterActorsParams>;
  pagination?: InputMaybe<ActorPaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeActorsCountArgs = {
  filters?: InputMaybe<FilterActorsParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeAddressesArgs = {
  filters?: InputMaybe<FilterAddressesParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeAgentArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeAgentExecutionArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeAgentExecutionsArgs = {
  filters?: InputMaybe<FilterAgentExecutionParams>;
  pagination?: InputMaybe<AgentExecutionPaginationParams>;
};


export type RootQueryTypeAgentExecutionsCountArgs = {
  filters?: InputMaybe<FilterAgentExecutionParams>;
};


export type RootQueryTypeAgentsArgs = {
  filters?: InputMaybe<FilterAgentParams>;
  pagination?: InputMaybe<AgentPaginationParams>;
};


export type RootQueryTypeAgentsCountArgs = {
  filters?: InputMaybe<FilterAgentParams>;
};


export type RootQueryTypeAggregatedCostsArgs = {
  costModelId: Scalars['Int']['input'];
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
};


export type RootQueryTypeAirlineArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeAirlinesArgs = {
  pagination?: InputMaybe<PaginationAirlineParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeAirlinesCountArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeAirportArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeAirportsArgs = {
  pagination?: InputMaybe<PaginationAirportParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeAirportsCountArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeApiRequestArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeApiRequestsArgs = {
  filters?: InputMaybe<FilterApiRequestParams>;
  pagination?: InputMaybe<PaginationApiRequestParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
};


export type RootQueryTypeApiRequestsCountArgs = {
  filters?: InputMaybe<FilterApiRequestParams>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
};


export type RootQueryTypeAutomationArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeBookingProposalArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeBookingQuotationInvitableRecipientsArgs = {
  processId: Scalars['Int']['input'];
};


export type RootQueryTypeBookingQuotationProposalsArgs = {
  partnershipId?: InputMaybe<Scalars['Int']['input']>;
  processId: Scalars['Int']['input'];
};


export type RootQueryTypeClientArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeClientsArgs = {
  pagination?: InputMaybe<ClientPaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeClientsCountArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeContainersPerProcessesArgs = {
  filters?: InputMaybe<FilterContainerParams>;
  pagination?: InputMaybe<ContainerPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeContainersPerProcessesCountArgs = {
  filters?: InputMaybe<FilterContainerParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeCostModelArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeCostModelVersionArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeCostModelsArgs = {
  filters?: InputMaybe<FilterCostModelParams>;
  pagination?: InputMaybe<CostModelPaginationParams>;
};


export type RootQueryTypeCostModelsCountArgs = {
  filters?: InputMaybe<FilterCostModelParams>;
};


export type RootQueryTypeCountSealinesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeCountriesArgs = {
  pagination?: InputMaybe<CountryPaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeCountriesCountArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeCourierArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeCouriersArgs = {
  pagination?: InputMaybe<PaginationCourierParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeCouriersCountArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeCredentialArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeCredentialsArgs = {
  filters?: InputMaybe<FilterCredentialParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeCredentialsByRestApiArgs = {
  filters?: InputMaybe<FilterCredentialParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeCredentialsCountArgs = {
  filters?: InputMaybe<FilterCredentialParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeCurrenciesArgs = {
  pagination?: InputMaybe<CurrencyPaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeCurrenciesCountArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeCurrentUserReportRequestsArgs = {
  pagination?: InputMaybe<ReportRequestsPaginationParams>;
};


export type RootQueryTypeDriverArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeDriversArgs = {
  pagination?: InputMaybe<DriverPaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeDriversCountArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeDynamicTableDataByRestApiArgs = {
  id: Scalars['Int']['input'];
  pagination?: InputMaybe<DynamicTableDataPaginationParams>;
};


export type RootQueryTypeDynamicTableDefinitionByRestApiArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeExternalDashboardUrlArgs = {
  dashboardId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeInsightsArgs = {
  filters?: InputMaybe<FilterInsightParams>;
};


export type RootQueryTypeInvoiceItemsPerProcessesArgs = {
  filters: FilterInvoiceItemParams;
  pagination?: InputMaybe<InvoiceItemPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeInvoiceItemsPerProcessesCountArgs = {
  filters: FilterInvoiceItemParams;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeLeadTimeAggregatedAvailableQuickFiltersArgs = {
  currentFilters?: InputMaybe<Scalars['JSON']['input']>;
  leadTimeModelId: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeLeadTimeModelArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeLeadTimeModelsArgs = {
  filters?: InputMaybe<FilterLeadTimeModelParams>;
  pagination?: InputMaybe<LeadTimeModelPaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeLeadTimeModelsCountArgs = {
  filters?: InputMaybe<FilterLeadTimeModelParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeLeadTimeProcessesFieldsArgs = {
  operationIds: Array<Scalars['Int']['input']>;
};


export type RootQueryTypeLeadTimeStagesPerProcessesArgs = {
  pagination?: InputMaybe<ProcessPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeLeadTimesAggregatedByPlannedArgs = {
  filters?: InputMaybe<FilterAggregatedLeadTimeParams>;
  leadTimeModelId: Scalars['Int']['input'];
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
};


export type RootQueryTypeLeadTimesAggregatedByProductArgs = {
  filters?: InputMaybe<FilterAggregatedLeadTimeParams>;
  leadTimeModelId: Scalars['Int']['input'];
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
};


export type RootQueryTypeLpcoArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeLpcoAvailableQuickFiltersArgs = {
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
};


export type RootQueryTypeLpcoByRestApiArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeLpcosArgs = {
  pagination?: InputMaybe<LpcoPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeLpcosCountArgs = {
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeMaritimePortArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeMaritimePortsArgs = {
  filters?: InputMaybe<FilterMaritimePortParams>;
  pagination?: InputMaybe<PaginationMaritimePortParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeMaritimePortsCountArgs = {
  filters?: InputMaybe<FilterMaritimePortParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeMeasurementArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeNationalRoadTransportTripsPerProcessesArgs = {
  filters?: InputMaybe<FilterRoadTransportTripParams>;
  pagination?: InputMaybe<RoadTransportTripPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeNationalRoadTransportTripsPerProcessesCountArgs = {
  filters?: InputMaybe<FilterRoadTransportTripParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeNotificationGroupArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeNotificationGroupRecipientsArgs = {
  filters?: InputMaybe<FilterNotificationGroupRecipientParams>;
};


export type RootQueryTypeNotificationGroupsArgs = {
  filters?: InputMaybe<FilterNotificationGroupParams>;
  pagination?: InputMaybe<NotificationGroupPaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeNotificationGroupsCountArgs = {
  filters?: InputMaybe<FilterNotificationGroupParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeOpenApiSpecArgs = {
  apiKeyId: Scalars['Int']['input'];
  operationId: Scalars['Int']['input'];
};


export type RootQueryTypeOperationArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeOperationPhaseArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeOperationsArgs = {
  filters?: InputMaybe<FilterOperationParams>;
  pagination?: InputMaybe<OperationPaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeOperationsCountArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeOrderArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeOrderByReferenceCodeArgs = {
  operationId: Scalars['Int']['input'];
  referenceCode: Scalars['String']['input'];
};


export type RootQueryTypeOrderByRestApiArgs = {
  id: Scalars['Int']['input'];
  operationId: Scalars['Int']['input'];
};


export type RootQueryTypeOrderItemsArgs = {
  filters: FilterOrderItemParams;
  orderFilters?: InputMaybe<FilterOrderParams>;
  pagination?: InputMaybe<OrderItemPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeOrderItemsCountArgs = {
  filters: FilterOrderItemParams;
  orderFilters?: InputMaybe<FilterOrderParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeOrderItemsWithShipmentItemsArgs = {
  filters: FilterOrderItemParams;
  orderFilters?: InputMaybe<FilterOrderParams>;
  pagination?: InputMaybe<OrderItemPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeOrderItemsWithShipmentItemsCountArgs = {
  filters: FilterOrderItemParams;
  orderFilters?: InputMaybe<FilterOrderParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeOrdersArgs = {
  filters?: InputMaybe<FilterOrderParams>;
  pagination?: InputMaybe<OrderPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeOrdersCountArgs = {
  filters?: InputMaybe<FilterOrderParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypePartnershipsArgs = {
  filters?: InputMaybe<FilterPartnershipsParams>;
  pagination?: InputMaybe<PartnershipPaginationParams>;
};


export type RootQueryTypePlannedLeadTimeArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypePlannedLeadTimesArgs = {
  filters: FilterPlannedLeadTimeParams;
  pagination?: InputMaybe<PlannedLeadTimePaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypePlannedLeadTimesCountArgs = {
  filters: FilterPlannedLeadTimeParams;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypePortSchedulesArgs = {
  filters: FilterPortScheduleParams;
  pagination?: InputMaybe<PaginationPortScheduleParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypePortSchedulesCountArgs = {
  filters: FilterPortScheduleParams;
};


export type RootQueryTypePortTerminalSchedulesArgs = {
  pagination?: InputMaybe<PaginationPortTerminalScheduleParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypePortTerminalSchedulesCountArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypePortTerminalsArgs = {
  filters?: InputMaybe<FilterPortTerminalParams>;
  pagination?: InputMaybe<PaginationPortTerminalParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypePortTerminalsCountArgs = {
  filters?: InputMaybe<FilterPortTerminalParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeProcessArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeProcessAuditorStatusArgs = {
  processId: Scalars['Int']['input'];
};


export type RootQueryTypeProcessByReferenceCodeArgs = {
  operationId: Scalars['Int']['input'];
  referenceCode: Scalars['String']['input'];
};


export type RootQueryTypeProcessByRestApiArgs = {
  id: Scalars['Int']['input'];
  operationId: Scalars['Int']['input'];
};


export type RootQueryTypeProcessesArgs = {
  filters?: InputMaybe<FilterProcessParams>;
  pagination?: InputMaybe<ProcessPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeProcessesCountArgs = {
  filters?: InputMaybe<FilterProcessParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeProductArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeProductByCodeArgs = {
  code: Scalars['String']['input'];
};


export type RootQueryTypeProductsArgs = {
  filters?: InputMaybe<FilterProductParams>;
  pagination?: InputMaybe<ProductPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeProductsCountArgs = {
  filters?: InputMaybe<FilterProductParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeProductsPerProcessesArgs = {
  filters?: InputMaybe<FilterProductParams>;
  pagination?: InputMaybe<ProductPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeProductsPerProcessesCountArgs = {
  filters?: InputMaybe<FilterProductParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeReportGroupArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeRouteArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeRoutesArgs = {
  filters?: InputMaybe<FilterRoutesParams>;
  pagination?: InputMaybe<RoutePaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeRoutesCountArgs = {
  filters?: InputMaybe<FilterRoutesParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeSealineArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeSealinesArgs = {
  pagination?: InputMaybe<SealinePaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeShipmentDuimpsPerProcessesArgs = {
  filters: FilterShipmentDuimpParams;
  pagination?: InputMaybe<ShipmentDuimpPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeShipmentDuimpsPerProcessesCountArgs = {
  filters: FilterShipmentDuimpParams;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeShipmentExportDeclarationsPerProcessesArgs = {
  filters: FilterShipmentExportDeclarationParams;
  pagination?: InputMaybe<ShipmentExportDeclarationPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeShipmentExportDeclarationsPerProcessesCountArgs = {
  filters: FilterShipmentExportDeclarationParams;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeShipmentImportDeclarationsPerProcessesArgs = {
  filters: FilterShipmentImportDeclarationParams;
  pagination?: InputMaybe<ShipmentImportDeclarationPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeShipmentImportDeclarationsPerProcessesCountArgs = {
  filters: FilterShipmentImportDeclarationParams;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeShipmentImportLicensesPerProcessesArgs = {
  filters: FilterShipmentImportLicenseParams;
  pagination?: InputMaybe<ShipmentImportLicensePaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeShipmentImportLicensesPerProcessesCountArgs = {
  filters: FilterShipmentImportLicenseParams;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeShipmentItemsArgs = {
  filters: FilterShipmentItemParams;
  pagination?: InputMaybe<ShipmentItemPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeShipmentItemsCountArgs = {
  filters: FilterShipmentItemParams;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeShipmentItemsWithOrderItemsArgs = {
  filters: FilterOrderItemParams;
  orderFilters?: InputMaybe<FilterOrderParams>;
  pagination?: InputMaybe<OrderItemPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeShipmentItemsWithOrderItemsCountArgs = {
  filters: FilterOrderItemParams;
  orderFilters?: InputMaybe<FilterOrderParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeSiscomexDocumentDownloadArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeTrailerArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeTrailersArgs = {
  pagination?: InputMaybe<TrailerPaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeTrailersCountArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeUsersTableArgs = {
  pagination?: InputMaybe<UserPaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeVehicleArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeVehiclesArgs = {
  pagination?: InputMaybe<VehiclePaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeVehiclesCountArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeVesselArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeVesselByMmsiArgs = {
  mmsi: Scalars['String']['input'];
};


export type RootQueryTypeVesselsArgs = {
  filters?: InputMaybe<FilterVesselParams>;
  pagination?: InputMaybe<PaginationVesselParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeVesselsCountArgs = {
  filters?: InputMaybe<FilterVesselParams>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeWarehouseArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeWarehouseOrderArgs = {
  id: Scalars['Int']['input'];
};

export type RootSubscriptionType = {
  __typename?: 'RootSubscriptionType';
  /** Subscription for CE Mercante Siscomex sync result */
  ceMercanteSyncSubscription: ForeignTradeShipmentCeMercanteSyncSubscriptionData;
  /** Subscription for DUIMP Siscomex sync result */
  duimpSyncSubscription: DuimpSyncSubscriptionData;
  /** Subscription for DUE Siscomex sync result */
  exportDeclarationSyncSubscription: ExportDeclarationSyncSubscriptionData;
  /** Subscription for DI Siscomex sync result */
  importDeclarationSyncSubscription: ImportDeclarationSyncSubscriptionData;
  /** Subscription for LI Siscomex sync result */
  importLicenseSyncSubscription: ImportLicenseSyncSubscriptionData;
  /** Subscription for LPCO Siscomex sync result */
  lpcoSyncSubscription: LpcoSyncSubscriptionData;
  /** Subscription for order */
  order: OrderSubscription;
  /** Subscription for orders */
  orders: Array<OrderSubscription>;
  /** Subscription for process */
  process: ProcessSubscription;
  /** Subscription for processes */
  processes: Array<ProcessSubscription>;
  /** Subscription for product Siscomex sync result */
  productSiscomexSyncSubscription: ProductSiscomexSyncSubscriptionData;
  /** Subscription for user notifications */
  userNotification: UserNotification;
};


export type RootSubscriptionTypeCeMercanteSyncSubscriptionArgs = {
  foreignTradeShipmentId: Scalars['Int']['input'];
};


export type RootSubscriptionTypeDuimpSyncSubscriptionArgs = {
  shipmentDuimpId: Scalars['Int']['input'];
};


export type RootSubscriptionTypeExportDeclarationSyncSubscriptionArgs = {
  shipmentExportDeclarationId: Scalars['Int']['input'];
};


export type RootSubscriptionTypeImportDeclarationSyncSubscriptionArgs = {
  shipmentImportDeclarationId: Scalars['Int']['input'];
};


export type RootSubscriptionTypeImportLicenseSyncSubscriptionArgs = {
  shipmentImportLicenseId: Scalars['Int']['input'];
};


export type RootSubscriptionTypeLpcoSyncSubscriptionArgs = {
  id: Scalars['Int']['input'];
};


export type RootSubscriptionTypeOrderArgs = {
  id: Scalars['Int']['input'];
};


export type RootSubscriptionTypeOrdersArgs = {
  operationId: Scalars['Int']['input'];
};


export type RootSubscriptionTypeProcessArgs = {
  id: Scalars['Int']['input'];
};


export type RootSubscriptionTypeProcessesArgs = {
  operationId: Scalars['Int']['input'];
};


export type RootSubscriptionTypeProductSiscomexSyncSubscriptionArgs = {
  id: Scalars['Int']['input'];
};

/** A Route */
export type Route = {
  __typename?: 'Route';
  active: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  points: Array<RoutePoint>;
};

/** The Route Order By Enum */
export enum RouteOrderByEnum {
  /** Ativo */
  Active = 'ACTIVE',
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Name */
  Name = 'NAME',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

export type RouteOrderParams = {
  field?: InputMaybe<RouteOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Routes */
export type RoutePaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RouteOrderParams>>;
};

/** A Route Point */
export type RoutePoint = {
  __typename?: 'RoutePoint';
  address: Maybe<Address>;
  id: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  routeType: RouteTypeEnum;
};

/** The Route Type Enum */
export enum RouteTypeEnum {
  /** Chegada na Fronteira */
  ArrivalAtTheBorder = 'ARRIVAL_AT_THE_BORDER',
  /** Disponibilidade Container Vazio */
  AvailabilityEmptyContainer = 'AVAILABILITY_EMPTY_CONTAINER',
  /** Nota Remessa Armazém */
  InvoiceExchange = 'INVOICE_EXCHANGE',
  /** Carregamento */
  Loading = 'LOADING',
  /** Carregamento Container Vazio */
  LoadingEmptyContainer = 'LOADING_EMPTY_CONTAINER',
  /** Carregamento Container Cheio */
  LoadingFullContainer = 'LOADING_FULL_CONTAINER',
  /** Devolução Container Vazio */
  ReturnEmptyContainer = 'RETURN_EMPTY_CONTAINER',
  /** Descarregamento */
  Unloading = 'UNLOADING',
  /** Descarregamento Container Vazio */
  UnloadingEmptyContainer = 'UNLOADING_EMPTY_CONTAINER',
  /** Descarregamento Container Cheio */
  UnloadingFullContainer = 'UNLOADING_FULL_CONTAINER',
  /** Coleta Container Vazio */
  WithdrawalEmptyContainer = 'WITHDRAWAL_EMPTY_CONTAINER'
}

export type Rule = {
  __typename?: 'Rule';
  analysis: Analysis;
  analysisSlug: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  impact: RuleImpactEnum;
  name: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};

/** The Rule Impact Enum */
export enum RuleImpactEnum {
  /** Alto */
  High = 'HIGH',
  /** Baixo */
  Low = 'LOW',
  /** Médio */
  Medium = 'MEDIUM'
}

export type RunAgentTestParams = {
  agentId: Scalars['ID']['input'];
  input?: InputMaybe<AgentTestInputParams>;
  runMode: AgentTestRunModeEnum;
  skipActions: Scalars['Boolean']['input'];
};

/** A Sales Order */
export type SalesOrder = {
  __typename?: 'SalesOrder';
  id: Scalars['Int']['output'];
  items: Array<SalesOrderItem>;
  order: Order;
  orderConfirmedAt: Maybe<Scalars['DateTime']['output']>;
  orderReceivedAt: Maybe<Scalars['DateTime']['output']>;
  type: OrderTransactionTypeEnum;
};

/** A Sales Order Item */
export type SalesOrderItem = {
  __typename?: 'SalesOrderItem';
  balance: Maybe<Scalars['Decimal']['output']>;
  balanceShipped: Maybe<Scalars['Decimal']['output']>;
  clientApprovedAt: Maybe<Scalars['DateTime']['output']>;
  cofinsTaxRate: Maybe<Scalars['Decimal']['output']>;
  cubageCubicMeters: Maybe<Scalars['Decimal']['output']>;
  dispatchNumber: Maybe<Scalars['String']['output']>;
  factoryDeliveryAt: Maybe<Scalars['DateTime']['output']>;
  factoryEstimatedDeliveryAt: Maybe<Scalars['DateTime']['output']>;
  grossWeightKg: Maybe<Scalars['Decimal']['output']>;
  icmsTaxRate: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Int']['output'];
  iiTaxRate: Maybe<Scalars['Decimal']['output']>;
  internalContainerReference: Maybe<Scalars['String']['output']>;
  ipiTaxRate: Maybe<Scalars['Decimal']['output']>;
  itemCalculations: Maybe<SalesOrderItemCalculations>;
  itemStatus: Maybe<Scalars['String']['output']>;
  lineNumber: Maybe<Scalars['Int']['output']>;
  lineReference: Scalars['String']['output'];
  measurementUnitSap: Maybe<Scalars['String']['output']>;
  necessityType: Maybe<Scalars['String']['output']>;
  netWeightKg: Maybe<Scalars['Decimal']['output']>;
  note: Maybe<Scalars['String']['output']>;
  order: Order;
  orderCurrency: Maybe<Currency>;
  orderItemReference: Maybe<Scalars['String']['output']>;
  orderRequestNumber: Maybe<Scalars['String']['output']>;
  orderTotalValue: Maybe<Scalars['Decimal']['output']>;
  orderUnitValue: Maybe<Scalars['Decimal']['output']>;
  /** @deprecated Use order_total_value */
  orderValue: Maybe<Scalars['Decimal']['output']>;
  palletGrouping: Maybe<Scalars['Decimal']['output']>;
  palletQuantity: Maybe<Scalars['Decimal']['output']>;
  pisTaxRate: Maybe<Scalars['Decimal']['output']>;
  preliminaryPickingStartedAt: Maybe<Scalars['DateTime']['output']>;
  product: Product;
  productDescription: Maybe<Scalars['String']['output']>;
  productMercosulCode: Maybe<Scalars['String']['output']>;
  productTranslatedDescription: Maybe<Scalars['String']['output']>;
  productTranslatedDescriptions: Maybe<Scalars['JSON']['output']>;
  quantity: Maybe<Scalars['Decimal']['output']>;
  reservedStockQuantity: Maybe<Scalars['Decimal']['output']>;
  salesOrder: SalesOrder;
  shipmentContainersQuantity: Maybe<Scalars['Decimal']['output']>;
  shipmentEquipmentType: Maybe<Scalars['String']['output']>;
  shipmentPlannedArrivalAt: Maybe<Scalars['DateTime']['output']>;
  shipmentPlannedBoardingAt: Maybe<Scalars['DateTime']['output']>;
  specialTreatments: Maybe<SpecialTreatmentsTypeEnum>;
  stockQuantity: Maybe<Scalars['Decimal']['output']>;
  stockReservationAt: Maybe<Scalars['DateTime']['output']>;
  supplierEstimatedReadyAt: Maybe<Scalars['DateTime']['output']>;
  supplierPlannedReadyAt: Maybe<Scalars['DateTime']['output']>;
  supplierReadyAt: Maybe<Scalars['DateTime']['output']>;
  supplierReadyDeviation: Maybe<Scalars['Int']['output']>;
  ubc: Maybe<Scalars['String']['output']>;
};

/** A Sales Order Item Calculations */
export type SalesOrderItemCalculations = {
  __typename?: 'SalesOrderItemCalculations';
  cubage: Maybe<Scalars['Decimal']['output']>;
  grossWeight: Maybe<Scalars['Decimal']['output']>;
  netWeight: Maybe<Scalars['Decimal']['output']>;
  palletQuantity: Maybe<Scalars['Decimal']['output']>;
};

/** A Sealine */
export type Sealine = {
  __typename?: 'Sealine';
  actor: Maybe<Actor>;
  id: Scalars['Int']['output'];
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
  scac: Scalars['String']['output'];
  website: Maybe<Scalars['String']['output']>;
};

/** The Sealine Order By Enum */
export enum SealineOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Nome */
  Name = 'NAME',
  /** Nickname */
  Nickname = 'NICKNAME',
  /** Código SCAC */
  Scac = 'SCAC',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT',
  /** URL do Website */
  Website = 'WEBSITE'
}

export type SealineOrderParams = {
  field?: InputMaybe<SealineOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** The Sealine Origin Enum */
export enum SealineOriginEnum {
  /** Manual */
  Manual = 'MANUAL',
  /** Tracking */
  Tracking = 'TRACKING'
}

/** Available parameters to paginate Ship Owners */
export type SealinePaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SealineOrderParams>>;
};

/** A Sealine Vessel Schedule */
export type SealineVesselSchedule = {
  __typename?: 'SealineVesselSchedule';
  cargoDeadline: Maybe<Scalars['DateTime']['output']>;
  draftDeadline: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  insertedAt: Maybe<Scalars['DateTime']['output']>;
  specialCargoDraftDeadline: Maybe<Scalars['DateTime']['output']>;
  vgmDeadline: Maybe<Scalars['DateTime']['output']>;
};

/** A user serpro response */
export type SerproResponse = {
  __typename?: 'SerproResponse';
  birthday: Maybe<Scalars['String']['output']>;
  code: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  situationCode: Maybe<Scalars['String']['output']>;
  situationDescription: Maybe<Scalars['String']['output']>;
};

/** Ship sub type enum */
export enum ShipSubTypeEnum {
  /** Transportador de Agregados */
  AggregatesCarrier = 'AGGREGATES_CARRIER',
  /** Transportador de Alumínio */
  AluminiumCarrier = 'ALUMINIUM_CARRIER',
  /** Transportador de Asfalto */
  BitumenCarrier = 'BITUMEN_CARRIER',
  /** Transportador de Cabu (Canola, Açu e Bunker) */
  CabuCarrier = 'CABU_CARRIER',
  /** Transportador de Dióxido de Carbono */
  CarbonDioxide = 'CARBON_DIOXIDE',
  /** Transportador de Automóveis */
  CarCarrier = 'CAR_CARRIER',
  /** Transportador de Cimento */
  CementCarrier = 'CEMENT_CARRIER',
  /** Carvão */
  Coal = 'COAL',
  /** Transportador de Combinação */
  CombinationCarrier = 'COMBINATION_CARRIER',
  /** Container */
  Container = 'CONTAINER',
  /** Transportador de Container a Granel */
  ContainerBulk = 'CONTAINER_BULK',
  /** Container Refrigerado */
  ContainerReefer = 'CONTAINER_REEFER',
  /** Carga de Convés */
  DeckCargo = 'DECK_CARGO',
  /** Carga a Granel Seca */
  DryBulk = 'DRY_BULK',
  /** Navio-Tanque de Efluentes */
  EffluentTanker = 'EFFLUENT_TANKER',
  /** Pesca */
  Fishing = 'FISHING',
  /** Transportador de Peixes */
  FishCarrier = 'FISH_CARRIER',
  /** Navio-Tanque Geral */
  GeneralTanker = 'GENERAL_TANKER',
  /** Grandes Lagos */
  GreatLakes = 'GREAT_LAKES',
  /** Transportador de Gesso */
  GypsumCarrier = 'GYPSUM_CARRIER',
  /** Transportador de Cargas Pesadas */
  HeavyLift = 'HEAVY_LIFT',
  /** Transportador de Cargas Pesadas Semi-submersível */
  HeavyLiftSemiSubmersible = 'HEAVY_LIFT_SEMI_SUBMERSIBLE',
  /** Transportador de Calcário */
  LimestoneCarrier = 'LIMESTONE_CARRIER',
  /** Transportador de Gado */
  Livestock = 'LIVESTOCK',
  /** Transportador de GNL */
  LngCarrier = 'LNG_CARRIER',
  /** Transportador de Troncos */
  Logs = 'LOGS',
  /** Transportador de Toras */
  LogCarrier = 'LOG_CARRIER',
  /** Transportador de GLP */
  LpgCarrier = 'LPG_CARRIER',
  /** Transportador de Madeira */
  LumberCarrier = 'LUMBER_CARRIER',
  /** Diversos */
  Miscellaneous = 'MISCELLANEOUS',
  /** Transportador de Melaço */
  MolassesCarrier = 'MOLASSES_CARRIER',
  /** Transportador de Uso Múltiplo */
  MultiPurposeCarrier = 'MULTI_PURPOSE_CARRIER',
  /** Transportador de Combustível Nuclear */
  NuclearFuelCarrier = 'NUCLEAR_FUEL_CARRIER',
  /** Offshore */
  Offshore = 'OFFSHORE',
  /** Porão Aberto */
  OpenHatch = 'OPEN_HATCH',
  /** Transportador de Minério / Petróleo a Granel */
  OreBulkOilCarrier = 'ORE_BULK_OIL_CARRIER',
  /** Transportador de Minério */
  OreCarrier = 'ORE_CARRIER',
  /** Transportador de Minério / Petróleo */
  OreOilCarrier = 'ORE_OIL_CARRIER',
  /** Outro */
  Other = 'OTHER',
  /** Transportador de Carga em Paletes */
  PalletCarrier = 'PALLET_CARRIER',
  /** Probo */
  Probo = 'PROBO',
  /** Refrigerado */
  Reefer = 'REEFER',
  /** Reabastecimento */
  Replenishment = 'REPLENISHMENT',
  /** Roll-on/Roll-off */
  RollOnRollOff = 'ROLL_ON_ROLL_OFF',
  /** Transportador Marítimo/Fluvial */
  SeaRiverType = 'SEA_RIVER_TYPE',
  /** Autodescarregável */
  SelfDischarging = 'SELF_DISCHARGING',
  /** Resíduos de Óleo */
  Slops = 'SLOPS',
  /** Transportador de Pedras */
  StoneCarrier = 'STONE_CARRIER',
  /** Navio-Tanque de Produtos Químicos */
  TankerChemicals = 'TANKER_CHEMICALS',
  /** Navio-Tanque de Petróleo Bruto */
  TankerCrude = 'TANKER_CRUDE',
  /** Navio-Tanque de Produtos */
  TankerProduct = 'TANKER_PRODUCT',
  /** Rebocador */
  Tug = 'TUG',
  /** Transportador de Convés Intermediário */
  TweenDecker = 'TWEEN_DECKER',
  /** Transportador de Óleo Vegetal */
  VegOilCarrier = 'VEG_OIL_CARRIER',
  /** Transportador de Veículos/Passageiros */
  VehiclePassenger = 'VEHICLE_PASSENGER',
  /** Transportador de Água */
  WaterCarrier = 'WATER_CARRIER',
  /** Transportador de Vinho */
  WineCarrier = 'WINE_CARRIER',
  /** Transportador de Cavaco de Madeira */
  WoodChipCarrier = 'WOOD_CHIP_CARRIER',
  /** Transportador de Polpa de Madeira */
  WoodPulp = 'WOOD_PULP'
}

/** Ship type enum */
export enum ShipTypeEnum {
  /** Navio Anti-Poluição */
  AntiPollution = 'ANTI_POLLUTION',
  /** Transportador de Automóveis */
  CarCarrier = 'CAR_CARRIER',
  /** Transportador de Combinação */
  CombinationCarrier = 'COMBINATION_CARRIER',
  /** Container */
  Container = 'CONTAINER',
  /** Navio de Mergulho */
  DiveVessel = 'DIVE_VESSEL',
  /** Draga */
  Dredger = 'DREDGER',
  /** Carga a Granel Seca */
  DryBulk = 'DRY_BULK',
  /** Pesca */
  Fishing = 'FISHING',
  /** Transportador de Gás */
  GasCarrier = 'GAS_CARRIER',
  /** Carga Geral */
  GeneralCargo = 'GENERAL_CARGO',
  /** Navio-Tanque Geral */
  GeneralTanker = 'GENERAL_TANKER',
  /** Embarcação de Alta Velocidade */
  HighSpeedCraft = 'HIGH_SPEED_CRAFT',
  /** Embarcação de Fiscalização */
  LawEnforcement = 'LAW_ENFORCEMENT',
  /** Transportador de Gado */
  Livestock = 'LIVESTOCK',
  /** Transportador de GNL */
  LngCarrier = 'LNG_CARRIER',
  /** Transporte Médico */
  MedicalTrans = 'MEDICAL_TRANS',
  /** Operações Militares */
  MilitaryOps = 'MILITARY_OPS',
  /** Offshore */
  Offshore = 'OFFSHORE',
  /** Outro */
  Other = 'OTHER',
  /** Passageiro */
  Passenger = 'PASSENGER',
  /** Embarcação de Praticagem */
  PilotVessel = 'PILOT_VESSEL',
  /** Embarcação de Recreio */
  PleasureCraft = 'PLEASURE_CRAFT',
  /** Embarcação de Serviço Portuário */
  PortTender = 'PORT_TENDER',
  /** Refrigerado */
  Reefer = 'REEFER',
  /** Roll-on/Roll-off */
  RollOnRollOff = 'ROLL_ON_ROLL_OFF',
  /** Veleiro */
  Sailing = 'SAILING',
  /** Busca e Salvamento */
  SearchAndRescue = 'SEARCH_AND_RESCUE',
  /** Embarcação Especial */
  SpecialCraft = 'SPECIAL_CRAFT',
  /** Navio-Tanque de Produtos Químicos */
  TankerChemicals = 'TANKER_CHEMICALS',
  /** Navio-Tanque de Petróleo Bruto */
  TankerCrude = 'TANKER_CRUDE',
  /** Navio-Tanque de Produtos */
  TankerProduct = 'TANKER_PRODUCT',
  /** Rebocador */
  Tug = 'TUG',
  /** Transportador de Veículos/Passageiros */
  VehiclePassenger = 'VEHICLE_PASSENGER'
}

/** The Shipment Document Authorization Status Enum */
export enum ShipmentDocumentAuthorizationStatusEnum {
  /** Autorizado */
  Authorized = 'AUTHORIZED',
  /** Acesso negado */
  Forbidden = 'FORBIDDEN',
  /** Não Autorizado */
  NotAuthorized = 'NOT_AUTHORIZED',
  /** Pendente de Autorização */
  Pending = 'PENDING'
}

/** The Shipment Document Automatic Link Origin Type Enum */
export enum ShipmentDocumentAutomaticLinkOriginTypeEnum {
  /** CCT */
  Cct = 'CCT',
  /** Mercante */
  Mercante = 'MERCANTE'
}

/** A Shipment DUIMP */
export type ShipmentDuimp = {
  __typename?: 'ShipmentDuimp';
  automaticLinkOrigin: Maybe<ShipmentDocumentAutomaticLinkOriginTypeEnum>;
  comments: Maybe<Scalars['String']['output']>;
  duimp: Duimp;
  foreignTradeShipment: ForeignTradeShipment;
  id: Scalars['Int']['output'];
  insertedAt: Maybe<Scalars['DateTime']['output']>;
  lastSyncErrorMessage: Maybe<Scalars['String']['output']>;
  lastSyncType: Maybe<SiscomexSyncTypeEnum>;
  status: ShipmentDocumentAuthorizationStatusEnum;
};

/** The Shipment DUIMP Order By Enum */
export enum ShipmentDuimpOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Status */
  Status = 'STATUS'
}

export type ShipmentDuimpOrderParams = {
  field?: InputMaybe<ShipmentDuimpOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Shipment DUIMP */
export type ShipmentDuimpPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentDuimpOrderParams>>;
};

/** An Shipment DUIMP per Process */
export type ShipmentDuimpPerProcess = {
  __typename?: 'ShipmentDuimpPerProcess';
  process: Process;
  shipmentDuimp: ShipmentDuimp;
};

/** A Shipment Export Declaration */
export type ShipmentExportDeclaration = {
  __typename?: 'ShipmentExportDeclaration';
  comments: Maybe<Scalars['String']['output']>;
  exportDeclaration: ExportDeclaration;
  foreignTradeShipment: ForeignTradeShipment;
  id: Scalars['Int']['output'];
  lastSyncErrorMessage: Maybe<Scalars['String']['output']>;
  lastSyncType: Maybe<SiscomexSyncTypeEnum>;
};

/** The Shipment Export Declaration Order By Enum */
export enum ShipmentExportDeclarationOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Status */
  Status = 'STATUS'
}

export type ShipmentExportDeclarationOrderParams = {
  field?: InputMaybe<ShipmentExportDeclarationOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Shipment Export Declarations */
export type ShipmentExportDeclarationPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentExportDeclarationOrderParams>>;
};

/** An Shipment Export Declaration per Process */
export type ShipmentExportDeclarationPerProcess = {
  __typename?: 'ShipmentExportDeclarationPerProcess';
  process: Process;
  shipmentExportDeclaration: ShipmentExportDeclaration;
};

/** A Shipment Import Declaration */
export type ShipmentImportDeclaration = {
  __typename?: 'ShipmentImportDeclaration';
  automaticLinkOrigin: Maybe<ShipmentDocumentAutomaticLinkOriginTypeEnum>;
  comments: Maybe<Scalars['String']['output']>;
  foreignTradeShipment: ForeignTradeShipment;
  id: Scalars['Int']['output'];
  importDeclaration: ImportDeclaration;
  insertedAt: Maybe<Scalars['DateTime']['output']>;
  lastSyncErrorMessage: Maybe<Scalars['String']['output']>;
  lastSyncType: Maybe<SiscomexSyncTypeEnum>;
  status: ShipmentDocumentAuthorizationStatusEnum;
};

/** The Shipment Import Declaration Order By Enum */
export enum ShipmentImportDeclarationOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Status */
  Status = 'STATUS'
}

export type ShipmentImportDeclarationOrderParams = {
  field?: InputMaybe<ShipmentImportDeclarationOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Shipment Import Declarations */
export type ShipmentImportDeclarationPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentImportDeclarationOrderParams>>;
};

/** An Shipment Import Declaration per Process */
export type ShipmentImportDeclarationPerProcess = {
  __typename?: 'ShipmentImportDeclarationPerProcess';
  process: Process;
  shipmentImportDeclaration: ShipmentImportDeclaration;
};

/** A Shipment Import License */
export type ShipmentImportLicense = {
  __typename?: 'ShipmentImportLicense';
  comments: Maybe<Scalars['String']['output']>;
  foreignTradeShipment: ForeignTradeShipment;
  id: Scalars['Int']['output'];
  importLicense: ImportLicense;
  insertedAt: Maybe<Scalars['DateTime']['output']>;
  lastSyncErrorMessage: Maybe<Scalars['String']['output']>;
  lastSyncType: Maybe<SiscomexSyncTypeEnum>;
  status: ShipmentDocumentAuthorizationStatusEnum;
};

/** The Shipment Import License Order By Enum */
export enum ShipmentImportLicenseOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Status */
  Status = 'STATUS'
}

export type ShipmentImportLicenseOrderParams = {
  field?: InputMaybe<ShipmentImportLicenseOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Shipment Import Licenses */
export type ShipmentImportLicensePaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentImportLicenseOrderParams>>;
};

/** An Shipment Import License per Process */
export type ShipmentImportLicensePerProcess = {
  __typename?: 'ShipmentImportLicensePerProcess';
  process: Process;
  shipmentImportLicense: ShipmentImportLicense;
};

/** A Shipment Item */
export type ShipmentItem = {
  __typename?: 'ShipmentItem';
  foreignTradeItemShipment: ForeignTradeItemShipment;
  process: Process;
};

/** The Shipment Item Order By Enum */
export enum ShipmentItemOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Quantidade */
  Quantity = 'QUANTITY'
}

export type ShipmentItemOrderParams = {
  field?: InputMaybe<ShipmentItemOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Shipment Items */
export type ShipmentItemPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentItemOrderParams>>;
};

/** A Shipment Item with Order Item */
export type ShipmentItemWithOrderItem = {
  __typename?: 'ShipmentItemWithOrderItem';
  foreignTradeItemShipment: ForeignTradeItemShipment;
  order: Order;
  process: Process;
  purchaseOrderItem: Maybe<PurchaseOrderItem>;
  salesOrderItem: Maybe<SalesOrderItem>;
};

/** A Shipment LPCO */
export type ShipmentLpco = {
  __typename?: 'ShipmentLpco';
  comments: Maybe<Scalars['String']['output']>;
  foreignTradeShipment: ForeignTradeShipment;
  id: Scalars['Int']['output'];
  lpco: Lpco;
};

/** A group of pallets of a Foreign Trade Shipment */
export type ShipmentPallet = {
  __typename?: 'ShipmentPallet';
  heightCm: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  lengthMm: Maybe<Scalars['Int']['output']>;
  palletStandard: Maybe<PalletStandard>;
  palletStandardId: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
  sizeType: PalletSizeTypeEnum;
  widthMm: Maybe<Scalars['Int']['output']>;
};

/** A Shipment Trailer */
export type ShipmentTrailer = {
  __typename?: 'ShipmentTrailer';
  id: Scalars['Int']['output'];
  shipment: RoadTransportShipment;
  trailer: Trailer;
};

/** The Shipment Type Enum */
export enum ShipmentTypeEnum {
  /** Embarque de transporte Aéreo */
  AirTransport = 'AIR_TRANSPORT',
  /** Embarque de transporte Marítimo */
  MaritimeTransport = 'MARITIME_TRANSPORT',
  /** Embarque de transporte Rodoviário */
  RoadTransport = 'ROAD_TRANSPORT'
}

/** The Simple Sorting Order Enum */
export enum SimpleSortingOrderEnum {
  /** Ordem crescente */
  Asc = 'ASC',
  /** Ordem decrescente */
  Desc = 'DESC'
}

/** A Siscomex Attribute */
export type SiscomexAttribute = {
  __typename?: 'SiscomexAttribute';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  validFromAt: Maybe<Scalars['DateTime']['output']>;
  validToAt: Maybe<Scalars['DateTime']['output']>;
};

/** A document attached to a Siscomex operation (LPCO, DUIMP, ...) */
export type SiscomexDocument = {
  __typename?: 'SiscomexDocument';
  attachedAt: Maybe<Scalars['DateTime']['output']>;
  attachedBy: Maybe<Scalars['String']['output']>;
  discarded: Maybe<Scalars['Boolean']['output']>;
  documentTypeCode: Maybe<Scalars['Int']['output']>;
  documentTypeName: Maybe<Scalars['String']['output']>;
  externalId: Maybe<Scalars['Int']['output']>;
  extra: Maybe<Scalars['JSON']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  itemType: SiscomexOperationTypeEnum;
  keywords: Array<SiscomexDocumentKeyword>;
  read: Maybe<Scalars['Boolean']['output']>;
  sha256: Maybe<Scalars['String']['output']>;
};

/** The downloaded content of a Siscomex document */
export type SiscomexDocumentDownload = {
  __typename?: 'SiscomexDocumentDownload';
  base64Content: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

/** A keyword extracted from a Siscomex document's content */
export type SiscomexDocumentKeyword = {
  __typename?: 'SiscomexDocumentKeyword';
  content: Maybe<Scalars['String']['output']>;
  externalId: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/** A dossier grouping documents attached to a Siscomex operation */
export type SiscomexDossier = {
  __typename?: 'SiscomexDossier';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  documents: Array<SiscomexDocument>;
  extra: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  itemType: SiscomexOperationTypeEnum;
  number: Maybe<Scalars['String']['output']>;
  typeCode: Maybe<Scalars['Int']['output']>;
  typeName: Maybe<Scalars['String']['output']>;
};

/** The Siscomex Operation Type Enum */
export enum SiscomexOperationTypeEnum {
  /** Catálogo de Produtos */
  Catp = 'CATP',
  /** Declaração de Importação */
  Di = 'DI',
  /** Declaração de Importação de Remessa */
  Dir = 'DIR',
  /** Declaração de Trânsito */
  Dt = 'DT',
  /** Declaração Única de Exportação */
  Due = 'DUE',
  /** Declaração Única de Importação */
  Duimp = 'DUIMP',
  /** Licença de Importação */
  Li = 'LI',
  /** Tratamento Administrativo/LPCO */
  Lpco = 'LPCO',
  /** Registro de Exportação */
  Re = 'RE'
}

/** A Siscomex Product */
export type SiscomexProduct = {
  __typename?: 'SiscomexProduct';
  attributes: Maybe<Scalars['JSON']['output']>;
  code: Scalars['String']['output'];
  denomination: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  extra: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  insertedAt: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  modality: Maybe<SiscomexProductModalityEnum>;
  ncm: Ncm;
  ncmCode: Maybe<Scalars['String']['output']>;
  product: Product;
  productAttributes: Maybe<Array<SiscomexProductAttribute>>;
  rootCnpj: Scalars['String']['output'];
  situation: Maybe<SiscomexProductSituationEnum>;
  version: Scalars['String']['output'];
};

/** A Siscomex Attribute with its resolved value from a product */
export type SiscomexProductAttribute = {
  __typename?: 'SiscomexProductAttribute';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  validFromAt: Maybe<Scalars['DateTime']['output']>;
  validToAt: Maybe<Scalars['DateTime']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

/** The Siscomex Product Modality Enum */
export enum SiscomexProductModalityEnum {
  /** Exportação */
  Export = 'EXPORT',
  /** Importação */
  Import = 'IMPORT'
}

/** The Siscomex Product Situation Enum */
export enum SiscomexProductSituationEnum {
  /** Ativado */
  Activated = 'ACTIVATED',
  /** Desativado */
  Deactivated = 'DEACTIVATED',
  /** Rascunho */
  Draft = 'DRAFT'
}

/** The Siscomex Status Response Enum */
export enum SiscomexStatusResponseEnum {
  /** Sem permissão */
  Forbidden = 'FORBIDDEN',
  /** Encontrado */
  Found = 'FOUND',
  /** Não Encontrado */
  NotFound = 'NOT_FOUND',
  /** Pendente */
  Pending = 'PENDING'
}

/** The Siscomex Document Sync Type Enum */
export enum SiscomexSyncTypeEnum {
  /** Erro na última sincronização */
  Error = 'ERROR',
  /** Vinculado ao catálogo de produtos do Siscomex */
  Linked = 'LINKED',
  /** Documento não encontrado no Siscomex */
  NotFound = 'NOT_FOUND',
  /** Sem vínculo no catálogo de produtos do Siscomex */
  NotLinked = 'NOT_LINKED',
  /** Desatualizado (Siscomex indisponível) */
  OutOfSync = 'OUT_OF_SYNC',
  /** Sincronizado */
  Synced = 'SYNCED'
}

/** A shipment field that changed on the Process after the Booking Quotation was sent */
export type SnapshotChange = {
  __typename?: 'SnapshotChange';
  after: Maybe<Scalars['JSON']['output']>;
  before: Maybe<Scalars['JSON']['output']>;
  label: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
};

/** The Sorting Order Enum */
export enum SortingOrderEnum {
  /** Ordem crescente */
  Asc = 'ASC',
  /** Ordem ascendente com valores nulos primeiro */
  AscNullsFirst = 'ASC_NULLS_FIRST',
  /** Ordem crescente com valores nulos por último */
  AscNullsLast = 'ASC_NULLS_LAST',
  /** Ordem decrescente */
  Desc = 'DESC',
  /** Ordem decrescente com valores nulos primeiro */
  DescNullsFirst = 'DESC_NULLS_FIRST',
  /** Ordem decrescente com valores nulos por último */
  DescNullsLast = 'DESC_NULLS_LAST'
}

/** The Specials Treatments Enum */
export enum SpecialTreatmentsTypeEnum {
  /** Drawback */
  Drawback = 'DRAWBACK',
  /** Diferimento ICMS */
  IcmsDeferral = 'ICMS_DEFERRAL',
  /** DI Única */
  SingleImportDeclaration = 'SINGLE_IMPORT_DECLARATION',
  /** Ex-Tarifário */
  TariffExemption = 'TARIFF_EXEMPTION'
}

/** The Status Filter Enum */
export enum StatusFilterEnum {
  /** Cancelado */
  Canceled = 'CANCELED',
  /** Deletado */
  Deleted = 'DELETED',
  /** Finalizado */
  Finished = 'FINISHED',
  /** Em andamento */
  Ongoing = 'ONGOING'
}

/** The LPCO Requirement Status Enum */
export enum StatusRequirementTypeEnum {
  /** Cancelado */
  Canceled = 'CANCELED',
  /** Cumprida */
  Fulfilled = 'FULFILLED',
  /** Não Cumprida */
  NotFulfilled = 'NOT_FULFILLED',
  /** Pendente */
  Pending = 'PENDING'
}

/** The Status Response from the Integration Enum */
export enum StatusResponseTypeEnum {
  /** Encontrado */
  Found = 'FOUND',
  /** Dados inválidos */
  Invalid = 'INVALID',
  /** Não Encontrado */
  NotFound = 'NOT_FOUND',
  /** Pendente */
  Pending = 'PENDING'
}

/** A Subsidiary */
export type Subsidiary = {
  __typename?: 'Subsidiary';
  actor: Actor;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** A supply origin count */
export type SupplyOriginCount = {
  __typename?: 'SupplyOriginCount';
  count: Scalars['Int']['output'];
  supplyOrigin: OriginTypeEnum;
};

/** Result of triggering an on-demand Siscomex sync for a document/entity */
export type SyncTriggerResult = {
  __typename?: 'SyncTriggerResult';
  /** Whether a sync is currently in progress for this entity — true for a freshly enqueued job or one already running/queued, false if the last sync already completed within the dedup window */
  syncing: Scalars['Boolean']['output'];
};

/** The Tracker Brand Enum */
export enum TrackerBrandEnum {
  /** Omnilink */
  Omnilink = 'OMNILINK',
  /** Sascar */
  Sascar = 'SASCAR'
}

/** The Tracking Key Enum */
export enum TrackingKeyEnum {
  /** Bill of Lading */
  BillOfLading = 'BILL_OF_LADING',
  /** Booking */
  Booking = 'BOOKING',
  /** Container Code */
  ContainerCode = 'CONTAINER_CODE',
  /** House Bill of Lading */
  HouseBl = 'HOUSE_BL',
  /** Reference Code */
  ReferenceCode = 'REFERENCE_CODE',
  /** Tracking Number */
  TrackingNumber = 'TRACKING_NUMBER',
  /** Vessel */
  Vessel = 'VESSEL'
}

/** A Trailer */
export type Trailer = {
  __typename?: 'Trailer';
  actor: Actor;
  id: Scalars['Int']['output'];
  isRefrigerated: Scalars['Boolean']['output'];
  plate: Scalars['String']['output'];
  speedLimitDry: Maybe<Scalars['Int']['output']>;
  speedLimitWet: Maybe<Scalars['Int']['output']>;
  tareWeightKg: Maybe<Scalars['Decimal']['output']>;
  temperatureMax: Maybe<Scalars['Int']['output']>;
  temperatureMin: Maybe<Scalars['Int']['output']>;
  trackerBrand: Maybe<TrackerBrandEnum>;
  trackerId: Maybe<Scalars['String']['output']>;
  type: TrailerTypeEnum;
};

/** The Trailer Order By Enum */
export enum TrailerOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** É refrigerado */
  IsRefrigerated = 'IS_REFRIGERATED',
  /** Placa */
  Plate = 'PLATE',
  /** Limite de velocidade seco */
  SpeedLimitDry = 'SPEED_LIMIT_DRY',
  /** Limite de velocidade molhado */
  SpeedLimitWet = 'SPEED_LIMIT_WET',
  /** Peso da tara em kg */
  TareWeightKg = 'TARE_WEIGHT_KG',
  /** Temperatura máxima */
  TemperatureMax = 'TEMPERATURE_MAX',
  /** Temperatura mínima */
  TemperatureMin = 'TEMPERATURE_MIN',
  /** Marca de rastreio */
  TrackerBrand = 'TRACKER_BRAND',
  /** ID de rastreio */
  TrackerId = 'TRACKER_ID',
  /** Tipo */
  Type = 'TYPE',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

export type TrailerOrderParams = {
  field?: InputMaybe<TrailerOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Trailers */
export type TrailerPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrailerOrderParams>>;
};

/** The Trailer Type Enum */
export enum TrailerTypeEnum {
  /** Baú */
  Box = 'BOX',
  /** Buggy 20 */
  Buggy_20 = 'BUGGY_20',
  /** Buggy 40 */
  Buggy_40 = 'BUGGY_40',
  /** Slider */
  Slider = 'SLIDER'
}

/** The Transaction Type Enum */
export enum TransactionTypeEnum {
  /** Criar */
  Create = 'CREATE',
  /** Excluir */
  Delete = 'DELETE',
  /** Atualizar */
  Update = 'UPDATE'
}

/** A Transport Acknowledgment */
export type TransportAcknowledgment = {
  __typename?: 'TransportAcknowledgment';
  electronicInvoices: Array<ElectronicInvoice>;
  emittedAt: Maybe<Scalars['DateTime']['output']>;
  key: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['String']['output']>;
  serviceValue: Maybe<Scalars['Float']['output']>;
  totalValue: Maybe<Scalars['Float']['output']>;
};

/** The Transport Feature Enum */
export enum TransportFeatureEnum {
  /** Transporte de produtos perigosos */
  HazardousProducts = 'HAZARDOUS_PRODUCTS',
  /** Transporte refrigerado */
  Refrigerated = 'REFRIGERATED'
}

/** The Transport Specification Enum */
export enum TransportSpecificationEnum {
  /** IMO */
  HazardousCargo = 'HAZARDOUS_CARGO',
  /** Carga Refrigerada */
  RefrigeratedCargo = 'REFRIGERATED_CARGO',
  /** Requer Escolta */
  RequiresEscort = 'REQUIRES_ESCORT',
  /** Requer Ajudante */
  RequiresHelper = 'REQUIRES_HELPER',
  /** Requer troca de Nota Fiscal */
  RequiresInvoiceExchange = 'REQUIRES_INVOICE_EXCHANGE'
}

/** A Transportable */
export type Transportable = {
  __typename?: 'Transportable';
  cargo: Maybe<Cargo>;
  container: Maybe<Container>;
  foreignTradeShipment: Maybe<ForeignTradeShipment>;
  id: Scalars['Int']['output'];
  invoiceItems: Array<InvoiceItem>;
  itemShipments: Array<ForeignTradeItemShipment>;
  roadTransportOrder: Maybe<RoadTransportOrder>;
  roadTransportShipment: Maybe<RoadTransportShipment>;
  trips: Array<RoadTransportTrip>;
  type: TransportableTypeEnum;
};

/** The Transportable Type Enum */
export enum TransportableTypeEnum {
  /** Transporte de Carga Solta */
  Cargo = 'CARGO',
  /** Transporte de Container */
  Container = 'CONTAINER'
}

/** A Trigger */
export type Trigger = {
  __typename?: 'Trigger';
  conditions: Array<Condition>;
  formula: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
};

/** A Unitary Costs */
export type UnitaryCost = {
  __typename?: 'UnitaryCost';
  cost: Maybe<Scalars['Decimal']['output']>;
  deviation: Maybe<Scalars['Decimal']['output']>;
  plannedCost: Maybe<Scalars['Decimal']['output']>;
};

/** Available parameters to update an Actor */
export type UpdateActorParams = {
  logo?: InputMaybe<Scalars['Upload']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  officialDocument?: InputMaybe<Scalars['String']['input']>;
  officialName?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<OperationHandlerEnum>>;
};

/** Available parameters to update an Address */
export type UpdateAddressParams = {
  actorId?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  complement?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  fences?: InputMaybe<Array<NestedUpdateFenceParams>>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

/** Available parameters to update an Automation */
export type UpdateAutomationParams = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Available parameters to update a Client */
export type UpdateClientParams = {
  actorId?: InputMaybe<Scalars['Int']['input']>;
};

/** Available parameters to update a Credential */
export type UpdateCredentialParams = {
  credentials?: InputMaybe<Scalars['JSON']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  password?: InputMaybe<Scalars['String']['input']>;
};

/** Available parameters to update a Document */
export type UpdateDocumentParams = {
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceId?: InputMaybe<Scalars['Int']['input']>;
  parentDocumentId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<DocumentTypeEnum>;
};

/** Available parameters to update a Driver */
export type UpdateDriverParams = {
  birthday?: InputMaybe<Scalars['Date']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  licenseCategory?: InputMaybe<Scalars['String']['input']>;
  licenseExpirationDate?: InputMaybe<Scalars['Date']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  officialDocument?: InputMaybe<Scalars['String']['input']>;
};

/** Available parameters to update a Lead Time Model */
export type UpdateLeadTimeModelParams = {
  ignoreTime: Scalars['Boolean']['input'];
  markerPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  operationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  referenceEvent?: InputMaybe<Scalars['String']['input']>;
  stages?: InputMaybe<Array<NestedUpdateLeadTimeStageModelParams>>;
};

/** Available parameters to update a Notification Group */
export type UpdateNotificationGroupParams = {
  ccEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationGroupRoles?: InputMaybe<Array<NestedNotificationGroupRoleParams>>;
};

/** Available parameters to update a Notification Group Recipient */
export type UpdateNotificationGroupRecipientParams = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  language?: InputMaybe<LanguageEnum>;
};

/** Available parameters to update an Operation */
export type UpdateOperationParams = {
  auditItems?: InputMaybe<Array<NestedUpdateAuditItemParams>>;
  autoGenerateOrderCode?: InputMaybe<Scalars['Boolean']['input']>;
  autoGenerateProcessCode?: InputMaybe<Scalars['Boolean']['input']>;
  cargoDeadlineDefaultReference?: InputMaybe<DeadlineDateReferenceEnum>;
  configProps?: InputMaybe<NestedOperationConfigPropsParams>;
  draftDeadlineDefaultReference?: InputMaybe<DeadlineDateReferenceEnum>;
  gateOpeningDeadlineDefaultReference?: InputMaybe<GateOpeningDeadlineDateReferenceEnum>;
  isPhaseSequential?: InputMaybe<Scalars['Boolean']['input']>;
  orderCode?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  processCode?: InputMaybe<Scalars['String']['input']>;
  subType?: InputMaybe<OperationSubTypeEnum>;
  subtitle?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<OperationTypeEnum>;
  vgmDeadlineDefaultReference?: InputMaybe<VgmDeadlineDateReferenceEnum>;
};

/** Available parameters to update an Order */
export type UpdateOrderParams = {
  alertLevel?: InputMaybe<AlertLevelEnum>;
  auditItems?: InputMaybe<Array<NestedUpdateOrderAuditItem>>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  documents?: InputMaybe<Array<UpdateDocumentParams>>;
  externalReferenceCode?: InputMaybe<Scalars['String']['input']>;
  extraFields?: InputMaybe<Scalars['JSON']['input']>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  handler?: InputMaybe<NestedUpsertHandlersByRoleParams>;
  handlers?: InputMaybe<Array<NestedUpdateHandlerParams>>;
  leadTimeDatetimeReference?: InputMaybe<Scalars['DateTime']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  purchaseOrder?: InputMaybe<NestedUpdatePurchaseOrderParams>;
  roadTransportOrder?: InputMaybe<NestedUpdateRoadTransportOrderParams>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  salesOrder?: InputMaybe<NestedUpdateSalesOrderParams>;
};

/** Available parameters to update a Partnership */
export type UpdatePartnershipParams = {
  contactDetails?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  internalCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<NestedUpdateRoleParams>>;
};

/** Available parameters to update a Planned Lead Time */
export type UpdatePlannedLeadTimeParams = {
  name?: InputMaybe<Scalars['String']['input']>;
  stages?: InputMaybe<Array<NestedUpdatePlannedLeadTimeStageParams>>;
};

/** Available parameters to update a Port Schedule Leg through Port Schedule */
export type UpdatePortScheduleLegNestedParams = {
  atu?: InputMaybe<Scalars['DateTime']['input']>;
  etb?: InputMaybe<Scalars['DateTime']['input']>;
  portUnlocode: Scalars['String']['input'];
};

/** Available parameters to update a Port Schedule */
export type UpdatePortScheduleParams = {
  atb?: InputMaybe<Scalars['DateTime']['input']>;
  atu?: InputMaybe<Scalars['DateTime']['input']>;
  carrierCode?: InputMaybe<Scalars['String']['input']>;
  carrierCountryCode?: InputMaybe<Scalars['String']['input']>;
  carrierName?: InputMaybe<Scalars['String']['input']>;
  carrierVoyage?: InputMaybe<Scalars['String']['input']>;
  etb?: InputMaybe<Scalars['DateTime']['input']>;
  etu?: InputMaybe<Scalars['DateTime']['input']>;
  lastPorts?: InputMaybe<Array<UpdatePortScheduleLegNestedParams>>;
  nextPorts?: InputMaybe<Array<UpdatePortScheduleLegNestedParams>>;
  operationType?: InputMaybe<Scalars['String']['input']>;
  portUnlocode: Scalars['String']['input'];
  scheduleNumber: Scalars['String']['input'];
  shippingAgencyCnpj?: InputMaybe<Scalars['String']['input']>;
  shippingAgencyName?: InputMaybe<Scalars['String']['input']>;
  vesselImo: Scalars['String']['input'];
  vesselMmsi: Scalars['String']['input'];
  vesselResponsible?: InputMaybe<Scalars['String']['input']>;
};

/** Available parameters to update a Process */
export type UpdateProcessParams = {
  alertLevel?: InputMaybe<AlertLevelEnum>;
  auditItems?: InputMaybe<Array<NestedUpdateProcessAuditItem>>;
  bookingQuotation?: InputMaybe<UpsertBookingQuotationParams>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  costModelVersionId?: InputMaybe<Scalars['Int']['input']>;
  documents?: InputMaybe<Array<UpdateDocumentParams>>;
  extraFields?: InputMaybe<Scalars['JSON']['input']>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  foreignTradeShipment?: InputMaybe<NestedUpdateForeignTradeShipmentParams>;
  handler?: InputMaybe<NestedUpsertHandlersByRoleParams>;
  handlers?: InputMaybe<Array<NestedUpdateHandlerParams>>;
  leadTimeDatetimeReference?: InputMaybe<Scalars['DateTime']['input']>;
  orderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  plannedLeadTimeId?: InputMaybe<Scalars['Int']['input']>;
};

/** Available parameters to update a Process by REST API */
export type UpdateProcessParamsByRestApi = {
  alertLevel?: InputMaybe<AlertLevelEnum>;
  auditItems?: InputMaybe<Array<NestedUpdateProcessAuditItem>>;
  brazilianInvoices?: InputMaybe<Array<Scalars['String']['input']>>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  costModelVersionId?: InputMaybe<Scalars['Int']['input']>;
  documents?: InputMaybe<Array<UpdateDocumentParams>>;
  extraFields?: InputMaybe<Scalars['JSON']['input']>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  foreignTradeShipment?: InputMaybe<NestedUpdateForeignTradeShipmentParams>;
  handler?: InputMaybe<NestedUpsertHandlersByRoleParams>;
  handlers?: InputMaybe<Array<NestedUpdateHandlerParams>>;
  leadTimeDatetimeReference?: InputMaybe<Scalars['DateTime']['input']>;
  orderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderReferenceCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  plannedLeadTimeId?: InputMaybe<Scalars['Int']['input']>;
};

/** Available parameters to update a Product */
export type UpdateProductParams = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  c9Ratio?: InputMaybe<Scalars['Decimal']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  contentCapacity?: InputMaybe<Scalars['Decimal']['input']>;
  contentCode?: InputMaybe<Scalars['String']['input']>;
  contentMeasurementUnit?: InputMaybe<MeasurementUnitEnum>;
  contentType?: InputMaybe<MeasurementUnitEnum>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  cubagePerPackage?: InputMaybe<Scalars['Decimal']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dumping?: InputMaybe<Scalars['Boolean']['input']>;
  extra?: InputMaybe<Scalars['JSON']['input']>;
  family?: InputMaybe<Scalars['String']['input']>;
  grossWeightPerPackage?: InputMaybe<Scalars['Decimal']['input']>;
  hasContainerization?: InputMaybe<Scalars['Boolean']['input']>;
  hasContent?: InputMaybe<Scalars['Boolean']['input']>;
  hasPalletization?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnitization?: InputMaybe<Scalars['Boolean']['input']>;
  internalCodes?: InputMaybe<Array<NestedUpdateProductInternalCodeParams>>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  mercosulCode?: InputMaybe<Scalars['String']['input']>;
  multipleCode?: InputMaybe<Scalars['String']['input']>;
  multiplePackageCapacity?: InputMaybe<Scalars['Decimal']['input']>;
  multiplePackageMeasurementUnit?: InputMaybe<MeasurementUnitEnum>;
  multiplePackagePerContainerFt20?: InputMaybe<Scalars['Int']['input']>;
  multiplePackagePerContainerFt40?: InputMaybe<Scalars['Int']['input']>;
  multiplePackageType?: InputMaybe<MeasurementUnitEnum>;
  netWeightPerPackage?: InputMaybe<Scalars['Decimal']['input']>;
  packageCapacity?: InputMaybe<Scalars['Decimal']['input']>;
  packageCode?: InputMaybe<Scalars['String']['input']>;
  packageMeasurementUnit?: InputMaybe<MeasurementUnitEnum>;
  packageType?: InputMaybe<MeasurementUnitEnum>;
  packagesPerContainerFt20?: InputMaybe<Scalars['Int']['input']>;
  packagesPerContainerFt40?: InputMaybe<Scalars['Int']['input']>;
  packagesPerPallet?: InputMaybe<Scalars['Int']['input']>;
  palletsPerContainerFt20?: InputMaybe<Scalars['Int']['input']>;
  palletsPerContainerFt40?: InputMaybe<Scalars['Int']['input']>;
  productForeignOperators?: InputMaybe<Array<Scalars['Int']['input']>>;
  translatedDescriptions?: InputMaybe<Scalars['JSON']['input']>;
};

/** Available parameters to update a Report Group */
export type UpdateReportGroupParams = {
  name?: InputMaybe<Scalars['String']['input']>;
  operationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<ReportReferenceEnum>;
};

/** Available parameters to update a Report */
export type UpdateReportParams = {
  columns?: InputMaybe<Scalars['JSON']['input']>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<Scalars['JSON']['input']>;
};

/** Available parameters to update a Route */
export type UpdateRouteParams = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Array<NestedUpdateRoutePointParams>>;
};

/** Available parameters to update a Trailer */
export type UpdateTrailerParams = {
  isRefrigerated?: InputMaybe<Scalars['Boolean']['input']>;
  plate?: InputMaybe<Scalars['String']['input']>;
  speedLimitDry?: InputMaybe<Scalars['Int']['input']>;
  speedLimitWet?: InputMaybe<Scalars['Int']['input']>;
  tareWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  temperatureMax?: InputMaybe<Scalars['Int']['input']>;
  temperatureMin?: InputMaybe<Scalars['Int']['input']>;
  trackerBrand?: InputMaybe<TrackerBrandEnum>;
  trackerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TrailerTypeEnum>;
};

/** Available parameters to update a user */
export type UpdateUserParams = {
  accessGroupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
};

/** Available parameters to update a user preference */
export type UpdateUserPreferenceParams = {
  cardSize?: InputMaybe<CardSizeEnum>;
  datetimeFormat?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Available parameters to update a Vehicle */
export type UpdateVehicleParams = {
  isRefrigerated?: InputMaybe<Scalars['Boolean']['input']>;
  plate?: InputMaybe<Scalars['String']['input']>;
  speedLimitDry?: InputMaybe<Scalars['Int']['input']>;
  speedLimitWet?: InputMaybe<Scalars['Int']['input']>;
  tareWeightKg?: InputMaybe<Scalars['Decimal']['input']>;
  temperatureMax?: InputMaybe<Scalars['Int']['input']>;
  temperatureMin?: InputMaybe<Scalars['Int']['input']>;
  trackerBrand?: InputMaybe<TrackerBrandEnum>;
  trackerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VehicleTypeEnum>;
};

/** Available parameters to update a Vessel */
export type UpdateVesselParams = {
  aisClass?: InputMaybe<AisClassEnum>;
  callsign?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<NestedUpdateDimensionsParams>;
  externalDataUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  imoNumber?: InputMaybe<Scalars['String']['input']>;
  isActiveMercante?: InputMaybe<Scalars['Boolean']['input']>;
  mmsiNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shipSubType?: InputMaybe<ShipSubTypeEnum>;
  shipType?: InputMaybe<ShipTypeEnum>;
};

export type UpsertBookingQuotationParams = {
  agentNotes?: InputMaybe<Scalars['String']['input']>;
  closesAt?: InputMaybe<Scalars['DateTime']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  recipientIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Available parameters to Upsert a Cost Model Expense by Rest Api */
export type UpsertCostModelExpenseParamsByRestApi = {
  dynamicTableDefinitionId?: InputMaybe<Scalars['Int']['input']>;
  expenseId: Scalars['Int']['input'];
  fallbackPath?: InputMaybe<Scalars['String']['input']>;
  matchingRules?: InputMaybe<Array<MatchingRuleParams>>;
  modelExpenseId?: InputMaybe<Scalars['Int']['input']>;
  precificationModel?: InputMaybe<CostModelExpenseConditionalPrecificationModelEnum>;
  priceField?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<CostModelExpenseReferenceEnum>;
  referenceProductProrated?: InputMaybe<CostModelExpenseReferenceProductProratedEnum>;
  referenceValue?: InputMaybe<Scalars['Decimal']['input']>;
};

/** Available parameters to Upsert a Cost per Expense by Rest Api */
export type UpsertCostPerExpenseParamsByRestApi = {
  cost?: InputMaybe<Scalars['Decimal']['input']>;
  costModelExpenseId: Scalars['Int']['input'];
  plannedCost?: InputMaybe<Scalars['Decimal']['input']>;
};

/** Available parameters to upsert a Driver */
export type UpsertDriverParams = {
  birthday?: InputMaybe<Scalars['Date']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  licenseCategory?: InputMaybe<Scalars['String']['input']>;
  licenseExpirationDate?: InputMaybe<Scalars['Date']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  officialDocument?: InputMaybe<Scalars['String']['input']>;
};

/** Available parameters to upsert a Dynamic Table Data */
export type UpsertDynamicTableDataParams = {
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertInsightParams = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  foreignTradeItemShipmentId?: InputMaybe<Scalars['Int']['input']>;
  hint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lpcoId?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  processId?: InputMaybe<Scalars['Int']['input']>;
  ruleSlug: Scalars['String']['input'];
  transportableId?: InputMaybe<Scalars['Int']['input']>;
};

/** Available parameters to upsert a Order */
export type UpsertOrderParams = {
  /** Defaults to NORMAL */
  alertLevel?: InputMaybe<AlertLevelEnum>;
  auditItems?: InputMaybe<Array<NestedUpdateProcessAuditItem>>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalReferenceCode?: InputMaybe<Scalars['String']['input']>;
  extraFields?: InputMaybe<Scalars['JSON']['input']>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  handler?: InputMaybe<NestedUpsertHandlersByRoleParams>;
  handlers?: InputMaybe<Array<NestedUpdateHandlerParams>>;
  leadTimeDatetimeReference?: InputMaybe<Scalars['DateTime']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  operationId?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrder?: InputMaybe<NestedUpdatePurchaseOrderParams>;
  referenceCode: Scalars['String']['input'];
  roadTransportOrder?: InputMaybe<NestedUpdateRoadTransportOrderParams>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  salesOrder?: InputMaybe<NestedUpdateSalesOrderParams>;
  subsidiaryId?: InputMaybe<Scalars['Int']['input']>;
};

/** Available parameters to Upsert a Partnership by Handlers */
export type UpsertPartnershipByHandlerParams = {
  contactDetails?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<ActorDocumentTypeEnum>;
  internalCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  officialDocument?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<NestedCreateRoleParams>>;
};

/** Available parameters to upsert a Port Terminal Schedule */
export type UpsertPortTerminalScheduleParams = {
  agency?: InputMaybe<Scalars['String']['input']>;
  ata?: InputMaybe<Scalars['DateTime']['input']>;
  atb?: InputMaybe<Scalars['DateTime']['input']>;
  atd?: InputMaybe<Scalars['DateTime']['input']>;
  berth?: InputMaybe<Scalars['String']['input']>;
  cargo?: InputMaybe<Scalars['String']['input']>;
  charterer?: InputMaybe<Scalars['String']['input']>;
  customFacilityCode: Scalars['String']['input'];
  dryDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  dryRelease?: InputMaybe<Scalars['DateTime']['input']>;
  eta?: InputMaybe<Scalars['DateTime']['input']>;
  etb?: InputMaybe<Scalars['DateTime']['input']>;
  etd?: InputMaybe<Scalars['DateTime']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  reeferDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  reeferRelease?: InputMaybe<Scalars['DateTime']['input']>;
  referenceDate?: InputMaybe<Scalars['DateTime']['input']>;
  scheduleIdentifier?: InputMaybe<Scalars['String']['input']>;
  sealine?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vessel: Scalars['String']['input'];
  voyage: Scalars['String']['input'];
};

/** Available parameters to upsert a Process */
export type UpsertProcessParams = {
  alertLevel?: InputMaybe<AlertLevelEnum>;
  auditItems?: InputMaybe<Array<NestedUpdateProcessAuditItem>>;
  brazilianInvoices?: InputMaybe<Array<Scalars['String']['input']>>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  costModelVersionId?: InputMaybe<Scalars['Int']['input']>;
  extraFields?: InputMaybe<Scalars['JSON']['input']>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  foreignTradeShipment?: InputMaybe<NestedUpdateForeignTradeShipmentParams>;
  handler?: InputMaybe<NestedUpsertHandlersByRoleParams>;
  handlers?: InputMaybe<Array<NestedUpdateHandlerParams>>;
  leadTimeDatetimeReference?: InputMaybe<Scalars['DateTime']['input']>;
  operationId?: InputMaybe<Scalars['Int']['input']>;
  orderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderReferenceCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  plannedLeadTimeId?: InputMaybe<Scalars['Int']['input']>;
  referenceCode: Scalars['String']['input'];
};

/** Available parameters to upsert a Trailer */
export type UpsertTrailerParams = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isRefrigerated?: InputMaybe<Scalars['Boolean']['input']>;
  plate?: InputMaybe<Scalars['String']['input']>;
  speedLimitDry?: InputMaybe<Scalars['Int']['input']>;
  speedLimitWet?: InputMaybe<Scalars['Int']['input']>;
  tareWeightKg?: InputMaybe<Scalars['Int']['input']>;
  temperatureMax?: InputMaybe<Scalars['Int']['input']>;
  temperatureMin?: InputMaybe<Scalars['Int']['input']>;
  trackerBrand?: InputMaybe<TrackerBrandEnum>;
  trackerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TrailerTypeEnum>;
};

/** Available parameters to upsert a Vehicle */
export type UpsertVehicleParams = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isRefrigerated?: InputMaybe<Scalars['Boolean']['input']>;
  plate?: InputMaybe<Scalars['String']['input']>;
  speedLimitDry?: InputMaybe<Scalars['Int']['input']>;
  speedLimitWet?: InputMaybe<Scalars['Int']['input']>;
  tareWeightKg?: InputMaybe<Scalars['Int']['input']>;
  temperatureMax?: InputMaybe<Scalars['Int']['input']>;
  temperatureMin?: InputMaybe<Scalars['Int']['input']>;
  trackerBrand?: InputMaybe<TrackerBrandEnum>;
  trackerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VehicleTypeEnum>;
};

/** A user */
export type User = {
  __typename?: 'User';
  canEditEmail: Maybe<Scalars['Boolean']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  currentWorkspace: Maybe<Workspace>;
  email: Maybe<Scalars['String']['output']>;
  featureAccesses: Array<FeatureAccessWithSlug>;
  id: Maybe<Scalars['String']['output']>;
  lastLogin: Maybe<Scalars['DateTime']['output']>;
  name: Maybe<Scalars['String']['output']>;
  picture: Maybe<Scalars['String']['output']>;
  registrationComplete: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  userMetadata: Maybe<UserMetadata>;
  workspaces: Array<Workspace>;
};

/** A user metadata */
export type UserMetadata = {
  __typename?: 'UserMetadata';
  countryCode: Scalars['String']['output'];
  documentNumber: Maybe<Scalars['String']['output']>;
  serproResponse: Maybe<SerproResponse>;
  userPreference: Maybe<UserPreference>;
};

/** The User NotificationGroups Response */
export type UserNotification = {
  __typename?: 'UserNotification';
  reportRequest: Maybe<ReportRequest>;
  type: UserNotificationTypeEnum;
};

/** The User Notification Type Enum */
export enum UserNotificationTypeEnum {
  /** Report Request */
  ReportRequest = 'REPORT_REQUEST'
}

/** The User Order By Enum */
export enum UserOrderByEnum {
  /** Data de criação */
  CreatedAt = 'CREATED_AT',
  /** Email do usuário */
  Email = 'EMAIL',
  /** ID */
  Id = 'ID',
  /** Último Login */
  LastLogin = 'LAST_LOGIN',
  /** Nome do usuário */
  Name = 'NAME',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

/** Available parameters to sort User */
export type UserOrderParams = {
  field?: InputMaybe<UserOrderByEnum>;
  order?: InputMaybe<SimpleSortingOrderEnum>;
};

/** Available parameters to paginate User */
export type UserPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserOrderParams>;
};

/** A User Preference */
export type UserPreference = {
  __typename?: 'UserPreference';
  cardSize: Maybe<CardSizeEnum>;
  datetimeFormat: Maybe<Scalars['String']['output']>;
  language: Maybe<Scalars['String']['output']>;
  timezone: Maybe<Scalars['String']['output']>;
};

/** The Users Query Response */
export type UsersResponse = {
  __typename?: 'UsersResponse';
  totalCount: Scalars['Int']['output'];
  users: Array<User>;
};

/** A Vehicle */
export type Vehicle = {
  __typename?: 'Vehicle';
  actor: Maybe<Actor>;
  id: Scalars['Int']['output'];
  isRefrigerated: Scalars['Boolean']['output'];
  plate: Scalars['String']['output'];
  speedLimitDry: Maybe<Scalars['Int']['output']>;
  speedLimitWet: Maybe<Scalars['Int']['output']>;
  tareWeightKg: Maybe<Scalars['Decimal']['output']>;
  temperatureMax: Maybe<Scalars['Int']['output']>;
  temperatureMin: Maybe<Scalars['Int']['output']>;
  trackerBrand: Maybe<TrackerBrandEnum>;
  trackerId: Maybe<Scalars['String']['output']>;
  type: VehicleTypeEnum;
};

/** The Vehicle Order By Enum */
export enum VehicleOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** É refrigerado */
  IsRefrigerated = 'IS_REFRIGERATED',
  /** Placa */
  Plate = 'PLATE',
  /** Limite de velocidade seco */
  SpeedLimitDry = 'SPEED_LIMIT_DRY',
  /** Limite de velocidade molhado */
  SpeedLimitWet = 'SPEED_LIMIT_WET',
  /** Peso da tara em kg */
  TareWeightKg = 'TARE_WEIGHT_KG',
  /** Temperatura máxima */
  TemperatureMax = 'TEMPERATURE_MAX',
  /** Temperatura mínima */
  TemperatureMin = 'TEMPERATURE_MIN',
  /** Marca de rastreio */
  TrackerBrand = 'TRACKER_BRAND',
  /** ID de rastreio */
  TrackerId = 'TRACKER_ID',
  /** Tipo */
  Type = 'TYPE',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

export type VehicleOrderParams = {
  field?: InputMaybe<VehicleOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Vehicles */
export type VehiclePaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VehicleOrderParams>>;
};

/** The Vehicle Type Enum */
export enum VehicleTypeEnum {
  /** Veículo de carga leve */
  Car = 'CAR',
  /** Cavalo Mecânico */
  Horse = 'HORSE',
  /** Cavalo Mecânico LS */
  MechanicalHorseDoubleAxis = 'MECHANICAL_HORSE_DOUBLE_AXIS',
  /** Moto */
  Motorcycle = 'MOTORCYCLE',
  /** Veículo de passeio */
  PassengerVehicle = 'PASSENGER_VEHICLE',
  /** Toco */
  SemiTruck = 'SEMI_TRUCK',
  /** VUC */
  ThreeQuarterTonTruck = 'THREE_QUARTER_TON_TRUCK',
  /** Truck */
  Truck = 'TRUCK',
  /** Furgão */
  Van = 'VAN'
}

/** A Version */
export type Version = {
  __typename?: 'Version';
  actor: Maybe<Actor>;
  apiKeyName: Maybe<Scalars['String']['output']>;
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  itemChanges: Scalars['JSON']['output'];
  itemId: Maybe<Scalars['Int']['output']>;
  itemType: Scalars['String']['output'];
  meta: Maybe<Scalars['JSON']['output']>;
  origin: Maybe<VersionOriginEnum>;
  originatorId: Maybe<Scalars['Int']['output']>;
  processedChanges: Maybe<Scalars['JSON']['output']>;
  user: Maybe<User>;
};

/** The Version Order By Enum */
export enum VersionOrderByEnum {
  /** Evento */
  Event = 'EVENT',
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Local de Origem */
  Origin = 'ORIGIN',
  /** ID do originador */
  OriginatorId = 'ORIGINATOR_ID'
}

/** Available parameters to order Versions */
export type VersionOrderParams = {
  field?: InputMaybe<VersionOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** The Version Origin Enum */
export enum VersionOriginEnum {
  /** API */
  Api = 'API',
  /** APP */
  App = 'APP',
  /** Automação */
  Automation = 'AUTOMATION',
  /** Externo */
  External = 'EXTERNAL',
  /** Automação Customizada */
  HookAutomation = 'HOOK_AUTOMATION',
  /** Tracking */
  Tracking = 'TRACKING'
}

/** Available parameters to paginate Versions */
export type VersionPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VersionOrderParams>>;
};

/** A Vessel */
export type Vessel = {
  __typename?: 'Vessel';
  aisClass: Maybe<AisClassEnum>;
  callsign: Maybe<Scalars['String']['output']>;
  country: Maybe<Country>;
  deadweight: Maybe<Scalars['Int']['output']>;
  dimensions: Maybe<Dimensions>;
  externalDataUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  grossTonnage: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  imoNumber: Maybe<Scalars['String']['output']>;
  isActiveMercante: Scalars['Boolean']['output'];
  lastPositionUpdate: Maybe<VesselPositionUpdate>;
  mmsiNumber: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  processes: Array<Process>;
  shipSubType: Maybe<ShipSubTypeEnum>;
  shipType: Maybe<ShipTypeEnum>;
};

/** The Vessel Order By Enum */
export enum VesselOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Nome */
  Name = 'NAME'
}

export type VesselOrderParams = {
  field?: InputMaybe<VesselOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** A Vessel Position Update */
export type VesselPositionUpdate = {
  __typename?: 'VesselPositionUpdate';
  aisUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  course: Maybe<Scalars['Float']['output']>;
  heading: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  positionRequestedAt: Maybe<Scalars['DateTime']['output']>;
  rot: Maybe<Scalars['Float']['output']>;
  speed: Maybe<Scalars['Float']['output']>;
  vessel: Vessel;
  voyageAtd: Maybe<Scalars['DateTime']['output']>;
  voyageDestination: Maybe<Scalars['String']['output']>;
  voyageDestinationPortName: Maybe<Scalars['String']['output']>;
  voyageDestinationPortUnlocode: Maybe<Scalars['String']['output']>;
  voyageEta: Maybe<Scalars['DateTime']['output']>;
  voyageOriginPortName: Maybe<Scalars['String']['output']>;
  voyageOriginPortUnlocode: Maybe<Scalars['String']['output']>;
  voyageUpdatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** A Vessel Schedule */
export type VesselSchedule = {
  __typename?: 'VesselSchedule';
  cargoDeadlineReference: Maybe<DeadlineDateReferenceEnum>;
  deadlineDates: Maybe<VesselScheduleDeadlineDates>;
  draftDeadlineReference: Maybe<DeadlineDateReferenceEnum>;
  foreignTradeShipment: ForeignTradeShipment;
  gateOpeningDeadlineReference: Maybe<GateOpeningDeadlineDateReferenceEnum>;
  id: Scalars['Int']['output'];
  portTerminalLastTrackingAt: Maybe<Scalars['DateTime']['output']>;
  portTerminalLastUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  portTerminalStatusResponse: VesselScheduleStatusResponseEnum;
  portTerminalVesselSchedules: Maybe<Array<PortTerminalVesselSchedule>>;
  sealineLastTrackingAt: Maybe<Scalars['DateTime']['output']>;
  sealineLastUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  sealineStatusResponse: VesselScheduleStatusResponseEnum;
  sealineVesselSchedules: Maybe<Array<SealineVesselSchedule>>;
  vgmDeadlineReference: Maybe<VgmDeadlineDateReferenceEnum>;
};

/** Calculated Deadline Dates for a Vessel Schedule based on Reference and Cargo Attributes */
export type VesselScheduleDeadlineDates = {
  __typename?: 'VesselScheduleDeadlineDates';
  cargoDeadline: Maybe<Scalars['DateTime']['output']>;
  draftDeadline: Maybe<Scalars['DateTime']['output']>;
  gateOpeningDeadline: Maybe<Scalars['DateTime']['output']>;
  vgmDeadline: Maybe<Scalars['DateTime']['output']>;
};

/** Deadline Date References for a Shipment, falling back to Operation defaults when not set on the Vessel Schedule */
export type VesselScheduleDeadlineReferences = {
  __typename?: 'VesselScheduleDeadlineReferences';
  cargoDeadlineReference: Maybe<DeadlineDateReferenceEnum>;
  draftDeadlineReference: Maybe<DeadlineDateReferenceEnum>;
  gateOpeningDeadlineReference: Maybe<GateOpeningDeadlineDateReferenceEnum>;
  vgmDeadlineReference: Maybe<VgmDeadlineDateReferenceEnum>;
};

/** The Status Response from the Vessel Schedule Integration Enum */
export enum VesselScheduleStatusResponseEnum {
  /** Encontrado */
  Found = 'FOUND',
  /** Dados inválidos */
  Invalid = 'INVALID',
  /** Não Encontrado */
  NotFound = 'NOT_FOUND',
  /** Pendente */
  Pending = 'PENDING',
  /** Armador não suportado */
  SealineNotSupported = 'SEALINE_NOT_SUPPORTED'
}

/** The VGM Deadline Date Reference Enum */
export enum VgmDeadlineDateReferenceEnum {
  /** Manual */
  Manual = 'MANUAL',
  /** Sealine */
  Sealine = 'SEALINE'
}

/** A Warehouse */
export type Warehouse = {
  __typename?: 'Warehouse';
  actor: Actor;
  dailyOutboundLimit: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastMeasurement: Maybe<Measurement>;
  latestWarehouseOrdersPerDay: Array<WarehouseOrder>;
  measurements: Array<Measurement>;
  packageBundleUnit: PackageUnitTypeEnum;
  packageUnit: PackageUnitTypeEnum;
  stockLimit: Scalars['Int']['output'];
};


/** A Warehouse */
export type WarehouseMeasurementsArgs = {
  pagination?: InputMaybe<MeasurementPaginationParams>;
};

/** A Warehouse Order */
export type WarehouseOrder = {
  __typename?: 'WarehouseOrder';
  id: Scalars['Int']['output'];
  items: Array<WarehouseOrderItem>;
  itemsCount: Maybe<Scalars['Int']['output']>;
  orderDatetime: Scalars['DateTime']['output'];
  packagesCount: Maybe<Scalars['Decimal']['output']>;
  warehouse: Warehouse;
};


/** A Warehouse Order */
export type WarehouseOrderItemsArgs = {
  pagination?: InputMaybe<WarehouseOrderItemPaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<WarehouseOrderTypeEnum>;
};


/** A Warehouse Order */
export type WarehouseOrderItemsCountArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  supplyOrigin?: InputMaybe<OriginTypeEnum>;
  type?: InputMaybe<WarehouseOrderTypeEnum>;
};


/** A Warehouse Order */
export type WarehouseOrderPackagesCountArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  supplyOrigin?: InputMaybe<OriginTypeEnum>;
  type?: InputMaybe<WarehouseOrderTypeEnum>;
};

/** A Warehouse Order Item */
export type WarehouseOrderItem = {
  __typename?: 'WarehouseOrderItem';
  extra: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  isHighRunner: Scalars['Boolean']['output'];
  product: Product;
  quantity: Scalars['Decimal']['output'];
  sector: Maybe<Scalars['String']['output']>;
  supplier: Maybe<Scalars['String']['output']>;
  supplyOrigin: OriginTypeEnum;
  type: WarehouseOrderTypeEnum;
};

/** The Warehouse Order Item Order By Enum */
export enum WarehouseOrderItemOrderByEnum {
  /** ID */
  Id = 'ID',
  /** Data de inserção */
  InsertedAt = 'INSERTED_AT',
  /** Quantidade */
  Quantity = 'QUANTITY',
  /** Setor */
  Sector = 'SECTOR',
  /** Origem dos suprimentos */
  SupplyOrigin = 'SUPPLY_ORIGIN',
  /** Tipo de Ordem */
  Type = 'TYPE',
  /** Última atualização */
  UpdatedAt = 'UPDATED_AT'
}

/** Available parameters to ordering Warehouse Order Item */
export type WarehouseOrderItemOrderParams = {
  field?: InputMaybe<WarehouseOrderItemOrderByEnum>;
  order?: InputMaybe<SortingOrderEnum>;
};

/** Available parameters to paginate Warehouse Order Item */
export type WarehouseOrderItemPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WarehouseOrderItemOrderParams>>;
};

/** The Warehouse Order Type Enum */
export enum WarehouseOrderTypeEnum {
  /** Entrada */
  Inbound = 'INBOUND',
  /** Saída */
  Outbound = 'OUTBOUND'
}

/** A webhook processor header */
export type WebhookProcessorHeader = {
  __typename?: 'WebhookProcessorHeader';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Parameters for a webhook processor header */
export type WebhookProcessorHeaderParams = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** A workspace */
export type Workspace = {
  __typename?: 'Workspace';
  accessGroups: Array<AccessGroup>;
  client: Maybe<Client>;
  currentAccessGroup: AccessGroup;
};

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  __typename?: '__EnumValue';
  name: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason: Maybe<Scalars['String']['output']>;
};

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  __typename?: '__Field';
  name: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  args: Array<__InputValue>;
  type: __Type;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason: Maybe<Scalars['String']['output']>;
};


/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __FieldArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  __typename?: '__InputValue';
  name: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  type: __Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason: Maybe<Scalars['String']['output']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  __typename?: '__Type';
  kind: __TypeKind;
  name: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  specifiedByURL: Maybe<Scalars['String']['output']>;
  fields: Maybe<Array<__Field>>;
  interfaces: Maybe<Array<__Type>>;
  possibleTypes: Maybe<Array<__Type>>;
  enumValues: Maybe<Array<__EnumValue>>;
  inputFields: Maybe<Array<__InputValue>>;
  ofType: Maybe<__Type>;
  isOneOf: Maybe<Scalars['Boolean']['output']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeInputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  Scalar = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  Object = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  Interface = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  Union = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  Enum = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  InputObject = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  List = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NonNull = 'NON_NULL'
}

export type DeleteLocationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteLocationMutation = { __typename?: 'RootMutationType', deleteAddress: { __typename?: 'Address', id: number } | null };

export type UpdateLocationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  params: UpdateAddressParams;
}>;


export type UpdateLocationMutation = { __typename?: 'RootMutationType', updateAddress: { __typename?: 'Address', id: number } | null };

export type AgentEntityRelatedEntitiesMapQueryVariables = Exact<{ [key: string]: never; }>;


export type AgentEntityRelatedEntitiesMapQuery = { __typename?: 'RootQueryType', agentEntityRelatedEntitiesMap: Array<{ __typename?: 'AgentEntityRelatedEntitiesMap', entity: AgentEntityTypeEnum, relatedEntities: Array<AgentRelatedEntityTypeEnum> }> };

export type ListProcessorsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListProcessorsQuery = { __typename?: 'RootQueryType', processors: Array<{ __typename?: 'Processor', defaultAction: ProcessorActionTypeEnum | null, description: string | null, icon: string, id: number, isAi: boolean, isReady: boolean, name: string | null, output: Array<ProcessorOutputTypeEnum> | null, targetEntities: Array<AgentEntityTypeEnum> | null }> };

export type CompleteRegistrationMutationVariables = Exact<{
  params: CompleteRegistrationParams;
}>;


export type CompleteRegistrationMutation = { __typename?: 'RootMutationType', completeRegistration: { __typename?: 'User', id: string | null, registrationComplete: boolean | null } | null };

export type UpsertCostPerExpenseMutationVariables = Exact<{
  processId: Scalars['Int']['input'];
  params: CreateCostPerExpenseParams;
}>;


export type UpsertCostPerExpenseMutation = { __typename?: 'RootMutationType', upsertCostPerExpense: { __typename?: 'CostPerExpense', id: number, cost: string | null, process: { __typename?: 'Process', id: number, costModelVersion: { __typename?: 'CostModelVersion', id: number, version: number, costModel: { __typename?: 'CostModel', id: number, name: string, hasPlannedCosts: boolean, currency: { __typename?: 'Currency', code: string, name: string } | null }, totals: { __typename?: 'CostModelVersionTotals', totalCosts: string | null, plannedCosts: string | null, deviation: string | null } | null, rootModelExpenses: Array<{ __typename?: 'CostModelExpense', id: number, precificationModel: CostModelExpenseConditionalPrecificationModelEnum | null, reference: CostModelExpenseReferenceEnum | null, referenceValue: string | null, referenceProductProrated: CostModelExpenseReferenceProductProratedEnum | null, childrenModelExpenses: Array<{ __typename?: 'CostModelExpense', id: number, precificationModel: CostModelExpenseConditionalPrecificationModelEnum | null, reference: CostModelExpenseReferenceEnum | null, referenceValue: string | null, referenceProductProrated: CostModelExpenseReferenceProductProratedEnum | null, childrenModelExpenses: Array<{ __typename?: 'CostModelExpense', id: number, precificationModel: CostModelExpenseConditionalPrecificationModelEnum | null, reference: CostModelExpenseReferenceEnum | null, referenceValue: string | null, referenceProductProrated: CostModelExpenseReferenceProductProratedEnum | null, cost: { __typename?: 'CostPerExpense', id: number, cost: string | null, plannedCost: string | null, deviation: string | null, costPerItems: Array<{ __typename?: 'CostPerItem', itemId: number, productId: number, cost: string | null, plannedCost: string | null, deviation: string | null }> } | null, costExpense: { __typename?: 'CostExpense', id: number, name: string, slug: string } }>, cost: { __typename?: 'CostPerExpense', id: number, cost: string | null, plannedCost: string | null, deviation: string | null, costPerItems: Array<{ __typename?: 'CostPerItem', itemId: number, productId: number, cost: string | null, plannedCost: string | null, deviation: string | null }> } | null, costExpense: { __typename?: 'CostExpense', id: number, name: string, slug: string } }>, cost: { __typename?: 'CostPerExpense', id: number, cost: string | null, plannedCost: string | null, deviation: string | null, costPerItems: Array<{ __typename?: 'CostPerItem', itemId: number, productId: number, cost: string | null, plannedCost: string | null, deviation: string | null }> } | null, costExpense: { __typename?: 'CostExpense', id: number, name: string, slug: string } }> } | null } } | null };

export type CloseCostMutationVariables = Exact<{
  processId: Scalars['Int']['input'];
}>;


export type CloseCostMutation = { __typename?: 'RootMutationType', closeCost: { __typename?: 'Process', id: number, costClosedAt: string | null } | null };

export type ReopenCostMutationVariables = Exact<{
  processId: Scalars['Int']['input'];
}>;


export type ReopenCostMutation = { __typename?: 'RootMutationType', reopenCost: { __typename?: 'Process', id: number, costClosedAt: string | null } | null };

export type GetBookingProposalQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetBookingProposalQuery = { __typename?: 'RootQueryType', bookingProposal: { __typename?: 'BookingProposal', id: number, number: string, serviceType: BookingProposalServiceTypeEnum | null, transitTimeDays: number | null, coLoader: string | null, routeNotes: string | null, conditions: string | null, originCosts: string | null, originFees: string | null, originDomesticFreight: string | null, internationalFreight: string | null, destinationCosts: string | null, destinationInlandFreight: string | null, total: string | null, representativeness: string | null, insertedAt: string, updatedAt: string, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string }, sealine: { __typename?: 'Sealine', id: number, name: string, nickname: string } | null, loadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, dischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, attachments: Array<{ __typename?: 'BookingProposalAttachment', id: number, originalFilename: string | null, downloadUrl: string | null }> } };

export type SiscomexAttributeFragmentFragment = { __typename?: 'SiscomexAttribute', code: string, validFromAt: string | null, validToAt: string | null, details: any | null };

export type LpcoFormFieldFragmentFragment = { __typename?: 'LpcoFormField', code: string | null, parentAttributeCode: string | null, values: Array<string>, compositeValue: any | null, measurementUnit: string | null, interveners: Array<any | null> | null, siscomexAttribute: { __typename?: 'SiscomexAttribute', code: string, validFromAt: string | null, validToAt: string | null, details: any | null } | null };

export type SiscomexDocumentFragmentFragment = { __typename?: 'SiscomexDocument', id: number, externalId: number | null, documentTypeName: string | null, fileName: string | null, attachedAt: string | null, read: boolean | null, discarded: boolean | null, keywords: Array<{ __typename?: 'SiscomexDocumentKeyword', externalId: number | null, name: string | null, content: string | null }> };

export type LpcoQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type LpcoQuery = { __typename?: 'RootQueryType', lpco: { __typename?: 'Lpco', id: number, number: string, lastUpdatedAt: string | null, registeredAt: string | null, statusUpdatedAt: string | null, status: LpcoSituationEnum | null, agency: string | null, name: string | null, operationType: LpcoOperationTypeEnum | null, extra: any | null, statusResponse: StatusResponseTypeEnum | null, modelCode: string | null, validityStart: string | null, validityEnd: string | null, transportMode: LpcoTransportModeEnum | null, channel: ChannelTypeEnum | null, accessKey: string | null, importerExporterDocument: string | null, extensionPending: boolean | null, rectificationPending: boolean | null, compatibilityPending: boolean | null, importLicenseNumber: string | null, billOfLadingNumber: string | null, shippedAt: string | null, cargoAvailableAt: string | null, feePaymentStatus: FeePaymentStatusEnum | null, additionalInformation: string | null, statusMessage: string | null, dueInClearance: string | null, insertedAt: string | null, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null, requirements: Array<{ __typename?: 'LpcoRequirement', number: number, status: StatusRequirementTypeEnum, date: string | null, response: string | null, responseDate: string | null, notice: string | null, description: string | null }>, history: Array<{ __typename?: 'LpcoHistory', status: LpcoSituationEnum | null, updatedAt: string | null, user: string | null, justification: string | null, reason: string | null, solicitation: string | null, solicitationStatus: string | null, updates: Array<{ __typename?: 'LpcoHistoryUpdate', code: string | null, origin: string | null, name: string | null, originalValue: string | null, updatedValue: string | null }> }>, balances: Array<{ __typename?: 'LpcoBalance', title: string | null, commercialQuantity: string | null, statisticalQuantity: string | null, vmle: string | null, netWeight: string | null, financedValue: string | null, saleConditionValue: string | null, vmleCurrency: string | null, financedValueCurrency: string | null, saleConditionValueCurrency: string | null }>, formFields: Array<{ __typename?: 'LpcoFormField', code: string | null, parentAttributeCode: string | null, values: Array<string>, compositeValue: any | null, measurementUnit: string | null, interveners: Array<any | null> | null, siscomexAttribute: { __typename?: 'SiscomexAttribute', code: string, validFromAt: string | null, validToAt: string | null, details: any | null } | null }>, lpcoNcms: Array<{ __typename?: 'LpcoNcm', ncmCode: string | null, itemNumber: number | null, productCode: string | null, productVersion: string | null, productRootCnpj: string | null, quotaIdentifier: string | null, quotaDistributionCriteria: string | null, quotaDistributionInstallment: string | null, fields: Array<{ __typename?: 'LpcoFormField', code: string | null, parentAttributeCode: string | null, values: Array<string>, compositeValue: any | null, measurementUnit: string | null, interveners: Array<any | null> | null, siscomexAttribute: { __typename?: 'SiscomexAttribute', code: string, validFromAt: string | null, validToAt: string | null, details: any | null } | null }>, attributes: Array<{ __typename?: 'LpcoFormField', code: string | null, parentAttributeCode: string | null, values: Array<string>, compositeValue: any | null, measurementUnit: string | null, interveners: Array<any | null> | null, siscomexAttribute: { __typename?: 'SiscomexAttribute', code: string, validFromAt: string | null, validToAt: string | null, details: any | null } | null }>, siscomexProduct: { __typename?: 'SiscomexProduct', id: number, code: string, denomination: string | null, description: string | null, version: string, rootCnpj: string, insertedAt: string | null, lastUpdatedAt: string | null, modality: SiscomexProductModalityEnum | null, situation: SiscomexProductSituationEnum | null, extra: any | null, productAttributes: Array<{ __typename?: 'SiscomexProductAttribute', code: string, value: string | null, details: any | null }> | null, product: { __typename?: 'Product', id: number, manufacturer: string | null, siscomexLastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null, country: { __typename?: 'Country', code: string } | null } } | null, ncm: { __typename?: 'Ncm', ncm: string, description: string | null, ncmSiscomexAttributes: Array<{ __typename?: 'NcmSiscomexAttribute', isRequired: boolean, isMultivalued: boolean, operationType: NcmSiscomexOperationTypeEnum, siscomexAttribute: { __typename?: 'SiscomexAttribute', code: string, validFromAt: string | null, validToAt: string | null, details: any | null } | null }> | null } | null }>, documents: Array<{ __typename?: 'SiscomexDocument', id: number, externalId: number | null, documentTypeName: string | null, fileName: string | null, attachedAt: string | null, read: boolean | null, discarded: boolean | null, keywords: Array<{ __typename?: 'SiscomexDocumentKeyword', externalId: number | null, name: string | null, content: string | null }> }>, dossiers: Array<{ __typename?: 'SiscomexDossier', id: number, number: string | null, typeName: string | null, createdAt: string | null, createdBy: string | null, documents: Array<{ __typename?: 'SiscomexDocument', id: number, externalId: number | null, documentTypeName: string | null, fileName: string | null, attachedAt: string | null, read: boolean | null, discarded: boolean | null, keywords: Array<{ __typename?: 'SiscomexDocumentKeyword', externalId: number | null, name: string | null, content: string | null }> }> }>, insights: Array<{ __typename?: 'Insight', id: number, explanation: string | null }> } | null };

export type LpcoSyncSubscriptionSubscriptionVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type LpcoSyncSubscriptionSubscription = { __typename?: 'RootSubscriptionType', lpcoSyncSubscription: { __typename?: 'LpcoSyncSubscriptionData', data: { __typename?: 'Lpco', id: number, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null, lastUpdatedAt: string | null } } };

export type SiscomexDocumentDownloadQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SiscomexDocumentDownloadQuery = { __typename?: 'RootQueryType', siscomexDocumentDownload: { __typename?: 'SiscomexDocumentDownload', fileName: string, contentType: string, base64Content: string } };

export type TriggerLpcoSyncMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type TriggerLpcoSyncMutation = { __typename?: 'RootMutationType', triggerLpcoSync: { __typename?: 'SyncTriggerResult', syncing: boolean } | null };

export type GetAgentsForDevModeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgentsForDevModeQuery = { __typename?: 'RootQueryType', agents: Array<{ __typename?: 'Agent', id: number, name: string, triggerType: AgentTriggerTypeEnum, canGenerateCurl: boolean, processor: { __typename?: 'Processor', id: number, name: string | null, icon: string }, triggerEventConfig: { __typename?: 'EventAgentConfig', entity: AgentEntityTypeEnum, event: AgentTriggerEventEnum, operationIds: Array<number> | null } | null, triggerRecurringConfig: { __typename?: 'RecurringAgentConfig', inputType: RecurringAgentInputTypeEnum, operationsInputConfig: { __typename?: 'RecurringOperationsInputConfig', entity: AgentEntityTypeEnum, operationIds: Array<number> } | null } | null }> };

export type RetryAgentTestMutationVariables = Exact<{
  agentExecutionId: Scalars['ID']['input'];
}>;


export type RetryAgentTestMutation = { __typename?: 'RootMutationType', retryAgentTest: { __typename?: 'AgentExecutionDetail', id: string } | null };

export type RunAgentTestMutationVariables = Exact<{
  params: RunAgentTestParams;
}>;


export type RunAgentTestMutation = { __typename?: 'RootMutationType', runAgentTest: { __typename?: 'AgentExecutionDetail', id: string } | null };

export type DeleteAutomationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteAutomationMutation = { __typename?: 'RootMutationType', deleteAutomation: { __typename?: 'Automation', id: number } | null };

export type GetAutomationsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  filters?: InputMaybe<FilterAutomationParams>;
}>;


export type GetAutomationsQuery = { __typename?: 'RootQueryType', operation: { __typename?: 'Operation', id: number, title: string, subtitle: string | null, automationsCount: number, processesFields: Array<{ __typename?: 'Path', label: string, path: string, type: PathTypeEnum, isList: boolean, options: Array<{ __typename?: 'PathFieldOption', label: string, value: string }> | null }>, ordersFields: Array<{ __typename?: 'Path', label: string, path: string, type: PathTypeEnum, isList: boolean, options: Array<{ __typename?: 'PathFieldOption', label: string, value: string }> | null }>, automations: Array<{ __typename?: 'Automation', id: number, name: string, type: AutomationTypeEnum, action: AutomationActionEnum, template: AutomationTemplateEnum, dateField: string, dateFieldLabel: string, dateTargetField: string | null, dateTargetFieldLabel: string | null, isEnabled: boolean, periodType: AutomationPeriodTypeEnum | null, periodAmount: number | null, confirmationField: string | null, confirmationFieldLabel: string | null, extra: any | null, pathFilters: any | null }> } | null };

export type UpdateAutomationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  params: UpdateAutomationParams;
}>;


export type UpdateAutomationMutation = { __typename?: 'RootMutationType', updateAutomation: { __typename?: 'Automation', id: number } | null };

export type BatchUpdateProcessesMutationMutationVariables = Exact<{
  processIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  params: UpdateProcessParams;
}>;


export type BatchUpdateProcessesMutationMutation = { __typename?: 'RootMutationType', batchUpdateProcesses: boolean | null };

export type GetProcessesDataQueryVariables = Exact<{
  filters?: InputMaybe<FilterProcessParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetProcessesDataQuery = { __typename?: 'RootQueryType', processes: Array<{ __typename?: 'Process', id: number, alertLevel: AlertLevelEnum, canceledAt: string | null, deletedAt: string | null, finishedAt: string | null, referenceCode: string, extraFields: any | null, operation: { __typename?: 'Operation', id: number, title: string, subtitle: string | null, type: OperationTypeEnum, subType: OperationSubTypeEnum, isSiscomexEnabled: boolean, isCeMercanteEnabled: boolean, acceptHourInNationalRoadTransports: boolean, operationPhases: Array<{ __typename?: 'OperationPhase', id: number, position: number, phase: { __typename?: 'Phase', id: number, phase: PhaseEnum }, components: Array<{ __typename?: 'Component', id: number, name: string, title: string | null, slug: string, props: any | null, position: number, extraFieldsDefinition: any | null, componentAccess: { __typename?: 'ComponentAccess', id: number, type: AccessEnum } }> }>, configProps: { __typename?: 'OperationConfigProps', isMultipleNationalRoadTransport: boolean, orderItemAdditionalFields: Array<string>, itemReference: ItemReferenceEnum }, operationAccess: { __typename?: 'OperationAccess', id: number, type: AccessEnum, canUpdateCancelledOrFinishedProcesses: boolean, canCloseOrReopenProcessesCosts: boolean, canSeeOrders: boolean }, actor: { __typename?: 'Actor', id: number, nickname: string, officialDocument: string | null, documentType: ActorDocumentTypeEnum | null }, operationHandlers: Array<{ __typename?: 'OperationHandler', id: number, owner: boolean, role: OperationHandlerEnum, isListedInDynamicList: boolean, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }> }, orders: Array<{ __typename?: 'Order', id: number, referenceCode: string }>, auditApprovalInfo: { __typename?: 'ProcessAuditApprovalInfo', approvedAt: string, approvedBy: { __typename?: 'User', id: string | null, name: string | null } } | null, auditItems: Array<{ __typename?: 'ProcessAuditItem', id: number, observations: string | null, checked: boolean | null, auditItem: { __typename?: 'AuditItem', id: number, name: string, showObservationsWhen: AuditItemShowObservationEnum } }>, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, bookingQuotation: { __typename?: 'BookingQuotation', id: number, agentNotes: string | null, documentIds: Array<number>, recipientIds: Array<number>, externalPagePublication: { __typename?: 'ExternalPagePublication', id: number, closesAt: string | null } } | null, documents: Array<{ __typename?: 'Document', id: number, type: DocumentTypeEnum, fileUrl: string, originalFilename: string, updatedAt: string, invoice: { __typename?: 'Invoice', id: number } | null, parentDocument: { __typename?: 'Document', id: number } | null, brazilianInvoiceInfo: { __typename?: 'BrazilianInvoice', accessKey: string, cfop: string | null, emittedAt: string, extra: string | null, number: string, type: string, sender: { __typename?: 'BrazilianInvoiceOriginator', cnpj: string | null, name: string, address: { __typename?: 'BrazilianInvoiceAddress', zip: string | null, street: string, number: string, neighborhood: string, city: string, state: string, country: string | null } | null }, transport: { __typename?: 'BrazilianInvoiceTransport', address: string | null, city: string | null, state: string | null, stateId: string | null, carrier: string | null, cnpj: string | null, brand: string | null, grossWeight: string | null, netWeight: string | null, quantity: string | null, specie: string | null, freightOnAccount: string, numeration: string | null, vehiclePlate: string | null }, tax: { __typename?: 'BrazilianInvoiceTax', base: string, discount: string, freight: string, importation: string, insurance: string, ipi: string, other: string, productValue: string, totalAmount: string, value: string }, products: Array<{ __typename?: 'BrazilianInvoiceProduct', code: string, description: string, ncm: string, unit: string, quantity: string, totalAmount: string, unitValue: string }>, issuer: { __typename?: 'BrazilianInvoiceOriginator', cnpj: string | null, name: string, stateId: string | null, address: { __typename?: 'BrazilianInvoiceAddress', zip: string | null, street: string, number: string, neighborhood: string, city: string, state: string, country: string | null } | null } } | null }>, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, ata: string | null, atd: string | null, eta: string | null, etd: string | null, type: ShipmentTypeEnum | null, receivedInWarehouseAt: string | null, departedFromWarehouseAt: string | null, warehouseFreeTimeDays: number, deliveredAt: string | null, insertedAt: string, statusResponse: StatusResponseTypeEnum, lastUpdatedAt: string | null, automaticTrackingEnabled: boolean, totalNetWeight: string | null, totalGrossWeight: string | null, cubageCubicMeters: string | null, ceMercanteNumber: string | null, ceMercanteAuthorizationStatus: ShipmentDocumentAuthorizationStatusEnum | null, ceMercanteLastSyncType: SiscomexSyncTypeEnum | null, ceMercanteLastSyncErrorMessage: string | null, ceMercanteData: { __typename?: 'CeMercanteData', id: number, number: string, issuedAt: string | null, insertedAt: string, cargoStatus: string | null, freightPaymentType: string | null, freightBasicCost: string | null, freightTotalCost: string | null, cargoDescription: string | null, grossWeightKg: string | null, hasDta: boolean | null, manifestArrivalAt: string | null, cargoPresenceInPrimaryZoneAt: string | null, cargoPresenceInSecondaryZoneAt: string | null, customsPlace: string | null, bl: string | null, consigneeDocument: string | null, consigneeExtraInfo: string | null, notes: string | null, extra: any | null, statusResponse: StatusResponseTypeEnum | null, lastUpdatedAt: string | null, cargoPresenceHistory: Array<{ __typename?: 'CeMercanteDataCargoPresenceHistory', ra: string | null, status: string | null, date: string | null, dtaNumber: string | null, syncedAt: string | null }>, containerSeals: Array<{ __typename?: 'CeMercanteDataContainerSeal', containerCode: string | null, sealCode: string | null, secondarySealCode: string | null }>, shippingAgency: { __typename?: 'Actor', id: number, officialDocument: string | null, nickname: string } | null, cargoManifests: Array<{ __typename?: 'CeMercanteDataCargoManifest', manifestNumber: string | null, loadingPortTerminal: string | null, dischargePortTerminal: string | null, loadingPortUnlocode: string | null, dischargePortUnlocode: string | null }>, freightCurrency: { __typename?: 'Currency', code: string, name: string } | null, originPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null, country: { __typename?: 'Country', code: string } | null } | null, destinationPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null, country: { __typename?: 'Country', code: string } | null } | null } | null, internationalTransportLegs: Array<{ __typename?: 'InternationalTransportLeg', arrivalPlace: string | null, departurePlace: string | null, etd: string | null, eta: string | null, atd: string | null, ata: string | null, modalType: ModalTypeEnum | null, voyage: string | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null } | null }>, hawbShipmentData: { __typename?: 'HawbShipmentData', id: number, status: string | null, hawb: string, extra: any | null, dtaNumber: string | null, vehiclePlateDta: string | null, departurePlaceDta: string | null, arrivalPlaceDta: string | null, ataDta: string | null, atdDta: string | null, loadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string }, unloadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } } | null, parcelShipments: Array<{ __typename?: 'ParcelShipment', id: number, ata: string | null, atd: string | null, eta: string | null, etd: string | null, status: ParcelShipmentStatusEnum, slug: string, trackingNumber: string, insertedAt: string, lastUpdatedAt: string | null, destinationAddress: string | null, originAddress: string | null, destinationCountry: { __typename?: 'Country', code: string, name: string } | null, events: Array<{ __typename?: 'ParcelShipmentEvent', address: string | null, date: string | null, status: string | null }>, originCountry: { __typename?: 'Country', code: string, name: string } | null, courier: { __typename?: 'Courier', id: number, logoUrl: string | null } | null }>, demurrage: { __typename?: 'Demurrage', id: number, freeTime: number | null, dailyRateUsd: string | null, calculations: { __typename?: 'DemurrageCalculations', totalExceedingDays: number, totalEstimatedCosts: string, totalDaysPaid: number, totalDaysToPay: number, averageCostPerDayUsd: string, totalOwedUsd: string, totalPaidUsd: string, totalToPayUsd: string } } | null, internationalFreight: { __typename?: 'InternationalFreight', id: number, freightForwarder: string | null, quotationNumber: string | null, plannedBoardingDate: string | null, freightCostPrepaid: string | null, freightCostCollect: string | null, freightCostRoad: string | null, freightCostTotal: string | null, type: InternationalFreightTypeEnum | null, bookingEta: string | null, bookingEtd: string | null, voyageNumber: string | null, cargoAttributes: Array<CargoAttributeEnum>, expectedSeparationAt: string | null, pickupLocation: string | null, currency: { __typename?: 'Currency', code: string } | null, portTerminal: { __typename?: 'PortTerminal', id: number, name: string } | null, bookingLoadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingDischargeAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingLoadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, sealine: { __typename?: 'Sealine', id: number, name: string, logoUrl: string | null } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } | null } | null, items: Array<{ __typename?: 'ForeignTradeItemShipment', id: number, quantity: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, unitValue: string | null, brazilianInvoiceUnitValue: string | null, totalValue: string | null, transportables: Array<{ __typename?: 'Transportable', id: number }>, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, balance: string | null, balanceShipped: string | null, lineNumber: number | null, lineReference: string, quantity: string | null, division: string | null, measurementUnitSap: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, sapByFactor: string | null, concessionAct: string | null, importTypeSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, orderModalTypeSap: string | null, orderAdjustedModalType: string | null, orderRequestedAt: string | null, planningRequestShippingAt: string | null, planningShippingAt: string | null, supplierSentAt: string | null, supplierConfirmationAt: string | null, supplierReadyLeadTimeDays: number | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierCalculatedReadyAt: string | null, supplierReadyDeviation: number | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedBoardingAt: string | null, shipmentPlannedArrivalAt: string | null, shipmentEstimatedBoardingAt: string | null, shipmentEstimatedArrivalAt: string | null, shipmentBoardingLeadTime: number | null, shipmentTransportLeadTime: number | null, customsEstimatedRegisterAt: string | null, customsRegisterLeadTime: number | null, customsEstimatedReleaseAt: string | null, customsReleaseLeadTime: number | null, factoryEstimatedDeliveryAt: string | null, factoryPlannedDeliveryAt: string | null, factoryDeliveryAt: string | null, factoryDeliveryLeadTime: number | null, adjustedCustomsRegisterLeadTime: number | null, adjustedCustomsReleaseLeadTime: number | null, adjustedFactoryDeliveryLeadTime: number | null, adjustedShipmentBoardingLeadTime: number | null, adjustedShipmentTransportLeadTime: number | null, adjustedSupplierReadyLeadTimeDays: number | null, assessmentSotd: string | null, itemStatus: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, invoiceIssuedAt: string | null, invoiceNumber: string | null, invoiceValue: string | null, invoiceType: string | null, deliveryNote: string | null, deliveryNoteIssuedAt: string | null, shippingDetailsDeliveryDate: string | null, quotationOpeningDate: string | null, purchaseOrder: { __typename?: 'PurchaseOrder', id: number, order: { __typename?: 'Order', id: number, referenceCode: string } }, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'PurchaseOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null, manufacturingCountry: { __typename?: 'Country', code: string } | null, purchaseCountry: { __typename?: 'Country', code: string } | null, dispatchingCountry: { __typename?: 'Country', code: string } | null } | null, salesOrderItem: { __typename?: 'SalesOrderItem', id: number, balance: string | null, balanceShipped: string | null, lineNumber: number | null, lineReference: string, quantity: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, dispatchNumber: string | null, measurementUnitSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedArrivalAt: string | null, shipmentPlannedBoardingAt: string | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierReadyDeviation: number | null, factoryDeliveryAt: string | null, factoryEstimatedDeliveryAt: string | null, itemStatus: string | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, necessityType: string | null, ubc: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, stockQuantity: string | null, clientApprovedAt: string | null, reservedStockQuantity: string | null, stockReservationAt: string | null, preliminaryPickingStartedAt: string | null, internalContainerReference: string | null, salesOrder: { __typename?: 'SalesOrder', id: number, order: { __typename?: 'Order', id: number, referenceCode: string } }, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'SalesOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null } | null }>, airTransportShipment: { __typename?: 'AirTransportShipment', id: number, type: AirTransportTypeEnum | null, awb: string | null, hawb: string | null, airline: { __typename?: 'Airline', id: number, name: string, logoUrl: string | null } | null, destinationAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string, country: { __typename?: 'Country', code: string } | null } | null, originAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string, country: { __typename?: 'Country', code: string } | null } | null } | null, roadTransportShipment: { __typename?: 'ForeignTradeRoadTransportShipment', id: number, type: ForeignTradeRoadTransportTypeEnum | null, crt: string | null, origin: string | null, destination: string | null } | null, maritimeTransportShipment: { __typename?: 'MaritimeTransportShipment', id: number, bl: string | null, booking: string | null, hbl: string | null, trackingNumber: string | null, trackingKey: TrackingKeyEnum | null, trackingKeyInsertedAt: string | null, trackingDischargePort: string | null, trackingLoadingPort: string | null, type: MaritimeTransportTypeEnum | null, voyageNumber: string | null, sealineOrigin: SealineOriginEnum | null, sealine: { __typename?: 'Sealine', id: number, name: string, logoUrl: string | null } | null, dischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null, country: { __typename?: 'Country', code: string } | null } | null, loadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null, country: { __typename?: 'Country', code: string } | null } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } | null } | null, pallets: Array<{ __typename?: 'ShipmentPallet', id: number, sizeType: PalletSizeTypeEnum, palletStandardId: number | null, lengthMm: number | null, widthMm: number | null, quantity: number, heightCm: number | null, palletStandard: { __typename?: 'PalletStandard', id: number, name: string | null, isoCode: string | null, eurCode: string | null } | null }>, transportables: Array<{ __typename?: 'Transportable', id: number, type: TransportableTypeEnum, container: { __typename?: 'Container', trackingApi: boolean, trackingManual: boolean, hidden: boolean, observations: string | null, id: number, code: string | null, type: ContainerTypeEnum | null, sizeFootType: ContainerSizeFootTypeEnum | null, loadType: LoadTypeEnum | null, maxWeightKg: string | null, grossWeightKg: string | null, tareWeightKg: string | null, sealCode: string | null, secondarySealCode: string | null, invoiceNumber: string | null, palletQuantity: number | null, isStackable: boolean | null, cubicMeters: string | null, dispatchNumber: string | null, transportDocument: string | null, actualReturnEmptyContainerAt: string | null, estimatedReturnEmptyContainerAt: string | null, demurrageDailyRateUsd: string | null, demurrageFreeTime: number | null, demurrageFreeTimeStartAt: string | null, route: string | null, internalReferenceCode: string | null, orderNumber: string | null, ncmCodes: Array<string> | null, htTreatment: boolean | null, htTreatmentAt: string | null, separationCompletedAt: string | null, estimatedStuffingAt: string | null, loadingScheduleAt: string | null, invoiceDocumentNumber: string | null, invoiceGrossWeight: string | null, invoiceValue: string | null, preStacking: boolean | null, preStackingReason: PreStackingReasonEnum | null, scaleExitAt: string | null, stackingScheduledAt: string | null, stackingStartedAt: string | null, portScheduledAt: string | null, portDepositDeadlineAt: string | null, portDepositAt: string | null, preStackingWarehouse: PreStackingWarehouseEnum | null, preStackingDays: number | null, emptyPickupAt: string | null, emptyReceivedAtFactory: string | null, oic: string | null, quantity: string | null, releasedForTripAt: string | null, washingValue: string | null, washingChargeReceivedAt: string | null, washingDamageStatus: ContainerWashingConclusionStatusEnum | null, washingTermStatus: ContainerWashingConclusionStatusEnum | null, washingTermDescription: ContainerWashingTermDescriptionEnum | null, washingServiceType: ContainerWashingServiceTypeEnum | null, washingPaymentStatus: ContainerWashingPaymentStatusEnum | null, washingPaymentAt: string | null, washingEmptyChecklist: boolean | null, washingDamageResult: ContainerWashingDamageResultEnum | null, washingInspection: string | null, debitNotes: Array<{ __typename?: 'DebitNote', coverageEndAt: string, coverageStartAt: string, daysCovered: number | null, id: number, number: string, payedAt: string | null, totalValueBrl: string | null, totalValueUsd: string, usdToBrlRate: string }>, demurrageCalculations: { __typename?: 'ContainerDemurrageCalculations', costPerDayBrl: string, costPerDayUsd: string, daysPaid: number, daysToPay: number, emptyReturnDeadline: string | null, estimatedCosts: string, exceedingDays: number, totalOwedBrl: string, totalOwedUsd: string, totalPaidBrl: string, totalPaidUsd: string, totalToPayBrl: string, totalToPayUsd: string } | null, events: Array<{ __typename?: 'ContainerEvent', datetime: string | null, estimated: boolean | null, place: string | null, status: string | null, transport: string | null, voyage: string | null }> } | null }>, shipmentDuimps: Array<{ __typename?: 'ShipmentDuimp', id: number, status: ShipmentDocumentAuthorizationStatusEnum, comments: string | null, insertedAt: string | null, automaticLinkOrigin: ShipmentDocumentAutomaticLinkOriginTypeEnum | null, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null, duimp: { __typename?: 'Duimp', id: number, channel: ChannelTypeEnum | null, customsClearedAt: string | null, deliveredAt: string | null, extra: any | null, lastUpdatedAt: string | null, number: string, registeredAt: string | null, status: DuimpStatusEnum | null, statusResponse: StatusResponseTypeEnum, statusUpdatedAt: string | null, version: number | null, importer: { __typename?: 'Actor', id: number, officialName: string, officialDocument: string | null, documentType: ActorDocumentTypeEnum | null, addresses: Array<{ __typename?: 'Address', id: number, country: string | null, state: string | null, city: string | null, street: string | null, number: string | null, postalCode: string | null, neighborhood: string | null, formattedAddress: string | null }> } | null } }>, shipmentImportDeclarations: Array<{ __typename?: 'ShipmentImportDeclaration', id: number, status: ShipmentDocumentAuthorizationStatusEnum, comments: string | null, insertedAt: string | null, automaticLinkOrigin: ShipmentDocumentAutomaticLinkOriginTypeEnum | null, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null, importDeclaration: { __typename?: 'ImportDeclaration', id: number, channel: ChannelTypeEnum | null, customsClearedAt: string | null, extra: any | null, lastUpdatedAt: string | null, number: string, registeredAt: string | null, status: ImportDeclarationStatusEnum | null, statusResponse: StatusResponseTypeEnum, statusUpdatedAt: string | null } }>, shipmentExportDeclarations: Array<{ __typename?: 'ShipmentExportDeclaration', id: number, comments: string | null, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null, exportDeclaration: { __typename?: 'ExportDeclaration', id: number, number: string, channel: ChannelExportDeclarationTypeEnum | null, extra: any | null, status: ExportDeclarationStatusEnum | null, statusResponse: StatusResponseTypeEnum, endorsedAt: string | null, customsClearedAt: string | null, registeredAt: string | null, insertedAt: string | null, lastUpdatedAt: string | null, events: Array<{ __typename?: 'ExportDeclarationEvent', action: ExportDeclarationEventActionEnum | null, date: string | null, extraInfo: string | null, responsible: string | null }> } }>, nationalRoadTransports: Array<{ __typename?: 'NationalRoadTransport', id: number, collectionScheduledAt: string | null, deliveryPlannedAt: string | null, isTransportTypeDta: boolean, loadType: LoadTypeEnum | null, roadTransportType: RoadTransportTypeEnum | null, transportFeatures: Array<TransportFeatureEnum>, quantityPallets: number | null, releasedForTransportAt: string | null, transportCompletedAt: string | null, legSlug: string, nationalRoadCarrier: { __typename?: 'Handler', id: number, actor: { __typename?: 'Actor', id: number, nickname: string }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null }, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum } } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, driverName: string | null, vehiclePlate: string | null, trailerPlate: string | null, position: number, driver: { __typename?: 'Driver', id: number, name: string } | null, vehicle: { __typename?: 'Vehicle', id: number, plate: string, trackerId: string | null } | null, trailer: { __typename?: 'Trailer', id: number, plate: string, trackerId: string | null } | null, phases: Array<{ __typename?: 'RoadTransportTripPhase', id: number, realizedAt: string | null, departureAt: string | null, estimatedRealizedAt: string | null, routePoint: { __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum } }>, transportables: Array<{ __typename?: 'Transportable', id: number }> }>, route: { __typename?: 'Route', id: number, name: string, active: boolean, points: Array<{ __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum, address: { __typename?: 'Address', id: number, city: string | null, country: string | null, name: string | null, number: string | null, postalCode: string | null, state: string | null, street: string | null, actor: { __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null } | null } | null }> } | null }>, shipmentImportLicenses: Array<{ __typename?: 'ShipmentImportLicense', id: number, status: ShipmentDocumentAuthorizationStatusEnum, comments: string | null, insertedAt: string | null, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null, importLicense: { __typename?: 'ImportLicense', id: number, approvedAt: string | null, extra: any | null, lastUpdatedAt: string | null, number: string, registeredAt: string | null, status: ImportLicenseStatusEnum | null, statusResponse: StatusResponseTypeEnum, statusUpdatedAt: string | null, importDeclaration: { __typename?: 'ImportDeclaration', id: number, number: string } | null } }>, invoices: Array<{ __typename?: 'Invoice', id: number, number: string, emittedAt: string, updatedAt: string, incoterm: IncotermTypeEnum, totalAmount: string, discount: string | null, finalValue: string, totalGrossWeightKg: string, items: Array<{ __typename?: 'InvoiceItem', id: number, productDescription: string | null, productSku: string, quantity: string, batchNumber: string | null, batchValidityDate: string | null, productionDate: string | null, totalAmount: string | null, unitaryAmount: string | null, totalGrossWeightKg: string | null, orderReferenceCode: string | null, orderItemLineReference: string | null, product: { __typename?: 'Product', id: number } | null, transportables: Array<{ __typename?: 'Transportable', id: number, container: { __typename?: 'Container', id: number, code: string | null } | null }> }>, currency: { __typename?: 'Currency', code: string } | null }>, vesselScheduleDeadlineReferences: { __typename?: 'VesselScheduleDeadlineReferences', draftDeadlineReference: DeadlineDateReferenceEnum | null, vgmDeadlineReference: VgmDeadlineDateReferenceEnum | null, cargoDeadlineReference: DeadlineDateReferenceEnum | null, gateOpeningDeadlineReference: GateOpeningDeadlineDateReferenceEnum | null } | null, vesselSchedule: { __typename?: 'VesselSchedule', id: number, sealineStatusResponse: VesselScheduleStatusResponseEnum, portTerminalStatusResponse: VesselScheduleStatusResponseEnum, sealineLastUpdatedAt: string | null, portTerminalLastUpdatedAt: string | null, deadlineDates: { __typename?: 'VesselScheduleDeadlineDates', draftDeadline: string | null, cargoDeadline: string | null, vgmDeadline: string | null, gateOpeningDeadline: string | null } | null, sealineVesselSchedules: Array<{ __typename?: 'SealineVesselSchedule', id: number, draftDeadline: string | null, cargoDeadline: string | null, specialCargoDraftDeadline: string | null, vgmDeadline: string | null, insertedAt: string | null }> | null, portTerminalVesselSchedules: Array<{ __typename?: 'PortTerminalVesselSchedule', id: number, draftDeadline: string | null, cargoDeadline: string | null, gateOpening: string | null, reeferGateOpening: string | null, insertedAt: string | null }> | null } | null } | null, handlers: Array<{ __typename?: 'Handler', id: number, reference: string | null, secondaryReference: string | null, businessUnit: string | null, actor: { __typename?: 'Actor', id: number, nickname: string, logoUrl: string | null }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null }, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, isListedInDynamicList: boolean, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean } }> }> };

export type CreateAutomationMutationVariables = Exact<{
  params: CreateAutomationParams;
}>;


export type CreateAutomationMutation = { __typename?: 'RootMutationType', createAutomation: { __typename?: 'Automation', id: number } | null };

export type CreateOrderMutationVariables = Exact<{
  params: CreateOrderParams;
}>;


export type CreateOrderMutation = { __typename?: 'RootMutationType', createOrder: { __typename?: 'Order', id: number, route: { __typename?: 'Route', id: number, name: string } | null } | null };

export type GetRoutesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRoutesQuery = { __typename?: 'RootQueryType', routes: Array<{ __typename?: 'Route', id: number, name: string, points: Array<{ __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum, address: { __typename?: 'Address', id: number, street: string | null, number: string | null, city: string | null, state: string | null, name: string | null } | null }> }> };

export type CreateProcessMutationVariables = Exact<{
  params: CreateProcessParams;
}>;


export type CreateProcessMutation = { __typename?: 'RootMutationType', createProcess: { __typename?: 'Process', id: number, finishedAt: string | null, alertLevel: AlertLevelEnum, referenceCode: string, ownerHandler: { __typename?: 'Handler', id: number } | null, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, type: ShipmentTypeEnum | null } | null } | null };

export type GetForeignTradeOrderDataFragment = { __typename?: 'Order', id: number, alertLevel: AlertLevelEnum, referenceCode: string, externalReferenceCode: string | null, canceledAt: string | null, finishedAt: string | null, insertedAt: string, type: OrderTypeEnum, extraFields: any | null, observations: string | null, subsidiary: { __typename?: 'Subsidiary', id: number, name: string, actor: { __typename?: 'Actor', id: number } } | null, handlers: Array<{ __typename?: 'Handler', id: number, reference: string | null, secondaryReference: string | null, businessUnit: string | null, actor: { __typename?: 'Actor', id: number }, partnership: { __typename?: 'Partnership', id: number, internalCode: string | null, nicknameWithFallback: string }, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, owner: boolean, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean, isListedInDynamicList: boolean } }>, ownerHandler: { __typename?: 'Handler', id: number, actor: { __typename?: 'Actor', id: number }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null }, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum } } | null, operation: { __typename?: 'Operation', id: number, title: string, subtitle: string | null, type: OperationTypeEnum, subType: OperationSubTypeEnum, actor: { __typename?: 'Actor', id: number }, operationAccess: { __typename?: 'OperationAccess', id: number, type: AccessEnum, canUpdateCancelledOrFinishedOrders: boolean }, operationPhases: Array<{ __typename?: 'OperationPhase', id: number, position: number, phase: { __typename?: 'Phase', id: number, phase: PhaseEnum } }>, operationHandlers: Array<{ __typename?: 'OperationHandler', id: number, owner: boolean, role: OperationHandlerEnum, isListedInDynamicList: boolean, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }>, orderModalHeaderConfigs: Array<{ __typename?: 'OperationModalHeaderConfig', label: string | null, value: string | null, type: PathConfigTypeEnum | null }>, orderComponents: Array<{ __typename?: 'Component', id: number, name: string, slug: string, props: any | null, position: number, extraFieldsDefinition: any | null, title: string | null, componentAccess: { __typename?: 'ComponentAccess', id: number, type: AccessEnum } }> }, salesOrder: { __typename?: 'SalesOrder', id: number, type: OrderTransactionTypeEnum, orderConfirmedAt: string | null, orderReceivedAt: string | null, items: Array<{ __typename?: 'SalesOrderItem', id: number, quantity: string | null, balance: string | null, balanceShipped: string | null, lineNumber: number | null, lineReference: string, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, dispatchNumber: string | null, measurementUnitSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedArrivalAt: string | null, shipmentPlannedBoardingAt: string | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierReadyDeviation: number | null, factoryDeliveryAt: string | null, factoryEstimatedDeliveryAt: string | null, itemStatus: string | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, necessityType: string | null, ubc: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, stockQuantity: string | null, clientApprovedAt: string | null, reservedStockQuantity: string | null, stockReservationAt: string | null, preliminaryPickingStartedAt: string | null, internalContainerReference: string | null, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'SalesOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null }> } | null, purchaseOrder: { __typename?: 'PurchaseOrder', id: number, type: OrderTransactionTypeEnum, supplierOrderAcceptedAt: string | null, supplierExpectedReadinessAt: string | null, supplierOrderSentAt: string | null, supplierReadinessAt: string | null, necessityDate: string | null, items: Array<{ __typename?: 'PurchaseOrderItem', id: number, quantity: string | null, balance: string | null, balanceShipped: string | null, division: string | null, lineNumber: number | null, lineReference: string, measurementUnitSap: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, sapByFactor: string | null, concessionAct: string | null, importTypeSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, orderModalTypeSap: string | null, orderAdjustedModalType: string | null, orderRequestedAt: string | null, planningRequestShippingAt: string | null, planningShippingAt: string | null, supplierSentAt: string | null, supplierConfirmationAt: string | null, supplierReadyLeadTimeDays: number | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierCalculatedReadyAt: string | null, supplierReadyDeviation: number | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedBoardingAt: string | null, shipmentPlannedArrivalAt: string | null, shipmentEstimatedBoardingAt: string | null, shipmentEstimatedArrivalAt: string | null, shipmentBoardingLeadTime: number | null, shipmentTransportLeadTime: number | null, customsEstimatedRegisterAt: string | null, customsRegisterLeadTime: number | null, customsEstimatedReleaseAt: string | null, customsReleaseLeadTime: number | null, factoryEstimatedDeliveryAt: string | null, factoryPlannedDeliveryAt: string | null, factoryDeliveryAt: string | null, factoryDeliveryLeadTime: number | null, adjustedCustomsRegisterLeadTime: number | null, adjustedCustomsReleaseLeadTime: number | null, adjustedFactoryDeliveryLeadTime: number | null, adjustedShipmentBoardingLeadTime: number | null, adjustedShipmentTransportLeadTime: number | null, adjustedSupplierReadyLeadTimeDays: number | null, assessmentSotd: string | null, itemStatus: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, invoiceIssuedAt: string | null, invoiceNumber: string | null, invoiceValue: string | null, invoiceType: string | null, deliveryNote: string | null, deliveryNoteIssuedAt: string | null, shippingDetailsDeliveryDate: string | null, quotationOpeningDate: string | null, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'PurchaseOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null, manufacturingCountry: { __typename?: 'Country', code: string } | null, purchaseCountry: { __typename?: 'Country', code: string } | null, dispatchingCountry: { __typename?: 'Country', code: string } | null }> } | null, processes: Array<{ __typename?: 'Process', id: number, finishedAt: string | null, referenceCode: string, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, orders: Array<{ __typename?: 'Order', id: number }>, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, items: Array<{ __typename?: 'ForeignTradeItemShipment', id: number, quantity: string | null, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, lineNumber: number | null, lineReference: string, productDescription: string | null, productMercosulCode: string | null, productTranslatedDescription: string | null, purchaseOrder: { __typename?: 'PurchaseOrder', id: number, order: { __typename?: 'Order', id: number, referenceCode: string } }, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> } } | null, salesOrderItem: { __typename?: 'SalesOrderItem', id: number, lineNumber: number | null, lineReference: string, productDescription: string | null, productMercosulCode: string | null, productTranslatedDescription: string | null, salesOrder: { __typename?: 'SalesOrder', id: number, order: { __typename?: 'Order', id: number, referenceCode: string } }, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> } } | null }> } | null }> };

export type GetForeignTradeOrderQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetForeignTradeOrderQuery = { __typename?: 'RootQueryType', order: { __typename?: 'Order', id: number, alertLevel: AlertLevelEnum, referenceCode: string, externalReferenceCode: string | null, canceledAt: string | null, finishedAt: string | null, insertedAt: string, type: OrderTypeEnum, extraFields: any | null, observations: string | null, subsidiary: { __typename?: 'Subsidiary', id: number, name: string, actor: { __typename?: 'Actor', id: number } } | null, handlers: Array<{ __typename?: 'Handler', id: number, reference: string | null, secondaryReference: string | null, businessUnit: string | null, actor: { __typename?: 'Actor', id: number }, partnership: { __typename?: 'Partnership', id: number, internalCode: string | null, nicknameWithFallback: string }, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, owner: boolean, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean, isListedInDynamicList: boolean } }>, ownerHandler: { __typename?: 'Handler', id: number, actor: { __typename?: 'Actor', id: number }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null }, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum } } | null, operation: { __typename?: 'Operation', id: number, title: string, subtitle: string | null, type: OperationTypeEnum, subType: OperationSubTypeEnum, actor: { __typename?: 'Actor', id: number }, operationAccess: { __typename?: 'OperationAccess', id: number, type: AccessEnum, canUpdateCancelledOrFinishedOrders: boolean }, operationPhases: Array<{ __typename?: 'OperationPhase', id: number, position: number, phase: { __typename?: 'Phase', id: number, phase: PhaseEnum } }>, operationHandlers: Array<{ __typename?: 'OperationHandler', id: number, owner: boolean, role: OperationHandlerEnum, isListedInDynamicList: boolean, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }>, orderModalHeaderConfigs: Array<{ __typename?: 'OperationModalHeaderConfig', label: string | null, value: string | null, type: PathConfigTypeEnum | null }>, orderComponents: Array<{ __typename?: 'Component', id: number, name: string, slug: string, props: any | null, position: number, extraFieldsDefinition: any | null, title: string | null, componentAccess: { __typename?: 'ComponentAccess', id: number, type: AccessEnum } }> }, salesOrder: { __typename?: 'SalesOrder', id: number, type: OrderTransactionTypeEnum, orderConfirmedAt: string | null, orderReceivedAt: string | null, items: Array<{ __typename?: 'SalesOrderItem', id: number, quantity: string | null, balance: string | null, balanceShipped: string | null, lineNumber: number | null, lineReference: string, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, dispatchNumber: string | null, measurementUnitSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedArrivalAt: string | null, shipmentPlannedBoardingAt: string | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierReadyDeviation: number | null, factoryDeliveryAt: string | null, factoryEstimatedDeliveryAt: string | null, itemStatus: string | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, necessityType: string | null, ubc: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, stockQuantity: string | null, clientApprovedAt: string | null, reservedStockQuantity: string | null, stockReservationAt: string | null, preliminaryPickingStartedAt: string | null, internalContainerReference: string | null, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'SalesOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null }> } | null, purchaseOrder: { __typename?: 'PurchaseOrder', id: number, type: OrderTransactionTypeEnum, supplierOrderAcceptedAt: string | null, supplierExpectedReadinessAt: string | null, supplierOrderSentAt: string | null, supplierReadinessAt: string | null, necessityDate: string | null, items: Array<{ __typename?: 'PurchaseOrderItem', id: number, quantity: string | null, balance: string | null, balanceShipped: string | null, division: string | null, lineNumber: number | null, lineReference: string, measurementUnitSap: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, sapByFactor: string | null, concessionAct: string | null, importTypeSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, orderModalTypeSap: string | null, orderAdjustedModalType: string | null, orderRequestedAt: string | null, planningRequestShippingAt: string | null, planningShippingAt: string | null, supplierSentAt: string | null, supplierConfirmationAt: string | null, supplierReadyLeadTimeDays: number | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierCalculatedReadyAt: string | null, supplierReadyDeviation: number | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedBoardingAt: string | null, shipmentPlannedArrivalAt: string | null, shipmentEstimatedBoardingAt: string | null, shipmentEstimatedArrivalAt: string | null, shipmentBoardingLeadTime: number | null, shipmentTransportLeadTime: number | null, customsEstimatedRegisterAt: string | null, customsRegisterLeadTime: number | null, customsEstimatedReleaseAt: string | null, customsReleaseLeadTime: number | null, factoryEstimatedDeliveryAt: string | null, factoryPlannedDeliveryAt: string | null, factoryDeliveryAt: string | null, factoryDeliveryLeadTime: number | null, adjustedCustomsRegisterLeadTime: number | null, adjustedCustomsReleaseLeadTime: number | null, adjustedFactoryDeliveryLeadTime: number | null, adjustedShipmentBoardingLeadTime: number | null, adjustedShipmentTransportLeadTime: number | null, adjustedSupplierReadyLeadTimeDays: number | null, assessmentSotd: string | null, itemStatus: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, invoiceIssuedAt: string | null, invoiceNumber: string | null, invoiceValue: string | null, invoiceType: string | null, deliveryNote: string | null, deliveryNoteIssuedAt: string | null, shippingDetailsDeliveryDate: string | null, quotationOpeningDate: string | null, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'PurchaseOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null, manufacturingCountry: { __typename?: 'Country', code: string } | null, purchaseCountry: { __typename?: 'Country', code: string } | null, dispatchingCountry: { __typename?: 'Country', code: string } | null }> } | null, processes: Array<{ __typename?: 'Process', id: number, finishedAt: string | null, referenceCode: string, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, orders: Array<{ __typename?: 'Order', id: number }>, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, items: Array<{ __typename?: 'ForeignTradeItemShipment', id: number, quantity: string | null, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, lineNumber: number | null, lineReference: string, productDescription: string | null, productMercosulCode: string | null, productTranslatedDescription: string | null, purchaseOrder: { __typename?: 'PurchaseOrder', id: number, order: { __typename?: 'Order', id: number, referenceCode: string } }, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> } } | null, salesOrderItem: { __typename?: 'SalesOrderItem', id: number, lineNumber: number | null, lineReference: string, productDescription: string | null, productMercosulCode: string | null, productTranslatedDescription: string | null, salesOrder: { __typename?: 'SalesOrder', id: number, order: { __typename?: 'Order', id: number, referenceCode: string } }, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> } } | null }> } | null }> } | null };

export type GetOrderPdfDocumentsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOrderPdfDocumentsQuery = { __typename?: 'RootQueryType', order: { __typename?: 'Order', id: number, pdfDocuments: Array<{ __typename?: 'PdfDocumentBase', id: number, name: any, props: any | null }> } | null };

export type GetOrderPdfDocumentByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  pdfDocumentId: Scalars['Int']['input'];
}>;


export type GetOrderPdfDocumentByIdQuery = { __typename?: 'RootQueryType', order: { __typename?: 'Order', id: number, pdfDocument: { __typename?: 'PdfDocument', id: number, name: any, header: any, props: any | null, sections: Array<{ __typename?: 'PdfSection', id: number, props: any | null, name: any, position: number, rows: Array<{ __typename?: 'PdfRow', id: number, fields: any, props: any | null, position: number }> }> } | null, operation: { __typename?: 'Operation', id: number, actor: { __typename?: 'Actor', id: number, logoUrl: string | null } } } | null };

export type OrderSubscriptionSubscriptionVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type OrderSubscriptionSubscription = { __typename?: 'RootSubscriptionType', order: { __typename?: 'OrderSubscription', data: { __typename?: 'Order', id: number, alertLevel: AlertLevelEnum, referenceCode: string, externalReferenceCode: string | null, canceledAt: string | null, finishedAt: string | null, insertedAt: string, type: OrderTypeEnum, extraFields: any | null, observations: string | null, subsidiary: { __typename?: 'Subsidiary', id: number, name: string, actor: { __typename?: 'Actor', id: number } } | null, handlers: Array<{ __typename?: 'Handler', id: number, reference: string | null, secondaryReference: string | null, businessUnit: string | null, actor: { __typename?: 'Actor', id: number }, partnership: { __typename?: 'Partnership', id: number, internalCode: string | null, nicknameWithFallback: string }, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, owner: boolean, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean, isListedInDynamicList: boolean } }>, ownerHandler: { __typename?: 'Handler', id: number, actor: { __typename?: 'Actor', id: number }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null }, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum } } | null, operation: { __typename?: 'Operation', id: number, title: string, subtitle: string | null, type: OperationTypeEnum, subType: OperationSubTypeEnum, actor: { __typename?: 'Actor', id: number }, operationAccess: { __typename?: 'OperationAccess', id: number, type: AccessEnum, canUpdateCancelledOrFinishedOrders: boolean }, operationPhases: Array<{ __typename?: 'OperationPhase', id: number, position: number, phase: { __typename?: 'Phase', id: number, phase: PhaseEnum } }>, operationHandlers: Array<{ __typename?: 'OperationHandler', id: number, owner: boolean, role: OperationHandlerEnum, isListedInDynamicList: boolean, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }>, orderModalHeaderConfigs: Array<{ __typename?: 'OperationModalHeaderConfig', label: string | null, value: string | null, type: PathConfigTypeEnum | null }>, orderComponents: Array<{ __typename?: 'Component', id: number, name: string, slug: string, props: any | null, position: number, extraFieldsDefinition: any | null, title: string | null, componentAccess: { __typename?: 'ComponentAccess', id: number, type: AccessEnum } }> }, salesOrder: { __typename?: 'SalesOrder', id: number, type: OrderTransactionTypeEnum, orderConfirmedAt: string | null, orderReceivedAt: string | null, items: Array<{ __typename?: 'SalesOrderItem', id: number, quantity: string | null, balance: string | null, balanceShipped: string | null, lineNumber: number | null, lineReference: string, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, dispatchNumber: string | null, measurementUnitSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedArrivalAt: string | null, shipmentPlannedBoardingAt: string | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierReadyDeviation: number | null, factoryDeliveryAt: string | null, factoryEstimatedDeliveryAt: string | null, itemStatus: string | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, necessityType: string | null, ubc: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, stockQuantity: string | null, clientApprovedAt: string | null, reservedStockQuantity: string | null, stockReservationAt: string | null, preliminaryPickingStartedAt: string | null, internalContainerReference: string | null, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'SalesOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null }> } | null, purchaseOrder: { __typename?: 'PurchaseOrder', id: number, type: OrderTransactionTypeEnum, supplierOrderAcceptedAt: string | null, supplierExpectedReadinessAt: string | null, supplierOrderSentAt: string | null, supplierReadinessAt: string | null, necessityDate: string | null, items: Array<{ __typename?: 'PurchaseOrderItem', id: number, quantity: string | null, balance: string | null, balanceShipped: string | null, division: string | null, lineNumber: number | null, lineReference: string, measurementUnitSap: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, sapByFactor: string | null, concessionAct: string | null, importTypeSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, orderModalTypeSap: string | null, orderAdjustedModalType: string | null, orderRequestedAt: string | null, planningRequestShippingAt: string | null, planningShippingAt: string | null, supplierSentAt: string | null, supplierConfirmationAt: string | null, supplierReadyLeadTimeDays: number | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierCalculatedReadyAt: string | null, supplierReadyDeviation: number | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedBoardingAt: string | null, shipmentPlannedArrivalAt: string | null, shipmentEstimatedBoardingAt: string | null, shipmentEstimatedArrivalAt: string | null, shipmentBoardingLeadTime: number | null, shipmentTransportLeadTime: number | null, customsEstimatedRegisterAt: string | null, customsRegisterLeadTime: number | null, customsEstimatedReleaseAt: string | null, customsReleaseLeadTime: number | null, factoryEstimatedDeliveryAt: string | null, factoryPlannedDeliveryAt: string | null, factoryDeliveryAt: string | null, factoryDeliveryLeadTime: number | null, adjustedCustomsRegisterLeadTime: number | null, adjustedCustomsReleaseLeadTime: number | null, adjustedFactoryDeliveryLeadTime: number | null, adjustedShipmentBoardingLeadTime: number | null, adjustedShipmentTransportLeadTime: number | null, adjustedSupplierReadyLeadTimeDays: number | null, assessmentSotd: string | null, itemStatus: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, invoiceIssuedAt: string | null, invoiceNumber: string | null, invoiceValue: string | null, invoiceType: string | null, deliveryNote: string | null, deliveryNoteIssuedAt: string | null, shippingDetailsDeliveryDate: string | null, quotationOpeningDate: string | null, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'PurchaseOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null, manufacturingCountry: { __typename?: 'Country', code: string } | null, purchaseCountry: { __typename?: 'Country', code: string } | null, dispatchingCountry: { __typename?: 'Country', code: string } | null }> } | null, processes: Array<{ __typename?: 'Process', id: number, finishedAt: string | null, referenceCode: string, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, orders: Array<{ __typename?: 'Order', id: number }>, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, items: Array<{ __typename?: 'ForeignTradeItemShipment', id: number, quantity: string | null, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, lineNumber: number | null, lineReference: string, productDescription: string | null, productMercosulCode: string | null, productTranslatedDescription: string | null, purchaseOrder: { __typename?: 'PurchaseOrder', id: number, order: { __typename?: 'Order', id: number, referenceCode: string } }, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> } } | null, salesOrderItem: { __typename?: 'SalesOrderItem', id: number, lineNumber: number | null, lineReference: string, productDescription: string | null, productMercosulCode: string | null, productTranslatedDescription: string | null, salesOrder: { __typename?: 'SalesOrder', id: number, order: { __typename?: 'Order', id: number, referenceCode: string } }, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> } } | null }> } | null }> } | null, latestVersion: { __typename?: 'Version', id: number, origin: VersionOriginEnum | null, user: { __typename?: 'User', id: string | null, email: string | null } | null } | null } };

export type ListLocalesQueryVariables = Exact<{
  filters?: InputMaybe<FilterAddressesParams>;
}>;


export type ListLocalesQuery = { __typename?: 'RootQueryType', addresses: Array<{ __typename?: 'Address', id: number, city: string | null, country: string | null, latitude: string, longitude: string, name: string | null, number: string | null, postalCode: string | null, state: string | null, street: string | null, neighborhood: string | null, actor: { __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null } | null }> };

export type GetOrderAutomationsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOrderAutomationsQuery = { __typename?: 'RootQueryType', order: { __typename?: 'Order', id: number, automationOrders: Array<{ __typename?: 'AutomationOrder', id: number, triggeredAt: string, action: AutomationActionEnum, automation: { __typename?: 'Automation', id: number, name: string, type: AutomationTypeEnum, confirmationField: string | null, confirmationFieldLabel: string | null, dateField: string, dateFieldLabel: string, dateTargetField: string | null, dateTargetFieldLabel: string | null, isEnabled: boolean, periodAmount: number | null, periodType: AutomationPeriodTypeEnum | null, template: AutomationTemplateEnum, extra: any | null, pathFilters: any | null } }> } | null };

export type ApproveOrderAuditMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ApproveOrderAuditMutation = { __typename?: 'RootMutationType', approveOrderAudit: { __typename?: 'Order', id: number } | null };

export type CancelOrUncancelOrderMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  cancelled: Scalars['Boolean']['input'];
}>;


export type CancelOrUncancelOrderMutation = { __typename?: 'RootMutationType', cancelOrUncancelOrder: { __typename?: 'Order', id: number } | null };

export type DeleteOrderMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteOrderMutation = { __typename?: 'RootMutationType', deleteOrder: { __typename?: 'Order', id: number } | null };

export type FinishOrUnfinishOrderMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  finished: Scalars['Boolean']['input'];
}>;


export type FinishOrUnfinishOrderMutation = { __typename?: 'RootMutationType', finishOrUnfinishOrder: { __typename?: 'Order', id: number, finishedAt: string | null } | null };

export type GetDocumentsSectionDataQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetDocumentsSectionDataQuery = { __typename?: 'RootQueryType', order: { __typename?: 'Order', id: number, leadTimeDatetimeReference: string | null, route: { __typename?: 'Route', id: number, name: string, points: Array<{ __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum, address: { __typename?: 'Address', id: number, city: string | null, country: string | null, name: string | null, number: string | null, postalCode: string | null, state: string | null, street: string | null } | null }> } | null, roadTransportOrder: { __typename?: 'RoadTransportOrder', id: number, bl: string | null, diOrDta: string | null, storageExpiration: string | null, type: RoadTransportOrderTypeEnum, vessel: string | null, voyage: string | null, port: string | null, importer: string | null, roadTransportShipments: Array<{ __typename?: 'RoadTransportShipment', id: number, vehicle: { __typename?: 'Vehicle', id: number, type: VehicleTypeEnum, trackerBrand: TrackerBrandEnum | null, trackerId: string | null, plate: string } | null, shipmentDrivers: Array<{ __typename?: 'RoadTransportShipmentDriver', id: number, driver: { __typename?: 'Driver', id: number, name: string } }>, shipmentTrailers: Array<{ __typename?: 'ShipmentTrailer', id: number, trailer: { __typename?: 'Trailer', id: number, type: TrailerTypeEnum, plate: string } }>, transportables: Array<{ __typename?: 'Transportable', id: number, type: TransportableTypeEnum, container: { __typename?: 'Container', id: number, type: ContainerTypeEnum | null, sealCode: string | null } | null }> }> } | null } | null };

export type GetOrderDataQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  filters?: InputMaybe<FilterProcessParams>;
}>;


export type GetOrderDataQuery = { __typename?: 'RootQueryType', order: { __typename?: 'Order', id: number, alertLevel: AlertLevelEnum, referenceCode: string, externalReferenceCode: string | null, type: OrderTypeEnum, insertedAt: string, finishedAt: string | null, leadTimeDatetimeReference: string | null, observations: string | null, subsidiary: { __typename?: 'Subsidiary', id: number, name: string, actor: { __typename?: 'Actor', id: number } } | null, handlers: Array<{ __typename?: 'Handler', id: number, reference: string | null, secondaryReference: string | null, businessUnit: string | null, actor: { __typename?: 'Actor', id: number }, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean } }>, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, auditApprovalInfo: { __typename?: 'OrderAuditApprovalInfo', approvedAt: string, approvedBy: { __typename?: 'User', id: string | null, name: string | null } } | null, auditItems: Array<{ __typename?: 'OrderAuditItem', id: number, observations: string | null, checked: boolean | null, auditItem: { __typename?: 'AuditItem', id: number, name: string, showObservationsWhen: AuditItemShowObservationEnum } }>, handler: { __typename?: 'Handler', id: number, reference: string | null, secondaryReference: string | null, actor: { __typename?: 'Actor', id: number, nickname: string, officialDocument: string | null, documentType: ActorDocumentTypeEnum | null, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }, operationHandler: { __typename?: 'OperationHandler', id: number, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean } } | null, route: { __typename?: 'Route', id: number, name: string, points: Array<{ __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum, address: { __typename?: 'Address', id: number, city: string | null, country: string | null, name: string | null, number: string | null, postalCode: string | null, state: string | null, street: string | null, actor: { __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null } | null } | null }> } | null, operation: { __typename?: 'Operation', id: number, title: string, subtitle: string | null, type: OperationTypeEnum, subType: OperationSubTypeEnum, operationAccess: { __typename?: 'OperationAccess', id: number, type: AccessEnum }, operationPhases: Array<{ __typename?: 'OperationPhase', id: number, position: number, phase: { __typename?: 'Phase', id: number, phase: PhaseEnum } }>, actor: { __typename?: 'Actor', id: number, nickname: string, officialDocument: string | null, documentType: ActorDocumentTypeEnum | null, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null } }, documents: Array<{ __typename?: 'Document', id: number, type: DocumentTypeEnum, fileUrl: string, originalFilename: string }>, salesOrder: { __typename?: 'SalesOrder', id: number, type: OrderTransactionTypeEnum, orderConfirmedAt: string | null, orderReceivedAt: string | null, items: Array<{ __typename?: 'SalesOrderItem', id: number, quantity: string | null, balance: string | null, balanceShipped: string | null, lineNumber: number | null, productDescription: string | null, product: { __typename?: 'Product', id: number, code: string } }> } | null, purchaseOrder: { __typename?: 'PurchaseOrder', id: number, type: OrderTransactionTypeEnum, supplierOrderAcceptedAt: string | null, supplierExpectedReadinessAt: string | null, supplierOrderSentAt: string | null, necessityDate: string | null, items: Array<{ __typename?: 'PurchaseOrderItem', id: number, quantity: string | null, balance: string | null, balanceShipped: string | null, lineNumber: number | null, division: string | null, productDescription: string | null, product: { __typename?: 'Product', id: number, code: string } }> } | null, roadTransportOrder: { __typename?: 'RoadTransportOrder', id: number, bl: string | null, diOrDta: string | null, storageExpiration: string | null, releasedForTransport: string | null, schedulingFinishedAt: string | null, type: RoadTransportOrderTypeEnum, vessel: string | null, voyage: string | null, port: string | null, importer: string | null, observations: string | null, transportSpecifications: Array<TransportSpecificationEnum>, booking: string | null, draftDeadline: string | null, cargoDeadline: string | null, destinationCountry: string | null, sealine: { __typename?: 'Sealine', id: number, name: string, nickname: string } | null, roadTransportShipments: Array<{ __typename?: 'RoadTransportShipment', id: number, clientArrivalAt: string | null, clientDepartureAt: string | null, invoiceExchangeStartAt: string | null, invoiceExchangeEndAt: string | null, startAt: string | null, endAt: string | null, emptyContainerReturnScheduledDate: string | null, arrivalInTerminalScheduledDate: string | null, vehicle: { __typename?: 'Vehicle', id: number, isRefrigerated: boolean, plate: string, speedLimitDry: number | null, speedLimitWet: number | null, tareWeightKg: string | null, temperatureMax: number | null, temperatureMin: number | null, trackerBrand: TrackerBrandEnum | null, trackerId: string | null, type: VehicleTypeEnum } | null, shipmentDrivers: Array<{ __typename?: 'RoadTransportShipmentDriver', id: number, ciot: string | null, missingAmount: string | null, isFullyPaid: boolean, totalAmountToPay: string | null, amountPaidInAdvance: string | null, driver: { __typename?: 'Driver', id: number, name: string, cpf: string | null, licenseNumber: string | null, licenseCategory: string | null }, roadTransportShipment: { __typename?: 'RoadTransportShipment', id: number } }>, shipmentTrailers: Array<{ __typename?: 'ShipmentTrailer', id: number, trailer: { __typename?: 'Trailer', id: number, isRefrigerated: boolean, plate: string, speedLimitDry: number | null, speedLimitWet: number | null, tareWeightKg: string | null, temperatureMax: number | null, temperatureMin: number | null, trackerBrand: TrackerBrandEnum | null, trackerId: string | null, type: TrailerTypeEnum } }>, transportables: Array<{ __typename?: 'Transportable', id: number, type: TransportableTypeEnum, container: { __typename?: 'Container', id: number, code: string | null, grossWeightKg: string | null, invoiceNumber: string | null, sealCode: string | null, secondarySealCode: string | null, sizeFootType: ContainerSizeFootTypeEnum | null, tareWeightKg: string | null, loadType: LoadTypeEnum | null, maxWeightKg: string | null, type: ContainerTypeEnum | null, isStackable: boolean | null, cubicMeters: string | null, dispatchNumber: string | null, transportDocument: string | null } | null }> }>, transportables: Array<{ __typename?: 'Transportable', id: number, type: TransportableTypeEnum, cargo: { __typename?: 'Cargo', id: number, cubicWeight: string | null, dimensions: string | null, measurementUnit: MeasurementUnitEnum, quantity: string, volumeCubicMeters: string | null, weightKg: string | null } | null, container: { __typename?: 'Container', id: number, code: string | null, grossWeightKg: string | null, maxWeightKg: string | null, loadType: LoadTypeEnum | null, sealCode: string | null, secondarySealCode: string | null, sizeFootType: ContainerSizeFootTypeEnum | null, tareWeightKg: string | null, invoiceNumber: string | null, type: ContainerTypeEnum | null, isStackable: boolean | null, cubicMeters: string | null, dispatchNumber: string | null, transportDocument: string | null } | null, roadTransportShipment: { __typename?: 'RoadTransportShipment', id: number } | null }> } | null, processes: Array<{ __typename?: 'Process', id: number, finishedAt: string | null, referenceCode: string, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, orders: Array<{ __typename?: 'Order', id: number }>, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, items: Array<{ __typename?: 'ForeignTradeItemShipment', id: number, quantity: string | null, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, productDescription: string | null, product: { __typename?: 'Product', id: number, code: string } } | null }> } | null }> } | null };

export type UpdateOrderMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  params: UpdateOrderParams;
}>;


export type UpdateOrderMutation = { __typename?: 'RootMutationType', updateOrder: { __typename?: 'Order', id: number } | null };

export type UploadDocumentsToOrderMutationVariables = Exact<{
  orderId: Scalars['Int']['input'];
  params: Array<CreateDocumentParams> | CreateDocumentParams;
}>;


export type UploadDocumentsToOrderMutation = { __typename?: 'RootMutationType', uploadDocumentsToOrder: Array<{ __typename?: 'Document', id: number }> };

export type GetProcessAutomationsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetProcessAutomationsQuery = { __typename?: 'RootQueryType', process: { __typename?: 'Process', id: number, automationProcesses: Array<{ __typename?: 'AutomationProcess', id: number, triggeredAt: string, action: AutomationActionEnum, automation: { __typename?: 'Automation', id: number, name: string, confirmationField: string | null, confirmationFieldLabel: string | null, dateField: string, dateFieldLabel: string, dateTargetField: string | null, dateTargetFieldLabel: string | null, isEnabled: boolean, periodAmount: number | null, periodType: AutomationPeriodTypeEnum | null, template: AutomationTemplateEnum, extra: any | null, pathFilters: any | null } }> } | null };

export type CostModelExpenseFieldsFragment = { __typename?: 'CostModelExpense', id: number, precificationModel: CostModelExpenseConditionalPrecificationModelEnum | null, reference: CostModelExpenseReferenceEnum | null, referenceValue: string | null, referenceProductProrated: CostModelExpenseReferenceProductProratedEnum | null, cost: { __typename?: 'CostPerExpense', id: number, cost: string | null, plannedCost: string | null, deviation: string | null, costPerItems: Array<{ __typename?: 'CostPerItem', itemId: number, productId: number, cost: string | null, plannedCost: string | null, deviation: string | null }> } | null, costExpense: { __typename?: 'CostExpense', id: number, name: string, slug: string } };

export type ChildrenModelExpensesFragment = { __typename?: 'CostModelExpense', id: number, precificationModel: CostModelExpenseConditionalPrecificationModelEnum | null, reference: CostModelExpenseReferenceEnum | null, referenceValue: string | null, referenceProductProrated: CostModelExpenseReferenceProductProratedEnum | null, childrenModelExpenses: Array<{ __typename?: 'CostModelExpense', id: number, precificationModel: CostModelExpenseConditionalPrecificationModelEnum | null, reference: CostModelExpenseReferenceEnum | null, referenceValue: string | null, referenceProductProrated: CostModelExpenseReferenceProductProratedEnum | null, childrenModelExpenses: Array<{ __typename?: 'CostModelExpense', id: number, precificationModel: CostModelExpenseConditionalPrecificationModelEnum | null, reference: CostModelExpenseReferenceEnum | null, referenceValue: string | null, referenceProductProrated: CostModelExpenseReferenceProductProratedEnum | null, cost: { __typename?: 'CostPerExpense', id: number, cost: string | null, plannedCost: string | null, deviation: string | null, costPerItems: Array<{ __typename?: 'CostPerItem', itemId: number, productId: number, cost: string | null, plannedCost: string | null, deviation: string | null }> } | null, costExpense: { __typename?: 'CostExpense', id: number, name: string, slug: string } }>, cost: { __typename?: 'CostPerExpense', id: number, cost: string | null, plannedCost: string | null, deviation: string | null, costPerItems: Array<{ __typename?: 'CostPerItem', itemId: number, productId: number, cost: string | null, plannedCost: string | null, deviation: string | null }> } | null, costExpense: { __typename?: 'CostExpense', id: number, name: string, slug: string } }>, cost: { __typename?: 'CostPerExpense', id: number, cost: string | null, plannedCost: string | null, deviation: string | null, costPerItems: Array<{ __typename?: 'CostPerItem', itemId: number, productId: number, cost: string | null, plannedCost: string | null, deviation: string | null }> } | null, costExpense: { __typename?: 'CostExpense', id: number, name: string, slug: string } };

export type UnitaryCostFragmentFragment = { __typename?: 'UnitaryCost', cost: string | null, deviation: string | null, plannedCost: string | null };

export type GetProcessCostsQueryVariables = Exact<{
  processId: Scalars['Int']['input'];
}>;


export type GetProcessCostsQuery = { __typename?: 'RootQueryType', process: { __typename?: 'Process', id: number, costClosedAt: string | null, itemCostsPerReference: { __typename?: 'ItemCostsPerReference', costItems: Array<{ __typename?: 'ItemsCostPerReference', itemId: number, reference: CostModelExpenseReferenceProductProratedEnum | null, totalReference: string | null, measurementUnit: MeasurementUnitEnum | null, totalCosts: { __typename?: 'UnitaryCost', cost: string | null, deviation: string | null, plannedCost: string | null }, unitaryCosts: { __typename?: 'UnitaryCost', cost: string | null, deviation: string | null, plannedCost: string | null } }>, totals: Array<{ __typename?: 'ItemsCostPerReferenceTotals', reference: CostModelExpenseReferenceProductProratedEnum | null, totalReference: string | null, measurementUnit: MeasurementUnitEnum | null, totalCosts: { __typename?: 'UnitaryCost', cost: string | null, deviation: string | null, plannedCost: string | null }, unitaryCosts: { __typename?: 'UnitaryCost', cost: string | null, deviation: string | null, plannedCost: string | null } }> } | null, costModelVersion: { __typename?: 'CostModelVersion', id: number, version: number, costModel: { __typename?: 'CostModel', id: number, name: string, hasPlannedCosts: boolean, hasCostPerProduct: boolean, hasCostPerProductUnitary: boolean, currency: { __typename?: 'Currency', code: string, name: string, symbol: string | null } | null }, totals: { __typename?: 'CostModelVersionTotals', totalCosts: string | null, plannedCosts: string | null, deviation: string | null, costPerItemsTotals: Array<{ __typename?: 'CostPerItemTotals', itemId: number, productId: number, totalCosts: string | null, plannedCosts: string | null, deviation: string | null }>, costPerItemExpenseTotals: Array<{ __typename?: 'CostPerItemExpenseTotals', expenseId: number, totalCosts: string | null, plannedCosts: string | null, deviation: string | null }> } | null, rootModelExpenses: Array<{ __typename?: 'CostModelExpense', id: number, precificationModel: CostModelExpenseConditionalPrecificationModelEnum | null, reference: CostModelExpenseReferenceEnum | null, referenceValue: string | null, referenceProductProrated: CostModelExpenseReferenceProductProratedEnum | null, childrenModelExpenses: Array<{ __typename?: 'CostModelExpense', id: number, precificationModel: CostModelExpenseConditionalPrecificationModelEnum | null, reference: CostModelExpenseReferenceEnum | null, referenceValue: string | null, referenceProductProrated: CostModelExpenseReferenceProductProratedEnum | null, childrenModelExpenses: Array<{ __typename?: 'CostModelExpense', id: number, precificationModel: CostModelExpenseConditionalPrecificationModelEnum | null, reference: CostModelExpenseReferenceEnum | null, referenceValue: string | null, referenceProductProrated: CostModelExpenseReferenceProductProratedEnum | null, cost: { __typename?: 'CostPerExpense', id: number, cost: string | null, plannedCost: string | null, deviation: string | null, costPerItems: Array<{ __typename?: 'CostPerItem', itemId: number, productId: number, cost: string | null, plannedCost: string | null, deviation: string | null }> } | null, costExpense: { __typename?: 'CostExpense', id: number, name: string, slug: string } }>, cost: { __typename?: 'CostPerExpense', id: number, cost: string | null, plannedCost: string | null, deviation: string | null, costPerItems: Array<{ __typename?: 'CostPerItem', itemId: number, productId: number, cost: string | null, plannedCost: string | null, deviation: string | null }> } | null, costExpense: { __typename?: 'CostExpense', id: number, name: string, slug: string } }>, cost: { __typename?: 'CostPerExpense', id: number, cost: string | null, plannedCost: string | null, deviation: string | null, costPerItems: Array<{ __typename?: 'CostPerItem', itemId: number, productId: number, cost: string | null, plannedCost: string | null, deviation: string | null }> } | null, costExpense: { __typename?: 'CostExpense', id: number, name: string, slug: string } }> } | null, operation: { __typename?: 'Operation', id: number, subType: OperationSubTypeEnum } } | null };

export type GetProcessDocumentsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetProcessDocumentsQuery = { __typename?: 'RootQueryType', process: { __typename?: 'Process', id: number, pdfDocuments: Array<{ __typename?: 'PdfDocumentBase', id: number, name: any, props: any | null }> } | null };

export type GetProcessPdfDocumentByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  pdfDocumentId: Scalars['Int']['input'];
}>;


export type GetProcessPdfDocumentByIdQuery = { __typename?: 'RootQueryType', process: { __typename?: 'Process', id: number, pdfDocument: { __typename?: 'PdfDocument', id: number, name: any, header: any, props: any | null, sections: Array<{ __typename?: 'PdfSection', id: number, props: any | null, name: any, position: number, rows: Array<{ __typename?: 'PdfRow', id: number, fields: any, props: any | null, position: number }> }> } | null, operation: { __typename?: 'Operation', id: number, actor: { __typename?: 'Actor', id: number, logoUrl: string | null } } } | null };

export type GetProcessVersionsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  filters?: InputMaybe<FilterVersionParams>;
  pagination?: InputMaybe<VersionPaginationParams>;
}>;


export type GetProcessVersionsQuery = { __typename?: 'RootQueryType', process: { __typename?: 'Process', id: number, versionsCount: number, versions: Array<{ __typename?: 'Version', apiKeyName: string | null, id: number, event: string, insertedAt: string, processedChanges: any | null, itemType: string, origin: VersionOriginEnum | null, originatorId: number | null, meta: any | null, user: { __typename?: 'User', id: string | null, name: string | null, email: string | null } | null }>, operation: { __typename?: 'Operation', id: number, operationPhases: Array<{ __typename?: 'OperationPhase', id: number, components: Array<{ __typename?: 'Component', id: number, slug: string, name: string, title: string | null, extraFieldsDefinition: any | null }> }> } } | null };

export type ProcessAuditorStatusQueryVariables = Exact<{
  processId: Scalars['Int']['input'];
}>;


export type ProcessAuditorStatusQuery = { __typename?: 'RootQueryType', processAuditorStatus: { __typename?: 'ProcessAuditorStatus', isRunning: boolean, canTrigger: boolean, cooldownUntil: string | null, lastRunAt: string | null, agentExecutionId: string | null } };

export type SetInsightFeedbackMutationVariables = Exact<{
  insightId: Scalars['Int']['input'];
  status: InsightStatusEnum;
  dismissReason?: InputMaybe<InsightDismissReasonEnum>;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetInsightFeedbackMutation = { __typename?: 'RootMutationType', setInsightFeedback: { __typename?: 'Insight', id: number, status: InsightStatusEnum, dismissReason: InsightDismissReasonEnum | null, feedbackAt: string | null, feedbackComment: string | null } };

export type TriggerAuditAgentMutationVariables = Exact<{
  processId: Scalars['Int']['input'];
}>;


export type TriggerAuditAgentMutation = { __typename?: 'RootMutationType', triggerAuditAgent: { __typename?: 'ProcessAuditorStatus', isRunning: boolean, canTrigger: boolean, cooldownUntil: string | null, lastRunAt: string | null, agentExecutionId: string | null } };

export type GetProcessLeadTimeQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetProcessLeadTimeQuery = { __typename?: 'RootQueryType', process: { __typename?: 'Process', id: number, leadTimeDatetimeReference: string | null, plannedLeadTime: { __typename?: 'PlannedLeadTime', id: number, name: string, leadTimeModel: { __typename?: 'LeadTimeModel', id: number, ignoreTime: boolean } } | null, leadTime: { __typename?: 'LeadTime', conclusionDate: string | null, deviationPercentage: string | null, differenceHours: number | null, plannedDurationHours: number | null, isRealized: boolean, processRealizedDatesByEvent: any, hasErrors: boolean, status: LeadTimeStatusEnum | null, realizedOrEstimatedDurationHours: number | null, errors: Array<{ __typename?: 'LeadTimeStageError', date: string | null, path: string, status: LeadTimeStageErrorStatusEnum | null }>, stages: Array<{ __typename?: 'LeadTimeStage', model: { __typename?: 'LeadTimeStageModel', id: number, name: string, color: string, endEvent: string, endEventLabel: string, startEvent: string, startEventLabel: string }, planned: { __typename?: 'CalculatedStage', durationHours: number | null, endedAt: string | null, startedAt: string | null }, realizedOrEstimated: { __typename?: 'CalculatedStage', durationHours: number | null, endedAt: string | null, startedAt: string | null } | null }> } | null, leadTimeMarkers: Array<{ __typename?: 'LeadTimeMarker', label: string, path: string, value: string }> | null, operation: { __typename?: 'Operation', id: number, subType: OperationSubTypeEnum } } | null };

export type ApproveProcessAuditMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ApproveProcessAuditMutation = { __typename?: 'RootMutationType', approveProcessAudit: { __typename?: 'Process', id: number } | null };

export type CancelOrUncancelProcessMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  cancelled: Scalars['Boolean']['input'];
}>;


export type CancelOrUncancelProcessMutation = { __typename?: 'RootMutationType', cancelOrUncancelProcess: { __typename?: 'Process', id: number } | null };

export type DeleteProcessMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteProcessMutation = { __typename?: 'RootMutationType', deleteProcess: { __typename?: 'Process', id: number } | null };

export type FinishOrUnfinishProcessMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  finished: Scalars['Boolean']['input'];
}>;


export type FinishOrUnfinishProcessMutation = { __typename?: 'RootMutationType', finishOrUnfinishProcess: { __typename?: 'Process', id: number } | null };

export type GetProcessPartialOperationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetProcessPartialOperationQuery = { __typename?: 'RootQueryType', operation: { __typename?: 'Operation', id: number, autoGenerateProcessCode: boolean, acceptHourInNationalRoadTransports: boolean, configProps: { __typename?: 'OperationConfigProps', isMultipleNationalRoadTransport: boolean, internationalModal: InternationalModalEnum, itemReference: ItemReferenceEnum, isOrderRequiredWhenCreatingProcess: boolean } } | null };

export type GetProcessDataFragment = { __typename?: 'Process', id: number, alertLevel: AlertLevelEnum, canceledAt: string | null, deletedAt: string | null, finishedAt: string | null, referenceCode: string, extraFields: any | null, orders: Array<{ __typename?: 'Order', id: number, referenceCode: string }>, auditApprovalInfo: { __typename?: 'ProcessAuditApprovalInfo', approvedAt: string, approvedBy: { __typename?: 'User', id: string | null, name: string | null } } | null, auditItems: Array<{ __typename?: 'ProcessAuditItem', id: number, observations: string | null, checked: boolean | null, auditItem: { __typename?: 'AuditItem', id: number, name: string, showObservationsWhen: AuditItemShowObservationEnum } }>, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, bookingQuotation: { __typename?: 'BookingQuotation', id: number, agentNotes: string | null, documentIds: Array<number>, recipientIds: Array<number>, externalPagePublication: { __typename?: 'ExternalPagePublication', id: number, closesAt: string | null } } | null, documents: Array<{ __typename?: 'Document', id: number, type: DocumentTypeEnum, fileUrl: string, originalFilename: string, updatedAt: string, invoice: { __typename?: 'Invoice', id: number } | null, parentDocument: { __typename?: 'Document', id: number } | null, brazilianInvoiceInfo: { __typename?: 'BrazilianInvoice', accessKey: string, cfop: string | null, emittedAt: string, extra: string | null, number: string, type: string, sender: { __typename?: 'BrazilianInvoiceOriginator', cnpj: string | null, name: string, address: { __typename?: 'BrazilianInvoiceAddress', zip: string | null, street: string, number: string, neighborhood: string, city: string, state: string, country: string | null } | null }, transport: { __typename?: 'BrazilianInvoiceTransport', address: string | null, city: string | null, state: string | null, stateId: string | null, carrier: string | null, cnpj: string | null, brand: string | null, grossWeight: string | null, netWeight: string | null, quantity: string | null, specie: string | null, freightOnAccount: string, numeration: string | null, vehiclePlate: string | null }, tax: { __typename?: 'BrazilianInvoiceTax', base: string, discount: string, freight: string, importation: string, insurance: string, ipi: string, other: string, productValue: string, totalAmount: string, value: string }, products: Array<{ __typename?: 'BrazilianInvoiceProduct', code: string, description: string, ncm: string, unit: string, quantity: string, totalAmount: string, unitValue: string }>, issuer: { __typename?: 'BrazilianInvoiceOriginator', cnpj: string | null, name: string, stateId: string | null, address: { __typename?: 'BrazilianInvoiceAddress', zip: string | null, street: string, number: string, neighborhood: string, city: string, state: string, country: string | null } | null } } | null }>, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, ata: string | null, atd: string | null, eta: string | null, etd: string | null, type: ShipmentTypeEnum | null, receivedInWarehouseAt: string | null, departedFromWarehouseAt: string | null, warehouseFreeTimeDays: number, deliveredAt: string | null, insertedAt: string, statusResponse: StatusResponseTypeEnum, lastUpdatedAt: string | null, automaticTrackingEnabled: boolean, totalNetWeight: string | null, totalGrossWeight: string | null, cubageCubicMeters: string | null, ceMercanteNumber: string | null, ceMercanteAuthorizationStatus: ShipmentDocumentAuthorizationStatusEnum | null, ceMercanteLastSyncType: SiscomexSyncTypeEnum | null, ceMercanteLastSyncErrorMessage: string | null, ceMercanteData: { __typename?: 'CeMercanteData', id: number, number: string, issuedAt: string | null, insertedAt: string, cargoStatus: string | null, freightPaymentType: string | null, freightBasicCost: string | null, freightTotalCost: string | null, cargoDescription: string | null, grossWeightKg: string | null, hasDta: boolean | null, manifestArrivalAt: string | null, cargoPresenceInPrimaryZoneAt: string | null, cargoPresenceInSecondaryZoneAt: string | null, customsPlace: string | null, bl: string | null, consigneeDocument: string | null, consigneeExtraInfo: string | null, notes: string | null, extra: any | null, statusResponse: StatusResponseTypeEnum | null, lastUpdatedAt: string | null, cargoPresenceHistory: Array<{ __typename?: 'CeMercanteDataCargoPresenceHistory', ra: string | null, status: string | null, date: string | null, dtaNumber: string | null, syncedAt: string | null }>, containerSeals: Array<{ __typename?: 'CeMercanteDataContainerSeal', containerCode: string | null, sealCode: string | null, secondarySealCode: string | null }>, shippingAgency: { __typename?: 'Actor', id: number, officialDocument: string | null, nickname: string } | null, cargoManifests: Array<{ __typename?: 'CeMercanteDataCargoManifest', manifestNumber: string | null, loadingPortTerminal: string | null, dischargePortTerminal: string | null, loadingPortUnlocode: string | null, dischargePortUnlocode: string | null }>, freightCurrency: { __typename?: 'Currency', code: string, name: string } | null, originPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null, country: { __typename?: 'Country', code: string } | null } | null, destinationPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null, country: { __typename?: 'Country', code: string } | null } | null } | null, internationalTransportLegs: Array<{ __typename?: 'InternationalTransportLeg', arrivalPlace: string | null, departurePlace: string | null, etd: string | null, eta: string | null, atd: string | null, ata: string | null, modalType: ModalTypeEnum | null, voyage: string | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null } | null }>, hawbShipmentData: { __typename?: 'HawbShipmentData', id: number, status: string | null, hawb: string, extra: any | null, dtaNumber: string | null, vehiclePlateDta: string | null, departurePlaceDta: string | null, arrivalPlaceDta: string | null, ataDta: string | null, atdDta: string | null, loadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string }, unloadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } } | null, parcelShipments: Array<{ __typename?: 'ParcelShipment', id: number, ata: string | null, atd: string | null, eta: string | null, etd: string | null, status: ParcelShipmentStatusEnum, slug: string, trackingNumber: string, insertedAt: string, lastUpdatedAt: string | null, destinationAddress: string | null, originAddress: string | null, destinationCountry: { __typename?: 'Country', code: string, name: string } | null, events: Array<{ __typename?: 'ParcelShipmentEvent', address: string | null, date: string | null, status: string | null }>, originCountry: { __typename?: 'Country', code: string, name: string } | null, courier: { __typename?: 'Courier', id: number, logoUrl: string | null } | null }>, demurrage: { __typename?: 'Demurrage', id: number, freeTime: number | null, dailyRateUsd: string | null, calculations: { __typename?: 'DemurrageCalculations', totalExceedingDays: number, totalEstimatedCosts: string, totalDaysPaid: number, totalDaysToPay: number, averageCostPerDayUsd: string, totalOwedUsd: string, totalPaidUsd: string, totalToPayUsd: string } } | null, internationalFreight: { __typename?: 'InternationalFreight', id: number, freightForwarder: string | null, quotationNumber: string | null, plannedBoardingDate: string | null, freightCostPrepaid: string | null, freightCostCollect: string | null, freightCostRoad: string | null, freightCostTotal: string | null, type: InternationalFreightTypeEnum | null, bookingEta: string | null, bookingEtd: string | null, voyageNumber: string | null, cargoAttributes: Array<CargoAttributeEnum>, expectedSeparationAt: string | null, pickupLocation: string | null, currency: { __typename?: 'Currency', code: string } | null, portTerminal: { __typename?: 'PortTerminal', id: number, name: string } | null, bookingLoadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingDischargeAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingLoadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, sealine: { __typename?: 'Sealine', id: number, name: string, logoUrl: string | null } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } | null } | null, items: Array<{ __typename?: 'ForeignTradeItemShipment', id: number, quantity: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, unitValue: string | null, brazilianInvoiceUnitValue: string | null, totalValue: string | null, transportables: Array<{ __typename?: 'Transportable', id: number }>, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, balance: string | null, balanceShipped: string | null, lineNumber: number | null, lineReference: string, quantity: string | null, division: string | null, measurementUnitSap: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, sapByFactor: string | null, concessionAct: string | null, importTypeSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, orderModalTypeSap: string | null, orderAdjustedModalType: string | null, orderRequestedAt: string | null, planningRequestShippingAt: string | null, planningShippingAt: string | null, supplierSentAt: string | null, supplierConfirmationAt: string | null, supplierReadyLeadTimeDays: number | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierCalculatedReadyAt: string | null, supplierReadyDeviation: number | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedBoardingAt: string | null, shipmentPlannedArrivalAt: string | null, shipmentEstimatedBoardingAt: string | null, shipmentEstimatedArrivalAt: string | null, shipmentBoardingLeadTime: number | null, shipmentTransportLeadTime: number | null, customsEstimatedRegisterAt: string | null, customsRegisterLeadTime: number | null, customsEstimatedReleaseAt: string | null, customsReleaseLeadTime: number | null, factoryEstimatedDeliveryAt: string | null, factoryPlannedDeliveryAt: string | null, factoryDeliveryAt: string | null, factoryDeliveryLeadTime: number | null, adjustedCustomsRegisterLeadTime: number | null, adjustedCustomsReleaseLeadTime: number | null, adjustedFactoryDeliveryLeadTime: number | null, adjustedShipmentBoardingLeadTime: number | null, adjustedShipmentTransportLeadTime: number | null, adjustedSupplierReadyLeadTimeDays: number | null, assessmentSotd: string | null, itemStatus: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, invoiceIssuedAt: string | null, invoiceNumber: string | null, invoiceValue: string | null, invoiceType: string | null, deliveryNote: string | null, deliveryNoteIssuedAt: string | null, shippingDetailsDeliveryDate: string | null, quotationOpeningDate: string | null, purchaseOrder: { __typename?: 'PurchaseOrder', id: number, order: { __typename?: 'Order', id: number, referenceCode: string } }, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'PurchaseOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null, manufacturingCountry: { __typename?: 'Country', code: string } | null, purchaseCountry: { __typename?: 'Country', code: string } | null, dispatchingCountry: { __typename?: 'Country', code: string } | null } | null, salesOrderItem: { __typename?: 'SalesOrderItem', id: number, balance: string | null, balanceShipped: string | null, lineNumber: number | null, lineReference: string, quantity: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, dispatchNumber: string | null, measurementUnitSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedArrivalAt: string | null, shipmentPlannedBoardingAt: string | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierReadyDeviation: number | null, factoryDeliveryAt: string | null, factoryEstimatedDeliveryAt: string | null, itemStatus: string | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, necessityType: string | null, ubc: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, stockQuantity: string | null, clientApprovedAt: string | null, reservedStockQuantity: string | null, stockReservationAt: string | null, preliminaryPickingStartedAt: string | null, internalContainerReference: string | null, salesOrder: { __typename?: 'SalesOrder', id: number, order: { __typename?: 'Order', id: number, referenceCode: string } }, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'SalesOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null } | null }>, airTransportShipment: { __typename?: 'AirTransportShipment', id: number, type: AirTransportTypeEnum | null, awb: string | null, hawb: string | null, airline: { __typename?: 'Airline', id: number, name: string, logoUrl: string | null } | null, destinationAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string, country: { __typename?: 'Country', code: string } | null } | null, originAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string, country: { __typename?: 'Country', code: string } | null } | null } | null, roadTransportShipment: { __typename?: 'ForeignTradeRoadTransportShipment', id: number, type: ForeignTradeRoadTransportTypeEnum | null, crt: string | null, origin: string | null, destination: string | null } | null, maritimeTransportShipment: { __typename?: 'MaritimeTransportShipment', id: number, bl: string | null, booking: string | null, hbl: string | null, trackingNumber: string | null, trackingKey: TrackingKeyEnum | null, trackingKeyInsertedAt: string | null, trackingDischargePort: string | null, trackingLoadingPort: string | null, type: MaritimeTransportTypeEnum | null, voyageNumber: string | null, sealineOrigin: SealineOriginEnum | null, sealine: { __typename?: 'Sealine', id: number, name: string, logoUrl: string | null } | null, dischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null, country: { __typename?: 'Country', code: string } | null } | null, loadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null, country: { __typename?: 'Country', code: string } | null } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } | null } | null, pallets: Array<{ __typename?: 'ShipmentPallet', id: number, sizeType: PalletSizeTypeEnum, palletStandardId: number | null, lengthMm: number | null, widthMm: number | null, quantity: number, heightCm: number | null, palletStandard: { __typename?: 'PalletStandard', id: number, name: string | null, isoCode: string | null, eurCode: string | null } | null }>, transportables: Array<{ __typename?: 'Transportable', id: number, type: TransportableTypeEnum, container: { __typename?: 'Container', trackingApi: boolean, trackingManual: boolean, hidden: boolean, observations: string | null, id: number, code: string | null, type: ContainerTypeEnum | null, sizeFootType: ContainerSizeFootTypeEnum | null, loadType: LoadTypeEnum | null, maxWeightKg: string | null, grossWeightKg: string | null, tareWeightKg: string | null, sealCode: string | null, secondarySealCode: string | null, invoiceNumber: string | null, palletQuantity: number | null, isStackable: boolean | null, cubicMeters: string | null, dispatchNumber: string | null, transportDocument: string | null, actualReturnEmptyContainerAt: string | null, estimatedReturnEmptyContainerAt: string | null, demurrageDailyRateUsd: string | null, demurrageFreeTime: number | null, demurrageFreeTimeStartAt: string | null, route: string | null, internalReferenceCode: string | null, orderNumber: string | null, ncmCodes: Array<string> | null, htTreatment: boolean | null, htTreatmentAt: string | null, separationCompletedAt: string | null, estimatedStuffingAt: string | null, loadingScheduleAt: string | null, invoiceDocumentNumber: string | null, invoiceGrossWeight: string | null, invoiceValue: string | null, preStacking: boolean | null, preStackingReason: PreStackingReasonEnum | null, scaleExitAt: string | null, stackingScheduledAt: string | null, stackingStartedAt: string | null, portScheduledAt: string | null, portDepositDeadlineAt: string | null, portDepositAt: string | null, preStackingWarehouse: PreStackingWarehouseEnum | null, preStackingDays: number | null, emptyPickupAt: string | null, emptyReceivedAtFactory: string | null, oic: string | null, quantity: string | null, releasedForTripAt: string | null, washingValue: string | null, washingChargeReceivedAt: string | null, washingDamageStatus: ContainerWashingConclusionStatusEnum | null, washingTermStatus: ContainerWashingConclusionStatusEnum | null, washingTermDescription: ContainerWashingTermDescriptionEnum | null, washingServiceType: ContainerWashingServiceTypeEnum | null, washingPaymentStatus: ContainerWashingPaymentStatusEnum | null, washingPaymentAt: string | null, washingEmptyChecklist: boolean | null, washingDamageResult: ContainerWashingDamageResultEnum | null, washingInspection: string | null, debitNotes: Array<{ __typename?: 'DebitNote', coverageEndAt: string, coverageStartAt: string, daysCovered: number | null, id: number, number: string, payedAt: string | null, totalValueBrl: string | null, totalValueUsd: string, usdToBrlRate: string }>, demurrageCalculations: { __typename?: 'ContainerDemurrageCalculations', costPerDayBrl: string, costPerDayUsd: string, daysPaid: number, daysToPay: number, emptyReturnDeadline: string | null, estimatedCosts: string, exceedingDays: number, totalOwedBrl: string, totalOwedUsd: string, totalPaidBrl: string, totalPaidUsd: string, totalToPayBrl: string, totalToPayUsd: string } | null, events: Array<{ __typename?: 'ContainerEvent', datetime: string | null, estimated: boolean | null, place: string | null, status: string | null, transport: string | null, voyage: string | null }> } | null }>, shipmentDuimps: Array<{ __typename?: 'ShipmentDuimp', id: number, status: ShipmentDocumentAuthorizationStatusEnum, comments: string | null, insertedAt: string | null, automaticLinkOrigin: ShipmentDocumentAutomaticLinkOriginTypeEnum | null, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null, duimp: { __typename?: 'Duimp', id: number, channel: ChannelTypeEnum | null, customsClearedAt: string | null, deliveredAt: string | null, extra: any | null, lastUpdatedAt: string | null, number: string, registeredAt: string | null, status: DuimpStatusEnum | null, statusResponse: StatusResponseTypeEnum, statusUpdatedAt: string | null, version: number | null, importer: { __typename?: 'Actor', id: number, officialName: string, officialDocument: string | null, documentType: ActorDocumentTypeEnum | null, addresses: Array<{ __typename?: 'Address', id: number, country: string | null, state: string | null, city: string | null, street: string | null, number: string | null, postalCode: string | null, neighborhood: string | null, formattedAddress: string | null }> } | null } }>, shipmentImportDeclarations: Array<{ __typename?: 'ShipmentImportDeclaration', id: number, status: ShipmentDocumentAuthorizationStatusEnum, comments: string | null, insertedAt: string | null, automaticLinkOrigin: ShipmentDocumentAutomaticLinkOriginTypeEnum | null, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null, importDeclaration: { __typename?: 'ImportDeclaration', id: number, channel: ChannelTypeEnum | null, customsClearedAt: string | null, extra: any | null, lastUpdatedAt: string | null, number: string, registeredAt: string | null, status: ImportDeclarationStatusEnum | null, statusResponse: StatusResponseTypeEnum, statusUpdatedAt: string | null } }>, shipmentExportDeclarations: Array<{ __typename?: 'ShipmentExportDeclaration', id: number, comments: string | null, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null, exportDeclaration: { __typename?: 'ExportDeclaration', id: number, number: string, channel: ChannelExportDeclarationTypeEnum | null, extra: any | null, status: ExportDeclarationStatusEnum | null, statusResponse: StatusResponseTypeEnum, endorsedAt: string | null, customsClearedAt: string | null, registeredAt: string | null, insertedAt: string | null, lastUpdatedAt: string | null, events: Array<{ __typename?: 'ExportDeclarationEvent', action: ExportDeclarationEventActionEnum | null, date: string | null, extraInfo: string | null, responsible: string | null }> } }>, nationalRoadTransports: Array<{ __typename?: 'NationalRoadTransport', id: number, collectionScheduledAt: string | null, deliveryPlannedAt: string | null, isTransportTypeDta: boolean, loadType: LoadTypeEnum | null, roadTransportType: RoadTransportTypeEnum | null, transportFeatures: Array<TransportFeatureEnum>, quantityPallets: number | null, releasedForTransportAt: string | null, transportCompletedAt: string | null, legSlug: string, nationalRoadCarrier: { __typename?: 'Handler', id: number, actor: { __typename?: 'Actor', id: number, nickname: string }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null }, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum } } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, driverName: string | null, vehiclePlate: string | null, trailerPlate: string | null, position: number, driver: { __typename?: 'Driver', id: number, name: string } | null, vehicle: { __typename?: 'Vehicle', id: number, plate: string, trackerId: string | null } | null, trailer: { __typename?: 'Trailer', id: number, plate: string, trackerId: string | null } | null, phases: Array<{ __typename?: 'RoadTransportTripPhase', id: number, realizedAt: string | null, departureAt: string | null, estimatedRealizedAt: string | null, routePoint: { __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum } }>, transportables: Array<{ __typename?: 'Transportable', id: number }> }>, route: { __typename?: 'Route', id: number, name: string, active: boolean, points: Array<{ __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum, address: { __typename?: 'Address', id: number, city: string | null, country: string | null, name: string | null, number: string | null, postalCode: string | null, state: string | null, street: string | null, actor: { __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null } | null } | null }> } | null }>, shipmentImportLicenses: Array<{ __typename?: 'ShipmentImportLicense', id: number, status: ShipmentDocumentAuthorizationStatusEnum, comments: string | null, insertedAt: string | null, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null, importLicense: { __typename?: 'ImportLicense', id: number, approvedAt: string | null, extra: any | null, lastUpdatedAt: string | null, number: string, registeredAt: string | null, status: ImportLicenseStatusEnum | null, statusResponse: StatusResponseTypeEnum, statusUpdatedAt: string | null, importDeclaration: { __typename?: 'ImportDeclaration', id: number, number: string } | null } }>, invoices: Array<{ __typename?: 'Invoice', id: number, number: string, emittedAt: string, updatedAt: string, incoterm: IncotermTypeEnum, totalAmount: string, discount: string | null, finalValue: string, totalGrossWeightKg: string, items: Array<{ __typename?: 'InvoiceItem', id: number, productDescription: string | null, productSku: string, quantity: string, batchNumber: string | null, batchValidityDate: string | null, productionDate: string | null, totalAmount: string | null, unitaryAmount: string | null, totalGrossWeightKg: string | null, orderReferenceCode: string | null, orderItemLineReference: string | null, product: { __typename?: 'Product', id: number } | null, transportables: Array<{ __typename?: 'Transportable', id: number, container: { __typename?: 'Container', id: number, code: string | null } | null }> }>, currency: { __typename?: 'Currency', code: string } | null }>, vesselScheduleDeadlineReferences: { __typename?: 'VesselScheduleDeadlineReferences', draftDeadlineReference: DeadlineDateReferenceEnum | null, vgmDeadlineReference: VgmDeadlineDateReferenceEnum | null, cargoDeadlineReference: DeadlineDateReferenceEnum | null, gateOpeningDeadlineReference: GateOpeningDeadlineDateReferenceEnum | null } | null, vesselSchedule: { __typename?: 'VesselSchedule', id: number, sealineStatusResponse: VesselScheduleStatusResponseEnum, portTerminalStatusResponse: VesselScheduleStatusResponseEnum, sealineLastUpdatedAt: string | null, portTerminalLastUpdatedAt: string | null, deadlineDates: { __typename?: 'VesselScheduleDeadlineDates', draftDeadline: string | null, cargoDeadline: string | null, vgmDeadline: string | null, gateOpeningDeadline: string | null } | null, sealineVesselSchedules: Array<{ __typename?: 'SealineVesselSchedule', id: number, draftDeadline: string | null, cargoDeadline: string | null, specialCargoDraftDeadline: string | null, vgmDeadline: string | null, insertedAt: string | null }> | null, portTerminalVesselSchedules: Array<{ __typename?: 'PortTerminalVesselSchedule', id: number, draftDeadline: string | null, cargoDeadline: string | null, gateOpening: string | null, reeferGateOpening: string | null, insertedAt: string | null }> | null } | null } | null, handlers: Array<{ __typename?: 'Handler', id: number, reference: string | null, secondaryReference: string | null, businessUnit: string | null, actor: { __typename?: 'Actor', id: number, nickname: string, logoUrl: string | null }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null }, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, isListedInDynamicList: boolean, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean } }> };

export type GetProcessQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetProcessQuery = { __typename?: 'RootQueryType', process: { __typename?: 'Process', id: number, alertLevel: AlertLevelEnum, canceledAt: string | null, deletedAt: string | null, finishedAt: string | null, referenceCode: string, extraFields: any | null, operation: { __typename?: 'Operation', id: number, title: string, subtitle: string | null, type: OperationTypeEnum, subType: OperationSubTypeEnum, isSiscomexEnabled: boolean, isCeMercanteEnabled: boolean, acceptHourInNationalRoadTransports: boolean, processModalHeaderConfigs: Array<{ __typename?: 'OperationModalHeaderConfig', label: string | null, value: string | null, type: PathConfigTypeEnum | null }>, operationPhases: Array<{ __typename?: 'OperationPhase', id: number, position: number, phase: { __typename?: 'Phase', id: number, phase: PhaseEnum }, components: Array<{ __typename?: 'Component', id: number, name: string, title: string | null, slug: string, props: any | null, position: number, extraFieldsDefinition: any | null, componentAccess: { __typename?: 'ComponentAccess', id: number, type: AccessEnum } }> }>, configProps: { __typename?: 'OperationConfigProps', isMultipleNationalRoadTransport: boolean, orderItemAdditionalFields: Array<string>, itemReference: ItemReferenceEnum }, operationAccess: { __typename?: 'OperationAccess', id: number, type: AccessEnum, canUpdateCancelledOrFinishedProcesses: boolean, canCloseOrReopenProcessesCosts: boolean, canSeeOrders: boolean }, actor: { __typename?: 'Actor', id: number, nickname: string, officialDocument: string | null, documentType: ActorDocumentTypeEnum | null }, operationHandlers: Array<{ __typename?: 'OperationHandler', id: number, owner: boolean, role: OperationHandlerEnum, isListedInDynamicList: boolean, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }> }, orders: Array<{ __typename?: 'Order', id: number, referenceCode: string }>, auditApprovalInfo: { __typename?: 'ProcessAuditApprovalInfo', approvedAt: string, approvedBy: { __typename?: 'User', id: string | null, name: string | null } } | null, auditItems: Array<{ __typename?: 'ProcessAuditItem', id: number, observations: string | null, checked: boolean | null, auditItem: { __typename?: 'AuditItem', id: number, name: string, showObservationsWhen: AuditItemShowObservationEnum } }>, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, bookingQuotation: { __typename?: 'BookingQuotation', id: number, agentNotes: string | null, documentIds: Array<number>, recipientIds: Array<number>, externalPagePublication: { __typename?: 'ExternalPagePublication', id: number, closesAt: string | null } } | null, documents: Array<{ __typename?: 'Document', id: number, type: DocumentTypeEnum, fileUrl: string, originalFilename: string, updatedAt: string, invoice: { __typename?: 'Invoice', id: number } | null, parentDocument: { __typename?: 'Document', id: number } | null, brazilianInvoiceInfo: { __typename?: 'BrazilianInvoice', accessKey: string, cfop: string | null, emittedAt: string, extra: string | null, number: string, type: string, sender: { __typename?: 'BrazilianInvoiceOriginator', cnpj: string | null, name: string, address: { __typename?: 'BrazilianInvoiceAddress', zip: string | null, street: string, number: string, neighborhood: string, city: string, state: string, country: string | null } | null }, transport: { __typename?: 'BrazilianInvoiceTransport', address: string | null, city: string | null, state: string | null, stateId: string | null, carrier: string | null, cnpj: string | null, brand: string | null, grossWeight: string | null, netWeight: string | null, quantity: string | null, specie: string | null, freightOnAccount: string, numeration: string | null, vehiclePlate: string | null }, tax: { __typename?: 'BrazilianInvoiceTax', base: string, discount: string, freight: string, importation: string, insurance: string, ipi: string, other: string, productValue: string, totalAmount: string, value: string }, products: Array<{ __typename?: 'BrazilianInvoiceProduct', code: string, description: string, ncm: string, unit: string, quantity: string, totalAmount: string, unitValue: string }>, issuer: { __typename?: 'BrazilianInvoiceOriginator', cnpj: string | null, name: string, stateId: string | null, address: { __typename?: 'BrazilianInvoiceAddress', zip: string | null, street: string, number: string, neighborhood: string, city: string, state: string, country: string | null } | null } } | null }>, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, ata: string | null, atd: string | null, eta: string | null, etd: string | null, type: ShipmentTypeEnum | null, receivedInWarehouseAt: string | null, departedFromWarehouseAt: string | null, warehouseFreeTimeDays: number, deliveredAt: string | null, insertedAt: string, statusResponse: StatusResponseTypeEnum, lastUpdatedAt: string | null, automaticTrackingEnabled: boolean, totalNetWeight: string | null, totalGrossWeight: string | null, cubageCubicMeters: string | null, ceMercanteNumber: string | null, ceMercanteAuthorizationStatus: ShipmentDocumentAuthorizationStatusEnum | null, ceMercanteLastSyncType: SiscomexSyncTypeEnum | null, ceMercanteLastSyncErrorMessage: string | null, ceMercanteData: { __typename?: 'CeMercanteData', id: number, number: string, issuedAt: string | null, insertedAt: string, cargoStatus: string | null, freightPaymentType: string | null, freightBasicCost: string | null, freightTotalCost: string | null, cargoDescription: string | null, grossWeightKg: string | null, hasDta: boolean | null, manifestArrivalAt: string | null, cargoPresenceInPrimaryZoneAt: string | null, cargoPresenceInSecondaryZoneAt: string | null, customsPlace: string | null, bl: string | null, consigneeDocument: string | null, consigneeExtraInfo: string | null, notes: string | null, extra: any | null, statusResponse: StatusResponseTypeEnum | null, lastUpdatedAt: string | null, cargoPresenceHistory: Array<{ __typename?: 'CeMercanteDataCargoPresenceHistory', ra: string | null, status: string | null, date: string | null, dtaNumber: string | null, syncedAt: string | null }>, containerSeals: Array<{ __typename?: 'CeMercanteDataContainerSeal', containerCode: string | null, sealCode: string | null, secondarySealCode: string | null }>, shippingAgency: { __typename?: 'Actor', id: number, officialDocument: string | null, nickname: string } | null, cargoManifests: Array<{ __typename?: 'CeMercanteDataCargoManifest', manifestNumber: string | null, loadingPortTerminal: string | null, dischargePortTerminal: string | null, loadingPortUnlocode: string | null, dischargePortUnlocode: string | null }>, freightCurrency: { __typename?: 'Currency', code: string, name: string } | null, originPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null, country: { __typename?: 'Country', code: string } | null } | null, destinationPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null, country: { __typename?: 'Country', code: string } | null } | null } | null, internationalTransportLegs: Array<{ __typename?: 'InternationalTransportLeg', arrivalPlace: string | null, departurePlace: string | null, etd: string | null, eta: string | null, atd: string | null, ata: string | null, modalType: ModalTypeEnum | null, voyage: string | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null } | null }>, hawbShipmentData: { __typename?: 'HawbShipmentData', id: number, status: string | null, hawb: string, extra: any | null, dtaNumber: string | null, vehiclePlateDta: string | null, departurePlaceDta: string | null, arrivalPlaceDta: string | null, ataDta: string | null, atdDta: string | null, loadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string }, unloadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } } | null, parcelShipments: Array<{ __typename?: 'ParcelShipment', id: number, ata: string | null, atd: string | null, eta: string | null, etd: string | null, status: ParcelShipmentStatusEnum, slug: string, trackingNumber: string, insertedAt: string, lastUpdatedAt: string | null, destinationAddress: string | null, originAddress: string | null, destinationCountry: { __typename?: 'Country', code: string, name: string } | null, events: Array<{ __typename?: 'ParcelShipmentEvent', address: string | null, date: string | null, status: string | null }>, originCountry: { __typename?: 'Country', code: string, name: string } | null, courier: { __typename?: 'Courier', id: number, logoUrl: string | null } | null }>, demurrage: { __typename?: 'Demurrage', id: number, freeTime: number | null, dailyRateUsd: string | null, calculations: { __typename?: 'DemurrageCalculations', totalExceedingDays: number, totalEstimatedCosts: string, totalDaysPaid: number, totalDaysToPay: number, averageCostPerDayUsd: string, totalOwedUsd: string, totalPaidUsd: string, totalToPayUsd: string } } | null, internationalFreight: { __typename?: 'InternationalFreight', id: number, freightForwarder: string | null, quotationNumber: string | null, plannedBoardingDate: string | null, freightCostPrepaid: string | null, freightCostCollect: string | null, freightCostRoad: string | null, freightCostTotal: string | null, type: InternationalFreightTypeEnum | null, bookingEta: string | null, bookingEtd: string | null, voyageNumber: string | null, cargoAttributes: Array<CargoAttributeEnum>, expectedSeparationAt: string | null, pickupLocation: string | null, currency: { __typename?: 'Currency', code: string } | null, portTerminal: { __typename?: 'PortTerminal', id: number, name: string } | null, bookingLoadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingDischargeAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingLoadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, sealine: { __typename?: 'Sealine', id: number, name: string, logoUrl: string | null } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } | null } | null, items: Array<{ __typename?: 'ForeignTradeItemShipment', id: number, quantity: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, unitValue: string | null, brazilianInvoiceUnitValue: string | null, totalValue: string | null, transportables: Array<{ __typename?: 'Transportable', id: number }>, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, balance: string | null, balanceShipped: string | null, lineNumber: number | null, lineReference: string, quantity: string | null, division: string | null, measurementUnitSap: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, sapByFactor: string | null, concessionAct: string | null, importTypeSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, orderModalTypeSap: string | null, orderAdjustedModalType: string | null, orderRequestedAt: string | null, planningRequestShippingAt: string | null, planningShippingAt: string | null, supplierSentAt: string | null, supplierConfirmationAt: string | null, supplierReadyLeadTimeDays: number | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierCalculatedReadyAt: string | null, supplierReadyDeviation: number | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedBoardingAt: string | null, shipmentPlannedArrivalAt: string | null, shipmentEstimatedBoardingAt: string | null, shipmentEstimatedArrivalAt: string | null, shipmentBoardingLeadTime: number | null, shipmentTransportLeadTime: number | null, customsEstimatedRegisterAt: string | null, customsRegisterLeadTime: number | null, customsEstimatedReleaseAt: string | null, customsReleaseLeadTime: number | null, factoryEstimatedDeliveryAt: string | null, factoryPlannedDeliveryAt: string | null, factoryDeliveryAt: string | null, factoryDeliveryLeadTime: number | null, adjustedCustomsRegisterLeadTime: number | null, adjustedCustomsReleaseLeadTime: number | null, adjustedFactoryDeliveryLeadTime: number | null, adjustedShipmentBoardingLeadTime: number | null, adjustedShipmentTransportLeadTime: number | null, adjustedSupplierReadyLeadTimeDays: number | null, assessmentSotd: string | null, itemStatus: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, invoiceIssuedAt: string | null, invoiceNumber: string | null, invoiceValue: string | null, invoiceType: string | null, deliveryNote: string | null, deliveryNoteIssuedAt: string | null, shippingDetailsDeliveryDate: string | null, quotationOpeningDate: string | null, purchaseOrder: { __typename?: 'PurchaseOrder', id: number, order: { __typename?: 'Order', id: number, referenceCode: string } }, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'PurchaseOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null, manufacturingCountry: { __typename?: 'Country', code: string } | null, purchaseCountry: { __typename?: 'Country', code: string } | null, dispatchingCountry: { __typename?: 'Country', code: string } | null } | null, salesOrderItem: { __typename?: 'SalesOrderItem', id: number, balance: string | null, balanceShipped: string | null, lineNumber: number | null, lineReference: string, quantity: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, dispatchNumber: string | null, measurementUnitSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedArrivalAt: string | null, shipmentPlannedBoardingAt: string | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierReadyDeviation: number | null, factoryDeliveryAt: string | null, factoryEstimatedDeliveryAt: string | null, itemStatus: string | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, necessityType: string | null, ubc: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, stockQuantity: string | null, clientApprovedAt: string | null, reservedStockQuantity: string | null, stockReservationAt: string | null, preliminaryPickingStartedAt: string | null, internalContainerReference: string | null, salesOrder: { __typename?: 'SalesOrder', id: number, order: { __typename?: 'Order', id: number, referenceCode: string } }, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'SalesOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null } | null }>, airTransportShipment: { __typename?: 'AirTransportShipment', id: number, type: AirTransportTypeEnum | null, awb: string | null, hawb: string | null, airline: { __typename?: 'Airline', id: number, name: string, logoUrl: string | null } | null, destinationAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string, country: { __typename?: 'Country', code: string } | null } | null, originAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string, country: { __typename?: 'Country', code: string } | null } | null } | null, roadTransportShipment: { __typename?: 'ForeignTradeRoadTransportShipment', id: number, type: ForeignTradeRoadTransportTypeEnum | null, crt: string | null, origin: string | null, destination: string | null } | null, maritimeTransportShipment: { __typename?: 'MaritimeTransportShipment', id: number, bl: string | null, booking: string | null, hbl: string | null, trackingNumber: string | null, trackingKey: TrackingKeyEnum | null, trackingKeyInsertedAt: string | null, trackingDischargePort: string | null, trackingLoadingPort: string | null, type: MaritimeTransportTypeEnum | null, voyageNumber: string | null, sealineOrigin: SealineOriginEnum | null, sealine: { __typename?: 'Sealine', id: number, name: string, logoUrl: string | null } | null, dischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null, country: { __typename?: 'Country', code: string } | null } | null, loadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null, country: { __typename?: 'Country', code: string } | null } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } | null } | null, pallets: Array<{ __typename?: 'ShipmentPallet', id: number, sizeType: PalletSizeTypeEnum, palletStandardId: number | null, lengthMm: number | null, widthMm: number | null, quantity: number, heightCm: number | null, palletStandard: { __typename?: 'PalletStandard', id: number, name: string | null, isoCode: string | null, eurCode: string | null } | null }>, transportables: Array<{ __typename?: 'Transportable', id: number, type: TransportableTypeEnum, container: { __typename?: 'Container', trackingApi: boolean, trackingManual: boolean, hidden: boolean, observations: string | null, id: number, code: string | null, type: ContainerTypeEnum | null, sizeFootType: ContainerSizeFootTypeEnum | null, loadType: LoadTypeEnum | null, maxWeightKg: string | null, grossWeightKg: string | null, tareWeightKg: string | null, sealCode: string | null, secondarySealCode: string | null, invoiceNumber: string | null, palletQuantity: number | null, isStackable: boolean | null, cubicMeters: string | null, dispatchNumber: string | null, transportDocument: string | null, actualReturnEmptyContainerAt: string | null, estimatedReturnEmptyContainerAt: string | null, demurrageDailyRateUsd: string | null, demurrageFreeTime: number | null, demurrageFreeTimeStartAt: string | null, route: string | null, internalReferenceCode: string | null, orderNumber: string | null, ncmCodes: Array<string> | null, htTreatment: boolean | null, htTreatmentAt: string | null, separationCompletedAt: string | null, estimatedStuffingAt: string | null, loadingScheduleAt: string | null, invoiceDocumentNumber: string | null, invoiceGrossWeight: string | null, invoiceValue: string | null, preStacking: boolean | null, preStackingReason: PreStackingReasonEnum | null, scaleExitAt: string | null, stackingScheduledAt: string | null, stackingStartedAt: string | null, portScheduledAt: string | null, portDepositDeadlineAt: string | null, portDepositAt: string | null, preStackingWarehouse: PreStackingWarehouseEnum | null, preStackingDays: number | null, emptyPickupAt: string | null, emptyReceivedAtFactory: string | null, oic: string | null, quantity: string | null, releasedForTripAt: string | null, washingValue: string | null, washingChargeReceivedAt: string | null, washingDamageStatus: ContainerWashingConclusionStatusEnum | null, washingTermStatus: ContainerWashingConclusionStatusEnum | null, washingTermDescription: ContainerWashingTermDescriptionEnum | null, washingServiceType: ContainerWashingServiceTypeEnum | null, washingPaymentStatus: ContainerWashingPaymentStatusEnum | null, washingPaymentAt: string | null, washingEmptyChecklist: boolean | null, washingDamageResult: ContainerWashingDamageResultEnum | null, washingInspection: string | null, debitNotes: Array<{ __typename?: 'DebitNote', coverageEndAt: string, coverageStartAt: string, daysCovered: number | null, id: number, number: string, payedAt: string | null, totalValueBrl: string | null, totalValueUsd: string, usdToBrlRate: string }>, demurrageCalculations: { __typename?: 'ContainerDemurrageCalculations', costPerDayBrl: string, costPerDayUsd: string, daysPaid: number, daysToPay: number, emptyReturnDeadline: string | null, estimatedCosts: string, exceedingDays: number, totalOwedBrl: string, totalOwedUsd: string, totalPaidBrl: string, totalPaidUsd: string, totalToPayBrl: string, totalToPayUsd: string } | null, events: Array<{ __typename?: 'ContainerEvent', datetime: string | null, estimated: boolean | null, place: string | null, status: string | null, transport: string | null, voyage: string | null }> } | null }>, shipmentDuimps: Array<{ __typename?: 'ShipmentDuimp', id: number, status: ShipmentDocumentAuthorizationStatusEnum, comments: string | null, insertedAt: string | null, automaticLinkOrigin: ShipmentDocumentAutomaticLinkOriginTypeEnum | null, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null, duimp: { __typename?: 'Duimp', id: number, channel: ChannelTypeEnum | null, customsClearedAt: string | null, deliveredAt: string | null, extra: any | null, lastUpdatedAt: string | null, number: string, registeredAt: string | null, status: DuimpStatusEnum | null, statusResponse: StatusResponseTypeEnum, statusUpdatedAt: string | null, version: number | null, importer: { __typename?: 'Actor', id: number, officialName: string, officialDocument: string | null, documentType: ActorDocumentTypeEnum | null, addresses: Array<{ __typename?: 'Address', id: number, country: string | null, state: string | null, city: string | null, street: string | null, number: string | null, postalCode: string | null, neighborhood: string | null, formattedAddress: string | null }> } | null } }>, shipmentImportDeclarations: Array<{ __typename?: 'ShipmentImportDeclaration', id: number, status: ShipmentDocumentAuthorizationStatusEnum, comments: string | null, insertedAt: string | null, automaticLinkOrigin: ShipmentDocumentAutomaticLinkOriginTypeEnum | null, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null, importDeclaration: { __typename?: 'ImportDeclaration', id: number, channel: ChannelTypeEnum | null, customsClearedAt: string | null, extra: any | null, lastUpdatedAt: string | null, number: string, registeredAt: string | null, status: ImportDeclarationStatusEnum | null, statusResponse: StatusResponseTypeEnum, statusUpdatedAt: string | null } }>, shipmentExportDeclarations: Array<{ __typename?: 'ShipmentExportDeclaration', id: number, comments: string | null, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null, exportDeclaration: { __typename?: 'ExportDeclaration', id: number, number: string, channel: ChannelExportDeclarationTypeEnum | null, extra: any | null, status: ExportDeclarationStatusEnum | null, statusResponse: StatusResponseTypeEnum, endorsedAt: string | null, customsClearedAt: string | null, registeredAt: string | null, insertedAt: string | null, lastUpdatedAt: string | null, events: Array<{ __typename?: 'ExportDeclarationEvent', action: ExportDeclarationEventActionEnum | null, date: string | null, extraInfo: string | null, responsible: string | null }> } }>, nationalRoadTransports: Array<{ __typename?: 'NationalRoadTransport', id: number, collectionScheduledAt: string | null, deliveryPlannedAt: string | null, isTransportTypeDta: boolean, loadType: LoadTypeEnum | null, roadTransportType: RoadTransportTypeEnum | null, transportFeatures: Array<TransportFeatureEnum>, quantityPallets: number | null, releasedForTransportAt: string | null, transportCompletedAt: string | null, legSlug: string, nationalRoadCarrier: { __typename?: 'Handler', id: number, actor: { __typename?: 'Actor', id: number, nickname: string }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null }, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum } } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, driverName: string | null, vehiclePlate: string | null, trailerPlate: string | null, position: number, driver: { __typename?: 'Driver', id: number, name: string } | null, vehicle: { __typename?: 'Vehicle', id: number, plate: string, trackerId: string | null } | null, trailer: { __typename?: 'Trailer', id: number, plate: string, trackerId: string | null } | null, phases: Array<{ __typename?: 'RoadTransportTripPhase', id: number, realizedAt: string | null, departureAt: string | null, estimatedRealizedAt: string | null, routePoint: { __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum } }>, transportables: Array<{ __typename?: 'Transportable', id: number }> }>, route: { __typename?: 'Route', id: number, name: string, active: boolean, points: Array<{ __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum, address: { __typename?: 'Address', id: number, city: string | null, country: string | null, name: string | null, number: string | null, postalCode: string | null, state: string | null, street: string | null, actor: { __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null } | null } | null }> } | null }>, shipmentImportLicenses: Array<{ __typename?: 'ShipmentImportLicense', id: number, status: ShipmentDocumentAuthorizationStatusEnum, comments: string | null, insertedAt: string | null, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null, importLicense: { __typename?: 'ImportLicense', id: number, approvedAt: string | null, extra: any | null, lastUpdatedAt: string | null, number: string, registeredAt: string | null, status: ImportLicenseStatusEnum | null, statusResponse: StatusResponseTypeEnum, statusUpdatedAt: string | null, importDeclaration: { __typename?: 'ImportDeclaration', id: number, number: string } | null } }>, invoices: Array<{ __typename?: 'Invoice', id: number, number: string, emittedAt: string, updatedAt: string, incoterm: IncotermTypeEnum, totalAmount: string, discount: string | null, finalValue: string, totalGrossWeightKg: string, items: Array<{ __typename?: 'InvoiceItem', id: number, productDescription: string | null, productSku: string, quantity: string, batchNumber: string | null, batchValidityDate: string | null, productionDate: string | null, totalAmount: string | null, unitaryAmount: string | null, totalGrossWeightKg: string | null, orderReferenceCode: string | null, orderItemLineReference: string | null, product: { __typename?: 'Product', id: number } | null, transportables: Array<{ __typename?: 'Transportable', id: number, container: { __typename?: 'Container', id: number, code: string | null } | null }> }>, currency: { __typename?: 'Currency', code: string } | null }>, vesselScheduleDeadlineReferences: { __typename?: 'VesselScheduleDeadlineReferences', draftDeadlineReference: DeadlineDateReferenceEnum | null, vgmDeadlineReference: VgmDeadlineDateReferenceEnum | null, cargoDeadlineReference: DeadlineDateReferenceEnum | null, gateOpeningDeadlineReference: GateOpeningDeadlineDateReferenceEnum | null } | null, vesselSchedule: { __typename?: 'VesselSchedule', id: number, sealineStatusResponse: VesselScheduleStatusResponseEnum, portTerminalStatusResponse: VesselScheduleStatusResponseEnum, sealineLastUpdatedAt: string | null, portTerminalLastUpdatedAt: string | null, deadlineDates: { __typename?: 'VesselScheduleDeadlineDates', draftDeadline: string | null, cargoDeadline: string | null, vgmDeadline: string | null, gateOpeningDeadline: string | null } | null, sealineVesselSchedules: Array<{ __typename?: 'SealineVesselSchedule', id: number, draftDeadline: string | null, cargoDeadline: string | null, specialCargoDraftDeadline: string | null, vgmDeadline: string | null, insertedAt: string | null }> | null, portTerminalVesselSchedules: Array<{ __typename?: 'PortTerminalVesselSchedule', id: number, draftDeadline: string | null, cargoDeadline: string | null, gateOpening: string | null, reeferGateOpening: string | null, insertedAt: string | null }> | null } | null } | null, handlers: Array<{ __typename?: 'Handler', id: number, reference: string | null, secondaryReference: string | null, businessUnit: string | null, actor: { __typename?: 'Actor', id: number, nickname: string, logoUrl: string | null }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null }, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, isListedInDynamicList: boolean, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean } }> } | null };

export type ProcessSubscriptionSubscriptionVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ProcessSubscriptionSubscription = { __typename?: 'RootSubscriptionType', process: { __typename?: 'ProcessSubscription', data: { __typename?: 'Process', id: number, alertLevel: AlertLevelEnum, canceledAt: string | null, deletedAt: string | null, finishedAt: string | null, referenceCode: string, extraFields: any | null, operation: { __typename?: 'Operation', id: number, title: string, subtitle: string | null, type: OperationTypeEnum, subType: OperationSubTypeEnum, isSiscomexEnabled: boolean, isCeMercanteEnabled: boolean, acceptHourInNationalRoadTransports: boolean, processModalHeaderConfigs: Array<{ __typename?: 'OperationModalHeaderConfig', label: string | null, value: string | null, type: PathConfigTypeEnum | null }>, operationPhases: Array<{ __typename?: 'OperationPhase', id: number, position: number, phase: { __typename?: 'Phase', id: number, phase: PhaseEnum }, components: Array<{ __typename?: 'Component', id: number, name: string, title: string | null, slug: string, props: any | null, position: number, extraFieldsDefinition: any | null, componentAccess: { __typename?: 'ComponentAccess', id: number, type: AccessEnum } }> }>, configProps: { __typename?: 'OperationConfigProps', isMultipleNationalRoadTransport: boolean, orderItemAdditionalFields: Array<string>, itemReference: ItemReferenceEnum }, operationAccess: { __typename?: 'OperationAccess', id: number, type: AccessEnum, canUpdateCancelledOrFinishedProcesses: boolean, canCloseOrReopenProcessesCosts: boolean, canSeeOrders: boolean }, actor: { __typename?: 'Actor', id: number, nickname: string, officialDocument: string | null, documentType: ActorDocumentTypeEnum | null }, operationHandlers: Array<{ __typename?: 'OperationHandler', id: number, owner: boolean, role: OperationHandlerEnum, isListedInDynamicList: boolean, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }> }, orders: Array<{ __typename?: 'Order', id: number, referenceCode: string }>, auditApprovalInfo: { __typename?: 'ProcessAuditApprovalInfo', approvedAt: string, approvedBy: { __typename?: 'User', id: string | null, name: string | null } } | null, auditItems: Array<{ __typename?: 'ProcessAuditItem', id: number, observations: string | null, checked: boolean | null, auditItem: { __typename?: 'AuditItem', id: number, name: string, showObservationsWhen: AuditItemShowObservationEnum } }>, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, bookingQuotation: { __typename?: 'BookingQuotation', id: number, agentNotes: string | null, documentIds: Array<number>, recipientIds: Array<number>, externalPagePublication: { __typename?: 'ExternalPagePublication', id: number, closesAt: string | null } } | null, documents: Array<{ __typename?: 'Document', id: number, type: DocumentTypeEnum, fileUrl: string, originalFilename: string, updatedAt: string, invoice: { __typename?: 'Invoice', id: number } | null, parentDocument: { __typename?: 'Document', id: number } | null, brazilianInvoiceInfo: { __typename?: 'BrazilianInvoice', accessKey: string, cfop: string | null, emittedAt: string, extra: string | null, number: string, type: string, sender: { __typename?: 'BrazilianInvoiceOriginator', cnpj: string | null, name: string, address: { __typename?: 'BrazilianInvoiceAddress', zip: string | null, street: string, number: string, neighborhood: string, city: string, state: string, country: string | null } | null }, transport: { __typename?: 'BrazilianInvoiceTransport', address: string | null, city: string | null, state: string | null, stateId: string | null, carrier: string | null, cnpj: string | null, brand: string | null, grossWeight: string | null, netWeight: string | null, quantity: string | null, specie: string | null, freightOnAccount: string, numeration: string | null, vehiclePlate: string | null }, tax: { __typename?: 'BrazilianInvoiceTax', base: string, discount: string, freight: string, importation: string, insurance: string, ipi: string, other: string, productValue: string, totalAmount: string, value: string }, products: Array<{ __typename?: 'BrazilianInvoiceProduct', code: string, description: string, ncm: string, unit: string, quantity: string, totalAmount: string, unitValue: string }>, issuer: { __typename?: 'BrazilianInvoiceOriginator', cnpj: string | null, name: string, stateId: string | null, address: { __typename?: 'BrazilianInvoiceAddress', zip: string | null, street: string, number: string, neighborhood: string, city: string, state: string, country: string | null } | null } } | null }>, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, ata: string | null, atd: string | null, eta: string | null, etd: string | null, type: ShipmentTypeEnum | null, receivedInWarehouseAt: string | null, departedFromWarehouseAt: string | null, warehouseFreeTimeDays: number, deliveredAt: string | null, insertedAt: string, statusResponse: StatusResponseTypeEnum, lastUpdatedAt: string | null, automaticTrackingEnabled: boolean, totalNetWeight: string | null, totalGrossWeight: string | null, cubageCubicMeters: string | null, ceMercanteNumber: string | null, ceMercanteAuthorizationStatus: ShipmentDocumentAuthorizationStatusEnum | null, ceMercanteLastSyncType: SiscomexSyncTypeEnum | null, ceMercanteLastSyncErrorMessage: string | null, ceMercanteData: { __typename?: 'CeMercanteData', id: number, number: string, issuedAt: string | null, insertedAt: string, cargoStatus: string | null, freightPaymentType: string | null, freightBasicCost: string | null, freightTotalCost: string | null, cargoDescription: string | null, grossWeightKg: string | null, hasDta: boolean | null, manifestArrivalAt: string | null, cargoPresenceInPrimaryZoneAt: string | null, cargoPresenceInSecondaryZoneAt: string | null, customsPlace: string | null, bl: string | null, consigneeDocument: string | null, consigneeExtraInfo: string | null, notes: string | null, extra: any | null, statusResponse: StatusResponseTypeEnum | null, lastUpdatedAt: string | null, cargoPresenceHistory: Array<{ __typename?: 'CeMercanteDataCargoPresenceHistory', ra: string | null, status: string | null, date: string | null, dtaNumber: string | null, syncedAt: string | null }>, containerSeals: Array<{ __typename?: 'CeMercanteDataContainerSeal', containerCode: string | null, sealCode: string | null, secondarySealCode: string | null }>, shippingAgency: { __typename?: 'Actor', id: number, officialDocument: string | null, nickname: string } | null, cargoManifests: Array<{ __typename?: 'CeMercanteDataCargoManifest', manifestNumber: string | null, loadingPortTerminal: string | null, dischargePortTerminal: string | null, loadingPortUnlocode: string | null, dischargePortUnlocode: string | null }>, freightCurrency: { __typename?: 'Currency', code: string, name: string } | null, originPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null, country: { __typename?: 'Country', code: string } | null } | null, destinationPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null, country: { __typename?: 'Country', code: string } | null } | null } | null, internationalTransportLegs: Array<{ __typename?: 'InternationalTransportLeg', arrivalPlace: string | null, departurePlace: string | null, etd: string | null, eta: string | null, atd: string | null, ata: string | null, modalType: ModalTypeEnum | null, voyage: string | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null } | null }>, hawbShipmentData: { __typename?: 'HawbShipmentData', id: number, status: string | null, hawb: string, extra: any | null, dtaNumber: string | null, vehiclePlateDta: string | null, departurePlaceDta: string | null, arrivalPlaceDta: string | null, ataDta: string | null, atdDta: string | null, loadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string }, unloadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } } | null, parcelShipments: Array<{ __typename?: 'ParcelShipment', id: number, ata: string | null, atd: string | null, eta: string | null, etd: string | null, status: ParcelShipmentStatusEnum, slug: string, trackingNumber: string, insertedAt: string, lastUpdatedAt: string | null, destinationAddress: string | null, originAddress: string | null, destinationCountry: { __typename?: 'Country', code: string, name: string } | null, events: Array<{ __typename?: 'ParcelShipmentEvent', address: string | null, date: string | null, status: string | null }>, originCountry: { __typename?: 'Country', code: string, name: string } | null, courier: { __typename?: 'Courier', id: number, logoUrl: string | null } | null }>, demurrage: { __typename?: 'Demurrage', id: number, freeTime: number | null, dailyRateUsd: string | null, calculations: { __typename?: 'DemurrageCalculations', totalExceedingDays: number, totalEstimatedCosts: string, totalDaysPaid: number, totalDaysToPay: number, averageCostPerDayUsd: string, totalOwedUsd: string, totalPaidUsd: string, totalToPayUsd: string } } | null, internationalFreight: { __typename?: 'InternationalFreight', id: number, freightForwarder: string | null, quotationNumber: string | null, plannedBoardingDate: string | null, freightCostPrepaid: string | null, freightCostCollect: string | null, freightCostRoad: string | null, freightCostTotal: string | null, type: InternationalFreightTypeEnum | null, bookingEta: string | null, bookingEtd: string | null, voyageNumber: string | null, cargoAttributes: Array<CargoAttributeEnum>, expectedSeparationAt: string | null, pickupLocation: string | null, currency: { __typename?: 'Currency', code: string } | null, portTerminal: { __typename?: 'PortTerminal', id: number, name: string } | null, bookingLoadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingDischargeAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingLoadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, sealine: { __typename?: 'Sealine', id: number, name: string, logoUrl: string | null } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } | null } | null, items: Array<{ __typename?: 'ForeignTradeItemShipment', id: number, quantity: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, unitValue: string | null, brazilianInvoiceUnitValue: string | null, totalValue: string | null, transportables: Array<{ __typename?: 'Transportable', id: number }>, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, balance: string | null, balanceShipped: string | null, lineNumber: number | null, lineReference: string, quantity: string | null, division: string | null, measurementUnitSap: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, sapByFactor: string | null, concessionAct: string | null, importTypeSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, orderModalTypeSap: string | null, orderAdjustedModalType: string | null, orderRequestedAt: string | null, planningRequestShippingAt: string | null, planningShippingAt: string | null, supplierSentAt: string | null, supplierConfirmationAt: string | null, supplierReadyLeadTimeDays: number | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierCalculatedReadyAt: string | null, supplierReadyDeviation: number | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedBoardingAt: string | null, shipmentPlannedArrivalAt: string | null, shipmentEstimatedBoardingAt: string | null, shipmentEstimatedArrivalAt: string | null, shipmentBoardingLeadTime: number | null, shipmentTransportLeadTime: number | null, customsEstimatedRegisterAt: string | null, customsRegisterLeadTime: number | null, customsEstimatedReleaseAt: string | null, customsReleaseLeadTime: number | null, factoryEstimatedDeliveryAt: string | null, factoryPlannedDeliveryAt: string | null, factoryDeliveryAt: string | null, factoryDeliveryLeadTime: number | null, adjustedCustomsRegisterLeadTime: number | null, adjustedCustomsReleaseLeadTime: number | null, adjustedFactoryDeliveryLeadTime: number | null, adjustedShipmentBoardingLeadTime: number | null, adjustedShipmentTransportLeadTime: number | null, adjustedSupplierReadyLeadTimeDays: number | null, assessmentSotd: string | null, itemStatus: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, invoiceIssuedAt: string | null, invoiceNumber: string | null, invoiceValue: string | null, invoiceType: string | null, deliveryNote: string | null, deliveryNoteIssuedAt: string | null, shippingDetailsDeliveryDate: string | null, quotationOpeningDate: string | null, purchaseOrder: { __typename?: 'PurchaseOrder', id: number, order: { __typename?: 'Order', id: number, referenceCode: string } }, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'PurchaseOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null, manufacturingCountry: { __typename?: 'Country', code: string } | null, purchaseCountry: { __typename?: 'Country', code: string } | null, dispatchingCountry: { __typename?: 'Country', code: string } | null } | null, salesOrderItem: { __typename?: 'SalesOrderItem', id: number, balance: string | null, balanceShipped: string | null, lineNumber: number | null, lineReference: string, quantity: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, dispatchNumber: string | null, measurementUnitSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedArrivalAt: string | null, shipmentPlannedBoardingAt: string | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierReadyDeviation: number | null, factoryDeliveryAt: string | null, factoryEstimatedDeliveryAt: string | null, itemStatus: string | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, necessityType: string | null, ubc: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, stockQuantity: string | null, clientApprovedAt: string | null, reservedStockQuantity: string | null, stockReservationAt: string | null, preliminaryPickingStartedAt: string | null, internalContainerReference: string | null, salesOrder: { __typename?: 'SalesOrder', id: number, order: { __typename?: 'Order', id: number, referenceCode: string } }, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'SalesOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null } | null }>, airTransportShipment: { __typename?: 'AirTransportShipment', id: number, type: AirTransportTypeEnum | null, awb: string | null, hawb: string | null, airline: { __typename?: 'Airline', id: number, name: string, logoUrl: string | null } | null, destinationAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string, country: { __typename?: 'Country', code: string } | null } | null, originAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string, country: { __typename?: 'Country', code: string } | null } | null } | null, roadTransportShipment: { __typename?: 'ForeignTradeRoadTransportShipment', id: number, type: ForeignTradeRoadTransportTypeEnum | null, crt: string | null, origin: string | null, destination: string | null } | null, maritimeTransportShipment: { __typename?: 'MaritimeTransportShipment', id: number, bl: string | null, booking: string | null, hbl: string | null, trackingNumber: string | null, trackingKey: TrackingKeyEnum | null, trackingKeyInsertedAt: string | null, trackingDischargePort: string | null, trackingLoadingPort: string | null, type: MaritimeTransportTypeEnum | null, voyageNumber: string | null, sealineOrigin: SealineOriginEnum | null, sealine: { __typename?: 'Sealine', id: number, name: string, logoUrl: string | null } | null, dischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null, country: { __typename?: 'Country', code: string } | null } | null, loadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null, country: { __typename?: 'Country', code: string } | null } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } | null } | null, pallets: Array<{ __typename?: 'ShipmentPallet', id: number, sizeType: PalletSizeTypeEnum, palletStandardId: number | null, lengthMm: number | null, widthMm: number | null, quantity: number, heightCm: number | null, palletStandard: { __typename?: 'PalletStandard', id: number, name: string | null, isoCode: string | null, eurCode: string | null } | null }>, transportables: Array<{ __typename?: 'Transportable', id: number, type: TransportableTypeEnum, container: { __typename?: 'Container', trackingApi: boolean, trackingManual: boolean, hidden: boolean, observations: string | null, id: number, code: string | null, type: ContainerTypeEnum | null, sizeFootType: ContainerSizeFootTypeEnum | null, loadType: LoadTypeEnum | null, maxWeightKg: string | null, grossWeightKg: string | null, tareWeightKg: string | null, sealCode: string | null, secondarySealCode: string | null, invoiceNumber: string | null, palletQuantity: number | null, isStackable: boolean | null, cubicMeters: string | null, dispatchNumber: string | null, transportDocument: string | null, actualReturnEmptyContainerAt: string | null, estimatedReturnEmptyContainerAt: string | null, demurrageDailyRateUsd: string | null, demurrageFreeTime: number | null, demurrageFreeTimeStartAt: string | null, route: string | null, internalReferenceCode: string | null, orderNumber: string | null, ncmCodes: Array<string> | null, htTreatment: boolean | null, htTreatmentAt: string | null, separationCompletedAt: string | null, estimatedStuffingAt: string | null, loadingScheduleAt: string | null, invoiceDocumentNumber: string | null, invoiceGrossWeight: string | null, invoiceValue: string | null, preStacking: boolean | null, preStackingReason: PreStackingReasonEnum | null, scaleExitAt: string | null, stackingScheduledAt: string | null, stackingStartedAt: string | null, portScheduledAt: string | null, portDepositDeadlineAt: string | null, portDepositAt: string | null, preStackingWarehouse: PreStackingWarehouseEnum | null, preStackingDays: number | null, emptyPickupAt: string | null, emptyReceivedAtFactory: string | null, oic: string | null, quantity: string | null, releasedForTripAt: string | null, washingValue: string | null, washingChargeReceivedAt: string | null, washingDamageStatus: ContainerWashingConclusionStatusEnum | null, washingTermStatus: ContainerWashingConclusionStatusEnum | null, washingTermDescription: ContainerWashingTermDescriptionEnum | null, washingServiceType: ContainerWashingServiceTypeEnum | null, washingPaymentStatus: ContainerWashingPaymentStatusEnum | null, washingPaymentAt: string | null, washingEmptyChecklist: boolean | null, washingDamageResult: ContainerWashingDamageResultEnum | null, washingInspection: string | null, debitNotes: Array<{ __typename?: 'DebitNote', coverageEndAt: string, coverageStartAt: string, daysCovered: number | null, id: number, number: string, payedAt: string | null, totalValueBrl: string | null, totalValueUsd: string, usdToBrlRate: string }>, demurrageCalculations: { __typename?: 'ContainerDemurrageCalculations', costPerDayBrl: string, costPerDayUsd: string, daysPaid: number, daysToPay: number, emptyReturnDeadline: string | null, estimatedCosts: string, exceedingDays: number, totalOwedBrl: string, totalOwedUsd: string, totalPaidBrl: string, totalPaidUsd: string, totalToPayBrl: string, totalToPayUsd: string } | null, events: Array<{ __typename?: 'ContainerEvent', datetime: string | null, estimated: boolean | null, place: string | null, status: string | null, transport: string | null, voyage: string | null }> } | null }>, shipmentDuimps: Array<{ __typename?: 'ShipmentDuimp', id: number, status: ShipmentDocumentAuthorizationStatusEnum, comments: string | null, insertedAt: string | null, automaticLinkOrigin: ShipmentDocumentAutomaticLinkOriginTypeEnum | null, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null, duimp: { __typename?: 'Duimp', id: number, channel: ChannelTypeEnum | null, customsClearedAt: string | null, deliveredAt: string | null, extra: any | null, lastUpdatedAt: string | null, number: string, registeredAt: string | null, status: DuimpStatusEnum | null, statusResponse: StatusResponseTypeEnum, statusUpdatedAt: string | null, version: number | null, importer: { __typename?: 'Actor', id: number, officialName: string, officialDocument: string | null, documentType: ActorDocumentTypeEnum | null, addresses: Array<{ __typename?: 'Address', id: number, country: string | null, state: string | null, city: string | null, street: string | null, number: string | null, postalCode: string | null, neighborhood: string | null, formattedAddress: string | null }> } | null } }>, shipmentImportDeclarations: Array<{ __typename?: 'ShipmentImportDeclaration', id: number, status: ShipmentDocumentAuthorizationStatusEnum, comments: string | null, insertedAt: string | null, automaticLinkOrigin: ShipmentDocumentAutomaticLinkOriginTypeEnum | null, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null, importDeclaration: { __typename?: 'ImportDeclaration', id: number, channel: ChannelTypeEnum | null, customsClearedAt: string | null, extra: any | null, lastUpdatedAt: string | null, number: string, registeredAt: string | null, status: ImportDeclarationStatusEnum | null, statusResponse: StatusResponseTypeEnum, statusUpdatedAt: string | null } }>, shipmentExportDeclarations: Array<{ __typename?: 'ShipmentExportDeclaration', id: number, comments: string | null, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null, exportDeclaration: { __typename?: 'ExportDeclaration', id: number, number: string, channel: ChannelExportDeclarationTypeEnum | null, extra: any | null, status: ExportDeclarationStatusEnum | null, statusResponse: StatusResponseTypeEnum, endorsedAt: string | null, customsClearedAt: string | null, registeredAt: string | null, insertedAt: string | null, lastUpdatedAt: string | null, events: Array<{ __typename?: 'ExportDeclarationEvent', action: ExportDeclarationEventActionEnum | null, date: string | null, extraInfo: string | null, responsible: string | null }> } }>, nationalRoadTransports: Array<{ __typename?: 'NationalRoadTransport', id: number, collectionScheduledAt: string | null, deliveryPlannedAt: string | null, isTransportTypeDta: boolean, loadType: LoadTypeEnum | null, roadTransportType: RoadTransportTypeEnum | null, transportFeatures: Array<TransportFeatureEnum>, quantityPallets: number | null, releasedForTransportAt: string | null, transportCompletedAt: string | null, legSlug: string, nationalRoadCarrier: { __typename?: 'Handler', id: number, actor: { __typename?: 'Actor', id: number, nickname: string }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null }, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum } } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, driverName: string | null, vehiclePlate: string | null, trailerPlate: string | null, position: number, driver: { __typename?: 'Driver', id: number, name: string } | null, vehicle: { __typename?: 'Vehicle', id: number, plate: string, trackerId: string | null } | null, trailer: { __typename?: 'Trailer', id: number, plate: string, trackerId: string | null } | null, phases: Array<{ __typename?: 'RoadTransportTripPhase', id: number, realizedAt: string | null, departureAt: string | null, estimatedRealizedAt: string | null, routePoint: { __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum } }>, transportables: Array<{ __typename?: 'Transportable', id: number }> }>, route: { __typename?: 'Route', id: number, name: string, active: boolean, points: Array<{ __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum, address: { __typename?: 'Address', id: number, city: string | null, country: string | null, name: string | null, number: string | null, postalCode: string | null, state: string | null, street: string | null, actor: { __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null } | null } | null }> } | null }>, shipmentImportLicenses: Array<{ __typename?: 'ShipmentImportLicense', id: number, status: ShipmentDocumentAuthorizationStatusEnum, comments: string | null, insertedAt: string | null, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null, importLicense: { __typename?: 'ImportLicense', id: number, approvedAt: string | null, extra: any | null, lastUpdatedAt: string | null, number: string, registeredAt: string | null, status: ImportLicenseStatusEnum | null, statusResponse: StatusResponseTypeEnum, statusUpdatedAt: string | null, importDeclaration: { __typename?: 'ImportDeclaration', id: number, number: string } | null } }>, invoices: Array<{ __typename?: 'Invoice', id: number, number: string, emittedAt: string, updatedAt: string, incoterm: IncotermTypeEnum, totalAmount: string, discount: string | null, finalValue: string, totalGrossWeightKg: string, items: Array<{ __typename?: 'InvoiceItem', id: number, productDescription: string | null, productSku: string, quantity: string, batchNumber: string | null, batchValidityDate: string | null, productionDate: string | null, totalAmount: string | null, unitaryAmount: string | null, totalGrossWeightKg: string | null, orderReferenceCode: string | null, orderItemLineReference: string | null, product: { __typename?: 'Product', id: number } | null, transportables: Array<{ __typename?: 'Transportable', id: number, container: { __typename?: 'Container', id: number, code: string | null } | null }> }>, currency: { __typename?: 'Currency', code: string } | null }>, vesselScheduleDeadlineReferences: { __typename?: 'VesselScheduleDeadlineReferences', draftDeadlineReference: DeadlineDateReferenceEnum | null, vgmDeadlineReference: VgmDeadlineDateReferenceEnum | null, cargoDeadlineReference: DeadlineDateReferenceEnum | null, gateOpeningDeadlineReference: GateOpeningDeadlineDateReferenceEnum | null } | null, vesselSchedule: { __typename?: 'VesselSchedule', id: number, sealineStatusResponse: VesselScheduleStatusResponseEnum, portTerminalStatusResponse: VesselScheduleStatusResponseEnum, sealineLastUpdatedAt: string | null, portTerminalLastUpdatedAt: string | null, deadlineDates: { __typename?: 'VesselScheduleDeadlineDates', draftDeadline: string | null, cargoDeadline: string | null, vgmDeadline: string | null, gateOpeningDeadline: string | null } | null, sealineVesselSchedules: Array<{ __typename?: 'SealineVesselSchedule', id: number, draftDeadline: string | null, cargoDeadline: string | null, specialCargoDraftDeadline: string | null, vgmDeadline: string | null, insertedAt: string | null }> | null, portTerminalVesselSchedules: Array<{ __typename?: 'PortTerminalVesselSchedule', id: number, draftDeadline: string | null, cargoDeadline: string | null, gateOpening: string | null, reeferGateOpening: string | null, insertedAt: string | null }> | null } | null } | null, handlers: Array<{ __typename?: 'Handler', id: number, reference: string | null, secondaryReference: string | null, businessUnit: string | null, actor: { __typename?: 'Actor', id: number, nickname: string, logoUrl: string | null }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null }, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, isListedInDynamicList: boolean, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean } }> } | null, latestVersion: { __typename?: 'Version', id: number, origin: VersionOriginEnum | null, user: { __typename?: 'User', id: string | null, email: string | null } | null } | null } };

export type UpdateProcessMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  params: UpdateProcessParams;
}>;


export type UpdateProcessMutation = { __typename?: 'RootMutationType', updateProcess: { __typename?: 'Process', id: number } | null };

export type UploadDocumentsToProcessMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  params: Array<CreateDocumentParams> | CreateDocumentParams;
}>;


export type UploadDocumentsToProcessMutation = { __typename?: 'RootMutationType', uploadDocumentsToProcess: Array<{ __typename?: 'Document', id: number }> };

export type GetOrderPartialOperationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOrderPartialOperationQuery = { __typename?: 'RootQueryType', operation: { __typename?: 'Operation', id: number, autoGenerateOrderCode: boolean, subType: OperationSubTypeEnum, configProps: { __typename?: 'OperationConfigProps', showExternalReferenceCode: boolean, orderItemAdditionalFields: Array<string>, itemReference: ItemReferenceEnum }, operationHandlers: Array<{ __typename?: 'OperationHandler', id: number, owner: boolean, role: OperationHandlerEnum, isListedInDynamicList: boolean, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }>, orderComponents: Array<{ __typename?: 'Component', id: number, name: string, slug: string, props: any | null, position: number, extraFieldsDefinition: any | null, title: string | null, componentAccess: { __typename?: 'ComponentAccess', id: number, type: AccessEnum } }> } | null };

export type GetContainerTypeEnumValuesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContainerTypeEnumValuesQuery = { __typename?: 'RootQueryType', __type: { __typename?: '__Type', name: string | null, enumValues: Array<{ __typename?: '__EnumValue', name: string, description: string | null }> | null } | null };

export type GetLoadTypeEnumValuesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoadTypeEnumValuesQuery = { __typename?: 'RootQueryType', __type: { __typename?: '__Type', name: string | null, enumValues: Array<{ __typename?: '__EnumValue', name: string, description: string | null }> | null } | null };

export type BookingProposalFieldsFragment = { __typename?: 'BookingProposal', id: number, number: string, serviceType: BookingProposalServiceTypeEnum | null, transitTimeDays: number | null, coLoader: string | null, routeNotes: string | null, conditions: string | null, originCosts: string | null, originFees: string | null, originDomesticFreight: string | null, internationalFreight: string | null, destinationCosts: string | null, destinationInlandFreight: string | null, originSubtotal: string, destinationSubtotal: string, total: string | null, representativeness: string | null, insertedAt: string, updatedAt: string, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string }, sealine: { __typename?: 'Sealine', id: number, name: string, nickname: string } | null, loadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, dischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, attachments: Array<{ __typename?: 'BookingProposalAttachment', id: number, originalFilename: string | null, downloadUrl: string | null }> };

export type BookingQuotationProposalsQueryVariables = Exact<{
  processId: Scalars['Int']['input'];
}>;


export type BookingQuotationProposalsQuery = { __typename?: 'RootQueryType', bookingQuotationProposals: Array<{ __typename?: 'BookingProposal', id: number, number: string, serviceType: BookingProposalServiceTypeEnum | null, transitTimeDays: number | null, coLoader: string | null, routeNotes: string | null, conditions: string | null, originCosts: string | null, originFees: string | null, originDomesticFreight: string | null, internationalFreight: string | null, destinationCosts: string | null, destinationInlandFreight: string | null, originSubtotal: string, destinationSubtotal: string, total: string | null, representativeness: string | null, insertedAt: string, updatedAt: string, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string }, sealine: { __typename?: 'Sealine', id: number, name: string, nickname: string } | null, loadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, dischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, attachments: Array<{ __typename?: 'BookingProposalAttachment', id: number, originalFilename: string | null, downloadUrl: string | null }> }> };

export type CancelBookingQuotationMutationVariables = Exact<{
  processId: Scalars['Int']['input'];
  params?: InputMaybe<CancelBookingQuotationParams>;
}>;


export type CancelBookingQuotationMutation = { __typename?: 'RootMutationType', cancelBookingQuotation: { __typename?: 'BookingQuotation', id: number } | null };

export type DefineBookingQuotationWinnerMutationVariables = Exact<{
  proposalId: Scalars['Int']['input'];
  params?: InputMaybe<DefineBookingQuotationWinnerParams>;
}>;


export type DefineBookingQuotationWinnerMutation = { __typename?: 'RootMutationType', defineBookingQuotationWinner: { __typename?: 'BookingQuotation', id: number } | null };

export type BookingQuotationInvitableRecipientsQueryVariables = Exact<{
  processId: Scalars['Int']['input'];
}>;


export type BookingQuotationInvitableRecipientsQuery = { __typename?: 'RootQueryType', bookingQuotationInvitableRecipients: Array<{ __typename?: 'NotificationGroupRecipient', id: number, emails: Array<string>, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> };

export type ProcessBookingQuotationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ProcessBookingQuotationQuery = { __typename?: 'RootQueryType', process: { __typename?: 'Process', id: number, bookingQuotationPage: { __typename?: 'ExternalPage', id: number, name: string, type: ExternalPageTypeEnum, timezone: string } | null, bookingDataPublication: { __typename?: 'ExternalPagePublication', id: number, lastInviteSentAt: string | null } | null, bookingQuotation: { __typename?: 'BookingQuotation', id: number, round: number, agentNotes: string | null, status: BookingQuotationStatusEnum, invitedCount: number, respondedCount: number, invoicesFinalValue: string | null, collectionNotes: string | null, winnerProposal: { __typename?: 'BookingProposal', id: number, number: string, serviceType: BookingProposalServiceTypeEnum | null, transitTimeDays: number | null, coLoader: string | null, routeNotes: string | null, conditions: string | null, originCosts: string | null, originFees: string | null, originDomesticFreight: string | null, internationalFreight: string | null, destinationCosts: string | null, destinationInlandFreight: string | null, originSubtotal: string, destinationSubtotal: string, total: string | null, representativeness: string | null, insertedAt: string, updatedAt: string, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string }, sealine: { __typename?: 'Sealine', id: number, name: string, nickname: string } | null, loadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, dischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, attachments: Array<{ __typename?: 'BookingProposalAttachment', id: number, originalFilename: string | null, downloadUrl: string | null }> } | null, externalPagePublication: { __typename?: 'ExternalPagePublication', id: number, insertedAt: string, publishedAt: string | null, closesAt: string | null, canceledAt: string | null, cancellationReason: string | null }, replies: Array<{ __typename?: 'BookingProposalReply', status: BookingProposalStatusReplyEnum, declineReason: string | null, lastUpdatedAt: string | null, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } }>, snapshotChanges: Array<{ __typename?: 'SnapshotChange', path: string, label: string | null, before: any | null, after: any | null }> } | null } | null };

export type ResendBookingDataInvitesMutationVariables = Exact<{
  processId: Scalars['Int']['input'];
}>;


export type ResendBookingDataInvitesMutation = { __typename?: 'RootMutationType', resendBookingDataInvites: { __typename?: 'ExternalPagePublication', id: number, lastInviteSentAt: string | null } | null };

export type SendBookingQuotationMutationVariables = Exact<{
  processId: Scalars['Int']['input'];
}>;


export type SendBookingQuotationMutation = { __typename?: 'RootMutationType', sendBookingQuotation: { __typename?: 'BookingQuotation', id: number } | null };

export type GetOperationCostModelsQueryVariables = Exact<{
  filters?: InputMaybe<FilterCostModelParams>;
}>;


export type GetOperationCostModelsQuery = { __typename?: 'RootQueryType', costModels: Array<{ __typename?: 'CostModel', id: number, name: string, versions: Array<{ __typename?: 'CostModelVersion', id: number, version: number }> }> };

export type GetPlannedLeadTimeOptionsQueryVariables = Exact<{
  filters: FilterPlannedLeadTimeParams;
}>;


export type GetPlannedLeadTimeOptionsQuery = { __typename?: 'RootQueryType', plannedLeadTimes: Array<{ __typename?: 'PlannedLeadTime', id: number, name: string, leadTimeModel: { __typename?: 'LeadTimeModel', id: number, referenceEvent: string, referenceEventLabel: string, ignoreTime: boolean }, stages: Array<{ __typename?: 'PlannedLeadTimeStage', id: number, days: number, hours: number, quantityHours: number, leadTimeStageModel: { __typename?: 'LeadTimeStageModel', id: number, name: string, color: string, startEvent: string, endEvent: string } }> }> };

export type ListProductsFromOrderQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  isImport: Scalars['Boolean']['input'];
}>;


export type ListProductsFromOrderQuery = { __typename?: 'RootQueryType', order: { __typename?: 'Order', id: number, referenceCode: string, purchaseOrder?: { __typename?: 'PurchaseOrder', id: number, items: Array<{ __typename?: 'PurchaseOrderItem', id: number, quantity: string | null, balance: string | null, lineNumber: number | null, lineReference: string, measurementUnitSap: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, sapByFactor: string | null, concessionAct: string | null, importTypeSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, orderModalTypeSap: string | null, orderAdjustedModalType: string | null, orderRequestedAt: string | null, planningRequestShippingAt: string | null, planningShippingAt: string | null, supplierSentAt: string | null, supplierConfirmationAt: string | null, supplierReadyLeadTimeDays: number | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierCalculatedReadyAt: string | null, supplierReadyDeviation: number | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedBoardingAt: string | null, shipmentPlannedArrivalAt: string | null, shipmentEstimatedBoardingAt: string | null, shipmentEstimatedArrivalAt: string | null, shipmentBoardingLeadTime: number | null, shipmentTransportLeadTime: number | null, customsEstimatedRegisterAt: string | null, customsRegisterLeadTime: number | null, customsEstimatedReleaseAt: string | null, customsReleaseLeadTime: number | null, factoryEstimatedDeliveryAt: string | null, factoryPlannedDeliveryAt: string | null, factoryDeliveryAt: string | null, factoryDeliveryLeadTime: number | null, adjustedCustomsRegisterLeadTime: number | null, adjustedCustomsReleaseLeadTime: number | null, adjustedFactoryDeliveryLeadTime: number | null, adjustedShipmentBoardingLeadTime: number | null, adjustedShipmentTransportLeadTime: number | null, adjustedSupplierReadyLeadTimeDays: number | null, assessmentSotd: string | null, itemStatus: string | null, division: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, invoiceIssuedAt: string | null, invoiceNumber: string | null, invoiceValue: string | null, invoiceType: string | null, deliveryNote: string | null, deliveryNoteIssuedAt: string | null, shippingDetailsDeliveryDate: string | null, quotationOpeningDate: string | null, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'PurchaseOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null, manufacturingCountry: { __typename?: 'Country', code: string } | null, purchaseCountry: { __typename?: 'Country', code: string } | null, dispatchingCountry: { __typename?: 'Country', code: string } | null }> } | null, salesOrder?: { __typename?: 'SalesOrder', id: number, items: Array<{ __typename?: 'SalesOrderItem', id: number, quantity: string | null, balance: string | null, lineNumber: number | null, lineReference: string, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, dispatchNumber: string | null, measurementUnitSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedArrivalAt: string | null, shipmentPlannedBoardingAt: string | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierReadyDeviation: number | null, factoryDeliveryAt: string | null, factoryEstimatedDeliveryAt: string | null, itemStatus: string | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, necessityType: string | null, ubc: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, stockQuantity: string | null, clientApprovedAt: string | null, reservedStockQuantity: string | null, stockReservationAt: string | null, preliminaryPickingStartedAt: string | null, internalContainerReference: string | null, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'SalesOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null }> } | null } | null };

export type ListShipmentOrdersQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  paginationNumber: Scalars['Int']['input'];
  filters?: InputMaybe<FilterOrderParams>;
}>;


export type ListShipmentOrdersQuery = { __typename?: 'RootQueryType', operation: { __typename?: 'Operation', id: number, orders: Array<{ __typename?: 'Order', id: number, referenceCode: string }> } | null };

export type CeMercanteSyncSubscriptionSubscriptionVariables = Exact<{
  foreignTradeShipmentId: Scalars['Int']['input'];
}>;


export type CeMercanteSyncSubscriptionSubscription = { __typename?: 'RootSubscriptionType', ceMercanteSyncSubscription: { __typename?: 'ForeignTradeShipmentCeMercanteSyncSubscriptionData', data: { __typename?: 'CeMercanteData', id: number, lastUpdatedAt: string | null }, shipment: { __typename?: 'ForeignTradeShipment', id: number, ceMercanteLastSyncType: SiscomexSyncTypeEnum | null, ceMercanteLastSyncErrorMessage: string | null } } };

export type TriggerCeMercanteSyncMutationVariables = Exact<{
  foreignTradeShipmentId: Scalars['Int']['input'];
}>;


export type TriggerCeMercanteSyncMutation = { __typename?: 'RootMutationType', triggerCeMercanteSync: { __typename?: 'SyncTriggerResult', syncing: boolean } | null };

export type DuimpSyncSubscriptionSubscriptionVariables = Exact<{
  shipmentDuimpId: Scalars['Int']['input'];
}>;


export type DuimpSyncSubscriptionSubscription = { __typename?: 'RootSubscriptionType', duimpSyncSubscription: { __typename?: 'DuimpSyncSubscriptionData', data: { __typename?: 'Duimp', id: number, lastUpdatedAt: string | null }, shipment: { __typename?: 'ShipmentDuimp', id: number, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null } } };

export type TriggerDuimpSyncMutationVariables = Exact<{
  shipmentDuimpId: Scalars['Int']['input'];
}>;


export type TriggerDuimpSyncMutation = { __typename?: 'RootMutationType', triggerDuimpSync: { __typename?: 'SyncTriggerResult', syncing: boolean } | null };

export type ExportDeclarationSyncSubscriptionSubscriptionVariables = Exact<{
  shipmentExportDeclarationId: Scalars['Int']['input'];
}>;


export type ExportDeclarationSyncSubscriptionSubscription = { __typename?: 'RootSubscriptionType', exportDeclarationSyncSubscription: { __typename?: 'ExportDeclarationSyncSubscriptionData', data: { __typename?: 'ExportDeclaration', id: number, lastUpdatedAt: string | null }, shipment: { __typename?: 'ShipmentExportDeclaration', id: number, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null } } };

export type TriggerExportDeclarationSyncMutationVariables = Exact<{
  shipmentExportDeclarationId: Scalars['Int']['input'];
}>;


export type TriggerExportDeclarationSyncMutation = { __typename?: 'RootMutationType', triggerExportDeclarationSync: { __typename?: 'SyncTriggerResult', syncing: boolean } | null };

export type ImportDeclarationSyncSubscriptionSubscriptionVariables = Exact<{
  shipmentImportDeclarationId: Scalars['Int']['input'];
}>;


export type ImportDeclarationSyncSubscriptionSubscription = { __typename?: 'RootSubscriptionType', importDeclarationSyncSubscription: { __typename?: 'ImportDeclarationSyncSubscriptionData', data: { __typename?: 'ImportDeclaration', id: number, lastUpdatedAt: string | null }, shipment: { __typename?: 'ShipmentImportDeclaration', id: number, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null } } };

export type TriggerImportDeclarationSyncMutationVariables = Exact<{
  shipmentImportDeclarationId: Scalars['Int']['input'];
}>;


export type TriggerImportDeclarationSyncMutation = { __typename?: 'RootMutationType', triggerImportDeclarationSync: { __typename?: 'SyncTriggerResult', syncing: boolean } | null };

export type ImportLicenseSyncSubscriptionSubscriptionVariables = Exact<{
  shipmentImportLicenseId: Scalars['Int']['input'];
}>;


export type ImportLicenseSyncSubscriptionSubscription = { __typename?: 'RootSubscriptionType', importLicenseSyncSubscription: { __typename?: 'ImportLicenseSyncSubscriptionData', data: { __typename?: 'ImportLicense', id: number, lastUpdatedAt: string | null }, shipment: { __typename?: 'ShipmentImportLicense', id: number, lastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null } } };

export type TriggerImportLicenseSyncMutationVariables = Exact<{
  shipmentImportLicenseId: Scalars['Int']['input'];
}>;


export type TriggerImportLicenseSyncMutation = { __typename?: 'RootMutationType', triggerImportLicenseSync: { __typename?: 'SyncTriggerResult', syncing: boolean } | null };

export type PalletStandardsQueryVariables = Exact<{ [key: string]: never; }>;


export type PalletStandardsQuery = { __typename?: 'RootQueryType', palletStandards: Array<{ __typename?: 'PalletStandard', id: number, name: string | null, lengthMm: number, widthMm: number, isoCode: string | null, eurCode: string | null }> };

export type FinishSchedulingMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type FinishSchedulingMutation = { __typename?: 'RootMutationType', finishScheduling: { __typename?: 'RoadTransportOrder', id: number } | null };

export type ListDriversToScheduleQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<DriverPaginationParams>;
}>;


export type ListDriversToScheduleQuery = { __typename?: 'RootQueryType', drivers: Array<{ __typename?: 'Driver', id: number, name: string, cpf: string | null, licenseNumber: string | null, licenseCategory: string | null }> };

export type ListTrailersToScheduleQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<TrailerPaginationParams>;
}>;


export type ListTrailersToScheduleQuery = { __typename?: 'RootQueryType', trailers: Array<{ __typename?: 'Trailer', id: number, plate: string, type: TrailerTypeEnum }> };

export type ListVehiclesToScheduleQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<VehiclePaginationParams>;
}>;


export type ListVehiclesToScheduleQuery = { __typename?: 'RootQueryType', vehicles: Array<{ __typename?: 'Vehicle', id: number, plate: string, type: VehicleTypeEnum }> };

export type UserNotificationSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UserNotificationSubscriptionSubscription = { __typename?: 'RootSubscriptionType', userNotification: { __typename?: 'UserNotification', type: UserNotificationTypeEnum, reportRequest: { __typename?: 'ReportRequest', id: number, fileUrl: string | null, report: { __typename?: 'Report', id: number, name: string, reportGroup: { __typename?: 'ReportGroup', id: number, reference: ReportReferenceEnum } } | null } | null } };

export type GetAccessGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccessGroupsQuery = { __typename?: 'RootQueryType', accessGroups: Array<{ __typename?: 'AccessGroup', id: number, name: string }> };

export type GetAgentsOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgentsOptionsQuery = { __typename?: 'RootQueryType', agents: Array<{ __typename?: 'Agent', id: number, name: string }> };

export type GetAirlinesQueryVariables = Exact<{
  paginationNumber?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAirlinesQuery = { __typename?: 'RootQueryType', airlines: Array<{ __typename?: 'Airline', id: number, logoUrl: string | null, name: string }> };

export type GetAirportsQueryVariables = Exact<{
  paginationNumber?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAirportsQuery = { __typename?: 'RootQueryType', airports: Array<{ __typename?: 'Airport', id: number, name: string, iataCode: string }> };

export type GetApiKeysOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApiKeysOptionsQuery = { __typename?: 'RootQueryType', apiKeys: Array<{ __typename?: 'ApiKey', id: number, name: string }> };

export type GetComponentsOptionsQueryVariables = Exact<{
  operationId: Scalars['Int']['input'];
}>;


export type GetComponentsOptionsQuery = { __typename?: 'RootQueryType', operation: { __typename?: 'Operation', id: number, operationPhases: Array<{ __typename?: 'OperationPhase', id: number, phase: { __typename?: 'Phase', id: number, phase: PhaseEnum }, components: Array<{ __typename?: 'Component', id: number, name: string, title: string | null, props: any | null, slug: string, extraFieldsDefinition: any | null, componentAccess: { __typename?: 'ComponentAccess', id: number, type: AccessEnum } }> }> } | null };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { __typename?: 'RootQueryType', countries: Array<{ __typename?: 'Country', code: string }> };

export type GetCurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrenciesQuery = { __typename?: 'RootQueryType', currencies: Array<{ __typename?: 'Currency', code: string, name: string, symbol: string | null }> };

export type GetDriversQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDriversQuery = { __typename?: 'RootQueryType', drivers: Array<{ __typename?: 'Driver', id: number, name: string }> };

export type GetLpcosSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<LpcoPaginationParams>;
}>;


export type GetLpcosSearchQuery = { __typename?: 'RootQueryType', lpcos: Array<{ __typename?: 'Lpco', id: number, number: string }> };

export type GetMaritimePortsQueryVariables = Exact<{
  paginationNumber?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMaritimePortsQuery = { __typename?: 'RootQueryType', maritimePorts: Array<{ __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null }> };

export type GetOperationsOptionsQueryVariables = Exact<{
  paginationNumber?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOperationsOptionsQuery = { __typename?: 'RootQueryType', operations: Array<{ __typename?: 'Operation', id: number, title: string }> };

export type GetOrdersSearchQueryVariables = Exact<{
  filters?: InputMaybe<FilterOrderParams>;
  paginationNumber?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetOrdersSearchQuery = { __typename?: 'RootQueryType', orders: Array<{ __typename?: 'Order', id: number, referenceCode: string }> };

export type GetPortTerminalsSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPortTerminalsSelectQuery = { __typename?: 'RootQueryType', portTerminals: Array<{ __typename?: 'PortTerminal', id: number, name: string }> };

export type GetProcessesFieldsQueryVariables = Exact<{
  operationIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetProcessesFieldsQuery = { __typename?: 'RootQueryType', leadTimeProcessesFields: Array<{ __typename?: 'Path', isList: boolean, label: string, path: string, type: PathTypeEnum }> };

export type GetProcessesOptionsQueryVariables = Exact<{
  filters?: InputMaybe<FilterProcessParams>;
  paginationNumber?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetProcessesOptionsQuery = { __typename?: 'RootQueryType', processes: Array<{ __typename?: 'Process', id: number, referenceCode: string, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, type: ShipmentTypeEnum | null, automaticTrackingEnabled: boolean } | null }> };

export type GetProcessesSearchQueryVariables = Exact<{
  filters?: InputMaybe<FilterProcessParams>;
  paginationNumber?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetProcessesSearchQuery = { __typename?: 'RootQueryType', processes: Array<{ __typename?: 'Process', id: number, referenceCode: string }> };

export type GetSealinesQueryVariables = Exact<{
  paginationNumber?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSealinesQuery = { __typename?: 'RootQueryType', sealines: Array<{ __typename?: 'Sealine', id: number, name: string, logoUrl: string | null }> };

export type GetSubsidiariesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubsidiariesQuery = { __typename?: 'RootQueryType', currentUser: { __typename?: 'User', id: string | null, currentWorkspace: { __typename?: 'Workspace', client: { __typename?: 'Client', id: number, actor: { __typename?: 'Actor', id: number, subsidiaries: Array<{ __typename?: 'Subsidiary', id: number, name: string }> } } | null } | null } | null };

export type GetTrailersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrailersQuery = { __typename?: 'RootQueryType', trailers: Array<{ __typename?: 'Trailer', id: number, plate: string }> };

export type GetVehiclesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVehiclesQuery = { __typename?: 'RootQueryType', vehicles: Array<{ __typename?: 'Vehicle', id: number, plate: string, trackerId: string | null, trackerBrand: TrackerBrandEnum | null }> };

export type GetVesselsSelectQueryVariables = Exact<{
  paginationNumber?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVesselsSelectQuery = { __typename?: 'RootQueryType', vessels: Array<{ __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null }> };

export type GetCurrentUserDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserDataQuery = { __typename?: 'RootQueryType', currentUser: { __typename?: 'User', id: string | null, name: string | null, picture: string | null, email: string | null } | null };

export type ContainerFieldsFragmentFragment = { __typename?: 'Container', id: number, code: string | null, type: ContainerTypeEnum | null, sizeFootType: ContainerSizeFootTypeEnum | null, loadType: LoadTypeEnum | null, maxWeightKg: string | null, grossWeightKg: string | null, tareWeightKg: string | null, sealCode: string | null, secondarySealCode: string | null, invoiceNumber: string | null, palletQuantity: number | null, isStackable: boolean | null, cubicMeters: string | null, dispatchNumber: string | null, transportDocument: string | null, actualReturnEmptyContainerAt: string | null, estimatedReturnEmptyContainerAt: string | null, demurrageDailyRateUsd: string | null, demurrageFreeTime: number | null, demurrageFreeTimeStartAt: string | null, route: string | null, internalReferenceCode: string | null, orderNumber: string | null, ncmCodes: Array<string> | null, htTreatment: boolean | null, htTreatmentAt: string | null, separationCompletedAt: string | null, estimatedStuffingAt: string | null, loadingScheduleAt: string | null, invoiceDocumentNumber: string | null, invoiceGrossWeight: string | null, invoiceValue: string | null, preStacking: boolean | null, preStackingReason: PreStackingReasonEnum | null, scaleExitAt: string | null, stackingScheduledAt: string | null, stackingStartedAt: string | null, portScheduledAt: string | null, portDepositDeadlineAt: string | null, portDepositAt: string | null, preStackingWarehouse: PreStackingWarehouseEnum | null, preStackingDays: number | null, emptyPickupAt: string | null, emptyReceivedAtFactory: string | null, oic: string | null, quantity: string | null, releasedForTripAt: string | null, washingValue: string | null, washingChargeReceivedAt: string | null, washingDamageStatus: ContainerWashingConclusionStatusEnum | null, washingTermStatus: ContainerWashingConclusionStatusEnum | null, washingTermDescription: ContainerWashingTermDescriptionEnum | null, washingServiceType: ContainerWashingServiceTypeEnum | null, washingPaymentStatus: ContainerWashingPaymentStatusEnum | null, washingPaymentAt: string | null, washingEmptyChecklist: boolean | null, washingDamageResult: ContainerWashingDamageResultEnum | null, washingInspection: string | null };

export type InsightBasicDataFragmentFragment = { __typename?: 'Insight', id: number, explanation: string | null };

export type ProcessDataOperationFragment = { __typename?: 'Operation', id: number, title: string, subtitle: string | null, type: OperationTypeEnum, subType: OperationSubTypeEnum, isSiscomexEnabled: boolean, isCeMercanteEnabled: boolean, acceptHourInNationalRoadTransports: boolean, configProps: { __typename?: 'OperationConfigProps', isMultipleNationalRoadTransport: boolean, orderItemAdditionalFields: Array<string>, itemReference: ItemReferenceEnum }, operationAccess: { __typename?: 'OperationAccess', id: number, type: AccessEnum, canUpdateCancelledOrFinishedProcesses: boolean, canCloseOrReopenProcessesCosts: boolean, canSeeOrders: boolean }, actor: { __typename?: 'Actor', id: number, nickname: string, officialDocument: string | null, documentType: ActorDocumentTypeEnum | null }, operationHandlers: Array<{ __typename?: 'OperationHandler', id: number, owner: boolean, role: OperationHandlerEnum, isListedInDynamicList: boolean, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }> };

export type ProductsDataFragment = { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> };

export type PurchaseOrderItemAdditionalFieldsFragmentFragment = { __typename?: 'PurchaseOrderItem', id: number, measurementUnitSap: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, sapByFactor: string | null, concessionAct: string | null, importTypeSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, orderModalTypeSap: string | null, orderAdjustedModalType: string | null, orderRequestedAt: string | null, planningRequestShippingAt: string | null, planningShippingAt: string | null, supplierSentAt: string | null, supplierConfirmationAt: string | null, supplierReadyLeadTimeDays: number | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierCalculatedReadyAt: string | null, supplierReadyDeviation: number | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedBoardingAt: string | null, shipmentPlannedArrivalAt: string | null, shipmentEstimatedBoardingAt: string | null, shipmentEstimatedArrivalAt: string | null, shipmentBoardingLeadTime: number | null, shipmentTransportLeadTime: number | null, customsEstimatedRegisterAt: string | null, customsRegisterLeadTime: number | null, customsEstimatedReleaseAt: string | null, customsReleaseLeadTime: number | null, factoryEstimatedDeliveryAt: string | null, factoryPlannedDeliveryAt: string | null, factoryDeliveryAt: string | null, factoryDeliveryLeadTime: number | null, adjustedCustomsRegisterLeadTime: number | null, adjustedCustomsReleaseLeadTime: number | null, adjustedFactoryDeliveryLeadTime: number | null, adjustedShipmentBoardingLeadTime: number | null, adjustedShipmentTransportLeadTime: number | null, adjustedSupplierReadyLeadTimeDays: number | null, assessmentSotd: string | null, itemStatus: string | null, division: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, invoiceIssuedAt: string | null, invoiceNumber: string | null, invoiceValue: string | null, invoiceType: string | null, deliveryNote: string | null, deliveryNoteIssuedAt: string | null, shippingDetailsDeliveryDate: string | null, quotationOpeningDate: string | null, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'PurchaseOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null, manufacturingCountry: { __typename?: 'Country', code: string } | null, purchaseCountry: { __typename?: 'Country', code: string } | null, dispatchingCountry: { __typename?: 'Country', code: string } | null };

export type SalesOrderItemAdditionalFieldsFragmentFragment = { __typename?: 'SalesOrderItem', id: number, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, dispatchNumber: string | null, measurementUnitSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedArrivalAt: string | null, shipmentPlannedBoardingAt: string | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierReadyDeviation: number | null, factoryDeliveryAt: string | null, factoryEstimatedDeliveryAt: string | null, itemStatus: string | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, necessityType: string | null, ubc: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, stockQuantity: string | null, clientApprovedAt: string | null, reservedStockQuantity: string | null, stockReservationAt: string | null, preliminaryPickingStartedAt: string | null, internalContainerReference: string | null, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'SalesOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null };

export type GetMaritimePortQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetMaritimePortQuery = { __typename?: 'RootQueryType', maritimePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null };

export type ListActorsWithFiltersQueryVariables = Exact<{
  filters?: InputMaybe<FilterActorsParams>;
}>;


export type ListActorsWithFiltersQuery = { __typename?: 'RootQueryType', actors: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null } | null }> };

export type ListPartnershipsWithFiltersQueryVariables = Exact<{
  filters?: InputMaybe<FilterPartnershipsParams>;
}>;


export type ListPartnershipsWithFiltersQuery = { __typename?: 'RootQueryType', partnerships: Array<{ __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, nickname: string } }> };

export type ListProductsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<ProductPaginationParams>;
}>;


export type ListProductsQuery = { __typename?: 'RootQueryType', products: Array<{ __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }> };

export type CreateLocationMutationVariables = Exact<{
  params: CreateAddressParams;
}>;


export type CreateLocationMutation = { __typename?: 'RootMutationType', createAddress: { __typename?: 'Address', id: number } | null };

export type ActorQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ActorQuery = { __typename?: 'RootQueryType', actor: { __typename?: 'Actor', id: number, officialDocument: string | null, officialName: string, openingDate: string | null, cnae: string | null, nickname: string, documentType: ActorDocumentTypeEnum | null, addresses: Array<{ __typename?: 'Address', id: number, name: string | null, latitude: string, longitude: string, country: string | null, state: string | null, city: string | null, street: string | null, number: string | null, postalCode: string | null, neighborhood: string | null, complement: string | null, reference: string | null, formattedAddress: string | null, routePoints: Array<{ __typename?: 'RoutePoint', id: number }> }>, partnershipAsPartner: { __typename?: 'Partnership', id: number, internalCode: string | null, contactDetails: string | null, description: string | null, nickname: string | null, roles: Array<{ __typename?: 'Role', id: number, role: OperationHandlerEnum, accessGroup: { __typename?: 'AccessGroup', id: number, name: string, slug: string } | null }> } | null } | null };

export type GetNotificationGroupRecipientsQueryVariables = Exact<{
  filters?: InputMaybe<FilterNotificationGroupRecipientParams>;
}>;


export type GetNotificationGroupRecipientsQuery = { __typename?: 'RootQueryType', notificationGroupRecipients: Array<{ __typename?: 'NotificationGroupRecipient', id: number, emails: Array<string>, language: LanguageEnum, notificationGroupRole: { __typename?: 'NotificationGroupRole', id: number, role: OperationHandlerEnum, notificationGroup: { __typename?: 'NotificationGroup', id: number, name: string } | null } | null }> };

export type UpdatePartnershipMutationVariables = Exact<{
  partnerId: Scalars['Int']['input'];
  params: UpdatePartnershipParams;
}>;


export type UpdatePartnershipMutation = { __typename?: 'RootMutationType', updatePartnership: { __typename?: 'Partnership', id: number, partner: { __typename?: 'Actor', id: number } } | null };

export type CreatePartnershipMutationVariables = Exact<{
  params: CreatePartnershipParams;
}>;


export type CreatePartnershipMutation = { __typename?: 'RootMutationType', createPartnership: { __typename?: 'Partnership', id: number, partner: { __typename?: 'Actor', id: number } } | null };

export type ActorsCountQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type ActorsCountQuery = { __typename?: 'RootQueryType', actorsCount: number | null };

export type ActorsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<ActorPaginationParams>;
}>;


export type ActorsQuery = { __typename?: 'RootQueryType', actors: Array<{ __typename?: 'Actor', id: number, officialName: string, officialDocument: string | null, openingDate: string | null, documentType: ActorDocumentTypeEnum | null, cnae: string | null, verified: boolean, tradingName: string | null, subsidiaries: Array<{ __typename?: 'Subsidiary', id: number, name: string }>, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, description: string | null, roles: Array<{ __typename?: 'Role', id: number, role: OperationHandlerEnum, accessGroup: { __typename?: 'AccessGroup', id: number, name: string, slug: string } | null }> } | null }> };

export type DeletePartnershipMutationVariables = Exact<{
  actorId: Scalars['Int']['input'];
}>;


export type DeletePartnershipMutation = { __typename?: 'RootMutationType', deletePartnership: { __typename?: 'Partnership', id: number, partner: { __typename?: 'Actor', id: number } } | null };

export type AgentExecutionsCountQueryVariables = Exact<{
  filters?: InputMaybe<FilterAgentExecutionParams>;
}>;


export type AgentExecutionsCountQuery = { __typename?: 'RootQueryType', agentExecutionsCount: number };

export type AgentExecutionsQueryVariables = Exact<{
  filters?: InputMaybe<FilterAgentExecutionParams>;
  pagination?: InputMaybe<AgentExecutionPaginationParams>;
}>;


export type AgentExecutionsQuery = { __typename?: 'RootQueryType', agentExecutions: Array<{ __typename?: 'AgentExecution', id: string, executionEndAt: string | null, executionStartAt: string | null, insertedAt: string, status: AgentExecutionStatusEnum, lpco: { __typename?: 'Lpco', id: number, number: string } | null, order: { __typename?: 'Order', id: number, referenceCode: string } | null, process: { __typename?: 'Process', id: number, referenceCode: string } | null, agent: { __typename?: 'Agent', id: number, name: string, triggerRecurringConfig: { __typename?: 'RecurringAgentConfig', operationsInputConfig: { __typename?: 'RecurringOperationsInputConfig', entity: AgentEntityTypeEnum } | null } | null, triggerEventConfig: { __typename?: 'EventAgentConfig', entity: AgentEntityTypeEnum } | null } }> };

export type GetAgentExecutionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAgentExecutionQuery = { __typename?: 'RootQueryType', agentExecution: { __typename?: 'AgentExecutionDetail', id: string, executionEndAt: string | null, executionStartAt: string | null, insertedAt: string, status: AgentExecutionStatusEnum, actionsLog: any | null, inputLog: any | null, processorResultLog: any | null, callbackUrl: string | null, devMode: boolean, devConfig: { __typename?: 'AgentExecutionDevConfig', skipActions: boolean, runMode: AgentTestRunModeEnum, curl: string | null, callbackCurl: string | null } | null, lpco: { __typename?: 'Lpco', id: number, number: string } | null, order: { __typename?: 'Order', id: number, referenceCode: string, operation: { __typename?: 'Operation', id: number, title: string } } | null, process: { __typename?: 'Process', id: number, referenceCode: string, operation: { __typename?: 'Operation', id: number, title: string } } | null, agent: { __typename?: 'Agent', id: number, name: string, triggerType: AgentTriggerTypeEnum, actions: Array<{ __typename?: 'AgentActionConfig', type: ProcessorActionTypeEnum }>, processor: { __typename?: 'Processor', id: number, name: string | null, icon: string }, triggerRecurringConfig: { __typename?: 'RecurringAgentConfig', inputType: RecurringAgentInputTypeEnum, operationsInputConfig: { __typename?: 'RecurringOperationsInputConfig', entity: AgentEntityTypeEnum } | null } | null, triggerEventConfig: { __typename?: 'EventAgentConfig', entity: AgentEntityTypeEnum, event: AgentTriggerEventEnum } | null } } | null };

export type AgentsQueryVariables = Exact<{
  filters?: InputMaybe<FilterAgentParams>;
  pagination?: InputMaybe<AgentPaginationParams>;
}>;


export type AgentsQuery = { __typename?: 'RootQueryType', agents: Array<{ __typename?: 'Agent', id: number, name: string, triggerType: AgentTriggerTypeEnum, lastExecutionAt: string | null, actions: Array<{ __typename?: 'AgentActionConfig', type: ProcessorActionTypeEnum }>, triggerRecurringConfig: { __typename?: 'RecurringAgentConfig', inputType: RecurringAgentInputTypeEnum } | null, processor: { __typename?: 'Processor', id: number, name: string | null, icon: string } }> };

export type CreateAgentMutationVariables = Exact<{
  params: CreateAgentParams;
}>;


export type CreateAgentMutation = { __typename?: 'RootMutationType', createAgent: { __typename?: 'Agent', id: number, name: string } | null };

export type GetExternalDashboardUrlQueryVariables = Exact<{
  dashboardId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetExternalDashboardUrlQuery = { __typename?: 'RootQueryType', externalDashboardUrl: string | null };

export type DriversCountQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type DriversCountQuery = { __typename?: 'RootQueryType', driversCount: number | null };

export type CreateDriverMutationVariables = Exact<{
  params: CreateDriverParams;
}>;


export type CreateDriverMutation = { __typename?: 'RootMutationType', createDriver: { __typename?: 'Driver', id: number } | null };

export type DeleteDriverMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteDriverMutation = { __typename?: 'RootMutationType', deleteDriver: { __typename?: 'Driver', id: number } | null };

export type DriverQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DriverQuery = { __typename?: 'RootQueryType', driver: { __typename?: 'Driver', id: number, birthday: string | null, cpf: string | null, licenseCategory: string | null, licenseExpirationDate: string | null, licenseNumber: string | null, name: string, officialDocument: string | null, country: { __typename?: 'Country', code: string } } | null };

export type DriversQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<DriverPaginationParams>;
}>;


export type DriversQuery = { __typename?: 'RootQueryType', drivers: Array<{ __typename?: 'Driver', id: number, name: string, officialDocument: string | null, cpf: string | null, birthday: string | null, licenseNumber: string | null, licenseCategory: string | null, licenseExpirationDate: string | null, country: { __typename?: 'Country', code: string } }> };

export type UpdateDriverMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  params: UpdateDriverParams;
}>;


export type UpdateDriverMutation = { __typename?: 'RootMutationType', updateDriver: { __typename?: 'Driver', id: number } | null };

export type GetVesselsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FilterVesselParams>;
}>;


export type GetVesselsQuery = { __typename?: 'RootQueryType', vesselsCount: number, vessels: Array<{ __typename?: 'Vessel', id: number, imoNumber: string | null, mmsiNumber: string | null, name: string, aisClass: AisClassEnum | null, callsign: string | null, shipType: ShipTypeEnum | null, shipSubType: ShipSubTypeEnum | null, country: { __typename?: 'Country', code: string } | null, dimensions: { __typename?: 'Dimensions', a: number | null, b: number | null, c: number | null, d: number | null, length: number | null, width: number | null } | null, processes: Array<{ __typename?: 'Process', id: number, referenceCode: string, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, transportables: Array<{ __typename?: 'Transportable', id: number, type: TransportableTypeEnum, container: { __typename?: 'Container', id: number, code: string | null, hidden: boolean } | null }> } | null }>, lastPositionUpdate: { __typename?: 'VesselPositionUpdate', id: number, speed: number | null, latitude: number, longitude: number, aisUpdatedAt: string | null, voyageAtd: string | null, voyageOriginPortName: string | null, voyageOriginPortUnlocode: string | null, voyageEta: string | null, voyageDestinationPortName: string | null, voyageDestinationPortUnlocode: string | null, course: number | null, rot: number | null, heading: number } | null }> };

export type InsightsProcessFragmentFragment = { __typename?: 'Process', id: number, referenceCode: string, operation: { __typename?: 'Operation', id: number, title: string } };

export type InsightsQueryVariables = Exact<{
  filters?: InputMaybe<FilterInsightParams>;
}>;


export type InsightsQuery = { __typename?: 'RootQueryType', insights: Array<{ __typename?: 'Insight', id: number, explanation: string | null, hint: string | null, insertedAt: string | null, lastSeenAt: string | null, status: InsightStatusEnum, dismissReason: InsightDismissReasonEnum | null, feedbackAt: string | null, feedbackComment: string | null, translatedData: Array<{ __typename?: 'InsightTranslatedData', path: string, label: string, value: string | null }> | null, rule: { __typename?: 'Rule', slug: string, name: string | null, impact: RuleImpactEnum, description: string | null, analysis: { __typename?: 'Analysis', slug: string, name: string, category: AnalysesCategoryEnum, description: string | null } }, process: { __typename?: 'Process', id: number, referenceCode: string, operation: { __typename?: 'Operation', id: number, title: string } } | null, order: { __typename?: 'Order', id: number, referenceCode: string, operation: { __typename?: 'Operation', id: number, title: string } } | null, foreignTradeItemShipment: { __typename?: 'ForeignTradeItemShipment', id: number, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, process: { __typename?: 'Process', id: number, referenceCode: string, operation: { __typename?: 'Operation', id: number, title: string } } } } | null, transportable: { __typename?: 'Transportable', id: number, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, process: { __typename?: 'Process', id: number, referenceCode: string, operation: { __typename?: 'Operation', id: number, title: string } } } | null } | null, lpco: { __typename?: 'Lpco', id: number, number: string } | null }> };

export type GetApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApiKeysQuery = { __typename?: 'RootQueryType', apiKeys: Array<{ __typename?: 'ApiKey', id: number, name: string, accessGroup: { __typename?: 'AccessGroup', id: number, allowedOperations: Array<{ __typename?: 'Operation', id: number, title: string }> } }> };

export type GetOpenApiSpecQueryVariables = Exact<{
  apiKeyId: Scalars['Int']['input'];
  operationId: Scalars['Int']['input'];
}>;


export type GetOpenApiSpecQuery = { __typename?: 'RootQueryType', openApiSpec: any };

export type GetApiRequestQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetApiRequestQuery = { __typename?: 'RootQueryType', apiRequest: { __typename?: 'ApiRequest', id: number, method: HttpMethodsEnum, statusCode: number, endpoint: string, referenceCodes: Array<string | null> | null, request: any | null, response: any | null, insertedAt: string, itemId: number | null, itemType: ApiRequestItemTypeEnum, apiKey: { __typename?: 'ApiKey', id: number, name: string } } | null };

export type GetApiRequestsErrorsAndSuccessesCountQueryVariables = Exact<{
  operationIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  countLimit?: InputMaybe<Scalars['Int']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetApiRequestsErrorsAndSuccessesCountQuery = { __typename?: 'RootQueryType', apiRequestsSuccess: number, apiRequestsError: number };

export type GetApiRequestsQueryVariables = Exact<{
  filters?: InputMaybe<FilterApiRequestParams>;
  pagination?: InputMaybe<PaginationApiRequestParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetApiRequestsQuery = { __typename?: 'RootQueryType', apiRequests: Array<{ __typename?: 'ApiRequest', id: number, method: HttpMethodsEnum, statusCode: number, endpoint: string, referenceCodes: Array<string | null> | null, itemId: number | null, itemType: ApiRequestItemTypeEnum, insertedAt: string, apiKey: { __typename?: 'ApiKey', id: number, name: string } }> };

export type GetOperationsLogQueryVariables = Exact<{
  filtersApiRequests?: InputMaybe<FilterApiRequestParams>;
  countLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOperationsLogQuery = { __typename?: 'RootQueryType', operations: Array<{ __typename?: 'Operation', id: number, title: string, subtitle: string | null, apiRequestsToday: number }> };

export type LpcoAvailableQuickFiltersQueryVariables = Exact<{
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type LpcoAvailableQuickFiltersQuery = { __typename?: 'RootQueryType', lpcoAvailableQuickFilters: Array<{ __typename?: 'QuickFilter', path: string, label: string | null, position: number, values: Array<{ __typename?: 'QuickFilterValue', value: any, label: string }> }> };

export type LpcoTotalsQueryVariables = Exact<{ [key: string]: never; }>;


export type LpcoTotalsQuery = { __typename?: 'RootQueryType', lpcoTotals: { __typename?: 'LpcoTotals', registersCount: number, modelsCount: number, importersCount: number, exportersCount: number } };

export type LpcosQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<LpcoPaginationParams>;
}>;


export type LpcosQuery = { __typename?: 'RootQueryType', lpcos: Array<{ __typename?: 'Lpco', id: number, agency: string | null, modelCode: string | null, name: string | null, number: string, operationType: LpcoOperationTypeEnum | null, registeredAt: string | null, status: LpcoSituationEnum | null, statusUpdatedAt: string | null, validityEnd: string | null, validityStart: string | null, linkedDeclarations: Array<{ __typename?: 'LpcoLinkedDeclaration', documentNumber: string | null }>, insights: Array<{ __typename?: 'Insight', id: number, explanation: string | null }> }> };

export type GetMercanteSchedulesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationPortScheduleParams>;
  filters: FilterPortScheduleParams;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMercanteSchedulesQuery = { __typename?: 'RootQueryType', portSchedulesCount: number, portSchedules: Array<{ __typename?: 'PortSchedule', id: number, etb: string | null, etu: string | null, atb: string | null, atu: string | null, carrierCode: string | null, carrierName: string | null, carrierVoyage: string | null, scheduleNumber: string, vesselResponsible: string | null, shippingAgencyCnpj: string | null, shippingAgencyName: string | null, lastPorts: Array<{ __typename?: 'PortScheduleLeg', portUnlocode: string, atu: string | null }>, nextPorts: Array<{ __typename?: 'PortScheduleLeg', portUnlocode: string, etb: string | null }>, carrierCountry: { __typename?: 'Country', code: string } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } }> };

export type ListMaritimePortsQueryVariables = Exact<{
  filters?: InputMaybe<FilterMaritimePortParams>;
}>;


export type ListMaritimePortsQuery = { __typename?: 'RootQueryType', maritimePorts: Array<{ __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null }> };

export type AggregatedCostModelExpenseFieldsFragment = { __typename?: 'CostModelExpense', id: number, calculatedCost: { __typename?: 'CalculatedAggregatedCosts', realized: string | null, realizedAverage: string | null, planned: string | null, plannedAverage: string | null, deviation: string | null } | null, costExpense: { __typename?: 'CostExpense', id: number, name: string, slug: string } };

export type AggregatedCostChildrenModelExpensesFragment = { __typename?: 'CostModelExpense', id: number, childrenModelExpenses: Array<{ __typename?: 'CostModelExpense', id: number, childrenModelExpenses: Array<{ __typename?: 'CostModelExpense', id: number, calculatedCost: { __typename?: 'CalculatedAggregatedCosts', realized: string | null, realizedAverage: string | null, planned: string | null, plannedAverage: string | null, deviation: string | null } | null, costExpense: { __typename?: 'CostExpense', id: number, name: string, slug: string } }>, calculatedCost: { __typename?: 'CalculatedAggregatedCosts', realized: string | null, realizedAverage: string | null, planned: string | null, plannedAverage: string | null, deviation: string | null } | null, costExpense: { __typename?: 'CostExpense', id: number, name: string, slug: string } }>, calculatedCost: { __typename?: 'CalculatedAggregatedCosts', realized: string | null, realizedAverage: string | null, planned: string | null, plannedAverage: string | null, deviation: string | null } | null, costExpense: { __typename?: 'CostExpense', id: number, name: string, slug: string } };

export type GetAggregatedProcessCostsQueryVariables = Exact<{
  costModelId: Scalars['Int']['input'];
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetAggregatedProcessCostsQuery = { __typename?: 'RootQueryType', aggregatedCosts: { __typename?: 'AggregatedCosts', processesCount: number, costModel: { __typename?: 'CostModel', id: number, name: string, hasPlannedCosts: boolean, currency: { __typename?: 'Currency', code: string, name: string } | null }, rootModelExpenses: Array<{ __typename?: 'CostModelExpense', id: number, childrenModelExpenses: Array<{ __typename?: 'CostModelExpense', id: number, childrenModelExpenses: Array<{ __typename?: 'CostModelExpense', id: number, calculatedCost: { __typename?: 'CalculatedAggregatedCosts', realized: string | null, realizedAverage: string | null, planned: string | null, plannedAverage: string | null, deviation: string | null } | null, costExpense: { __typename?: 'CostExpense', id: number, name: string, slug: string } }>, calculatedCost: { __typename?: 'CalculatedAggregatedCosts', realized: string | null, realizedAverage: string | null, planned: string | null, plannedAverage: string | null, deviation: string | null } | null, costExpense: { __typename?: 'CostExpense', id: number, name: string, slug: string } }>, calculatedCost: { __typename?: 'CalculatedAggregatedCosts', realized: string | null, realizedAverage: string | null, planned: string | null, plannedAverage: string | null, deviation: string | null } | null, costExpense: { __typename?: 'CostExpense', id: number, name: string, slug: string } }>, calculatedTotals: { __typename?: 'CostModelAggregatedTotals', totalCosts: string | null, plannedCosts: string | null, deviation: string | null } } | null };

export type GetCostModelsQueryVariables = Exact<{
  filters?: InputMaybe<FilterCostModelParams>;
}>;


export type GetCostModelsQuery = { __typename?: 'RootQueryType', costModels: Array<{ __typename?: 'CostModel', id: number, name: string, hasPlannedCosts: boolean, operations: Array<{ __typename?: 'Operation', id: number }>, versions: Array<{ __typename?: 'CostModelVersion', id: number, version: number }> }> };

export type CreateLeadTimeModelMutationVariables = Exact<{
  params: CreateLeadTimeModelParams;
}>;


export type CreateLeadTimeModelMutation = { __typename?: 'RootMutationType', createLeadTimeModel: { __typename?: 'LeadTimeModel', id: number, name: string } | null };

export type CreatePlannedLeadTimeMutationVariables = Exact<{
  params: CreatePlannedLeadTimeParams;
}>;


export type CreatePlannedLeadTimeMutation = { __typename?: 'RootMutationType', createPlannedLeadTime: { __typename?: 'PlannedLeadTime', id: number, name: string, stages: Array<{ __typename?: 'PlannedLeadTimeStage', id: number, quantityHours: number }> } | null };

export type DeleteLeadTimeModelMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteLeadTimeModelMutation = { __typename?: 'RootMutationType', deleteLeadTimeModel: { __typename?: 'LeadTimeModel', id: number } | null };

export type DeletePlannedLeadTimeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeletePlannedLeadTimeMutation = { __typename?: 'RootMutationType', deletePlannedLeadTime: { __typename?: 'PlannedLeadTime', id: number } | null };

export type GetLeadTimeModelQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetLeadTimeModelQuery = { __typename?: 'RootQueryType', leadTimeModel: { __typename?: 'LeadTimeModel', id: number, name: string, ignoreTime: boolean, markerPaths: Array<string>, markerPathsLabels: Array<string>, referenceEvent: string, referenceEventLabel: string, stages: Array<{ __typename?: 'LeadTimeStageModel', id: number, name: string, color: string, startEvent: string, startEventLabel: string, endEvent: string, endEventLabel: string }>, operations: Array<{ __typename?: 'Operation', id: number, title: string }>, plannedLeadTimes: Array<{ __typename?: 'PlannedLeadTime', id: number, name: string, stages: Array<{ __typename?: 'PlannedLeadTimeStage', id: number, days: number, hours: number, quantityHours: number, leadTimeStageModel: { __typename?: 'LeadTimeStageModel', id: number, name: string, color: string } }> }> } | null };

export type GetLeadTimeModelsQueryVariables = Exact<{
  pagination?: InputMaybe<LeadTimeModelPaginationParams>;
}>;


export type GetLeadTimeModelsQuery = { __typename?: 'RootQueryType', leadTimeModels: Array<{ __typename?: 'LeadTimeModel', id: number, name: string, ignoreTime: boolean, markerPaths: Array<string> }> };

export type GetLeadTimeModelsOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeadTimeModelsOptionsQuery = { __typename?: 'RootQueryType', leadTimeModels: Array<{ __typename?: 'LeadTimeModel', id: number, name: string, ignoreTime: boolean, operations: Array<{ __typename?: 'Operation', id: number }> }> };

export type UpdateLeadTimeModelMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  params: UpdateLeadTimeModelParams;
}>;


export type UpdateLeadTimeModelMutation = { __typename?: 'RootMutationType', updateLeadTimeModel: { __typename?: 'LeadTimeModel', id: number } | null };

export type UpdatePlannedLeadTimeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  params: UpdatePlannedLeadTimeParams;
}>;


export type UpdatePlannedLeadTimeMutation = { __typename?: 'RootMutationType', updatePlannedLeadTime: { __typename?: 'PlannedLeadTime', id: number } | null };

export type GetLeadTimeAggregatedAvailableQuickFiltersQueryVariables = Exact<{
  leadTimeModelId: Scalars['Int']['input'];
  currentFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLeadTimeAggregatedAvailableQuickFiltersQuery = { __typename?: 'RootQueryType', leadTimeAggregatedAvailableQuickFilters: Array<{ __typename?: 'QuickFilter', label: string | null, path: string, values: Array<{ __typename?: 'QuickFilterValue', label: string, value: any }> }> };

export type GetLeadTimesAggregatedByPlannedQueryVariables = Exact<{
  leadTimeModelId: Scalars['Int']['input'];
  filters?: InputMaybe<FilterAggregatedLeadTimeParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetLeadTimesAggregatedByPlannedQuery = { __typename?: 'RootQueryType', leadTimesAggregatedByPlanned: Array<{ __typename?: 'LeadTimeAggregatedByPlanned', countShipments: number, plannedLeadTime: { __typename?: 'PlannedLeadTime', id: number, name: string, leadTimeModel: { __typename?: 'LeadTimeModel', id: number, ignoreTime: boolean } }, leadTime: { __typename?: 'LeadTime', deviationPercentage: string | null, differenceHours: number | null, plannedDurationHours: number | null, realizedOrEstimatedDurationHours: number | null, stages: Array<{ __typename?: 'LeadTimeStage', deviationPercentage: string | null, model: { __typename?: 'LeadTimeStageModel', id: number, name: string, color: string }, realizedOrEstimated: { __typename?: 'CalculatedStage', durationHours: number | null } | null, planned: { __typename?: 'CalculatedStage', durationHours: number | null } }> } }> };

export type GetLeadTimesAggregatedByProductQueryVariables = Exact<{
  leadTimeModelId: Scalars['Int']['input'];
  filters?: InputMaybe<FilterAggregatedLeadTimeParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetLeadTimesAggregatedByProductQuery = { __typename?: 'RootQueryType', leadTimesAggregatedByProduct: Array<{ __typename?: 'LeadTimeAggregatedByProduct', countShipments: number, product: { __typename?: 'Product', id: number, translatedDescription: string | null, code: string, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }> }, leadTime: { __typename?: 'LeadTime', deviationPercentage: string | null, differenceHours: number | null, plannedDurationHours: number | null, realizedOrEstimatedDurationHours: number | null, stages: Array<{ __typename?: 'LeadTimeStage', deviationPercentage: string | null, model: { __typename?: 'LeadTimeStageModel', id: number, name: string, color: string }, realizedOrEstimated: { __typename?: 'CalculatedStage', durationHours: number | null } | null, planned: { __typename?: 'CalculatedStage', durationHours: number | null } }> } }> };

export type LeadTimesAggregatedDataFragment = { __typename?: 'LeadTime', deviationPercentage: string | null, differenceHours: number | null, plannedDurationHours: number | null, realizedOrEstimatedDurationHours: number | null, stages: Array<{ __typename?: 'LeadTimeStage', deviationPercentage: string | null, model: { __typename?: 'LeadTimeStageModel', id: number, name: string, color: string }, realizedOrEstimated: { __typename?: 'CalculatedStage', durationHours: number | null } | null, planned: { __typename?: 'CalculatedStage', durationHours: number | null } }> };

export type GetOperationTrashItemsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOperationTrashItemsQuery = { __typename?: 'RootQueryType', operation: { __typename?: 'Operation', id: number, title: string, subtitle: string | null, processes: Array<{ __typename?: 'Process', id: number, referenceCode: string, insertedAt: string, canceledAt: string | null, deletedAt: string | null }>, orders: Array<{ __typename?: 'Order', id: number, referenceCode: string, insertedAt: string, canceledAt: string | null, deletedAt: string | null }> } | null };

export type RestoreOrderMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RestoreOrderMutation = { __typename?: 'RootMutationType', restoreOrder: { __typename?: 'Order', id: number } | null };

export type RestoreProcessMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RestoreProcessMutation = { __typename?: 'RootMutationType', restoreProcess: { __typename?: 'Process', id: number } | null };

export type AlertLevelCountFragmentFragment = { __typename?: 'AlertLevelOverview', totalCount: number, dangerCount: number, warningCount: number };

export type GetOperationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOperationsQuery = { __typename?: 'RootQueryType', operations: Array<{ __typename?: 'Operation', id: number, type: OperationTypeEnum, subType: OperationSubTypeEnum, title: string, subtitle: string | null, ordersCountOverview: { __typename?: 'AlertLevelOverview', totalCount: number, dangerCount: number, warningCount: number }, processesCountOverview: { __typename?: 'AlertLevelOverview', totalCount: number, dangerCount: number, warningCount: number }, operationPhases: Array<{ __typename?: 'OperationPhase', id: number, position: number, phase: { __typename?: 'Phase', id: number, phase: PhaseEnum }, processesCountOverview: { __typename?: 'AlertLevelOverview', totalCount: number, dangerCount: number, warningCount: number } }>, operationAccess: { __typename?: 'OperationAccess', id: number, canSeeOrders: boolean } }> };

export type CreateReportMutationVariables = Exact<{
  params: CreateReportParams;
}>;


export type CreateReportMutation = { __typename?: 'RootMutationType', createReport: { __typename?: 'Report', id: number } | null };

export type CreateReportRequestMutationVariables = Exact<{
  params: CreateReportRequestParams;
}>;


export type CreateReportRequestMutation = { __typename?: 'RootMutationType', createReportRequest: { __typename?: 'ReportRequest', id: number } | null };

export type DeleteReportMutationVariables = Exact<{
  reportId: Scalars['Int']['input'];
}>;


export type DeleteReportMutation = { __typename?: 'RootMutationType', deleteReport: { __typename?: 'Report', id: number } | null };

export type GetContainersTableRowsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FilterContainerParams>;
  pagination?: InputMaybe<ContainerPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  includeDocuments: Scalars['Boolean']['input'];
  includeProcessLeadTime: Scalars['Boolean']['input'];
  includeProcessBrazilianInvoiceInfo: Scalars['Boolean']['input'];
  includeVesselScheduleCalculatedDates: Scalars['Boolean']['input'];
  includeShipmentDuimps: Scalars['Boolean']['input'];
  includeShipmentExportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportLicenses: Scalars['Boolean']['input'];
  includeDemurrageAny: Scalars['Boolean']['input'];
  includeDemurrage: Scalars['Boolean']['input'];
  includeDemurrageCalculations: Scalars['Boolean']['input'];
}>;


export type GetContainersTableRowsQuery = { __typename?: 'RootQueryType', containersPerProcessesCount: number, containersPerProcesses: Array<{ __typename?: 'ContainerPerProcess', container: { __typename?: 'Container', trackingApi: boolean, trackingManual: boolean, id: number, code: string | null, type: ContainerTypeEnum | null, sizeFootType: ContainerSizeFootTypeEnum | null, loadType: LoadTypeEnum | null, maxWeightKg: string | null, grossWeightKg: string | null, tareWeightKg: string | null, sealCode: string | null, secondarySealCode: string | null, invoiceNumber: string | null, palletQuantity: number | null, isStackable: boolean | null, cubicMeters: string | null, dispatchNumber: string | null, transportDocument: string | null, actualReturnEmptyContainerAt: string | null, estimatedReturnEmptyContainerAt: string | null, demurrageDailyRateUsd: string | null, demurrageFreeTime: number | null, demurrageFreeTimeStartAt: string | null, route: string | null, internalReferenceCode: string | null, orderNumber: string | null, ncmCodes: Array<string> | null, htTreatment: boolean | null, htTreatmentAt: string | null, separationCompletedAt: string | null, estimatedStuffingAt: string | null, loadingScheduleAt: string | null, invoiceDocumentNumber: string | null, invoiceGrossWeight: string | null, invoiceValue: string | null, preStacking: boolean | null, preStackingReason: PreStackingReasonEnum | null, scaleExitAt: string | null, stackingScheduledAt: string | null, stackingStartedAt: string | null, portScheduledAt: string | null, portDepositDeadlineAt: string | null, portDepositAt: string | null, preStackingWarehouse: PreStackingWarehouseEnum | null, preStackingDays: number | null, emptyPickupAt: string | null, emptyReceivedAtFactory: string | null, oic: string | null, quantity: string | null, releasedForTripAt: string | null, washingValue: string | null, washingChargeReceivedAt: string | null, washingDamageStatus: ContainerWashingConclusionStatusEnum | null, washingTermStatus: ContainerWashingConclusionStatusEnum | null, washingTermDescription: ContainerWashingTermDescriptionEnum | null, washingServiceType: ContainerWashingServiceTypeEnum | null, washingPaymentStatus: ContainerWashingPaymentStatusEnum | null, washingPaymentAt: string | null, washingEmptyChecklist: boolean | null, washingDamageResult: ContainerWashingDamageResultEnum | null, washingInspection: string | null, demurrageCalculations: { __typename?: 'ContainerDemurrageCalculations', costPerDayBrl: string, costPerDayUsd: string, daysPaid: number, daysToPay: number, emptyReturnDeadline: string | null, estimatedCosts: string, exceedingDays: number, totalOwedBrl: string, totalOwedUsd: string, totalPaidBrl: string, totalPaidUsd: string, totalToPayBrl: string, totalToPayUsd: string } | null, transportable: { __typename?: 'Transportable', id: number, itemShipments: Array<{ __typename?: 'ForeignTradeItemShipment', id: number, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string } } | null, salesOrderItem: { __typename?: 'SalesOrderItem', id: number, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string } } | null }>, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, phases: Array<{ __typename?: 'RoadTransportTripPhase', id: number, realizedAt: string | null, estimatedRealizedAt: string | null, routePoint: { __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum } }> }> } | null }, process: { __typename?: 'Process', id: number, leadTimeDatetimeReference: string | null, referenceCode: string, alertLevel: AlertLevelEnum, extraFields: any | null, canceledAt: string | null, finishedAt: string | null, insertedAt: string, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, type: ShipmentTypeEnum | null, ata: string | null, atd: string | null, eta: string | null, etd: string | null, deliveredAt: string | null, receivedInWarehouseAt: string | null, departedFromWarehouseAt: string | null, totalNetWeight: string | null, totalGrossWeight: string | null, cubageCubicMeters: string | null, automaticTrackingEnabled: boolean, statusResponse: StatusResponseTypeEnum, ceMercanteData: { __typename?: 'CeMercanteData', id: number, number: string, issuedAt: string | null, cargoStatus: string | null, hasDta: boolean | null, manifestArrivalAt: string | null, cargoPresenceInPrimaryZoneAt: string | null, cargoPresenceInSecondaryZoneAt: string | null, customsPlace: string | null, bl: string | null, cargoPresenceHistory: Array<{ __typename?: 'CeMercanteDataCargoPresenceHistory', ra: string | null, status: string | null, date: string | null, dtaNumber: string | null, syncedAt: string | null }>, containerSeals: Array<{ __typename?: 'CeMercanteDataContainerSeal', containerCode: string | null, sealCode: string | null, secondarySealCode: string | null }>, originPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, destinationPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null } | null, parcelShipments: Array<{ __typename?: 'ParcelShipment', id: number, trackingNumber: string, slug: string }>, internationalFreight: { __typename?: 'InternationalFreight', id: number, cargoAttributes: Array<CargoAttributeEnum>, expectedSeparationAt: string | null, pickupLocation: string | null, freightForwarder: string | null, quotationNumber: string | null, plannedBoardingDate: string | null, freightCostPrepaid: string | null, freightCostCollect: string | null, freightCostRoad: string | null, freightCostTotal: string | null, type: InternationalFreightTypeEnum | null, bookingEta: string | null, bookingEtd: string | null, voyageNumber: string | null, currency: { __typename?: 'Currency', name: string, code: string } | null, sealine: { __typename?: 'Sealine', id: number, name: string, logoUrl: string | null } | null, bookingLoadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingDischargeAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingLoadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } | null, portTerminal: { __typename?: 'PortTerminal', id: number, name: string } | null } | null, airTransportShipment: { __typename?: 'AirTransportShipment', awb: string | null, hawb: string | null, id: number, type: AirTransportTypeEnum | null, destinationAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, originAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, airline: { __typename?: 'Airline', id: number, name: string } | null } | null, demurrage?: { __typename?: 'Demurrage', id: number, dailyRateUsd?: string | null, freeTime?: number | null, calculations?: { __typename?: 'DemurrageCalculations', totalExceedingDays: number, totalEstimatedCosts: string, totalDaysPaid: number, totalDaysToPay: number, averageCostPerDayUsd: string, totalOwedUsd: string, totalPaidUsd: string, totalToPayUsd: string } } | null, maritimeTransportShipment: { __typename?: 'MaritimeTransportShipment', id: number, type: MaritimeTransportTypeEnum | null, bl: string | null, booking: string | null, hbl: string | null, trackingNumber: string | null, trackingLoadingPort: string | null, trackingDischargePort: string | null, voyageNumber: string | null, trackingKey: TrackingKeyEnum | null, sealine: { __typename?: 'Sealine', id: number, logoUrl: string | null, name: string } | null, vessel: { __typename?: 'Vessel', id: number, name: string } | null, loadingPort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null, dischargePort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null } | null, roadTransportShipment: { __typename?: 'ForeignTradeRoadTransportShipment', id: number, type: ForeignTradeRoadTransportTypeEnum | null, crt: string | null, origin: string | null, destination: string | null } | null, route: { __typename?: 'Route', id: number, name: string } | null, shipmentDuimps?: Array<{ __typename?: 'ShipmentDuimp', id: number, duimp: { __typename?: 'Duimp', id: number, number: string, registeredAt: string | null, deliveredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: DuimpStatusEnum | null } }>, shipmentExportDeclarations?: Array<{ __typename?: 'ShipmentExportDeclaration', id: number, exportDeclaration: { __typename?: 'ExportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, endorsedAt: string | null, channel: ChannelExportDeclarationTypeEnum | null, status: ExportDeclarationStatusEnum | null } }>, shipmentImportDeclarations?: Array<{ __typename?: 'ShipmentImportDeclaration', id: number, importDeclaration: { __typename?: 'ImportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: ImportDeclarationStatusEnum | null } }>, shipmentImportLicenses?: Array<{ __typename?: 'ShipmentImportLicense', id: number, importLicense: { __typename?: 'ImportLicense', id: number, number: string, registeredAt: string | null, approvedAt: string | null, status: ImportLicenseStatusEnum | null } }>, invoices: Array<{ __typename?: 'Invoice', id: number, number: string, emittedAt: string, incoterm: IncotermTypeEnum, totalAmount: string, discount: string | null, finalValue: string, totalGrossWeightKg: string, currency: { __typename?: 'Currency', code: string } | null }>, vesselScheduleDeadlineReferences: { __typename?: 'VesselScheduleDeadlineReferences', draftDeadlineReference: DeadlineDateReferenceEnum | null, vgmDeadlineReference: VgmDeadlineDateReferenceEnum | null, cargoDeadlineReference: DeadlineDateReferenceEnum | null, gateOpeningDeadlineReference: GateOpeningDeadlineDateReferenceEnum | null } | null, vesselSchedule: { __typename?: 'VesselSchedule', id: number, sealineStatusResponse: VesselScheduleStatusResponseEnum, portTerminalStatusResponse: VesselScheduleStatusResponseEnum, deadlineDates?: { __typename?: 'VesselScheduleDeadlineDates', draftDeadline: string | null, cargoDeadline: string | null, vgmDeadline: string | null, gateOpeningDeadline: string | null } | null } | null, nationalRoadTransports: Array<{ __typename?: 'NationalRoadTransport', id: number, collectionScheduledAt: string | null, deliveryPlannedAt: string | null, loadType: LoadTypeEnum | null, roadTransportType: RoadTransportTypeEnum | null, transportFeatures: Array<TransportFeatureEnum>, releasedForTransportAt: string | null, transportCompletedAt: string | null, legSlug: string, route: { __typename?: 'Route', id: number, name: string } | null, nationalRoadCarrier: { __typename?: 'Handler', id: number, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null } } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, driverName: string | null, vehiclePlate: string | null, trailerPlate: string | null, driver: { __typename?: 'Driver', id: number, name: string } | null, vehicle: { __typename?: 'Vehicle', id: number, plate: string } | null, trailer: { __typename?: 'Trailer', id: number, plate: string } | null, transportables: Array<{ __typename?: 'Transportable', id: number, container: { __typename?: 'Container', id: number, code: string | null } | null }> }> }> } | null, leadTime?: { __typename?: 'LeadTime', conclusionDate: string | null, startDate: string | null, plannedConclusionDate: string, deviationPercentage: string | null, differenceHours: number | null, isRealized: boolean, status: LeadTimeStatusEnum | null } | null, plannedLeadTime: { __typename?: 'PlannedLeadTime', id: number, name: string, leadTimeModel: { __typename?: 'LeadTimeModel', id: number, ignoreTime: boolean } } | null, automationProcesses: Array<{ __typename?: 'AutomationProcess', id: number, automation: { __typename?: 'Automation', id: number, name: string } }>, operation: { __typename?: 'Operation', id: number, title: string, subType: OperationSubTypeEnum }, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, documents?: Array<{ __typename?: 'Document', id: number, type: DocumentTypeEnum, brazilianInvoiceInfo?: { __typename?: 'BrazilianInvoice', emittedAt: string, number: string, accessKey: string, tax: { __typename?: 'BrazilianInvoiceTax', totalAmount: string }, transport: { __typename?: 'BrazilianInvoiceTransport', grossWeight: string | null } } | null }>, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }>, ownerHandler: { __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } } | null, orders: Array<{ __typename?: 'Order', id: number, referenceCode: string, externalReferenceCode: string | null, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }> }> } }> };

export type GetInvoiceItemsTableRowsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filters: FilterInvoiceItemParams;
  pagination?: InputMaybe<InvoiceItemPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  includeDocuments: Scalars['Boolean']['input'];
  includeProcessLeadTime: Scalars['Boolean']['input'];
  includeProcessBrazilianInvoiceInfo: Scalars['Boolean']['input'];
  includeVesselScheduleCalculatedDates: Scalars['Boolean']['input'];
  includeShipmentDuimps: Scalars['Boolean']['input'];
  includeShipmentExportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportLicenses: Scalars['Boolean']['input'];
  includeContainers: Scalars['Boolean']['input'];
  includeDemurrageAny: Scalars['Boolean']['input'];
  includeDemurrage: Scalars['Boolean']['input'];
  includeDemurrageCalculations: Scalars['Boolean']['input'];
}>;


export type GetInvoiceItemsTableRowsQuery = { __typename?: 'RootQueryType', invoiceItemsPerProcessesCount: number, invoiceItemsPerProcesses: Array<{ __typename?: 'InvoiceItemPerProcess', invoiceItem: { __typename?: 'InvoiceItem', id: number, quantity: string, productSku: string, productDescription: string | null, batchNumber: string | null, unitaryAmount: string | null, batchValidityDate: string | null, productionDate: string | null, totalAmount: string | null, totalGrossWeightKg: string | null, orderReferenceCode: string | null, orderItemLineReference: string | null, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> } | null, invoice: { __typename?: 'Invoice', id: number, number: string, emittedAt: string, incoterm: IncotermTypeEnum, discount: string | null, totalAmount: string, finalValue: string, totalGrossWeightKg: string, currency: { __typename?: 'Currency', code: string, name: string } | null } | null, transportables: Array<{ __typename?: 'Transportable', id: number, container: { __typename?: 'Container', id: number, code: string | null, actualReturnEmptyContainerAt: string | null, estimatedReturnEmptyContainerAt: string | null, invoiceNumber: string | null, sealCode: string | null, secondarySealCode: string | null, grossWeightKg: string | null, maxWeightKg: string | null, tareWeightKg: string | null, loadType: LoadTypeEnum | null, sizeFootType: ContainerSizeFootTypeEnum | null, type: ContainerTypeEnum | null, palletQuantity: number | null, demurrageDailyRateUsd: string | null, demurrageFreeTime: number | null, demurrageFreeTimeStartAt: string | null, isStackable: boolean | null, cubicMeters: string | null, dispatchNumber: string | null, transportDocument: string | null, demurrageCalculations: { __typename?: 'ContainerDemurrageCalculations', emptyReturnDeadline: string | null, estimatedCosts: string, exceedingDays: number } | null } | null }> }, process: { __typename?: 'Process', id: number, leadTimeDatetimeReference: string | null, referenceCode: string, alertLevel: AlertLevelEnum, extraFields: any | null, canceledAt: string | null, finishedAt: string | null, insertedAt: string, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, type: ShipmentTypeEnum | null, ata: string | null, atd: string | null, eta: string | null, etd: string | null, deliveredAt: string | null, receivedInWarehouseAt: string | null, departedFromWarehouseAt: string | null, totalNetWeight: string | null, totalGrossWeight: string | null, cubageCubicMeters: string | null, automaticTrackingEnabled: boolean, statusResponse: StatusResponseTypeEnum, ceMercanteData: { __typename?: 'CeMercanteData', id: number, number: string, issuedAt: string | null, cargoStatus: string | null, hasDta: boolean | null, manifestArrivalAt: string | null, cargoPresenceInPrimaryZoneAt: string | null, cargoPresenceInSecondaryZoneAt: string | null, customsPlace: string | null, bl: string | null, cargoPresenceHistory: Array<{ __typename?: 'CeMercanteDataCargoPresenceHistory', ra: string | null, status: string | null, date: string | null, dtaNumber: string | null, syncedAt: string | null }>, containerSeals: Array<{ __typename?: 'CeMercanteDataContainerSeal', containerCode: string | null, sealCode: string | null, secondarySealCode: string | null }>, originPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, destinationPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null } | null, parcelShipments: Array<{ __typename?: 'ParcelShipment', id: number, trackingNumber: string, slug: string }>, internationalFreight: { __typename?: 'InternationalFreight', id: number, cargoAttributes: Array<CargoAttributeEnum>, expectedSeparationAt: string | null, pickupLocation: string | null, freightForwarder: string | null, quotationNumber: string | null, plannedBoardingDate: string | null, freightCostPrepaid: string | null, freightCostCollect: string | null, freightCostRoad: string | null, freightCostTotal: string | null, type: InternationalFreightTypeEnum | null, bookingEta: string | null, bookingEtd: string | null, voyageNumber: string | null, currency: { __typename?: 'Currency', name: string, code: string } | null, sealine: { __typename?: 'Sealine', id: number, name: string, logoUrl: string | null } | null, bookingLoadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingDischargeAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingLoadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } | null, portTerminal: { __typename?: 'PortTerminal', id: number, name: string } | null } | null, airTransportShipment: { __typename?: 'AirTransportShipment', awb: string | null, hawb: string | null, id: number, type: AirTransportTypeEnum | null, destinationAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, originAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, airline: { __typename?: 'Airline', id: number, name: string } | null } | null, demurrage?: { __typename?: 'Demurrage', id: number, dailyRateUsd?: string | null, freeTime?: number | null, calculations?: { __typename?: 'DemurrageCalculations', totalExceedingDays: number, totalEstimatedCosts: string, totalDaysPaid: number, totalDaysToPay: number, averageCostPerDayUsd: string, totalOwedUsd: string, totalPaidUsd: string, totalToPayUsd: string } } | null, maritimeTransportShipment: { __typename?: 'MaritimeTransportShipment', id: number, type: MaritimeTransportTypeEnum | null, bl: string | null, booking: string | null, hbl: string | null, trackingNumber: string | null, trackingLoadingPort: string | null, trackingDischargePort: string | null, voyageNumber: string | null, trackingKey: TrackingKeyEnum | null, sealine: { __typename?: 'Sealine', id: number, logoUrl: string | null, name: string } | null, vessel: { __typename?: 'Vessel', id: number, name: string } | null, loadingPort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null, dischargePort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null } | null, roadTransportShipment: { __typename?: 'ForeignTradeRoadTransportShipment', id: number, type: ForeignTradeRoadTransportTypeEnum | null, crt: string | null, origin: string | null, destination: string | null } | null, route: { __typename?: 'Route', id: number, name: string } | null, shipmentDuimps?: Array<{ __typename?: 'ShipmentDuimp', id: number, duimp: { __typename?: 'Duimp', id: number, number: string, registeredAt: string | null, deliveredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: DuimpStatusEnum | null } }>, shipmentExportDeclarations?: Array<{ __typename?: 'ShipmentExportDeclaration', id: number, exportDeclaration: { __typename?: 'ExportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, endorsedAt: string | null, channel: ChannelExportDeclarationTypeEnum | null, status: ExportDeclarationStatusEnum | null } }>, shipmentImportDeclarations?: Array<{ __typename?: 'ShipmentImportDeclaration', id: number, importDeclaration: { __typename?: 'ImportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: ImportDeclarationStatusEnum | null } }>, shipmentImportLicenses?: Array<{ __typename?: 'ShipmentImportLicense', id: number, importLicense: { __typename?: 'ImportLicense', id: number, number: string, registeredAt: string | null, approvedAt: string | null, status: ImportLicenseStatusEnum | null } }>, invoices: Array<{ __typename?: 'Invoice', id: number, number: string, emittedAt: string, incoterm: IncotermTypeEnum, totalAmount: string, discount: string | null, finalValue: string, totalGrossWeightKg: string, currency: { __typename?: 'Currency', code: string } | null }>, vesselScheduleDeadlineReferences: { __typename?: 'VesselScheduleDeadlineReferences', draftDeadlineReference: DeadlineDateReferenceEnum | null, vgmDeadlineReference: VgmDeadlineDateReferenceEnum | null, cargoDeadlineReference: DeadlineDateReferenceEnum | null, gateOpeningDeadlineReference: GateOpeningDeadlineDateReferenceEnum | null } | null, vesselSchedule: { __typename?: 'VesselSchedule', id: number, sealineStatusResponse: VesselScheduleStatusResponseEnum, portTerminalStatusResponse: VesselScheduleStatusResponseEnum, deadlineDates?: { __typename?: 'VesselScheduleDeadlineDates', draftDeadline: string | null, cargoDeadline: string | null, vgmDeadline: string | null, gateOpeningDeadline: string | null } | null } | null, nationalRoadTransports: Array<{ __typename?: 'NationalRoadTransport', id: number, collectionScheduledAt: string | null, deliveryPlannedAt: string | null, loadType: LoadTypeEnum | null, roadTransportType: RoadTransportTypeEnum | null, transportFeatures: Array<TransportFeatureEnum>, releasedForTransportAt: string | null, transportCompletedAt: string | null, legSlug: string, route: { __typename?: 'Route', id: number, name: string } | null, nationalRoadCarrier: { __typename?: 'Handler', id: number, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null } } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, driverName: string | null, vehiclePlate: string | null, trailerPlate: string | null, driver: { __typename?: 'Driver', id: number, name: string } | null, vehicle: { __typename?: 'Vehicle', id: number, plate: string } | null, trailer: { __typename?: 'Trailer', id: number, plate: string } | null, transportables: Array<{ __typename?: 'Transportable', id: number, container: { __typename?: 'Container', id: number, code: string | null } | null }> }> }>, items: Array<{ __typename?: 'ForeignTradeItemShipment', id: number, quantity: string | null, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, balance: string | null, quantity: string | null, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }> } } | null, salesOrderItem: { __typename?: 'SalesOrderItem', id: number, balance: string | null, quantity: string | null, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }> } } | null }>, transportables?: Array<{ __typename?: 'Transportable', id: number, type: TransportableTypeEnum, container: { __typename?: 'Container', id: number, code: string | null } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, phases: Array<{ __typename?: 'RoadTransportTripPhase', id: number, realizedAt: string | null, routePoint: { __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum } }> }> }> } | null, leadTime?: { __typename?: 'LeadTime', conclusionDate: string | null, startDate: string | null, plannedConclusionDate: string, deviationPercentage: string | null, differenceHours: number | null, isRealized: boolean, status: LeadTimeStatusEnum | null } | null, plannedLeadTime: { __typename?: 'PlannedLeadTime', id: number, name: string, leadTimeModel: { __typename?: 'LeadTimeModel', id: number, ignoreTime: boolean } } | null, automationProcesses: Array<{ __typename?: 'AutomationProcess', id: number, automation: { __typename?: 'Automation', id: number, name: string } }>, operation: { __typename?: 'Operation', id: number, title: string, subType: OperationSubTypeEnum }, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, documents?: Array<{ __typename?: 'Document', id: number, type: DocumentTypeEnum, brazilianInvoiceInfo?: { __typename?: 'BrazilianInvoice', emittedAt: string, number: string, accessKey: string, tax: { __typename?: 'BrazilianInvoiceTax', totalAmount: string }, transport: { __typename?: 'BrazilianInvoiceTransport', grossWeight: string | null } } | null }>, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }>, ownerHandler: { __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } } | null, orders: Array<{ __typename?: 'Order', id: number, referenceCode: string, externalReferenceCode: string | null, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }> }> } }> };

export type GetLeadTimeStagesPerProcessesTableRowsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  processFilters: FilterProcessParams;
  pagination?: InputMaybe<ProcessPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  includeDocuments: Scalars['Boolean']['input'];
  includeProcessLeadTime: Scalars['Boolean']['input'];
  includeProcessBrazilianInvoiceInfo: Scalars['Boolean']['input'];
  includeVesselScheduleCalculatedDates: Scalars['Boolean']['input'];
  includeShipmentDuimps: Scalars['Boolean']['input'];
  includeShipmentExportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportLicenses: Scalars['Boolean']['input'];
  includeContainers: Scalars['Boolean']['input'];
  includeDemurrageAny: Scalars['Boolean']['input'];
  includeDemurrage: Scalars['Boolean']['input'];
  includeDemurrageCalculations: Scalars['Boolean']['input'];
}>;


export type GetLeadTimeStagesPerProcessesTableRowsQuery = { __typename?: 'RootQueryType', leadTimeStagesPerProcesses: { __typename?: 'LeadTimeStagesPerProcessesResult', totalCount: number, data: Array<{ __typename?: 'LeadTimeStagePerProcess', process: { __typename?: 'Process', id: number, leadTimeDatetimeReference: string | null, referenceCode: string, alertLevel: AlertLevelEnum, extraFields: any | null, canceledAt: string | null, finishedAt: string | null, insertedAt: string, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, type: ShipmentTypeEnum | null, ata: string | null, atd: string | null, eta: string | null, etd: string | null, deliveredAt: string | null, receivedInWarehouseAt: string | null, departedFromWarehouseAt: string | null, totalNetWeight: string | null, totalGrossWeight: string | null, cubageCubicMeters: string | null, automaticTrackingEnabled: boolean, statusResponse: StatusResponseTypeEnum, ceMercanteData: { __typename?: 'CeMercanteData', id: number, number: string, issuedAt: string | null, cargoStatus: string | null, hasDta: boolean | null, manifestArrivalAt: string | null, cargoPresenceInPrimaryZoneAt: string | null, cargoPresenceInSecondaryZoneAt: string | null, customsPlace: string | null, bl: string | null, cargoPresenceHistory: Array<{ __typename?: 'CeMercanteDataCargoPresenceHistory', ra: string | null, status: string | null, date: string | null, dtaNumber: string | null, syncedAt: string | null }>, containerSeals: Array<{ __typename?: 'CeMercanteDataContainerSeal', containerCode: string | null, sealCode: string | null, secondarySealCode: string | null }>, originPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, destinationPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null } | null, parcelShipments: Array<{ __typename?: 'ParcelShipment', id: number, trackingNumber: string, slug: string }>, internationalFreight: { __typename?: 'InternationalFreight', id: number, cargoAttributes: Array<CargoAttributeEnum>, expectedSeparationAt: string | null, pickupLocation: string | null, freightForwarder: string | null, quotationNumber: string | null, plannedBoardingDate: string | null, freightCostPrepaid: string | null, freightCostCollect: string | null, freightCostRoad: string | null, freightCostTotal: string | null, type: InternationalFreightTypeEnum | null, bookingEta: string | null, bookingEtd: string | null, voyageNumber: string | null, currency: { __typename?: 'Currency', name: string, code: string } | null, sealine: { __typename?: 'Sealine', id: number, name: string, logoUrl: string | null } | null, bookingLoadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingDischargeAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingLoadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } | null, portTerminal: { __typename?: 'PortTerminal', id: number, name: string } | null } | null, airTransportShipment: { __typename?: 'AirTransportShipment', awb: string | null, hawb: string | null, id: number, type: AirTransportTypeEnum | null, destinationAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, originAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, airline: { __typename?: 'Airline', id: number, name: string } | null } | null, demurrage?: { __typename?: 'Demurrage', id: number, dailyRateUsd?: string | null, freeTime?: number | null, calculations?: { __typename?: 'DemurrageCalculations', totalExceedingDays: number, totalEstimatedCosts: string, totalDaysPaid: number, totalDaysToPay: number, averageCostPerDayUsd: string, totalOwedUsd: string, totalPaidUsd: string, totalToPayUsd: string } } | null, maritimeTransportShipment: { __typename?: 'MaritimeTransportShipment', id: number, type: MaritimeTransportTypeEnum | null, bl: string | null, booking: string | null, hbl: string | null, trackingNumber: string | null, trackingLoadingPort: string | null, trackingDischargePort: string | null, voyageNumber: string | null, trackingKey: TrackingKeyEnum | null, sealine: { __typename?: 'Sealine', id: number, logoUrl: string | null, name: string } | null, vessel: { __typename?: 'Vessel', id: number, name: string } | null, loadingPort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null, dischargePort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null } | null, roadTransportShipment: { __typename?: 'ForeignTradeRoadTransportShipment', id: number, type: ForeignTradeRoadTransportTypeEnum | null, crt: string | null, origin: string | null, destination: string | null } | null, route: { __typename?: 'Route', id: number, name: string } | null, shipmentDuimps?: Array<{ __typename?: 'ShipmentDuimp', id: number, duimp: { __typename?: 'Duimp', id: number, number: string, registeredAt: string | null, deliveredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: DuimpStatusEnum | null } }>, shipmentExportDeclarations?: Array<{ __typename?: 'ShipmentExportDeclaration', id: number, exportDeclaration: { __typename?: 'ExportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, endorsedAt: string | null, channel: ChannelExportDeclarationTypeEnum | null, status: ExportDeclarationStatusEnum | null } }>, shipmentImportDeclarations?: Array<{ __typename?: 'ShipmentImportDeclaration', id: number, importDeclaration: { __typename?: 'ImportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: ImportDeclarationStatusEnum | null } }>, shipmentImportLicenses?: Array<{ __typename?: 'ShipmentImportLicense', id: number, importLicense: { __typename?: 'ImportLicense', id: number, number: string, registeredAt: string | null, approvedAt: string | null, status: ImportLicenseStatusEnum | null } }>, invoices: Array<{ __typename?: 'Invoice', id: number, number: string, emittedAt: string, incoterm: IncotermTypeEnum, totalAmount: string, discount: string | null, finalValue: string, totalGrossWeightKg: string, currency: { __typename?: 'Currency', code: string } | null }>, vesselScheduleDeadlineReferences: { __typename?: 'VesselScheduleDeadlineReferences', draftDeadlineReference: DeadlineDateReferenceEnum | null, vgmDeadlineReference: VgmDeadlineDateReferenceEnum | null, cargoDeadlineReference: DeadlineDateReferenceEnum | null, gateOpeningDeadlineReference: GateOpeningDeadlineDateReferenceEnum | null } | null, vesselSchedule: { __typename?: 'VesselSchedule', id: number, sealineStatusResponse: VesselScheduleStatusResponseEnum, portTerminalStatusResponse: VesselScheduleStatusResponseEnum, deadlineDates?: { __typename?: 'VesselScheduleDeadlineDates', draftDeadline: string | null, cargoDeadline: string | null, vgmDeadline: string | null, gateOpeningDeadline: string | null } | null } | null, nationalRoadTransports: Array<{ __typename?: 'NationalRoadTransport', id: number, collectionScheduledAt: string | null, deliveryPlannedAt: string | null, loadType: LoadTypeEnum | null, roadTransportType: RoadTransportTypeEnum | null, transportFeatures: Array<TransportFeatureEnum>, releasedForTransportAt: string | null, transportCompletedAt: string | null, legSlug: string, route: { __typename?: 'Route', id: number, name: string } | null, nationalRoadCarrier: { __typename?: 'Handler', id: number, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null } } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, driverName: string | null, vehiclePlate: string | null, trailerPlate: string | null, driver: { __typename?: 'Driver', id: number, name: string } | null, vehicle: { __typename?: 'Vehicle', id: number, plate: string } | null, trailer: { __typename?: 'Trailer', id: number, plate: string } | null, transportables: Array<{ __typename?: 'Transportable', id: number, container: { __typename?: 'Container', id: number, code: string | null } | null }> }> }>, transportables?: Array<{ __typename?: 'Transportable', id: number, type: TransportableTypeEnum, container: { __typename?: 'Container', id: number, code: string | null } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, phases: Array<{ __typename?: 'RoadTransportTripPhase', id: number, realizedAt: string | null, routePoint: { __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum } }> }> }>, items: Array<{ __typename?: 'ForeignTradeItemShipment', id: number, quantity: string | null, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, balance: string | null, quantity: string | null, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }> } } | null, salesOrderItem: { __typename?: 'SalesOrderItem', id: number, balance: string | null, quantity: string | null, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }> } } | null }> } | null, plannedLeadTime: { __typename?: 'PlannedLeadTime', id: number, name: string, leadTimeModel: { __typename?: 'LeadTimeModel', id: number, name: string, ignoreTime: boolean, referenceEvent: string, referenceEventLabel: string } } | null, leadTime?: { __typename?: 'LeadTime', conclusionDate: string | null, startDate: string | null, plannedConclusionDate: string, deviationPercentage: string | null, differenceHours: number | null, isRealized: boolean, status: LeadTimeStatusEnum | null } | null, automationProcesses: Array<{ __typename?: 'AutomationProcess', id: number, automation: { __typename?: 'Automation', id: number, name: string } }>, operation: { __typename?: 'Operation', id: number, title: string, subType: OperationSubTypeEnum }, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, documents?: Array<{ __typename?: 'Document', id: number, type: DocumentTypeEnum, brazilianInvoiceInfo?: { __typename?: 'BrazilianInvoice', emittedAt: string, number: string, accessKey: string, tax: { __typename?: 'BrazilianInvoiceTax', totalAmount: string }, transport: { __typename?: 'BrazilianInvoiceTransport', grossWeight: string | null } } | null }>, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }>, ownerHandler: { __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } } | null, orders: Array<{ __typename?: 'Order', id: number, referenceCode: string, externalReferenceCode: string | null, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }> }> }, leadTime: { __typename?: 'LeadTime', status: LeadTimeStatusEnum | null, plannedDurationHours: number | null, realizedOrEstimatedDurationHours: number | null, differenceHours: number | null, deviationPercentage: string | null, conclusionDate: string | null, startDate: string | null, plannedConclusionDate: string }, leadTimeStage: { __typename?: 'LeadTimeStage', deviationPercentage: string | null, model: { __typename?: 'LeadTimeStageModel', id: number, name: string, startEventLabel: string, endEventLabel: string }, planned: { __typename?: 'CalculatedStage', startedAt: string | null, endedAt: string | null, durationHours: number | null }, realized: { __typename?: 'CalculatedStage', startedAt: string | null, endedAt: string | null, durationHours: number | null } | null, estimated: { __typename?: 'CalculatedStage', startedAt: string | null, endedAt: string | null, durationHours: number | null } | null } }> } };

export type GetOrderItemsWithShipmentItemTableRowsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filters: FilterOrderItemParams;
  pagination?: InputMaybe<OrderItemPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  orderFilters?: InputMaybe<FilterOrderParams>;
  includeDocuments: Scalars['Boolean']['input'];
  includeProcessLeadTime: Scalars['Boolean']['input'];
  includeProcessBrazilianInvoiceInfo: Scalars['Boolean']['input'];
  includeVesselScheduleCalculatedDates: Scalars['Boolean']['input'];
  includeShipmentDuimps: Scalars['Boolean']['input'];
  includeShipmentExportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportLicenses: Scalars['Boolean']['input'];
  includeContainers: Scalars['Boolean']['input'];
  includeDemurrageAny: Scalars['Boolean']['input'];
  includeDemurrage: Scalars['Boolean']['input'];
  includeDemurrageCalculations: Scalars['Boolean']['input'];
}>;


export type GetOrderItemsWithShipmentItemTableRowsQuery = { __typename?: 'RootQueryType', orderItemsWithShipmentItemsCount: number, orderItemsWithShipmentItems: Array<{ __typename?: 'OrderItemWithShipmentItem', foreignTradeItemShipment: { __typename?: 'ForeignTradeItemShipment', id: number, quantity: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, unitValue: string | null, brazilianInvoiceUnitValue: string | null, totalValue: string | null, transportables: Array<{ __typename?: 'Transportable', id: number, container: { __typename?: 'Container', id: number, code: string | null, actualReturnEmptyContainerAt: string | null, estimatedReturnEmptyContainerAt: string | null, invoiceNumber: string | null, sealCode: string | null, secondarySealCode: string | null, grossWeightKg: string | null, maxWeightKg: string | null, tareWeightKg: string | null, loadType: LoadTypeEnum | null, sizeFootType: ContainerSizeFootTypeEnum | null, type: ContainerTypeEnum | null, palletQuantity: number | null, demurrageDailyRateUsd: string | null, demurrageFreeTime: number | null, demurrageFreeTimeStartAt: string | null, isStackable: boolean | null, cubicMeters: string | null, dispatchNumber: string | null, transportDocument: string | null, demurrageCalculations: { __typename?: 'ContainerDemurrageCalculations', emptyReturnDeadline: string | null, estimatedCosts: string, exceedingDays: number } | null } | null }> } | null, salesOrderItem: { __typename?: 'SalesOrderItem', id: number, lineNumber: number | null, lineReference: string, quantity: string | null, balance: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, dispatchNumber: string | null, measurementUnitSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedArrivalAt: string | null, shipmentPlannedBoardingAt: string | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierReadyDeviation: number | null, factoryDeliveryAt: string | null, factoryEstimatedDeliveryAt: string | null, itemStatus: string | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, necessityType: string | null, ubc: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, stockQuantity: string | null, clientApprovedAt: string | null, reservedStockQuantity: string | null, stockReservationAt: string | null, preliminaryPickingStartedAt: string | null, internalContainerReference: string | null, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, salesOrder: { __typename?: 'SalesOrder', id: number, order: { __typename?: 'Order', id: number, referenceCode: string } }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'SalesOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null } | null, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, lineNumber: number | null, lineReference: string, quantity: string | null, balance: string | null, measurementUnitSap: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, sapByFactor: string | null, concessionAct: string | null, importTypeSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, orderModalTypeSap: string | null, orderAdjustedModalType: string | null, orderRequestedAt: string | null, planningRequestShippingAt: string | null, planningShippingAt: string | null, supplierSentAt: string | null, supplierConfirmationAt: string | null, supplierReadyLeadTimeDays: number | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierCalculatedReadyAt: string | null, supplierReadyDeviation: number | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedBoardingAt: string | null, shipmentPlannedArrivalAt: string | null, shipmentEstimatedBoardingAt: string | null, shipmentEstimatedArrivalAt: string | null, shipmentBoardingLeadTime: number | null, shipmentTransportLeadTime: number | null, customsEstimatedRegisterAt: string | null, customsRegisterLeadTime: number | null, customsEstimatedReleaseAt: string | null, customsReleaseLeadTime: number | null, factoryEstimatedDeliveryAt: string | null, factoryPlannedDeliveryAt: string | null, factoryDeliveryAt: string | null, factoryDeliveryLeadTime: number | null, adjustedCustomsRegisterLeadTime: number | null, adjustedCustomsReleaseLeadTime: number | null, adjustedFactoryDeliveryLeadTime: number | null, adjustedShipmentBoardingLeadTime: number | null, adjustedShipmentTransportLeadTime: number | null, adjustedSupplierReadyLeadTimeDays: number | null, assessmentSotd: string | null, itemStatus: string | null, division: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, invoiceIssuedAt: string | null, invoiceNumber: string | null, invoiceValue: string | null, invoiceType: string | null, deliveryNote: string | null, deliveryNoteIssuedAt: string | null, shippingDetailsDeliveryDate: string | null, quotationOpeningDate: string | null, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, purchaseOrder: { __typename?: 'PurchaseOrder', id: number, order: { __typename?: 'Order', id: number, referenceCode: string } }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'PurchaseOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null, manufacturingCountry: { __typename?: 'Country', code: string } | null, purchaseCountry: { __typename?: 'Country', code: string } | null, dispatchingCountry: { __typename?: 'Country', code: string } | null } | null, process: { __typename?: 'Process', id: number, leadTimeDatetimeReference: string | null, referenceCode: string, alertLevel: AlertLevelEnum, extraFields: any | null, canceledAt: string | null, finishedAt: string | null, insertedAt: string, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, type: ShipmentTypeEnum | null, ata: string | null, atd: string | null, eta: string | null, etd: string | null, deliveredAt: string | null, receivedInWarehouseAt: string | null, departedFromWarehouseAt: string | null, totalNetWeight: string | null, totalGrossWeight: string | null, cubageCubicMeters: string | null, automaticTrackingEnabled: boolean, statusResponse: StatusResponseTypeEnum, ceMercanteData: { __typename?: 'CeMercanteData', id: number, number: string, issuedAt: string | null, cargoStatus: string | null, hasDta: boolean | null, manifestArrivalAt: string | null, cargoPresenceInPrimaryZoneAt: string | null, cargoPresenceInSecondaryZoneAt: string | null, customsPlace: string | null, bl: string | null, cargoPresenceHistory: Array<{ __typename?: 'CeMercanteDataCargoPresenceHistory', ra: string | null, status: string | null, date: string | null, dtaNumber: string | null, syncedAt: string | null }>, containerSeals: Array<{ __typename?: 'CeMercanteDataContainerSeal', containerCode: string | null, sealCode: string | null, secondarySealCode: string | null }>, originPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, destinationPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null } | null, parcelShipments: Array<{ __typename?: 'ParcelShipment', id: number, trackingNumber: string, slug: string }>, internationalFreight: { __typename?: 'InternationalFreight', id: number, cargoAttributes: Array<CargoAttributeEnum>, expectedSeparationAt: string | null, pickupLocation: string | null, freightForwarder: string | null, quotationNumber: string | null, plannedBoardingDate: string | null, freightCostPrepaid: string | null, freightCostCollect: string | null, freightCostRoad: string | null, freightCostTotal: string | null, type: InternationalFreightTypeEnum | null, bookingEta: string | null, bookingEtd: string | null, voyageNumber: string | null, currency: { __typename?: 'Currency', name: string, code: string } | null, sealine: { __typename?: 'Sealine', id: number, name: string, logoUrl: string | null } | null, bookingLoadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingDischargeAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingLoadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } | null, portTerminal: { __typename?: 'PortTerminal', id: number, name: string } | null } | null, airTransportShipment: { __typename?: 'AirTransportShipment', awb: string | null, hawb: string | null, id: number, type: AirTransportTypeEnum | null, destinationAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, originAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, airline: { __typename?: 'Airline', id: number, name: string } | null } | null, demurrage?: { __typename?: 'Demurrage', id: number, dailyRateUsd?: string | null, freeTime?: number | null, calculations?: { __typename?: 'DemurrageCalculations', totalExceedingDays: number, totalEstimatedCosts: string, totalDaysPaid: number, totalDaysToPay: number, averageCostPerDayUsd: string, totalOwedUsd: string, totalPaidUsd: string, totalToPayUsd: string } } | null, maritimeTransportShipment: { __typename?: 'MaritimeTransportShipment', id: number, type: MaritimeTransportTypeEnum | null, bl: string | null, booking: string | null, hbl: string | null, trackingNumber: string | null, trackingLoadingPort: string | null, trackingDischargePort: string | null, voyageNumber: string | null, trackingKey: TrackingKeyEnum | null, sealine: { __typename?: 'Sealine', id: number, logoUrl: string | null, name: string } | null, vessel: { __typename?: 'Vessel', id: number, name: string } | null, loadingPort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null, dischargePort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null } | null, roadTransportShipment: { __typename?: 'ForeignTradeRoadTransportShipment', id: number, type: ForeignTradeRoadTransportTypeEnum | null, crt: string | null, origin: string | null, destination: string | null } | null, route: { __typename?: 'Route', id: number, name: string } | null, shipmentDuimps?: Array<{ __typename?: 'ShipmentDuimp', id: number, duimp: { __typename?: 'Duimp', id: number, number: string, registeredAt: string | null, deliveredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: DuimpStatusEnum | null } }>, shipmentExportDeclarations?: Array<{ __typename?: 'ShipmentExportDeclaration', id: number, exportDeclaration: { __typename?: 'ExportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, endorsedAt: string | null, channel: ChannelExportDeclarationTypeEnum | null, status: ExportDeclarationStatusEnum | null } }>, shipmentImportDeclarations?: Array<{ __typename?: 'ShipmentImportDeclaration', id: number, importDeclaration: { __typename?: 'ImportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: ImportDeclarationStatusEnum | null } }>, shipmentImportLicenses?: Array<{ __typename?: 'ShipmentImportLicense', id: number, importLicense: { __typename?: 'ImportLicense', id: number, number: string, registeredAt: string | null, approvedAt: string | null, status: ImportLicenseStatusEnum | null } }>, invoices: Array<{ __typename?: 'Invoice', id: number, number: string, emittedAt: string, incoterm: IncotermTypeEnum, totalAmount: string, discount: string | null, finalValue: string, totalGrossWeightKg: string, currency: { __typename?: 'Currency', code: string } | null }>, vesselScheduleDeadlineReferences: { __typename?: 'VesselScheduleDeadlineReferences', draftDeadlineReference: DeadlineDateReferenceEnum | null, vgmDeadlineReference: VgmDeadlineDateReferenceEnum | null, cargoDeadlineReference: DeadlineDateReferenceEnum | null, gateOpeningDeadlineReference: GateOpeningDeadlineDateReferenceEnum | null } | null, vesselSchedule: { __typename?: 'VesselSchedule', id: number, sealineStatusResponse: VesselScheduleStatusResponseEnum, portTerminalStatusResponse: VesselScheduleStatusResponseEnum, deadlineDates?: { __typename?: 'VesselScheduleDeadlineDates', draftDeadline: string | null, cargoDeadline: string | null, vgmDeadline: string | null, gateOpeningDeadline: string | null } | null } | null, nationalRoadTransports: Array<{ __typename?: 'NationalRoadTransport', id: number, collectionScheduledAt: string | null, deliveryPlannedAt: string | null, loadType: LoadTypeEnum | null, roadTransportType: RoadTransportTypeEnum | null, transportFeatures: Array<TransportFeatureEnum>, releasedForTransportAt: string | null, transportCompletedAt: string | null, legSlug: string, route: { __typename?: 'Route', id: number, name: string } | null, nationalRoadCarrier: { __typename?: 'Handler', id: number, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null } } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, driverName: string | null, vehiclePlate: string | null, trailerPlate: string | null, driver: { __typename?: 'Driver', id: number, name: string } | null, vehicle: { __typename?: 'Vehicle', id: number, plate: string } | null, trailer: { __typename?: 'Trailer', id: number, plate: string } | null, transportables: Array<{ __typename?: 'Transportable', id: number, container: { __typename?: 'Container', id: number, code: string | null } | null }> }> }>, transportables?: Array<{ __typename?: 'Transportable', id: number, type: TransportableTypeEnum, container: { __typename?: 'Container', id: number, code: string | null } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, phases: Array<{ __typename?: 'RoadTransportTripPhase', id: number, realizedAt: string | null, routePoint: { __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum } }> }> }> } | null, leadTime?: { __typename?: 'LeadTime', conclusionDate: string | null, startDate: string | null, plannedConclusionDate: string, deviationPercentage: string | null, differenceHours: number | null, isRealized: boolean, status: LeadTimeStatusEnum | null } | null, plannedLeadTime: { __typename?: 'PlannedLeadTime', id: number, name: string, leadTimeModel: { __typename?: 'LeadTimeModel', id: number, ignoreTime: boolean } } | null, automationProcesses: Array<{ __typename?: 'AutomationProcess', id: number, automation: { __typename?: 'Automation', id: number, name: string } }>, operation: { __typename?: 'Operation', id: number, title: string, subType: OperationSubTypeEnum }, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, documents?: Array<{ __typename?: 'Document', id: number, type: DocumentTypeEnum, brazilianInvoiceInfo?: { __typename?: 'BrazilianInvoice', emittedAt: string, number: string, accessKey: string, tax: { __typename?: 'BrazilianInvoiceTax', totalAmount: string }, transport: { __typename?: 'BrazilianInvoiceTransport', grossWeight: string | null } } | null }>, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }>, ownerHandler: { __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } } | null, orders: Array<{ __typename?: 'Order', id: number, referenceCode: string, externalReferenceCode: string | null, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }> }> } | null, order: { __typename?: 'Order', id: number, referenceCode: string, externalReferenceCode: string | null, insertedAt: string, finishedAt: string | null, alertLevel: AlertLevelEnum, type: OrderTypeEnum, extraFields: any | null, observations: string | null, automationOrders: Array<{ __typename?: 'AutomationOrder', id: number, automation: { __typename?: 'Automation', id: number, name: string } }>, subsidiary: { __typename?: 'Subsidiary', id: number, name: string } | null, processes: Array<{ __typename?: 'Process', id: number, referenceCode: string }>, operation: { __typename?: 'Operation', id: number, title: string, subType: OperationSubTypeEnum }, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, actor: { __typename?: 'Actor', id: number, nickname: string }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }>, purchaseOrder: { __typename?: 'PurchaseOrder', id: number, type: OrderTransactionTypeEnum, supplierOrderAcceptedAt: string | null, supplierOrderSentAt: string | null, supplierReadinessAt: string | null, supplierExpectedReadinessAt: string | null, necessityDate: string | null } | null, salesOrder: { __typename?: 'SalesOrder', id: number, type: OrderTransactionTypeEnum, orderConfirmedAt: string | null, orderReceivedAt: string | null } | null } }> };

export type GetOrderItemsTableRowsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filters: FilterOrderItemParams;
  pagination?: InputMaybe<OrderItemPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  orderFilters?: InputMaybe<FilterOrderParams>;
}>;


export type GetOrderItemsTableRowsQuery = { __typename?: 'RootQueryType', orderItemsCount: number, orderItems: Array<{ __typename?: 'OrderItem', salesOrderItem: { __typename?: 'SalesOrderItem', id: number, lineNumber: number | null, lineReference: string, quantity: string | null, balanceShipped: string | null, balance: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, dispatchNumber: string | null, measurementUnitSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedArrivalAt: string | null, shipmentPlannedBoardingAt: string | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierReadyDeviation: number | null, factoryDeliveryAt: string | null, factoryEstimatedDeliveryAt: string | null, itemStatus: string | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, necessityType: string | null, ubc: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, stockQuantity: string | null, clientApprovedAt: string | null, reservedStockQuantity: string | null, stockReservationAt: string | null, preliminaryPickingStartedAt: string | null, internalContainerReference: string | null, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'SalesOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null } | null, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, lineNumber: number | null, lineReference: string, quantity: string | null, balanceShipped: string | null, balance: string | null, measurementUnitSap: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, sapByFactor: string | null, concessionAct: string | null, importTypeSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, orderModalTypeSap: string | null, orderAdjustedModalType: string | null, orderRequestedAt: string | null, planningRequestShippingAt: string | null, planningShippingAt: string | null, supplierSentAt: string | null, supplierConfirmationAt: string | null, supplierReadyLeadTimeDays: number | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierCalculatedReadyAt: string | null, supplierReadyDeviation: number | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedBoardingAt: string | null, shipmentPlannedArrivalAt: string | null, shipmentEstimatedBoardingAt: string | null, shipmentEstimatedArrivalAt: string | null, shipmentBoardingLeadTime: number | null, shipmentTransportLeadTime: number | null, customsEstimatedRegisterAt: string | null, customsRegisterLeadTime: number | null, customsEstimatedReleaseAt: string | null, customsReleaseLeadTime: number | null, factoryEstimatedDeliveryAt: string | null, factoryPlannedDeliveryAt: string | null, factoryDeliveryAt: string | null, factoryDeliveryLeadTime: number | null, adjustedCustomsRegisterLeadTime: number | null, adjustedCustomsReleaseLeadTime: number | null, adjustedFactoryDeliveryLeadTime: number | null, adjustedShipmentBoardingLeadTime: number | null, adjustedShipmentTransportLeadTime: number | null, adjustedSupplierReadyLeadTimeDays: number | null, assessmentSotd: string | null, itemStatus: string | null, division: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, invoiceIssuedAt: string | null, invoiceNumber: string | null, invoiceValue: string | null, invoiceType: string | null, deliveryNote: string | null, deliveryNoteIssuedAt: string | null, shippingDetailsDeliveryDate: string | null, quotationOpeningDate: string | null, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'PurchaseOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null, manufacturingCountry: { __typename?: 'Country', code: string } | null, purchaseCountry: { __typename?: 'Country', code: string } | null, dispatchingCountry: { __typename?: 'Country', code: string } | null } | null, order: { __typename?: 'Order', id: number, referenceCode: string, externalReferenceCode: string | null, insertedAt: string, finishedAt: string | null, alertLevel: AlertLevelEnum, type: OrderTypeEnum, extraFields: any | null, observations: string | null, automationOrders: Array<{ __typename?: 'AutomationOrder', id: number, automation: { __typename?: 'Automation', id: number, name: string } }>, subsidiary: { __typename?: 'Subsidiary', id: number, name: string } | null, processes: Array<{ __typename?: 'Process', id: number, referenceCode: string }>, operation: { __typename?: 'Operation', id: number, title: string, subType: OperationSubTypeEnum }, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, actor: { __typename?: 'Actor', id: number, nickname: string }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }>, purchaseOrder: { __typename?: 'PurchaseOrder', id: number, type: OrderTransactionTypeEnum, supplierOrderAcceptedAt: string | null, supplierOrderSentAt: string | null, supplierReadinessAt: string | null, supplierExpectedReadinessAt: string | null, necessityDate: string | null } | null, salesOrder: { __typename?: 'SalesOrder', id: number, type: OrderTransactionTypeEnum, orderConfirmedAt: string | null, orderReceivedAt: string | null } | null } }> };

export type OrdersDataFragment = { __typename?: 'Order', id: number, referenceCode: string, externalReferenceCode: string | null, insertedAt: string, finishedAt: string | null, alertLevel: AlertLevelEnum, type: OrderTypeEnum, extraFields: any | null, observations: string | null, automationOrders: Array<{ __typename?: 'AutomationOrder', id: number, automation: { __typename?: 'Automation', id: number, name: string } }>, subsidiary: { __typename?: 'Subsidiary', id: number, name: string } | null, processes: Array<{ __typename?: 'Process', id: number, referenceCode: string }>, operation: { __typename?: 'Operation', id: number, title: string, subType: OperationSubTypeEnum }, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, actor: { __typename?: 'Actor', id: number, nickname: string }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }>, purchaseOrder: { __typename?: 'PurchaseOrder', id: number, type: OrderTransactionTypeEnum, supplierOrderAcceptedAt: string | null, supplierOrderSentAt: string | null, supplierReadinessAt: string | null, supplierExpectedReadinessAt: string | null, necessityDate: string | null } | null, salesOrder: { __typename?: 'SalesOrder', id: number, type: OrderTransactionTypeEnum, orderConfirmedAt: string | null, orderReceivedAt: string | null } | null };

export type GetOrdersTableRowsQueryVariables = Exact<{
  pagination?: InputMaybe<OrderPaginationParams>;
  filters?: InputMaybe<FilterOrderParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrdersTableRowsQuery = { __typename?: 'RootQueryType', ordersCount: number, orders: Array<{ __typename?: 'Order', id: number, referenceCode: string, externalReferenceCode: string | null, insertedAt: string, finishedAt: string | null, alertLevel: AlertLevelEnum, type: OrderTypeEnum, extraFields: any | null, observations: string | null, automationOrders: Array<{ __typename?: 'AutomationOrder', id: number, automation: { __typename?: 'Automation', id: number, name: string } }>, subsidiary: { __typename?: 'Subsidiary', id: number, name: string } | null, processes: Array<{ __typename?: 'Process', id: number, referenceCode: string }>, operation: { __typename?: 'Operation', id: number, title: string, subType: OperationSubTypeEnum }, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, actor: { __typename?: 'Actor', id: number, nickname: string }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }>, purchaseOrder: { __typename?: 'PurchaseOrder', id: number, type: OrderTransactionTypeEnum, supplierOrderAcceptedAt: string | null, supplierOrderSentAt: string | null, supplierReadinessAt: string | null, supplierExpectedReadinessAt: string | null, necessityDate: string | null } | null, salesOrder: { __typename?: 'SalesOrder', id: number, type: OrderTransactionTypeEnum, orderConfirmedAt: string | null, orderReceivedAt: string | null } | null }> };

export type GetProcessCostsTableRowsQueryVariables = Exact<{
  pagination?: InputMaybe<ProcessPaginationParams>;
  filters?: InputMaybe<FilterProcessParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  includeDocuments: Scalars['Boolean']['input'];
  includeProcessLeadTime: Scalars['Boolean']['input'];
  includeProcessBrazilianInvoiceInfo: Scalars['Boolean']['input'];
  includeVesselScheduleCalculatedDates: Scalars['Boolean']['input'];
  includeShipmentDuimps: Scalars['Boolean']['input'];
  includeShipmentExportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportLicenses: Scalars['Boolean']['input'];
  includeContainers: Scalars['Boolean']['input'];
  includeDemurrageAny: Scalars['Boolean']['input'];
  includeDemurrage: Scalars['Boolean']['input'];
  includeDemurrageCalculations: Scalars['Boolean']['input'];
}>;


export type GetProcessCostsTableRowsQuery = { __typename?: 'RootQueryType', processesCount: number, processes: Array<{ __typename?: 'Process', id: number, leadTimeDatetimeReference: string | null, referenceCode: string, alertLevel: AlertLevelEnum, extraFields: any | null, canceledAt: string | null, finishedAt: string | null, insertedAt: string, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, type: ShipmentTypeEnum | null, ata: string | null, atd: string | null, eta: string | null, etd: string | null, deliveredAt: string | null, receivedInWarehouseAt: string | null, departedFromWarehouseAt: string | null, totalNetWeight: string | null, totalGrossWeight: string | null, cubageCubicMeters: string | null, automaticTrackingEnabled: boolean, statusResponse: StatusResponseTypeEnum, ceMercanteData: { __typename?: 'CeMercanteData', id: number, number: string, issuedAt: string | null, cargoStatus: string | null, hasDta: boolean | null, manifestArrivalAt: string | null, cargoPresenceInPrimaryZoneAt: string | null, cargoPresenceInSecondaryZoneAt: string | null, customsPlace: string | null, bl: string | null, cargoPresenceHistory: Array<{ __typename?: 'CeMercanteDataCargoPresenceHistory', ra: string | null, status: string | null, date: string | null, dtaNumber: string | null, syncedAt: string | null }>, containerSeals: Array<{ __typename?: 'CeMercanteDataContainerSeal', containerCode: string | null, sealCode: string | null, secondarySealCode: string | null }>, originPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, destinationPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null } | null, parcelShipments: Array<{ __typename?: 'ParcelShipment', id: number, trackingNumber: string, slug: string }>, internationalFreight: { __typename?: 'InternationalFreight', id: number, cargoAttributes: Array<CargoAttributeEnum>, expectedSeparationAt: string | null, pickupLocation: string | null, freightForwarder: string | null, quotationNumber: string | null, plannedBoardingDate: string | null, freightCostPrepaid: string | null, freightCostCollect: string | null, freightCostRoad: string | null, freightCostTotal: string | null, type: InternationalFreightTypeEnum | null, bookingEta: string | null, bookingEtd: string | null, voyageNumber: string | null, currency: { __typename?: 'Currency', name: string, code: string } | null, sealine: { __typename?: 'Sealine', id: number, name: string, logoUrl: string | null } | null, bookingLoadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingDischargeAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingLoadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } | null, portTerminal: { __typename?: 'PortTerminal', id: number, name: string } | null } | null, airTransportShipment: { __typename?: 'AirTransportShipment', awb: string | null, hawb: string | null, id: number, type: AirTransportTypeEnum | null, destinationAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, originAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, airline: { __typename?: 'Airline', id: number, name: string } | null } | null, demurrage?: { __typename?: 'Demurrage', id: number, dailyRateUsd?: string | null, freeTime?: number | null, calculations?: { __typename?: 'DemurrageCalculations', totalExceedingDays: number, totalEstimatedCosts: string, totalDaysPaid: number, totalDaysToPay: number, averageCostPerDayUsd: string, totalOwedUsd: string, totalPaidUsd: string, totalToPayUsd: string } } | null, maritimeTransportShipment: { __typename?: 'MaritimeTransportShipment', id: number, type: MaritimeTransportTypeEnum | null, bl: string | null, booking: string | null, hbl: string | null, trackingNumber: string | null, trackingLoadingPort: string | null, trackingDischargePort: string | null, voyageNumber: string | null, trackingKey: TrackingKeyEnum | null, sealine: { __typename?: 'Sealine', id: number, logoUrl: string | null, name: string } | null, vessel: { __typename?: 'Vessel', id: number, name: string } | null, loadingPort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null, dischargePort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null } | null, roadTransportShipment: { __typename?: 'ForeignTradeRoadTransportShipment', id: number, type: ForeignTradeRoadTransportTypeEnum | null, crt: string | null, origin: string | null, destination: string | null } | null, route: { __typename?: 'Route', id: number, name: string } | null, shipmentDuimps?: Array<{ __typename?: 'ShipmentDuimp', id: number, duimp: { __typename?: 'Duimp', id: number, number: string, registeredAt: string | null, deliveredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: DuimpStatusEnum | null } }>, shipmentExportDeclarations?: Array<{ __typename?: 'ShipmentExportDeclaration', id: number, exportDeclaration: { __typename?: 'ExportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, endorsedAt: string | null, channel: ChannelExportDeclarationTypeEnum | null, status: ExportDeclarationStatusEnum | null } }>, shipmentImportDeclarations?: Array<{ __typename?: 'ShipmentImportDeclaration', id: number, importDeclaration: { __typename?: 'ImportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: ImportDeclarationStatusEnum | null } }>, shipmentImportLicenses?: Array<{ __typename?: 'ShipmentImportLicense', id: number, importLicense: { __typename?: 'ImportLicense', id: number, number: string, registeredAt: string | null, approvedAt: string | null, status: ImportLicenseStatusEnum | null } }>, invoices: Array<{ __typename?: 'Invoice', id: number, number: string, emittedAt: string, incoterm: IncotermTypeEnum, totalAmount: string, discount: string | null, finalValue: string, totalGrossWeightKg: string, currency: { __typename?: 'Currency', code: string } | null }>, vesselScheduleDeadlineReferences: { __typename?: 'VesselScheduleDeadlineReferences', draftDeadlineReference: DeadlineDateReferenceEnum | null, vgmDeadlineReference: VgmDeadlineDateReferenceEnum | null, cargoDeadlineReference: DeadlineDateReferenceEnum | null, gateOpeningDeadlineReference: GateOpeningDeadlineDateReferenceEnum | null } | null, vesselSchedule: { __typename?: 'VesselSchedule', id: number, sealineStatusResponse: VesselScheduleStatusResponseEnum, portTerminalStatusResponse: VesselScheduleStatusResponseEnum, deadlineDates?: { __typename?: 'VesselScheduleDeadlineDates', draftDeadline: string | null, cargoDeadline: string | null, vgmDeadline: string | null, gateOpeningDeadline: string | null } | null } | null, items: Array<{ __typename?: 'ForeignTradeItemShipment', id: number, quantity: string | null, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, balance: string | null, quantity: string | null, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }> } } | null, salesOrderItem: { __typename?: 'SalesOrderItem', id: number, balance: string | null, quantity: string | null, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }> } } | null }>, nationalRoadTransports: Array<{ __typename?: 'NationalRoadTransport', id: number, collectionScheduledAt: string | null, deliveryPlannedAt: string | null, loadType: LoadTypeEnum | null, roadTransportType: RoadTransportTypeEnum | null, transportFeatures: Array<TransportFeatureEnum>, releasedForTransportAt: string | null, transportCompletedAt: string | null, legSlug: string, route: { __typename?: 'Route', id: number, name: string } | null, nationalRoadCarrier: { __typename?: 'Handler', id: number, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null } } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, driverName: string | null, vehiclePlate: string | null, trailerPlate: string | null, driver: { __typename?: 'Driver', id: number, name: string } | null, vehicle: { __typename?: 'Vehicle', id: number, plate: string } | null, trailer: { __typename?: 'Trailer', id: number, plate: string } | null, transportables: Array<{ __typename?: 'Transportable', id: number, container: { __typename?: 'Container', id: number, code: string | null } | null }> }> }>, transportables?: Array<{ __typename?: 'Transportable', id: number, type: TransportableTypeEnum, container: { __typename?: 'Container', id: number, code: string | null } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, phases: Array<{ __typename?: 'RoadTransportTripPhase', id: number, realizedAt: string | null, routePoint: { __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum } }> }> }> } | null, costModelVersion: { __typename?: 'CostModelVersion', id: number, version: number, costModel: { __typename?: 'CostModel', id: number, name: string, hasPlannedCosts: boolean, currency: { __typename?: 'Currency', code: string, name: string } | null } } | null, costPerExpenses: Array<{ __typename?: 'CostPerExpense', id: number, cost: string | null, plannedCost: string | null, deviation: string | null, costModelExpense: { __typename?: 'CostModelExpense', id: number, costExpense: { __typename?: 'CostExpense', id: number } } }>, leadTime?: { __typename?: 'LeadTime', conclusionDate: string | null, startDate: string | null, plannedConclusionDate: string, deviationPercentage: string | null, differenceHours: number | null, isRealized: boolean, status: LeadTimeStatusEnum | null } | null, plannedLeadTime: { __typename?: 'PlannedLeadTime', id: number, name: string, leadTimeModel: { __typename?: 'LeadTimeModel', id: number, ignoreTime: boolean } } | null, automationProcesses: Array<{ __typename?: 'AutomationProcess', id: number, automation: { __typename?: 'Automation', id: number, name: string } }>, operation: { __typename?: 'Operation', id: number, title: string, subType: OperationSubTypeEnum }, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, documents?: Array<{ __typename?: 'Document', id: number, type: DocumentTypeEnum, brazilianInvoiceInfo?: { __typename?: 'BrazilianInvoice', emittedAt: string, number: string, accessKey: string, tax: { __typename?: 'BrazilianInvoiceTax', totalAmount: string }, transport: { __typename?: 'BrazilianInvoiceTransport', grossWeight: string | null } } | null }>, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }>, ownerHandler: { __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } } | null, orders: Array<{ __typename?: 'Order', id: number, referenceCode: string, externalReferenceCode: string | null, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }> }> }> };

export type HandlersDataFragment = { __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } };

export type NationalRoadTranportsDataFragment = { __typename?: 'ForeignTradeShipment', id: number, nationalRoadTransports: Array<{ __typename?: 'NationalRoadTransport', id: number, collectionScheduledAt: string | null, deliveryPlannedAt: string | null, loadType: LoadTypeEnum | null, roadTransportType: RoadTransportTypeEnum | null, transportFeatures: Array<TransportFeatureEnum>, releasedForTransportAt: string | null, transportCompletedAt: string | null, legSlug: string, route: { __typename?: 'Route', id: number, name: string } | null, nationalRoadCarrier: { __typename?: 'Handler', id: number, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null } } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, driverName: string | null, vehiclePlate: string | null, trailerPlate: string | null, driver: { __typename?: 'Driver', id: number, name: string } | null, vehicle: { __typename?: 'Vehicle', id: number, plate: string } | null, trailer: { __typename?: 'Trailer', id: number, plate: string } | null, transportables: Array<{ __typename?: 'Transportable', id: number, container: { __typename?: 'Container', id: number, code: string | null } | null }> }> }> };

export type ContainersDataFragment = { __typename?: 'ForeignTradeShipment', id: number, transportables?: Array<{ __typename?: 'Transportable', id: number, type: TransportableTypeEnum, container: { __typename?: 'Container', id: number, code: string | null } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, phases: Array<{ __typename?: 'RoadTransportTripPhase', id: number, realizedAt: string | null, routePoint: { __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum } }> }> }> };

export type DefaultForeignTradeShipmentDataFragment = { __typename?: 'ForeignTradeShipment', id: number, type: ShipmentTypeEnum | null, ata: string | null, atd: string | null, eta: string | null, etd: string | null, deliveredAt: string | null, receivedInWarehouseAt: string | null, departedFromWarehouseAt: string | null, totalNetWeight: string | null, totalGrossWeight: string | null, cubageCubicMeters: string | null, automaticTrackingEnabled: boolean, statusResponse: StatusResponseTypeEnum, ceMercanteData: { __typename?: 'CeMercanteData', id: number, number: string, issuedAt: string | null, cargoStatus: string | null, hasDta: boolean | null, manifestArrivalAt: string | null, cargoPresenceInPrimaryZoneAt: string | null, cargoPresenceInSecondaryZoneAt: string | null, customsPlace: string | null, bl: string | null, cargoPresenceHistory: Array<{ __typename?: 'CeMercanteDataCargoPresenceHistory', ra: string | null, status: string | null, date: string | null, dtaNumber: string | null, syncedAt: string | null }>, containerSeals: Array<{ __typename?: 'CeMercanteDataContainerSeal', containerCode: string | null, sealCode: string | null, secondarySealCode: string | null }>, originPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, destinationPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null } | null, parcelShipments: Array<{ __typename?: 'ParcelShipment', id: number, trackingNumber: string, slug: string }>, internationalFreight: { __typename?: 'InternationalFreight', id: number, cargoAttributes: Array<CargoAttributeEnum>, expectedSeparationAt: string | null, pickupLocation: string | null, freightForwarder: string | null, quotationNumber: string | null, plannedBoardingDate: string | null, freightCostPrepaid: string | null, freightCostCollect: string | null, freightCostRoad: string | null, freightCostTotal: string | null, type: InternationalFreightTypeEnum | null, bookingEta: string | null, bookingEtd: string | null, voyageNumber: string | null, currency: { __typename?: 'Currency', name: string, code: string } | null, sealine: { __typename?: 'Sealine', id: number, name: string, logoUrl: string | null } | null, bookingLoadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingDischargeAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingLoadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } | null, portTerminal: { __typename?: 'PortTerminal', id: number, name: string } | null } | null, airTransportShipment: { __typename?: 'AirTransportShipment', awb: string | null, hawb: string | null, id: number, type: AirTransportTypeEnum | null, destinationAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, originAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, airline: { __typename?: 'Airline', id: number, name: string } | null } | null, demurrage?: { __typename?: 'Demurrage', id: number, dailyRateUsd?: string | null, freeTime?: number | null, calculations?: { __typename?: 'DemurrageCalculations', totalExceedingDays: number, totalEstimatedCosts: string, totalDaysPaid: number, totalDaysToPay: number, averageCostPerDayUsd: string, totalOwedUsd: string, totalPaidUsd: string, totalToPayUsd: string } } | null, maritimeTransportShipment: { __typename?: 'MaritimeTransportShipment', id: number, type: MaritimeTransportTypeEnum | null, bl: string | null, booking: string | null, hbl: string | null, trackingNumber: string | null, trackingLoadingPort: string | null, trackingDischargePort: string | null, voyageNumber: string | null, trackingKey: TrackingKeyEnum | null, sealine: { __typename?: 'Sealine', id: number, logoUrl: string | null, name: string } | null, vessel: { __typename?: 'Vessel', id: number, name: string } | null, loadingPort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null, dischargePort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null } | null, roadTransportShipment: { __typename?: 'ForeignTradeRoadTransportShipment', id: number, type: ForeignTradeRoadTransportTypeEnum | null, crt: string | null, origin: string | null, destination: string | null } | null, route: { __typename?: 'Route', id: number, name: string } | null, shipmentDuimps?: Array<{ __typename?: 'ShipmentDuimp', id: number, duimp: { __typename?: 'Duimp', id: number, number: string, registeredAt: string | null, deliveredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: DuimpStatusEnum | null } }>, shipmentExportDeclarations?: Array<{ __typename?: 'ShipmentExportDeclaration', id: number, exportDeclaration: { __typename?: 'ExportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, endorsedAt: string | null, channel: ChannelExportDeclarationTypeEnum | null, status: ExportDeclarationStatusEnum | null } }>, shipmentImportDeclarations?: Array<{ __typename?: 'ShipmentImportDeclaration', id: number, importDeclaration: { __typename?: 'ImportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: ImportDeclarationStatusEnum | null } }>, shipmentImportLicenses?: Array<{ __typename?: 'ShipmentImportLicense', id: number, importLicense: { __typename?: 'ImportLicense', id: number, number: string, registeredAt: string | null, approvedAt: string | null, status: ImportLicenseStatusEnum | null } }>, invoices: Array<{ __typename?: 'Invoice', id: number, number: string, emittedAt: string, incoterm: IncotermTypeEnum, totalAmount: string, discount: string | null, finalValue: string, totalGrossWeightKg: string, currency: { __typename?: 'Currency', code: string } | null }>, vesselScheduleDeadlineReferences: { __typename?: 'VesselScheduleDeadlineReferences', draftDeadlineReference: DeadlineDateReferenceEnum | null, vgmDeadlineReference: VgmDeadlineDateReferenceEnum | null, cargoDeadlineReference: DeadlineDateReferenceEnum | null, gateOpeningDeadlineReference: GateOpeningDeadlineDateReferenceEnum | null } | null, vesselSchedule: { __typename?: 'VesselSchedule', id: number, sealineStatusResponse: VesselScheduleStatusResponseEnum, portTerminalStatusResponse: VesselScheduleStatusResponseEnum, deadlineDates?: { __typename?: 'VesselScheduleDeadlineDates', draftDeadline: string | null, cargoDeadline: string | null, vgmDeadline: string | null, gateOpeningDeadline: string | null } | null } | null };

export type ProcessesDataFragment = { __typename?: 'Process', id: number, leadTimeDatetimeReference: string | null, referenceCode: string, alertLevel: AlertLevelEnum, extraFields: any | null, canceledAt: string | null, finishedAt: string | null, insertedAt: string, leadTime?: { __typename?: 'LeadTime', conclusionDate: string | null, startDate: string | null, plannedConclusionDate: string, deviationPercentage: string | null, differenceHours: number | null, isRealized: boolean, status: LeadTimeStatusEnum | null } | null, plannedLeadTime: { __typename?: 'PlannedLeadTime', id: number, name: string, leadTimeModel: { __typename?: 'LeadTimeModel', id: number, ignoreTime: boolean } } | null, automationProcesses: Array<{ __typename?: 'AutomationProcess', id: number, automation: { __typename?: 'Automation', id: number, name: string } }>, operation: { __typename?: 'Operation', id: number, title: string, subType: OperationSubTypeEnum }, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, documents?: Array<{ __typename?: 'Document', id: number, type: DocumentTypeEnum, brazilianInvoiceInfo?: { __typename?: 'BrazilianInvoice', emittedAt: string, number: string, accessKey: string, tax: { __typename?: 'BrazilianInvoiceTax', totalAmount: string }, transport: { __typename?: 'BrazilianInvoiceTransport', grossWeight: string | null } } | null }>, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }>, ownerHandler: { __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } } | null, orders: Array<{ __typename?: 'Order', id: number, referenceCode: string, externalReferenceCode: string | null, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }> }> };

export type ItemsDataFragment = { __typename?: 'ForeignTradeShipment', id: number, items: Array<{ __typename?: 'ForeignTradeItemShipment', id: number, quantity: string | null, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, balance: string | null, quantity: string | null, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }> } } | null, salesOrderItem: { __typename?: 'SalesOrderItem', id: number, balance: string | null, quantity: string | null, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }> } } | null }> };

export type GetProcessesTableRowsQueryVariables = Exact<{
  pagination?: InputMaybe<ProcessPaginationParams>;
  filters?: InputMaybe<FilterProcessParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  includeDocuments: Scalars['Boolean']['input'];
  includeProcessLeadTime: Scalars['Boolean']['input'];
  includeProcessBrazilianInvoiceInfo: Scalars['Boolean']['input'];
  includeVesselScheduleCalculatedDates: Scalars['Boolean']['input'];
  includeShipmentDuimps: Scalars['Boolean']['input'];
  includeShipmentExportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportLicenses: Scalars['Boolean']['input'];
  includeContainers: Scalars['Boolean']['input'];
  includeDemurrageAny: Scalars['Boolean']['input'];
  includeDemurrage: Scalars['Boolean']['input'];
  includeDemurrageCalculations: Scalars['Boolean']['input'];
}>;


export type GetProcessesTableRowsQuery = { __typename?: 'RootQueryType', processesCount: number, processes: Array<{ __typename?: 'Process', id: number, leadTimeDatetimeReference: string | null, referenceCode: string, alertLevel: AlertLevelEnum, extraFields: any | null, canceledAt: string | null, finishedAt: string | null, insertedAt: string, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, type: ShipmentTypeEnum | null, ata: string | null, atd: string | null, eta: string | null, etd: string | null, deliveredAt: string | null, receivedInWarehouseAt: string | null, departedFromWarehouseAt: string | null, totalNetWeight: string | null, totalGrossWeight: string | null, cubageCubicMeters: string | null, automaticTrackingEnabled: boolean, statusResponse: StatusResponseTypeEnum, ceMercanteData: { __typename?: 'CeMercanteData', id: number, number: string, issuedAt: string | null, cargoStatus: string | null, hasDta: boolean | null, manifestArrivalAt: string | null, cargoPresenceInPrimaryZoneAt: string | null, cargoPresenceInSecondaryZoneAt: string | null, customsPlace: string | null, bl: string | null, cargoPresenceHistory: Array<{ __typename?: 'CeMercanteDataCargoPresenceHistory', ra: string | null, status: string | null, date: string | null, dtaNumber: string | null, syncedAt: string | null }>, containerSeals: Array<{ __typename?: 'CeMercanteDataContainerSeal', containerCode: string | null, sealCode: string | null, secondarySealCode: string | null }>, originPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, destinationPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null } | null, parcelShipments: Array<{ __typename?: 'ParcelShipment', id: number, trackingNumber: string, slug: string }>, internationalFreight: { __typename?: 'InternationalFreight', id: number, cargoAttributes: Array<CargoAttributeEnum>, expectedSeparationAt: string | null, pickupLocation: string | null, freightForwarder: string | null, quotationNumber: string | null, plannedBoardingDate: string | null, freightCostPrepaid: string | null, freightCostCollect: string | null, freightCostRoad: string | null, freightCostTotal: string | null, type: InternationalFreightTypeEnum | null, bookingEta: string | null, bookingEtd: string | null, voyageNumber: string | null, currency: { __typename?: 'Currency', name: string, code: string } | null, sealine: { __typename?: 'Sealine', id: number, name: string, logoUrl: string | null } | null, bookingLoadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingDischargeAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingLoadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } | null, portTerminal: { __typename?: 'PortTerminal', id: number, name: string } | null } | null, airTransportShipment: { __typename?: 'AirTransportShipment', awb: string | null, hawb: string | null, id: number, type: AirTransportTypeEnum | null, destinationAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, originAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, airline: { __typename?: 'Airline', id: number, name: string } | null } | null, demurrage?: { __typename?: 'Demurrage', id: number, dailyRateUsd?: string | null, freeTime?: number | null, calculations?: { __typename?: 'DemurrageCalculations', totalExceedingDays: number, totalEstimatedCosts: string, totalDaysPaid: number, totalDaysToPay: number, averageCostPerDayUsd: string, totalOwedUsd: string, totalPaidUsd: string, totalToPayUsd: string } } | null, maritimeTransportShipment: { __typename?: 'MaritimeTransportShipment', id: number, type: MaritimeTransportTypeEnum | null, bl: string | null, booking: string | null, hbl: string | null, trackingNumber: string | null, trackingLoadingPort: string | null, trackingDischargePort: string | null, voyageNumber: string | null, trackingKey: TrackingKeyEnum | null, sealine: { __typename?: 'Sealine', id: number, logoUrl: string | null, name: string } | null, vessel: { __typename?: 'Vessel', id: number, name: string } | null, loadingPort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null, dischargePort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null } | null, roadTransportShipment: { __typename?: 'ForeignTradeRoadTransportShipment', id: number, type: ForeignTradeRoadTransportTypeEnum | null, crt: string | null, origin: string | null, destination: string | null } | null, route: { __typename?: 'Route', id: number, name: string } | null, shipmentDuimps?: Array<{ __typename?: 'ShipmentDuimp', id: number, duimp: { __typename?: 'Duimp', id: number, number: string, registeredAt: string | null, deliveredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: DuimpStatusEnum | null } }>, shipmentExportDeclarations?: Array<{ __typename?: 'ShipmentExportDeclaration', id: number, exportDeclaration: { __typename?: 'ExportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, endorsedAt: string | null, channel: ChannelExportDeclarationTypeEnum | null, status: ExportDeclarationStatusEnum | null } }>, shipmentImportDeclarations?: Array<{ __typename?: 'ShipmentImportDeclaration', id: number, importDeclaration: { __typename?: 'ImportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: ImportDeclarationStatusEnum | null } }>, shipmentImportLicenses?: Array<{ __typename?: 'ShipmentImportLicense', id: number, importLicense: { __typename?: 'ImportLicense', id: number, number: string, registeredAt: string | null, approvedAt: string | null, status: ImportLicenseStatusEnum | null } }>, invoices: Array<{ __typename?: 'Invoice', id: number, number: string, emittedAt: string, incoterm: IncotermTypeEnum, totalAmount: string, discount: string | null, finalValue: string, totalGrossWeightKg: string, currency: { __typename?: 'Currency', code: string } | null }>, vesselScheduleDeadlineReferences: { __typename?: 'VesselScheduleDeadlineReferences', draftDeadlineReference: DeadlineDateReferenceEnum | null, vgmDeadlineReference: VgmDeadlineDateReferenceEnum | null, cargoDeadlineReference: DeadlineDateReferenceEnum | null, gateOpeningDeadlineReference: GateOpeningDeadlineDateReferenceEnum | null } | null, vesselSchedule: { __typename?: 'VesselSchedule', id: number, sealineStatusResponse: VesselScheduleStatusResponseEnum, portTerminalStatusResponse: VesselScheduleStatusResponseEnum, deadlineDates?: { __typename?: 'VesselScheduleDeadlineDates', draftDeadline: string | null, cargoDeadline: string | null, vgmDeadline: string | null, gateOpeningDeadline: string | null } | null } | null, items: Array<{ __typename?: 'ForeignTradeItemShipment', id: number, quantity: string | null, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, balance: string | null, quantity: string | null, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }> } } | null, salesOrderItem: { __typename?: 'SalesOrderItem', id: number, balance: string | null, quantity: string | null, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }> } } | null }>, nationalRoadTransports: Array<{ __typename?: 'NationalRoadTransport', id: number, collectionScheduledAt: string | null, deliveryPlannedAt: string | null, loadType: LoadTypeEnum | null, roadTransportType: RoadTransportTypeEnum | null, transportFeatures: Array<TransportFeatureEnum>, releasedForTransportAt: string | null, transportCompletedAt: string | null, legSlug: string, route: { __typename?: 'Route', id: number, name: string } | null, nationalRoadCarrier: { __typename?: 'Handler', id: number, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null } } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, driverName: string | null, vehiclePlate: string | null, trailerPlate: string | null, driver: { __typename?: 'Driver', id: number, name: string } | null, vehicle: { __typename?: 'Vehicle', id: number, plate: string } | null, trailer: { __typename?: 'Trailer', id: number, plate: string } | null, transportables: Array<{ __typename?: 'Transportable', id: number, container: { __typename?: 'Container', id: number, code: string | null } | null }> }> }>, transportables?: Array<{ __typename?: 'Transportable', id: number, type: TransportableTypeEnum, container: { __typename?: 'Container', id: number, code: string | null } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, phases: Array<{ __typename?: 'RoadTransportTripPhase', id: number, realizedAt: string | null, routePoint: { __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum } }> }> }> } | null, leadTime?: { __typename?: 'LeadTime', conclusionDate: string | null, startDate: string | null, plannedConclusionDate: string, deviationPercentage: string | null, differenceHours: number | null, isRealized: boolean, status: LeadTimeStatusEnum | null } | null, plannedLeadTime: { __typename?: 'PlannedLeadTime', id: number, name: string, leadTimeModel: { __typename?: 'LeadTimeModel', id: number, ignoreTime: boolean } } | null, automationProcesses: Array<{ __typename?: 'AutomationProcess', id: number, automation: { __typename?: 'Automation', id: number, name: string } }>, operation: { __typename?: 'Operation', id: number, title: string, subType: OperationSubTypeEnum }, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, documents?: Array<{ __typename?: 'Document', id: number, type: DocumentTypeEnum, brazilianInvoiceInfo?: { __typename?: 'BrazilianInvoice', emittedAt: string, number: string, accessKey: string, tax: { __typename?: 'BrazilianInvoiceTax', totalAmount: string }, transport: { __typename?: 'BrazilianInvoiceTransport', grossWeight: string | null } } | null }>, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }>, ownerHandler: { __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } } | null, orders: Array<{ __typename?: 'Order', id: number, referenceCode: string, externalReferenceCode: string | null, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }> }> }> };

export type GetRoadTransportTripTableRowsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FilterRoadTransportTripParams>;
  pagination?: InputMaybe<RoadTransportTripPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  includeDocuments: Scalars['Boolean']['input'];
  includeProcessLeadTime: Scalars['Boolean']['input'];
  includeProcessBrazilianInvoiceInfo: Scalars['Boolean']['input'];
  includeVesselScheduleCalculatedDates: Scalars['Boolean']['input'];
  includeShipmentDuimps: Scalars['Boolean']['input'];
  includeShipmentExportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportLicenses: Scalars['Boolean']['input'];
  includeDemurrageAny: Scalars['Boolean']['input'];
  includeDemurrage: Scalars['Boolean']['input'];
  includeDemurrageCalculations: Scalars['Boolean']['input'];
}>;


export type GetRoadTransportTripTableRowsQuery = { __typename?: 'RootQueryType', nationalRoadTransportTripsPerProcessesCount: number | null, nationalRoadTransportTripsPerProcesses: Array<{ __typename?: 'RoadTransportTripPerProcess', roadTransportTrip: { __typename?: 'RoadTransportTrip', id: number, driverName: string | null, trailerPlate: string | null, vehiclePlate: string | null, transportables: Array<{ __typename?: 'Transportable', id: number, container: { __typename?: 'Container', id: number, code: string | null } | null }>, driver: { __typename?: 'Driver', id: number, name: string } | null, trailer: { __typename?: 'Trailer', id: number, plate: string } | null, vehicle: { __typename?: 'Vehicle', id: number, plate: string } | null, phases: Array<{ __typename?: 'RoadTransportTripPhase', id: number, departureAt: string | null, estimatedRealizedAt: string | null, realizedAt: string | null, routePoint: { __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum } }>, nationalRoadTransport: { __typename?: 'NationalRoadTransport', id: number, legSlug: string, collectionScheduledAt: string | null, deliveryPlannedAt: string | null, loadType: LoadTypeEnum | null, roadTransportType: RoadTransportTypeEnum | null, transportFeatures: Array<TransportFeatureEnum>, releasedForTransportAt: string | null, transportCompletedAt: string | null, route: { __typename?: 'Route', id: number, name: string } | null, nationalRoadCarrier: { __typename?: 'Handler', id: number, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null } } | null } }, process: { __typename?: 'Process', id: number, leadTimeDatetimeReference: string | null, referenceCode: string, alertLevel: AlertLevelEnum, extraFields: any | null, canceledAt: string | null, finishedAt: string | null, insertedAt: string, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, type: ShipmentTypeEnum | null, ata: string | null, atd: string | null, eta: string | null, etd: string | null, deliveredAt: string | null, receivedInWarehouseAt: string | null, departedFromWarehouseAt: string | null, totalNetWeight: string | null, totalGrossWeight: string | null, cubageCubicMeters: string | null, automaticTrackingEnabled: boolean, statusResponse: StatusResponseTypeEnum, ceMercanteData: { __typename?: 'CeMercanteData', id: number, number: string, issuedAt: string | null, cargoStatus: string | null, hasDta: boolean | null, manifestArrivalAt: string | null, cargoPresenceInPrimaryZoneAt: string | null, cargoPresenceInSecondaryZoneAt: string | null, customsPlace: string | null, bl: string | null, cargoPresenceHistory: Array<{ __typename?: 'CeMercanteDataCargoPresenceHistory', ra: string | null, status: string | null, date: string | null, dtaNumber: string | null, syncedAt: string | null }>, containerSeals: Array<{ __typename?: 'CeMercanteDataContainerSeal', containerCode: string | null, sealCode: string | null, secondarySealCode: string | null }>, originPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, destinationPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null } | null, parcelShipments: Array<{ __typename?: 'ParcelShipment', id: number, trackingNumber: string, slug: string }>, internationalFreight: { __typename?: 'InternationalFreight', id: number, cargoAttributes: Array<CargoAttributeEnum>, expectedSeparationAt: string | null, pickupLocation: string | null, freightForwarder: string | null, quotationNumber: string | null, plannedBoardingDate: string | null, freightCostPrepaid: string | null, freightCostCollect: string | null, freightCostRoad: string | null, freightCostTotal: string | null, type: InternationalFreightTypeEnum | null, bookingEta: string | null, bookingEtd: string | null, voyageNumber: string | null, currency: { __typename?: 'Currency', name: string, code: string } | null, sealine: { __typename?: 'Sealine', id: number, name: string, logoUrl: string | null } | null, bookingLoadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingDischargeAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingLoadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } | null, portTerminal: { __typename?: 'PortTerminal', id: number, name: string } | null } | null, airTransportShipment: { __typename?: 'AirTransportShipment', awb: string | null, hawb: string | null, id: number, type: AirTransportTypeEnum | null, destinationAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, originAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, airline: { __typename?: 'Airline', id: number, name: string } | null } | null, demurrage?: { __typename?: 'Demurrage', id: number, dailyRateUsd?: string | null, freeTime?: number | null, calculations?: { __typename?: 'DemurrageCalculations', totalExceedingDays: number, totalEstimatedCosts: string, totalDaysPaid: number, totalDaysToPay: number, averageCostPerDayUsd: string, totalOwedUsd: string, totalPaidUsd: string, totalToPayUsd: string } } | null, maritimeTransportShipment: { __typename?: 'MaritimeTransportShipment', id: number, type: MaritimeTransportTypeEnum | null, bl: string | null, booking: string | null, hbl: string | null, trackingNumber: string | null, trackingLoadingPort: string | null, trackingDischargePort: string | null, voyageNumber: string | null, trackingKey: TrackingKeyEnum | null, sealine: { __typename?: 'Sealine', id: number, logoUrl: string | null, name: string } | null, vessel: { __typename?: 'Vessel', id: number, name: string } | null, loadingPort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null, dischargePort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null } | null, roadTransportShipment: { __typename?: 'ForeignTradeRoadTransportShipment', id: number, type: ForeignTradeRoadTransportTypeEnum | null, crt: string | null, origin: string | null, destination: string | null } | null, route: { __typename?: 'Route', id: number, name: string } | null, shipmentDuimps?: Array<{ __typename?: 'ShipmentDuimp', id: number, duimp: { __typename?: 'Duimp', id: number, number: string, registeredAt: string | null, deliveredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: DuimpStatusEnum | null } }>, shipmentExportDeclarations?: Array<{ __typename?: 'ShipmentExportDeclaration', id: number, exportDeclaration: { __typename?: 'ExportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, endorsedAt: string | null, channel: ChannelExportDeclarationTypeEnum | null, status: ExportDeclarationStatusEnum | null } }>, shipmentImportDeclarations?: Array<{ __typename?: 'ShipmentImportDeclaration', id: number, importDeclaration: { __typename?: 'ImportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: ImportDeclarationStatusEnum | null } }>, shipmentImportLicenses?: Array<{ __typename?: 'ShipmentImportLicense', id: number, importLicense: { __typename?: 'ImportLicense', id: number, number: string, registeredAt: string | null, approvedAt: string | null, status: ImportLicenseStatusEnum | null } }>, invoices: Array<{ __typename?: 'Invoice', id: number, number: string, emittedAt: string, incoterm: IncotermTypeEnum, totalAmount: string, discount: string | null, finalValue: string, totalGrossWeightKg: string, currency: { __typename?: 'Currency', code: string } | null }>, vesselScheduleDeadlineReferences: { __typename?: 'VesselScheduleDeadlineReferences', draftDeadlineReference: DeadlineDateReferenceEnum | null, vgmDeadlineReference: VgmDeadlineDateReferenceEnum | null, cargoDeadlineReference: DeadlineDateReferenceEnum | null, gateOpeningDeadlineReference: GateOpeningDeadlineDateReferenceEnum | null } | null, vesselSchedule: { __typename?: 'VesselSchedule', id: number, sealineStatusResponse: VesselScheduleStatusResponseEnum, portTerminalStatusResponse: VesselScheduleStatusResponseEnum, deadlineDates?: { __typename?: 'VesselScheduleDeadlineDates', draftDeadline: string | null, cargoDeadline: string | null, vgmDeadline: string | null, gateOpeningDeadline: string | null } | null } | null, items: Array<{ __typename?: 'ForeignTradeItemShipment', id: number, quantity: string | null, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, balance: string | null, quantity: string | null, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }> } } | null, salesOrderItem: { __typename?: 'SalesOrderItem', id: number, balance: string | null, quantity: string | null, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }> } } | null }> } | null, leadTime?: { __typename?: 'LeadTime', conclusionDate: string | null, startDate: string | null, plannedConclusionDate: string, deviationPercentage: string | null, differenceHours: number | null, isRealized: boolean, status: LeadTimeStatusEnum | null } | null, plannedLeadTime: { __typename?: 'PlannedLeadTime', id: number, name: string, leadTimeModel: { __typename?: 'LeadTimeModel', id: number, ignoreTime: boolean } } | null, automationProcesses: Array<{ __typename?: 'AutomationProcess', id: number, automation: { __typename?: 'Automation', id: number, name: string } }>, operation: { __typename?: 'Operation', id: number, title: string, subType: OperationSubTypeEnum }, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, documents?: Array<{ __typename?: 'Document', id: number, type: DocumentTypeEnum, brazilianInvoiceInfo?: { __typename?: 'BrazilianInvoice', emittedAt: string, number: string, accessKey: string, tax: { __typename?: 'BrazilianInvoiceTax', totalAmount: string }, transport: { __typename?: 'BrazilianInvoiceTransport', grossWeight: string | null } } | null }>, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }>, ownerHandler: { __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } } | null, orders: Array<{ __typename?: 'Order', id: number, referenceCode: string, externalReferenceCode: string | null, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }> }> } }> };

export type GetShipmentExportDeclarationsTableRowsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filters: FilterShipmentExportDeclarationParams;
  pagination?: InputMaybe<ShipmentExportDeclarationPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  includeDocuments: Scalars['Boolean']['input'];
  includeProcessLeadTime: Scalars['Boolean']['input'];
  includeProcessBrazilianInvoiceInfo: Scalars['Boolean']['input'];
  includeVesselScheduleCalculatedDates: Scalars['Boolean']['input'];
  includeShipmentDuimps: Scalars['Boolean']['input'];
  includeShipmentExportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportLicenses: Scalars['Boolean']['input'];
  includeContainers: Scalars['Boolean']['input'];
  includeDemurrageAny: Scalars['Boolean']['input'];
  includeDemurrage: Scalars['Boolean']['input'];
  includeDemurrageCalculations: Scalars['Boolean']['input'];
}>;


export type GetShipmentExportDeclarationsTableRowsQuery = { __typename?: 'RootQueryType', shipmentExportDeclarationsPerProcessesCount: number, shipmentExportDeclarationsPerProcesses: Array<{ __typename?: 'ShipmentExportDeclarationPerProcess', shipmentExportDeclaration: { __typename?: 'ShipmentExportDeclaration', id: number, exportDeclaration: { __typename?: 'ExportDeclaration', id: number, status: ExportDeclarationStatusEnum | null, statusResponse: StatusResponseTypeEnum, channel: ChannelExportDeclarationTypeEnum | null, number: string, registeredAt: string | null, customsClearedAt: string | null, endorsedAt: string | null } }, process: { __typename?: 'Process', id: number, leadTimeDatetimeReference: string | null, referenceCode: string, alertLevel: AlertLevelEnum, extraFields: any | null, canceledAt: string | null, finishedAt: string | null, insertedAt: string, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, type: ShipmentTypeEnum | null, ata: string | null, atd: string | null, eta: string | null, etd: string | null, deliveredAt: string | null, receivedInWarehouseAt: string | null, departedFromWarehouseAt: string | null, totalNetWeight: string | null, totalGrossWeight: string | null, cubageCubicMeters: string | null, automaticTrackingEnabled: boolean, statusResponse: StatusResponseTypeEnum, ceMercanteData: { __typename?: 'CeMercanteData', id: number, number: string, issuedAt: string | null, cargoStatus: string | null, hasDta: boolean | null, manifestArrivalAt: string | null, cargoPresenceInPrimaryZoneAt: string | null, cargoPresenceInSecondaryZoneAt: string | null, customsPlace: string | null, bl: string | null, cargoPresenceHistory: Array<{ __typename?: 'CeMercanteDataCargoPresenceHistory', ra: string | null, status: string | null, date: string | null, dtaNumber: string | null, syncedAt: string | null }>, containerSeals: Array<{ __typename?: 'CeMercanteDataContainerSeal', containerCode: string | null, sealCode: string | null, secondarySealCode: string | null }>, originPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, destinationPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null } | null, parcelShipments: Array<{ __typename?: 'ParcelShipment', id: number, trackingNumber: string, slug: string }>, internationalFreight: { __typename?: 'InternationalFreight', id: number, cargoAttributes: Array<CargoAttributeEnum>, expectedSeparationAt: string | null, pickupLocation: string | null, freightForwarder: string | null, quotationNumber: string | null, plannedBoardingDate: string | null, freightCostPrepaid: string | null, freightCostCollect: string | null, freightCostRoad: string | null, freightCostTotal: string | null, type: InternationalFreightTypeEnum | null, bookingEta: string | null, bookingEtd: string | null, voyageNumber: string | null, currency: { __typename?: 'Currency', name: string, code: string } | null, sealine: { __typename?: 'Sealine', id: number, name: string, logoUrl: string | null } | null, bookingLoadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingDischargeAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingLoadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } | null, portTerminal: { __typename?: 'PortTerminal', id: number, name: string } | null } | null, airTransportShipment: { __typename?: 'AirTransportShipment', awb: string | null, hawb: string | null, id: number, type: AirTransportTypeEnum | null, destinationAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, originAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, airline: { __typename?: 'Airline', id: number, name: string } | null } | null, demurrage?: { __typename?: 'Demurrage', id: number, dailyRateUsd?: string | null, freeTime?: number | null, calculations?: { __typename?: 'DemurrageCalculations', totalExceedingDays: number, totalEstimatedCosts: string, totalDaysPaid: number, totalDaysToPay: number, averageCostPerDayUsd: string, totalOwedUsd: string, totalPaidUsd: string, totalToPayUsd: string } } | null, maritimeTransportShipment: { __typename?: 'MaritimeTransportShipment', id: number, type: MaritimeTransportTypeEnum | null, bl: string | null, booking: string | null, hbl: string | null, trackingNumber: string | null, trackingLoadingPort: string | null, trackingDischargePort: string | null, voyageNumber: string | null, trackingKey: TrackingKeyEnum | null, sealine: { __typename?: 'Sealine', id: number, logoUrl: string | null, name: string } | null, vessel: { __typename?: 'Vessel', id: number, name: string } | null, loadingPort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null, dischargePort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null } | null, roadTransportShipment: { __typename?: 'ForeignTradeRoadTransportShipment', id: number, type: ForeignTradeRoadTransportTypeEnum | null, crt: string | null, origin: string | null, destination: string | null } | null, route: { __typename?: 'Route', id: number, name: string } | null, shipmentDuimps?: Array<{ __typename?: 'ShipmentDuimp', id: number, duimp: { __typename?: 'Duimp', id: number, number: string, registeredAt: string | null, deliveredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: DuimpStatusEnum | null } }>, shipmentExportDeclarations?: Array<{ __typename?: 'ShipmentExportDeclaration', id: number, exportDeclaration: { __typename?: 'ExportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, endorsedAt: string | null, channel: ChannelExportDeclarationTypeEnum | null, status: ExportDeclarationStatusEnum | null } }>, shipmentImportDeclarations?: Array<{ __typename?: 'ShipmentImportDeclaration', id: number, importDeclaration: { __typename?: 'ImportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: ImportDeclarationStatusEnum | null } }>, shipmentImportLicenses?: Array<{ __typename?: 'ShipmentImportLicense', id: number, importLicense: { __typename?: 'ImportLicense', id: number, number: string, registeredAt: string | null, approvedAt: string | null, status: ImportLicenseStatusEnum | null } }>, invoices: Array<{ __typename?: 'Invoice', id: number, number: string, emittedAt: string, incoterm: IncotermTypeEnum, totalAmount: string, discount: string | null, finalValue: string, totalGrossWeightKg: string, currency: { __typename?: 'Currency', code: string } | null }>, vesselScheduleDeadlineReferences: { __typename?: 'VesselScheduleDeadlineReferences', draftDeadlineReference: DeadlineDateReferenceEnum | null, vgmDeadlineReference: VgmDeadlineDateReferenceEnum | null, cargoDeadlineReference: DeadlineDateReferenceEnum | null, gateOpeningDeadlineReference: GateOpeningDeadlineDateReferenceEnum | null } | null, vesselSchedule: { __typename?: 'VesselSchedule', id: number, sealineStatusResponse: VesselScheduleStatusResponseEnum, portTerminalStatusResponse: VesselScheduleStatusResponseEnum, deadlineDates?: { __typename?: 'VesselScheduleDeadlineDates', draftDeadline: string | null, cargoDeadline: string | null, vgmDeadline: string | null, gateOpeningDeadline: string | null } | null } | null, nationalRoadTransports: Array<{ __typename?: 'NationalRoadTransport', id: number, collectionScheduledAt: string | null, deliveryPlannedAt: string | null, loadType: LoadTypeEnum | null, roadTransportType: RoadTransportTypeEnum | null, transportFeatures: Array<TransportFeatureEnum>, releasedForTransportAt: string | null, transportCompletedAt: string | null, legSlug: string, route: { __typename?: 'Route', id: number, name: string } | null, nationalRoadCarrier: { __typename?: 'Handler', id: number, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null } } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, driverName: string | null, vehiclePlate: string | null, trailerPlate: string | null, driver: { __typename?: 'Driver', id: number, name: string } | null, vehicle: { __typename?: 'Vehicle', id: number, plate: string } | null, trailer: { __typename?: 'Trailer', id: number, plate: string } | null, transportables: Array<{ __typename?: 'Transportable', id: number, container: { __typename?: 'Container', id: number, code: string | null } | null }> }> }>, transportables?: Array<{ __typename?: 'Transportable', id: number, type: TransportableTypeEnum, container: { __typename?: 'Container', id: number, code: string | null } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, phases: Array<{ __typename?: 'RoadTransportTripPhase', id: number, realizedAt: string | null, routePoint: { __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum } }> }> }>, items: Array<{ __typename?: 'ForeignTradeItemShipment', id: number, quantity: string | null, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, balance: string | null, quantity: string | null, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }> } } | null, salesOrderItem: { __typename?: 'SalesOrderItem', id: number, balance: string | null, quantity: string | null, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }> } } | null }> } | null, leadTime?: { __typename?: 'LeadTime', conclusionDate: string | null, startDate: string | null, plannedConclusionDate: string, deviationPercentage: string | null, differenceHours: number | null, isRealized: boolean, status: LeadTimeStatusEnum | null } | null, plannedLeadTime: { __typename?: 'PlannedLeadTime', id: number, name: string, leadTimeModel: { __typename?: 'LeadTimeModel', id: number, ignoreTime: boolean } } | null, automationProcesses: Array<{ __typename?: 'AutomationProcess', id: number, automation: { __typename?: 'Automation', id: number, name: string } }>, operation: { __typename?: 'Operation', id: number, title: string, subType: OperationSubTypeEnum }, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, documents?: Array<{ __typename?: 'Document', id: number, type: DocumentTypeEnum, brazilianInvoiceInfo?: { __typename?: 'BrazilianInvoice', emittedAt: string, number: string, accessKey: string, tax: { __typename?: 'BrazilianInvoiceTax', totalAmount: string }, transport: { __typename?: 'BrazilianInvoiceTransport', grossWeight: string | null } } | null }>, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }>, ownerHandler: { __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } } | null, orders: Array<{ __typename?: 'Order', id: number, referenceCode: string, externalReferenceCode: string | null, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }> }> } }> };

export type GetShipmentImportDeclarationsTableRowsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filters: FilterShipmentImportDeclarationParams;
  pagination?: InputMaybe<ShipmentImportDeclarationPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  includeDocuments: Scalars['Boolean']['input'];
  includeProcessLeadTime: Scalars['Boolean']['input'];
  includeProcessBrazilianInvoiceInfo: Scalars['Boolean']['input'];
  includeVesselScheduleCalculatedDates: Scalars['Boolean']['input'];
  includeShipmentDuimps: Scalars['Boolean']['input'];
  includeShipmentExportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportLicenses: Scalars['Boolean']['input'];
  includeContainers: Scalars['Boolean']['input'];
  includeDemurrageAny: Scalars['Boolean']['input'];
  includeDemurrage: Scalars['Boolean']['input'];
  includeDemurrageCalculations: Scalars['Boolean']['input'];
}>;


export type GetShipmentImportDeclarationsTableRowsQuery = { __typename?: 'RootQueryType', shipmentImportDeclarationsPerProcessesCount: number, shipmentImportDeclarationsPerProcesses: Array<{ __typename?: 'ShipmentImportDeclarationPerProcess', shipmentImportDeclaration: { __typename?: 'ShipmentImportDeclaration', id: number, importDeclaration: { __typename?: 'ImportDeclaration', id: number, status: ImportDeclarationStatusEnum | null, statusResponse: StatusResponseTypeEnum, channel: ChannelTypeEnum | null, number: string, registeredAt: string | null, customsClearedAt: string | null } }, process: { __typename?: 'Process', id: number, leadTimeDatetimeReference: string | null, referenceCode: string, alertLevel: AlertLevelEnum, extraFields: any | null, canceledAt: string | null, finishedAt: string | null, insertedAt: string, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, type: ShipmentTypeEnum | null, ata: string | null, atd: string | null, eta: string | null, etd: string | null, deliveredAt: string | null, receivedInWarehouseAt: string | null, departedFromWarehouseAt: string | null, totalNetWeight: string | null, totalGrossWeight: string | null, cubageCubicMeters: string | null, automaticTrackingEnabled: boolean, statusResponse: StatusResponseTypeEnum, ceMercanteData: { __typename?: 'CeMercanteData', id: number, number: string, issuedAt: string | null, cargoStatus: string | null, hasDta: boolean | null, manifestArrivalAt: string | null, cargoPresenceInPrimaryZoneAt: string | null, cargoPresenceInSecondaryZoneAt: string | null, customsPlace: string | null, bl: string | null, cargoPresenceHistory: Array<{ __typename?: 'CeMercanteDataCargoPresenceHistory', ra: string | null, status: string | null, date: string | null, dtaNumber: string | null, syncedAt: string | null }>, containerSeals: Array<{ __typename?: 'CeMercanteDataContainerSeal', containerCode: string | null, sealCode: string | null, secondarySealCode: string | null }>, originPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, destinationPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null } | null, parcelShipments: Array<{ __typename?: 'ParcelShipment', id: number, trackingNumber: string, slug: string }>, internationalFreight: { __typename?: 'InternationalFreight', id: number, cargoAttributes: Array<CargoAttributeEnum>, expectedSeparationAt: string | null, pickupLocation: string | null, freightForwarder: string | null, quotationNumber: string | null, plannedBoardingDate: string | null, freightCostPrepaid: string | null, freightCostCollect: string | null, freightCostRoad: string | null, freightCostTotal: string | null, type: InternationalFreightTypeEnum | null, bookingEta: string | null, bookingEtd: string | null, voyageNumber: string | null, currency: { __typename?: 'Currency', name: string, code: string } | null, sealine: { __typename?: 'Sealine', id: number, name: string, logoUrl: string | null } | null, bookingLoadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingDischargeAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingLoadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } | null, portTerminal: { __typename?: 'PortTerminal', id: number, name: string } | null } | null, airTransportShipment: { __typename?: 'AirTransportShipment', awb: string | null, hawb: string | null, id: number, type: AirTransportTypeEnum | null, destinationAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, originAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, airline: { __typename?: 'Airline', id: number, name: string } | null } | null, demurrage?: { __typename?: 'Demurrage', id: number, dailyRateUsd?: string | null, freeTime?: number | null, calculations?: { __typename?: 'DemurrageCalculations', totalExceedingDays: number, totalEstimatedCosts: string, totalDaysPaid: number, totalDaysToPay: number, averageCostPerDayUsd: string, totalOwedUsd: string, totalPaidUsd: string, totalToPayUsd: string } } | null, maritimeTransportShipment: { __typename?: 'MaritimeTransportShipment', id: number, type: MaritimeTransportTypeEnum | null, bl: string | null, booking: string | null, hbl: string | null, trackingNumber: string | null, trackingLoadingPort: string | null, trackingDischargePort: string | null, voyageNumber: string | null, trackingKey: TrackingKeyEnum | null, sealine: { __typename?: 'Sealine', id: number, logoUrl: string | null, name: string } | null, vessel: { __typename?: 'Vessel', id: number, name: string } | null, loadingPort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null, dischargePort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null } | null, roadTransportShipment: { __typename?: 'ForeignTradeRoadTransportShipment', id: number, type: ForeignTradeRoadTransportTypeEnum | null, crt: string | null, origin: string | null, destination: string | null } | null, route: { __typename?: 'Route', id: number, name: string } | null, shipmentDuimps?: Array<{ __typename?: 'ShipmentDuimp', id: number, duimp: { __typename?: 'Duimp', id: number, number: string, registeredAt: string | null, deliveredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: DuimpStatusEnum | null } }>, shipmentExportDeclarations?: Array<{ __typename?: 'ShipmentExportDeclaration', id: number, exportDeclaration: { __typename?: 'ExportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, endorsedAt: string | null, channel: ChannelExportDeclarationTypeEnum | null, status: ExportDeclarationStatusEnum | null } }>, shipmentImportDeclarations?: Array<{ __typename?: 'ShipmentImportDeclaration', id: number, importDeclaration: { __typename?: 'ImportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: ImportDeclarationStatusEnum | null } }>, shipmentImportLicenses?: Array<{ __typename?: 'ShipmentImportLicense', id: number, importLicense: { __typename?: 'ImportLicense', id: number, number: string, registeredAt: string | null, approvedAt: string | null, status: ImportLicenseStatusEnum | null } }>, invoices: Array<{ __typename?: 'Invoice', id: number, number: string, emittedAt: string, incoterm: IncotermTypeEnum, totalAmount: string, discount: string | null, finalValue: string, totalGrossWeightKg: string, currency: { __typename?: 'Currency', code: string } | null }>, vesselScheduleDeadlineReferences: { __typename?: 'VesselScheduleDeadlineReferences', draftDeadlineReference: DeadlineDateReferenceEnum | null, vgmDeadlineReference: VgmDeadlineDateReferenceEnum | null, cargoDeadlineReference: DeadlineDateReferenceEnum | null, gateOpeningDeadlineReference: GateOpeningDeadlineDateReferenceEnum | null } | null, vesselSchedule: { __typename?: 'VesselSchedule', id: number, sealineStatusResponse: VesselScheduleStatusResponseEnum, portTerminalStatusResponse: VesselScheduleStatusResponseEnum, deadlineDates?: { __typename?: 'VesselScheduleDeadlineDates', draftDeadline: string | null, cargoDeadline: string | null, vgmDeadline: string | null, gateOpeningDeadline: string | null } | null } | null, nationalRoadTransports: Array<{ __typename?: 'NationalRoadTransport', id: number, collectionScheduledAt: string | null, deliveryPlannedAt: string | null, loadType: LoadTypeEnum | null, roadTransportType: RoadTransportTypeEnum | null, transportFeatures: Array<TransportFeatureEnum>, releasedForTransportAt: string | null, transportCompletedAt: string | null, legSlug: string, route: { __typename?: 'Route', id: number, name: string } | null, nationalRoadCarrier: { __typename?: 'Handler', id: number, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null } } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, driverName: string | null, vehiclePlate: string | null, trailerPlate: string | null, driver: { __typename?: 'Driver', id: number, name: string } | null, vehicle: { __typename?: 'Vehicle', id: number, plate: string } | null, trailer: { __typename?: 'Trailer', id: number, plate: string } | null, transportables: Array<{ __typename?: 'Transportable', id: number, container: { __typename?: 'Container', id: number, code: string | null } | null }> }> }>, transportables?: Array<{ __typename?: 'Transportable', id: number, type: TransportableTypeEnum, container: { __typename?: 'Container', id: number, code: string | null } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, phases: Array<{ __typename?: 'RoadTransportTripPhase', id: number, realizedAt: string | null, routePoint: { __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum } }> }> }>, items: Array<{ __typename?: 'ForeignTradeItemShipment', id: number, quantity: string | null, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, balance: string | null, quantity: string | null, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }> } } | null, salesOrderItem: { __typename?: 'SalesOrderItem', id: number, balance: string | null, quantity: string | null, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }> } } | null }> } | null, leadTime?: { __typename?: 'LeadTime', conclusionDate: string | null, startDate: string | null, plannedConclusionDate: string, deviationPercentage: string | null, differenceHours: number | null, isRealized: boolean, status: LeadTimeStatusEnum | null } | null, plannedLeadTime: { __typename?: 'PlannedLeadTime', id: number, name: string, leadTimeModel: { __typename?: 'LeadTimeModel', id: number, ignoreTime: boolean } } | null, automationProcesses: Array<{ __typename?: 'AutomationProcess', id: number, automation: { __typename?: 'Automation', id: number, name: string } }>, operation: { __typename?: 'Operation', id: number, title: string, subType: OperationSubTypeEnum }, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, documents?: Array<{ __typename?: 'Document', id: number, type: DocumentTypeEnum, brazilianInvoiceInfo?: { __typename?: 'BrazilianInvoice', emittedAt: string, number: string, accessKey: string, tax: { __typename?: 'BrazilianInvoiceTax', totalAmount: string }, transport: { __typename?: 'BrazilianInvoiceTransport', grossWeight: string | null } } | null }>, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }>, ownerHandler: { __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } } | null, orders: Array<{ __typename?: 'Order', id: number, referenceCode: string, externalReferenceCode: string | null, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }> }> } }> };

export type GetShipmentImportLicensesTableRowsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filters: FilterShipmentImportLicenseParams;
  pagination?: InputMaybe<ShipmentImportLicensePaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  includeDocuments: Scalars['Boolean']['input'];
  includeProcessLeadTime: Scalars['Boolean']['input'];
  includeProcessBrazilianInvoiceInfo: Scalars['Boolean']['input'];
  includeVesselScheduleCalculatedDates: Scalars['Boolean']['input'];
  includeShipmentDuimps: Scalars['Boolean']['input'];
  includeShipmentExportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportLicenses: Scalars['Boolean']['input'];
  includeContainers: Scalars['Boolean']['input'];
  includeDemurrageAny: Scalars['Boolean']['input'];
  includeDemurrage: Scalars['Boolean']['input'];
  includeDemurrageCalculations: Scalars['Boolean']['input'];
}>;


export type GetShipmentImportLicensesTableRowsQuery = { __typename?: 'RootQueryType', shipmentImportLicensesPerProcessesCount: number, shipmentImportLicensesPerProcesses: Array<{ __typename?: 'ShipmentImportLicensePerProcess', shipmentImportLicense: { __typename?: 'ShipmentImportLicense', id: number, importLicense: { __typename?: 'ImportLicense', id: number, status: ImportLicenseStatusEnum | null, statusResponse: StatusResponseTypeEnum, number: string, registeredAt: string | null, approvedAt: string | null } }, process: { __typename?: 'Process', id: number, leadTimeDatetimeReference: string | null, referenceCode: string, alertLevel: AlertLevelEnum, extraFields: any | null, canceledAt: string | null, finishedAt: string | null, insertedAt: string, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, type: ShipmentTypeEnum | null, ata: string | null, atd: string | null, eta: string | null, etd: string | null, deliveredAt: string | null, receivedInWarehouseAt: string | null, departedFromWarehouseAt: string | null, totalNetWeight: string | null, totalGrossWeight: string | null, cubageCubicMeters: string | null, automaticTrackingEnabled: boolean, statusResponse: StatusResponseTypeEnum, ceMercanteData: { __typename?: 'CeMercanteData', id: number, number: string, issuedAt: string | null, cargoStatus: string | null, hasDta: boolean | null, manifestArrivalAt: string | null, cargoPresenceInPrimaryZoneAt: string | null, cargoPresenceInSecondaryZoneAt: string | null, customsPlace: string | null, bl: string | null, cargoPresenceHistory: Array<{ __typename?: 'CeMercanteDataCargoPresenceHistory', ra: string | null, status: string | null, date: string | null, dtaNumber: string | null, syncedAt: string | null }>, containerSeals: Array<{ __typename?: 'CeMercanteDataContainerSeal', containerCode: string | null, sealCode: string | null, secondarySealCode: string | null }>, originPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, destinationPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null } | null, parcelShipments: Array<{ __typename?: 'ParcelShipment', id: number, trackingNumber: string, slug: string }>, internationalFreight: { __typename?: 'InternationalFreight', id: number, cargoAttributes: Array<CargoAttributeEnum>, expectedSeparationAt: string | null, pickupLocation: string | null, freightForwarder: string | null, quotationNumber: string | null, plannedBoardingDate: string | null, freightCostPrepaid: string | null, freightCostCollect: string | null, freightCostRoad: string | null, freightCostTotal: string | null, type: InternationalFreightTypeEnum | null, bookingEta: string | null, bookingEtd: string | null, voyageNumber: string | null, currency: { __typename?: 'Currency', name: string, code: string } | null, sealine: { __typename?: 'Sealine', id: number, name: string, logoUrl: string | null } | null, bookingLoadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingDischargeAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingLoadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } | null, portTerminal: { __typename?: 'PortTerminal', id: number, name: string } | null } | null, airTransportShipment: { __typename?: 'AirTransportShipment', awb: string | null, hawb: string | null, id: number, type: AirTransportTypeEnum | null, destinationAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, originAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, airline: { __typename?: 'Airline', id: number, name: string } | null } | null, demurrage?: { __typename?: 'Demurrage', id: number, dailyRateUsd?: string | null, freeTime?: number | null, calculations?: { __typename?: 'DemurrageCalculations', totalExceedingDays: number, totalEstimatedCosts: string, totalDaysPaid: number, totalDaysToPay: number, averageCostPerDayUsd: string, totalOwedUsd: string, totalPaidUsd: string, totalToPayUsd: string } } | null, maritimeTransportShipment: { __typename?: 'MaritimeTransportShipment', id: number, type: MaritimeTransportTypeEnum | null, bl: string | null, booking: string | null, hbl: string | null, trackingNumber: string | null, trackingLoadingPort: string | null, trackingDischargePort: string | null, voyageNumber: string | null, trackingKey: TrackingKeyEnum | null, sealine: { __typename?: 'Sealine', id: number, logoUrl: string | null, name: string } | null, vessel: { __typename?: 'Vessel', id: number, name: string } | null, loadingPort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null, dischargePort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null } | null, roadTransportShipment: { __typename?: 'ForeignTradeRoadTransportShipment', id: number, type: ForeignTradeRoadTransportTypeEnum | null, crt: string | null, origin: string | null, destination: string | null } | null, route: { __typename?: 'Route', id: number, name: string } | null, shipmentDuimps?: Array<{ __typename?: 'ShipmentDuimp', id: number, duimp: { __typename?: 'Duimp', id: number, number: string, registeredAt: string | null, deliveredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: DuimpStatusEnum | null } }>, shipmentExportDeclarations?: Array<{ __typename?: 'ShipmentExportDeclaration', id: number, exportDeclaration: { __typename?: 'ExportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, endorsedAt: string | null, channel: ChannelExportDeclarationTypeEnum | null, status: ExportDeclarationStatusEnum | null } }>, shipmentImportDeclarations?: Array<{ __typename?: 'ShipmentImportDeclaration', id: number, importDeclaration: { __typename?: 'ImportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: ImportDeclarationStatusEnum | null } }>, shipmentImportLicenses?: Array<{ __typename?: 'ShipmentImportLicense', id: number, importLicense: { __typename?: 'ImportLicense', id: number, number: string, registeredAt: string | null, approvedAt: string | null, status: ImportLicenseStatusEnum | null } }>, invoices: Array<{ __typename?: 'Invoice', id: number, number: string, emittedAt: string, incoterm: IncotermTypeEnum, totalAmount: string, discount: string | null, finalValue: string, totalGrossWeightKg: string, currency: { __typename?: 'Currency', code: string } | null }>, vesselScheduleDeadlineReferences: { __typename?: 'VesselScheduleDeadlineReferences', draftDeadlineReference: DeadlineDateReferenceEnum | null, vgmDeadlineReference: VgmDeadlineDateReferenceEnum | null, cargoDeadlineReference: DeadlineDateReferenceEnum | null, gateOpeningDeadlineReference: GateOpeningDeadlineDateReferenceEnum | null } | null, vesselSchedule: { __typename?: 'VesselSchedule', id: number, sealineStatusResponse: VesselScheduleStatusResponseEnum, portTerminalStatusResponse: VesselScheduleStatusResponseEnum, deadlineDates?: { __typename?: 'VesselScheduleDeadlineDates', draftDeadline: string | null, cargoDeadline: string | null, vgmDeadline: string | null, gateOpeningDeadline: string | null } | null } | null, nationalRoadTransports: Array<{ __typename?: 'NationalRoadTransport', id: number, collectionScheduledAt: string | null, deliveryPlannedAt: string | null, loadType: LoadTypeEnum | null, roadTransportType: RoadTransportTypeEnum | null, transportFeatures: Array<TransportFeatureEnum>, releasedForTransportAt: string | null, transportCompletedAt: string | null, legSlug: string, route: { __typename?: 'Route', id: number, name: string } | null, nationalRoadCarrier: { __typename?: 'Handler', id: number, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null } } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, driverName: string | null, vehiclePlate: string | null, trailerPlate: string | null, driver: { __typename?: 'Driver', id: number, name: string } | null, vehicle: { __typename?: 'Vehicle', id: number, plate: string } | null, trailer: { __typename?: 'Trailer', id: number, plate: string } | null, transportables: Array<{ __typename?: 'Transportable', id: number, container: { __typename?: 'Container', id: number, code: string | null } | null }> }> }>, transportables?: Array<{ __typename?: 'Transportable', id: number, type: TransportableTypeEnum, container: { __typename?: 'Container', id: number, code: string | null } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, phases: Array<{ __typename?: 'RoadTransportTripPhase', id: number, realizedAt: string | null, routePoint: { __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum } }> }> }>, items: Array<{ __typename?: 'ForeignTradeItemShipment', id: number, quantity: string | null, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, balance: string | null, quantity: string | null, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }> } } | null, salesOrderItem: { __typename?: 'SalesOrderItem', id: number, balance: string | null, quantity: string | null, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }> } } | null }> } | null, leadTime?: { __typename?: 'LeadTime', conclusionDate: string | null, startDate: string | null, plannedConclusionDate: string, deviationPercentage: string | null, differenceHours: number | null, isRealized: boolean, status: LeadTimeStatusEnum | null } | null, plannedLeadTime: { __typename?: 'PlannedLeadTime', id: number, name: string, leadTimeModel: { __typename?: 'LeadTimeModel', id: number, ignoreTime: boolean } } | null, automationProcesses: Array<{ __typename?: 'AutomationProcess', id: number, automation: { __typename?: 'Automation', id: number, name: string } }>, operation: { __typename?: 'Operation', id: number, title: string, subType: OperationSubTypeEnum }, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, documents?: Array<{ __typename?: 'Document', id: number, type: DocumentTypeEnum, brazilianInvoiceInfo?: { __typename?: 'BrazilianInvoice', emittedAt: string, number: string, accessKey: string, tax: { __typename?: 'BrazilianInvoiceTax', totalAmount: string }, transport: { __typename?: 'BrazilianInvoiceTransport', grossWeight: string | null } } | null }>, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }>, ownerHandler: { __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } } | null, orders: Array<{ __typename?: 'Order', id: number, referenceCode: string, externalReferenceCode: string | null, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }> }> } }> };

export type GetShipmentItemsTableRowsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filters: FilterShipmentItemParams;
  pagination?: InputMaybe<ShipmentItemPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  includeDocuments: Scalars['Boolean']['input'];
  includeProcessLeadTime: Scalars['Boolean']['input'];
  includeProcessBrazilianInvoiceInfo: Scalars['Boolean']['input'];
  includeVesselScheduleCalculatedDates: Scalars['Boolean']['input'];
  includeShipmentDuimps: Scalars['Boolean']['input'];
  includeShipmentExportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportLicenses: Scalars['Boolean']['input'];
  includeContainers: Scalars['Boolean']['input'];
  includeDemurrageAny: Scalars['Boolean']['input'];
  includeDemurrage: Scalars['Boolean']['input'];
  includeDemurrageCalculations: Scalars['Boolean']['input'];
}>;


export type GetShipmentItemsTableRowsQuery = { __typename?: 'RootQueryType', shipmentItemsCount: number | null, shipmentItems: Array<{ __typename?: 'ShipmentItem', foreignTradeItemShipment: { __typename?: 'ForeignTradeItemShipment', id: number, quantity: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, unitValue: string | null, brazilianInvoiceUnitValue: string | null, totalValue: string | null, transportables: Array<{ __typename?: 'Transportable', id: number, container: { __typename?: 'Container', id: number, code: string | null, actualReturnEmptyContainerAt: string | null, estimatedReturnEmptyContainerAt: string | null, invoiceNumber: string | null, sealCode: string | null, secondarySealCode: string | null, grossWeightKg: string | null, maxWeightKg: string | null, tareWeightKg: string | null, loadType: LoadTypeEnum | null, sizeFootType: ContainerSizeFootTypeEnum | null, type: ContainerTypeEnum | null, palletQuantity: number | null, demurrageDailyRateUsd: string | null, demurrageFreeTime: number | null, demurrageFreeTimeStartAt: string | null, isStackable: boolean | null, cubicMeters: string | null, dispatchNumber: string | null, transportDocument: string | null, demurrageCalculations: { __typename?: 'ContainerDemurrageCalculations', emptyReturnDeadline: string | null, estimatedCosts: string, exceedingDays: number } | null } | null }>, salesOrderItem: { __typename?: 'SalesOrderItem', id: number, productTranslatedDescription: string | null, lineNumber: number | null, lineReference: string, salesOrder: { __typename?: 'SalesOrder', id: number, order: { __typename?: 'Order', id: number, referenceCode: string } }, product: { __typename?: 'Product', id: number, code: string, translatedDescription: string | null } } | null, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, productTranslatedDescription: string | null, lineNumber: number | null, lineReference: string, purchaseOrder: { __typename?: 'PurchaseOrder', id: number, order: { __typename?: 'Order', id: number, referenceCode: string } }, product: { __typename?: 'Product', id: number, code: string, translatedDescription: string | null } } | null }, process: { __typename?: 'Process', id: number, leadTimeDatetimeReference: string | null, referenceCode: string, alertLevel: AlertLevelEnum, extraFields: any | null, canceledAt: string | null, finishedAt: string | null, insertedAt: string, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, type: ShipmentTypeEnum | null, ata: string | null, atd: string | null, eta: string | null, etd: string | null, deliveredAt: string | null, receivedInWarehouseAt: string | null, departedFromWarehouseAt: string | null, totalNetWeight: string | null, totalGrossWeight: string | null, cubageCubicMeters: string | null, automaticTrackingEnabled: boolean, statusResponse: StatusResponseTypeEnum, ceMercanteData: { __typename?: 'CeMercanteData', id: number, number: string, issuedAt: string | null, cargoStatus: string | null, hasDta: boolean | null, manifestArrivalAt: string | null, cargoPresenceInPrimaryZoneAt: string | null, cargoPresenceInSecondaryZoneAt: string | null, customsPlace: string | null, bl: string | null, cargoPresenceHistory: Array<{ __typename?: 'CeMercanteDataCargoPresenceHistory', ra: string | null, status: string | null, date: string | null, dtaNumber: string | null, syncedAt: string | null }>, containerSeals: Array<{ __typename?: 'CeMercanteDataContainerSeal', containerCode: string | null, sealCode: string | null, secondarySealCode: string | null }>, originPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, destinationPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null } | null, parcelShipments: Array<{ __typename?: 'ParcelShipment', id: number, trackingNumber: string, slug: string }>, internationalFreight: { __typename?: 'InternationalFreight', id: number, cargoAttributes: Array<CargoAttributeEnum>, expectedSeparationAt: string | null, pickupLocation: string | null, freightForwarder: string | null, quotationNumber: string | null, plannedBoardingDate: string | null, freightCostPrepaid: string | null, freightCostCollect: string | null, freightCostRoad: string | null, freightCostTotal: string | null, type: InternationalFreightTypeEnum | null, bookingEta: string | null, bookingEtd: string | null, voyageNumber: string | null, currency: { __typename?: 'Currency', name: string, code: string } | null, sealine: { __typename?: 'Sealine', id: number, name: string, logoUrl: string | null } | null, bookingLoadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingDischargeAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingLoadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } | null, portTerminal: { __typename?: 'PortTerminal', id: number, name: string } | null } | null, airTransportShipment: { __typename?: 'AirTransportShipment', awb: string | null, hawb: string | null, id: number, type: AirTransportTypeEnum | null, destinationAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, originAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, airline: { __typename?: 'Airline', id: number, name: string } | null } | null, demurrage?: { __typename?: 'Demurrage', id: number, dailyRateUsd?: string | null, freeTime?: number | null, calculations?: { __typename?: 'DemurrageCalculations', totalExceedingDays: number, totalEstimatedCosts: string, totalDaysPaid: number, totalDaysToPay: number, averageCostPerDayUsd: string, totalOwedUsd: string, totalPaidUsd: string, totalToPayUsd: string } } | null, maritimeTransportShipment: { __typename?: 'MaritimeTransportShipment', id: number, type: MaritimeTransportTypeEnum | null, bl: string | null, booking: string | null, hbl: string | null, trackingNumber: string | null, trackingLoadingPort: string | null, trackingDischargePort: string | null, voyageNumber: string | null, trackingKey: TrackingKeyEnum | null, sealine: { __typename?: 'Sealine', id: number, logoUrl: string | null, name: string } | null, vessel: { __typename?: 'Vessel', id: number, name: string } | null, loadingPort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null, dischargePort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null } | null, roadTransportShipment: { __typename?: 'ForeignTradeRoadTransportShipment', id: number, type: ForeignTradeRoadTransportTypeEnum | null, crt: string | null, origin: string | null, destination: string | null } | null, route: { __typename?: 'Route', id: number, name: string } | null, shipmentDuimps?: Array<{ __typename?: 'ShipmentDuimp', id: number, duimp: { __typename?: 'Duimp', id: number, number: string, registeredAt: string | null, deliveredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: DuimpStatusEnum | null } }>, shipmentExportDeclarations?: Array<{ __typename?: 'ShipmentExportDeclaration', id: number, exportDeclaration: { __typename?: 'ExportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, endorsedAt: string | null, channel: ChannelExportDeclarationTypeEnum | null, status: ExportDeclarationStatusEnum | null } }>, shipmentImportDeclarations?: Array<{ __typename?: 'ShipmentImportDeclaration', id: number, importDeclaration: { __typename?: 'ImportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: ImportDeclarationStatusEnum | null } }>, shipmentImportLicenses?: Array<{ __typename?: 'ShipmentImportLicense', id: number, importLicense: { __typename?: 'ImportLicense', id: number, number: string, registeredAt: string | null, approvedAt: string | null, status: ImportLicenseStatusEnum | null } }>, invoices: Array<{ __typename?: 'Invoice', id: number, number: string, emittedAt: string, incoterm: IncotermTypeEnum, totalAmount: string, discount: string | null, finalValue: string, totalGrossWeightKg: string, currency: { __typename?: 'Currency', code: string } | null }>, vesselScheduleDeadlineReferences: { __typename?: 'VesselScheduleDeadlineReferences', draftDeadlineReference: DeadlineDateReferenceEnum | null, vgmDeadlineReference: VgmDeadlineDateReferenceEnum | null, cargoDeadlineReference: DeadlineDateReferenceEnum | null, gateOpeningDeadlineReference: GateOpeningDeadlineDateReferenceEnum | null } | null, vesselSchedule: { __typename?: 'VesselSchedule', id: number, sealineStatusResponse: VesselScheduleStatusResponseEnum, portTerminalStatusResponse: VesselScheduleStatusResponseEnum, deadlineDates?: { __typename?: 'VesselScheduleDeadlineDates', draftDeadline: string | null, cargoDeadline: string | null, vgmDeadline: string | null, gateOpeningDeadline: string | null } | null } | null, nationalRoadTransports: Array<{ __typename?: 'NationalRoadTransport', id: number, collectionScheduledAt: string | null, deliveryPlannedAt: string | null, loadType: LoadTypeEnum | null, roadTransportType: RoadTransportTypeEnum | null, transportFeatures: Array<TransportFeatureEnum>, releasedForTransportAt: string | null, transportCompletedAt: string | null, legSlug: string, route: { __typename?: 'Route', id: number, name: string } | null, nationalRoadCarrier: { __typename?: 'Handler', id: number, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null } } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, driverName: string | null, vehiclePlate: string | null, trailerPlate: string | null, driver: { __typename?: 'Driver', id: number, name: string } | null, vehicle: { __typename?: 'Vehicle', id: number, plate: string } | null, trailer: { __typename?: 'Trailer', id: number, plate: string } | null, transportables: Array<{ __typename?: 'Transportable', id: number, container: { __typename?: 'Container', id: number, code: string | null } | null }> }> }>, transportables?: Array<{ __typename?: 'Transportable', id: number, type: TransportableTypeEnum, container: { __typename?: 'Container', id: number, code: string | null } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, phases: Array<{ __typename?: 'RoadTransportTripPhase', id: number, realizedAt: string | null, routePoint: { __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum } }> }> }> } | null, leadTime?: { __typename?: 'LeadTime', conclusionDate: string | null, startDate: string | null, plannedConclusionDate: string, deviationPercentage: string | null, differenceHours: number | null, isRealized: boolean, status: LeadTimeStatusEnum | null } | null, plannedLeadTime: { __typename?: 'PlannedLeadTime', id: number, name: string, leadTimeModel: { __typename?: 'LeadTimeModel', id: number, ignoreTime: boolean } } | null, automationProcesses: Array<{ __typename?: 'AutomationProcess', id: number, automation: { __typename?: 'Automation', id: number, name: string } }>, operation: { __typename?: 'Operation', id: number, title: string, subType: OperationSubTypeEnum }, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, documents?: Array<{ __typename?: 'Document', id: number, type: DocumentTypeEnum, brazilianInvoiceInfo?: { __typename?: 'BrazilianInvoice', emittedAt: string, number: string, accessKey: string, tax: { __typename?: 'BrazilianInvoiceTax', totalAmount: string }, transport: { __typename?: 'BrazilianInvoiceTransport', grossWeight: string | null } } | null }>, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }>, ownerHandler: { __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } } | null, orders: Array<{ __typename?: 'Order', id: number, referenceCode: string, externalReferenceCode: string | null, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }> }> } }> };

export type GetShipmentItemsWithOrderItemsTableRowsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filters: FilterOrderItemParams;
  pagination?: InputMaybe<OrderItemPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
  processFilters?: InputMaybe<FilterProcessParams>;
  orderFilters?: InputMaybe<FilterOrderParams>;
  includeDocuments: Scalars['Boolean']['input'];
  includeProcessLeadTime: Scalars['Boolean']['input'];
  includeProcessBrazilianInvoiceInfo: Scalars['Boolean']['input'];
  includeVesselScheduleCalculatedDates: Scalars['Boolean']['input'];
  includeShipmentDuimps: Scalars['Boolean']['input'];
  includeShipmentExportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportDeclarations: Scalars['Boolean']['input'];
  includeShipmentImportLicenses: Scalars['Boolean']['input'];
  includeContainers: Scalars['Boolean']['input'];
  includeDemurrageAny: Scalars['Boolean']['input'];
  includeDemurrage: Scalars['Boolean']['input'];
  includeDemurrageCalculations: Scalars['Boolean']['input'];
}>;


export type GetShipmentItemsWithOrderItemsTableRowsQuery = { __typename?: 'RootQueryType', shipmentItemsWithOrderItemsCount: number, shipmentItemsWithOrderItems: Array<{ __typename?: 'ShipmentItemWithOrderItem', foreignTradeItemShipment: { __typename?: 'ForeignTradeItemShipment', id: number, quantity: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, unitValue: string | null, brazilianInvoiceUnitValue: string | null, totalValue: string | null, transportables: Array<{ __typename?: 'Transportable', id: number, container: { __typename?: 'Container', id: number, code: string | null, actualReturnEmptyContainerAt: string | null, estimatedReturnEmptyContainerAt: string | null, invoiceNumber: string | null, sealCode: string | null, secondarySealCode: string | null, grossWeightKg: string | null, maxWeightKg: string | null, tareWeightKg: string | null, loadType: LoadTypeEnum | null, sizeFootType: ContainerSizeFootTypeEnum | null, type: ContainerTypeEnum | null, palletQuantity: number | null, demurrageDailyRateUsd: string | null, demurrageFreeTime: number | null, demurrageFreeTimeStartAt: string | null, isStackable: boolean | null, cubicMeters: string | null, dispatchNumber: string | null, transportDocument: string | null, demurrageCalculations: { __typename?: 'ContainerDemurrageCalculations', emptyReturnDeadline: string | null, estimatedCosts: string, exceedingDays: number } | null } | null }> }, salesOrderItem: { __typename?: 'SalesOrderItem', id: number, lineNumber: number | null, lineReference: string, quantity: string | null, balance: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, dispatchNumber: string | null, measurementUnitSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedArrivalAt: string | null, shipmentPlannedBoardingAt: string | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierReadyDeviation: number | null, factoryDeliveryAt: string | null, factoryEstimatedDeliveryAt: string | null, itemStatus: string | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, necessityType: string | null, ubc: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, stockQuantity: string | null, clientApprovedAt: string | null, reservedStockQuantity: string | null, stockReservationAt: string | null, preliminaryPickingStartedAt: string | null, internalContainerReference: string | null, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'SalesOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null } | null, purchaseOrderItem: { __typename?: 'PurchaseOrderItem', id: number, lineNumber: number | null, lineReference: string, quantity: string | null, balance: string | null, measurementUnitSap: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, sapByFactor: string | null, concessionAct: string | null, importTypeSap: string | null, orderItemReference: string | null, orderRequestNumber: string | null, orderUnitValue: string | null, orderTotalValue: string | null, orderModalTypeSap: string | null, orderAdjustedModalType: string | null, orderRequestedAt: string | null, planningRequestShippingAt: string | null, planningShippingAt: string | null, supplierSentAt: string | null, supplierConfirmationAt: string | null, supplierReadyLeadTimeDays: number | null, supplierPlannedReadyAt: string | null, supplierEstimatedReadyAt: string | null, supplierReadyAt: string | null, supplierCalculatedReadyAt: string | null, supplierReadyDeviation: number | null, shipmentEquipmentType: string | null, shipmentContainersQuantity: string | null, shipmentPlannedBoardingAt: string | null, shipmentPlannedArrivalAt: string | null, shipmentEstimatedBoardingAt: string | null, shipmentEstimatedArrivalAt: string | null, shipmentBoardingLeadTime: number | null, shipmentTransportLeadTime: number | null, customsEstimatedRegisterAt: string | null, customsRegisterLeadTime: number | null, customsEstimatedReleaseAt: string | null, customsReleaseLeadTime: number | null, factoryEstimatedDeliveryAt: string | null, factoryPlannedDeliveryAt: string | null, factoryDeliveryAt: string | null, factoryDeliveryLeadTime: number | null, adjustedCustomsRegisterLeadTime: number | null, adjustedCustomsReleaseLeadTime: number | null, adjustedFactoryDeliveryLeadTime: number | null, adjustedShipmentBoardingLeadTime: number | null, adjustedShipmentTransportLeadTime: number | null, adjustedSupplierReadyLeadTimeDays: number | null, assessmentSotd: string | null, itemStatus: string | null, division: string | null, note: string | null, palletQuantity: string | null, palletGrouping: string | null, ipiTaxRate: string | null, iiTaxRate: string | null, cofinsTaxRate: string | null, pisTaxRate: string | null, icmsTaxRate: string | null, specialTreatments: SpecialTreatmentsTypeEnum | null, productTranslatedDescription: string | null, productDescription: string | null, productMercosulCode: string | null, invoiceIssuedAt: string | null, invoiceNumber: string | null, invoiceValue: string | null, invoiceType: string | null, deliveryNote: string | null, deliveryNoteIssuedAt: string | null, shippingDetailsDeliveryDate: string | null, quotationOpeningDate: string | null, product: { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }, orderCurrency: { __typename?: 'Currency', code: string } | null, itemCalculations: { __typename?: 'PurchaseOrderItemCalculations', grossWeight: string | null, netWeight: string | null, cubage: string | null, palletQuantity: string | null } | null, manufacturingCountry: { __typename?: 'Country', code: string } | null, purchaseCountry: { __typename?: 'Country', code: string } | null, dispatchingCountry: { __typename?: 'Country', code: string } | null } | null, process: { __typename?: 'Process', id: number, leadTimeDatetimeReference: string | null, referenceCode: string, alertLevel: AlertLevelEnum, extraFields: any | null, canceledAt: string | null, finishedAt: string | null, insertedAt: string, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, type: ShipmentTypeEnum | null, ata: string | null, atd: string | null, eta: string | null, etd: string | null, deliveredAt: string | null, receivedInWarehouseAt: string | null, departedFromWarehouseAt: string | null, totalNetWeight: string | null, totalGrossWeight: string | null, cubageCubicMeters: string | null, automaticTrackingEnabled: boolean, statusResponse: StatusResponseTypeEnum, ceMercanteData: { __typename?: 'CeMercanteData', id: number, number: string, issuedAt: string | null, cargoStatus: string | null, hasDta: boolean | null, manifestArrivalAt: string | null, cargoPresenceInPrimaryZoneAt: string | null, cargoPresenceInSecondaryZoneAt: string | null, customsPlace: string | null, bl: string | null, cargoPresenceHistory: Array<{ __typename?: 'CeMercanteDataCargoPresenceHistory', ra: string | null, status: string | null, date: string | null, dtaNumber: string | null, syncedAt: string | null }>, containerSeals: Array<{ __typename?: 'CeMercanteDataContainerSeal', containerCode: string | null, sealCode: string | null, secondarySealCode: string | null }>, originPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, destinationPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null } | null, parcelShipments: Array<{ __typename?: 'ParcelShipment', id: number, trackingNumber: string, slug: string }>, internationalFreight: { __typename?: 'InternationalFreight', id: number, cargoAttributes: Array<CargoAttributeEnum>, expectedSeparationAt: string | null, pickupLocation: string | null, freightForwarder: string | null, quotationNumber: string | null, plannedBoardingDate: string | null, freightCostPrepaid: string | null, freightCostCollect: string | null, freightCostRoad: string | null, freightCostTotal: string | null, type: InternationalFreightTypeEnum | null, bookingEta: string | null, bookingEtd: string | null, voyageNumber: string | null, currency: { __typename?: 'Currency', name: string, code: string } | null, sealine: { __typename?: 'Sealine', id: number, name: string, logoUrl: string | null } | null, bookingLoadingAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingDischargeAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, bookingLoadingPort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, bookingDischargePort: { __typename?: 'MaritimePort', id: number, name: string, unlocode: string | null } | null, vessel: { __typename?: 'Vessel', id: number, name: string, imoNumber: string | null, country: { __typename?: 'Country', code: string } | null } | null, portTerminal: { __typename?: 'PortTerminal', id: number, name: string } | null } | null, airTransportShipment: { __typename?: 'AirTransportShipment', awb: string | null, hawb: string | null, id: number, type: AirTransportTypeEnum | null, destinationAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, originAirport: { __typename?: 'Airport', id: number, name: string, iataCode: string } | null, airline: { __typename?: 'Airline', id: number, name: string } | null } | null, demurrage?: { __typename?: 'Demurrage', id: number, dailyRateUsd?: string | null, freeTime?: number | null, calculations?: { __typename?: 'DemurrageCalculations', totalExceedingDays: number, totalEstimatedCosts: string, totalDaysPaid: number, totalDaysToPay: number, averageCostPerDayUsd: string, totalOwedUsd: string, totalPaidUsd: string, totalToPayUsd: string } } | null, maritimeTransportShipment: { __typename?: 'MaritimeTransportShipment', id: number, type: MaritimeTransportTypeEnum | null, bl: string | null, booking: string | null, hbl: string | null, trackingNumber: string | null, trackingLoadingPort: string | null, trackingDischargePort: string | null, voyageNumber: string | null, trackingKey: TrackingKeyEnum | null, sealine: { __typename?: 'Sealine', id: number, logoUrl: string | null, name: string } | null, vessel: { __typename?: 'Vessel', id: number, name: string } | null, loadingPort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null, dischargePort: { __typename?: 'MaritimePort', id: number, unlocode: string | null, name: string } | null } | null, roadTransportShipment: { __typename?: 'ForeignTradeRoadTransportShipment', id: number, type: ForeignTradeRoadTransportTypeEnum | null, crt: string | null, origin: string | null, destination: string | null } | null, route: { __typename?: 'Route', id: number, name: string } | null, shipmentDuimps?: Array<{ __typename?: 'ShipmentDuimp', id: number, duimp: { __typename?: 'Duimp', id: number, number: string, registeredAt: string | null, deliveredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: DuimpStatusEnum | null } }>, shipmentExportDeclarations?: Array<{ __typename?: 'ShipmentExportDeclaration', id: number, exportDeclaration: { __typename?: 'ExportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, endorsedAt: string | null, channel: ChannelExportDeclarationTypeEnum | null, status: ExportDeclarationStatusEnum | null } }>, shipmentImportDeclarations?: Array<{ __typename?: 'ShipmentImportDeclaration', id: number, importDeclaration: { __typename?: 'ImportDeclaration', id: number, number: string, registeredAt: string | null, customsClearedAt: string | null, channel: ChannelTypeEnum | null, status: ImportDeclarationStatusEnum | null } }>, shipmentImportLicenses?: Array<{ __typename?: 'ShipmentImportLicense', id: number, importLicense: { __typename?: 'ImportLicense', id: number, number: string, registeredAt: string | null, approvedAt: string | null, status: ImportLicenseStatusEnum | null } }>, invoices: Array<{ __typename?: 'Invoice', id: number, number: string, emittedAt: string, incoterm: IncotermTypeEnum, totalAmount: string, discount: string | null, finalValue: string, totalGrossWeightKg: string, currency: { __typename?: 'Currency', code: string } | null }>, vesselScheduleDeadlineReferences: { __typename?: 'VesselScheduleDeadlineReferences', draftDeadlineReference: DeadlineDateReferenceEnum | null, vgmDeadlineReference: VgmDeadlineDateReferenceEnum | null, cargoDeadlineReference: DeadlineDateReferenceEnum | null, gateOpeningDeadlineReference: GateOpeningDeadlineDateReferenceEnum | null } | null, vesselSchedule: { __typename?: 'VesselSchedule', id: number, sealineStatusResponse: VesselScheduleStatusResponseEnum, portTerminalStatusResponse: VesselScheduleStatusResponseEnum, deadlineDates?: { __typename?: 'VesselScheduleDeadlineDates', draftDeadline: string | null, cargoDeadline: string | null, vgmDeadline: string | null, gateOpeningDeadline: string | null } | null } | null, nationalRoadTransports: Array<{ __typename?: 'NationalRoadTransport', id: number, collectionScheduledAt: string | null, deliveryPlannedAt: string | null, loadType: LoadTypeEnum | null, roadTransportType: RoadTransportTypeEnum | null, transportFeatures: Array<TransportFeatureEnum>, releasedForTransportAt: string | null, transportCompletedAt: string | null, legSlug: string, route: { __typename?: 'Route', id: number, name: string } | null, nationalRoadCarrier: { __typename?: 'Handler', id: number, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null } } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, driverName: string | null, vehiclePlate: string | null, trailerPlate: string | null, driver: { __typename?: 'Driver', id: number, name: string } | null, vehicle: { __typename?: 'Vehicle', id: number, plate: string } | null, trailer: { __typename?: 'Trailer', id: number, plate: string } | null, transportables: Array<{ __typename?: 'Transportable', id: number, container: { __typename?: 'Container', id: number, code: string | null } | null }> }> }>, transportables?: Array<{ __typename?: 'Transportable', id: number, type: TransportableTypeEnum, container: { __typename?: 'Container', id: number, code: string | null } | null, trips: Array<{ __typename?: 'RoadTransportTrip', id: number, phases: Array<{ __typename?: 'RoadTransportTripPhase', id: number, realizedAt: string | null, routePoint: { __typename?: 'RoutePoint', id: number, routeType: RouteTypeEnum } }> }> }> } | null, leadTime?: { __typename?: 'LeadTime', conclusionDate: string | null, startDate: string | null, plannedConclusionDate: string, deviationPercentage: string | null, differenceHours: number | null, isRealized: boolean, status: LeadTimeStatusEnum | null } | null, plannedLeadTime: { __typename?: 'PlannedLeadTime', id: number, name: string, leadTimeModel: { __typename?: 'LeadTimeModel', id: number, ignoreTime: boolean } } | null, automationProcesses: Array<{ __typename?: 'AutomationProcess', id: number, automation: { __typename?: 'Automation', id: number, name: string } }>, operation: { __typename?: 'Operation', id: number, title: string, subType: OperationSubTypeEnum }, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, documents?: Array<{ __typename?: 'Document', id: number, type: DocumentTypeEnum, brazilianInvoiceInfo?: { __typename?: 'BrazilianInvoice', emittedAt: string, number: string, accessKey: string, tax: { __typename?: 'BrazilianInvoiceTax', totalAmount: string }, transport: { __typename?: 'BrazilianInvoiceTransport', grossWeight: string | null } } | null }>, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }>, ownerHandler: { __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } } | null, orders: Array<{ __typename?: 'Order', id: number, referenceCode: string, externalReferenceCode: string | null, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }> }> }, order: { __typename?: 'Order', id: number, referenceCode: string, externalReferenceCode: string | null, insertedAt: string, finishedAt: string | null, alertLevel: AlertLevelEnum, type: OrderTypeEnum, extraFields: any | null, observations: string | null, automationOrders: Array<{ __typename?: 'AutomationOrder', id: number, automation: { __typename?: 'Automation', id: number, name: string } }>, subsidiary: { __typename?: 'Subsidiary', id: number, name: string } | null, processes: Array<{ __typename?: 'Process', id: number, referenceCode: string }>, operation: { __typename?: 'Operation', id: number, title: string, subType: OperationSubTypeEnum }, handlers: Array<{ __typename?: 'Handler', id: number, businessUnit: string | null, reference: string | null, secondaryReference: string | null, operationHandler: { __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }, actor: { __typename?: 'Actor', id: number, nickname: string }, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string, internalCode: string | null, partner: { __typename?: 'Actor', id: number, documentType: ActorDocumentTypeEnum | null, officialDocument: string | null } } }>, purchaseOrder: { __typename?: 'PurchaseOrder', id: number, type: OrderTransactionTypeEnum, supplierOrderAcceptedAt: string | null, supplierOrderSentAt: string | null, supplierReadinessAt: string | null, supplierExpectedReadinessAt: string | null, necessityDate: string | null } | null, salesOrder: { __typename?: 'SalesOrder', id: number, type: OrderTransactionTypeEnum, orderConfirmedAt: string | null, orderReceivedAt: string | null } | null } }> };

export type LinkedContainersDataFragment = { __typename?: 'Container', id: number, code: string | null, actualReturnEmptyContainerAt: string | null, estimatedReturnEmptyContainerAt: string | null, invoiceNumber: string | null, sealCode: string | null, secondarySealCode: string | null, grossWeightKg: string | null, maxWeightKg: string | null, tareWeightKg: string | null, loadType: LoadTypeEnum | null, sizeFootType: ContainerSizeFootTypeEnum | null, type: ContainerTypeEnum | null, palletQuantity: number | null, demurrageDailyRateUsd: string | null, demurrageFreeTime: number | null, demurrageFreeTimeStartAt: string | null, isStackable: boolean | null, cubicMeters: string | null, dispatchNumber: string | null, transportDocument: string | null, demurrageCalculations: { __typename?: 'ContainerDemurrageCalculations', emptyReturnDeadline: string | null, estimatedCosts: string, exceedingDays: number } | null };

export type ProductFieldsFragment = { __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> };

export type ShipmentItemDataFragment = { __typename?: 'ForeignTradeItemShipment', id: number, quantity: string | null, netWeightKg: string | null, grossWeightKg: string | null, cubageCubicMeters: string | null, unitValue: string | null, brazilianInvoiceUnitValue: string | null, totalValue: string | null };

export type UpdateReportMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  params: UpdateReportParams;
}>;


export type UpdateReportMutation = { __typename?: 'RootMutationType', updateReport: { __typename?: 'Report', id: number, columns: any | null } | null };

export type CostModelExpenseFieldsForReportGroupsFragment = { __typename?: 'CostModelExpense', id: number, costExpense: { __typename?: 'CostExpense', id: number, name: string, slug: string } };

export type ReportGroupsQueryVariables = Exact<{
  includeCostModels: Scalars['Boolean']['input'];
}>;


export type ReportGroupsQuery = { __typename?: 'RootQueryType', reportGroups: Array<{ __typename?: 'ReportGroup', id: number, name: string, position: number, reference: ReportReferenceEnum, operations: Array<{ __typename?: 'Operation', id: number, title: string, subType: OperationSubTypeEnum, acceptHourInNationalRoadTransports: boolean, configProps: { __typename?: 'OperationConfigProps', showExternalReferenceCode: boolean, isMultipleNationalRoadTransport: boolean, orderItemAdditionalFields: Array<string> }, operationHandlers: Array<{ __typename?: 'OperationHandler', id: number, role: OperationHandlerEnum, bindingType: HandlerBindingTypeEnum, showBusinessUnit: boolean, showReference: boolean, showSecondaryReference: boolean }>, operationPhases: Array<{ __typename?: 'OperationPhase', id: number, position: number, phase: { __typename?: 'Phase', id: number, phase: PhaseEnum }, components: Array<{ __typename?: 'Component', id: number, name: string, slug: string, props: any | null, title: string | null, position: number, extraFieldsDefinition: any | null }> }>, orderComponents: Array<{ __typename?: 'Component', id: number, name: string, slug: string, props: any | null, title: string | null, position: number, extraFieldsDefinition: any | null }>, costModels?: Array<{ __typename?: 'CostModel', id: number, name: string, hasPlannedCosts: boolean, versions: Array<{ __typename?: 'CostModelVersion', id: number, version: number, rootModelExpenses: Array<{ __typename?: 'CostModelExpense', id: number, childrenModelExpenses: Array<{ __typename?: 'CostModelExpense', id: number, childrenModelExpenses: Array<{ __typename?: 'CostModelExpense', id: number, costExpense: { __typename?: 'CostExpense', id: number, name: string, slug: string } }>, costExpense: { __typename?: 'CostExpense', id: number, name: string, slug: string } }>, costExpense: { __typename?: 'CostExpense', id: number, name: string, slug: string } }> }> }> }>, reportGroupAccess: { __typename?: 'ReportGroupAccess', id: number, type: AccessEnum }, reports: Array<{ __typename?: 'Report', id: number, name: string, position: number, filters: any | null, columns: any | null, sorting: any | null }> }> };

export type GetQuickFiltersConfigsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetQuickFiltersConfigsQuery = { __typename?: 'RootQueryType', operation: { __typename?: 'Operation', id: number, quickFiltersConfigs: Array<{ __typename?: 'QuickFilterConfig', label: any | null, path: string }> } | null };

export type GetAvailableQuickFiltersQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  currentFilters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAvailableQuickFiltersQuery = { __typename?: 'RootQueryType', operation: { __typename?: 'Operation', id: number, availableQuickFilters: Array<{ __typename?: 'QuickFilter', label: string | null, path: string, values: Array<{ __typename?: 'QuickFilterValue', label: string, value: any }> }> } | null };

export type GetOperationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOperationQuery = { __typename?: 'RootQueryType', operation: { __typename?: 'Operation', id: number, title: string, subtitle: string | null, subType: OperationSubTypeEnum, type: OperationTypeEnum, acceptHourInNationalRoadTransports: boolean, actor: { __typename?: 'Actor', id: number }, configProps: { __typename?: 'OperationConfigProps', internationalModal: InternationalModalEnum }, cardConfig: { __typename?: 'OperationCardConfig', id: number, color: string }, operationPhases: Array<{ __typename?: 'OperationPhase', id: number, position: number, phase: { __typename?: 'Phase', id: number, phase: PhaseEnum, sortingLabel: string | null, sortingOrder: SimpleSortingOrderEnum | null, sortingPath: string | null } }>, operationAccess: { __typename?: 'OperationAccess', id: number, type: AccessEnum, canCreateProcesses: boolean, canCreateOrders: boolean, canSeeOrders: boolean } } | null };

export type GetOperationOrdersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FilterOrderParams>;
  pagination?: InputMaybe<OrderPaginationParams>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetOperationOrdersQuery = { __typename?: 'RootQueryType', ordersCount: number, orders: Array<{ __typename?: 'Order', id: number, alertLevel: AlertLevelEnum, referenceCode: string, type: OrderTypeEnum, customer: { __typename?: 'Handler', id: number, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } } | null, supplier: { __typename?: 'Handler', id: number, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } } | null, ownerHandler: { __typename?: 'Handler', id: number, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } } | null, processes: Array<{ __typename?: 'Process', id: number, finishedAt: string | null }> }> };

export type GetPhaseOrdersQueryVariables = Exact<{
  phaseId: Scalars['Int']['input'];
  filters?: InputMaybe<FilterOrderParams>;
  pagination?: InputMaybe<OrderPaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPhaseOrdersQuery = { __typename?: 'RootQueryType', operationPhase: { __typename?: 'OperationPhase', id: number, ordersCount: number | null, phase: { __typename?: 'Phase', id: number, trigger: { __typename?: 'Trigger', label: string } | null }, orders: Array<{ __typename?: 'Order', id: number, alertLevel: AlertLevelEnum, referenceCode: string, leadTimeDatetimeReference: string | null, currentPhase: { __typename?: 'Phase', id: number, phase: PhaseEnum } | null, checkpoints: Array<{ __typename?: 'CheckpointStatus', label: string, fulfilledItemsCount: number, itemsCount: number }>, route: { __typename?: 'Route', id: number, name: string } | null, ownerHandler: { __typename?: 'Handler', id: number, actor: { __typename?: 'Actor', id: number, nickname: string } } | null, salesOrder: { __typename?: 'SalesOrder', id: number, items: Array<{ __typename?: 'SalesOrderItem', id: number, quantity: string | null, lineNumber: number | null, balance: string | null, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string } }> } | null, purchaseOrder: { __typename?: 'PurchaseOrder', id: number, supplierOrderAcceptedAt: string | null, supplierOrderSentAt: string | null, items: Array<{ __typename?: 'PurchaseOrderItem', id: number, quantity: string | null, lineNumber: number | null, balance: string | null, productTranslatedDescription: string | null, product: { __typename?: 'Product', id: number, code: string } }> } | null, roadTransportOrder: { __typename?: 'RoadTransportOrder', id: number, type: RoadTransportOrderTypeEnum, roadTransportShipments: Array<{ __typename?: 'RoadTransportShipment', id: number, vehicle: { __typename?: 'Vehicle', id: number, plate: string } | null, shipmentDrivers: Array<{ __typename?: 'RoadTransportShipmentDriver', id: number, driver: { __typename?: 'Driver', id: number, name: string } }> }> } | null }> } | null };

export type GetPhaseProcessesQueryVariables = Exact<{
  operationPhaseId: Scalars['Int']['input'];
  filters?: InputMaybe<FilterProcessParams>;
  pagination?: InputMaybe<ProcessPaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
  pathFilters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetPhaseProcessesQuery = { __typename?: 'RootQueryType', operationPhase: { __typename?: 'OperationPhase', id: number, processesCount: number, phase: { __typename?: 'Phase', id: number, phase: PhaseEnum, trigger: { __typename?: 'Trigger', label: string } | null }, processes: Array<{ __typename?: 'Process', id: number, alertLevel: AlertLevelEnum, referenceCode: string, cardInfo: { __typename?: 'OperationCard', title: string | null, subtitle: string | null, headerLeft: string | null, headerRight: string | null, panelType: PathConfigTypeEnum | null, panelValue: string | null, panelLabel: string | null, color: string | null } | null, checkpoints: Array<{ __typename?: 'CheckpointStatus', label: string, fulfilledItemsCount: number, itemsCount: number }>, foreignTradeShipment: { __typename?: 'ForeignTradeShipment', id: number, type: ShipmentTypeEnum | null } | null }> } | null };

export type ListAddressesQueryVariables = Exact<{
  filters?: InputMaybe<FilterAddressesParams>;
}>;


export type ListAddressesQuery = { __typename?: 'RootQueryType', addresses: Array<{ __typename?: 'Address', id: number, city: string | null, country: string | null, latitude: string, longitude: string, name: string | null, number: string | null, postalCode: string | null, state: string | null, street: string | null, neighborhood: string | null, actor: { __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null } | null }> };

export type OrdersSubscriptionVariables = Exact<{
  operationId: Scalars['Int']['input'];
}>;


export type OrdersSubscription = { __typename?: 'RootSubscriptionType', orders: Array<{ __typename?: 'OrderSubscription', data: { __typename?: 'Order', id: number } | null }> };

export type ProcessesSubscriptionVariables = Exact<{
  operationId: Scalars['Int']['input'];
}>;


export type ProcessesSubscription = { __typename?: 'RootSubscriptionType', processes: Array<{ __typename?: 'ProcessSubscription', data: { __typename?: 'Process', id: number, currentPhase: { __typename?: 'Phase', id: number } | null, previousPhase: { __typename?: 'Phase', id: number } | null } | null }> };

export type GetOperationFieldsQueryVariables = Exact<{
  operationId: Scalars['Int']['input'];
  includeOptions: Scalars['Boolean']['input'];
}>;


export type GetOperationFieldsQuery = { __typename?: 'RootQueryType', operation: { __typename?: 'Operation', id: number, processesFields: Array<{ __typename?: 'Path', label: string, path: string, type: PathTypeEnum, isList: boolean, options?: Array<{ __typename?: 'PathFieldOption', label: string, value: string }> | null }>, ordersFields: Array<{ __typename?: 'Path', label: string, path: string, type: PathTypeEnum, isList: boolean, options?: Array<{ __typename?: 'PathFieldOption', label: string, value: string }> | null }> } | null };

export type ProductsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<ProductPaginationParams>;
}>;


export type ProductsQuery = { __typename?: 'RootQueryType', products: Array<{ __typename?: 'Product', id: number, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, extra: any | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, actor: { __typename?: 'Actor', id: number, nickname: string }, country: { __typename?: 'Country', code: string } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string, label: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }> };

export type ProductsCountQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductsCountQuery = { __typename?: 'RootQueryType', productsCount: number | null };

export type CreateProductMutationVariables = Exact<{
  params: CreateProductParams;
}>;


export type CreateProductMutation = { __typename?: 'RootMutationType', createProduct: { __typename?: 'Product', id: number } | null };

export type DeleteProductMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteProductMutation = { __typename?: 'RootMutationType', deleteProduct: { __typename?: 'Product', id: number } | null };

export type ProductQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ProductQuery = { __typename?: 'RootQueryType', product: { __typename?: 'Product', id: number, siscomexLastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null, additionalDetails: string | null, c9Ratio: string | null, category: string | null, code: string, contentCapacity: string | null, contentCode: string | null, contentMeasurementUnit: MeasurementUnitEnum | null, contentPerPallet: string | null, contentType: MeasurementUnitEnum | null, cubagePerPackage: string | null, description: string, dumping: boolean | null, family: string | null, grossWeightPerPackage: string | null, manufacturer: string | null, mercosulCode: string | null, multipleCode: string | null, multiplePackageCapacity: string | null, multiplePackageMeasurementUnit: MeasurementUnitEnum | null, multiplePackagePerContainerFt20: number | null, multiplePackagePerContainerFt40: number | null, multiplePackagePerPallet: string | null, multiplePackageType: MeasurementUnitEnum | null, netWeightPerPackage: string | null, packageCapacity: string | null, packageCode: string | null, packageMeasurementUnit: MeasurementUnitEnum | null, packagesPerContainerFt20: number | null, packagesPerContainerFt40: number | null, packagesPerPallet: number | null, packageType: MeasurementUnitEnum | null, palletsPerContainerFt20: number | null, palletsPerContainerFt40: number | null, translatedDescription: string | null, translatedDescriptions: any | null, hasContainerization: boolean | null, hasContent: boolean | null, hasPalletization: boolean | null, hasUnitization: boolean | null, siscomexProduct: { __typename?: 'SiscomexProduct', id: number, ncmCode: string | null, description: string | null, lastUpdatedAt: string | null, insertedAt: string | null } | null, actor: { __typename?: 'Actor', id: number, rootCnpjs: Array<string> }, country: { __typename?: 'Country', code: string, iso3: string | null } | null, internalCodes: Array<{ __typename?: 'ProductInternalCode', id: number, code: string, label: string }>, productForeignOperators: Array<{ __typename?: 'Actor', id: number, nickname: string, officialName: string, officialDocument: string | null, openingDate: string | null, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> } | null };

export type ProductsListActorsQueryVariables = Exact<{
  pagination?: InputMaybe<ActorPaginationParams>;
}>;


export type ProductsListActorsQuery = { __typename?: 'RootQueryType', actors: Array<{ __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> };

export type ProductSiscomexSyncSubscriptionVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ProductSiscomexSyncSubscription = { __typename?: 'RootSubscriptionType', productSiscomexSyncSubscription: { __typename?: 'ProductSiscomexSyncSubscriptionData', data: { __typename?: 'Product', id: number, siscomexLastSyncType: SiscomexSyncTypeEnum | null, lastSyncErrorMessage: string | null, siscomexProduct: { __typename?: 'SiscomexProduct', id: number, ncmCode: string | null, description: string | null, lastUpdatedAt: string | null, insertedAt: string | null } | null } } };

export type TriggerProductSyncMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type TriggerProductSyncMutation = { __typename?: 'RootMutationType', triggerProductSync: { __typename?: 'SyncTriggerResult', syncing: boolean } | null };

export type UpdateProductMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  params: UpdateProductParams;
}>;


export type UpdateProductMutation = { __typename?: 'RootMutationType', updateProduct: { __typename?: 'Product', id: number } | null };

export type CountRoutesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type CountRoutesQuery = { __typename?: 'RootQueryType', routesCount: number | null };

export type CreateRouteMutationVariables = Exact<{
  params: CreateRouteParams;
}>;


export type CreateRouteMutation = { __typename?: 'RootMutationType', createRoute: { __typename?: 'Route', id: number } | null };

export type DeleteRouteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteRouteMutation = { __typename?: 'RootMutationType', deleteRoute: { __typename?: 'Route', id: number } | null };

export type RouteQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RouteQuery = { __typename?: 'RootQueryType', route: { __typename?: 'Route', id: number, name: string, active: boolean, points: Array<{ __typename?: 'RoutePoint', id: number, position: number, routeType: RouteTypeEnum, address: { __typename?: 'Address', city: string | null, complement: string | null, country: string | null, id: number, latitude: string, longitude: string, neighborhood: string | null, name: string | null, number: string | null, postalCode: string | null, reference: string | null, state: string | null, street: string | null } | null }> } | null };

export type ListRoutesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<RoutePaginationParams>;
  filters?: InputMaybe<FilterRoutesParams>;
}>;


export type ListRoutesQuery = { __typename?: 'RootQueryType', routes: Array<{ __typename?: 'Route', id: number, name: string, active: boolean, points: Array<{ __typename?: 'RoutePoint', id: number, position: number, routeType: RouteTypeEnum, address: { __typename?: 'Address', id: number, name: string | null, formattedAddress: string | null } | null }> }> };

export type UpdateRouteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  params: UpdateRouteParams;
}>;


export type UpdateRouteMutation = { __typename?: 'RootMutationType', updateRoute: { __typename?: 'Route', id: number } | null };

export type GetCurrentUserWorkspaceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserWorkspaceQuery = { __typename?: 'RootQueryType', currentUser: { __typename?: 'User', id: string | null, workspaces: Array<{ __typename?: 'Workspace', client: { __typename?: 'Client', id: number, actor: { __typename?: 'Actor', id: number, nickname: string } } | null, accessGroups: Array<{ __typename?: 'AccessGroup', id: number, name: string, slug: string }> }> } | null };

export type CreateCredentialMutationVariables = Exact<{
  params: CreateCredentialParams;
}>;


export type CreateCredentialMutation = { __typename?: 'RootMutationType', createCredential: { __typename?: 'Credential', id: number } | null };

export type DeleteCredentialMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteCredentialMutation = { __typename?: 'RootMutationType', deleteCredential: { __typename?: 'Credential', id: number } | null };

export type GetCredentialQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetCredentialQuery = { __typename?: 'RootQueryType', credential: { __typename?: 'Credential', id: number, name: string | null, partnerships: Array<{ __typename?: 'Partnership', id: number, partner: { __typename?: 'Actor', id: number, nickname: string } }> } | null };

export type GetCredentialsQueryVariables = Exact<{
  filters?: InputMaybe<FilterCredentialParams>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCredentialsQuery = { __typename?: 'RootQueryType', credentials: Array<{ __typename?: 'Credential', id: number, type: CredentialTypeEnum, app: AppTypeEnum, name: string | null, originalFilename: string | null, ecpf: { __typename?: 'Ecpf', commonName: string, cpf: string, expiresAt: string } | null, partnerships: Array<{ __typename?: 'Partnership', id: number, partner: { __typename?: 'Actor', id: number, nickname: string, partnershipAsPartner: { __typename?: 'Partnership', id: number, roles: Array<{ __typename?: 'Role', id: number, role: OperationHandlerEnum }> } | null } }> }> };

export type UpdateCredentialMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  params: UpdateCredentialParams;
}>;


export type UpdateCredentialMutation = { __typename?: 'RootMutationType', updateCredential: { __typename?: 'Credential', id: number } | null };

export type CreateNotificationGroupMutationVariables = Exact<{
  params: CreateNotificationGroupParams;
}>;


export type CreateNotificationGroupMutation = { __typename?: 'RootMutationType', createNotificationGroup: { __typename?: 'NotificationGroup', id: number, name: string, ccEmails: Array<string>, insertedAt: string, notificationGroupRoles: Array<{ __typename?: 'NotificationGroupRole', id: number, role: OperationHandlerEnum }> } | null };

export type CreateNotificationGroupRecipientMutationVariables = Exact<{
  params: CreateNotificationGroupRecipientParams;
}>;


export type CreateNotificationGroupRecipientMutation = { __typename?: 'RootMutationType', createNotificationGroupRecipient: { __typename?: 'NotificationGroupRecipient', id: number, emails: Array<string>, language: LanguageEnum, partnershipId: number, notificationGroupRoleId: number } | null };

export type DeleteNotificationGroupMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteNotificationGroupMutation = { __typename?: 'RootMutationType', deleteNotificationGroup: { __typename?: 'NotificationGroup', id: number } | null };

export type DeleteNotificationGroupRecipientMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteNotificationGroupRecipientMutation = { __typename?: 'RootMutationType', deleteNotificationGroupRecipient: { __typename?: 'NotificationGroupRecipient', id: number } | null };

export type GetNotificationGroupByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetNotificationGroupByIdQuery = { __typename?: 'RootQueryType', notificationGroup: { __typename?: 'NotificationGroup', id: number, name: string, ccEmails: Array<string>, insertedAt: string, notificationGroupRoles: Array<{ __typename?: 'NotificationGroupRole', id: number, role: OperationHandlerEnum, notificationGroupRecipients: Array<{ __typename?: 'NotificationGroupRecipient', id: number, emails: Array<string>, language: LanguageEnum, partnershipId: number, notificationGroupRoleId: number, partnership: { __typename?: 'Partnership', id: number, nicknameWithFallback: string } | null }> }> } | null };

export type GetNotificationGroupsQueryVariables = Exact<{
  pagination?: InputMaybe<NotificationGroupPaginationParams>;
  filters?: InputMaybe<FilterNotificationGroupParams>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetNotificationGroupsQuery = { __typename?: 'RootQueryType', notificationGroups: Array<{ __typename?: 'NotificationGroup', id: number, name: string, ccEmails: Array<string>, insertedAt: string, updatedAt: string, notificationGroupRoles: Array<{ __typename?: 'NotificationGroupRole', id: number, role: OperationHandlerEnum }> }> };

export type GetNotificationGroupsCountQueryVariables = Exact<{
  filters?: InputMaybe<FilterNotificationGroupParams>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetNotificationGroupsCountQuery = { __typename?: 'RootQueryType', notificationGroupsCount: number };

export type UpdateNotificationGroupMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  params: UpdateNotificationGroupParams;
}>;


export type UpdateNotificationGroupMutation = { __typename?: 'RootMutationType', updateNotificationGroup: { __typename?: 'NotificationGroup', id: number, name: string, ccEmails: Array<string>, insertedAt: string, notificationGroupRoles: Array<{ __typename?: 'NotificationGroupRole', id: number, role: OperationHandlerEnum }> } | null };

export type UpdateNotificationGroupRecipientMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  params: UpdateNotificationGroupRecipientParams;
}>;


export type UpdateNotificationGroupRecipientMutation = { __typename?: 'RootMutationType', updateNotificationGroupRecipient: { __typename?: 'NotificationGroupRecipient', id: number, emails: Array<string>, language: LanguageEnum, partnershipId: number, notificationGroupRoleId: number } | null };

export type CreateOrInviteUserMutationVariables = Exact<{
  params: CreateUserParams;
}>;


export type CreateOrInviteUserMutation = { __typename?: 'RootMutationType', createOrInviteUser: { __typename?: 'User', id: string | null, email: string | null, name: string | null, lastLogin: string | null, canEditEmail: boolean | null, createdBy: string | null, createdAt: string | null, workspaces: Array<{ __typename?: 'Workspace', accessGroups: Array<{ __typename?: 'AccessGroup', id: number, name: string }> }> } | null };

export type DeleteOrRemoveUserFromWorkspaceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteOrRemoveUserFromWorkspaceMutation = { __typename?: 'RootMutationType', deleteOrRemoveUserFromWorkspace: { __typename?: 'User', id: string | null, email: string | null, name: string | null, lastLogin: string | null, canEditEmail: boolean | null, createdBy: string | null, createdAt: string | null, workspaces: Array<{ __typename?: 'Workspace', accessGroups: Array<{ __typename?: 'AccessGroup', id: number, name: string }> }> } | null };

export type GetUsersFragmentFragment = { __typename?: 'User', id: string | null, email: string | null, name: string | null, lastLogin: string | null, canEditEmail: boolean | null, createdBy: string | null, createdAt: string | null, workspaces: Array<{ __typename?: 'Workspace', accessGroups: Array<{ __typename?: 'AccessGroup', id: number, name: string }> }> };

export type GetUsersQueryVariables = Exact<{
  pagination?: InputMaybe<UserPaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUsersQuery = { __typename?: 'RootQueryType', usersTable: { __typename?: 'UsersResponse', totalCount: number, users: Array<{ __typename?: 'User', id: string | null, email: string | null, name: string | null, lastLogin: string | null, canEditEmail: boolean | null, createdBy: string | null, createdAt: string | null, workspaces: Array<{ __typename?: 'Workspace', accessGroups: Array<{ __typename?: 'AccessGroup', id: number, name: string }> }> }> } | null };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
  params: UpdateUserParams;
}>;


export type UpdateUserMutation = { __typename?: 'RootMutationType', updateUser: { __typename?: 'User', id: string | null, email: string | null, name: string | null, lastLogin: string | null, canEditEmail: boolean | null, createdBy: string | null, createdAt: string | null, workspaces: Array<{ __typename?: 'Workspace', accessGroups: Array<{ __typename?: 'AccessGroup', id: number, name: string }> }> } | null };

export type GetUserWorkspaceSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserWorkspaceSettingsQuery = { __typename?: 'RootQueryType', currentUser: { __typename?: 'User', id: string | null, currentWorkspace: { __typename?: 'Workspace', client: { __typename?: 'Client', id: number, actor: { __typename?: 'Actor', id: number, nickname: string, documentType: ActorDocumentTypeEnum | null, officialName: string, officialDocument: string | null, logoUrl: string | null, partnershipAsPartner: { __typename?: 'Partnership', id: number, roles: Array<{ __typename?: 'Role', id: number, role: OperationHandlerEnum }> } | null, addresses: Array<{ __typename?: 'Address', id: number, name: string | null, latitude: string, longitude: string, country: string | null, state: string | null, city: string | null, street: string | null, number: string | null, postalCode: string | null, neighborhood: string | null, complement: string | null, reference: string | null, formattedAddress: string | null, routePoints: Array<{ __typename?: 'RoutePoint', id: number }> }> } } | null } | null } | null };

export type UpdateSelfPartnershipMutationVariables = Exact<{
  partnerId: Scalars['Int']['input'];
  params: UpdatePartnershipParams;
}>;


export type UpdateSelfPartnershipMutation = { __typename?: 'RootMutationType', updatePartnership: { __typename?: 'Partnership', id: number } | null };

export type UpdateActorMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  params: UpdateActorParams;
}>;


export type UpdateActorMutation = { __typename?: 'RootMutationType', updateActor: { __typename?: 'Actor', id: number, nickname: string } | null };

export type UpdateUserPreferenceMutationVariables = Exact<{
  params: UpdateUserPreferenceParams;
}>;


export type UpdateUserPreferenceMutation = { __typename?: 'RootMutationType', updateUserPreference: { __typename?: 'User', id: string | null, userMetadata: { __typename?: 'UserMetadata', userPreference: { __typename?: 'UserPreference', language: string | null } | null } | null } | null };

export type TrailersCountQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type TrailersCountQuery = { __typename?: 'RootQueryType', trailersCount: number | null };

export type CreateTrailerMutationVariables = Exact<{
  params: CreateTrailerParams;
}>;


export type CreateTrailerMutation = { __typename?: 'RootMutationType', createTrailer: { __typename?: 'Trailer', id: number } | null };

export type DeleteTrailerMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteTrailerMutation = { __typename?: 'RootMutationType', deleteTrailer: { __typename?: 'Trailer', id: number } | null };

export type TrailerQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type TrailerQuery = { __typename?: 'RootQueryType', trailer: { __typename?: 'Trailer', id: number, plate: string, type: TrailerTypeEnum, isRefrigerated: boolean, trackerBrand: TrackerBrandEnum | null, trackerId: string | null, speedLimitDry: number | null, speedLimitWet: number | null, tareWeightKg: string | null, temperatureMax: number | null, temperatureMin: number | null } | null };

export type TrailersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<TrailerPaginationParams>;
}>;


export type TrailersQuery = { __typename?: 'RootQueryType', trailers: Array<{ __typename?: 'Trailer', id: number, plate: string, type: TrailerTypeEnum, isRefrigerated: boolean, trackerBrand: TrackerBrandEnum | null, trackerId: string | null, speedLimitDry: number | null, speedLimitWet: number | null, tareWeightKg: string | null, temperatureMax: number | null, temperatureMin: number | null }> };

export type UpdateTrailerMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  params: UpdateTrailerParams;
}>;


export type UpdateTrailerMutation = { __typename?: 'RootMutationType', updateTrailer: { __typename?: 'Trailer', id: number, plate: string, type: TrailerTypeEnum, isRefrigerated: boolean, trackerBrand: TrackerBrandEnum | null, trackerId: string | null, speedLimitDry: number | null, speedLimitWet: number | null, tareWeightKg: string | null, temperatureMax: number | null, temperatureMin: number | null } | null };

export type VehiclesCountQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type VehiclesCountQuery = { __typename?: 'RootQueryType', vehiclesCount: number | null };

export type CreateVehicleMutationVariables = Exact<{
  params: CreateVehicleParams;
}>;


export type CreateVehicleMutation = { __typename?: 'RootMutationType', createVehicle: { __typename?: 'Vehicle', id: number } | null };

export type DeleteVehicleMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteVehicleMutation = { __typename?: 'RootMutationType', deleteVehicle: { __typename?: 'Vehicle', id: number } | null };

export type VehicleQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type VehicleQuery = { __typename?: 'RootQueryType', vehicle: { __typename?: 'Vehicle', id: number, plate: string, type: VehicleTypeEnum, isRefrigerated: boolean, trackerBrand: TrackerBrandEnum | null, trackerId: string | null, speedLimitDry: number | null, speedLimitWet: number | null, tareWeightKg: string | null, temperatureMax: number | null, temperatureMin: number | null } | null };

export type VehiclesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<VehiclePaginationParams>;
}>;


export type VehiclesQuery = { __typename?: 'RootQueryType', vehicles: Array<{ __typename?: 'Vehicle', id: number, plate: string, type: VehicleTypeEnum, isRefrigerated: boolean, speedLimitDry: number | null, speedLimitWet: number | null, tareWeightKg: string | null, temperatureMax: number | null, temperatureMin: number | null, trackerBrand: TrackerBrandEnum | null, trackerId: string | null }> };

export type UpdateVehicleMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  params: UpdateVehicleParams;
}>;


export type UpdateVehicleMutation = { __typename?: 'RootMutationType', updateVehicle: { __typename?: 'Vehicle', id: number, plate: string, type: VehicleTypeEnum, isRefrigerated: boolean, trackerBrand: TrackerBrandEnum | null, trackerId: string | null, speedLimitDry: number | null, speedLimitWet: number | null, tareWeightKg: string | null, temperatureMax: number | null, temperatureMin: number | null } | null };

export type GetCurrentUserDashboardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserDashboardsQuery = { __typename?: 'RootQueryType', currentUser: { __typename?: 'User', id: string | null, currentWorkspace: { __typename?: 'Workspace', currentAccessGroup: { __typename?: 'AccessGroup', id: number, dashboardAccesses: Array<{ __typename?: 'DashboardAccess', dashboard: { __typename?: 'Dashboard', id: number, label: string } }> } } | null } | null };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'RootQueryType', currentUser: { __typename?: 'User', id: string | null, name: string | null, registrationComplete: boolean | null, featureAccesses: Array<{ __typename?: 'FeatureAccessWithSlug', type: AccessEnum, slug: string }>, currentWorkspace: { __typename?: 'Workspace', client: { __typename?: 'Client', id: number, actor: { __typename?: 'Actor', id: number, nickname: string } } | null, currentAccessGroup: { __typename?: 'AccessGroup', id: number, slug: string } } | null, workspaces: Array<{ __typename?: 'Workspace', client: { __typename?: 'Client', id: number } | null }> } | null };

export const SiscomexAttributeFragmentFragmentDoc = gql`
    fragment SiscomexAttributeFragment on SiscomexAttribute {
  code
  validFromAt
  validToAt
  details
}
    `;
export const LpcoFormFieldFragmentFragmentDoc = gql`
    fragment LpcoFormFieldFragment on LpcoFormField {
  code
  parentAttributeCode
  values
  compositeValue
  measurementUnit
  interveners
  siscomexAttribute {
    ...SiscomexAttributeFragment
  }
}
    ${SiscomexAttributeFragmentFragmentDoc}`;
export const SiscomexDocumentFragmentFragmentDoc = gql`
    fragment SiscomexDocumentFragment on SiscomexDocument {
  id
  externalId
  documentTypeName
  fileName
  attachedAt
  read
  discarded
  keywords {
    externalId
    name
    content
  }
}
    `;
export const SalesOrderItemAdditionalFieldsFragmentFragmentDoc = gql`
    fragment SalesOrderItemAdditionalFieldsFragment on SalesOrderItem {
  id
  netWeightKg
  grossWeightKg
  cubageCubicMeters
  dispatchNumber
  measurementUnitSap
  orderItemReference
  orderRequestNumber
  orderUnitValue
  orderTotalValue
  orderCurrency {
    code
  }
  shipmentEquipmentType
  shipmentContainersQuantity
  shipmentPlannedArrivalAt
  shipmentPlannedBoardingAt
  supplierPlannedReadyAt
  supplierEstimatedReadyAt
  supplierReadyAt
  supplierReadyDeviation
  factoryDeliveryAt
  factoryEstimatedDeliveryAt
  itemStatus
  productTranslatedDescription
  productDescription
  productMercosulCode
  necessityType
  ubc
  itemCalculations {
    grossWeight
    netWeight
    cubage
    palletQuantity
  }
  note
  palletQuantity
  palletGrouping
  ipiTaxRate
  iiTaxRate
  cofinsTaxRate
  pisTaxRate
  icmsTaxRate
  specialTreatments
  stockQuantity
  clientApprovedAt
  reservedStockQuantity
  stockReservationAt
  preliminaryPickingStartedAt
  internalContainerReference
}
    `;
export const ProductsDataFragmentDoc = gql`
    fragment ProductsData on Product {
  id
  additionalDetails
  c9Ratio
  category
  code
  contentCapacity
  contentCode
  contentMeasurementUnit
  contentPerPallet
  contentType
  cubagePerPackage
  description
  dumping
  family
  grossWeightPerPackage
  manufacturer
  mercosulCode
  multipleCode
  multiplePackageCapacity
  multiplePackageMeasurementUnit
  multiplePackagePerContainerFt20
  multiplePackagePerContainerFt40
  multiplePackagePerPallet
  multiplePackageType
  netWeightPerPackage
  packageCapacity
  packageCode
  packageMeasurementUnit
  multiplePackagePerContainerFt40
  packagesPerContainerFt20
  packagesPerContainerFt40
  packagesPerPallet
  packageType
  palletsPerContainerFt20
  palletsPerContainerFt40
  translatedDescription
  country {
    code
  }
  internalCodes {
    id
    code
  }
  productForeignOperators {
    id
    nickname
    partnershipAsPartner {
      id
      nicknameWithFallback
    }
  }
}
    `;
export const PurchaseOrderItemAdditionalFieldsFragmentFragmentDoc = gql`
    fragment PurchaseOrderItemAdditionalFieldsFragment on PurchaseOrderItem {
  id
  measurementUnitSap
  netWeightKg
  grossWeightKg
  cubageCubicMeters
  sapByFactor
  concessionAct
  importTypeSap
  orderItemReference
  orderRequestNumber
  orderUnitValue
  orderTotalValue
  orderCurrency {
    code
  }
  orderModalTypeSap
  orderAdjustedModalType
  orderRequestedAt
  planningRequestShippingAt
  planningShippingAt
  supplierSentAt
  supplierConfirmationAt
  supplierReadyLeadTimeDays
  supplierPlannedReadyAt
  supplierEstimatedReadyAt
  supplierReadyAt
  supplierCalculatedReadyAt
  supplierReadyDeviation
  shipmentEquipmentType
  shipmentContainersQuantity
  shipmentPlannedBoardingAt
  shipmentPlannedArrivalAt
  shipmentEstimatedBoardingAt
  shipmentEstimatedArrivalAt
  shipmentBoardingLeadTime
  shipmentTransportLeadTime
  customsEstimatedRegisterAt
  customsRegisterLeadTime
  customsEstimatedReleaseAt
  customsReleaseLeadTime
  factoryEstimatedDeliveryAt
  factoryPlannedDeliveryAt
  factoryDeliveryAt
  factoryDeliveryLeadTime
  adjustedCustomsRegisterLeadTime
  adjustedCustomsReleaseLeadTime
  adjustedFactoryDeliveryLeadTime
  adjustedShipmentBoardingLeadTime
  adjustedShipmentTransportLeadTime
  adjustedSupplierReadyLeadTimeDays
  assessmentSotd
  itemStatus
  division
  note
  palletQuantity
  palletGrouping
  ipiTaxRate
  iiTaxRate
  cofinsTaxRate
  pisTaxRate
  icmsTaxRate
  specialTreatments
  productTranslatedDescription
  productDescription
  productMercosulCode
  itemCalculations {
    grossWeight
    netWeight
    cubage
    palletQuantity
  }
  manufacturingCountry {
    code
  }
  purchaseCountry {
    code
  }
  dispatchingCountry {
    code
  }
  invoiceIssuedAt
  invoiceNumber
  invoiceValue
  invoiceType
  deliveryNote
  deliveryNoteIssuedAt
  shippingDetailsDeliveryDate
  quotationOpeningDate
}
    `;
export const GetForeignTradeOrderDataFragmentDoc = gql`
    fragment GetForeignTradeOrderData on Order {
  id
  alertLevel
  referenceCode
  externalReferenceCode
  canceledAt
  finishedAt
  insertedAt
  type
  extraFields
  subsidiary {
    id
    name
    actor {
      id
    }
  }
  handlers {
    id
    reference
    secondaryReference
    businessUnit
    actor {
      id
    }
    partnership {
      id
      internalCode
      nicknameWithFallback
    }
    operationHandler {
      id
      role
      owner
      showBusinessUnit
      showReference
      showSecondaryReference
      isListedInDynamicList
    }
  }
  ownerHandler {
    id
    actor {
      id
    }
    partnership {
      id
      nicknameWithFallback
      internalCode
    }
    operationHandler {
      id
      role
    }
  }
  operation {
    id
    title
    subtitle
    type
    subType
    actor {
      id
    }
    operationAccess {
      id
      type
      canUpdateCancelledOrFinishedOrders
    }
    operationPhases {
      id
      position
      phase {
        id
        phase
      }
    }
    operationHandlers(filters: {bindingType: [ORDER_HANDLER]}) {
      id
      owner
      role
      isListedInDynamicList
      showBusinessUnit
      showReference
      showSecondaryReference
    }
    orderModalHeaderConfigs(orderId: $id) {
      label
      value
      type
    }
    orderComponents(orderId: $id) {
      id
      name
      slug
      props
      position
      extraFieldsDefinition
      title
      componentAccess {
        id
        type
      }
    }
  }
  observations
  salesOrder {
    id
    type
    orderConfirmedAt
    orderReceivedAt
    items {
      id
      quantity
      balance
      balanceShipped
      lineNumber
      lineReference
      ...SalesOrderItemAdditionalFieldsFragment
      product {
        ...ProductsData
      }
    }
  }
  purchaseOrder {
    id
    type
    supplierOrderAcceptedAt
    supplierExpectedReadinessAt
    supplierOrderSentAt
    supplierReadinessAt
    necessityDate
    items {
      id
      quantity
      balance
      balanceShipped
      division
      lineNumber
      lineReference
      ...PurchaseOrderItemAdditionalFieldsFragment
      product {
        ...ProductsData
      }
    }
  }
  processes(filters: {status: [ONGOING, FINISHED]}) {
    id
    finishedAt
    referenceCode
    currentPhase {
      id
      phase
    }
    orders {
      id
    }
    foreignTradeShipment {
      id
      items {
        id
        quantity
        purchaseOrderItem {
          id
          lineNumber
          lineReference
          productDescription
          productMercosulCode
          productTranslatedDescription
          purchaseOrder {
            id
            order {
              id
              referenceCode
            }
          }
          product {
            ...ProductsData
          }
        }
        salesOrderItem {
          id
          lineNumber
          lineReference
          productDescription
          productMercosulCode
          productTranslatedDescription
          salesOrder {
            id
            order {
              id
              referenceCode
            }
          }
          product {
            ...ProductsData
          }
        }
      }
    }
  }
}
    ${SalesOrderItemAdditionalFieldsFragmentFragmentDoc}
${ProductsDataFragmentDoc}
${PurchaseOrderItemAdditionalFieldsFragmentFragmentDoc}`;
export const CostModelExpenseFieldsFragmentDoc = gql`
    fragment CostModelExpenseFields on CostModelExpense {
  id
  precificationModel
  reference
  referenceValue
  referenceProductProrated
  cost(processId: $processId) {
    id
    cost
    plannedCost
    deviation
    costPerItems {
      itemId
      productId
      cost
      plannedCost
      deviation
    }
  }
  costExpense {
    id
    name
    slug
  }
}
    `;
export const ChildrenModelExpensesFragmentDoc = gql`
    fragment ChildrenModelExpenses on CostModelExpense {
  ...CostModelExpenseFields
  childrenModelExpenses {
    ...CostModelExpenseFields
    childrenModelExpenses {
      ...CostModelExpenseFields
    }
  }
}
    ${CostModelExpenseFieldsFragmentDoc}`;
export const UnitaryCostFragmentFragmentDoc = gql`
    fragment UnitaryCostFragment on UnitaryCost {
  cost
  deviation
  plannedCost
}
    `;
export const ContainerFieldsFragmentFragmentDoc = gql`
    fragment ContainerFieldsFragment on Container {
  id
  code
  type
  sizeFootType
  loadType
  maxWeightKg
  grossWeightKg
  tareWeightKg
  sealCode
  secondarySealCode
  invoiceNumber
  palletQuantity
  isStackable
  cubicMeters
  dispatchNumber
  transportDocument
  actualReturnEmptyContainerAt
  estimatedReturnEmptyContainerAt
  demurrageDailyRateUsd
  demurrageFreeTime
  demurrageFreeTimeStartAt
  route
  internalReferenceCode
  orderNumber
  ncmCodes
  htTreatment
  htTreatmentAt
  separationCompletedAt
  estimatedStuffingAt
  loadingScheduleAt
  invoiceDocumentNumber
  invoiceGrossWeight
  invoiceValue
  preStacking
  preStackingReason
  scaleExitAt
  stackingScheduledAt
  stackingStartedAt
  portScheduledAt
  portDepositDeadlineAt
  portDepositAt
  preStackingWarehouse
  preStackingDays
  emptyPickupAt
  emptyReceivedAtFactory
  oic
  quantity
  releasedForTripAt
  washingValue
  washingChargeReceivedAt
  washingDamageStatus
  washingTermStatus
  washingTermDescription
  washingServiceType
  washingPaymentStatus
  washingPaymentAt
  washingEmptyChecklist
  washingDamageResult
  washingInspection
}
    `;
export const GetProcessDataFragmentDoc = gql`
    fragment GetProcessData on Process {
  id
  alertLevel
  canceledAt
  deletedAt
  finishedAt
  referenceCode
  extraFields
  orders {
    id
    referenceCode
  }
  auditApprovalInfo {
    approvedAt
    approvedBy {
      id
      name
    }
  }
  auditItems {
    id
    observations
    checked
    auditItem {
      id
      name
      showObservationsWhen
    }
  }
  currentPhase {
    id
    phase
  }
  bookingQuotation {
    id
    agentNotes
    documentIds
    recipientIds
    externalPagePublication {
      id
      closesAt
    }
  }
  documents {
    id
    type
    fileUrl
    originalFilename
    updatedAt
    invoice {
      id
    }
    parentDocument {
      id
    }
    brazilianInvoiceInfo {
      accessKey
      cfop
      emittedAt
      extra
      number
      type
      sender {
        cnpj
        name
        address {
          zip
          street
          number
          neighborhood
          city
          state
          country
        }
      }
      transport {
        address
        city
        state
        stateId
        carrier
        cnpj
        brand
        grossWeight
        netWeight
        quantity
        specie
        state
        freightOnAccount
        numeration
        vehiclePlate
      }
      tax {
        base
        discount
        freight
        importation
        insurance
        ipi
        other
        productValue
        totalAmount
        value
      }
      products {
        code
        description
        ncm
        unit
        quantity
        totalAmount
        unitValue
      }
      issuer {
        cnpj
        name
        stateId
        address {
          zip
          street
          number
          neighborhood
          city
          state
          country
        }
      }
    }
  }
  foreignTradeShipment {
    id
    ata
    atd
    eta
    etd
    type
    receivedInWarehouseAt
    departedFromWarehouseAt
    warehouseFreeTimeDays
    deliveredAt
    insertedAt
    statusResponse
    lastUpdatedAt
    automaticTrackingEnabled
    totalNetWeight
    totalGrossWeight
    cubageCubicMeters
    ceMercanteNumber
    ceMercanteAuthorizationStatus
    ceMercanteLastSyncType
    ceMercanteLastSyncErrorMessage
    ceMercanteData {
      id
      number
      issuedAt
      insertedAt
      cargoStatus
      freightPaymentType
      freightBasicCost
      freightTotalCost
      cargoDescription
      grossWeightKg
      hasDta
      manifestArrivalAt
      cargoPresenceInPrimaryZoneAt
      cargoPresenceInSecondaryZoneAt
      customsPlace
      cargoPresenceHistory {
        ra
        status
        date
        dtaNumber
        syncedAt
      }
      containerSeals {
        containerCode
        sealCode
        secondarySealCode
      }
      bl
      consigneeDocument
      consigneeExtraInfo
      notes
      extra
      statusResponse
      lastUpdatedAt
      shippingAgency {
        id
        officialDocument
        nickname
      }
      cargoManifests {
        manifestNumber
        loadingPortTerminal
        dischargePortTerminal
        loadingPortUnlocode
        dischargePortUnlocode
      }
      freightCurrency {
        code
        name
      }
      originPort {
        id
        name
        unlocode
        country {
          code
        }
      }
      destinationPort {
        id
        name
        unlocode
        country {
          code
        }
      }
    }
    internationalTransportLegs {
      arrivalPlace
      departurePlace
      etd
      eta
      atd
      ata
      modalType
      voyage
      vessel {
        id
        name
        imoNumber
      }
    }
    hawbShipmentData {
      id
      status
      hawb
      extra
      dtaNumber
      vehiclePlateDta
      departurePlaceDta
      arrivalPlaceDta
      ataDta
      atdDta
      loadingAirport {
        id
        name
        iataCode
      }
      unloadingAirport {
        id
        name
        iataCode
      }
    }
    parcelShipments {
      id
      ata
      atd
      eta
      etd
      status
      slug
      trackingNumber
      insertedAt
      lastUpdatedAt
      destinationAddress
      originAddress
      destinationCountry {
        code
        name
      }
      events {
        address
        date
        status
      }
      originCountry {
        code
        name
      }
      courier {
        id
        logoUrl
      }
    }
    demurrage {
      id
      freeTime
      dailyRateUsd
      calculations {
        totalExceedingDays
        totalEstimatedCosts
        totalDaysPaid
        totalDaysToPay
        averageCostPerDayUsd
        totalOwedUsd
        totalPaidUsd
        totalToPayUsd
      }
    }
    internationalFreight {
      id
      currency {
        code
      }
      freightForwarder
      quotationNumber
      plannedBoardingDate
      freightCostPrepaid
      freightCostCollect
      freightCostRoad
      freightCostTotal
      type
      bookingEta
      bookingEtd
      voyageNumber
      cargoAttributes
      expectedSeparationAt
      pickupLocation
      portTerminal {
        id
        name
      }
      bookingLoadingAirport {
        id
        name
        iataCode
      }
      bookingDischargeAirport {
        id
        name
        iataCode
      }
      bookingLoadingPort {
        id
        name
        unlocode
      }
      bookingDischargePort {
        id
        name
        unlocode
      }
      sealine {
        id
        name
        logoUrl
      }
      vessel {
        id
        name
        imoNumber
        country {
          code
        }
      }
    }
    items {
      id
      quantity
      netWeightKg
      grossWeightKg
      cubageCubicMeters
      unitValue
      brazilianInvoiceUnitValue
      totalValue
      transportables {
        id
      }
      purchaseOrderItem {
        id
        balance
        balanceShipped
        lineNumber
        lineReference
        quantity
        division
        ...PurchaseOrderItemAdditionalFieldsFragment
        purchaseOrder {
          id
          order {
            id
            referenceCode
          }
        }
        product {
          ...ProductsData
        }
      }
      salesOrderItem {
        id
        balance
        balanceShipped
        lineNumber
        lineReference
        quantity
        ...SalesOrderItemAdditionalFieldsFragment
        salesOrder {
          id
          order {
            id
            referenceCode
          }
        }
        product {
          ...ProductsData
        }
      }
    }
    airTransportShipment {
      id
      type
      awb
      hawb
      airline {
        id
        name
        logoUrl
      }
      destinationAirport {
        id
        name
        iataCode
        country {
          code
        }
      }
      originAirport {
        id
        name
        iataCode
        country {
          code
        }
      }
    }
    roadTransportShipment {
      id
      type
      crt
      origin
      destination
    }
    maritimeTransportShipment {
      id
      bl
      booking
      hbl
      trackingNumber
      trackingKey
      trackingKeyInsertedAt
      trackingDischargePort
      trackingLoadingPort
      type
      voyageNumber
      sealineOrigin
      sealine {
        id
        name
        logoUrl
      }
      dischargePort {
        id
        name
        unlocode
        country {
          code
        }
      }
      loadingPort {
        id
        name
        unlocode
        country {
          code
        }
      }
      vessel {
        id
        name
        imoNumber
        country {
          code
        }
      }
    }
    pallets {
      id
      sizeType
      palletStandardId
      palletStandard {
        id
        name
        isoCode
        eurCode
      }
      lengthMm
      widthMm
      quantity
      heightCm
    }
    transportables {
      id
      type
      container {
        ...ContainerFieldsFragment
        trackingApi
        trackingManual
        hidden
        observations
        debitNotes {
          coverageEndAt
          coverageStartAt
          daysCovered
          id
          number
          payedAt
          totalValueBrl
          totalValueUsd
          usdToBrlRate
        }
        demurrageCalculations {
          costPerDayBrl
          costPerDayUsd
          daysPaid
          daysToPay
          emptyReturnDeadline
          estimatedCosts
          exceedingDays
          totalOwedBrl
          totalOwedUsd
          totalPaidBrl
          totalPaidUsd
          totalToPayBrl
          totalToPayUsd
        }
        events {
          datetime
          estimated
          place
          status
          transport
          voyage
        }
      }
    }
    shipmentDuimps {
      id
      status
      comments
      insertedAt
      automaticLinkOrigin
      lastSyncType
      lastSyncErrorMessage
      duimp {
        id
        channel
        customsClearedAt
        deliveredAt
        extra
        lastUpdatedAt
        number
        registeredAt
        status
        statusResponse
        statusUpdatedAt
        version
        importer {
          id
          officialName
          officialDocument
          documentType
          addresses {
            id
            country
            state
            city
            street
            number
            postalCode
            neighborhood
            formattedAddress
          }
        }
      }
    }
    shipmentImportDeclarations {
      id
      status
      comments
      insertedAt
      automaticLinkOrigin
      lastSyncType
      lastSyncErrorMessage
      importDeclaration {
        id
        channel
        customsClearedAt
        extra
        lastUpdatedAt
        number
        registeredAt
        status
        statusResponse
        statusUpdatedAt
      }
    }
    shipmentExportDeclarations {
      id
      comments
      lastSyncType
      lastSyncErrorMessage
      exportDeclaration {
        id
        number
        channel
        extra
        status
        statusResponse
        endorsedAt
        customsClearedAt
        registeredAt
        insertedAt
        lastUpdatedAt
        events {
          action
          date
          extraInfo
          responsible
        }
      }
    }
    nationalRoadTransports {
      id
      collectionScheduledAt
      deliveryPlannedAt
      isTransportTypeDta
      loadType
      roadTransportType
      transportFeatures
      quantityPallets
      releasedForTransportAt
      transportCompletedAt
      legSlug
      nationalRoadCarrier {
        id
        actor {
          id
          nickname
        }
        partnership {
          id
          nicknameWithFallback
          internalCode
        }
        operationHandler {
          id
          role
        }
      }
      trips {
        id
        driverName
        vehiclePlate
        trailerPlate
        position
        driver {
          id
          name
        }
        vehicle {
          id
          plate
          trackerId
        }
        trailer {
          id
          plate
          trackerId
        }
        phases {
          id
          realizedAt
          departureAt
          estimatedRealizedAt
          routePoint {
            id
            routeType
          }
        }
        transportables {
          id
        }
      }
      route {
        id
        name
        active
        points {
          id
          routeType
          address {
            id
            city
            country
            name
            number
            postalCode
            state
            street
            actor {
              id
              nickname
              partnershipAsPartner {
                id
                nicknameWithFallback
              }
            }
          }
        }
      }
    }
    shipmentImportLicenses {
      id
      status
      comments
      insertedAt
      lastSyncType
      lastSyncErrorMessage
      importLicense {
        id
        approvedAt
        extra
        lastUpdatedAt
        number
        registeredAt
        status
        statusResponse
        statusUpdatedAt
        importDeclaration {
          id
          number
        }
      }
    }
    invoices {
      id
      number
      emittedAt
      updatedAt
      incoterm
      totalAmount
      discount
      finalValue
      totalGrossWeightKg
      items {
        id
        productDescription
        productSku
        quantity
        batchNumber
        batchValidityDate
        productionDate
        totalAmount
        unitaryAmount
        totalGrossWeightKg
        orderReferenceCode
        orderItemLineReference
        product {
          id
        }
        transportables {
          id
          container {
            id
            code
          }
        }
      }
      currency {
        code
      }
    }
    vesselScheduleDeadlineReferences {
      draftDeadlineReference
      vgmDeadlineReference
      cargoDeadlineReference
      gateOpeningDeadlineReference
    }
    vesselSchedule {
      id
      sealineStatusResponse
      portTerminalStatusResponse
      sealineLastUpdatedAt
      portTerminalLastUpdatedAt
      deadlineDates {
        draftDeadline
        cargoDeadline
        vgmDeadline
        gateOpeningDeadline
      }
      sealineVesselSchedules {
        id
        draftDeadline
        cargoDeadline
        specialCargoDraftDeadline
        vgmDeadline
        insertedAt
      }
      portTerminalVesselSchedules {
        id
        draftDeadline
        cargoDeadline
        gateOpening
        reeferGateOpening
        insertedAt
      }
    }
  }
  handlers {
    id
    reference
    secondaryReference
    businessUnit
    actor {
      id
      nickname
      logoUrl
    }
    partnership {
      id
      nicknameWithFallback
      internalCode
    }
    operationHandler {
      id
      role
      isListedInDynamicList
      showBusinessUnit
      showReference
      showSecondaryReference
    }
  }
}
    ${PurchaseOrderItemAdditionalFieldsFragmentFragmentDoc}
${ProductsDataFragmentDoc}
${SalesOrderItemAdditionalFieldsFragmentFragmentDoc}
${ContainerFieldsFragmentFragmentDoc}`;
export const BookingProposalFieldsFragmentDoc = gql`
    fragment BookingProposalFields on BookingProposal {
  id
  number
  serviceType
  transitTimeDays
  coLoader
  routeNotes
  conditions
  originCosts
  originFees
  originDomesticFreight
  internationalFreight
  destinationCosts
  destinationInlandFreight
  originSubtotal
  destinationSubtotal
  total
  representativeness
  insertedAt
  updatedAt
  partnership {
    id
    nicknameWithFallback
  }
  sealine {
    id
    name
    nickname
  }
  loadingPort {
    id
    name
    unlocode
  }
  dischargePort {
    id
    name
    unlocode
  }
  attachments {
    id
    originalFilename
    downloadUrl
  }
}
    `;
export const InsightBasicDataFragmentFragmentDoc = gql`
    fragment InsightBasicDataFragment on Insight {
  id
  explanation
}
    `;
export const ProcessDataOperationFragmentDoc = gql`
    fragment ProcessDataOperation on Operation {
  id
  title
  subtitle
  type
  subType
  isSiscomexEnabled
  isCeMercanteEnabled
  acceptHourInNationalRoadTransports
  configProps {
    isMultipleNationalRoadTransport
    orderItemAdditionalFields
    itemReference
  }
  operationAccess {
    id
    type
    canUpdateCancelledOrFinishedProcesses
    canCloseOrReopenProcessesCosts
    canSeeOrders
  }
  actor {
    id
    nickname
    officialDocument
    documentType
  }
  operationHandlers(filters: {bindingType: [PROCESS_HANDLER]}) {
    id
    owner
    role
    isListedInDynamicList
    showBusinessUnit
    showReference
    showSecondaryReference
  }
}
    `;
export const InsightsProcessFragmentFragmentDoc = gql`
    fragment InsightsProcessFragment on Process {
  id
  referenceCode
  operation {
    id
    title
  }
}
    `;
export const AggregatedCostModelExpenseFieldsFragmentDoc = gql`
    fragment AggregatedCostModelExpenseFields on CostModelExpense {
  id
  calculatedCost {
    realized
    realizedAverage
    planned
    plannedAverage
    deviation
  }
  costExpense {
    id
    name
    slug
  }
}
    `;
export const AggregatedCostChildrenModelExpensesFragmentDoc = gql`
    fragment AggregatedCostChildrenModelExpenses on CostModelExpense {
  ...AggregatedCostModelExpenseFields
  childrenModelExpenses {
    ...AggregatedCostModelExpenseFields
    childrenModelExpenses {
      ...AggregatedCostModelExpenseFields
    }
  }
}
    ${AggregatedCostModelExpenseFieldsFragmentDoc}`;
export const LeadTimesAggregatedDataFragmentDoc = gql`
    fragment LeadTimesAggregatedData on LeadTime {
  deviationPercentage
  differenceHours
  plannedDurationHours
  realizedOrEstimatedDurationHours
  stages {
    deviationPercentage
    model {
      id
      name
      color
    }
    realizedOrEstimated {
      durationHours
    }
    planned {
      durationHours
    }
  }
}
    `;
export const AlertLevelCountFragmentFragmentDoc = gql`
    fragment AlertLevelCountFragment on AlertLevelOverview {
  totalCount
  dangerCount
  warningCount
}
    `;
export const OrdersDataFragmentDoc = gql`
    fragment OrdersData on Order {
  id
  referenceCode
  externalReferenceCode
  insertedAt
  finishedAt
  alertLevel
  type
  extraFields
  automationOrders {
    id
    automation {
      id
      name
    }
  }
  subsidiary {
    id
    name
  }
  processes {
    id
    referenceCode
  }
  operation {
    id
    title
    subType
  }
  handlers {
    id
    businessUnit
    reference
    secondaryReference
    operationHandler {
      id
      role
      showBusinessUnit
      showReference
      showSecondaryReference
    }
    actor {
      id
      nickname
    }
    partnership {
      id
      nicknameWithFallback
      internalCode
      partner {
        id
        documentType
        officialDocument
      }
    }
  }
  observations
  purchaseOrder {
    id
    type
    supplierOrderAcceptedAt
    supplierOrderSentAt
    supplierReadinessAt
    supplierExpectedReadinessAt
    necessityDate
  }
  salesOrder {
    id
    type
    orderConfirmedAt
    orderReceivedAt
  }
}
    `;
export const NationalRoadTranportsDataFragmentDoc = gql`
    fragment NationalRoadTranportsData on ForeignTradeShipment {
  id
  nationalRoadTransports {
    id
    collectionScheduledAt
    deliveryPlannedAt
    loadType
    roadTransportType
    transportFeatures
    releasedForTransportAt
    transportCompletedAt
    legSlug
    route {
      id
      name
    }
    nationalRoadCarrier {
      id
      partnership {
        id
        nicknameWithFallback
        internalCode
      }
    }
    trips {
      id
      driverName
      vehiclePlate
      trailerPlate
      driver {
        id
        name
      }
      vehicle {
        id
        plate
      }
      trailer {
        id
        plate
      }
      transportables(containerHidden: false) {
        id
        container {
          id
          code
        }
      }
    }
  }
}
    `;
export const ContainersDataFragmentDoc = gql`
    fragment ContainersData on ForeignTradeShipment {
  id
  transportables(containerHidden: false) @include(if: $includeContainers) {
    id
    type
    container {
      id
      code
    }
    trips {
      id
      phases {
        id
        routePoint {
          id
          routeType
        }
        realizedAt
      }
    }
  }
}
    `;
export const DefaultForeignTradeShipmentDataFragmentDoc = gql`
    fragment DefaultForeignTradeShipmentData on ForeignTradeShipment {
  id
  type
  ata
  atd
  eta
  etd
  deliveredAt
  receivedInWarehouseAt
  departedFromWarehouseAt
  totalNetWeight
  totalGrossWeight
  cubageCubicMeters
  automaticTrackingEnabled
  statusResponse
  ceMercanteData {
    id
    number
    issuedAt
    cargoStatus
    hasDta
    manifestArrivalAt
    cargoPresenceInPrimaryZoneAt
    cargoPresenceInSecondaryZoneAt
    customsPlace
    cargoPresenceHistory {
      ra
      status
      date
      dtaNumber
      syncedAt
    }
    containerSeals {
      containerCode
      sealCode
      secondarySealCode
    }
    bl
    originPort {
      id
      name
      unlocode
    }
    destinationPort {
      id
      name
      unlocode
    }
  }
  parcelShipments {
    id
    trackingNumber
    slug
  }
  internationalFreight {
    id
    cargoAttributes
    expectedSeparationAt
    pickupLocation
    currency {
      name
      code
    }
    freightForwarder
    quotationNumber
    plannedBoardingDate
    freightCostPrepaid
    freightCostCollect
    freightCostRoad
    freightCostTotal
    type
    bookingEta
    bookingEtd
    sealine {
      id
      name
      logoUrl
    }
    bookingLoadingAirport {
      id
      name
      iataCode
    }
    bookingDischargeAirport {
      id
      name
      iataCode
    }
    bookingLoadingPort {
      id
      name
      unlocode
    }
    bookingDischargePort {
      id
      name
      unlocode
    }
    voyageNumber
    vessel {
      id
      name
      imoNumber
      country {
        code
      }
    }
    portTerminal {
      id
      name
    }
  }
  airTransportShipment {
    awb
    hawb
    destinationAirport {
      id
      name
      iataCode
    }
    id
    originAirport {
      id
      name
      iataCode
    }
    type
    airline {
      id
      name
    }
  }
  demurrage @include(if: $includeDemurrageAny) {
    id
    dailyRateUsd @include(if: $includeDemurrage)
    freeTime @include(if: $includeDemurrage)
    calculations @include(if: $includeDemurrageCalculations) {
      totalExceedingDays
      totalEstimatedCosts
      totalDaysPaid
      totalDaysToPay
      averageCostPerDayUsd
      totalOwedUsd
      totalPaidUsd
      totalToPayUsd
    }
  }
  maritimeTransportShipment {
    id
    type
    bl
    booking
    hbl
    trackingNumber
    trackingLoadingPort
    trackingDischargePort
    voyageNumber
    trackingKey
    sealine {
      id
      logoUrl
      name
    }
    vessel {
      id
      name
    }
    loadingPort {
      id
      unlocode
      name
    }
    dischargePort {
      id
      unlocode
      name
    }
  }
  roadTransportShipment {
    id
    type
    crt
    origin
    destination
  }
  route {
    id
    name
  }
  shipmentDuimps @include(if: $includeShipmentDuimps) {
    id
    duimp {
      id
      number
      registeredAt
      deliveredAt
      customsClearedAt
      channel
      status
    }
  }
  shipmentExportDeclarations @include(if: $includeShipmentExportDeclarations) {
    id
    exportDeclaration {
      id
      number
      registeredAt
      customsClearedAt
      endorsedAt
      channel
      status
    }
  }
  shipmentImportDeclarations @include(if: $includeShipmentImportDeclarations) {
    id
    importDeclaration {
      id
      number
      registeredAt
      customsClearedAt
      channel
      status
    }
  }
  shipmentImportLicenses @include(if: $includeShipmentImportLicenses) {
    id
    importLicense {
      id
      number
      registeredAt
      approvedAt
      status
    }
  }
  invoices {
    id
    number
    emittedAt
    incoterm
    totalAmount
    discount
    finalValue
    totalGrossWeightKg
    currency {
      code
    }
  }
  vesselScheduleDeadlineReferences {
    draftDeadlineReference
    vgmDeadlineReference
    cargoDeadlineReference
    gateOpeningDeadlineReference
  }
  vesselSchedule {
    id
    sealineStatusResponse
    portTerminalStatusResponse
    deadlineDates @include(if: $includeVesselScheduleCalculatedDates) {
      draftDeadline
      cargoDeadline
      vgmDeadline
      gateOpeningDeadline
    }
  }
}
    `;
export const HandlersDataFragmentDoc = gql`
    fragment HandlersData on Handler {
  id
  businessUnit
  reference
  secondaryReference
  operationHandler {
    id
    role
    showBusinessUnit
    showReference
    showSecondaryReference
  }
  partnership {
    id
    nicknameWithFallback
    internalCode
    partner {
      id
      documentType
      officialDocument
    }
  }
}
    `;
export const ProcessesDataFragmentDoc = gql`
    fragment ProcessesData on Process {
  id
  leadTimeDatetimeReference
  referenceCode
  alertLevel
  extraFields
  canceledAt
  finishedAt
  insertedAt
  leadTime @include(if: $includeProcessLeadTime) {
    conclusionDate
    startDate
    plannedConclusionDate
    deviationPercentage
    differenceHours
    isRealized
    status
  }
  plannedLeadTime {
    id
    name
    leadTimeModel {
      id
      ignoreTime
    }
  }
  automationProcesses {
    id
    automation {
      id
      name
    }
  }
  operation {
    id
    title
    subType
  }
  currentPhase {
    id
    phase
  }
  documents @include(if: $includeDocuments) {
    id
    type
    brazilianInvoiceInfo @include(if: $includeProcessBrazilianInvoiceInfo) {
      emittedAt
      number
      accessKey
      tax {
        totalAmount
      }
      transport {
        grossWeight
      }
    }
  }
  handlers {
    ...HandlersData
  }
  ownerHandler {
    ...HandlersData
  }
  orders {
    id
    referenceCode
    externalReferenceCode
    handlers {
      ...HandlersData
    }
  }
}
    ${HandlersDataFragmentDoc}`;
export const ItemsDataFragmentDoc = gql`
    fragment ItemsData on ForeignTradeShipment {
  id
  items {
    id
    quantity
    purchaseOrderItem {
      id
      balance
      quantity
      productTranslatedDescription
      product {
        id
        code
        internalCodes {
          id
          code
        }
      }
    }
    salesOrderItem {
      id
      balance
      quantity
      productTranslatedDescription
      product {
        id
        code
        internalCodes {
          id
          code
        }
      }
    }
  }
}
    `;
export const LinkedContainersDataFragmentDoc = gql`
    fragment LinkedContainersData on Container {
  id
  code
  actualReturnEmptyContainerAt
  estimatedReturnEmptyContainerAt
  invoiceNumber
  sealCode
  secondarySealCode
  grossWeightKg
  maxWeightKg
  tareWeightKg
  loadType
  sizeFootType
  type
  palletQuantity
  demurrageDailyRateUsd
  demurrageFreeTime
  demurrageFreeTimeStartAt
  isStackable
  cubicMeters
  dispatchNumber
  transportDocument
  demurrageCalculations {
    emptyReturnDeadline
    estimatedCosts
    exceedingDays
  }
}
    `;
export const ProductFieldsFragmentDoc = gql`
    fragment ProductFields on Product {
  id
  additionalDetails
  c9Ratio
  category
  code
  contentCapacity
  contentCode
  contentMeasurementUnit
  contentPerPallet
  contentType
  cubagePerPackage
  dumping
  family
  grossWeightPerPackage
  manufacturer
  mercosulCode
  multipleCode
  multiplePackageCapacity
  multiplePackageMeasurementUnit
  multiplePackagePerContainerFt20
  multiplePackagePerContainerFt40
  multiplePackagePerPallet
  multiplePackageType
  netWeightPerPackage
  packageCapacity
  packageCode
  packageMeasurementUnit
  packagesPerContainerFt20
  packagesPerContainerFt40
  packagesPerPallet
  packageType
  palletsPerContainerFt20
  palletsPerContainerFt40
  translatedDescription
  country {
    code
  }
  internalCodes {
    id
    code
  }
  productForeignOperators {
    id
    nickname
    partnershipAsPartner {
      id
      nicknameWithFallback
    }
  }
}
    `;
export const ShipmentItemDataFragmentDoc = gql`
    fragment ShipmentItemData on ForeignTradeItemShipment {
  id
  quantity
  netWeightKg
  grossWeightKg
  cubageCubicMeters
  unitValue
  brazilianInvoiceUnitValue
  totalValue
}
    `;
export const CostModelExpenseFieldsForReportGroupsFragmentDoc = gql`
    fragment CostModelExpenseFieldsForReportGroups on CostModelExpense {
  id
  costExpense {
    id
    name
    slug
  }
}
    `;
export const GetUsersFragmentFragmentDoc = gql`
    fragment GetUsersFragment on User {
  id
  email
  name
  lastLogin
  canEditEmail
  createdBy
  createdAt
  workspaces {
    accessGroups {
      id
      name
    }
  }
}
    `;
export const DeleteLocationDocument = gql`
    mutation DeleteLocation($id: Int!) {
  deleteAddress(id: $id) {
    id
  }
}
    `;
export type DeleteLocationMutationFn = Apollo.MutationFunction<DeleteLocationMutation, DeleteLocationMutationVariables>;

/**
 * __useDeleteLocationMutation__
 *
 * To run a mutation, you first call `useDeleteLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationMutation, { data, loading, error }] = useDeleteLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationMutation, DeleteLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationMutation, DeleteLocationMutationVariables>(DeleteLocationDocument, options);
      }
export type DeleteLocationMutationHookResult = ReturnType<typeof useDeleteLocationMutation>;
export type DeleteLocationMutationResult = Apollo.MutationResult<DeleteLocationMutation>;
export type DeleteLocationMutationOptions = Apollo.BaseMutationOptions<DeleteLocationMutation, DeleteLocationMutationVariables>;
export const UpdateLocationDocument = gql`
    mutation UpdateLocation($id: Int!, $params: UpdateAddressParams!) {
  updateAddress(id: $id, params: $params) {
    id
  }
}
    `;
export type UpdateLocationMutationFn = Apollo.MutationFunction<UpdateLocationMutation, UpdateLocationMutationVariables>;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMutation, { data, loading, error }] = useUpdateLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationMutation, UpdateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationMutation, UpdateLocationMutationVariables>(UpdateLocationDocument, options);
      }
export type UpdateLocationMutationHookResult = ReturnType<typeof useUpdateLocationMutation>;
export type UpdateLocationMutationResult = Apollo.MutationResult<UpdateLocationMutation>;
export type UpdateLocationMutationOptions = Apollo.BaseMutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const AgentEntityRelatedEntitiesMapDocument = gql`
    query AgentEntityRelatedEntitiesMap {
  agentEntityRelatedEntitiesMap {
    entity
    relatedEntities
  }
}
    `;

/**
 * __useAgentEntityRelatedEntitiesMapQuery__
 *
 * To run a query within a React component, call `useAgentEntityRelatedEntitiesMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentEntityRelatedEntitiesMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentEntityRelatedEntitiesMapQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgentEntityRelatedEntitiesMapQuery(baseOptions?: Apollo.QueryHookOptions<AgentEntityRelatedEntitiesMapQuery, AgentEntityRelatedEntitiesMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentEntityRelatedEntitiesMapQuery, AgentEntityRelatedEntitiesMapQueryVariables>(AgentEntityRelatedEntitiesMapDocument, options);
      }
export function useAgentEntityRelatedEntitiesMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentEntityRelatedEntitiesMapQuery, AgentEntityRelatedEntitiesMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentEntityRelatedEntitiesMapQuery, AgentEntityRelatedEntitiesMapQueryVariables>(AgentEntityRelatedEntitiesMapDocument, options);
        }
// @ts-ignore
export function useAgentEntityRelatedEntitiesMapSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgentEntityRelatedEntitiesMapQuery, AgentEntityRelatedEntitiesMapQueryVariables>): Apollo.UseSuspenseQueryResult<AgentEntityRelatedEntitiesMapQuery, AgentEntityRelatedEntitiesMapQueryVariables>;
export function useAgentEntityRelatedEntitiesMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentEntityRelatedEntitiesMapQuery, AgentEntityRelatedEntitiesMapQueryVariables>): Apollo.UseSuspenseQueryResult<AgentEntityRelatedEntitiesMapQuery | undefined, AgentEntityRelatedEntitiesMapQueryVariables>;
export function useAgentEntityRelatedEntitiesMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentEntityRelatedEntitiesMapQuery, AgentEntityRelatedEntitiesMapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentEntityRelatedEntitiesMapQuery, AgentEntityRelatedEntitiesMapQueryVariables>(AgentEntityRelatedEntitiesMapDocument, options);
        }
export type AgentEntityRelatedEntitiesMapQueryHookResult = ReturnType<typeof useAgentEntityRelatedEntitiesMapQuery>;
export type AgentEntityRelatedEntitiesMapLazyQueryHookResult = ReturnType<typeof useAgentEntityRelatedEntitiesMapLazyQuery>;
export type AgentEntityRelatedEntitiesMapSuspenseQueryHookResult = ReturnType<typeof useAgentEntityRelatedEntitiesMapSuspenseQuery>;
export type AgentEntityRelatedEntitiesMapQueryResult = Apollo.QueryResult<AgentEntityRelatedEntitiesMapQuery, AgentEntityRelatedEntitiesMapQueryVariables>;
export const ListProcessorsDocument = gql`
    query ListProcessors {
  processors {
    defaultAction
    description
    icon
    id
    isAi
    isReady
    name
    output
    targetEntities
  }
}
    `;

/**
 * __useListProcessorsQuery__
 *
 * To run a query within a React component, call `useListProcessorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProcessorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProcessorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListProcessorsQuery(baseOptions?: Apollo.QueryHookOptions<ListProcessorsQuery, ListProcessorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProcessorsQuery, ListProcessorsQueryVariables>(ListProcessorsDocument, options);
      }
export function useListProcessorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProcessorsQuery, ListProcessorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProcessorsQuery, ListProcessorsQueryVariables>(ListProcessorsDocument, options);
        }
// @ts-ignore
export function useListProcessorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListProcessorsQuery, ListProcessorsQueryVariables>): Apollo.UseSuspenseQueryResult<ListProcessorsQuery, ListProcessorsQueryVariables>;
export function useListProcessorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProcessorsQuery, ListProcessorsQueryVariables>): Apollo.UseSuspenseQueryResult<ListProcessorsQuery | undefined, ListProcessorsQueryVariables>;
export function useListProcessorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProcessorsQuery, ListProcessorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProcessorsQuery, ListProcessorsQueryVariables>(ListProcessorsDocument, options);
        }
export type ListProcessorsQueryHookResult = ReturnType<typeof useListProcessorsQuery>;
export type ListProcessorsLazyQueryHookResult = ReturnType<typeof useListProcessorsLazyQuery>;
export type ListProcessorsSuspenseQueryHookResult = ReturnType<typeof useListProcessorsSuspenseQuery>;
export type ListProcessorsQueryResult = Apollo.QueryResult<ListProcessorsQuery, ListProcessorsQueryVariables>;
export const CompleteRegistrationDocument = gql`
    mutation CompleteRegistration($params: CompleteRegistrationParams!) {
  completeRegistration(params: $params) {
    id
    registrationComplete
  }
}
    `;
export type CompleteRegistrationMutationFn = Apollo.MutationFunction<CompleteRegistrationMutation, CompleteRegistrationMutationVariables>;

/**
 * __useCompleteRegistrationMutation__
 *
 * To run a mutation, you first call `useCompleteRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeRegistrationMutation, { data, loading, error }] = useCompleteRegistrationMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCompleteRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<CompleteRegistrationMutation, CompleteRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteRegistrationMutation, CompleteRegistrationMutationVariables>(CompleteRegistrationDocument, options);
      }
export type CompleteRegistrationMutationHookResult = ReturnType<typeof useCompleteRegistrationMutation>;
export type CompleteRegistrationMutationResult = Apollo.MutationResult<CompleteRegistrationMutation>;
export type CompleteRegistrationMutationOptions = Apollo.BaseMutationOptions<CompleteRegistrationMutation, CompleteRegistrationMutationVariables>;
export const UpsertCostPerExpenseDocument = gql`
    mutation UpsertCostPerExpense($processId: Int!, $params: CreateCostPerExpenseParams!) {
  upsertCostPerExpense(params: $params) {
    id
    cost
    process {
      id
      costModelVersion {
        id
        version
        costModel {
          id
          name
          hasPlannedCosts
          currency {
            code
            name
          }
        }
        totals(processId: $processId) {
          totalCosts
          plannedCosts
          deviation
        }
        rootModelExpenses {
          ...ChildrenModelExpenses
        }
      }
    }
  }
}
    ${ChildrenModelExpensesFragmentDoc}`;
export type UpsertCostPerExpenseMutationFn = Apollo.MutationFunction<UpsertCostPerExpenseMutation, UpsertCostPerExpenseMutationVariables>;

/**
 * __useUpsertCostPerExpenseMutation__
 *
 * To run a mutation, you first call `useUpsertCostPerExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCostPerExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCostPerExpenseMutation, { data, loading, error }] = useUpsertCostPerExpenseMutation({
 *   variables: {
 *      processId: // value for 'processId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpsertCostPerExpenseMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCostPerExpenseMutation, UpsertCostPerExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCostPerExpenseMutation, UpsertCostPerExpenseMutationVariables>(UpsertCostPerExpenseDocument, options);
      }
export type UpsertCostPerExpenseMutationHookResult = ReturnType<typeof useUpsertCostPerExpenseMutation>;
export type UpsertCostPerExpenseMutationResult = Apollo.MutationResult<UpsertCostPerExpenseMutation>;
export type UpsertCostPerExpenseMutationOptions = Apollo.BaseMutationOptions<UpsertCostPerExpenseMutation, UpsertCostPerExpenseMutationVariables>;
export const CloseCostDocument = gql`
    mutation CloseCost($processId: Int!) {
  closeCost(processId: $processId) {
    id
    costClosedAt
  }
}
    `;
export type CloseCostMutationFn = Apollo.MutationFunction<CloseCostMutation, CloseCostMutationVariables>;

/**
 * __useCloseCostMutation__
 *
 * To run a mutation, you first call `useCloseCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeCostMutation, { data, loading, error }] = useCloseCostMutation({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useCloseCostMutation(baseOptions?: Apollo.MutationHookOptions<CloseCostMutation, CloseCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseCostMutation, CloseCostMutationVariables>(CloseCostDocument, options);
      }
export type CloseCostMutationHookResult = ReturnType<typeof useCloseCostMutation>;
export type CloseCostMutationResult = Apollo.MutationResult<CloseCostMutation>;
export type CloseCostMutationOptions = Apollo.BaseMutationOptions<CloseCostMutation, CloseCostMutationVariables>;
export const ReopenCostDocument = gql`
    mutation ReopenCost($processId: Int!) {
  reopenCost(processId: $processId) {
    id
    costClosedAt
  }
}
    `;
export type ReopenCostMutationFn = Apollo.MutationFunction<ReopenCostMutation, ReopenCostMutationVariables>;

/**
 * __useReopenCostMutation__
 *
 * To run a mutation, you first call `useReopenCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenCostMutation, { data, loading, error }] = useReopenCostMutation({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useReopenCostMutation(baseOptions?: Apollo.MutationHookOptions<ReopenCostMutation, ReopenCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReopenCostMutation, ReopenCostMutationVariables>(ReopenCostDocument, options);
      }
export type ReopenCostMutationHookResult = ReturnType<typeof useReopenCostMutation>;
export type ReopenCostMutationResult = Apollo.MutationResult<ReopenCostMutation>;
export type ReopenCostMutationOptions = Apollo.BaseMutationOptions<ReopenCostMutation, ReopenCostMutationVariables>;
export const GetBookingProposalDocument = gql`
    query GetBookingProposal($id: Int!) {
  bookingProposal(id: $id) {
    id
    number
    serviceType
    transitTimeDays
    coLoader
    routeNotes
    conditions
    originCosts
    originFees
    originDomesticFreight
    internationalFreight
    destinationCosts
    destinationInlandFreight
    total
    representativeness
    insertedAt
    updatedAt
    partnership {
      id
      nicknameWithFallback
    }
    sealine {
      id
      name
      nickname
    }
    loadingPort {
      id
      name
      unlocode
    }
    dischargePort {
      id
      name
      unlocode
    }
    attachments {
      id
      originalFilename
      downloadUrl
    }
  }
}
    `;

/**
 * __useGetBookingProposalQuery__
 *
 * To run a query within a React component, call `useGetBookingProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingProposalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookingProposalQuery(baseOptions: Apollo.QueryHookOptions<GetBookingProposalQuery, GetBookingProposalQueryVariables> & ({ variables: GetBookingProposalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingProposalQuery, GetBookingProposalQueryVariables>(GetBookingProposalDocument, options);
      }
export function useGetBookingProposalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingProposalQuery, GetBookingProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingProposalQuery, GetBookingProposalQueryVariables>(GetBookingProposalDocument, options);
        }
// @ts-ignore
export function useGetBookingProposalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBookingProposalQuery, GetBookingProposalQueryVariables>): Apollo.UseSuspenseQueryResult<GetBookingProposalQuery, GetBookingProposalQueryVariables>;
export function useGetBookingProposalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBookingProposalQuery, GetBookingProposalQueryVariables>): Apollo.UseSuspenseQueryResult<GetBookingProposalQuery | undefined, GetBookingProposalQueryVariables>;
export function useGetBookingProposalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBookingProposalQuery, GetBookingProposalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingProposalQuery, GetBookingProposalQueryVariables>(GetBookingProposalDocument, options);
        }
export type GetBookingProposalQueryHookResult = ReturnType<typeof useGetBookingProposalQuery>;
export type GetBookingProposalLazyQueryHookResult = ReturnType<typeof useGetBookingProposalLazyQuery>;
export type GetBookingProposalSuspenseQueryHookResult = ReturnType<typeof useGetBookingProposalSuspenseQuery>;
export type GetBookingProposalQueryResult = Apollo.QueryResult<GetBookingProposalQuery, GetBookingProposalQueryVariables>;
export const LpcoDocument = gql`
    query Lpco($id: Int!) {
  lpco(id: $id) {
    id
    number
    lastUpdatedAt
    registeredAt
    statusUpdatedAt
    status
    agency
    name
    operationType
    extra
    statusResponse
    modelCode
    validityStart
    validityEnd
    transportMode
    channel
    accessKey
    importerExporterDocument
    extensionPending
    rectificationPending
    compatibilityPending
    importLicenseNumber
    billOfLadingNumber
    shippedAt
    cargoAvailableAt
    feePaymentStatus
    additionalInformation
    statusMessage
    dueInClearance
    insertedAt
    lastSyncType
    lastSyncErrorMessage
    requirements {
      number
      status
      date
      response
      responseDate
      notice
      description
    }
    history {
      status
      updatedAt
      user
      justification
      reason
      solicitation
      solicitationStatus
      updates {
        code
        origin
        name
        originalValue
        updatedValue
      }
    }
    balances {
      title
      commercialQuantity
      statisticalQuantity
      vmle
      netWeight
      financedValue
      saleConditionValue
      vmleCurrency
      financedValueCurrency
      saleConditionValueCurrency
    }
    formFields {
      ...LpcoFormFieldFragment
    }
    lpcoNcms {
      ncmCode
      itemNumber
      productCode
      productVersion
      productRootCnpj
      quotaIdentifier
      quotaDistributionCriteria
      quotaDistributionInstallment
      fields {
        ...LpcoFormFieldFragment
      }
      attributes {
        ...LpcoFormFieldFragment
      }
      siscomexProduct {
        id
        code
        denomination
        description
        version
        rootCnpj
        insertedAt
        lastUpdatedAt
        modality
        situation
        extra
        productAttributes {
          code
          value
          details
        }
        product {
          id
          manufacturer
          siscomexLastSyncType
          lastSyncErrorMessage
          country {
            code
          }
        }
      }
      ncm {
        ncm
        description
        ncmSiscomexAttributes {
          isRequired
          isMultivalued
          operationType
          siscomexAttribute {
            ...SiscomexAttributeFragment
          }
        }
      }
    }
    documents {
      ...SiscomexDocumentFragment
    }
    dossiers {
      id
      number
      typeName
      createdAt
      createdBy
      documents {
        ...SiscomexDocumentFragment
      }
    }
    insights {
      ...InsightBasicDataFragment
    }
  }
}
    ${LpcoFormFieldFragmentFragmentDoc}
${SiscomexAttributeFragmentFragmentDoc}
${SiscomexDocumentFragmentFragmentDoc}
${InsightBasicDataFragmentFragmentDoc}`;

/**
 * __useLpcoQuery__
 *
 * To run a query within a React component, call `useLpcoQuery` and pass it any options that fit your needs.
 * When your component renders, `useLpcoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLpcoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLpcoQuery(baseOptions: Apollo.QueryHookOptions<LpcoQuery, LpcoQueryVariables> & ({ variables: LpcoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LpcoQuery, LpcoQueryVariables>(LpcoDocument, options);
      }
export function useLpcoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LpcoQuery, LpcoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LpcoQuery, LpcoQueryVariables>(LpcoDocument, options);
        }
// @ts-ignore
export function useLpcoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LpcoQuery, LpcoQueryVariables>): Apollo.UseSuspenseQueryResult<LpcoQuery, LpcoQueryVariables>;
export function useLpcoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LpcoQuery, LpcoQueryVariables>): Apollo.UseSuspenseQueryResult<LpcoQuery | undefined, LpcoQueryVariables>;
export function useLpcoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LpcoQuery, LpcoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LpcoQuery, LpcoQueryVariables>(LpcoDocument, options);
        }
export type LpcoQueryHookResult = ReturnType<typeof useLpcoQuery>;
export type LpcoLazyQueryHookResult = ReturnType<typeof useLpcoLazyQuery>;
export type LpcoSuspenseQueryHookResult = ReturnType<typeof useLpcoSuspenseQuery>;
export type LpcoQueryResult = Apollo.QueryResult<LpcoQuery, LpcoQueryVariables>;
export const LpcoSyncSubscriptionDocument = gql`
    subscription LpcoSyncSubscription($id: Int!) {
  lpcoSyncSubscription(id: $id) {
    data {
      id
      lastSyncType
      lastSyncErrorMessage
      lastUpdatedAt
    }
  }
}
    `;

/**
 * __useLpcoSyncSubscriptionSubscription__
 *
 * To run a query within a React component, call `useLpcoSyncSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLpcoSyncSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLpcoSyncSubscriptionSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLpcoSyncSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<LpcoSyncSubscriptionSubscription, LpcoSyncSubscriptionSubscriptionVariables> & ({ variables: LpcoSyncSubscriptionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LpcoSyncSubscriptionSubscription, LpcoSyncSubscriptionSubscriptionVariables>(LpcoSyncSubscriptionDocument, options);
      }
export type LpcoSyncSubscriptionSubscriptionHookResult = ReturnType<typeof useLpcoSyncSubscriptionSubscription>;
export type LpcoSyncSubscriptionSubscriptionResult = Apollo.SubscriptionResult<LpcoSyncSubscriptionSubscription>;
export const SiscomexDocumentDownloadDocument = gql`
    query SiscomexDocumentDownload($id: Int!) {
  siscomexDocumentDownload(id: $id) {
    fileName
    contentType
    base64Content
  }
}
    `;

/**
 * __useSiscomexDocumentDownloadQuery__
 *
 * To run a query within a React component, call `useSiscomexDocumentDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiscomexDocumentDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiscomexDocumentDownloadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSiscomexDocumentDownloadQuery(baseOptions: Apollo.QueryHookOptions<SiscomexDocumentDownloadQuery, SiscomexDocumentDownloadQueryVariables> & ({ variables: SiscomexDocumentDownloadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiscomexDocumentDownloadQuery, SiscomexDocumentDownloadQueryVariables>(SiscomexDocumentDownloadDocument, options);
      }
export function useSiscomexDocumentDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiscomexDocumentDownloadQuery, SiscomexDocumentDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiscomexDocumentDownloadQuery, SiscomexDocumentDownloadQueryVariables>(SiscomexDocumentDownloadDocument, options);
        }
// @ts-ignore
export function useSiscomexDocumentDownloadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SiscomexDocumentDownloadQuery, SiscomexDocumentDownloadQueryVariables>): Apollo.UseSuspenseQueryResult<SiscomexDocumentDownloadQuery, SiscomexDocumentDownloadQueryVariables>;
export function useSiscomexDocumentDownloadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SiscomexDocumentDownloadQuery, SiscomexDocumentDownloadQueryVariables>): Apollo.UseSuspenseQueryResult<SiscomexDocumentDownloadQuery | undefined, SiscomexDocumentDownloadQueryVariables>;
export function useSiscomexDocumentDownloadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SiscomexDocumentDownloadQuery, SiscomexDocumentDownloadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiscomexDocumentDownloadQuery, SiscomexDocumentDownloadQueryVariables>(SiscomexDocumentDownloadDocument, options);
        }
export type SiscomexDocumentDownloadQueryHookResult = ReturnType<typeof useSiscomexDocumentDownloadQuery>;
export type SiscomexDocumentDownloadLazyQueryHookResult = ReturnType<typeof useSiscomexDocumentDownloadLazyQuery>;
export type SiscomexDocumentDownloadSuspenseQueryHookResult = ReturnType<typeof useSiscomexDocumentDownloadSuspenseQuery>;
export type SiscomexDocumentDownloadQueryResult = Apollo.QueryResult<SiscomexDocumentDownloadQuery, SiscomexDocumentDownloadQueryVariables>;
export const TriggerLpcoSyncDocument = gql`
    mutation TriggerLpcoSync($id: Int!) {
  triggerLpcoSync(id: $id) {
    syncing
  }
}
    `;
export type TriggerLpcoSyncMutationFn = Apollo.MutationFunction<TriggerLpcoSyncMutation, TriggerLpcoSyncMutationVariables>;

/**
 * __useTriggerLpcoSyncMutation__
 *
 * To run a mutation, you first call `useTriggerLpcoSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerLpcoSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerLpcoSyncMutation, { data, loading, error }] = useTriggerLpcoSyncMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTriggerLpcoSyncMutation(baseOptions?: Apollo.MutationHookOptions<TriggerLpcoSyncMutation, TriggerLpcoSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerLpcoSyncMutation, TriggerLpcoSyncMutationVariables>(TriggerLpcoSyncDocument, options);
      }
export type TriggerLpcoSyncMutationHookResult = ReturnType<typeof useTriggerLpcoSyncMutation>;
export type TriggerLpcoSyncMutationResult = Apollo.MutationResult<TriggerLpcoSyncMutation>;
export type TriggerLpcoSyncMutationOptions = Apollo.BaseMutationOptions<TriggerLpcoSyncMutation, TriggerLpcoSyncMutationVariables>;
export const GetAgentsForDevModeDocument = gql`
    query GetAgentsForDevMode {
  agents {
    id
    name
    triggerType
    canGenerateCurl
    processor {
      id
      name
      icon
    }
    triggerEventConfig {
      entity
      event
      operationIds
    }
    triggerRecurringConfig {
      inputType
      operationsInputConfig {
        entity
        operationIds
      }
    }
  }
}
    `;

/**
 * __useGetAgentsForDevModeQuery__
 *
 * To run a query within a React component, call `useGetAgentsForDevModeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentsForDevModeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentsForDevModeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgentsForDevModeQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentsForDevModeQuery, GetAgentsForDevModeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentsForDevModeQuery, GetAgentsForDevModeQueryVariables>(GetAgentsForDevModeDocument, options);
      }
export function useGetAgentsForDevModeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentsForDevModeQuery, GetAgentsForDevModeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentsForDevModeQuery, GetAgentsForDevModeQueryVariables>(GetAgentsForDevModeDocument, options);
        }
// @ts-ignore
export function useGetAgentsForDevModeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentsForDevModeQuery, GetAgentsForDevModeQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentsForDevModeQuery, GetAgentsForDevModeQueryVariables>;
export function useGetAgentsForDevModeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentsForDevModeQuery, GetAgentsForDevModeQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentsForDevModeQuery | undefined, GetAgentsForDevModeQueryVariables>;
export function useGetAgentsForDevModeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentsForDevModeQuery, GetAgentsForDevModeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentsForDevModeQuery, GetAgentsForDevModeQueryVariables>(GetAgentsForDevModeDocument, options);
        }
export type GetAgentsForDevModeQueryHookResult = ReturnType<typeof useGetAgentsForDevModeQuery>;
export type GetAgentsForDevModeLazyQueryHookResult = ReturnType<typeof useGetAgentsForDevModeLazyQuery>;
export type GetAgentsForDevModeSuspenseQueryHookResult = ReturnType<typeof useGetAgentsForDevModeSuspenseQuery>;
export type GetAgentsForDevModeQueryResult = Apollo.QueryResult<GetAgentsForDevModeQuery, GetAgentsForDevModeQueryVariables>;
export const RetryAgentTestDocument = gql`
    mutation RetryAgentTest($agentExecutionId: ID!) {
  retryAgentTest(agentExecutionId: $agentExecutionId) {
    id
  }
}
    `;
export type RetryAgentTestMutationFn = Apollo.MutationFunction<RetryAgentTestMutation, RetryAgentTestMutationVariables>;

/**
 * __useRetryAgentTestMutation__
 *
 * To run a mutation, you first call `useRetryAgentTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryAgentTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryAgentTestMutation, { data, loading, error }] = useRetryAgentTestMutation({
 *   variables: {
 *      agentExecutionId: // value for 'agentExecutionId'
 *   },
 * });
 */
export function useRetryAgentTestMutation(baseOptions?: Apollo.MutationHookOptions<RetryAgentTestMutation, RetryAgentTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryAgentTestMutation, RetryAgentTestMutationVariables>(RetryAgentTestDocument, options);
      }
export type RetryAgentTestMutationHookResult = ReturnType<typeof useRetryAgentTestMutation>;
export type RetryAgentTestMutationResult = Apollo.MutationResult<RetryAgentTestMutation>;
export type RetryAgentTestMutationOptions = Apollo.BaseMutationOptions<RetryAgentTestMutation, RetryAgentTestMutationVariables>;
export const RunAgentTestDocument = gql`
    mutation RunAgentTest($params: RunAgentTestParams!) {
  runAgentTest(params: $params) {
    id
  }
}
    `;
export type RunAgentTestMutationFn = Apollo.MutationFunction<RunAgentTestMutation, RunAgentTestMutationVariables>;

/**
 * __useRunAgentTestMutation__
 *
 * To run a mutation, you first call `useRunAgentTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunAgentTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runAgentTestMutation, { data, loading, error }] = useRunAgentTestMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useRunAgentTestMutation(baseOptions?: Apollo.MutationHookOptions<RunAgentTestMutation, RunAgentTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunAgentTestMutation, RunAgentTestMutationVariables>(RunAgentTestDocument, options);
      }
export type RunAgentTestMutationHookResult = ReturnType<typeof useRunAgentTestMutation>;
export type RunAgentTestMutationResult = Apollo.MutationResult<RunAgentTestMutation>;
export type RunAgentTestMutationOptions = Apollo.BaseMutationOptions<RunAgentTestMutation, RunAgentTestMutationVariables>;
export const DeleteAutomationDocument = gql`
    mutation DeleteAutomation($id: Int!) {
  deleteAutomation(id: $id) {
    id
  }
}
    `;
export type DeleteAutomationMutationFn = Apollo.MutationFunction<DeleteAutomationMutation, DeleteAutomationMutationVariables>;

/**
 * __useDeleteAutomationMutation__
 *
 * To run a mutation, you first call `useDeleteAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAutomationMutation, { data, loading, error }] = useDeleteAutomationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAutomationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAutomationMutation, DeleteAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAutomationMutation, DeleteAutomationMutationVariables>(DeleteAutomationDocument, options);
      }
export type DeleteAutomationMutationHookResult = ReturnType<typeof useDeleteAutomationMutation>;
export type DeleteAutomationMutationResult = Apollo.MutationResult<DeleteAutomationMutation>;
export type DeleteAutomationMutationOptions = Apollo.BaseMutationOptions<DeleteAutomationMutation, DeleteAutomationMutationVariables>;
export const GetAutomationsDocument = gql`
    query GetAutomations($id: Int!, $filters: FilterAutomationParams) {
  operation(id: $id) {
    id
    title
    subtitle
    processesFields {
      label
      path
      type
      isList
      options {
        label
        value
      }
    }
    ordersFields {
      label
      path
      type
      isList
      options {
        label
        value
      }
    }
    automationsCount(filters: $filters)
    automations(filters: $filters, pagination: {orderBy: [{field: ID, order: ASC}]}) {
      id
      name
      type
      action
      template
      dateField
      dateFieldLabel
      dateTargetField
      dateTargetFieldLabel
      isEnabled
      periodType
      periodAmount
      confirmationField
      confirmationFieldLabel
      extra
      pathFilters
    }
  }
}
    `;

/**
 * __useGetAutomationsQuery__
 *
 * To run a query within a React component, call `useGetAutomationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAutomationsQuery(baseOptions: Apollo.QueryHookOptions<GetAutomationsQuery, GetAutomationsQueryVariables> & ({ variables: GetAutomationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutomationsQuery, GetAutomationsQueryVariables>(GetAutomationsDocument, options);
      }
export function useGetAutomationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutomationsQuery, GetAutomationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutomationsQuery, GetAutomationsQueryVariables>(GetAutomationsDocument, options);
        }
// @ts-ignore
export function useGetAutomationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAutomationsQuery, GetAutomationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAutomationsQuery, GetAutomationsQueryVariables>;
export function useGetAutomationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAutomationsQuery, GetAutomationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAutomationsQuery | undefined, GetAutomationsQueryVariables>;
export function useGetAutomationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAutomationsQuery, GetAutomationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAutomationsQuery, GetAutomationsQueryVariables>(GetAutomationsDocument, options);
        }
export type GetAutomationsQueryHookResult = ReturnType<typeof useGetAutomationsQuery>;
export type GetAutomationsLazyQueryHookResult = ReturnType<typeof useGetAutomationsLazyQuery>;
export type GetAutomationsSuspenseQueryHookResult = ReturnType<typeof useGetAutomationsSuspenseQuery>;
export type GetAutomationsQueryResult = Apollo.QueryResult<GetAutomationsQuery, GetAutomationsQueryVariables>;
export const UpdateAutomationDocument = gql`
    mutation UpdateAutomation($id: Int!, $params: UpdateAutomationParams!) {
  updateAutomation(id: $id, params: $params) {
    id
  }
}
    `;
export type UpdateAutomationMutationFn = Apollo.MutationFunction<UpdateAutomationMutation, UpdateAutomationMutationVariables>;

/**
 * __useUpdateAutomationMutation__
 *
 * To run a mutation, you first call `useUpdateAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutomationMutation, { data, loading, error }] = useUpdateAutomationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateAutomationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutomationMutation, UpdateAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutomationMutation, UpdateAutomationMutationVariables>(UpdateAutomationDocument, options);
      }
export type UpdateAutomationMutationHookResult = ReturnType<typeof useUpdateAutomationMutation>;
export type UpdateAutomationMutationResult = Apollo.MutationResult<UpdateAutomationMutation>;
export type UpdateAutomationMutationOptions = Apollo.BaseMutationOptions<UpdateAutomationMutation, UpdateAutomationMutationVariables>;
export const BatchUpdateProcessesMutationDocument = gql`
    mutation BatchUpdateProcessesMutation($processIds: [Int!]!, $params: UpdateProcessParams!) {
  batchUpdateProcesses(processIds: $processIds, params: $params)
}
    `;
export type BatchUpdateProcessesMutationMutationFn = Apollo.MutationFunction<BatchUpdateProcessesMutationMutation, BatchUpdateProcessesMutationMutationVariables>;

/**
 * __useBatchUpdateProcessesMutationMutation__
 *
 * To run a mutation, you first call `useBatchUpdateProcessesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchUpdateProcessesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchUpdateProcessesMutationMutation, { data, loading, error }] = useBatchUpdateProcessesMutationMutation({
 *   variables: {
 *      processIds: // value for 'processIds'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useBatchUpdateProcessesMutationMutation(baseOptions?: Apollo.MutationHookOptions<BatchUpdateProcessesMutationMutation, BatchUpdateProcessesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchUpdateProcessesMutationMutation, BatchUpdateProcessesMutationMutationVariables>(BatchUpdateProcessesMutationDocument, options);
      }
export type BatchUpdateProcessesMutationMutationHookResult = ReturnType<typeof useBatchUpdateProcessesMutationMutation>;
export type BatchUpdateProcessesMutationMutationResult = Apollo.MutationResult<BatchUpdateProcessesMutationMutation>;
export type BatchUpdateProcessesMutationMutationOptions = Apollo.BaseMutationOptions<BatchUpdateProcessesMutationMutation, BatchUpdateProcessesMutationMutationVariables>;
export const GetProcessesDataDocument = gql`
    query GetProcessesData($filters: FilterProcessParams, $pathFilters: JSON) {
  processes(filters: $filters, pathFilters: $pathFilters) {
    ...GetProcessData
    operation {
      ...ProcessDataOperation
      operationPhases {
        id
        position
        phase {
          id
          phase
        }
        components {
          id
          name
          title
          slug
          props
          position
          extraFieldsDefinition
          componentAccess {
            id
            type
          }
        }
      }
    }
  }
}
    ${GetProcessDataFragmentDoc}
${ProcessDataOperationFragmentDoc}`;

/**
 * __useGetProcessesDataQuery__
 *
 * To run a query within a React component, call `useGetProcessesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessesDataQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pathFilters: // value for 'pathFilters'
 *   },
 * });
 */
export function useGetProcessesDataQuery(baseOptions?: Apollo.QueryHookOptions<GetProcessesDataQuery, GetProcessesDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessesDataQuery, GetProcessesDataQueryVariables>(GetProcessesDataDocument, options);
      }
export function useGetProcessesDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessesDataQuery, GetProcessesDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessesDataQuery, GetProcessesDataQueryVariables>(GetProcessesDataDocument, options);
        }
// @ts-ignore
export function useGetProcessesDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProcessesDataQuery, GetProcessesDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessesDataQuery, GetProcessesDataQueryVariables>;
export function useGetProcessesDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessesDataQuery, GetProcessesDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessesDataQuery | undefined, GetProcessesDataQueryVariables>;
export function useGetProcessesDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessesDataQuery, GetProcessesDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProcessesDataQuery, GetProcessesDataQueryVariables>(GetProcessesDataDocument, options);
        }
export type GetProcessesDataQueryHookResult = ReturnType<typeof useGetProcessesDataQuery>;
export type GetProcessesDataLazyQueryHookResult = ReturnType<typeof useGetProcessesDataLazyQuery>;
export type GetProcessesDataSuspenseQueryHookResult = ReturnType<typeof useGetProcessesDataSuspenseQuery>;
export type GetProcessesDataQueryResult = Apollo.QueryResult<GetProcessesDataQuery, GetProcessesDataQueryVariables>;
export const CreateAutomationDocument = gql`
    mutation CreateAutomation($params: CreateAutomationParams!) {
  createAutomation(params: $params) {
    id
  }
}
    `;
export type CreateAutomationMutationFn = Apollo.MutationFunction<CreateAutomationMutation, CreateAutomationMutationVariables>;

/**
 * __useCreateAutomationMutation__
 *
 * To run a mutation, you first call `useCreateAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutomationMutation, { data, loading, error }] = useCreateAutomationMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateAutomationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAutomationMutation, CreateAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAutomationMutation, CreateAutomationMutationVariables>(CreateAutomationDocument, options);
      }
export type CreateAutomationMutationHookResult = ReturnType<typeof useCreateAutomationMutation>;
export type CreateAutomationMutationResult = Apollo.MutationResult<CreateAutomationMutation>;
export type CreateAutomationMutationOptions = Apollo.BaseMutationOptions<CreateAutomationMutation, CreateAutomationMutationVariables>;
export const CreateOrderDocument = gql`
    mutation CreateOrder($params: CreateOrderParams!) {
  createOrder(params: $params) {
    id
    route {
      id
      name
    }
  }
}
    `;
export type CreateOrderMutationFn = Apollo.MutationFunction<CreateOrderMutation, CreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderMutation, CreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = Apollo.MutationResult<CreateOrderMutation>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<CreateOrderMutation, CreateOrderMutationVariables>;
export const GetRoutesDocument = gql`
    query GetRoutes {
  routes {
    id
    name
    points {
      id
      routeType
      address {
        id
        street
        number
        city
        state
        name
      }
    }
  }
}
    `;

/**
 * __useGetRoutesQuery__
 *
 * To run a query within a React component, call `useGetRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoutesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRoutesQuery(baseOptions?: Apollo.QueryHookOptions<GetRoutesQuery, GetRoutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoutesQuery, GetRoutesQueryVariables>(GetRoutesDocument, options);
      }
export function useGetRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoutesQuery, GetRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoutesQuery, GetRoutesQueryVariables>(GetRoutesDocument, options);
        }
// @ts-ignore
export function useGetRoutesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoutesQuery, GetRoutesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRoutesQuery, GetRoutesQueryVariables>;
export function useGetRoutesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRoutesQuery, GetRoutesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRoutesQuery | undefined, GetRoutesQueryVariables>;
export function useGetRoutesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRoutesQuery, GetRoutesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoutesQuery, GetRoutesQueryVariables>(GetRoutesDocument, options);
        }
export type GetRoutesQueryHookResult = ReturnType<typeof useGetRoutesQuery>;
export type GetRoutesLazyQueryHookResult = ReturnType<typeof useGetRoutesLazyQuery>;
export type GetRoutesSuspenseQueryHookResult = ReturnType<typeof useGetRoutesSuspenseQuery>;
export type GetRoutesQueryResult = Apollo.QueryResult<GetRoutesQuery, GetRoutesQueryVariables>;
export const CreateProcessDocument = gql`
    mutation CreateProcess($params: CreateProcessParams!) {
  createProcess(params: $params) {
    id
    finishedAt
    alertLevel
    referenceCode
    ownerHandler {
      id
    }
    foreignTradeShipment {
      id
      type
    }
  }
}
    `;
export type CreateProcessMutationFn = Apollo.MutationFunction<CreateProcessMutation, CreateProcessMutationVariables>;

/**
 * __useCreateProcessMutation__
 *
 * To run a mutation, you first call `useCreateProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcessMutation, { data, loading, error }] = useCreateProcessMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateProcessMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcessMutation, CreateProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProcessMutation, CreateProcessMutationVariables>(CreateProcessDocument, options);
      }
export type CreateProcessMutationHookResult = ReturnType<typeof useCreateProcessMutation>;
export type CreateProcessMutationResult = Apollo.MutationResult<CreateProcessMutation>;
export type CreateProcessMutationOptions = Apollo.BaseMutationOptions<CreateProcessMutation, CreateProcessMutationVariables>;
export const GetForeignTradeOrderDocument = gql`
    query GetForeignTradeOrder($id: Int!) {
  order(id: $id) {
    ...GetForeignTradeOrderData
  }
}
    ${GetForeignTradeOrderDataFragmentDoc}`;

/**
 * __useGetForeignTradeOrderQuery__
 *
 * To run a query within a React component, call `useGetForeignTradeOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetForeignTradeOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetForeignTradeOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetForeignTradeOrderQuery(baseOptions: Apollo.QueryHookOptions<GetForeignTradeOrderQuery, GetForeignTradeOrderQueryVariables> & ({ variables: GetForeignTradeOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetForeignTradeOrderQuery, GetForeignTradeOrderQueryVariables>(GetForeignTradeOrderDocument, options);
      }
export function useGetForeignTradeOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetForeignTradeOrderQuery, GetForeignTradeOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetForeignTradeOrderQuery, GetForeignTradeOrderQueryVariables>(GetForeignTradeOrderDocument, options);
        }
// @ts-ignore
export function useGetForeignTradeOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetForeignTradeOrderQuery, GetForeignTradeOrderQueryVariables>): Apollo.UseSuspenseQueryResult<GetForeignTradeOrderQuery, GetForeignTradeOrderQueryVariables>;
export function useGetForeignTradeOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetForeignTradeOrderQuery, GetForeignTradeOrderQueryVariables>): Apollo.UseSuspenseQueryResult<GetForeignTradeOrderQuery | undefined, GetForeignTradeOrderQueryVariables>;
export function useGetForeignTradeOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetForeignTradeOrderQuery, GetForeignTradeOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetForeignTradeOrderQuery, GetForeignTradeOrderQueryVariables>(GetForeignTradeOrderDocument, options);
        }
export type GetForeignTradeOrderQueryHookResult = ReturnType<typeof useGetForeignTradeOrderQuery>;
export type GetForeignTradeOrderLazyQueryHookResult = ReturnType<typeof useGetForeignTradeOrderLazyQuery>;
export type GetForeignTradeOrderSuspenseQueryHookResult = ReturnType<typeof useGetForeignTradeOrderSuspenseQuery>;
export type GetForeignTradeOrderQueryResult = Apollo.QueryResult<GetForeignTradeOrderQuery, GetForeignTradeOrderQueryVariables>;
export const GetOrderPdfDocumentsDocument = gql`
    query GetOrderPDFDocuments($id: Int!) {
  order(id: $id) {
    id
    pdfDocuments {
      id
      name
      props
    }
  }
}
    `;

/**
 * __useGetOrderPdfDocumentsQuery__
 *
 * To run a query within a React component, call `useGetOrderPdfDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderPdfDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderPdfDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderPdfDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetOrderPdfDocumentsQuery, GetOrderPdfDocumentsQueryVariables> & ({ variables: GetOrderPdfDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderPdfDocumentsQuery, GetOrderPdfDocumentsQueryVariables>(GetOrderPdfDocumentsDocument, options);
      }
export function useGetOrderPdfDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderPdfDocumentsQuery, GetOrderPdfDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderPdfDocumentsQuery, GetOrderPdfDocumentsQueryVariables>(GetOrderPdfDocumentsDocument, options);
        }
// @ts-ignore
export function useGetOrderPdfDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrderPdfDocumentsQuery, GetOrderPdfDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderPdfDocumentsQuery, GetOrderPdfDocumentsQueryVariables>;
export function useGetOrderPdfDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderPdfDocumentsQuery, GetOrderPdfDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderPdfDocumentsQuery | undefined, GetOrderPdfDocumentsQueryVariables>;
export function useGetOrderPdfDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderPdfDocumentsQuery, GetOrderPdfDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderPdfDocumentsQuery, GetOrderPdfDocumentsQueryVariables>(GetOrderPdfDocumentsDocument, options);
        }
export type GetOrderPdfDocumentsQueryHookResult = ReturnType<typeof useGetOrderPdfDocumentsQuery>;
export type GetOrderPdfDocumentsLazyQueryHookResult = ReturnType<typeof useGetOrderPdfDocumentsLazyQuery>;
export type GetOrderPdfDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetOrderPdfDocumentsSuspenseQuery>;
export type GetOrderPdfDocumentsQueryResult = Apollo.QueryResult<GetOrderPdfDocumentsQuery, GetOrderPdfDocumentsQueryVariables>;
export const GetOrderPdfDocumentByIdDocument = gql`
    query GetOrderPdfDocumentById($id: Int!, $pdfDocumentId: Int!) {
  order(id: $id) {
    id
    pdfDocument(id: $pdfDocumentId) {
      id
      name
      header
      props
      sections {
        id
        props
        name
        position
        rows {
          id
          fields
          props
          position
        }
      }
    }
    operation {
      id
      actor {
        id
        logoUrl
      }
    }
  }
}
    `;

/**
 * __useGetOrderPdfDocumentByIdQuery__
 *
 * To run a query within a React component, call `useGetOrderPdfDocumentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderPdfDocumentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderPdfDocumentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pdfDocumentId: // value for 'pdfDocumentId'
 *   },
 * });
 */
export function useGetOrderPdfDocumentByIdQuery(baseOptions: Apollo.QueryHookOptions<GetOrderPdfDocumentByIdQuery, GetOrderPdfDocumentByIdQueryVariables> & ({ variables: GetOrderPdfDocumentByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderPdfDocumentByIdQuery, GetOrderPdfDocumentByIdQueryVariables>(GetOrderPdfDocumentByIdDocument, options);
      }
export function useGetOrderPdfDocumentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderPdfDocumentByIdQuery, GetOrderPdfDocumentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderPdfDocumentByIdQuery, GetOrderPdfDocumentByIdQueryVariables>(GetOrderPdfDocumentByIdDocument, options);
        }
// @ts-ignore
export function useGetOrderPdfDocumentByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrderPdfDocumentByIdQuery, GetOrderPdfDocumentByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderPdfDocumentByIdQuery, GetOrderPdfDocumentByIdQueryVariables>;
export function useGetOrderPdfDocumentByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderPdfDocumentByIdQuery, GetOrderPdfDocumentByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderPdfDocumentByIdQuery | undefined, GetOrderPdfDocumentByIdQueryVariables>;
export function useGetOrderPdfDocumentByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderPdfDocumentByIdQuery, GetOrderPdfDocumentByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderPdfDocumentByIdQuery, GetOrderPdfDocumentByIdQueryVariables>(GetOrderPdfDocumentByIdDocument, options);
        }
export type GetOrderPdfDocumentByIdQueryHookResult = ReturnType<typeof useGetOrderPdfDocumentByIdQuery>;
export type GetOrderPdfDocumentByIdLazyQueryHookResult = ReturnType<typeof useGetOrderPdfDocumentByIdLazyQuery>;
export type GetOrderPdfDocumentByIdSuspenseQueryHookResult = ReturnType<typeof useGetOrderPdfDocumentByIdSuspenseQuery>;
export type GetOrderPdfDocumentByIdQueryResult = Apollo.QueryResult<GetOrderPdfDocumentByIdQuery, GetOrderPdfDocumentByIdQueryVariables>;
export const OrderSubscriptionDocument = gql`
    subscription OrderSubscription($id: Int!) {
  order(id: $id) {
    data {
      ...GetForeignTradeOrderData
    }
    latestVersion {
      id
      origin
      user {
        id
        email
      }
    }
  }
}
    ${GetForeignTradeOrderDataFragmentDoc}`;

/**
 * __useOrderSubscriptionSubscription__
 *
 * To run a query within a React component, call `useOrderSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOrderSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSubscriptionSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<OrderSubscriptionSubscription, OrderSubscriptionSubscriptionVariables> & ({ variables: OrderSubscriptionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OrderSubscriptionSubscription, OrderSubscriptionSubscriptionVariables>(OrderSubscriptionDocument, options);
      }
export type OrderSubscriptionSubscriptionHookResult = ReturnType<typeof useOrderSubscriptionSubscription>;
export type OrderSubscriptionSubscriptionResult = Apollo.SubscriptionResult<OrderSubscriptionSubscription>;
export const ListLocalesDocument = gql`
    query ListLocales($filters: FilterAddressesParams) {
  addresses(filters: $filters) {
    id
    city
    country
    latitude
    longitude
    name
    number
    postalCode
    state
    street
    neighborhood
    actor {
      id
      nickname
      partnershipAsPartner {
        id
        nicknameWithFallback
      }
    }
  }
}
    `;

/**
 * __useListLocalesQuery__
 *
 * To run a query within a React component, call `useListLocalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLocalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLocalesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListLocalesQuery(baseOptions?: Apollo.QueryHookOptions<ListLocalesQuery, ListLocalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLocalesQuery, ListLocalesQueryVariables>(ListLocalesDocument, options);
      }
export function useListLocalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLocalesQuery, ListLocalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLocalesQuery, ListLocalesQueryVariables>(ListLocalesDocument, options);
        }
// @ts-ignore
export function useListLocalesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListLocalesQuery, ListLocalesQueryVariables>): Apollo.UseSuspenseQueryResult<ListLocalesQuery, ListLocalesQueryVariables>;
export function useListLocalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLocalesQuery, ListLocalesQueryVariables>): Apollo.UseSuspenseQueryResult<ListLocalesQuery | undefined, ListLocalesQueryVariables>;
export function useListLocalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLocalesQuery, ListLocalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListLocalesQuery, ListLocalesQueryVariables>(ListLocalesDocument, options);
        }
export type ListLocalesQueryHookResult = ReturnType<typeof useListLocalesQuery>;
export type ListLocalesLazyQueryHookResult = ReturnType<typeof useListLocalesLazyQuery>;
export type ListLocalesSuspenseQueryHookResult = ReturnType<typeof useListLocalesSuspenseQuery>;
export type ListLocalesQueryResult = Apollo.QueryResult<ListLocalesQuery, ListLocalesQueryVariables>;
export const GetOrderAutomationsDocument = gql`
    query GetOrderAutomations($id: Int!) {
  order(id: $id) {
    id
    automationOrders {
      id
      triggeredAt
      action
      automation {
        id
        name
        type
        confirmationField
        confirmationFieldLabel
        dateField
        dateFieldLabel
        dateTargetField
        dateTargetFieldLabel
        isEnabled
        periodAmount
        periodType
        template
        extra
        pathFilters
      }
    }
  }
}
    `;

/**
 * __useGetOrderAutomationsQuery__
 *
 * To run a query within a React component, call `useGetOrderAutomationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderAutomationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderAutomationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderAutomationsQuery(baseOptions: Apollo.QueryHookOptions<GetOrderAutomationsQuery, GetOrderAutomationsQueryVariables> & ({ variables: GetOrderAutomationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderAutomationsQuery, GetOrderAutomationsQueryVariables>(GetOrderAutomationsDocument, options);
      }
export function useGetOrderAutomationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderAutomationsQuery, GetOrderAutomationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderAutomationsQuery, GetOrderAutomationsQueryVariables>(GetOrderAutomationsDocument, options);
        }
// @ts-ignore
export function useGetOrderAutomationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrderAutomationsQuery, GetOrderAutomationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderAutomationsQuery, GetOrderAutomationsQueryVariables>;
export function useGetOrderAutomationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderAutomationsQuery, GetOrderAutomationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderAutomationsQuery | undefined, GetOrderAutomationsQueryVariables>;
export function useGetOrderAutomationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderAutomationsQuery, GetOrderAutomationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderAutomationsQuery, GetOrderAutomationsQueryVariables>(GetOrderAutomationsDocument, options);
        }
export type GetOrderAutomationsQueryHookResult = ReturnType<typeof useGetOrderAutomationsQuery>;
export type GetOrderAutomationsLazyQueryHookResult = ReturnType<typeof useGetOrderAutomationsLazyQuery>;
export type GetOrderAutomationsSuspenseQueryHookResult = ReturnType<typeof useGetOrderAutomationsSuspenseQuery>;
export type GetOrderAutomationsQueryResult = Apollo.QueryResult<GetOrderAutomationsQuery, GetOrderAutomationsQueryVariables>;
export const ApproveOrderAuditDocument = gql`
    mutation ApproveOrderAudit($id: Int!) {
  approveOrderAudit(id: $id) {
    id
  }
}
    `;
export type ApproveOrderAuditMutationFn = Apollo.MutationFunction<ApproveOrderAuditMutation, ApproveOrderAuditMutationVariables>;

/**
 * __useApproveOrderAuditMutation__
 *
 * To run a mutation, you first call `useApproveOrderAuditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveOrderAuditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveOrderAuditMutation, { data, loading, error }] = useApproveOrderAuditMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveOrderAuditMutation(baseOptions?: Apollo.MutationHookOptions<ApproveOrderAuditMutation, ApproveOrderAuditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveOrderAuditMutation, ApproveOrderAuditMutationVariables>(ApproveOrderAuditDocument, options);
      }
export type ApproveOrderAuditMutationHookResult = ReturnType<typeof useApproveOrderAuditMutation>;
export type ApproveOrderAuditMutationResult = Apollo.MutationResult<ApproveOrderAuditMutation>;
export type ApproveOrderAuditMutationOptions = Apollo.BaseMutationOptions<ApproveOrderAuditMutation, ApproveOrderAuditMutationVariables>;
export const CancelOrUncancelOrderDocument = gql`
    mutation CancelOrUncancelOrder($id: Int!, $cancelled: Boolean!) {
  cancelOrUncancelOrder(id: $id, cancelled: $cancelled) {
    id
  }
}
    `;
export type CancelOrUncancelOrderMutationFn = Apollo.MutationFunction<CancelOrUncancelOrderMutation, CancelOrUncancelOrderMutationVariables>;

/**
 * __useCancelOrUncancelOrderMutation__
 *
 * To run a mutation, you first call `useCancelOrUncancelOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOrUncancelOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOrUncancelOrderMutation, { data, loading, error }] = useCancelOrUncancelOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      cancelled: // value for 'cancelled'
 *   },
 * });
 */
export function useCancelOrUncancelOrderMutation(baseOptions?: Apollo.MutationHookOptions<CancelOrUncancelOrderMutation, CancelOrUncancelOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelOrUncancelOrderMutation, CancelOrUncancelOrderMutationVariables>(CancelOrUncancelOrderDocument, options);
      }
export type CancelOrUncancelOrderMutationHookResult = ReturnType<typeof useCancelOrUncancelOrderMutation>;
export type CancelOrUncancelOrderMutationResult = Apollo.MutationResult<CancelOrUncancelOrderMutation>;
export type CancelOrUncancelOrderMutationOptions = Apollo.BaseMutationOptions<CancelOrUncancelOrderMutation, CancelOrUncancelOrderMutationVariables>;
export const DeleteOrderDocument = gql`
    mutation DeleteOrder($id: Int!) {
  deleteOrder(id: $id) {
    id
  }
}
    `;
export type DeleteOrderMutationFn = Apollo.MutationFunction<DeleteOrderMutation, DeleteOrderMutationVariables>;

/**
 * __useDeleteOrderMutation__
 *
 * To run a mutation, you first call `useDeleteOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderMutation, { data, loading, error }] = useDeleteOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrderMutation, DeleteOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrderMutation, DeleteOrderMutationVariables>(DeleteOrderDocument, options);
      }
export type DeleteOrderMutationHookResult = ReturnType<typeof useDeleteOrderMutation>;
export type DeleteOrderMutationResult = Apollo.MutationResult<DeleteOrderMutation>;
export type DeleteOrderMutationOptions = Apollo.BaseMutationOptions<DeleteOrderMutation, DeleteOrderMutationVariables>;
export const FinishOrUnfinishOrderDocument = gql`
    mutation FinishOrUnfinishOrder($id: Int!, $finished: Boolean!) {
  finishOrUnfinishOrder(id: $id, finished: $finished) {
    id
    finishedAt
  }
}
    `;
export type FinishOrUnfinishOrderMutationFn = Apollo.MutationFunction<FinishOrUnfinishOrderMutation, FinishOrUnfinishOrderMutationVariables>;

/**
 * __useFinishOrUnfinishOrderMutation__
 *
 * To run a mutation, you first call `useFinishOrUnfinishOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishOrUnfinishOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishOrUnfinishOrderMutation, { data, loading, error }] = useFinishOrUnfinishOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      finished: // value for 'finished'
 *   },
 * });
 */
export function useFinishOrUnfinishOrderMutation(baseOptions?: Apollo.MutationHookOptions<FinishOrUnfinishOrderMutation, FinishOrUnfinishOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishOrUnfinishOrderMutation, FinishOrUnfinishOrderMutationVariables>(FinishOrUnfinishOrderDocument, options);
      }
export type FinishOrUnfinishOrderMutationHookResult = ReturnType<typeof useFinishOrUnfinishOrderMutation>;
export type FinishOrUnfinishOrderMutationResult = Apollo.MutationResult<FinishOrUnfinishOrderMutation>;
export type FinishOrUnfinishOrderMutationOptions = Apollo.BaseMutationOptions<FinishOrUnfinishOrderMutation, FinishOrUnfinishOrderMutationVariables>;
export const GetDocumentsSectionDataDocument = gql`
    query GetDocumentsSectionData($id: Int!) {
  order(id: $id) {
    route {
      id
      name
      points {
        id
        routeType
        address {
          id
          city
          country
          name
          number
          postalCode
          state
          street
        }
      }
    }
    id
    leadTimeDatetimeReference
    roadTransportOrder {
      id
      bl
      diOrDta
      storageExpiration
      type
      vessel
      voyage
      port
      importer
      roadTransportShipments {
        id
        vehicle {
          id
          type
          trackerBrand
          trackerId
          plate
        }
        shipmentDrivers {
          id
          driver {
            id
            name
          }
        }
        shipmentTrailers {
          id
          trailer {
            id
            type
            plate
          }
        }
        transportables {
          id
          type
          container {
            id
            type
            sealCode
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetDocumentsSectionDataQuery__
 *
 * To run a query within a React component, call `useGetDocumentsSectionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsSectionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsSectionDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDocumentsSectionDataQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentsSectionDataQuery, GetDocumentsSectionDataQueryVariables> & ({ variables: GetDocumentsSectionDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentsSectionDataQuery, GetDocumentsSectionDataQueryVariables>(GetDocumentsSectionDataDocument, options);
      }
export function useGetDocumentsSectionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentsSectionDataQuery, GetDocumentsSectionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentsSectionDataQuery, GetDocumentsSectionDataQueryVariables>(GetDocumentsSectionDataDocument, options);
        }
// @ts-ignore
export function useGetDocumentsSectionDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentsSectionDataQuery, GetDocumentsSectionDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentsSectionDataQuery, GetDocumentsSectionDataQueryVariables>;
export function useGetDocumentsSectionDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentsSectionDataQuery, GetDocumentsSectionDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentsSectionDataQuery | undefined, GetDocumentsSectionDataQueryVariables>;
export function useGetDocumentsSectionDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentsSectionDataQuery, GetDocumentsSectionDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentsSectionDataQuery, GetDocumentsSectionDataQueryVariables>(GetDocumentsSectionDataDocument, options);
        }
export type GetDocumentsSectionDataQueryHookResult = ReturnType<typeof useGetDocumentsSectionDataQuery>;
export type GetDocumentsSectionDataLazyQueryHookResult = ReturnType<typeof useGetDocumentsSectionDataLazyQuery>;
export type GetDocumentsSectionDataSuspenseQueryHookResult = ReturnType<typeof useGetDocumentsSectionDataSuspenseQuery>;
export type GetDocumentsSectionDataQueryResult = Apollo.QueryResult<GetDocumentsSectionDataQuery, GetDocumentsSectionDataQueryVariables>;
export const GetOrderDataDocument = gql`
    query GetOrderData($id: Int!, $filters: FilterProcessParams) {
  order(id: $id) {
    id
    alertLevel
    referenceCode
    externalReferenceCode
    type
    insertedAt
    finishedAt
    subsidiary {
      id
      name
      actor {
        id
      }
    }
    handlers {
      id
      reference
      secondaryReference
      businessUnit
      actor {
        id
      }
      operationHandler {
        id
        role
        showBusinessUnit
        showReference
        showSecondaryReference
      }
    }
    currentPhase {
      id
      phase
    }
    auditApprovalInfo {
      approvedAt
      approvedBy {
        id
        name
      }
    }
    auditItems {
      id
      observations
      checked
      auditItem {
        id
        name
        showObservationsWhen
      }
    }
    handler(role: CARGO_OWNER) {
      id
      reference
      secondaryReference
      actor {
        id
        nickname
        officialDocument
        documentType
        partnershipAsPartner {
          id
          nicknameWithFallback
        }
      }
      operationHandler {
        id
        showBusinessUnit
        showReference
        showSecondaryReference
      }
    }
    route {
      id
      name
      points {
        id
        routeType
        address {
          id
          city
          country
          name
          number
          postalCode
          state
          street
          actor {
            id
            nickname
            partnershipAsPartner {
              id
              nicknameWithFallback
            }
          }
        }
      }
    }
    operation {
      id
      title
      subtitle
      type
      subType
      operationAccess {
        id
        type
      }
      operationPhases {
        id
        position
        phase {
          id
          phase
        }
      }
      actor {
        id
        nickname
        officialDocument
        documentType
        partnershipAsPartner {
          id
          nicknameWithFallback
        }
      }
    }
    documents {
      id
      type
      fileUrl
      originalFilename
    }
    leadTimeDatetimeReference
    observations
    salesOrder {
      id
      type
      orderConfirmedAt
      orderReceivedAt
      items {
        id
        quantity
        balance
        balanceShipped
        lineNumber
        product {
          id
          code
        }
        productDescription
      }
    }
    purchaseOrder {
      id
      type
      supplierOrderAcceptedAt
      supplierExpectedReadinessAt
      supplierOrderSentAt
      necessityDate
      items {
        id
        quantity
        balance
        balanceShipped
        lineNumber
        division
        product {
          id
          code
        }
        productDescription
      }
    }
    roadTransportOrder {
      id
      bl
      diOrDta
      storageExpiration
      releasedForTransport
      schedulingFinishedAt
      type
      vessel
      voyage
      port
      importer
      observations
      sealine {
        id
        name
        nickname
      }
      transportSpecifications
      booking
      draftDeadline
      cargoDeadline
      destinationCountry
      transportSpecifications
      observations
      roadTransportShipments {
        id
        clientArrivalAt
        clientDepartureAt
        invoiceExchangeStartAt
        invoiceExchangeEndAt
        startAt
        endAt
        emptyContainerReturnScheduledDate
        arrivalInTerminalScheduledDate
        vehicle {
          id
          isRefrigerated
          plate
          speedLimitDry
          speedLimitWet
          tareWeightKg
          temperatureMax
          temperatureMin
          trackerBrand
          trackerId
          type
        }
        shipmentDrivers {
          id
          ciot
          missingAmount
          isFullyPaid
          totalAmountToPay
          amountPaidInAdvance
          driver {
            id
            name
            cpf
            licenseNumber
            licenseCategory
          }
          roadTransportShipment {
            id
          }
        }
        shipmentTrailers {
          id
          trailer {
            id
            isRefrigerated
            plate
            speedLimitDry
            speedLimitWet
            tareWeightKg
            temperatureMax
            temperatureMin
            trackerBrand
            trackerId
            type
          }
        }
        transportables {
          id
          type
          container {
            id
            code
            grossWeightKg
            invoiceNumber
            sealCode
            secondarySealCode
            sizeFootType
            tareWeightKg
            loadType
            maxWeightKg
            type
            isStackable
            cubicMeters
            dispatchNumber
            transportDocument
          }
        }
      }
      transportables {
        id
        type
        cargo {
          id
          cubicWeight
          dimensions
          measurementUnit
          quantity
          volumeCubicMeters
          weightKg
        }
        container {
          id
          code
          grossWeightKg
          maxWeightKg
          loadType
          sealCode
          secondarySealCode
          sizeFootType
          tareWeightKg
          invoiceNumber
          type
          isStackable
          cubicMeters
          dispatchNumber
          transportDocument
        }
        roadTransportShipment {
          id
        }
      }
    }
    processes(filters: $filters) {
      id
      finishedAt
      referenceCode
      currentPhase {
        id
        phase
      }
      orders {
        id
      }
      foreignTradeShipment {
        id
        items {
          id
          quantity
          purchaseOrderItem {
            id
            productDescription
            product {
              id
              code
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrderDataQuery__
 *
 * To run a query within a React component, call `useGetOrderDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetOrderDataQuery(baseOptions: Apollo.QueryHookOptions<GetOrderDataQuery, GetOrderDataQueryVariables> & ({ variables: GetOrderDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderDataQuery, GetOrderDataQueryVariables>(GetOrderDataDocument, options);
      }
export function useGetOrderDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderDataQuery, GetOrderDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderDataQuery, GetOrderDataQueryVariables>(GetOrderDataDocument, options);
        }
// @ts-ignore
export function useGetOrderDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrderDataQuery, GetOrderDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderDataQuery, GetOrderDataQueryVariables>;
export function useGetOrderDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderDataQuery, GetOrderDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderDataQuery | undefined, GetOrderDataQueryVariables>;
export function useGetOrderDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderDataQuery, GetOrderDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderDataQuery, GetOrderDataQueryVariables>(GetOrderDataDocument, options);
        }
export type GetOrderDataQueryHookResult = ReturnType<typeof useGetOrderDataQuery>;
export type GetOrderDataLazyQueryHookResult = ReturnType<typeof useGetOrderDataLazyQuery>;
export type GetOrderDataSuspenseQueryHookResult = ReturnType<typeof useGetOrderDataSuspenseQuery>;
export type GetOrderDataQueryResult = Apollo.QueryResult<GetOrderDataQuery, GetOrderDataQueryVariables>;
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($id: Int!, $params: UpdateOrderParams!) {
  updateOrder(id: $id, params: $params) {
    id
  }
}
    `;
export type UpdateOrderMutationFn = Apollo.MutationFunction<UpdateOrderMutation, UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const UploadDocumentsToOrderDocument = gql`
    mutation uploadDocumentsToOrder($orderId: Int!, $params: [CreateDocumentParams!]!) {
  uploadDocumentsToOrder(orderId: $orderId, params: $params) {
    id
  }
}
    `;
export type UploadDocumentsToOrderMutationFn = Apollo.MutationFunction<UploadDocumentsToOrderMutation, UploadDocumentsToOrderMutationVariables>;

/**
 * __useUploadDocumentsToOrderMutation__
 *
 * To run a mutation, you first call `useUploadDocumentsToOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDocumentsToOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDocumentsToOrderMutation, { data, loading, error }] = useUploadDocumentsToOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUploadDocumentsToOrderMutation(baseOptions?: Apollo.MutationHookOptions<UploadDocumentsToOrderMutation, UploadDocumentsToOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDocumentsToOrderMutation, UploadDocumentsToOrderMutationVariables>(UploadDocumentsToOrderDocument, options);
      }
export type UploadDocumentsToOrderMutationHookResult = ReturnType<typeof useUploadDocumentsToOrderMutation>;
export type UploadDocumentsToOrderMutationResult = Apollo.MutationResult<UploadDocumentsToOrderMutation>;
export type UploadDocumentsToOrderMutationOptions = Apollo.BaseMutationOptions<UploadDocumentsToOrderMutation, UploadDocumentsToOrderMutationVariables>;
export const GetProcessAutomationsDocument = gql`
    query GetProcessAutomations($id: Int!) {
  process(id: $id) {
    id
    automationProcesses {
      id
      triggeredAt
      action
      automation {
        id
        name
        confirmationField
        confirmationFieldLabel
        dateField
        dateFieldLabel
        dateTargetField
        dateTargetFieldLabel
        isEnabled
        periodAmount
        periodType
        template
        extra
        pathFilters
      }
    }
  }
}
    `;

/**
 * __useGetProcessAutomationsQuery__
 *
 * To run a query within a React component, call `useGetProcessAutomationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessAutomationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessAutomationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProcessAutomationsQuery(baseOptions: Apollo.QueryHookOptions<GetProcessAutomationsQuery, GetProcessAutomationsQueryVariables> & ({ variables: GetProcessAutomationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessAutomationsQuery, GetProcessAutomationsQueryVariables>(GetProcessAutomationsDocument, options);
      }
export function useGetProcessAutomationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessAutomationsQuery, GetProcessAutomationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessAutomationsQuery, GetProcessAutomationsQueryVariables>(GetProcessAutomationsDocument, options);
        }
// @ts-ignore
export function useGetProcessAutomationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProcessAutomationsQuery, GetProcessAutomationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessAutomationsQuery, GetProcessAutomationsQueryVariables>;
export function useGetProcessAutomationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessAutomationsQuery, GetProcessAutomationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessAutomationsQuery | undefined, GetProcessAutomationsQueryVariables>;
export function useGetProcessAutomationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessAutomationsQuery, GetProcessAutomationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProcessAutomationsQuery, GetProcessAutomationsQueryVariables>(GetProcessAutomationsDocument, options);
        }
export type GetProcessAutomationsQueryHookResult = ReturnType<typeof useGetProcessAutomationsQuery>;
export type GetProcessAutomationsLazyQueryHookResult = ReturnType<typeof useGetProcessAutomationsLazyQuery>;
export type GetProcessAutomationsSuspenseQueryHookResult = ReturnType<typeof useGetProcessAutomationsSuspenseQuery>;
export type GetProcessAutomationsQueryResult = Apollo.QueryResult<GetProcessAutomationsQuery, GetProcessAutomationsQueryVariables>;
export const GetProcessCostsDocument = gql`
    query GetProcessCosts($processId: Int!) {
  process(id: $processId) {
    id
    costClosedAt
    itemCostsPerReference {
      costItems {
        itemId
        reference
        totalReference
        measurementUnit
        totalCosts {
          ...UnitaryCostFragment
        }
        unitaryCosts {
          ...UnitaryCostFragment
        }
      }
      totals {
        reference
        totalReference
        measurementUnit
        totalCosts {
          ...UnitaryCostFragment
        }
        unitaryCosts {
          ...UnitaryCostFragment
        }
      }
    }
    costModelVersion {
      id
      version
      costModel {
        id
        name
        hasPlannedCosts
        hasCostPerProduct
        hasCostPerProductUnitary
        currency {
          code
          name
          symbol
        }
      }
      totals(processId: $processId) {
        totalCosts
        plannedCosts
        deviation
        costPerItemsTotals {
          itemId
          productId
          totalCosts
          plannedCosts
          deviation
        }
        costPerItemExpenseTotals {
          expenseId
          totalCosts
          plannedCosts
          deviation
        }
      }
      rootModelExpenses {
        ...ChildrenModelExpenses
      }
    }
    operation {
      id
      subType
    }
  }
}
    ${UnitaryCostFragmentFragmentDoc}
${ChildrenModelExpensesFragmentDoc}`;

/**
 * __useGetProcessCostsQuery__
 *
 * To run a query within a React component, call `useGetProcessCostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessCostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessCostsQuery({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useGetProcessCostsQuery(baseOptions: Apollo.QueryHookOptions<GetProcessCostsQuery, GetProcessCostsQueryVariables> & ({ variables: GetProcessCostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessCostsQuery, GetProcessCostsQueryVariables>(GetProcessCostsDocument, options);
      }
export function useGetProcessCostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessCostsQuery, GetProcessCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessCostsQuery, GetProcessCostsQueryVariables>(GetProcessCostsDocument, options);
        }
// @ts-ignore
export function useGetProcessCostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProcessCostsQuery, GetProcessCostsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessCostsQuery, GetProcessCostsQueryVariables>;
export function useGetProcessCostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessCostsQuery, GetProcessCostsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessCostsQuery | undefined, GetProcessCostsQueryVariables>;
export function useGetProcessCostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessCostsQuery, GetProcessCostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProcessCostsQuery, GetProcessCostsQueryVariables>(GetProcessCostsDocument, options);
        }
export type GetProcessCostsQueryHookResult = ReturnType<typeof useGetProcessCostsQuery>;
export type GetProcessCostsLazyQueryHookResult = ReturnType<typeof useGetProcessCostsLazyQuery>;
export type GetProcessCostsSuspenseQueryHookResult = ReturnType<typeof useGetProcessCostsSuspenseQuery>;
export type GetProcessCostsQueryResult = Apollo.QueryResult<GetProcessCostsQuery, GetProcessCostsQueryVariables>;
export const GetProcessDocumentsDocument = gql`
    query GetProcessDocuments($id: Int!) {
  process(id: $id) {
    id
    pdfDocuments {
      id
      name
      props
    }
  }
}
    `;

/**
 * __useGetProcessDocumentsQuery__
 *
 * To run a query within a React component, call `useGetProcessDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProcessDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetProcessDocumentsQuery, GetProcessDocumentsQueryVariables> & ({ variables: GetProcessDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessDocumentsQuery, GetProcessDocumentsQueryVariables>(GetProcessDocumentsDocument, options);
      }
export function useGetProcessDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessDocumentsQuery, GetProcessDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessDocumentsQuery, GetProcessDocumentsQueryVariables>(GetProcessDocumentsDocument, options);
        }
// @ts-ignore
export function useGetProcessDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProcessDocumentsQuery, GetProcessDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessDocumentsQuery, GetProcessDocumentsQueryVariables>;
export function useGetProcessDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessDocumentsQuery, GetProcessDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessDocumentsQuery | undefined, GetProcessDocumentsQueryVariables>;
export function useGetProcessDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessDocumentsQuery, GetProcessDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProcessDocumentsQuery, GetProcessDocumentsQueryVariables>(GetProcessDocumentsDocument, options);
        }
export type GetProcessDocumentsQueryHookResult = ReturnType<typeof useGetProcessDocumentsQuery>;
export type GetProcessDocumentsLazyQueryHookResult = ReturnType<typeof useGetProcessDocumentsLazyQuery>;
export type GetProcessDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetProcessDocumentsSuspenseQuery>;
export type GetProcessDocumentsQueryResult = Apollo.QueryResult<GetProcessDocumentsQuery, GetProcessDocumentsQueryVariables>;
export const GetProcessPdfDocumentByIdDocument = gql`
    query GetProcessPdfDocumentById($id: Int!, $pdfDocumentId: Int!) {
  process(id: $id) {
    id
    pdfDocument(id: $pdfDocumentId) {
      id
      name
      header
      props
      sections {
        id
        props
        name
        position
        rows {
          id
          fields
          props
          position
        }
      }
    }
    operation {
      id
      actor {
        id
        logoUrl
      }
    }
  }
}
    `;

/**
 * __useGetProcessPdfDocumentByIdQuery__
 *
 * To run a query within a React component, call `useGetProcessPdfDocumentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessPdfDocumentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessPdfDocumentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pdfDocumentId: // value for 'pdfDocumentId'
 *   },
 * });
 */
export function useGetProcessPdfDocumentByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProcessPdfDocumentByIdQuery, GetProcessPdfDocumentByIdQueryVariables> & ({ variables: GetProcessPdfDocumentByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessPdfDocumentByIdQuery, GetProcessPdfDocumentByIdQueryVariables>(GetProcessPdfDocumentByIdDocument, options);
      }
export function useGetProcessPdfDocumentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessPdfDocumentByIdQuery, GetProcessPdfDocumentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessPdfDocumentByIdQuery, GetProcessPdfDocumentByIdQueryVariables>(GetProcessPdfDocumentByIdDocument, options);
        }
// @ts-ignore
export function useGetProcessPdfDocumentByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProcessPdfDocumentByIdQuery, GetProcessPdfDocumentByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessPdfDocumentByIdQuery, GetProcessPdfDocumentByIdQueryVariables>;
export function useGetProcessPdfDocumentByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessPdfDocumentByIdQuery, GetProcessPdfDocumentByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessPdfDocumentByIdQuery | undefined, GetProcessPdfDocumentByIdQueryVariables>;
export function useGetProcessPdfDocumentByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessPdfDocumentByIdQuery, GetProcessPdfDocumentByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProcessPdfDocumentByIdQuery, GetProcessPdfDocumentByIdQueryVariables>(GetProcessPdfDocumentByIdDocument, options);
        }
export type GetProcessPdfDocumentByIdQueryHookResult = ReturnType<typeof useGetProcessPdfDocumentByIdQuery>;
export type GetProcessPdfDocumentByIdLazyQueryHookResult = ReturnType<typeof useGetProcessPdfDocumentByIdLazyQuery>;
export type GetProcessPdfDocumentByIdSuspenseQueryHookResult = ReturnType<typeof useGetProcessPdfDocumentByIdSuspenseQuery>;
export type GetProcessPdfDocumentByIdQueryResult = Apollo.QueryResult<GetProcessPdfDocumentByIdQuery, GetProcessPdfDocumentByIdQueryVariables>;
export const GetProcessVersionsDocument = gql`
    query GetProcessVersions($id: Int!, $filters: FilterVersionParams, $pagination: VersionPaginationParams) {
  process(id: $id) {
    id
    versionsCount(filters: $filters)
    versions(filters: $filters, pagination: $pagination) {
      apiKeyName
      id
      event
      insertedAt
      processedChanges
      itemType
      origin
      originatorId
      meta
      user {
        id
        name
        email
      }
    }
    operation {
      id
      operationPhases {
        id
        components(processId: $id) {
          id
          slug
          name
          title
          extraFieldsDefinition
        }
      }
    }
  }
}
    `;

/**
 * __useGetProcessVersionsQuery__
 *
 * To run a query within a React component, call `useGetProcessVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessVersionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetProcessVersionsQuery(baseOptions: Apollo.QueryHookOptions<GetProcessVersionsQuery, GetProcessVersionsQueryVariables> & ({ variables: GetProcessVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessVersionsQuery, GetProcessVersionsQueryVariables>(GetProcessVersionsDocument, options);
      }
export function useGetProcessVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessVersionsQuery, GetProcessVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessVersionsQuery, GetProcessVersionsQueryVariables>(GetProcessVersionsDocument, options);
        }
// @ts-ignore
export function useGetProcessVersionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProcessVersionsQuery, GetProcessVersionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessVersionsQuery, GetProcessVersionsQueryVariables>;
export function useGetProcessVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessVersionsQuery, GetProcessVersionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessVersionsQuery | undefined, GetProcessVersionsQueryVariables>;
export function useGetProcessVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessVersionsQuery, GetProcessVersionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProcessVersionsQuery, GetProcessVersionsQueryVariables>(GetProcessVersionsDocument, options);
        }
export type GetProcessVersionsQueryHookResult = ReturnType<typeof useGetProcessVersionsQuery>;
export type GetProcessVersionsLazyQueryHookResult = ReturnType<typeof useGetProcessVersionsLazyQuery>;
export type GetProcessVersionsSuspenseQueryHookResult = ReturnType<typeof useGetProcessVersionsSuspenseQuery>;
export type GetProcessVersionsQueryResult = Apollo.QueryResult<GetProcessVersionsQuery, GetProcessVersionsQueryVariables>;
export const ProcessAuditorStatusDocument = gql`
    query ProcessAuditorStatus($processId: Int!) {
  processAuditorStatus(processId: $processId) {
    isRunning
    canTrigger
    cooldownUntil
    lastRunAt
    agentExecutionId
  }
}
    `;

/**
 * __useProcessAuditorStatusQuery__
 *
 * To run a query within a React component, call `useProcessAuditorStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessAuditorStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessAuditorStatusQuery({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useProcessAuditorStatusQuery(baseOptions: Apollo.QueryHookOptions<ProcessAuditorStatusQuery, ProcessAuditorStatusQueryVariables> & ({ variables: ProcessAuditorStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessAuditorStatusQuery, ProcessAuditorStatusQueryVariables>(ProcessAuditorStatusDocument, options);
      }
export function useProcessAuditorStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessAuditorStatusQuery, ProcessAuditorStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessAuditorStatusQuery, ProcessAuditorStatusQueryVariables>(ProcessAuditorStatusDocument, options);
        }
// @ts-ignore
export function useProcessAuditorStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProcessAuditorStatusQuery, ProcessAuditorStatusQueryVariables>): Apollo.UseSuspenseQueryResult<ProcessAuditorStatusQuery, ProcessAuditorStatusQueryVariables>;
export function useProcessAuditorStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProcessAuditorStatusQuery, ProcessAuditorStatusQueryVariables>): Apollo.UseSuspenseQueryResult<ProcessAuditorStatusQuery | undefined, ProcessAuditorStatusQueryVariables>;
export function useProcessAuditorStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProcessAuditorStatusQuery, ProcessAuditorStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProcessAuditorStatusQuery, ProcessAuditorStatusQueryVariables>(ProcessAuditorStatusDocument, options);
        }
export type ProcessAuditorStatusQueryHookResult = ReturnType<typeof useProcessAuditorStatusQuery>;
export type ProcessAuditorStatusLazyQueryHookResult = ReturnType<typeof useProcessAuditorStatusLazyQuery>;
export type ProcessAuditorStatusSuspenseQueryHookResult = ReturnType<typeof useProcessAuditorStatusSuspenseQuery>;
export type ProcessAuditorStatusQueryResult = Apollo.QueryResult<ProcessAuditorStatusQuery, ProcessAuditorStatusQueryVariables>;
export const SetInsightFeedbackDocument = gql`
    mutation SetInsightFeedback($insightId: Int!, $status: InsightStatusEnum!, $dismissReason: InsightDismissReasonEnum, $comment: String) {
  setInsightFeedback(
    insightId: $insightId
    status: $status
    dismissReason: $dismissReason
    comment: $comment
  ) {
    id
    status
    dismissReason
    feedbackAt
    feedbackComment
  }
}
    `;
export type SetInsightFeedbackMutationFn = Apollo.MutationFunction<SetInsightFeedbackMutation, SetInsightFeedbackMutationVariables>;

/**
 * __useSetInsightFeedbackMutation__
 *
 * To run a mutation, you first call `useSetInsightFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInsightFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInsightFeedbackMutation, { data, loading, error }] = useSetInsightFeedbackMutation({
 *   variables: {
 *      insightId: // value for 'insightId'
 *      status: // value for 'status'
 *      dismissReason: // value for 'dismissReason'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSetInsightFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SetInsightFeedbackMutation, SetInsightFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetInsightFeedbackMutation, SetInsightFeedbackMutationVariables>(SetInsightFeedbackDocument, options);
      }
export type SetInsightFeedbackMutationHookResult = ReturnType<typeof useSetInsightFeedbackMutation>;
export type SetInsightFeedbackMutationResult = Apollo.MutationResult<SetInsightFeedbackMutation>;
export type SetInsightFeedbackMutationOptions = Apollo.BaseMutationOptions<SetInsightFeedbackMutation, SetInsightFeedbackMutationVariables>;
export const TriggerAuditAgentDocument = gql`
    mutation TriggerAuditAgent($processId: Int!) {
  triggerAuditAgent(processId: $processId) {
    isRunning
    canTrigger
    cooldownUntil
    lastRunAt
    agentExecutionId
  }
}
    `;
export type TriggerAuditAgentMutationFn = Apollo.MutationFunction<TriggerAuditAgentMutation, TriggerAuditAgentMutationVariables>;

/**
 * __useTriggerAuditAgentMutation__
 *
 * To run a mutation, you first call `useTriggerAuditAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerAuditAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerAuditAgentMutation, { data, loading, error }] = useTriggerAuditAgentMutation({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useTriggerAuditAgentMutation(baseOptions?: Apollo.MutationHookOptions<TriggerAuditAgentMutation, TriggerAuditAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerAuditAgentMutation, TriggerAuditAgentMutationVariables>(TriggerAuditAgentDocument, options);
      }
export type TriggerAuditAgentMutationHookResult = ReturnType<typeof useTriggerAuditAgentMutation>;
export type TriggerAuditAgentMutationResult = Apollo.MutationResult<TriggerAuditAgentMutation>;
export type TriggerAuditAgentMutationOptions = Apollo.BaseMutationOptions<TriggerAuditAgentMutation, TriggerAuditAgentMutationVariables>;
export const GetProcessLeadTimeDocument = gql`
    query GetProcessLeadTime($id: Int!) {
  process(id: $id) {
    id
    leadTimeDatetimeReference
    plannedLeadTime {
      id
      name
      leadTimeModel {
        id
        ignoreTime
      }
    }
    leadTime {
      conclusionDate
      deviationPercentage
      differenceHours
      plannedDurationHours
      isRealized
      processRealizedDatesByEvent
      hasErrors
      status
      errors {
        date
        path
        status
      }
      stages {
        model {
          id
          name
          color
          endEvent
          endEventLabel
          startEvent
          startEventLabel
        }
        planned {
          durationHours
          endedAt
          startedAt
        }
        realizedOrEstimated {
          durationHours
          endedAt
          startedAt
        }
      }
      realizedOrEstimatedDurationHours
    }
    leadTimeMarkers {
      label
      path
      value
    }
    operation {
      id
      subType
    }
  }
}
    `;

/**
 * __useGetProcessLeadTimeQuery__
 *
 * To run a query within a React component, call `useGetProcessLeadTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessLeadTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessLeadTimeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProcessLeadTimeQuery(baseOptions: Apollo.QueryHookOptions<GetProcessLeadTimeQuery, GetProcessLeadTimeQueryVariables> & ({ variables: GetProcessLeadTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessLeadTimeQuery, GetProcessLeadTimeQueryVariables>(GetProcessLeadTimeDocument, options);
      }
export function useGetProcessLeadTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessLeadTimeQuery, GetProcessLeadTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessLeadTimeQuery, GetProcessLeadTimeQueryVariables>(GetProcessLeadTimeDocument, options);
        }
// @ts-ignore
export function useGetProcessLeadTimeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProcessLeadTimeQuery, GetProcessLeadTimeQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessLeadTimeQuery, GetProcessLeadTimeQueryVariables>;
export function useGetProcessLeadTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessLeadTimeQuery, GetProcessLeadTimeQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessLeadTimeQuery | undefined, GetProcessLeadTimeQueryVariables>;
export function useGetProcessLeadTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessLeadTimeQuery, GetProcessLeadTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProcessLeadTimeQuery, GetProcessLeadTimeQueryVariables>(GetProcessLeadTimeDocument, options);
        }
export type GetProcessLeadTimeQueryHookResult = ReturnType<typeof useGetProcessLeadTimeQuery>;
export type GetProcessLeadTimeLazyQueryHookResult = ReturnType<typeof useGetProcessLeadTimeLazyQuery>;
export type GetProcessLeadTimeSuspenseQueryHookResult = ReturnType<typeof useGetProcessLeadTimeSuspenseQuery>;
export type GetProcessLeadTimeQueryResult = Apollo.QueryResult<GetProcessLeadTimeQuery, GetProcessLeadTimeQueryVariables>;
export const ApproveProcessAuditDocument = gql`
    mutation ApproveProcessAudit($id: Int!) {
  approveProcessAudit(id: $id) {
    id
  }
}
    `;
export type ApproveProcessAuditMutationFn = Apollo.MutationFunction<ApproveProcessAuditMutation, ApproveProcessAuditMutationVariables>;

/**
 * __useApproveProcessAuditMutation__
 *
 * To run a mutation, you first call `useApproveProcessAuditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveProcessAuditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveProcessAuditMutation, { data, loading, error }] = useApproveProcessAuditMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveProcessAuditMutation(baseOptions?: Apollo.MutationHookOptions<ApproveProcessAuditMutation, ApproveProcessAuditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveProcessAuditMutation, ApproveProcessAuditMutationVariables>(ApproveProcessAuditDocument, options);
      }
export type ApproveProcessAuditMutationHookResult = ReturnType<typeof useApproveProcessAuditMutation>;
export type ApproveProcessAuditMutationResult = Apollo.MutationResult<ApproveProcessAuditMutation>;
export type ApproveProcessAuditMutationOptions = Apollo.BaseMutationOptions<ApproveProcessAuditMutation, ApproveProcessAuditMutationVariables>;
export const CancelOrUncancelProcessDocument = gql`
    mutation CancelOrUncancelProcess($id: Int!, $cancelled: Boolean!) {
  cancelOrUncancelProcess(id: $id, cancelled: $cancelled) {
    id
  }
}
    `;
export type CancelOrUncancelProcessMutationFn = Apollo.MutationFunction<CancelOrUncancelProcessMutation, CancelOrUncancelProcessMutationVariables>;

/**
 * __useCancelOrUncancelProcessMutation__
 *
 * To run a mutation, you first call `useCancelOrUncancelProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOrUncancelProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOrUncancelProcessMutation, { data, loading, error }] = useCancelOrUncancelProcessMutation({
 *   variables: {
 *      id: // value for 'id'
 *      cancelled: // value for 'cancelled'
 *   },
 * });
 */
export function useCancelOrUncancelProcessMutation(baseOptions?: Apollo.MutationHookOptions<CancelOrUncancelProcessMutation, CancelOrUncancelProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelOrUncancelProcessMutation, CancelOrUncancelProcessMutationVariables>(CancelOrUncancelProcessDocument, options);
      }
export type CancelOrUncancelProcessMutationHookResult = ReturnType<typeof useCancelOrUncancelProcessMutation>;
export type CancelOrUncancelProcessMutationResult = Apollo.MutationResult<CancelOrUncancelProcessMutation>;
export type CancelOrUncancelProcessMutationOptions = Apollo.BaseMutationOptions<CancelOrUncancelProcessMutation, CancelOrUncancelProcessMutationVariables>;
export const DeleteProcessDocument = gql`
    mutation DeleteProcess($id: Int!) {
  deleteProcess(id: $id) {
    id
  }
}
    `;
export type DeleteProcessMutationFn = Apollo.MutationFunction<DeleteProcessMutation, DeleteProcessMutationVariables>;

/**
 * __useDeleteProcessMutation__
 *
 * To run a mutation, you first call `useDeleteProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProcessMutation, { data, loading, error }] = useDeleteProcessMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProcessMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProcessMutation, DeleteProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProcessMutation, DeleteProcessMutationVariables>(DeleteProcessDocument, options);
      }
export type DeleteProcessMutationHookResult = ReturnType<typeof useDeleteProcessMutation>;
export type DeleteProcessMutationResult = Apollo.MutationResult<DeleteProcessMutation>;
export type DeleteProcessMutationOptions = Apollo.BaseMutationOptions<DeleteProcessMutation, DeleteProcessMutationVariables>;
export const FinishOrUnfinishProcessDocument = gql`
    mutation FinishOrUnfinishProcess($id: Int!, $finished: Boolean!) {
  finishOrUnfinishProcess(id: $id, finished: $finished) {
    id
  }
}
    `;
export type FinishOrUnfinishProcessMutationFn = Apollo.MutationFunction<FinishOrUnfinishProcessMutation, FinishOrUnfinishProcessMutationVariables>;

/**
 * __useFinishOrUnfinishProcessMutation__
 *
 * To run a mutation, you first call `useFinishOrUnfinishProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishOrUnfinishProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishOrUnfinishProcessMutation, { data, loading, error }] = useFinishOrUnfinishProcessMutation({
 *   variables: {
 *      id: // value for 'id'
 *      finished: // value for 'finished'
 *   },
 * });
 */
export function useFinishOrUnfinishProcessMutation(baseOptions?: Apollo.MutationHookOptions<FinishOrUnfinishProcessMutation, FinishOrUnfinishProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishOrUnfinishProcessMutation, FinishOrUnfinishProcessMutationVariables>(FinishOrUnfinishProcessDocument, options);
      }
export type FinishOrUnfinishProcessMutationHookResult = ReturnType<typeof useFinishOrUnfinishProcessMutation>;
export type FinishOrUnfinishProcessMutationResult = Apollo.MutationResult<FinishOrUnfinishProcessMutation>;
export type FinishOrUnfinishProcessMutationOptions = Apollo.BaseMutationOptions<FinishOrUnfinishProcessMutation, FinishOrUnfinishProcessMutationVariables>;
export const GetProcessPartialOperationDocument = gql`
    query GetProcessPartialOperation($id: Int!) {
  operation(id: $id) {
    id
    autoGenerateProcessCode
    acceptHourInNationalRoadTransports
    configProps {
      isMultipleNationalRoadTransport
      internationalModal
      itemReference
      isOrderRequiredWhenCreatingProcess
    }
  }
}
    `;

/**
 * __useGetProcessPartialOperationQuery__
 *
 * To run a query within a React component, call `useGetProcessPartialOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessPartialOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessPartialOperationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProcessPartialOperationQuery(baseOptions: Apollo.QueryHookOptions<GetProcessPartialOperationQuery, GetProcessPartialOperationQueryVariables> & ({ variables: GetProcessPartialOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessPartialOperationQuery, GetProcessPartialOperationQueryVariables>(GetProcessPartialOperationDocument, options);
      }
export function useGetProcessPartialOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessPartialOperationQuery, GetProcessPartialOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessPartialOperationQuery, GetProcessPartialOperationQueryVariables>(GetProcessPartialOperationDocument, options);
        }
// @ts-ignore
export function useGetProcessPartialOperationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProcessPartialOperationQuery, GetProcessPartialOperationQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessPartialOperationQuery, GetProcessPartialOperationQueryVariables>;
export function useGetProcessPartialOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessPartialOperationQuery, GetProcessPartialOperationQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessPartialOperationQuery | undefined, GetProcessPartialOperationQueryVariables>;
export function useGetProcessPartialOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessPartialOperationQuery, GetProcessPartialOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProcessPartialOperationQuery, GetProcessPartialOperationQueryVariables>(GetProcessPartialOperationDocument, options);
        }
export type GetProcessPartialOperationQueryHookResult = ReturnType<typeof useGetProcessPartialOperationQuery>;
export type GetProcessPartialOperationLazyQueryHookResult = ReturnType<typeof useGetProcessPartialOperationLazyQuery>;
export type GetProcessPartialOperationSuspenseQueryHookResult = ReturnType<typeof useGetProcessPartialOperationSuspenseQuery>;
export type GetProcessPartialOperationQueryResult = Apollo.QueryResult<GetProcessPartialOperationQuery, GetProcessPartialOperationQueryVariables>;
export const GetProcessDocument = gql`
    query GetProcess($id: Int!) {
  process(id: $id) {
    ...GetProcessData
    operation {
      ...ProcessDataOperation
      processModalHeaderConfigs(processId: $id) {
        label
        value
        type
      }
      operationPhases {
        id
        position
        phase {
          id
          phase
        }
        components(processId: $id) {
          id
          name
          title
          slug
          props
          position
          extraFieldsDefinition
          componentAccess {
            id
            type
          }
        }
      }
    }
  }
}
    ${GetProcessDataFragmentDoc}
${ProcessDataOperationFragmentDoc}`;

/**
 * __useGetProcessQuery__
 *
 * To run a query within a React component, call `useGetProcessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProcessQuery(baseOptions: Apollo.QueryHookOptions<GetProcessQuery, GetProcessQueryVariables> & ({ variables: GetProcessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessQuery, GetProcessQueryVariables>(GetProcessDocument, options);
      }
export function useGetProcessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessQuery, GetProcessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessQuery, GetProcessQueryVariables>(GetProcessDocument, options);
        }
// @ts-ignore
export function useGetProcessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProcessQuery, GetProcessQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessQuery, GetProcessQueryVariables>;
export function useGetProcessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessQuery, GetProcessQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessQuery | undefined, GetProcessQueryVariables>;
export function useGetProcessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessQuery, GetProcessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProcessQuery, GetProcessQueryVariables>(GetProcessDocument, options);
        }
export type GetProcessQueryHookResult = ReturnType<typeof useGetProcessQuery>;
export type GetProcessLazyQueryHookResult = ReturnType<typeof useGetProcessLazyQuery>;
export type GetProcessSuspenseQueryHookResult = ReturnType<typeof useGetProcessSuspenseQuery>;
export type GetProcessQueryResult = Apollo.QueryResult<GetProcessQuery, GetProcessQueryVariables>;
export const ProcessSubscriptionDocument = gql`
    subscription ProcessSubscription($id: Int!) {
  process(id: $id) {
    data {
      ...GetProcessData
      operation {
        ...ProcessDataOperation
        processModalHeaderConfigs(processId: $id) {
          label
          value
          type
        }
        operationPhases {
          id
          position
          phase {
            id
            phase
          }
          components(processId: $id) {
            id
            name
            title
            slug
            props
            position
            extraFieldsDefinition
            componentAccess {
              id
              type
            }
          }
        }
      }
    }
    latestVersion {
      id
      origin
      user {
        id
        email
      }
    }
  }
}
    ${GetProcessDataFragmentDoc}
${ProcessDataOperationFragmentDoc}`;

/**
 * __useProcessSubscriptionSubscription__
 *
 * To run a query within a React component, call `useProcessSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProcessSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessSubscriptionSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProcessSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<ProcessSubscriptionSubscription, ProcessSubscriptionSubscriptionVariables> & ({ variables: ProcessSubscriptionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ProcessSubscriptionSubscription, ProcessSubscriptionSubscriptionVariables>(ProcessSubscriptionDocument, options);
      }
export type ProcessSubscriptionSubscriptionHookResult = ReturnType<typeof useProcessSubscriptionSubscription>;
export type ProcessSubscriptionSubscriptionResult = Apollo.SubscriptionResult<ProcessSubscriptionSubscription>;
export const UpdateProcessDocument = gql`
    mutation UpdateProcess($id: Int!, $params: UpdateProcessParams!) {
  updateProcess(id: $id, params: $params) {
    id
  }
}
    `;
export type UpdateProcessMutationFn = Apollo.MutationFunction<UpdateProcessMutation, UpdateProcessMutationVariables>;

/**
 * __useUpdateProcessMutation__
 *
 * To run a mutation, you first call `useUpdateProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcessMutation, { data, loading, error }] = useUpdateProcessMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateProcessMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcessMutation, UpdateProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProcessMutation, UpdateProcessMutationVariables>(UpdateProcessDocument, options);
      }
export type UpdateProcessMutationHookResult = ReturnType<typeof useUpdateProcessMutation>;
export type UpdateProcessMutationResult = Apollo.MutationResult<UpdateProcessMutation>;
export type UpdateProcessMutationOptions = Apollo.BaseMutationOptions<UpdateProcessMutation, UpdateProcessMutationVariables>;
export const UploadDocumentsToProcessDocument = gql`
    mutation UploadDocumentsToProcess($id: Int!, $params: [CreateDocumentParams!]!) {
  uploadDocumentsToProcess(processId: $id, params: $params) {
    id
  }
}
    `;
export type UploadDocumentsToProcessMutationFn = Apollo.MutationFunction<UploadDocumentsToProcessMutation, UploadDocumentsToProcessMutationVariables>;

/**
 * __useUploadDocumentsToProcessMutation__
 *
 * To run a mutation, you first call `useUploadDocumentsToProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDocumentsToProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDocumentsToProcessMutation, { data, loading, error }] = useUploadDocumentsToProcessMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUploadDocumentsToProcessMutation(baseOptions?: Apollo.MutationHookOptions<UploadDocumentsToProcessMutation, UploadDocumentsToProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDocumentsToProcessMutation, UploadDocumentsToProcessMutationVariables>(UploadDocumentsToProcessDocument, options);
      }
export type UploadDocumentsToProcessMutationHookResult = ReturnType<typeof useUploadDocumentsToProcessMutation>;
export type UploadDocumentsToProcessMutationResult = Apollo.MutationResult<UploadDocumentsToProcessMutation>;
export type UploadDocumentsToProcessMutationOptions = Apollo.BaseMutationOptions<UploadDocumentsToProcessMutation, UploadDocumentsToProcessMutationVariables>;
export const GetOrderPartialOperationDocument = gql`
    query GetOrderPartialOperation($id: Int!) {
  operation(id: $id) {
    id
    autoGenerateOrderCode
    subType
    configProps {
      showExternalReferenceCode
      orderItemAdditionalFields
      itemReference
    }
    operationHandlers(filters: {bindingType: [ORDER_HANDLER]}) {
      id
      owner
      role
      isListedInDynamicList
      showBusinessUnit
      showReference
      showSecondaryReference
    }
    orderComponents {
      id
      name
      slug
      props
      position
      extraFieldsDefinition
      title
      componentAccess {
        id
        type
      }
    }
  }
}
    `;

/**
 * __useGetOrderPartialOperationQuery__
 *
 * To run a query within a React component, call `useGetOrderPartialOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderPartialOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderPartialOperationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderPartialOperationQuery(baseOptions: Apollo.QueryHookOptions<GetOrderPartialOperationQuery, GetOrderPartialOperationQueryVariables> & ({ variables: GetOrderPartialOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderPartialOperationQuery, GetOrderPartialOperationQueryVariables>(GetOrderPartialOperationDocument, options);
      }
export function useGetOrderPartialOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderPartialOperationQuery, GetOrderPartialOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderPartialOperationQuery, GetOrderPartialOperationQueryVariables>(GetOrderPartialOperationDocument, options);
        }
// @ts-ignore
export function useGetOrderPartialOperationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrderPartialOperationQuery, GetOrderPartialOperationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderPartialOperationQuery, GetOrderPartialOperationQueryVariables>;
export function useGetOrderPartialOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderPartialOperationQuery, GetOrderPartialOperationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderPartialOperationQuery | undefined, GetOrderPartialOperationQueryVariables>;
export function useGetOrderPartialOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderPartialOperationQuery, GetOrderPartialOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderPartialOperationQuery, GetOrderPartialOperationQueryVariables>(GetOrderPartialOperationDocument, options);
        }
export type GetOrderPartialOperationQueryHookResult = ReturnType<typeof useGetOrderPartialOperationQuery>;
export type GetOrderPartialOperationLazyQueryHookResult = ReturnType<typeof useGetOrderPartialOperationLazyQuery>;
export type GetOrderPartialOperationSuspenseQueryHookResult = ReturnType<typeof useGetOrderPartialOperationSuspenseQuery>;
export type GetOrderPartialOperationQueryResult = Apollo.QueryResult<GetOrderPartialOperationQuery, GetOrderPartialOperationQueryVariables>;
export const GetContainerTypeEnumValuesDocument = gql`
    query GetContainerTypeEnumValues {
  __type(name: "ContainerTypeEnum") {
    name
    enumValues {
      name
      description
    }
  }
}
    `;

/**
 * __useGetContainerTypeEnumValuesQuery__
 *
 * To run a query within a React component, call `useGetContainerTypeEnumValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContainerTypeEnumValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContainerTypeEnumValuesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContainerTypeEnumValuesQuery(baseOptions?: Apollo.QueryHookOptions<GetContainerTypeEnumValuesQuery, GetContainerTypeEnumValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContainerTypeEnumValuesQuery, GetContainerTypeEnumValuesQueryVariables>(GetContainerTypeEnumValuesDocument, options);
      }
export function useGetContainerTypeEnumValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContainerTypeEnumValuesQuery, GetContainerTypeEnumValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContainerTypeEnumValuesQuery, GetContainerTypeEnumValuesQueryVariables>(GetContainerTypeEnumValuesDocument, options);
        }
// @ts-ignore
export function useGetContainerTypeEnumValuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContainerTypeEnumValuesQuery, GetContainerTypeEnumValuesQueryVariables>): Apollo.UseSuspenseQueryResult<GetContainerTypeEnumValuesQuery, GetContainerTypeEnumValuesQueryVariables>;
export function useGetContainerTypeEnumValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContainerTypeEnumValuesQuery, GetContainerTypeEnumValuesQueryVariables>): Apollo.UseSuspenseQueryResult<GetContainerTypeEnumValuesQuery | undefined, GetContainerTypeEnumValuesQueryVariables>;
export function useGetContainerTypeEnumValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContainerTypeEnumValuesQuery, GetContainerTypeEnumValuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContainerTypeEnumValuesQuery, GetContainerTypeEnumValuesQueryVariables>(GetContainerTypeEnumValuesDocument, options);
        }
export type GetContainerTypeEnumValuesQueryHookResult = ReturnType<typeof useGetContainerTypeEnumValuesQuery>;
export type GetContainerTypeEnumValuesLazyQueryHookResult = ReturnType<typeof useGetContainerTypeEnumValuesLazyQuery>;
export type GetContainerTypeEnumValuesSuspenseQueryHookResult = ReturnType<typeof useGetContainerTypeEnumValuesSuspenseQuery>;
export type GetContainerTypeEnumValuesQueryResult = Apollo.QueryResult<GetContainerTypeEnumValuesQuery, GetContainerTypeEnumValuesQueryVariables>;
export const GetLoadTypeEnumValuesDocument = gql`
    query GetLoadTypeEnumValues {
  __type(name: "LoadTypeEnum") {
    name
    enumValues {
      name
      description
    }
  }
}
    `;

/**
 * __useGetLoadTypeEnumValuesQuery__
 *
 * To run a query within a React component, call `useGetLoadTypeEnumValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoadTypeEnumValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoadTypeEnumValuesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLoadTypeEnumValuesQuery(baseOptions?: Apollo.QueryHookOptions<GetLoadTypeEnumValuesQuery, GetLoadTypeEnumValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoadTypeEnumValuesQuery, GetLoadTypeEnumValuesQueryVariables>(GetLoadTypeEnumValuesDocument, options);
      }
export function useGetLoadTypeEnumValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoadTypeEnumValuesQuery, GetLoadTypeEnumValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoadTypeEnumValuesQuery, GetLoadTypeEnumValuesQueryVariables>(GetLoadTypeEnumValuesDocument, options);
        }
// @ts-ignore
export function useGetLoadTypeEnumValuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoadTypeEnumValuesQuery, GetLoadTypeEnumValuesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLoadTypeEnumValuesQuery, GetLoadTypeEnumValuesQueryVariables>;
export function useGetLoadTypeEnumValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLoadTypeEnumValuesQuery, GetLoadTypeEnumValuesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLoadTypeEnumValuesQuery | undefined, GetLoadTypeEnumValuesQueryVariables>;
export function useGetLoadTypeEnumValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLoadTypeEnumValuesQuery, GetLoadTypeEnumValuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLoadTypeEnumValuesQuery, GetLoadTypeEnumValuesQueryVariables>(GetLoadTypeEnumValuesDocument, options);
        }
export type GetLoadTypeEnumValuesQueryHookResult = ReturnType<typeof useGetLoadTypeEnumValuesQuery>;
export type GetLoadTypeEnumValuesLazyQueryHookResult = ReturnType<typeof useGetLoadTypeEnumValuesLazyQuery>;
export type GetLoadTypeEnumValuesSuspenseQueryHookResult = ReturnType<typeof useGetLoadTypeEnumValuesSuspenseQuery>;
export type GetLoadTypeEnumValuesQueryResult = Apollo.QueryResult<GetLoadTypeEnumValuesQuery, GetLoadTypeEnumValuesQueryVariables>;
export const BookingQuotationProposalsDocument = gql`
    query BookingQuotationProposals($processId: Int!) {
  bookingQuotationProposals(processId: $processId) {
    ...BookingProposalFields
  }
}
    ${BookingProposalFieldsFragmentDoc}`;

/**
 * __useBookingQuotationProposalsQuery__
 *
 * To run a query within a React component, call `useBookingQuotationProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingQuotationProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingQuotationProposalsQuery({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useBookingQuotationProposalsQuery(baseOptions: Apollo.QueryHookOptions<BookingQuotationProposalsQuery, BookingQuotationProposalsQueryVariables> & ({ variables: BookingQuotationProposalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingQuotationProposalsQuery, BookingQuotationProposalsQueryVariables>(BookingQuotationProposalsDocument, options);
      }
export function useBookingQuotationProposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingQuotationProposalsQuery, BookingQuotationProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingQuotationProposalsQuery, BookingQuotationProposalsQueryVariables>(BookingQuotationProposalsDocument, options);
        }
// @ts-ignore
export function useBookingQuotationProposalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookingQuotationProposalsQuery, BookingQuotationProposalsQueryVariables>): Apollo.UseSuspenseQueryResult<BookingQuotationProposalsQuery, BookingQuotationProposalsQueryVariables>;
export function useBookingQuotationProposalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingQuotationProposalsQuery, BookingQuotationProposalsQueryVariables>): Apollo.UseSuspenseQueryResult<BookingQuotationProposalsQuery | undefined, BookingQuotationProposalsQueryVariables>;
export function useBookingQuotationProposalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingQuotationProposalsQuery, BookingQuotationProposalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingQuotationProposalsQuery, BookingQuotationProposalsQueryVariables>(BookingQuotationProposalsDocument, options);
        }
export type BookingQuotationProposalsQueryHookResult = ReturnType<typeof useBookingQuotationProposalsQuery>;
export type BookingQuotationProposalsLazyQueryHookResult = ReturnType<typeof useBookingQuotationProposalsLazyQuery>;
export type BookingQuotationProposalsSuspenseQueryHookResult = ReturnType<typeof useBookingQuotationProposalsSuspenseQuery>;
export type BookingQuotationProposalsQueryResult = Apollo.QueryResult<BookingQuotationProposalsQuery, BookingQuotationProposalsQueryVariables>;
export const CancelBookingQuotationDocument = gql`
    mutation CancelBookingQuotation($processId: Int!, $params: CancelBookingQuotationParams) {
  cancelBookingQuotation(processId: $processId, params: $params) {
    id
  }
}
    `;
export type CancelBookingQuotationMutationFn = Apollo.MutationFunction<CancelBookingQuotationMutation, CancelBookingQuotationMutationVariables>;

/**
 * __useCancelBookingQuotationMutation__
 *
 * To run a mutation, you first call `useCancelBookingQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelBookingQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelBookingQuotationMutation, { data, loading, error }] = useCancelBookingQuotationMutation({
 *   variables: {
 *      processId: // value for 'processId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCancelBookingQuotationMutation(baseOptions?: Apollo.MutationHookOptions<CancelBookingQuotationMutation, CancelBookingQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelBookingQuotationMutation, CancelBookingQuotationMutationVariables>(CancelBookingQuotationDocument, options);
      }
export type CancelBookingQuotationMutationHookResult = ReturnType<typeof useCancelBookingQuotationMutation>;
export type CancelBookingQuotationMutationResult = Apollo.MutationResult<CancelBookingQuotationMutation>;
export type CancelBookingQuotationMutationOptions = Apollo.BaseMutationOptions<CancelBookingQuotationMutation, CancelBookingQuotationMutationVariables>;
export const DefineBookingQuotationWinnerDocument = gql`
    mutation DefineBookingQuotationWinner($proposalId: Int!, $params: DefineBookingQuotationWinnerParams) {
  defineBookingQuotationWinner(proposalId: $proposalId, params: $params) {
    id
  }
}
    `;
export type DefineBookingQuotationWinnerMutationFn = Apollo.MutationFunction<DefineBookingQuotationWinnerMutation, DefineBookingQuotationWinnerMutationVariables>;

/**
 * __useDefineBookingQuotationWinnerMutation__
 *
 * To run a mutation, you first call `useDefineBookingQuotationWinnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDefineBookingQuotationWinnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [defineBookingQuotationWinnerMutation, { data, loading, error }] = useDefineBookingQuotationWinnerMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useDefineBookingQuotationWinnerMutation(baseOptions?: Apollo.MutationHookOptions<DefineBookingQuotationWinnerMutation, DefineBookingQuotationWinnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DefineBookingQuotationWinnerMutation, DefineBookingQuotationWinnerMutationVariables>(DefineBookingQuotationWinnerDocument, options);
      }
export type DefineBookingQuotationWinnerMutationHookResult = ReturnType<typeof useDefineBookingQuotationWinnerMutation>;
export type DefineBookingQuotationWinnerMutationResult = Apollo.MutationResult<DefineBookingQuotationWinnerMutation>;
export type DefineBookingQuotationWinnerMutationOptions = Apollo.BaseMutationOptions<DefineBookingQuotationWinnerMutation, DefineBookingQuotationWinnerMutationVariables>;
export const BookingQuotationInvitableRecipientsDocument = gql`
    query BookingQuotationInvitableRecipients($processId: Int!) {
  bookingQuotationInvitableRecipients(processId: $processId) {
    id
    emails
    partnership {
      id
      nicknameWithFallback
    }
  }
}
    `;

/**
 * __useBookingQuotationInvitableRecipientsQuery__
 *
 * To run a query within a React component, call `useBookingQuotationInvitableRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingQuotationInvitableRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingQuotationInvitableRecipientsQuery({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useBookingQuotationInvitableRecipientsQuery(baseOptions: Apollo.QueryHookOptions<BookingQuotationInvitableRecipientsQuery, BookingQuotationInvitableRecipientsQueryVariables> & ({ variables: BookingQuotationInvitableRecipientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingQuotationInvitableRecipientsQuery, BookingQuotationInvitableRecipientsQueryVariables>(BookingQuotationInvitableRecipientsDocument, options);
      }
export function useBookingQuotationInvitableRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingQuotationInvitableRecipientsQuery, BookingQuotationInvitableRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingQuotationInvitableRecipientsQuery, BookingQuotationInvitableRecipientsQueryVariables>(BookingQuotationInvitableRecipientsDocument, options);
        }
// @ts-ignore
export function useBookingQuotationInvitableRecipientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookingQuotationInvitableRecipientsQuery, BookingQuotationInvitableRecipientsQueryVariables>): Apollo.UseSuspenseQueryResult<BookingQuotationInvitableRecipientsQuery, BookingQuotationInvitableRecipientsQueryVariables>;
export function useBookingQuotationInvitableRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingQuotationInvitableRecipientsQuery, BookingQuotationInvitableRecipientsQueryVariables>): Apollo.UseSuspenseQueryResult<BookingQuotationInvitableRecipientsQuery | undefined, BookingQuotationInvitableRecipientsQueryVariables>;
export function useBookingQuotationInvitableRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingQuotationInvitableRecipientsQuery, BookingQuotationInvitableRecipientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingQuotationInvitableRecipientsQuery, BookingQuotationInvitableRecipientsQueryVariables>(BookingQuotationInvitableRecipientsDocument, options);
        }
export type BookingQuotationInvitableRecipientsQueryHookResult = ReturnType<typeof useBookingQuotationInvitableRecipientsQuery>;
export type BookingQuotationInvitableRecipientsLazyQueryHookResult = ReturnType<typeof useBookingQuotationInvitableRecipientsLazyQuery>;
export type BookingQuotationInvitableRecipientsSuspenseQueryHookResult = ReturnType<typeof useBookingQuotationInvitableRecipientsSuspenseQuery>;
export type BookingQuotationInvitableRecipientsQueryResult = Apollo.QueryResult<BookingQuotationInvitableRecipientsQuery, BookingQuotationInvitableRecipientsQueryVariables>;
export const ProcessBookingQuotationDocument = gql`
    query ProcessBookingQuotation($id: Int!) {
  process(id: $id) {
    id
    bookingQuotationPage {
      id
      name
      type
      timezone
    }
    bookingDataPublication {
      id
      lastInviteSentAt
    }
    bookingQuotation {
      id
      round
      agentNotes
      status
      invitedCount
      respondedCount
      invoicesFinalValue
      collectionNotes
      winnerProposal {
        ...BookingProposalFields
      }
      externalPagePublication {
        id
        insertedAt
        publishedAt
        closesAt
        canceledAt
        cancellationReason
      }
      replies {
        status
        declineReason
        lastUpdatedAt
        partnership {
          id
          nicknameWithFallback
        }
      }
      snapshotChanges {
        path
        label
        before
        after
      }
    }
  }
}
    ${BookingProposalFieldsFragmentDoc}`;

/**
 * __useProcessBookingQuotationQuery__
 *
 * To run a query within a React component, call `useProcessBookingQuotationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessBookingQuotationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessBookingQuotationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProcessBookingQuotationQuery(baseOptions: Apollo.QueryHookOptions<ProcessBookingQuotationQuery, ProcessBookingQuotationQueryVariables> & ({ variables: ProcessBookingQuotationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessBookingQuotationQuery, ProcessBookingQuotationQueryVariables>(ProcessBookingQuotationDocument, options);
      }
export function useProcessBookingQuotationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessBookingQuotationQuery, ProcessBookingQuotationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessBookingQuotationQuery, ProcessBookingQuotationQueryVariables>(ProcessBookingQuotationDocument, options);
        }
// @ts-ignore
export function useProcessBookingQuotationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProcessBookingQuotationQuery, ProcessBookingQuotationQueryVariables>): Apollo.UseSuspenseQueryResult<ProcessBookingQuotationQuery, ProcessBookingQuotationQueryVariables>;
export function useProcessBookingQuotationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProcessBookingQuotationQuery, ProcessBookingQuotationQueryVariables>): Apollo.UseSuspenseQueryResult<ProcessBookingQuotationQuery | undefined, ProcessBookingQuotationQueryVariables>;
export function useProcessBookingQuotationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProcessBookingQuotationQuery, ProcessBookingQuotationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProcessBookingQuotationQuery, ProcessBookingQuotationQueryVariables>(ProcessBookingQuotationDocument, options);
        }
export type ProcessBookingQuotationQueryHookResult = ReturnType<typeof useProcessBookingQuotationQuery>;
export type ProcessBookingQuotationLazyQueryHookResult = ReturnType<typeof useProcessBookingQuotationLazyQuery>;
export type ProcessBookingQuotationSuspenseQueryHookResult = ReturnType<typeof useProcessBookingQuotationSuspenseQuery>;
export type ProcessBookingQuotationQueryResult = Apollo.QueryResult<ProcessBookingQuotationQuery, ProcessBookingQuotationQueryVariables>;
export const ResendBookingDataInvitesDocument = gql`
    mutation ResendBookingDataInvites($processId: Int!) {
  resendBookingDataInvites(processId: $processId) {
    id
    lastInviteSentAt
  }
}
    `;
export type ResendBookingDataInvitesMutationFn = Apollo.MutationFunction<ResendBookingDataInvitesMutation, ResendBookingDataInvitesMutationVariables>;

/**
 * __useResendBookingDataInvitesMutation__
 *
 * To run a mutation, you first call `useResendBookingDataInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendBookingDataInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendBookingDataInvitesMutation, { data, loading, error }] = useResendBookingDataInvitesMutation({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useResendBookingDataInvitesMutation(baseOptions?: Apollo.MutationHookOptions<ResendBookingDataInvitesMutation, ResendBookingDataInvitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendBookingDataInvitesMutation, ResendBookingDataInvitesMutationVariables>(ResendBookingDataInvitesDocument, options);
      }
export type ResendBookingDataInvitesMutationHookResult = ReturnType<typeof useResendBookingDataInvitesMutation>;
export type ResendBookingDataInvitesMutationResult = Apollo.MutationResult<ResendBookingDataInvitesMutation>;
export type ResendBookingDataInvitesMutationOptions = Apollo.BaseMutationOptions<ResendBookingDataInvitesMutation, ResendBookingDataInvitesMutationVariables>;
export const SendBookingQuotationDocument = gql`
    mutation SendBookingQuotation($processId: Int!) {
  sendBookingQuotation(processId: $processId) {
    id
  }
}
    `;
export type SendBookingQuotationMutationFn = Apollo.MutationFunction<SendBookingQuotationMutation, SendBookingQuotationMutationVariables>;

/**
 * __useSendBookingQuotationMutation__
 *
 * To run a mutation, you first call `useSendBookingQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBookingQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBookingQuotationMutation, { data, loading, error }] = useSendBookingQuotationMutation({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useSendBookingQuotationMutation(baseOptions?: Apollo.MutationHookOptions<SendBookingQuotationMutation, SendBookingQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendBookingQuotationMutation, SendBookingQuotationMutationVariables>(SendBookingQuotationDocument, options);
      }
export type SendBookingQuotationMutationHookResult = ReturnType<typeof useSendBookingQuotationMutation>;
export type SendBookingQuotationMutationResult = Apollo.MutationResult<SendBookingQuotationMutation>;
export type SendBookingQuotationMutationOptions = Apollo.BaseMutationOptions<SendBookingQuotationMutation, SendBookingQuotationMutationVariables>;
export const GetOperationCostModelsDocument = gql`
    query GetOperationCostModels($filters: FilterCostModelParams) {
  costModels(filters: $filters) {
    id
    name
    versions {
      id
      version
    }
  }
}
    `;

/**
 * __useGetOperationCostModelsQuery__
 *
 * To run a query within a React component, call `useGetOperationCostModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOperationCostModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOperationCostModelsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetOperationCostModelsQuery(baseOptions?: Apollo.QueryHookOptions<GetOperationCostModelsQuery, GetOperationCostModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOperationCostModelsQuery, GetOperationCostModelsQueryVariables>(GetOperationCostModelsDocument, options);
      }
export function useGetOperationCostModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOperationCostModelsQuery, GetOperationCostModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOperationCostModelsQuery, GetOperationCostModelsQueryVariables>(GetOperationCostModelsDocument, options);
        }
// @ts-ignore
export function useGetOperationCostModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOperationCostModelsQuery, GetOperationCostModelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOperationCostModelsQuery, GetOperationCostModelsQueryVariables>;
export function useGetOperationCostModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOperationCostModelsQuery, GetOperationCostModelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOperationCostModelsQuery | undefined, GetOperationCostModelsQueryVariables>;
export function useGetOperationCostModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOperationCostModelsQuery, GetOperationCostModelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOperationCostModelsQuery, GetOperationCostModelsQueryVariables>(GetOperationCostModelsDocument, options);
        }
export type GetOperationCostModelsQueryHookResult = ReturnType<typeof useGetOperationCostModelsQuery>;
export type GetOperationCostModelsLazyQueryHookResult = ReturnType<typeof useGetOperationCostModelsLazyQuery>;
export type GetOperationCostModelsSuspenseQueryHookResult = ReturnType<typeof useGetOperationCostModelsSuspenseQuery>;
export type GetOperationCostModelsQueryResult = Apollo.QueryResult<GetOperationCostModelsQuery, GetOperationCostModelsQueryVariables>;
export const GetPlannedLeadTimeOptionsDocument = gql`
    query GetPlannedLeadTimeOptions($filters: FilterPlannedLeadTimeParams!) {
  plannedLeadTimes(filters: $filters) {
    id
    name
    leadTimeModel {
      id
      referenceEvent
      referenceEventLabel
      ignoreTime
    }
    stages {
      id
      days
      hours
      quantityHours
      leadTimeStageModel {
        id
        name
        color
        startEvent
        endEvent
      }
    }
  }
}
    `;

/**
 * __useGetPlannedLeadTimeOptionsQuery__
 *
 * To run a query within a React component, call `useGetPlannedLeadTimeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlannedLeadTimeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlannedLeadTimeOptionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetPlannedLeadTimeOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetPlannedLeadTimeOptionsQuery, GetPlannedLeadTimeOptionsQueryVariables> & ({ variables: GetPlannedLeadTimeOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlannedLeadTimeOptionsQuery, GetPlannedLeadTimeOptionsQueryVariables>(GetPlannedLeadTimeOptionsDocument, options);
      }
export function useGetPlannedLeadTimeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlannedLeadTimeOptionsQuery, GetPlannedLeadTimeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlannedLeadTimeOptionsQuery, GetPlannedLeadTimeOptionsQueryVariables>(GetPlannedLeadTimeOptionsDocument, options);
        }
// @ts-ignore
export function useGetPlannedLeadTimeOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlannedLeadTimeOptionsQuery, GetPlannedLeadTimeOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlannedLeadTimeOptionsQuery, GetPlannedLeadTimeOptionsQueryVariables>;
export function useGetPlannedLeadTimeOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlannedLeadTimeOptionsQuery, GetPlannedLeadTimeOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlannedLeadTimeOptionsQuery | undefined, GetPlannedLeadTimeOptionsQueryVariables>;
export function useGetPlannedLeadTimeOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlannedLeadTimeOptionsQuery, GetPlannedLeadTimeOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlannedLeadTimeOptionsQuery, GetPlannedLeadTimeOptionsQueryVariables>(GetPlannedLeadTimeOptionsDocument, options);
        }
export type GetPlannedLeadTimeOptionsQueryHookResult = ReturnType<typeof useGetPlannedLeadTimeOptionsQuery>;
export type GetPlannedLeadTimeOptionsLazyQueryHookResult = ReturnType<typeof useGetPlannedLeadTimeOptionsLazyQuery>;
export type GetPlannedLeadTimeOptionsSuspenseQueryHookResult = ReturnType<typeof useGetPlannedLeadTimeOptionsSuspenseQuery>;
export type GetPlannedLeadTimeOptionsQueryResult = Apollo.QueryResult<GetPlannedLeadTimeOptionsQuery, GetPlannedLeadTimeOptionsQueryVariables>;
export const ListProductsFromOrderDocument = gql`
    query listProductsFromOrder($id: Int!, $isImport: Boolean!) {
  order(id: $id) {
    id
    referenceCode
    purchaseOrder @include(if: $isImport) {
      id
      items {
        id
        quantity
        balance
        lineNumber
        lineReference
        ...PurchaseOrderItemAdditionalFieldsFragment
        product {
          ...ProductsData
        }
      }
    }
    salesOrder @skip(if: $isImport) {
      id
      items {
        id
        quantity
        balance
        lineNumber
        lineReference
        ...SalesOrderItemAdditionalFieldsFragment
        product {
          ...ProductsData
        }
      }
    }
  }
}
    ${PurchaseOrderItemAdditionalFieldsFragmentFragmentDoc}
${ProductsDataFragmentDoc}
${SalesOrderItemAdditionalFieldsFragmentFragmentDoc}`;

/**
 * __useListProductsFromOrderQuery__
 *
 * To run a query within a React component, call `useListProductsFromOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProductsFromOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProductsFromOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isImport: // value for 'isImport'
 *   },
 * });
 */
export function useListProductsFromOrderQuery(baseOptions: Apollo.QueryHookOptions<ListProductsFromOrderQuery, ListProductsFromOrderQueryVariables> & ({ variables: ListProductsFromOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProductsFromOrderQuery, ListProductsFromOrderQueryVariables>(ListProductsFromOrderDocument, options);
      }
export function useListProductsFromOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProductsFromOrderQuery, ListProductsFromOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProductsFromOrderQuery, ListProductsFromOrderQueryVariables>(ListProductsFromOrderDocument, options);
        }
// @ts-ignore
export function useListProductsFromOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListProductsFromOrderQuery, ListProductsFromOrderQueryVariables>): Apollo.UseSuspenseQueryResult<ListProductsFromOrderQuery, ListProductsFromOrderQueryVariables>;
export function useListProductsFromOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProductsFromOrderQuery, ListProductsFromOrderQueryVariables>): Apollo.UseSuspenseQueryResult<ListProductsFromOrderQuery | undefined, ListProductsFromOrderQueryVariables>;
export function useListProductsFromOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProductsFromOrderQuery, ListProductsFromOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProductsFromOrderQuery, ListProductsFromOrderQueryVariables>(ListProductsFromOrderDocument, options);
        }
export type ListProductsFromOrderQueryHookResult = ReturnType<typeof useListProductsFromOrderQuery>;
export type ListProductsFromOrderLazyQueryHookResult = ReturnType<typeof useListProductsFromOrderLazyQuery>;
export type ListProductsFromOrderSuspenseQueryHookResult = ReturnType<typeof useListProductsFromOrderSuspenseQuery>;
export type ListProductsFromOrderQueryResult = Apollo.QueryResult<ListProductsFromOrderQuery, ListProductsFromOrderQueryVariables>;
export const ListShipmentOrdersDocument = gql`
    query listShipmentOrders($id: Int!, $search: String, $paginationNumber: Int!, $filters: FilterOrderParams = {status: ONGOING}) {
  operation(id: $id) {
    id
    orders(
      search: $search
      filters: $filters
      pagination: {limit: $paginationNumber, orderBy: [{field: INSERTED_AT, order: DESC}]}
    ) {
      id
      referenceCode
    }
  }
}
    `;

/**
 * __useListShipmentOrdersQuery__
 *
 * To run a query within a React component, call `useListShipmentOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListShipmentOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListShipmentOrdersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      search: // value for 'search'
 *      paginationNumber: // value for 'paginationNumber'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListShipmentOrdersQuery(baseOptions: Apollo.QueryHookOptions<ListShipmentOrdersQuery, ListShipmentOrdersQueryVariables> & ({ variables: ListShipmentOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListShipmentOrdersQuery, ListShipmentOrdersQueryVariables>(ListShipmentOrdersDocument, options);
      }
export function useListShipmentOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListShipmentOrdersQuery, ListShipmentOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListShipmentOrdersQuery, ListShipmentOrdersQueryVariables>(ListShipmentOrdersDocument, options);
        }
// @ts-ignore
export function useListShipmentOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListShipmentOrdersQuery, ListShipmentOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<ListShipmentOrdersQuery, ListShipmentOrdersQueryVariables>;
export function useListShipmentOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListShipmentOrdersQuery, ListShipmentOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<ListShipmentOrdersQuery | undefined, ListShipmentOrdersQueryVariables>;
export function useListShipmentOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListShipmentOrdersQuery, ListShipmentOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListShipmentOrdersQuery, ListShipmentOrdersQueryVariables>(ListShipmentOrdersDocument, options);
        }
export type ListShipmentOrdersQueryHookResult = ReturnType<typeof useListShipmentOrdersQuery>;
export type ListShipmentOrdersLazyQueryHookResult = ReturnType<typeof useListShipmentOrdersLazyQuery>;
export type ListShipmentOrdersSuspenseQueryHookResult = ReturnType<typeof useListShipmentOrdersSuspenseQuery>;
export type ListShipmentOrdersQueryResult = Apollo.QueryResult<ListShipmentOrdersQuery, ListShipmentOrdersQueryVariables>;
export const CeMercanteSyncSubscriptionDocument = gql`
    subscription CeMercanteSyncSubscription($foreignTradeShipmentId: Int!) {
  ceMercanteSyncSubscription(foreignTradeShipmentId: $foreignTradeShipmentId) {
    data {
      id
      lastUpdatedAt
    }
    shipment {
      id
      ceMercanteLastSyncType
      ceMercanteLastSyncErrorMessage
    }
  }
}
    `;

/**
 * __useCeMercanteSyncSubscriptionSubscription__
 *
 * To run a query within a React component, call `useCeMercanteSyncSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCeMercanteSyncSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCeMercanteSyncSubscriptionSubscription({
 *   variables: {
 *      foreignTradeShipmentId: // value for 'foreignTradeShipmentId'
 *   },
 * });
 */
export function useCeMercanteSyncSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<CeMercanteSyncSubscriptionSubscription, CeMercanteSyncSubscriptionSubscriptionVariables> & ({ variables: CeMercanteSyncSubscriptionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CeMercanteSyncSubscriptionSubscription, CeMercanteSyncSubscriptionSubscriptionVariables>(CeMercanteSyncSubscriptionDocument, options);
      }
export type CeMercanteSyncSubscriptionSubscriptionHookResult = ReturnType<typeof useCeMercanteSyncSubscriptionSubscription>;
export type CeMercanteSyncSubscriptionSubscriptionResult = Apollo.SubscriptionResult<CeMercanteSyncSubscriptionSubscription>;
export const TriggerCeMercanteSyncDocument = gql`
    mutation TriggerCeMercanteSync($foreignTradeShipmentId: Int!) {
  triggerCeMercanteSync(foreignTradeShipmentId: $foreignTradeShipmentId) {
    syncing
  }
}
    `;
export type TriggerCeMercanteSyncMutationFn = Apollo.MutationFunction<TriggerCeMercanteSyncMutation, TriggerCeMercanteSyncMutationVariables>;

/**
 * __useTriggerCeMercanteSyncMutation__
 *
 * To run a mutation, you first call `useTriggerCeMercanteSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerCeMercanteSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerCeMercanteSyncMutation, { data, loading, error }] = useTriggerCeMercanteSyncMutation({
 *   variables: {
 *      foreignTradeShipmentId: // value for 'foreignTradeShipmentId'
 *   },
 * });
 */
export function useTriggerCeMercanteSyncMutation(baseOptions?: Apollo.MutationHookOptions<TriggerCeMercanteSyncMutation, TriggerCeMercanteSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerCeMercanteSyncMutation, TriggerCeMercanteSyncMutationVariables>(TriggerCeMercanteSyncDocument, options);
      }
export type TriggerCeMercanteSyncMutationHookResult = ReturnType<typeof useTriggerCeMercanteSyncMutation>;
export type TriggerCeMercanteSyncMutationResult = Apollo.MutationResult<TriggerCeMercanteSyncMutation>;
export type TriggerCeMercanteSyncMutationOptions = Apollo.BaseMutationOptions<TriggerCeMercanteSyncMutation, TriggerCeMercanteSyncMutationVariables>;
export const DuimpSyncSubscriptionDocument = gql`
    subscription DuimpSyncSubscription($shipmentDuimpId: Int!) {
  duimpSyncSubscription(shipmentDuimpId: $shipmentDuimpId) {
    data {
      id
      lastUpdatedAt
    }
    shipment {
      id
      lastSyncType
      lastSyncErrorMessage
    }
  }
}
    `;

/**
 * __useDuimpSyncSubscriptionSubscription__
 *
 * To run a query within a React component, call `useDuimpSyncSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDuimpSyncSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDuimpSyncSubscriptionSubscription({
 *   variables: {
 *      shipmentDuimpId: // value for 'shipmentDuimpId'
 *   },
 * });
 */
export function useDuimpSyncSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<DuimpSyncSubscriptionSubscription, DuimpSyncSubscriptionSubscriptionVariables> & ({ variables: DuimpSyncSubscriptionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DuimpSyncSubscriptionSubscription, DuimpSyncSubscriptionSubscriptionVariables>(DuimpSyncSubscriptionDocument, options);
      }
export type DuimpSyncSubscriptionSubscriptionHookResult = ReturnType<typeof useDuimpSyncSubscriptionSubscription>;
export type DuimpSyncSubscriptionSubscriptionResult = Apollo.SubscriptionResult<DuimpSyncSubscriptionSubscription>;
export const TriggerDuimpSyncDocument = gql`
    mutation TriggerDuimpSync($shipmentDuimpId: Int!) {
  triggerDuimpSync(shipmentDuimpId: $shipmentDuimpId) {
    syncing
  }
}
    `;
export type TriggerDuimpSyncMutationFn = Apollo.MutationFunction<TriggerDuimpSyncMutation, TriggerDuimpSyncMutationVariables>;

/**
 * __useTriggerDuimpSyncMutation__
 *
 * To run a mutation, you first call `useTriggerDuimpSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerDuimpSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerDuimpSyncMutation, { data, loading, error }] = useTriggerDuimpSyncMutation({
 *   variables: {
 *      shipmentDuimpId: // value for 'shipmentDuimpId'
 *   },
 * });
 */
export function useTriggerDuimpSyncMutation(baseOptions?: Apollo.MutationHookOptions<TriggerDuimpSyncMutation, TriggerDuimpSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerDuimpSyncMutation, TriggerDuimpSyncMutationVariables>(TriggerDuimpSyncDocument, options);
      }
export type TriggerDuimpSyncMutationHookResult = ReturnType<typeof useTriggerDuimpSyncMutation>;
export type TriggerDuimpSyncMutationResult = Apollo.MutationResult<TriggerDuimpSyncMutation>;
export type TriggerDuimpSyncMutationOptions = Apollo.BaseMutationOptions<TriggerDuimpSyncMutation, TriggerDuimpSyncMutationVariables>;
export const ExportDeclarationSyncSubscriptionDocument = gql`
    subscription ExportDeclarationSyncSubscription($shipmentExportDeclarationId: Int!) {
  exportDeclarationSyncSubscription(
    shipmentExportDeclarationId: $shipmentExportDeclarationId
  ) {
    data {
      id
      lastUpdatedAt
    }
    shipment {
      id
      lastSyncType
      lastSyncErrorMessage
    }
  }
}
    `;

/**
 * __useExportDeclarationSyncSubscriptionSubscription__
 *
 * To run a query within a React component, call `useExportDeclarationSyncSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useExportDeclarationSyncSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportDeclarationSyncSubscriptionSubscription({
 *   variables: {
 *      shipmentExportDeclarationId: // value for 'shipmentExportDeclarationId'
 *   },
 * });
 */
export function useExportDeclarationSyncSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<ExportDeclarationSyncSubscriptionSubscription, ExportDeclarationSyncSubscriptionSubscriptionVariables> & ({ variables: ExportDeclarationSyncSubscriptionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ExportDeclarationSyncSubscriptionSubscription, ExportDeclarationSyncSubscriptionSubscriptionVariables>(ExportDeclarationSyncSubscriptionDocument, options);
      }
export type ExportDeclarationSyncSubscriptionSubscriptionHookResult = ReturnType<typeof useExportDeclarationSyncSubscriptionSubscription>;
export type ExportDeclarationSyncSubscriptionSubscriptionResult = Apollo.SubscriptionResult<ExportDeclarationSyncSubscriptionSubscription>;
export const TriggerExportDeclarationSyncDocument = gql`
    mutation TriggerExportDeclarationSync($shipmentExportDeclarationId: Int!) {
  triggerExportDeclarationSync(
    shipmentExportDeclarationId: $shipmentExportDeclarationId
  ) {
    syncing
  }
}
    `;
export type TriggerExportDeclarationSyncMutationFn = Apollo.MutationFunction<TriggerExportDeclarationSyncMutation, TriggerExportDeclarationSyncMutationVariables>;

/**
 * __useTriggerExportDeclarationSyncMutation__
 *
 * To run a mutation, you first call `useTriggerExportDeclarationSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerExportDeclarationSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerExportDeclarationSyncMutation, { data, loading, error }] = useTriggerExportDeclarationSyncMutation({
 *   variables: {
 *      shipmentExportDeclarationId: // value for 'shipmentExportDeclarationId'
 *   },
 * });
 */
export function useTriggerExportDeclarationSyncMutation(baseOptions?: Apollo.MutationHookOptions<TriggerExportDeclarationSyncMutation, TriggerExportDeclarationSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerExportDeclarationSyncMutation, TriggerExportDeclarationSyncMutationVariables>(TriggerExportDeclarationSyncDocument, options);
      }
export type TriggerExportDeclarationSyncMutationHookResult = ReturnType<typeof useTriggerExportDeclarationSyncMutation>;
export type TriggerExportDeclarationSyncMutationResult = Apollo.MutationResult<TriggerExportDeclarationSyncMutation>;
export type TriggerExportDeclarationSyncMutationOptions = Apollo.BaseMutationOptions<TriggerExportDeclarationSyncMutation, TriggerExportDeclarationSyncMutationVariables>;
export const ImportDeclarationSyncSubscriptionDocument = gql`
    subscription ImportDeclarationSyncSubscription($shipmentImportDeclarationId: Int!) {
  importDeclarationSyncSubscription(
    shipmentImportDeclarationId: $shipmentImportDeclarationId
  ) {
    data {
      id
      lastUpdatedAt
    }
    shipment {
      id
      lastSyncType
      lastSyncErrorMessage
    }
  }
}
    `;

/**
 * __useImportDeclarationSyncSubscriptionSubscription__
 *
 * To run a query within a React component, call `useImportDeclarationSyncSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useImportDeclarationSyncSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportDeclarationSyncSubscriptionSubscription({
 *   variables: {
 *      shipmentImportDeclarationId: // value for 'shipmentImportDeclarationId'
 *   },
 * });
 */
export function useImportDeclarationSyncSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<ImportDeclarationSyncSubscriptionSubscription, ImportDeclarationSyncSubscriptionSubscriptionVariables> & ({ variables: ImportDeclarationSyncSubscriptionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ImportDeclarationSyncSubscriptionSubscription, ImportDeclarationSyncSubscriptionSubscriptionVariables>(ImportDeclarationSyncSubscriptionDocument, options);
      }
export type ImportDeclarationSyncSubscriptionSubscriptionHookResult = ReturnType<typeof useImportDeclarationSyncSubscriptionSubscription>;
export type ImportDeclarationSyncSubscriptionSubscriptionResult = Apollo.SubscriptionResult<ImportDeclarationSyncSubscriptionSubscription>;
export const TriggerImportDeclarationSyncDocument = gql`
    mutation TriggerImportDeclarationSync($shipmentImportDeclarationId: Int!) {
  triggerImportDeclarationSync(
    shipmentImportDeclarationId: $shipmentImportDeclarationId
  ) {
    syncing
  }
}
    `;
export type TriggerImportDeclarationSyncMutationFn = Apollo.MutationFunction<TriggerImportDeclarationSyncMutation, TriggerImportDeclarationSyncMutationVariables>;

/**
 * __useTriggerImportDeclarationSyncMutation__
 *
 * To run a mutation, you first call `useTriggerImportDeclarationSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerImportDeclarationSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerImportDeclarationSyncMutation, { data, loading, error }] = useTriggerImportDeclarationSyncMutation({
 *   variables: {
 *      shipmentImportDeclarationId: // value for 'shipmentImportDeclarationId'
 *   },
 * });
 */
export function useTriggerImportDeclarationSyncMutation(baseOptions?: Apollo.MutationHookOptions<TriggerImportDeclarationSyncMutation, TriggerImportDeclarationSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerImportDeclarationSyncMutation, TriggerImportDeclarationSyncMutationVariables>(TriggerImportDeclarationSyncDocument, options);
      }
export type TriggerImportDeclarationSyncMutationHookResult = ReturnType<typeof useTriggerImportDeclarationSyncMutation>;
export type TriggerImportDeclarationSyncMutationResult = Apollo.MutationResult<TriggerImportDeclarationSyncMutation>;
export type TriggerImportDeclarationSyncMutationOptions = Apollo.BaseMutationOptions<TriggerImportDeclarationSyncMutation, TriggerImportDeclarationSyncMutationVariables>;
export const ImportLicenseSyncSubscriptionDocument = gql`
    subscription ImportLicenseSyncSubscription($shipmentImportLicenseId: Int!) {
  importLicenseSyncSubscription(shipmentImportLicenseId: $shipmentImportLicenseId) {
    data {
      id
      lastUpdatedAt
    }
    shipment {
      id
      lastSyncType
      lastSyncErrorMessage
    }
  }
}
    `;

/**
 * __useImportLicenseSyncSubscriptionSubscription__
 *
 * To run a query within a React component, call `useImportLicenseSyncSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useImportLicenseSyncSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportLicenseSyncSubscriptionSubscription({
 *   variables: {
 *      shipmentImportLicenseId: // value for 'shipmentImportLicenseId'
 *   },
 * });
 */
export function useImportLicenseSyncSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<ImportLicenseSyncSubscriptionSubscription, ImportLicenseSyncSubscriptionSubscriptionVariables> & ({ variables: ImportLicenseSyncSubscriptionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ImportLicenseSyncSubscriptionSubscription, ImportLicenseSyncSubscriptionSubscriptionVariables>(ImportLicenseSyncSubscriptionDocument, options);
      }
export type ImportLicenseSyncSubscriptionSubscriptionHookResult = ReturnType<typeof useImportLicenseSyncSubscriptionSubscription>;
export type ImportLicenseSyncSubscriptionSubscriptionResult = Apollo.SubscriptionResult<ImportLicenseSyncSubscriptionSubscription>;
export const TriggerImportLicenseSyncDocument = gql`
    mutation TriggerImportLicenseSync($shipmentImportLicenseId: Int!) {
  triggerImportLicenseSync(shipmentImportLicenseId: $shipmentImportLicenseId) {
    syncing
  }
}
    `;
export type TriggerImportLicenseSyncMutationFn = Apollo.MutationFunction<TriggerImportLicenseSyncMutation, TriggerImportLicenseSyncMutationVariables>;

/**
 * __useTriggerImportLicenseSyncMutation__
 *
 * To run a mutation, you first call `useTriggerImportLicenseSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerImportLicenseSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerImportLicenseSyncMutation, { data, loading, error }] = useTriggerImportLicenseSyncMutation({
 *   variables: {
 *      shipmentImportLicenseId: // value for 'shipmentImportLicenseId'
 *   },
 * });
 */
export function useTriggerImportLicenseSyncMutation(baseOptions?: Apollo.MutationHookOptions<TriggerImportLicenseSyncMutation, TriggerImportLicenseSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerImportLicenseSyncMutation, TriggerImportLicenseSyncMutationVariables>(TriggerImportLicenseSyncDocument, options);
      }
export type TriggerImportLicenseSyncMutationHookResult = ReturnType<typeof useTriggerImportLicenseSyncMutation>;
export type TriggerImportLicenseSyncMutationResult = Apollo.MutationResult<TriggerImportLicenseSyncMutation>;
export type TriggerImportLicenseSyncMutationOptions = Apollo.BaseMutationOptions<TriggerImportLicenseSyncMutation, TriggerImportLicenseSyncMutationVariables>;
export const PalletStandardsDocument = gql`
    query PalletStandards {
  palletStandards {
    id
    name
    lengthMm
    widthMm
    isoCode
    eurCode
  }
}
    `;

/**
 * __usePalletStandardsQuery__
 *
 * To run a query within a React component, call `usePalletStandardsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePalletStandardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePalletStandardsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePalletStandardsQuery(baseOptions?: Apollo.QueryHookOptions<PalletStandardsQuery, PalletStandardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PalletStandardsQuery, PalletStandardsQueryVariables>(PalletStandardsDocument, options);
      }
export function usePalletStandardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PalletStandardsQuery, PalletStandardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PalletStandardsQuery, PalletStandardsQueryVariables>(PalletStandardsDocument, options);
        }
// @ts-ignore
export function usePalletStandardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PalletStandardsQuery, PalletStandardsQueryVariables>): Apollo.UseSuspenseQueryResult<PalletStandardsQuery, PalletStandardsQueryVariables>;
export function usePalletStandardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PalletStandardsQuery, PalletStandardsQueryVariables>): Apollo.UseSuspenseQueryResult<PalletStandardsQuery | undefined, PalletStandardsQueryVariables>;
export function usePalletStandardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PalletStandardsQuery, PalletStandardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PalletStandardsQuery, PalletStandardsQueryVariables>(PalletStandardsDocument, options);
        }
export type PalletStandardsQueryHookResult = ReturnType<typeof usePalletStandardsQuery>;
export type PalletStandardsLazyQueryHookResult = ReturnType<typeof usePalletStandardsLazyQuery>;
export type PalletStandardsSuspenseQueryHookResult = ReturnType<typeof usePalletStandardsSuspenseQuery>;
export type PalletStandardsQueryResult = Apollo.QueryResult<PalletStandardsQuery, PalletStandardsQueryVariables>;
export const FinishSchedulingDocument = gql`
    mutation FinishScheduling($id: Int!) {
  finishScheduling(id: $id) {
    id
  }
}
    `;
export type FinishSchedulingMutationFn = Apollo.MutationFunction<FinishSchedulingMutation, FinishSchedulingMutationVariables>;

/**
 * __useFinishSchedulingMutation__
 *
 * To run a mutation, you first call `useFinishSchedulingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishSchedulingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishSchedulingMutation, { data, loading, error }] = useFinishSchedulingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFinishSchedulingMutation(baseOptions?: Apollo.MutationHookOptions<FinishSchedulingMutation, FinishSchedulingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishSchedulingMutation, FinishSchedulingMutationVariables>(FinishSchedulingDocument, options);
      }
export type FinishSchedulingMutationHookResult = ReturnType<typeof useFinishSchedulingMutation>;
export type FinishSchedulingMutationResult = Apollo.MutationResult<FinishSchedulingMutation>;
export type FinishSchedulingMutationOptions = Apollo.BaseMutationOptions<FinishSchedulingMutation, FinishSchedulingMutationVariables>;
export const ListDriversToScheduleDocument = gql`
    query ListDriversToSchedule($search: String, $pagination: DriverPaginationParams) {
  drivers(search: $search, pagination: $pagination) {
    id
    name
    cpf
    licenseNumber
    licenseCategory
  }
}
    `;

/**
 * __useListDriversToScheduleQuery__
 *
 * To run a query within a React component, call `useListDriversToScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDriversToScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDriversToScheduleQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListDriversToScheduleQuery(baseOptions?: Apollo.QueryHookOptions<ListDriversToScheduleQuery, ListDriversToScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDriversToScheduleQuery, ListDriversToScheduleQueryVariables>(ListDriversToScheduleDocument, options);
      }
export function useListDriversToScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDriversToScheduleQuery, ListDriversToScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDriversToScheduleQuery, ListDriversToScheduleQueryVariables>(ListDriversToScheduleDocument, options);
        }
// @ts-ignore
export function useListDriversToScheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListDriversToScheduleQuery, ListDriversToScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<ListDriversToScheduleQuery, ListDriversToScheduleQueryVariables>;
export function useListDriversToScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDriversToScheduleQuery, ListDriversToScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<ListDriversToScheduleQuery | undefined, ListDriversToScheduleQueryVariables>;
export function useListDriversToScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDriversToScheduleQuery, ListDriversToScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDriversToScheduleQuery, ListDriversToScheduleQueryVariables>(ListDriversToScheduleDocument, options);
        }
export type ListDriversToScheduleQueryHookResult = ReturnType<typeof useListDriversToScheduleQuery>;
export type ListDriversToScheduleLazyQueryHookResult = ReturnType<typeof useListDriversToScheduleLazyQuery>;
export type ListDriversToScheduleSuspenseQueryHookResult = ReturnType<typeof useListDriversToScheduleSuspenseQuery>;
export type ListDriversToScheduleQueryResult = Apollo.QueryResult<ListDriversToScheduleQuery, ListDriversToScheduleQueryVariables>;
export const ListTrailersToScheduleDocument = gql`
    query ListTrailersToSchedule($search: String, $pagination: TrailerPaginationParams) {
  trailers(search: $search, pagination: $pagination) {
    id
    plate
    type
  }
}
    `;

/**
 * __useListTrailersToScheduleQuery__
 *
 * To run a query within a React component, call `useListTrailersToScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTrailersToScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTrailersToScheduleQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListTrailersToScheduleQuery(baseOptions?: Apollo.QueryHookOptions<ListTrailersToScheduleQuery, ListTrailersToScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTrailersToScheduleQuery, ListTrailersToScheduleQueryVariables>(ListTrailersToScheduleDocument, options);
      }
export function useListTrailersToScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTrailersToScheduleQuery, ListTrailersToScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTrailersToScheduleQuery, ListTrailersToScheduleQueryVariables>(ListTrailersToScheduleDocument, options);
        }
// @ts-ignore
export function useListTrailersToScheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListTrailersToScheduleQuery, ListTrailersToScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<ListTrailersToScheduleQuery, ListTrailersToScheduleQueryVariables>;
export function useListTrailersToScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTrailersToScheduleQuery, ListTrailersToScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<ListTrailersToScheduleQuery | undefined, ListTrailersToScheduleQueryVariables>;
export function useListTrailersToScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTrailersToScheduleQuery, ListTrailersToScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListTrailersToScheduleQuery, ListTrailersToScheduleQueryVariables>(ListTrailersToScheduleDocument, options);
        }
export type ListTrailersToScheduleQueryHookResult = ReturnType<typeof useListTrailersToScheduleQuery>;
export type ListTrailersToScheduleLazyQueryHookResult = ReturnType<typeof useListTrailersToScheduleLazyQuery>;
export type ListTrailersToScheduleSuspenseQueryHookResult = ReturnType<typeof useListTrailersToScheduleSuspenseQuery>;
export type ListTrailersToScheduleQueryResult = Apollo.QueryResult<ListTrailersToScheduleQuery, ListTrailersToScheduleQueryVariables>;
export const ListVehiclesToScheduleDocument = gql`
    query ListVehiclesToSchedule($search: String, $pagination: VehiclePaginationParams) {
  vehicles(search: $search, pagination: $pagination) {
    id
    plate
    type
  }
}
    `;

/**
 * __useListVehiclesToScheduleQuery__
 *
 * To run a query within a React component, call `useListVehiclesToScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useListVehiclesToScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListVehiclesToScheduleQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListVehiclesToScheduleQuery(baseOptions?: Apollo.QueryHookOptions<ListVehiclesToScheduleQuery, ListVehiclesToScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListVehiclesToScheduleQuery, ListVehiclesToScheduleQueryVariables>(ListVehiclesToScheduleDocument, options);
      }
export function useListVehiclesToScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListVehiclesToScheduleQuery, ListVehiclesToScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListVehiclesToScheduleQuery, ListVehiclesToScheduleQueryVariables>(ListVehiclesToScheduleDocument, options);
        }
// @ts-ignore
export function useListVehiclesToScheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListVehiclesToScheduleQuery, ListVehiclesToScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<ListVehiclesToScheduleQuery, ListVehiclesToScheduleQueryVariables>;
export function useListVehiclesToScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListVehiclesToScheduleQuery, ListVehiclesToScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<ListVehiclesToScheduleQuery | undefined, ListVehiclesToScheduleQueryVariables>;
export function useListVehiclesToScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListVehiclesToScheduleQuery, ListVehiclesToScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListVehiclesToScheduleQuery, ListVehiclesToScheduleQueryVariables>(ListVehiclesToScheduleDocument, options);
        }
export type ListVehiclesToScheduleQueryHookResult = ReturnType<typeof useListVehiclesToScheduleQuery>;
export type ListVehiclesToScheduleLazyQueryHookResult = ReturnType<typeof useListVehiclesToScheduleLazyQuery>;
export type ListVehiclesToScheduleSuspenseQueryHookResult = ReturnType<typeof useListVehiclesToScheduleSuspenseQuery>;
export type ListVehiclesToScheduleQueryResult = Apollo.QueryResult<ListVehiclesToScheduleQuery, ListVehiclesToScheduleQueryVariables>;
export const UserNotificationSubscriptionDocument = gql`
    subscription UserNotificationSubscription {
  userNotification {
    type
    reportRequest {
      id
      fileUrl
      report {
        id
        name
        reportGroup {
          id
          reference
        }
      }
    }
  }
}
    `;

/**
 * __useUserNotificationSubscriptionSubscription__
 *
 * To run a query within a React component, call `useUserNotificationSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotificationSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUserNotificationSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UserNotificationSubscriptionSubscription, UserNotificationSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UserNotificationSubscriptionSubscription, UserNotificationSubscriptionSubscriptionVariables>(UserNotificationSubscriptionDocument, options);
      }
export type UserNotificationSubscriptionSubscriptionHookResult = ReturnType<typeof useUserNotificationSubscriptionSubscription>;
export type UserNotificationSubscriptionSubscriptionResult = Apollo.SubscriptionResult<UserNotificationSubscriptionSubscription>;
export const GetAccessGroupsDocument = gql`
    query GetAccessGroups {
  accessGroups {
    id
    name
  }
}
    `;

/**
 * __useGetAccessGroupsQuery__
 *
 * To run a query within a React component, call `useGetAccessGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccessGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetAccessGroupsQuery, GetAccessGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccessGroupsQuery, GetAccessGroupsQueryVariables>(GetAccessGroupsDocument, options);
      }
export function useGetAccessGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccessGroupsQuery, GetAccessGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccessGroupsQuery, GetAccessGroupsQueryVariables>(GetAccessGroupsDocument, options);
        }
// @ts-ignore
export function useGetAccessGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccessGroupsQuery, GetAccessGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccessGroupsQuery, GetAccessGroupsQueryVariables>;
export function useGetAccessGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccessGroupsQuery, GetAccessGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccessGroupsQuery | undefined, GetAccessGroupsQueryVariables>;
export function useGetAccessGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccessGroupsQuery, GetAccessGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccessGroupsQuery, GetAccessGroupsQueryVariables>(GetAccessGroupsDocument, options);
        }
export type GetAccessGroupsQueryHookResult = ReturnType<typeof useGetAccessGroupsQuery>;
export type GetAccessGroupsLazyQueryHookResult = ReturnType<typeof useGetAccessGroupsLazyQuery>;
export type GetAccessGroupsSuspenseQueryHookResult = ReturnType<typeof useGetAccessGroupsSuspenseQuery>;
export type GetAccessGroupsQueryResult = Apollo.QueryResult<GetAccessGroupsQuery, GetAccessGroupsQueryVariables>;
export const GetAgentsOptionsDocument = gql`
    query GetAgentsOptions {
  agents {
    id
    name
  }
}
    `;

/**
 * __useGetAgentsOptionsQuery__
 *
 * To run a query within a React component, call `useGetAgentsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentsOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgentsOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentsOptionsQuery, GetAgentsOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentsOptionsQuery, GetAgentsOptionsQueryVariables>(GetAgentsOptionsDocument, options);
      }
export function useGetAgentsOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentsOptionsQuery, GetAgentsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentsOptionsQuery, GetAgentsOptionsQueryVariables>(GetAgentsOptionsDocument, options);
        }
// @ts-ignore
export function useGetAgentsOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentsOptionsQuery, GetAgentsOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentsOptionsQuery, GetAgentsOptionsQueryVariables>;
export function useGetAgentsOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentsOptionsQuery, GetAgentsOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentsOptionsQuery | undefined, GetAgentsOptionsQueryVariables>;
export function useGetAgentsOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentsOptionsQuery, GetAgentsOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentsOptionsQuery, GetAgentsOptionsQueryVariables>(GetAgentsOptionsDocument, options);
        }
export type GetAgentsOptionsQueryHookResult = ReturnType<typeof useGetAgentsOptionsQuery>;
export type GetAgentsOptionsLazyQueryHookResult = ReturnType<typeof useGetAgentsOptionsLazyQuery>;
export type GetAgentsOptionsSuspenseQueryHookResult = ReturnType<typeof useGetAgentsOptionsSuspenseQuery>;
export type GetAgentsOptionsQueryResult = Apollo.QueryResult<GetAgentsOptionsQuery, GetAgentsOptionsQueryVariables>;
export const GetAirlinesDocument = gql`
    query GetAirlines($paginationNumber: Int, $search: String) {
  airlines(
    search: $search
    pagination: {limit: $paginationNumber, orderBy: [{field: IATA_CODE, order: ASC}]}
  ) {
    id
    logoUrl
    name
  }
}
    `;

/**
 * __useGetAirlinesQuery__
 *
 * To run a query within a React component, call `useGetAirlinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAirlinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAirlinesQuery({
 *   variables: {
 *      paginationNumber: // value for 'paginationNumber'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAirlinesQuery(baseOptions?: Apollo.QueryHookOptions<GetAirlinesQuery, GetAirlinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAirlinesQuery, GetAirlinesQueryVariables>(GetAirlinesDocument, options);
      }
export function useGetAirlinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAirlinesQuery, GetAirlinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAirlinesQuery, GetAirlinesQueryVariables>(GetAirlinesDocument, options);
        }
// @ts-ignore
export function useGetAirlinesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAirlinesQuery, GetAirlinesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAirlinesQuery, GetAirlinesQueryVariables>;
export function useGetAirlinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAirlinesQuery, GetAirlinesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAirlinesQuery | undefined, GetAirlinesQueryVariables>;
export function useGetAirlinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAirlinesQuery, GetAirlinesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAirlinesQuery, GetAirlinesQueryVariables>(GetAirlinesDocument, options);
        }
export type GetAirlinesQueryHookResult = ReturnType<typeof useGetAirlinesQuery>;
export type GetAirlinesLazyQueryHookResult = ReturnType<typeof useGetAirlinesLazyQuery>;
export type GetAirlinesSuspenseQueryHookResult = ReturnType<typeof useGetAirlinesSuspenseQuery>;
export type GetAirlinesQueryResult = Apollo.QueryResult<GetAirlinesQuery, GetAirlinesQueryVariables>;
export const GetAirportsDocument = gql`
    query GetAirports($paginationNumber: Int, $search: String) {
  airports(
    search: $search
    pagination: {limit: $paginationNumber, orderBy: [{field: IATA_CODE, order: ASC}]}
  ) {
    id
    name
    iataCode
  }
}
    `;

/**
 * __useGetAirportsQuery__
 *
 * To run a query within a React component, call `useGetAirportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAirportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAirportsQuery({
 *   variables: {
 *      paginationNumber: // value for 'paginationNumber'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAirportsQuery(baseOptions?: Apollo.QueryHookOptions<GetAirportsQuery, GetAirportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAirportsQuery, GetAirportsQueryVariables>(GetAirportsDocument, options);
      }
export function useGetAirportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAirportsQuery, GetAirportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAirportsQuery, GetAirportsQueryVariables>(GetAirportsDocument, options);
        }
// @ts-ignore
export function useGetAirportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAirportsQuery, GetAirportsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAirportsQuery, GetAirportsQueryVariables>;
export function useGetAirportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAirportsQuery, GetAirportsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAirportsQuery | undefined, GetAirportsQueryVariables>;
export function useGetAirportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAirportsQuery, GetAirportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAirportsQuery, GetAirportsQueryVariables>(GetAirportsDocument, options);
        }
export type GetAirportsQueryHookResult = ReturnType<typeof useGetAirportsQuery>;
export type GetAirportsLazyQueryHookResult = ReturnType<typeof useGetAirportsLazyQuery>;
export type GetAirportsSuspenseQueryHookResult = ReturnType<typeof useGetAirportsSuspenseQuery>;
export type GetAirportsQueryResult = Apollo.QueryResult<GetAirportsQuery, GetAirportsQueryVariables>;
export const GetApiKeysOptionsDocument = gql`
    query GetApiKeysOptions {
  apiKeys {
    id
    name
  }
}
    `;

/**
 * __useGetApiKeysOptionsQuery__
 *
 * To run a query within a React component, call `useGetApiKeysOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiKeysOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiKeysOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApiKeysOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetApiKeysOptionsQuery, GetApiKeysOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiKeysOptionsQuery, GetApiKeysOptionsQueryVariables>(GetApiKeysOptionsDocument, options);
      }
export function useGetApiKeysOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiKeysOptionsQuery, GetApiKeysOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiKeysOptionsQuery, GetApiKeysOptionsQueryVariables>(GetApiKeysOptionsDocument, options);
        }
// @ts-ignore
export function useGetApiKeysOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApiKeysOptionsQuery, GetApiKeysOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiKeysOptionsQuery, GetApiKeysOptionsQueryVariables>;
export function useGetApiKeysOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiKeysOptionsQuery, GetApiKeysOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiKeysOptionsQuery | undefined, GetApiKeysOptionsQueryVariables>;
export function useGetApiKeysOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiKeysOptionsQuery, GetApiKeysOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApiKeysOptionsQuery, GetApiKeysOptionsQueryVariables>(GetApiKeysOptionsDocument, options);
        }
export type GetApiKeysOptionsQueryHookResult = ReturnType<typeof useGetApiKeysOptionsQuery>;
export type GetApiKeysOptionsLazyQueryHookResult = ReturnType<typeof useGetApiKeysOptionsLazyQuery>;
export type GetApiKeysOptionsSuspenseQueryHookResult = ReturnType<typeof useGetApiKeysOptionsSuspenseQuery>;
export type GetApiKeysOptionsQueryResult = Apollo.QueryResult<GetApiKeysOptionsQuery, GetApiKeysOptionsQueryVariables>;
export const GetComponentsOptionsDocument = gql`
    query GetComponentsOptions($operationId: Int!) {
  operation(id: $operationId) {
    id
    operationPhases {
      id
      phase {
        id
        phase
      }
      components {
        id
        name
        title
        props
        slug
        extraFieldsDefinition
        componentAccess {
          id
          type
        }
      }
    }
  }
}
    `;

/**
 * __useGetComponentsOptionsQuery__
 *
 * To run a query within a React component, call `useGetComponentsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComponentsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComponentsOptionsQuery({
 *   variables: {
 *      operationId: // value for 'operationId'
 *   },
 * });
 */
export function useGetComponentsOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetComponentsOptionsQuery, GetComponentsOptionsQueryVariables> & ({ variables: GetComponentsOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetComponentsOptionsQuery, GetComponentsOptionsQueryVariables>(GetComponentsOptionsDocument, options);
      }
export function useGetComponentsOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetComponentsOptionsQuery, GetComponentsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetComponentsOptionsQuery, GetComponentsOptionsQueryVariables>(GetComponentsOptionsDocument, options);
        }
// @ts-ignore
export function useGetComponentsOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetComponentsOptionsQuery, GetComponentsOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetComponentsOptionsQuery, GetComponentsOptionsQueryVariables>;
export function useGetComponentsOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetComponentsOptionsQuery, GetComponentsOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetComponentsOptionsQuery | undefined, GetComponentsOptionsQueryVariables>;
export function useGetComponentsOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetComponentsOptionsQuery, GetComponentsOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetComponentsOptionsQuery, GetComponentsOptionsQueryVariables>(GetComponentsOptionsDocument, options);
        }
export type GetComponentsOptionsQueryHookResult = ReturnType<typeof useGetComponentsOptionsQuery>;
export type GetComponentsOptionsLazyQueryHookResult = ReturnType<typeof useGetComponentsOptionsLazyQuery>;
export type GetComponentsOptionsSuspenseQueryHookResult = ReturnType<typeof useGetComponentsOptionsSuspenseQuery>;
export type GetComponentsOptionsQueryResult = Apollo.QueryResult<GetComponentsOptionsQuery, GetComponentsOptionsQueryVariables>;
export const GetCountriesDocument = gql`
    query GetCountries {
  countries {
    code
  }
}
    `;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
      }
export function useGetCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
// @ts-ignore
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCountriesQuery | undefined, GetCountriesQueryVariables>;
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesSuspenseQueryHookResult = ReturnType<typeof useGetCountriesSuspenseQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export const GetCurrenciesDocument = gql`
    query GetCurrencies {
  currencies {
    code
    name
    symbol
  }
}
    `;

/**
 * __useGetCurrenciesQuery__
 *
 * To run a query within a React component, call `useGetCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrenciesQuery, GetCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrenciesQuery, GetCurrenciesQueryVariables>(GetCurrenciesDocument, options);
      }
export function useGetCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrenciesQuery, GetCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrenciesQuery, GetCurrenciesQueryVariables>(GetCurrenciesDocument, options);
        }
// @ts-ignore
export function useGetCurrenciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrenciesQuery, GetCurrenciesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrenciesQuery, GetCurrenciesQueryVariables>;
export function useGetCurrenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrenciesQuery, GetCurrenciesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrenciesQuery | undefined, GetCurrenciesQueryVariables>;
export function useGetCurrenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrenciesQuery, GetCurrenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrenciesQuery, GetCurrenciesQueryVariables>(GetCurrenciesDocument, options);
        }
export type GetCurrenciesQueryHookResult = ReturnType<typeof useGetCurrenciesQuery>;
export type GetCurrenciesLazyQueryHookResult = ReturnType<typeof useGetCurrenciesLazyQuery>;
export type GetCurrenciesSuspenseQueryHookResult = ReturnType<typeof useGetCurrenciesSuspenseQuery>;
export type GetCurrenciesQueryResult = Apollo.QueryResult<GetCurrenciesQuery, GetCurrenciesQueryVariables>;
export const GetDriversDocument = gql`
    query GetDrivers {
  drivers {
    id
    name
  }
}
    `;

/**
 * __useGetDriversQuery__
 *
 * To run a query within a React component, call `useGetDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriversQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDriversQuery(baseOptions?: Apollo.QueryHookOptions<GetDriversQuery, GetDriversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriversQuery, GetDriversQueryVariables>(GetDriversDocument, options);
      }
export function useGetDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriversQuery, GetDriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriversQuery, GetDriversQueryVariables>(GetDriversDocument, options);
        }
// @ts-ignore
export function useGetDriversSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDriversQuery, GetDriversQueryVariables>): Apollo.UseSuspenseQueryResult<GetDriversQuery, GetDriversQueryVariables>;
export function useGetDriversSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDriversQuery, GetDriversQueryVariables>): Apollo.UseSuspenseQueryResult<GetDriversQuery | undefined, GetDriversQueryVariables>;
export function useGetDriversSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDriversQuery, GetDriversQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDriversQuery, GetDriversQueryVariables>(GetDriversDocument, options);
        }
export type GetDriversQueryHookResult = ReturnType<typeof useGetDriversQuery>;
export type GetDriversLazyQueryHookResult = ReturnType<typeof useGetDriversLazyQuery>;
export type GetDriversSuspenseQueryHookResult = ReturnType<typeof useGetDriversSuspenseQuery>;
export type GetDriversQueryResult = Apollo.QueryResult<GetDriversQuery, GetDriversQueryVariables>;
export const GetLpcosSearchDocument = gql`
    query GetLpcosSearch($search: String, $pathFilters: JSON, $pagination: LpcoPaginationParams) {
  lpcos(search: $search, pathFilters: $pathFilters, pagination: $pagination) {
    id
    number
  }
}
    `;

/**
 * __useGetLpcosSearchQuery__
 *
 * To run a query within a React component, call `useGetLpcosSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLpcosSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLpcosSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pathFilters: // value for 'pathFilters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetLpcosSearchQuery(baseOptions?: Apollo.QueryHookOptions<GetLpcosSearchQuery, GetLpcosSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLpcosSearchQuery, GetLpcosSearchQueryVariables>(GetLpcosSearchDocument, options);
      }
export function useGetLpcosSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLpcosSearchQuery, GetLpcosSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLpcosSearchQuery, GetLpcosSearchQueryVariables>(GetLpcosSearchDocument, options);
        }
// @ts-ignore
export function useGetLpcosSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLpcosSearchQuery, GetLpcosSearchQueryVariables>): Apollo.UseSuspenseQueryResult<GetLpcosSearchQuery, GetLpcosSearchQueryVariables>;
export function useGetLpcosSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLpcosSearchQuery, GetLpcosSearchQueryVariables>): Apollo.UseSuspenseQueryResult<GetLpcosSearchQuery | undefined, GetLpcosSearchQueryVariables>;
export function useGetLpcosSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLpcosSearchQuery, GetLpcosSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLpcosSearchQuery, GetLpcosSearchQueryVariables>(GetLpcosSearchDocument, options);
        }
export type GetLpcosSearchQueryHookResult = ReturnType<typeof useGetLpcosSearchQuery>;
export type GetLpcosSearchLazyQueryHookResult = ReturnType<typeof useGetLpcosSearchLazyQuery>;
export type GetLpcosSearchSuspenseQueryHookResult = ReturnType<typeof useGetLpcosSearchSuspenseQuery>;
export type GetLpcosSearchQueryResult = Apollo.QueryResult<GetLpcosSearchQuery, GetLpcosSearchQueryVariables>;
export const GetMaritimePortsDocument = gql`
    query GetMaritimePorts($paginationNumber: Int, $search: String) {
  maritimePorts(
    search: $search
    pagination: {limit: $paginationNumber, orderBy: [{field: UNLOCODE, order: ASC}]}
  ) {
    id
    name
    unlocode
  }
}
    `;

/**
 * __useGetMaritimePortsQuery__
 *
 * To run a query within a React component, call `useGetMaritimePortsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaritimePortsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaritimePortsQuery({
 *   variables: {
 *      paginationNumber: // value for 'paginationNumber'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetMaritimePortsQuery(baseOptions?: Apollo.QueryHookOptions<GetMaritimePortsQuery, GetMaritimePortsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaritimePortsQuery, GetMaritimePortsQueryVariables>(GetMaritimePortsDocument, options);
      }
export function useGetMaritimePortsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaritimePortsQuery, GetMaritimePortsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaritimePortsQuery, GetMaritimePortsQueryVariables>(GetMaritimePortsDocument, options);
        }
// @ts-ignore
export function useGetMaritimePortsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMaritimePortsQuery, GetMaritimePortsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMaritimePortsQuery, GetMaritimePortsQueryVariables>;
export function useGetMaritimePortsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMaritimePortsQuery, GetMaritimePortsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMaritimePortsQuery | undefined, GetMaritimePortsQueryVariables>;
export function useGetMaritimePortsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMaritimePortsQuery, GetMaritimePortsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMaritimePortsQuery, GetMaritimePortsQueryVariables>(GetMaritimePortsDocument, options);
        }
export type GetMaritimePortsQueryHookResult = ReturnType<typeof useGetMaritimePortsQuery>;
export type GetMaritimePortsLazyQueryHookResult = ReturnType<typeof useGetMaritimePortsLazyQuery>;
export type GetMaritimePortsSuspenseQueryHookResult = ReturnType<typeof useGetMaritimePortsSuspenseQuery>;
export type GetMaritimePortsQueryResult = Apollo.QueryResult<GetMaritimePortsQuery, GetMaritimePortsQueryVariables>;
export const GetOperationsOptionsDocument = gql`
    query GetOperationsOptions($paginationNumber: Int, $search: String) {
  operations(
    search: $search
    pagination: {limit: $paginationNumber, orderBy: [{field: TITLE, order: ASC}]}
  ) {
    id
    title
  }
}
    `;

/**
 * __useGetOperationsOptionsQuery__
 *
 * To run a query within a React component, call `useGetOperationsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOperationsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOperationsOptionsQuery({
 *   variables: {
 *      paginationNumber: // value for 'paginationNumber'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetOperationsOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetOperationsOptionsQuery, GetOperationsOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOperationsOptionsQuery, GetOperationsOptionsQueryVariables>(GetOperationsOptionsDocument, options);
      }
export function useGetOperationsOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOperationsOptionsQuery, GetOperationsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOperationsOptionsQuery, GetOperationsOptionsQueryVariables>(GetOperationsOptionsDocument, options);
        }
// @ts-ignore
export function useGetOperationsOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOperationsOptionsQuery, GetOperationsOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOperationsOptionsQuery, GetOperationsOptionsQueryVariables>;
export function useGetOperationsOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOperationsOptionsQuery, GetOperationsOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOperationsOptionsQuery | undefined, GetOperationsOptionsQueryVariables>;
export function useGetOperationsOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOperationsOptionsQuery, GetOperationsOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOperationsOptionsQuery, GetOperationsOptionsQueryVariables>(GetOperationsOptionsDocument, options);
        }
export type GetOperationsOptionsQueryHookResult = ReturnType<typeof useGetOperationsOptionsQuery>;
export type GetOperationsOptionsLazyQueryHookResult = ReturnType<typeof useGetOperationsOptionsLazyQuery>;
export type GetOperationsOptionsSuspenseQueryHookResult = ReturnType<typeof useGetOperationsOptionsSuspenseQuery>;
export type GetOperationsOptionsQueryResult = Apollo.QueryResult<GetOperationsOptionsQuery, GetOperationsOptionsQueryVariables>;
export const GetOrdersSearchDocument = gql`
    query GetOrdersSearch($filters: FilterOrderParams, $paginationNumber: Int, $search: String, $pathFilters: JSON) {
  orders(
    filters: $filters
    search: $search
    pagination: {offset: 0, limit: $paginationNumber}
    pathFilters: $pathFilters
  ) {
    id
    referenceCode
  }
}
    `;

/**
 * __useGetOrdersSearchQuery__
 *
 * To run a query within a React component, call `useGetOrdersSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersSearchQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      paginationNumber: // value for 'paginationNumber'
 *      search: // value for 'search'
 *      pathFilters: // value for 'pathFilters'
 *   },
 * });
 */
export function useGetOrdersSearchQuery(baseOptions?: Apollo.QueryHookOptions<GetOrdersSearchQuery, GetOrdersSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersSearchQuery, GetOrdersSearchQueryVariables>(GetOrdersSearchDocument, options);
      }
export function useGetOrdersSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersSearchQuery, GetOrdersSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersSearchQuery, GetOrdersSearchQueryVariables>(GetOrdersSearchDocument, options);
        }
// @ts-ignore
export function useGetOrdersSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrdersSearchQuery, GetOrdersSearchQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrdersSearchQuery, GetOrdersSearchQueryVariables>;
export function useGetOrdersSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersSearchQuery, GetOrdersSearchQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrdersSearchQuery | undefined, GetOrdersSearchQueryVariables>;
export function useGetOrdersSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersSearchQuery, GetOrdersSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrdersSearchQuery, GetOrdersSearchQueryVariables>(GetOrdersSearchDocument, options);
        }
export type GetOrdersSearchQueryHookResult = ReturnType<typeof useGetOrdersSearchQuery>;
export type GetOrdersSearchLazyQueryHookResult = ReturnType<typeof useGetOrdersSearchLazyQuery>;
export type GetOrdersSearchSuspenseQueryHookResult = ReturnType<typeof useGetOrdersSearchSuspenseQuery>;
export type GetOrdersSearchQueryResult = Apollo.QueryResult<GetOrdersSearchQuery, GetOrdersSearchQueryVariables>;
export const GetPortTerminalsSelectDocument = gql`
    query GetPortTerminalsSelect {
  portTerminals {
    id
    name
  }
}
    `;

/**
 * __useGetPortTerminalsSelectQuery__
 *
 * To run a query within a React component, call `useGetPortTerminalsSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortTerminalsSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortTerminalsSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPortTerminalsSelectQuery(baseOptions?: Apollo.QueryHookOptions<GetPortTerminalsSelectQuery, GetPortTerminalsSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortTerminalsSelectQuery, GetPortTerminalsSelectQueryVariables>(GetPortTerminalsSelectDocument, options);
      }
export function useGetPortTerminalsSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortTerminalsSelectQuery, GetPortTerminalsSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortTerminalsSelectQuery, GetPortTerminalsSelectQueryVariables>(GetPortTerminalsSelectDocument, options);
        }
// @ts-ignore
export function useGetPortTerminalsSelectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPortTerminalsSelectQuery, GetPortTerminalsSelectQueryVariables>): Apollo.UseSuspenseQueryResult<GetPortTerminalsSelectQuery, GetPortTerminalsSelectQueryVariables>;
export function useGetPortTerminalsSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortTerminalsSelectQuery, GetPortTerminalsSelectQueryVariables>): Apollo.UseSuspenseQueryResult<GetPortTerminalsSelectQuery | undefined, GetPortTerminalsSelectQueryVariables>;
export function useGetPortTerminalsSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortTerminalsSelectQuery, GetPortTerminalsSelectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortTerminalsSelectQuery, GetPortTerminalsSelectQueryVariables>(GetPortTerminalsSelectDocument, options);
        }
export type GetPortTerminalsSelectQueryHookResult = ReturnType<typeof useGetPortTerminalsSelectQuery>;
export type GetPortTerminalsSelectLazyQueryHookResult = ReturnType<typeof useGetPortTerminalsSelectLazyQuery>;
export type GetPortTerminalsSelectSuspenseQueryHookResult = ReturnType<typeof useGetPortTerminalsSelectSuspenseQuery>;
export type GetPortTerminalsSelectQueryResult = Apollo.QueryResult<GetPortTerminalsSelectQuery, GetPortTerminalsSelectQueryVariables>;
export const GetProcessesFieldsDocument = gql`
    query getProcessesFields($operationIds: [Int!]!) {
  leadTimeProcessesFields(operationIds: $operationIds) {
    isList
    label
    path
    type
  }
}
    `;

/**
 * __useGetProcessesFieldsQuery__
 *
 * To run a query within a React component, call `useGetProcessesFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessesFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessesFieldsQuery({
 *   variables: {
 *      operationIds: // value for 'operationIds'
 *   },
 * });
 */
export function useGetProcessesFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetProcessesFieldsQuery, GetProcessesFieldsQueryVariables> & ({ variables: GetProcessesFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessesFieldsQuery, GetProcessesFieldsQueryVariables>(GetProcessesFieldsDocument, options);
      }
export function useGetProcessesFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessesFieldsQuery, GetProcessesFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessesFieldsQuery, GetProcessesFieldsQueryVariables>(GetProcessesFieldsDocument, options);
        }
// @ts-ignore
export function useGetProcessesFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProcessesFieldsQuery, GetProcessesFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessesFieldsQuery, GetProcessesFieldsQueryVariables>;
export function useGetProcessesFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessesFieldsQuery, GetProcessesFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessesFieldsQuery | undefined, GetProcessesFieldsQueryVariables>;
export function useGetProcessesFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessesFieldsQuery, GetProcessesFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProcessesFieldsQuery, GetProcessesFieldsQueryVariables>(GetProcessesFieldsDocument, options);
        }
export type GetProcessesFieldsQueryHookResult = ReturnType<typeof useGetProcessesFieldsQuery>;
export type GetProcessesFieldsLazyQueryHookResult = ReturnType<typeof useGetProcessesFieldsLazyQuery>;
export type GetProcessesFieldsSuspenseQueryHookResult = ReturnType<typeof useGetProcessesFieldsSuspenseQuery>;
export type GetProcessesFieldsQueryResult = Apollo.QueryResult<GetProcessesFieldsQuery, GetProcessesFieldsQueryVariables>;
export const GetProcessesOptionsDocument = gql`
    query GetProcessesOptions($filters: FilterProcessParams, $paginationNumber: Int, $search: String, $pathFilters: JSON) {
  processes(
    filters: $filters
    search: $search
    pagination: {offset: 0, limit: $paginationNumber}
    pathFilters: $pathFilters
  ) {
    id
    referenceCode
    foreignTradeShipment {
      id
      type
      automaticTrackingEnabled
    }
  }
}
    `;

/**
 * __useGetProcessesOptionsQuery__
 *
 * To run a query within a React component, call `useGetProcessesOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessesOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessesOptionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      paginationNumber: // value for 'paginationNumber'
 *      search: // value for 'search'
 *      pathFilters: // value for 'pathFilters'
 *   },
 * });
 */
export function useGetProcessesOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetProcessesOptionsQuery, GetProcessesOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessesOptionsQuery, GetProcessesOptionsQueryVariables>(GetProcessesOptionsDocument, options);
      }
export function useGetProcessesOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessesOptionsQuery, GetProcessesOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessesOptionsQuery, GetProcessesOptionsQueryVariables>(GetProcessesOptionsDocument, options);
        }
// @ts-ignore
export function useGetProcessesOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProcessesOptionsQuery, GetProcessesOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessesOptionsQuery, GetProcessesOptionsQueryVariables>;
export function useGetProcessesOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessesOptionsQuery, GetProcessesOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessesOptionsQuery | undefined, GetProcessesOptionsQueryVariables>;
export function useGetProcessesOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessesOptionsQuery, GetProcessesOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProcessesOptionsQuery, GetProcessesOptionsQueryVariables>(GetProcessesOptionsDocument, options);
        }
export type GetProcessesOptionsQueryHookResult = ReturnType<typeof useGetProcessesOptionsQuery>;
export type GetProcessesOptionsLazyQueryHookResult = ReturnType<typeof useGetProcessesOptionsLazyQuery>;
export type GetProcessesOptionsSuspenseQueryHookResult = ReturnType<typeof useGetProcessesOptionsSuspenseQuery>;
export type GetProcessesOptionsQueryResult = Apollo.QueryResult<GetProcessesOptionsQuery, GetProcessesOptionsQueryVariables>;
export const GetProcessesSearchDocument = gql`
    query GetProcessesSearch($filters: FilterProcessParams, $paginationNumber: Int, $search: String, $pathFilters: JSON) {
  processes(
    filters: $filters
    search: $search
    pagination: {offset: 0, limit: $paginationNumber}
    pathFilters: $pathFilters
  ) {
    id
    referenceCode
  }
}
    `;

/**
 * __useGetProcessesSearchQuery__
 *
 * To run a query within a React component, call `useGetProcessesSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessesSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessesSearchQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      paginationNumber: // value for 'paginationNumber'
 *      search: // value for 'search'
 *      pathFilters: // value for 'pathFilters'
 *   },
 * });
 */
export function useGetProcessesSearchQuery(baseOptions?: Apollo.QueryHookOptions<GetProcessesSearchQuery, GetProcessesSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessesSearchQuery, GetProcessesSearchQueryVariables>(GetProcessesSearchDocument, options);
      }
export function useGetProcessesSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessesSearchQuery, GetProcessesSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessesSearchQuery, GetProcessesSearchQueryVariables>(GetProcessesSearchDocument, options);
        }
// @ts-ignore
export function useGetProcessesSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProcessesSearchQuery, GetProcessesSearchQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessesSearchQuery, GetProcessesSearchQueryVariables>;
export function useGetProcessesSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessesSearchQuery, GetProcessesSearchQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessesSearchQuery | undefined, GetProcessesSearchQueryVariables>;
export function useGetProcessesSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessesSearchQuery, GetProcessesSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProcessesSearchQuery, GetProcessesSearchQueryVariables>(GetProcessesSearchDocument, options);
        }
export type GetProcessesSearchQueryHookResult = ReturnType<typeof useGetProcessesSearchQuery>;
export type GetProcessesSearchLazyQueryHookResult = ReturnType<typeof useGetProcessesSearchLazyQuery>;
export type GetProcessesSearchSuspenseQueryHookResult = ReturnType<typeof useGetProcessesSearchSuspenseQuery>;
export type GetProcessesSearchQueryResult = Apollo.QueryResult<GetProcessesSearchQuery, GetProcessesSearchQueryVariables>;
export const GetSealinesDocument = gql`
    query GetSealines($paginationNumber: Int, $search: String) {
  sealines(
    search: $search
    pagination: {limit: $paginationNumber, orderBy: [{field: NAME, order: ASC}]}
  ) {
    id
    name
    logoUrl
  }
}
    `;

/**
 * __useGetSealinesQuery__
 *
 * To run a query within a React component, call `useGetSealinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSealinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSealinesQuery({
 *   variables: {
 *      paginationNumber: // value for 'paginationNumber'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetSealinesQuery(baseOptions?: Apollo.QueryHookOptions<GetSealinesQuery, GetSealinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSealinesQuery, GetSealinesQueryVariables>(GetSealinesDocument, options);
      }
export function useGetSealinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSealinesQuery, GetSealinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSealinesQuery, GetSealinesQueryVariables>(GetSealinesDocument, options);
        }
// @ts-ignore
export function useGetSealinesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSealinesQuery, GetSealinesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSealinesQuery, GetSealinesQueryVariables>;
export function useGetSealinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSealinesQuery, GetSealinesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSealinesQuery | undefined, GetSealinesQueryVariables>;
export function useGetSealinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSealinesQuery, GetSealinesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSealinesQuery, GetSealinesQueryVariables>(GetSealinesDocument, options);
        }
export type GetSealinesQueryHookResult = ReturnType<typeof useGetSealinesQuery>;
export type GetSealinesLazyQueryHookResult = ReturnType<typeof useGetSealinesLazyQuery>;
export type GetSealinesSuspenseQueryHookResult = ReturnType<typeof useGetSealinesSuspenseQuery>;
export type GetSealinesQueryResult = Apollo.QueryResult<GetSealinesQuery, GetSealinesQueryVariables>;
export const GetSubsidiariesDocument = gql`
    query GetSubsidiaries {
  currentUser {
    id
    currentWorkspace {
      client {
        id
        actor {
          id
          subsidiaries {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSubsidiariesQuery__
 *
 * To run a query within a React component, call `useGetSubsidiariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubsidiariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubsidiariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubsidiariesQuery(baseOptions?: Apollo.QueryHookOptions<GetSubsidiariesQuery, GetSubsidiariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubsidiariesQuery, GetSubsidiariesQueryVariables>(GetSubsidiariesDocument, options);
      }
export function useGetSubsidiariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubsidiariesQuery, GetSubsidiariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubsidiariesQuery, GetSubsidiariesQueryVariables>(GetSubsidiariesDocument, options);
        }
// @ts-ignore
export function useGetSubsidiariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubsidiariesQuery, GetSubsidiariesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubsidiariesQuery, GetSubsidiariesQueryVariables>;
export function useGetSubsidiariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubsidiariesQuery, GetSubsidiariesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubsidiariesQuery | undefined, GetSubsidiariesQueryVariables>;
export function useGetSubsidiariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubsidiariesQuery, GetSubsidiariesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubsidiariesQuery, GetSubsidiariesQueryVariables>(GetSubsidiariesDocument, options);
        }
export type GetSubsidiariesQueryHookResult = ReturnType<typeof useGetSubsidiariesQuery>;
export type GetSubsidiariesLazyQueryHookResult = ReturnType<typeof useGetSubsidiariesLazyQuery>;
export type GetSubsidiariesSuspenseQueryHookResult = ReturnType<typeof useGetSubsidiariesSuspenseQuery>;
export type GetSubsidiariesQueryResult = Apollo.QueryResult<GetSubsidiariesQuery, GetSubsidiariesQueryVariables>;
export const GetTrailersDocument = gql`
    query GetTrailers {
  trailers {
    id
    plate
  }
}
    `;

/**
 * __useGetTrailersQuery__
 *
 * To run a query within a React component, call `useGetTrailersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrailersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrailersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTrailersQuery(baseOptions?: Apollo.QueryHookOptions<GetTrailersQuery, GetTrailersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrailersQuery, GetTrailersQueryVariables>(GetTrailersDocument, options);
      }
export function useGetTrailersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrailersQuery, GetTrailersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrailersQuery, GetTrailersQueryVariables>(GetTrailersDocument, options);
        }
// @ts-ignore
export function useGetTrailersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTrailersQuery, GetTrailersQueryVariables>): Apollo.UseSuspenseQueryResult<GetTrailersQuery, GetTrailersQueryVariables>;
export function useGetTrailersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTrailersQuery, GetTrailersQueryVariables>): Apollo.UseSuspenseQueryResult<GetTrailersQuery | undefined, GetTrailersQueryVariables>;
export function useGetTrailersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTrailersQuery, GetTrailersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTrailersQuery, GetTrailersQueryVariables>(GetTrailersDocument, options);
        }
export type GetTrailersQueryHookResult = ReturnType<typeof useGetTrailersQuery>;
export type GetTrailersLazyQueryHookResult = ReturnType<typeof useGetTrailersLazyQuery>;
export type GetTrailersSuspenseQueryHookResult = ReturnType<typeof useGetTrailersSuspenseQuery>;
export type GetTrailersQueryResult = Apollo.QueryResult<GetTrailersQuery, GetTrailersQueryVariables>;
export const GetVehiclesDocument = gql`
    query GetVehicles {
  vehicles {
    id
    plate
    trackerId
    trackerBrand
  }
}
    `;

/**
 * __useGetVehiclesQuery__
 *
 * To run a query within a React component, call `useGetVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehiclesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVehiclesQuery(baseOptions?: Apollo.QueryHookOptions<GetVehiclesQuery, GetVehiclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehiclesQuery, GetVehiclesQueryVariables>(GetVehiclesDocument, options);
      }
export function useGetVehiclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehiclesQuery, GetVehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehiclesQuery, GetVehiclesQueryVariables>(GetVehiclesDocument, options);
        }
// @ts-ignore
export function useGetVehiclesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVehiclesQuery, GetVehiclesQueryVariables>): Apollo.UseSuspenseQueryResult<GetVehiclesQuery, GetVehiclesQueryVariables>;
export function useGetVehiclesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVehiclesQuery, GetVehiclesQueryVariables>): Apollo.UseSuspenseQueryResult<GetVehiclesQuery | undefined, GetVehiclesQueryVariables>;
export function useGetVehiclesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVehiclesQuery, GetVehiclesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVehiclesQuery, GetVehiclesQueryVariables>(GetVehiclesDocument, options);
        }
export type GetVehiclesQueryHookResult = ReturnType<typeof useGetVehiclesQuery>;
export type GetVehiclesLazyQueryHookResult = ReturnType<typeof useGetVehiclesLazyQuery>;
export type GetVehiclesSuspenseQueryHookResult = ReturnType<typeof useGetVehiclesSuspenseQuery>;
export type GetVehiclesQueryResult = Apollo.QueryResult<GetVehiclesQuery, GetVehiclesQueryVariables>;
export const GetVesselsSelectDocument = gql`
    query GetVesselsSelect($paginationNumber: Int, $search: String) {
  vessels(
    search: $search
    pagination: {limit: $paginationNumber, orderBy: [{field: NAME, order: ASC}]}
  ) {
    id
    name
    imoNumber
    country {
      code
    }
  }
}
    `;

/**
 * __useGetVesselsSelectQuery__
 *
 * To run a query within a React component, call `useGetVesselsSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVesselsSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVesselsSelectQuery({
 *   variables: {
 *      paginationNumber: // value for 'paginationNumber'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetVesselsSelectQuery(baseOptions?: Apollo.QueryHookOptions<GetVesselsSelectQuery, GetVesselsSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVesselsSelectQuery, GetVesselsSelectQueryVariables>(GetVesselsSelectDocument, options);
      }
export function useGetVesselsSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVesselsSelectQuery, GetVesselsSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVesselsSelectQuery, GetVesselsSelectQueryVariables>(GetVesselsSelectDocument, options);
        }
// @ts-ignore
export function useGetVesselsSelectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVesselsSelectQuery, GetVesselsSelectQueryVariables>): Apollo.UseSuspenseQueryResult<GetVesselsSelectQuery, GetVesselsSelectQueryVariables>;
export function useGetVesselsSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVesselsSelectQuery, GetVesselsSelectQueryVariables>): Apollo.UseSuspenseQueryResult<GetVesselsSelectQuery | undefined, GetVesselsSelectQueryVariables>;
export function useGetVesselsSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVesselsSelectQuery, GetVesselsSelectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVesselsSelectQuery, GetVesselsSelectQueryVariables>(GetVesselsSelectDocument, options);
        }
export type GetVesselsSelectQueryHookResult = ReturnType<typeof useGetVesselsSelectQuery>;
export type GetVesselsSelectLazyQueryHookResult = ReturnType<typeof useGetVesselsSelectLazyQuery>;
export type GetVesselsSelectSuspenseQueryHookResult = ReturnType<typeof useGetVesselsSelectSuspenseQuery>;
export type GetVesselsSelectQueryResult = Apollo.QueryResult<GetVesselsSelectQuery, GetVesselsSelectQueryVariables>;
export const GetCurrentUserDataDocument = gql`
    query GetCurrentUserData {
  currentUser {
    id
    name
    picture
    email
  }
}
    `;

/**
 * __useGetCurrentUserDataQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserDataQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserDataQuery, GetCurrentUserDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserDataQuery, GetCurrentUserDataQueryVariables>(GetCurrentUserDataDocument, options);
      }
export function useGetCurrentUserDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserDataQuery, GetCurrentUserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserDataQuery, GetCurrentUserDataQueryVariables>(GetCurrentUserDataDocument, options);
        }
// @ts-ignore
export function useGetCurrentUserDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserDataQuery, GetCurrentUserDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserDataQuery, GetCurrentUserDataQueryVariables>;
export function useGetCurrentUserDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserDataQuery, GetCurrentUserDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserDataQuery | undefined, GetCurrentUserDataQueryVariables>;
export function useGetCurrentUserDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserDataQuery, GetCurrentUserDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserDataQuery, GetCurrentUserDataQueryVariables>(GetCurrentUserDataDocument, options);
        }
export type GetCurrentUserDataQueryHookResult = ReturnType<typeof useGetCurrentUserDataQuery>;
export type GetCurrentUserDataLazyQueryHookResult = ReturnType<typeof useGetCurrentUserDataLazyQuery>;
export type GetCurrentUserDataSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserDataSuspenseQuery>;
export type GetCurrentUserDataQueryResult = Apollo.QueryResult<GetCurrentUserDataQuery, GetCurrentUserDataQueryVariables>;
export const GetMaritimePortDocument = gql`
    query GetMaritimePort($id: Int!) {
  maritimePort(id: $id) {
    id
    name
    unlocode
  }
}
    `;

/**
 * __useGetMaritimePortQuery__
 *
 * To run a query within a React component, call `useGetMaritimePortQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaritimePortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaritimePortQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMaritimePortQuery(baseOptions: Apollo.QueryHookOptions<GetMaritimePortQuery, GetMaritimePortQueryVariables> & ({ variables: GetMaritimePortQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaritimePortQuery, GetMaritimePortQueryVariables>(GetMaritimePortDocument, options);
      }
export function useGetMaritimePortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaritimePortQuery, GetMaritimePortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaritimePortQuery, GetMaritimePortQueryVariables>(GetMaritimePortDocument, options);
        }
// @ts-ignore
export function useGetMaritimePortSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMaritimePortQuery, GetMaritimePortQueryVariables>): Apollo.UseSuspenseQueryResult<GetMaritimePortQuery, GetMaritimePortQueryVariables>;
export function useGetMaritimePortSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMaritimePortQuery, GetMaritimePortQueryVariables>): Apollo.UseSuspenseQueryResult<GetMaritimePortQuery | undefined, GetMaritimePortQueryVariables>;
export function useGetMaritimePortSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMaritimePortQuery, GetMaritimePortQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMaritimePortQuery, GetMaritimePortQueryVariables>(GetMaritimePortDocument, options);
        }
export type GetMaritimePortQueryHookResult = ReturnType<typeof useGetMaritimePortQuery>;
export type GetMaritimePortLazyQueryHookResult = ReturnType<typeof useGetMaritimePortLazyQuery>;
export type GetMaritimePortSuspenseQueryHookResult = ReturnType<typeof useGetMaritimePortSuspenseQuery>;
export type GetMaritimePortQueryResult = Apollo.QueryResult<GetMaritimePortQuery, GetMaritimePortQueryVariables>;
export const ListActorsWithFiltersDocument = gql`
    query ListActorsWithFilters($filters: FilterActorsParams) {
  actors(filters: $filters) {
    id
    nickname
    partnershipAsPartner {
      id
      nicknameWithFallback
      internalCode
    }
  }
}
    `;

/**
 * __useListActorsWithFiltersQuery__
 *
 * To run a query within a React component, call `useListActorsWithFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActorsWithFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActorsWithFiltersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListActorsWithFiltersQuery(baseOptions?: Apollo.QueryHookOptions<ListActorsWithFiltersQuery, ListActorsWithFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListActorsWithFiltersQuery, ListActorsWithFiltersQueryVariables>(ListActorsWithFiltersDocument, options);
      }
export function useListActorsWithFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListActorsWithFiltersQuery, ListActorsWithFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListActorsWithFiltersQuery, ListActorsWithFiltersQueryVariables>(ListActorsWithFiltersDocument, options);
        }
// @ts-ignore
export function useListActorsWithFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListActorsWithFiltersQuery, ListActorsWithFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<ListActorsWithFiltersQuery, ListActorsWithFiltersQueryVariables>;
export function useListActorsWithFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListActorsWithFiltersQuery, ListActorsWithFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<ListActorsWithFiltersQuery | undefined, ListActorsWithFiltersQueryVariables>;
export function useListActorsWithFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListActorsWithFiltersQuery, ListActorsWithFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListActorsWithFiltersQuery, ListActorsWithFiltersQueryVariables>(ListActorsWithFiltersDocument, options);
        }
export type ListActorsWithFiltersQueryHookResult = ReturnType<typeof useListActorsWithFiltersQuery>;
export type ListActorsWithFiltersLazyQueryHookResult = ReturnType<typeof useListActorsWithFiltersLazyQuery>;
export type ListActorsWithFiltersSuspenseQueryHookResult = ReturnType<typeof useListActorsWithFiltersSuspenseQuery>;
export type ListActorsWithFiltersQueryResult = Apollo.QueryResult<ListActorsWithFiltersQuery, ListActorsWithFiltersQueryVariables>;
export const ListPartnershipsWithFiltersDocument = gql`
    query ListPartnershipsWithFilters($filters: FilterPartnershipsParams) {
  partnerships(filters: $filters) {
    id
    nicknameWithFallback
    internalCode
    partner {
      id
      nickname
    }
  }
}
    `;

/**
 * __useListPartnershipsWithFiltersQuery__
 *
 * To run a query within a React component, call `useListPartnershipsWithFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPartnershipsWithFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPartnershipsWithFiltersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListPartnershipsWithFiltersQuery(baseOptions?: Apollo.QueryHookOptions<ListPartnershipsWithFiltersQuery, ListPartnershipsWithFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPartnershipsWithFiltersQuery, ListPartnershipsWithFiltersQueryVariables>(ListPartnershipsWithFiltersDocument, options);
      }
export function useListPartnershipsWithFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPartnershipsWithFiltersQuery, ListPartnershipsWithFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPartnershipsWithFiltersQuery, ListPartnershipsWithFiltersQueryVariables>(ListPartnershipsWithFiltersDocument, options);
        }
// @ts-ignore
export function useListPartnershipsWithFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListPartnershipsWithFiltersQuery, ListPartnershipsWithFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<ListPartnershipsWithFiltersQuery, ListPartnershipsWithFiltersQueryVariables>;
export function useListPartnershipsWithFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPartnershipsWithFiltersQuery, ListPartnershipsWithFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<ListPartnershipsWithFiltersQuery | undefined, ListPartnershipsWithFiltersQueryVariables>;
export function useListPartnershipsWithFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPartnershipsWithFiltersQuery, ListPartnershipsWithFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPartnershipsWithFiltersQuery, ListPartnershipsWithFiltersQueryVariables>(ListPartnershipsWithFiltersDocument, options);
        }
export type ListPartnershipsWithFiltersQueryHookResult = ReturnType<typeof useListPartnershipsWithFiltersQuery>;
export type ListPartnershipsWithFiltersLazyQueryHookResult = ReturnType<typeof useListPartnershipsWithFiltersLazyQuery>;
export type ListPartnershipsWithFiltersSuspenseQueryHookResult = ReturnType<typeof useListPartnershipsWithFiltersSuspenseQuery>;
export type ListPartnershipsWithFiltersQueryResult = Apollo.QueryResult<ListPartnershipsWithFiltersQuery, ListPartnershipsWithFiltersQueryVariables>;
export const ListProductsDocument = gql`
    query ListProducts($search: String, $pagination: ProductPaginationParams) {
  products(search: $search, pagination: $pagination) {
    ...ProductsData
  }
}
    ${ProductsDataFragmentDoc}`;

/**
 * __useListProductsQuery__
 *
 * To run a query within a React component, call `useListProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProductsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListProductsQuery(baseOptions?: Apollo.QueryHookOptions<ListProductsQuery, ListProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProductsQuery, ListProductsQueryVariables>(ListProductsDocument, options);
      }
export function useListProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProductsQuery, ListProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProductsQuery, ListProductsQueryVariables>(ListProductsDocument, options);
        }
// @ts-ignore
export function useListProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListProductsQuery, ListProductsQueryVariables>): Apollo.UseSuspenseQueryResult<ListProductsQuery, ListProductsQueryVariables>;
export function useListProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProductsQuery, ListProductsQueryVariables>): Apollo.UseSuspenseQueryResult<ListProductsQuery | undefined, ListProductsQueryVariables>;
export function useListProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProductsQuery, ListProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProductsQuery, ListProductsQueryVariables>(ListProductsDocument, options);
        }
export type ListProductsQueryHookResult = ReturnType<typeof useListProductsQuery>;
export type ListProductsLazyQueryHookResult = ReturnType<typeof useListProductsLazyQuery>;
export type ListProductsSuspenseQueryHookResult = ReturnType<typeof useListProductsSuspenseQuery>;
export type ListProductsQueryResult = Apollo.QueryResult<ListProductsQuery, ListProductsQueryVariables>;
export const CreateLocationDocument = gql`
    mutation CreateLocation($params: CreateAddressParams!) {
  createAddress(params: $params) {
    id
  }
}
    `;
export type CreateLocationMutationFn = Apollo.MutationFunction<CreateLocationMutation, CreateLocationMutationVariables>;

/**
 * __useCreateLocationMutation__
 *
 * To run a mutation, you first call `useCreateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationMutation, { data, loading, error }] = useCreateLocationMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationMutation, CreateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationMutation, CreateLocationMutationVariables>(CreateLocationDocument, options);
      }
export type CreateLocationMutationHookResult = ReturnType<typeof useCreateLocationMutation>;
export type CreateLocationMutationResult = Apollo.MutationResult<CreateLocationMutation>;
export type CreateLocationMutationOptions = Apollo.BaseMutationOptions<CreateLocationMutation, CreateLocationMutationVariables>;
export const ActorDocument = gql`
    query Actor($id: Int!) {
  actor(id: $id) {
    id
    officialDocument
    officialName
    openingDate
    cnae
    nickname
    documentType
    addresses {
      id
      name
      latitude
      longitude
      country
      state
      city
      street
      number
      postalCode
      neighborhood
      complement
      reference
      formattedAddress
      routePoints {
        id
      }
    }
    partnershipAsPartner {
      id
      internalCode
      contactDetails
      description
      nickname
      roles {
        id
        role
        accessGroup {
          id
          name
          slug
        }
      }
    }
  }
}
    `;

/**
 * __useActorQuery__
 *
 * To run a query within a React component, call `useActorQuery` and pass it any options that fit your needs.
 * When your component renders, `useActorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActorQuery(baseOptions: Apollo.QueryHookOptions<ActorQuery, ActorQueryVariables> & ({ variables: ActorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActorQuery, ActorQueryVariables>(ActorDocument, options);
      }
export function useActorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActorQuery, ActorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActorQuery, ActorQueryVariables>(ActorDocument, options);
        }
// @ts-ignore
export function useActorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActorQuery, ActorQueryVariables>): Apollo.UseSuspenseQueryResult<ActorQuery, ActorQueryVariables>;
export function useActorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActorQuery, ActorQueryVariables>): Apollo.UseSuspenseQueryResult<ActorQuery | undefined, ActorQueryVariables>;
export function useActorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActorQuery, ActorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActorQuery, ActorQueryVariables>(ActorDocument, options);
        }
export type ActorQueryHookResult = ReturnType<typeof useActorQuery>;
export type ActorLazyQueryHookResult = ReturnType<typeof useActorLazyQuery>;
export type ActorSuspenseQueryHookResult = ReturnType<typeof useActorSuspenseQuery>;
export type ActorQueryResult = Apollo.QueryResult<ActorQuery, ActorQueryVariables>;
export const GetNotificationGroupRecipientsDocument = gql`
    query GetNotificationGroupRecipients($filters: FilterNotificationGroupRecipientParams) {
  notificationGroupRecipients(filters: $filters) {
    id
    emails
    language
    notificationGroupRole {
      id
      role
      notificationGroup {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetNotificationGroupRecipientsQuery__
 *
 * To run a query within a React component, call `useGetNotificationGroupRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationGroupRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationGroupRecipientsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetNotificationGroupRecipientsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationGroupRecipientsQuery, GetNotificationGroupRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationGroupRecipientsQuery, GetNotificationGroupRecipientsQueryVariables>(GetNotificationGroupRecipientsDocument, options);
      }
export function useGetNotificationGroupRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationGroupRecipientsQuery, GetNotificationGroupRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationGroupRecipientsQuery, GetNotificationGroupRecipientsQueryVariables>(GetNotificationGroupRecipientsDocument, options);
        }
// @ts-ignore
export function useGetNotificationGroupRecipientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationGroupRecipientsQuery, GetNotificationGroupRecipientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationGroupRecipientsQuery, GetNotificationGroupRecipientsQueryVariables>;
export function useGetNotificationGroupRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationGroupRecipientsQuery, GetNotificationGroupRecipientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationGroupRecipientsQuery | undefined, GetNotificationGroupRecipientsQueryVariables>;
export function useGetNotificationGroupRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationGroupRecipientsQuery, GetNotificationGroupRecipientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationGroupRecipientsQuery, GetNotificationGroupRecipientsQueryVariables>(GetNotificationGroupRecipientsDocument, options);
        }
export type GetNotificationGroupRecipientsQueryHookResult = ReturnType<typeof useGetNotificationGroupRecipientsQuery>;
export type GetNotificationGroupRecipientsLazyQueryHookResult = ReturnType<typeof useGetNotificationGroupRecipientsLazyQuery>;
export type GetNotificationGroupRecipientsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationGroupRecipientsSuspenseQuery>;
export type GetNotificationGroupRecipientsQueryResult = Apollo.QueryResult<GetNotificationGroupRecipientsQuery, GetNotificationGroupRecipientsQueryVariables>;
export const UpdatePartnershipDocument = gql`
    mutation UpdatePartnership($partnerId: Int!, $params: UpdatePartnershipParams!) {
  updatePartnership(partnerId: $partnerId, params: $params) {
    id
    partner {
      id
    }
  }
}
    `;
export type UpdatePartnershipMutationFn = Apollo.MutationFunction<UpdatePartnershipMutation, UpdatePartnershipMutationVariables>;

/**
 * __useUpdatePartnershipMutation__
 *
 * To run a mutation, you first call `useUpdatePartnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnershipMutation, { data, loading, error }] = useUpdatePartnershipMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdatePartnershipMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartnershipMutation, UpdatePartnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartnershipMutation, UpdatePartnershipMutationVariables>(UpdatePartnershipDocument, options);
      }
export type UpdatePartnershipMutationHookResult = ReturnType<typeof useUpdatePartnershipMutation>;
export type UpdatePartnershipMutationResult = Apollo.MutationResult<UpdatePartnershipMutation>;
export type UpdatePartnershipMutationOptions = Apollo.BaseMutationOptions<UpdatePartnershipMutation, UpdatePartnershipMutationVariables>;
export const CreatePartnershipDocument = gql`
    mutation CreatePartnership($params: CreatePartnershipParams!) {
  createPartnership(params: $params) {
    id
    partner {
      id
    }
  }
}
    `;
export type CreatePartnershipMutationFn = Apollo.MutationFunction<CreatePartnershipMutation, CreatePartnershipMutationVariables>;

/**
 * __useCreatePartnershipMutation__
 *
 * To run a mutation, you first call `useCreatePartnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartnershipMutation, { data, loading, error }] = useCreatePartnershipMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreatePartnershipMutation(baseOptions?: Apollo.MutationHookOptions<CreatePartnershipMutation, CreatePartnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePartnershipMutation, CreatePartnershipMutationVariables>(CreatePartnershipDocument, options);
      }
export type CreatePartnershipMutationHookResult = ReturnType<typeof useCreatePartnershipMutation>;
export type CreatePartnershipMutationResult = Apollo.MutationResult<CreatePartnershipMutation>;
export type CreatePartnershipMutationOptions = Apollo.BaseMutationOptions<CreatePartnershipMutation, CreatePartnershipMutationVariables>;
export const ActorsCountDocument = gql`
    query ActorsCount($search: String) {
  actorsCount(search: $search, filters: {hideOwnerActor: true})
}
    `;

/**
 * __useActorsCountQuery__
 *
 * To run a query within a React component, call `useActorsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useActorsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActorsCountQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useActorsCountQuery(baseOptions?: Apollo.QueryHookOptions<ActorsCountQuery, ActorsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActorsCountQuery, ActorsCountQueryVariables>(ActorsCountDocument, options);
      }
export function useActorsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActorsCountQuery, ActorsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActorsCountQuery, ActorsCountQueryVariables>(ActorsCountDocument, options);
        }
// @ts-ignore
export function useActorsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActorsCountQuery, ActorsCountQueryVariables>): Apollo.UseSuspenseQueryResult<ActorsCountQuery, ActorsCountQueryVariables>;
export function useActorsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActorsCountQuery, ActorsCountQueryVariables>): Apollo.UseSuspenseQueryResult<ActorsCountQuery | undefined, ActorsCountQueryVariables>;
export function useActorsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActorsCountQuery, ActorsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActorsCountQuery, ActorsCountQueryVariables>(ActorsCountDocument, options);
        }
export type ActorsCountQueryHookResult = ReturnType<typeof useActorsCountQuery>;
export type ActorsCountLazyQueryHookResult = ReturnType<typeof useActorsCountLazyQuery>;
export type ActorsCountSuspenseQueryHookResult = ReturnType<typeof useActorsCountSuspenseQuery>;
export type ActorsCountQueryResult = Apollo.QueryResult<ActorsCountQuery, ActorsCountQueryVariables>;
export const ActorsDocument = gql`
    query Actors($search: String, $pagination: ActorPaginationParams) {
  actors(
    search: $search
    pagination: $pagination
    filters: {hideOwnerActor: true}
  ) {
    id
    officialName
    officialDocument
    openingDate
    documentType
    subsidiaries {
      id
      name
    }
    cnae
    verified
    tradingName
    partnershipAsPartner {
      id
      nicknameWithFallback
      internalCode
      description
      roles {
        id
        role
        accessGroup {
          id
          name
          slug
        }
      }
    }
  }
}
    `;

/**
 * __useActorsQuery__
 *
 * To run a query within a React component, call `useActorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActorsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useActorsQuery(baseOptions?: Apollo.QueryHookOptions<ActorsQuery, ActorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActorsQuery, ActorsQueryVariables>(ActorsDocument, options);
      }
export function useActorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActorsQuery, ActorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActorsQuery, ActorsQueryVariables>(ActorsDocument, options);
        }
// @ts-ignore
export function useActorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActorsQuery, ActorsQueryVariables>): Apollo.UseSuspenseQueryResult<ActorsQuery, ActorsQueryVariables>;
export function useActorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActorsQuery, ActorsQueryVariables>): Apollo.UseSuspenseQueryResult<ActorsQuery | undefined, ActorsQueryVariables>;
export function useActorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActorsQuery, ActorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActorsQuery, ActorsQueryVariables>(ActorsDocument, options);
        }
export type ActorsQueryHookResult = ReturnType<typeof useActorsQuery>;
export type ActorsLazyQueryHookResult = ReturnType<typeof useActorsLazyQuery>;
export type ActorsSuspenseQueryHookResult = ReturnType<typeof useActorsSuspenseQuery>;
export type ActorsQueryResult = Apollo.QueryResult<ActorsQuery, ActorsQueryVariables>;
export const DeletePartnershipDocument = gql`
    mutation DeletePartnership($actorId: Int!) {
  deletePartnership(actorId: $actorId) {
    id
    partner {
      id
    }
  }
}
    `;
export type DeletePartnershipMutationFn = Apollo.MutationFunction<DeletePartnershipMutation, DeletePartnershipMutationVariables>;

/**
 * __useDeletePartnershipMutation__
 *
 * To run a mutation, you first call `useDeletePartnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePartnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePartnershipMutation, { data, loading, error }] = useDeletePartnershipMutation({
 *   variables: {
 *      actorId: // value for 'actorId'
 *   },
 * });
 */
export function useDeletePartnershipMutation(baseOptions?: Apollo.MutationHookOptions<DeletePartnershipMutation, DeletePartnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePartnershipMutation, DeletePartnershipMutationVariables>(DeletePartnershipDocument, options);
      }
export type DeletePartnershipMutationHookResult = ReturnType<typeof useDeletePartnershipMutation>;
export type DeletePartnershipMutationResult = Apollo.MutationResult<DeletePartnershipMutation>;
export type DeletePartnershipMutationOptions = Apollo.BaseMutationOptions<DeletePartnershipMutation, DeletePartnershipMutationVariables>;
export const AgentExecutionsCountDocument = gql`
    query AgentExecutionsCount($filters: FilterAgentExecutionParams) {
  agentExecutionsCount(filters: $filters)
}
    `;

/**
 * __useAgentExecutionsCountQuery__
 *
 * To run a query within a React component, call `useAgentExecutionsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentExecutionsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentExecutionsCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAgentExecutionsCountQuery(baseOptions?: Apollo.QueryHookOptions<AgentExecutionsCountQuery, AgentExecutionsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentExecutionsCountQuery, AgentExecutionsCountQueryVariables>(AgentExecutionsCountDocument, options);
      }
export function useAgentExecutionsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentExecutionsCountQuery, AgentExecutionsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentExecutionsCountQuery, AgentExecutionsCountQueryVariables>(AgentExecutionsCountDocument, options);
        }
// @ts-ignore
export function useAgentExecutionsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgentExecutionsCountQuery, AgentExecutionsCountQueryVariables>): Apollo.UseSuspenseQueryResult<AgentExecutionsCountQuery, AgentExecutionsCountQueryVariables>;
export function useAgentExecutionsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentExecutionsCountQuery, AgentExecutionsCountQueryVariables>): Apollo.UseSuspenseQueryResult<AgentExecutionsCountQuery | undefined, AgentExecutionsCountQueryVariables>;
export function useAgentExecutionsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentExecutionsCountQuery, AgentExecutionsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentExecutionsCountQuery, AgentExecutionsCountQueryVariables>(AgentExecutionsCountDocument, options);
        }
export type AgentExecutionsCountQueryHookResult = ReturnType<typeof useAgentExecutionsCountQuery>;
export type AgentExecutionsCountLazyQueryHookResult = ReturnType<typeof useAgentExecutionsCountLazyQuery>;
export type AgentExecutionsCountSuspenseQueryHookResult = ReturnType<typeof useAgentExecutionsCountSuspenseQuery>;
export type AgentExecutionsCountQueryResult = Apollo.QueryResult<AgentExecutionsCountQuery, AgentExecutionsCountQueryVariables>;
export const AgentExecutionsDocument = gql`
    query AgentExecutions($filters: FilterAgentExecutionParams, $pagination: AgentExecutionPaginationParams) {
  agentExecutions(filters: $filters, pagination: $pagination) {
    id
    executionEndAt
    executionStartAt
    insertedAt
    status
    lpco {
      id
      number
    }
    order {
      id
      referenceCode
    }
    process {
      id
      referenceCode
    }
    agent {
      id
      name
      triggerRecurringConfig {
        operationsInputConfig {
          entity
        }
      }
      triggerEventConfig {
        entity
      }
    }
  }
}
    `;

/**
 * __useAgentExecutionsQuery__
 *
 * To run a query within a React component, call `useAgentExecutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentExecutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentExecutionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAgentExecutionsQuery(baseOptions?: Apollo.QueryHookOptions<AgentExecutionsQuery, AgentExecutionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentExecutionsQuery, AgentExecutionsQueryVariables>(AgentExecutionsDocument, options);
      }
export function useAgentExecutionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentExecutionsQuery, AgentExecutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentExecutionsQuery, AgentExecutionsQueryVariables>(AgentExecutionsDocument, options);
        }
// @ts-ignore
export function useAgentExecutionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgentExecutionsQuery, AgentExecutionsQueryVariables>): Apollo.UseSuspenseQueryResult<AgentExecutionsQuery, AgentExecutionsQueryVariables>;
export function useAgentExecutionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentExecutionsQuery, AgentExecutionsQueryVariables>): Apollo.UseSuspenseQueryResult<AgentExecutionsQuery | undefined, AgentExecutionsQueryVariables>;
export function useAgentExecutionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentExecutionsQuery, AgentExecutionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentExecutionsQuery, AgentExecutionsQueryVariables>(AgentExecutionsDocument, options);
        }
export type AgentExecutionsQueryHookResult = ReturnType<typeof useAgentExecutionsQuery>;
export type AgentExecutionsLazyQueryHookResult = ReturnType<typeof useAgentExecutionsLazyQuery>;
export type AgentExecutionsSuspenseQueryHookResult = ReturnType<typeof useAgentExecutionsSuspenseQuery>;
export type AgentExecutionsQueryResult = Apollo.QueryResult<AgentExecutionsQuery, AgentExecutionsQueryVariables>;
export const GetAgentExecutionDocument = gql`
    query getAgentExecution($id: ID!) {
  agentExecution(id: $id) {
    id
    executionEndAt
    executionStartAt
    insertedAt
    status
    actionsLog
    inputLog
    processorResultLog
    callbackUrl
    devConfig {
      skipActions
      runMode
      curl
      callbackCurl
    }
    devMode
    lpco {
      id
      number
    }
    order {
      id
      referenceCode
      operation {
        id
        title
      }
    }
    process {
      id
      referenceCode
      operation {
        id
        title
      }
    }
    agent {
      id
      name
      triggerType
      actions {
        type
      }
      processor {
        id
        name
        icon
      }
      triggerRecurringConfig {
        inputType
        operationsInputConfig {
          entity
        }
      }
      triggerEventConfig {
        entity
        event
      }
    }
  }
}
    `;

/**
 * __useGetAgentExecutionQuery__
 *
 * To run a query within a React component, call `useGetAgentExecutionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentExecutionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentExecutionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAgentExecutionQuery(baseOptions: Apollo.QueryHookOptions<GetAgentExecutionQuery, GetAgentExecutionQueryVariables> & ({ variables: GetAgentExecutionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentExecutionQuery, GetAgentExecutionQueryVariables>(GetAgentExecutionDocument, options);
      }
export function useGetAgentExecutionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentExecutionQuery, GetAgentExecutionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentExecutionQuery, GetAgentExecutionQueryVariables>(GetAgentExecutionDocument, options);
        }
// @ts-ignore
export function useGetAgentExecutionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentExecutionQuery, GetAgentExecutionQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentExecutionQuery, GetAgentExecutionQueryVariables>;
export function useGetAgentExecutionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentExecutionQuery, GetAgentExecutionQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentExecutionQuery | undefined, GetAgentExecutionQueryVariables>;
export function useGetAgentExecutionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentExecutionQuery, GetAgentExecutionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentExecutionQuery, GetAgentExecutionQueryVariables>(GetAgentExecutionDocument, options);
        }
export type GetAgentExecutionQueryHookResult = ReturnType<typeof useGetAgentExecutionQuery>;
export type GetAgentExecutionLazyQueryHookResult = ReturnType<typeof useGetAgentExecutionLazyQuery>;
export type GetAgentExecutionSuspenseQueryHookResult = ReturnType<typeof useGetAgentExecutionSuspenseQuery>;
export type GetAgentExecutionQueryResult = Apollo.QueryResult<GetAgentExecutionQuery, GetAgentExecutionQueryVariables>;
export const AgentsDocument = gql`
    query Agents($filters: FilterAgentParams, $pagination: AgentPaginationParams) {
  agents(filters: $filters, pagination: $pagination) {
    id
    name
    triggerType
    lastExecutionAt
    actions {
      type
    }
    triggerRecurringConfig {
      inputType
    }
    processor {
      id
      name
      icon
    }
  }
}
    `;

/**
 * __useAgentsQuery__
 *
 * To run a query within a React component, call `useAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAgentsQuery(baseOptions?: Apollo.QueryHookOptions<AgentsQuery, AgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentsQuery, AgentsQueryVariables>(AgentsDocument, options);
      }
export function useAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentsQuery, AgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentsQuery, AgentsQueryVariables>(AgentsDocument, options);
        }
// @ts-ignore
export function useAgentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgentsQuery, AgentsQueryVariables>): Apollo.UseSuspenseQueryResult<AgentsQuery, AgentsQueryVariables>;
export function useAgentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentsQuery, AgentsQueryVariables>): Apollo.UseSuspenseQueryResult<AgentsQuery | undefined, AgentsQueryVariables>;
export function useAgentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentsQuery, AgentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentsQuery, AgentsQueryVariables>(AgentsDocument, options);
        }
export type AgentsQueryHookResult = ReturnType<typeof useAgentsQuery>;
export type AgentsLazyQueryHookResult = ReturnType<typeof useAgentsLazyQuery>;
export type AgentsSuspenseQueryHookResult = ReturnType<typeof useAgentsSuspenseQuery>;
export type AgentsQueryResult = Apollo.QueryResult<AgentsQuery, AgentsQueryVariables>;
export const CreateAgentDocument = gql`
    mutation CreateAgent($params: CreateAgentParams!) {
  createAgent(params: $params) {
    id
    name
  }
}
    `;
export type CreateAgentMutationFn = Apollo.MutationFunction<CreateAgentMutation, CreateAgentMutationVariables>;

/**
 * __useCreateAgentMutation__
 *
 * To run a mutation, you first call `useCreateAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgentMutation, { data, loading, error }] = useCreateAgentMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateAgentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgentMutation, CreateAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgentMutation, CreateAgentMutationVariables>(CreateAgentDocument, options);
      }
export type CreateAgentMutationHookResult = ReturnType<typeof useCreateAgentMutation>;
export type CreateAgentMutationResult = Apollo.MutationResult<CreateAgentMutation>;
export type CreateAgentMutationOptions = Apollo.BaseMutationOptions<CreateAgentMutation, CreateAgentMutationVariables>;
export const GetExternalDashboardUrlDocument = gql`
    query GetExternalDashboardUrl($dashboardId: Int) {
  externalDashboardUrl(dashboardId: $dashboardId)
}
    `;

/**
 * __useGetExternalDashboardUrlQuery__
 *
 * To run a query within a React component, call `useGetExternalDashboardUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalDashboardUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalDashboardUrlQuery({
 *   variables: {
 *      dashboardId: // value for 'dashboardId'
 *   },
 * });
 */
export function useGetExternalDashboardUrlQuery(baseOptions?: Apollo.QueryHookOptions<GetExternalDashboardUrlQuery, GetExternalDashboardUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalDashboardUrlQuery, GetExternalDashboardUrlQueryVariables>(GetExternalDashboardUrlDocument, options);
      }
export function useGetExternalDashboardUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalDashboardUrlQuery, GetExternalDashboardUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalDashboardUrlQuery, GetExternalDashboardUrlQueryVariables>(GetExternalDashboardUrlDocument, options);
        }
// @ts-ignore
export function useGetExternalDashboardUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExternalDashboardUrlQuery, GetExternalDashboardUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetExternalDashboardUrlQuery, GetExternalDashboardUrlQueryVariables>;
export function useGetExternalDashboardUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalDashboardUrlQuery, GetExternalDashboardUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetExternalDashboardUrlQuery | undefined, GetExternalDashboardUrlQueryVariables>;
export function useGetExternalDashboardUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalDashboardUrlQuery, GetExternalDashboardUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExternalDashboardUrlQuery, GetExternalDashboardUrlQueryVariables>(GetExternalDashboardUrlDocument, options);
        }
export type GetExternalDashboardUrlQueryHookResult = ReturnType<typeof useGetExternalDashboardUrlQuery>;
export type GetExternalDashboardUrlLazyQueryHookResult = ReturnType<typeof useGetExternalDashboardUrlLazyQuery>;
export type GetExternalDashboardUrlSuspenseQueryHookResult = ReturnType<typeof useGetExternalDashboardUrlSuspenseQuery>;
export type GetExternalDashboardUrlQueryResult = Apollo.QueryResult<GetExternalDashboardUrlQuery, GetExternalDashboardUrlQueryVariables>;
export const DriversCountDocument = gql`
    query DriversCount($search: String) {
  driversCount(search: $search)
}
    `;

/**
 * __useDriversCountQuery__
 *
 * To run a query within a React component, call `useDriversCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDriversCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDriversCountQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useDriversCountQuery(baseOptions?: Apollo.QueryHookOptions<DriversCountQuery, DriversCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DriversCountQuery, DriversCountQueryVariables>(DriversCountDocument, options);
      }
export function useDriversCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DriversCountQuery, DriversCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DriversCountQuery, DriversCountQueryVariables>(DriversCountDocument, options);
        }
// @ts-ignore
export function useDriversCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DriversCountQuery, DriversCountQueryVariables>): Apollo.UseSuspenseQueryResult<DriversCountQuery, DriversCountQueryVariables>;
export function useDriversCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DriversCountQuery, DriversCountQueryVariables>): Apollo.UseSuspenseQueryResult<DriversCountQuery | undefined, DriversCountQueryVariables>;
export function useDriversCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DriversCountQuery, DriversCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DriversCountQuery, DriversCountQueryVariables>(DriversCountDocument, options);
        }
export type DriversCountQueryHookResult = ReturnType<typeof useDriversCountQuery>;
export type DriversCountLazyQueryHookResult = ReturnType<typeof useDriversCountLazyQuery>;
export type DriversCountSuspenseQueryHookResult = ReturnType<typeof useDriversCountSuspenseQuery>;
export type DriversCountQueryResult = Apollo.QueryResult<DriversCountQuery, DriversCountQueryVariables>;
export const CreateDriverDocument = gql`
    mutation CreateDriver($params: CreateDriverParams!) {
  createDriver(params: $params) {
    id
  }
}
    `;
export type CreateDriverMutationFn = Apollo.MutationFunction<CreateDriverMutation, CreateDriverMutationVariables>;

/**
 * __useCreateDriverMutation__
 *
 * To run a mutation, you first call `useCreateDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDriverMutation, { data, loading, error }] = useCreateDriverMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateDriverMutation(baseOptions?: Apollo.MutationHookOptions<CreateDriverMutation, CreateDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDriverMutation, CreateDriverMutationVariables>(CreateDriverDocument, options);
      }
export type CreateDriverMutationHookResult = ReturnType<typeof useCreateDriverMutation>;
export type CreateDriverMutationResult = Apollo.MutationResult<CreateDriverMutation>;
export type CreateDriverMutationOptions = Apollo.BaseMutationOptions<CreateDriverMutation, CreateDriverMutationVariables>;
export const DeleteDriverDocument = gql`
    mutation DeleteDriver($id: Int!) {
  deleteDriver(id: $id) {
    id
  }
}
    `;
export type DeleteDriverMutationFn = Apollo.MutationFunction<DeleteDriverMutation, DeleteDriverMutationVariables>;

/**
 * __useDeleteDriverMutation__
 *
 * To run a mutation, you first call `useDeleteDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDriverMutation, { data, loading, error }] = useDeleteDriverMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDriverMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDriverMutation, DeleteDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDriverMutation, DeleteDriverMutationVariables>(DeleteDriverDocument, options);
      }
export type DeleteDriverMutationHookResult = ReturnType<typeof useDeleteDriverMutation>;
export type DeleteDriverMutationResult = Apollo.MutationResult<DeleteDriverMutation>;
export type DeleteDriverMutationOptions = Apollo.BaseMutationOptions<DeleteDriverMutation, DeleteDriverMutationVariables>;
export const DriverDocument = gql`
    query Driver($id: Int!) {
  driver(id: $id) {
    id
    birthday
    cpf
    licenseCategory
    licenseExpirationDate
    licenseNumber
    name
    officialDocument
    country {
      code
    }
  }
}
    `;

/**
 * __useDriverQuery__
 *
 * To run a query within a React component, call `useDriverQuery` and pass it any options that fit your needs.
 * When your component renders, `useDriverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDriverQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDriverQuery(baseOptions: Apollo.QueryHookOptions<DriverQuery, DriverQueryVariables> & ({ variables: DriverQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DriverQuery, DriverQueryVariables>(DriverDocument, options);
      }
export function useDriverLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DriverQuery, DriverQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DriverQuery, DriverQueryVariables>(DriverDocument, options);
        }
// @ts-ignore
export function useDriverSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DriverQuery, DriverQueryVariables>): Apollo.UseSuspenseQueryResult<DriverQuery, DriverQueryVariables>;
export function useDriverSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DriverQuery, DriverQueryVariables>): Apollo.UseSuspenseQueryResult<DriverQuery | undefined, DriverQueryVariables>;
export function useDriverSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DriverQuery, DriverQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DriverQuery, DriverQueryVariables>(DriverDocument, options);
        }
export type DriverQueryHookResult = ReturnType<typeof useDriverQuery>;
export type DriverLazyQueryHookResult = ReturnType<typeof useDriverLazyQuery>;
export type DriverSuspenseQueryHookResult = ReturnType<typeof useDriverSuspenseQuery>;
export type DriverQueryResult = Apollo.QueryResult<DriverQuery, DriverQueryVariables>;
export const DriversDocument = gql`
    query Drivers($search: String, $pagination: DriverPaginationParams) {
  drivers(search: $search, pagination: $pagination) {
    id
    name
    officialDocument
    cpf
    birthday
    licenseNumber
    licenseCategory
    licenseExpirationDate
    country {
      code
    }
  }
}
    `;

/**
 * __useDriversQuery__
 *
 * To run a query within a React component, call `useDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDriversQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useDriversQuery(baseOptions?: Apollo.QueryHookOptions<DriversQuery, DriversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DriversQuery, DriversQueryVariables>(DriversDocument, options);
      }
export function useDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DriversQuery, DriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DriversQuery, DriversQueryVariables>(DriversDocument, options);
        }
// @ts-ignore
export function useDriversSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DriversQuery, DriversQueryVariables>): Apollo.UseSuspenseQueryResult<DriversQuery, DriversQueryVariables>;
export function useDriversSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DriversQuery, DriversQueryVariables>): Apollo.UseSuspenseQueryResult<DriversQuery | undefined, DriversQueryVariables>;
export function useDriversSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DriversQuery, DriversQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DriversQuery, DriversQueryVariables>(DriversDocument, options);
        }
export type DriversQueryHookResult = ReturnType<typeof useDriversQuery>;
export type DriversLazyQueryHookResult = ReturnType<typeof useDriversLazyQuery>;
export type DriversSuspenseQueryHookResult = ReturnType<typeof useDriversSuspenseQuery>;
export type DriversQueryResult = Apollo.QueryResult<DriversQuery, DriversQueryVariables>;
export const UpdateDriverDocument = gql`
    mutation UpdateDriver($id: Int!, $params: UpdateDriverParams!) {
  updateDriver(id: $id, params: $params) {
    id
  }
}
    `;
export type UpdateDriverMutationFn = Apollo.MutationFunction<UpdateDriverMutation, UpdateDriverMutationVariables>;

/**
 * __useUpdateDriverMutation__
 *
 * To run a mutation, you first call `useUpdateDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverMutation, { data, loading, error }] = useUpdateDriverMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateDriverMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverMutation, UpdateDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverMutation, UpdateDriverMutationVariables>(UpdateDriverDocument, options);
      }
export type UpdateDriverMutationHookResult = ReturnType<typeof useUpdateDriverMutation>;
export type UpdateDriverMutationResult = Apollo.MutationResult<UpdateDriverMutation>;
export type UpdateDriverMutationOptions = Apollo.BaseMutationOptions<UpdateDriverMutation, UpdateDriverMutationVariables>;
export const GetVesselsDocument = gql`
    query GetVessels($search: String, $filters: FilterVesselParams) {
  vesselsCount(search: $search, filters: $filters)
  vessels(search: $search, filters: $filters) {
    id
    imoNumber
    mmsiNumber
    name
    country {
      code
    }
    aisClass
    callsign
    dimensions {
      a
      b
      c
      d
      length
      width
    }
    shipType
    shipSubType
    processes {
      id
      referenceCode
      foreignTradeShipment {
        id
        transportables {
          id
          type
          container {
            id
            code
            hidden
          }
        }
      }
    }
    lastPositionUpdate {
      id
      speed
      latitude
      longitude
      aisUpdatedAt
      voyageAtd
      voyageOriginPortName
      voyageOriginPortUnlocode
      voyageEta
      voyageDestinationPortName
      voyageDestinationPortUnlocode
      course
      rot
      heading
    }
  }
}
    `;

/**
 * __useGetVesselsQuery__
 *
 * To run a query within a React component, call `useGetVesselsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVesselsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVesselsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetVesselsQuery(baseOptions?: Apollo.QueryHookOptions<GetVesselsQuery, GetVesselsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVesselsQuery, GetVesselsQueryVariables>(GetVesselsDocument, options);
      }
export function useGetVesselsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVesselsQuery, GetVesselsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVesselsQuery, GetVesselsQueryVariables>(GetVesselsDocument, options);
        }
// @ts-ignore
export function useGetVesselsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVesselsQuery, GetVesselsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVesselsQuery, GetVesselsQueryVariables>;
export function useGetVesselsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVesselsQuery, GetVesselsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVesselsQuery | undefined, GetVesselsQueryVariables>;
export function useGetVesselsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVesselsQuery, GetVesselsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVesselsQuery, GetVesselsQueryVariables>(GetVesselsDocument, options);
        }
export type GetVesselsQueryHookResult = ReturnType<typeof useGetVesselsQuery>;
export type GetVesselsLazyQueryHookResult = ReturnType<typeof useGetVesselsLazyQuery>;
export type GetVesselsSuspenseQueryHookResult = ReturnType<typeof useGetVesselsSuspenseQuery>;
export type GetVesselsQueryResult = Apollo.QueryResult<GetVesselsQuery, GetVesselsQueryVariables>;
export const InsightsDocument = gql`
    query Insights($filters: FilterInsightParams) {
  insights(filters: $filters) {
    id
    explanation
    hint
    insertedAt
    lastSeenAt
    status
    dismissReason
    feedbackAt
    feedbackComment
    translatedData {
      path
      label
      value
    }
    rule {
      slug
      name
      impact
      description
      analysis {
        slug
        name
        category
        description
      }
    }
    process {
      ...InsightsProcessFragment
    }
    order {
      id
      referenceCode
      operation {
        id
        title
      }
    }
    foreignTradeItemShipment {
      id
      foreignTradeShipment {
        id
        process {
          ...InsightsProcessFragment
        }
      }
    }
    transportable {
      id
      foreignTradeShipment {
        id
        process {
          ...InsightsProcessFragment
        }
      }
    }
    lpco {
      id
      number
    }
  }
}
    ${InsightsProcessFragmentFragmentDoc}`;

/**
 * __useInsightsQuery__
 *
 * To run a query within a React component, call `useInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useInsightsQuery(baseOptions?: Apollo.QueryHookOptions<InsightsQuery, InsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightsQuery, InsightsQueryVariables>(InsightsDocument, options);
      }
export function useInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightsQuery, InsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightsQuery, InsightsQueryVariables>(InsightsDocument, options);
        }
// @ts-ignore
export function useInsightsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InsightsQuery, InsightsQueryVariables>): Apollo.UseSuspenseQueryResult<InsightsQuery, InsightsQueryVariables>;
export function useInsightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightsQuery, InsightsQueryVariables>): Apollo.UseSuspenseQueryResult<InsightsQuery | undefined, InsightsQueryVariables>;
export function useInsightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightsQuery, InsightsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightsQuery, InsightsQueryVariables>(InsightsDocument, options);
        }
export type InsightsQueryHookResult = ReturnType<typeof useInsightsQuery>;
export type InsightsLazyQueryHookResult = ReturnType<typeof useInsightsLazyQuery>;
export type InsightsSuspenseQueryHookResult = ReturnType<typeof useInsightsSuspenseQuery>;
export type InsightsQueryResult = Apollo.QueryResult<InsightsQuery, InsightsQueryVariables>;
export const GetApiKeysDocument = gql`
    query GetApiKeys {
  apiKeys {
    id
    name
    accessGroup {
      id
      allowedOperations {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useGetApiKeysQuery__
 *
 * To run a query within a React component, call `useGetApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApiKeysQuery(baseOptions?: Apollo.QueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
      }
export function useGetApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
        }
// @ts-ignore
export function useGetApiKeysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiKeysQuery, GetApiKeysQueryVariables>;
export function useGetApiKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiKeysQuery | undefined, GetApiKeysQueryVariables>;
export function useGetApiKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
        }
export type GetApiKeysQueryHookResult = ReturnType<typeof useGetApiKeysQuery>;
export type GetApiKeysLazyQueryHookResult = ReturnType<typeof useGetApiKeysLazyQuery>;
export type GetApiKeysSuspenseQueryHookResult = ReturnType<typeof useGetApiKeysSuspenseQuery>;
export type GetApiKeysQueryResult = Apollo.QueryResult<GetApiKeysQuery, GetApiKeysQueryVariables>;
export const GetOpenApiSpecDocument = gql`
    query GetOpenApiSpec($apiKeyId: Int!, $operationId: Int!) {
  openApiSpec(apiKeyId: $apiKeyId, operationId: $operationId)
}
    `;

/**
 * __useGetOpenApiSpecQuery__
 *
 * To run a query within a React component, call `useGetOpenApiSpecQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenApiSpecQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpenApiSpecQuery({
 *   variables: {
 *      apiKeyId: // value for 'apiKeyId'
 *      operationId: // value for 'operationId'
 *   },
 * });
 */
export function useGetOpenApiSpecQuery(baseOptions: Apollo.QueryHookOptions<GetOpenApiSpecQuery, GetOpenApiSpecQueryVariables> & ({ variables: GetOpenApiSpecQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpenApiSpecQuery, GetOpenApiSpecQueryVariables>(GetOpenApiSpecDocument, options);
      }
export function useGetOpenApiSpecLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpenApiSpecQuery, GetOpenApiSpecQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpenApiSpecQuery, GetOpenApiSpecQueryVariables>(GetOpenApiSpecDocument, options);
        }
// @ts-ignore
export function useGetOpenApiSpecSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOpenApiSpecQuery, GetOpenApiSpecQueryVariables>): Apollo.UseSuspenseQueryResult<GetOpenApiSpecQuery, GetOpenApiSpecQueryVariables>;
export function useGetOpenApiSpecSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOpenApiSpecQuery, GetOpenApiSpecQueryVariables>): Apollo.UseSuspenseQueryResult<GetOpenApiSpecQuery | undefined, GetOpenApiSpecQueryVariables>;
export function useGetOpenApiSpecSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOpenApiSpecQuery, GetOpenApiSpecQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOpenApiSpecQuery, GetOpenApiSpecQueryVariables>(GetOpenApiSpecDocument, options);
        }
export type GetOpenApiSpecQueryHookResult = ReturnType<typeof useGetOpenApiSpecQuery>;
export type GetOpenApiSpecLazyQueryHookResult = ReturnType<typeof useGetOpenApiSpecLazyQuery>;
export type GetOpenApiSpecSuspenseQueryHookResult = ReturnType<typeof useGetOpenApiSpecSuspenseQuery>;
export type GetOpenApiSpecQueryResult = Apollo.QueryResult<GetOpenApiSpecQuery, GetOpenApiSpecQueryVariables>;
export const GetApiRequestDocument = gql`
    query GetApiRequest($id: Int!) {
  apiRequest(id: $id) {
    id
    method
    statusCode
    endpoint
    referenceCodes
    request
    response
    insertedAt
    itemId
    itemType
    apiKey {
      id
      name
    }
  }
}
    `;

/**
 * __useGetApiRequestQuery__
 *
 * To run a query within a React component, call `useGetApiRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetApiRequestQuery(baseOptions: Apollo.QueryHookOptions<GetApiRequestQuery, GetApiRequestQueryVariables> & ({ variables: GetApiRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiRequestQuery, GetApiRequestQueryVariables>(GetApiRequestDocument, options);
      }
export function useGetApiRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiRequestQuery, GetApiRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiRequestQuery, GetApiRequestQueryVariables>(GetApiRequestDocument, options);
        }
// @ts-ignore
export function useGetApiRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApiRequestQuery, GetApiRequestQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiRequestQuery, GetApiRequestQueryVariables>;
export function useGetApiRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiRequestQuery, GetApiRequestQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiRequestQuery | undefined, GetApiRequestQueryVariables>;
export function useGetApiRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiRequestQuery, GetApiRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApiRequestQuery, GetApiRequestQueryVariables>(GetApiRequestDocument, options);
        }
export type GetApiRequestQueryHookResult = ReturnType<typeof useGetApiRequestQuery>;
export type GetApiRequestLazyQueryHookResult = ReturnType<typeof useGetApiRequestLazyQuery>;
export type GetApiRequestSuspenseQueryHookResult = ReturnType<typeof useGetApiRequestSuspenseQuery>;
export type GetApiRequestQueryResult = Apollo.QueryResult<GetApiRequestQuery, GetApiRequestQueryVariables>;
export const GetApiRequestsErrorsAndSuccessesCountDocument = gql`
    query GetApiRequestsErrorsAndSuccessesCount($operationIds: [Int!], $countLimit: Int, $minInsertedAt: DateTime, $maxInsertedAt: DateTime) {
  apiRequestsSuccess: apiRequestsCount(
    filters: {statusCode: [200, 201, 204], operationId: $operationIds, minInsertedAt: $minInsertedAt, maxInsertedAt: $maxInsertedAt}
    limit: $countLimit
  )
  apiRequestsError: apiRequestsCount(
    filters: {statusCode: [400, 401, 403, 404, 408, 413, 414, 422, 429, 500, 502, 503, 504], operationId: $operationIds, minInsertedAt: $minInsertedAt, maxInsertedAt: $maxInsertedAt}
    limit: $countLimit
  )
}
    `;

/**
 * __useGetApiRequestsErrorsAndSuccessesCountQuery__
 *
 * To run a query within a React component, call `useGetApiRequestsErrorsAndSuccessesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiRequestsErrorsAndSuccessesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiRequestsErrorsAndSuccessesCountQuery({
 *   variables: {
 *      operationIds: // value for 'operationIds'
 *      countLimit: // value for 'countLimit'
 *      minInsertedAt: // value for 'minInsertedAt'
 *      maxInsertedAt: // value for 'maxInsertedAt'
 *   },
 * });
 */
export function useGetApiRequestsErrorsAndSuccessesCountQuery(baseOptions?: Apollo.QueryHookOptions<GetApiRequestsErrorsAndSuccessesCountQuery, GetApiRequestsErrorsAndSuccessesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiRequestsErrorsAndSuccessesCountQuery, GetApiRequestsErrorsAndSuccessesCountQueryVariables>(GetApiRequestsErrorsAndSuccessesCountDocument, options);
      }
export function useGetApiRequestsErrorsAndSuccessesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiRequestsErrorsAndSuccessesCountQuery, GetApiRequestsErrorsAndSuccessesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiRequestsErrorsAndSuccessesCountQuery, GetApiRequestsErrorsAndSuccessesCountQueryVariables>(GetApiRequestsErrorsAndSuccessesCountDocument, options);
        }
// @ts-ignore
export function useGetApiRequestsErrorsAndSuccessesCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApiRequestsErrorsAndSuccessesCountQuery, GetApiRequestsErrorsAndSuccessesCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiRequestsErrorsAndSuccessesCountQuery, GetApiRequestsErrorsAndSuccessesCountQueryVariables>;
export function useGetApiRequestsErrorsAndSuccessesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiRequestsErrorsAndSuccessesCountQuery, GetApiRequestsErrorsAndSuccessesCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiRequestsErrorsAndSuccessesCountQuery | undefined, GetApiRequestsErrorsAndSuccessesCountQueryVariables>;
export function useGetApiRequestsErrorsAndSuccessesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiRequestsErrorsAndSuccessesCountQuery, GetApiRequestsErrorsAndSuccessesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApiRequestsErrorsAndSuccessesCountQuery, GetApiRequestsErrorsAndSuccessesCountQueryVariables>(GetApiRequestsErrorsAndSuccessesCountDocument, options);
        }
export type GetApiRequestsErrorsAndSuccessesCountQueryHookResult = ReturnType<typeof useGetApiRequestsErrorsAndSuccessesCountQuery>;
export type GetApiRequestsErrorsAndSuccessesCountLazyQueryHookResult = ReturnType<typeof useGetApiRequestsErrorsAndSuccessesCountLazyQuery>;
export type GetApiRequestsErrorsAndSuccessesCountSuspenseQueryHookResult = ReturnType<typeof useGetApiRequestsErrorsAndSuccessesCountSuspenseQuery>;
export type GetApiRequestsErrorsAndSuccessesCountQueryResult = Apollo.QueryResult<GetApiRequestsErrorsAndSuccessesCountQuery, GetApiRequestsErrorsAndSuccessesCountQueryVariables>;
export const GetApiRequestsDocument = gql`
    query GetApiRequests($filters: FilterApiRequestParams, $pagination: PaginationApiRequestParams, $pathFilters: JSON) {
  apiRequests(
    filters: $filters
    pagination: $pagination
    pathFilters: $pathFilters
  ) {
    id
    method
    statusCode
    endpoint
    referenceCodes
    itemId
    itemType
    insertedAt
    apiKey {
      id
      name
    }
  }
}
    `;

/**
 * __useGetApiRequestsQuery__
 *
 * To run a query within a React component, call `useGetApiRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiRequestsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      pathFilters: // value for 'pathFilters'
 *   },
 * });
 */
export function useGetApiRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetApiRequestsQuery, GetApiRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiRequestsQuery, GetApiRequestsQueryVariables>(GetApiRequestsDocument, options);
      }
export function useGetApiRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiRequestsQuery, GetApiRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiRequestsQuery, GetApiRequestsQueryVariables>(GetApiRequestsDocument, options);
        }
// @ts-ignore
export function useGetApiRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApiRequestsQuery, GetApiRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiRequestsQuery, GetApiRequestsQueryVariables>;
export function useGetApiRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiRequestsQuery, GetApiRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiRequestsQuery | undefined, GetApiRequestsQueryVariables>;
export function useGetApiRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiRequestsQuery, GetApiRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApiRequestsQuery, GetApiRequestsQueryVariables>(GetApiRequestsDocument, options);
        }
export type GetApiRequestsQueryHookResult = ReturnType<typeof useGetApiRequestsQuery>;
export type GetApiRequestsLazyQueryHookResult = ReturnType<typeof useGetApiRequestsLazyQuery>;
export type GetApiRequestsSuspenseQueryHookResult = ReturnType<typeof useGetApiRequestsSuspenseQuery>;
export type GetApiRequestsQueryResult = Apollo.QueryResult<GetApiRequestsQuery, GetApiRequestsQueryVariables>;
export const GetOperationsLogDocument = gql`
    query GetOperationsLog($filtersApiRequests: FilterApiRequestParams, $countLimit: Int) {
  operations {
    id
    title
    subtitle
    apiRequestsToday: apiRequestsCount(
      filters: $filtersApiRequests
      limit: $countLimit
    )
  }
}
    `;

/**
 * __useGetOperationsLogQuery__
 *
 * To run a query within a React component, call `useGetOperationsLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOperationsLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOperationsLogQuery({
 *   variables: {
 *      filtersApiRequests: // value for 'filtersApiRequests'
 *      countLimit: // value for 'countLimit'
 *   },
 * });
 */
export function useGetOperationsLogQuery(baseOptions?: Apollo.QueryHookOptions<GetOperationsLogQuery, GetOperationsLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOperationsLogQuery, GetOperationsLogQueryVariables>(GetOperationsLogDocument, options);
      }
export function useGetOperationsLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOperationsLogQuery, GetOperationsLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOperationsLogQuery, GetOperationsLogQueryVariables>(GetOperationsLogDocument, options);
        }
// @ts-ignore
export function useGetOperationsLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOperationsLogQuery, GetOperationsLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetOperationsLogQuery, GetOperationsLogQueryVariables>;
export function useGetOperationsLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOperationsLogQuery, GetOperationsLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetOperationsLogQuery | undefined, GetOperationsLogQueryVariables>;
export function useGetOperationsLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOperationsLogQuery, GetOperationsLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOperationsLogQuery, GetOperationsLogQueryVariables>(GetOperationsLogDocument, options);
        }
export type GetOperationsLogQueryHookResult = ReturnType<typeof useGetOperationsLogQuery>;
export type GetOperationsLogLazyQueryHookResult = ReturnType<typeof useGetOperationsLogLazyQuery>;
export type GetOperationsLogSuspenseQueryHookResult = ReturnType<typeof useGetOperationsLogSuspenseQuery>;
export type GetOperationsLogQueryResult = Apollo.QueryResult<GetOperationsLogQuery, GetOperationsLogQueryVariables>;
export const LpcoAvailableQuickFiltersDocument = gql`
    query LpcoAvailableQuickFilters($pathFilters: JSON) {
  lpcoAvailableQuickFilters(pathFilters: $pathFilters) {
    path
    label
    position
    values {
      value
      label
    }
  }
}
    `;

/**
 * __useLpcoAvailableQuickFiltersQuery__
 *
 * To run a query within a React component, call `useLpcoAvailableQuickFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLpcoAvailableQuickFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLpcoAvailableQuickFiltersQuery({
 *   variables: {
 *      pathFilters: // value for 'pathFilters'
 *   },
 * });
 */
export function useLpcoAvailableQuickFiltersQuery(baseOptions?: Apollo.QueryHookOptions<LpcoAvailableQuickFiltersQuery, LpcoAvailableQuickFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LpcoAvailableQuickFiltersQuery, LpcoAvailableQuickFiltersQueryVariables>(LpcoAvailableQuickFiltersDocument, options);
      }
export function useLpcoAvailableQuickFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LpcoAvailableQuickFiltersQuery, LpcoAvailableQuickFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LpcoAvailableQuickFiltersQuery, LpcoAvailableQuickFiltersQueryVariables>(LpcoAvailableQuickFiltersDocument, options);
        }
// @ts-ignore
export function useLpcoAvailableQuickFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LpcoAvailableQuickFiltersQuery, LpcoAvailableQuickFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<LpcoAvailableQuickFiltersQuery, LpcoAvailableQuickFiltersQueryVariables>;
export function useLpcoAvailableQuickFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LpcoAvailableQuickFiltersQuery, LpcoAvailableQuickFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<LpcoAvailableQuickFiltersQuery | undefined, LpcoAvailableQuickFiltersQueryVariables>;
export function useLpcoAvailableQuickFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LpcoAvailableQuickFiltersQuery, LpcoAvailableQuickFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LpcoAvailableQuickFiltersQuery, LpcoAvailableQuickFiltersQueryVariables>(LpcoAvailableQuickFiltersDocument, options);
        }
export type LpcoAvailableQuickFiltersQueryHookResult = ReturnType<typeof useLpcoAvailableQuickFiltersQuery>;
export type LpcoAvailableQuickFiltersLazyQueryHookResult = ReturnType<typeof useLpcoAvailableQuickFiltersLazyQuery>;
export type LpcoAvailableQuickFiltersSuspenseQueryHookResult = ReturnType<typeof useLpcoAvailableQuickFiltersSuspenseQuery>;
export type LpcoAvailableQuickFiltersQueryResult = Apollo.QueryResult<LpcoAvailableQuickFiltersQuery, LpcoAvailableQuickFiltersQueryVariables>;
export const LpcoTotalsDocument = gql`
    query LpcoTotals {
  lpcoTotals {
    registersCount
    modelsCount
    importersCount
    exportersCount
  }
}
    `;

/**
 * __useLpcoTotalsQuery__
 *
 * To run a query within a React component, call `useLpcoTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLpcoTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLpcoTotalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLpcoTotalsQuery(baseOptions?: Apollo.QueryHookOptions<LpcoTotalsQuery, LpcoTotalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LpcoTotalsQuery, LpcoTotalsQueryVariables>(LpcoTotalsDocument, options);
      }
export function useLpcoTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LpcoTotalsQuery, LpcoTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LpcoTotalsQuery, LpcoTotalsQueryVariables>(LpcoTotalsDocument, options);
        }
// @ts-ignore
export function useLpcoTotalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LpcoTotalsQuery, LpcoTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<LpcoTotalsQuery, LpcoTotalsQueryVariables>;
export function useLpcoTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LpcoTotalsQuery, LpcoTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<LpcoTotalsQuery | undefined, LpcoTotalsQueryVariables>;
export function useLpcoTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LpcoTotalsQuery, LpcoTotalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LpcoTotalsQuery, LpcoTotalsQueryVariables>(LpcoTotalsDocument, options);
        }
export type LpcoTotalsQueryHookResult = ReturnType<typeof useLpcoTotalsQuery>;
export type LpcoTotalsLazyQueryHookResult = ReturnType<typeof useLpcoTotalsLazyQuery>;
export type LpcoTotalsSuspenseQueryHookResult = ReturnType<typeof useLpcoTotalsSuspenseQuery>;
export type LpcoTotalsQueryResult = Apollo.QueryResult<LpcoTotalsQuery, LpcoTotalsQueryVariables>;
export const LpcosDocument = gql`
    query Lpcos($search: String, $pathFilters: JSON, $pagination: LpcoPaginationParams) {
  lpcos(search: $search, pathFilters: $pathFilters, pagination: $pagination) {
    id
    agency
    linkedDeclarations {
      documentNumber
    }
    insights {
      ...InsightBasicDataFragment
    }
    modelCode
    name
    number
    operationType
    registeredAt
    status
    statusUpdatedAt
    validityEnd
    validityStart
  }
}
    ${InsightBasicDataFragmentFragmentDoc}`;

/**
 * __useLpcosQuery__
 *
 * To run a query within a React component, call `useLpcosQuery` and pass it any options that fit your needs.
 * When your component renders, `useLpcosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLpcosQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pathFilters: // value for 'pathFilters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useLpcosQuery(baseOptions?: Apollo.QueryHookOptions<LpcosQuery, LpcosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LpcosQuery, LpcosQueryVariables>(LpcosDocument, options);
      }
export function useLpcosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LpcosQuery, LpcosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LpcosQuery, LpcosQueryVariables>(LpcosDocument, options);
        }
// @ts-ignore
export function useLpcosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LpcosQuery, LpcosQueryVariables>): Apollo.UseSuspenseQueryResult<LpcosQuery, LpcosQueryVariables>;
export function useLpcosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LpcosQuery, LpcosQueryVariables>): Apollo.UseSuspenseQueryResult<LpcosQuery | undefined, LpcosQueryVariables>;
export function useLpcosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LpcosQuery, LpcosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LpcosQuery, LpcosQueryVariables>(LpcosDocument, options);
        }
export type LpcosQueryHookResult = ReturnType<typeof useLpcosQuery>;
export type LpcosLazyQueryHookResult = ReturnType<typeof useLpcosLazyQuery>;
export type LpcosSuspenseQueryHookResult = ReturnType<typeof useLpcosSuspenseQuery>;
export type LpcosQueryResult = Apollo.QueryResult<LpcosQuery, LpcosQueryVariables>;
export const GetMercanteSchedulesDocument = gql`
    query GetMercanteSchedules($pagination: PaginationPortScheduleParams, $filters: FilterPortScheduleParams!, $search: String) {
  portSchedulesCount(filters: $filters)
  portSchedules(pagination: $pagination, filters: $filters, search: $search) {
    id
    etb
    etu
    atb
    atu
    carrierCode
    carrierName
    carrierVoyage
    scheduleNumber
    vesselResponsible
    shippingAgencyCnpj
    shippingAgencyName
    lastPorts {
      portUnlocode
      atu
    }
    nextPorts {
      portUnlocode
      etb
    }
    carrierCountry {
      code
    }
    vessel {
      id
      name
      imoNumber
      country {
        code
      }
    }
  }
}
    `;

/**
 * __useGetMercanteSchedulesQuery__
 *
 * To run a query within a React component, call `useGetMercanteSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMercanteSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMercanteSchedulesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetMercanteSchedulesQuery(baseOptions: Apollo.QueryHookOptions<GetMercanteSchedulesQuery, GetMercanteSchedulesQueryVariables> & ({ variables: GetMercanteSchedulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMercanteSchedulesQuery, GetMercanteSchedulesQueryVariables>(GetMercanteSchedulesDocument, options);
      }
export function useGetMercanteSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMercanteSchedulesQuery, GetMercanteSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMercanteSchedulesQuery, GetMercanteSchedulesQueryVariables>(GetMercanteSchedulesDocument, options);
        }
// @ts-ignore
export function useGetMercanteSchedulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMercanteSchedulesQuery, GetMercanteSchedulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMercanteSchedulesQuery, GetMercanteSchedulesQueryVariables>;
export function useGetMercanteSchedulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMercanteSchedulesQuery, GetMercanteSchedulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMercanteSchedulesQuery | undefined, GetMercanteSchedulesQueryVariables>;
export function useGetMercanteSchedulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMercanteSchedulesQuery, GetMercanteSchedulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMercanteSchedulesQuery, GetMercanteSchedulesQueryVariables>(GetMercanteSchedulesDocument, options);
        }
export type GetMercanteSchedulesQueryHookResult = ReturnType<typeof useGetMercanteSchedulesQuery>;
export type GetMercanteSchedulesLazyQueryHookResult = ReturnType<typeof useGetMercanteSchedulesLazyQuery>;
export type GetMercanteSchedulesSuspenseQueryHookResult = ReturnType<typeof useGetMercanteSchedulesSuspenseQuery>;
export type GetMercanteSchedulesQueryResult = Apollo.QueryResult<GetMercanteSchedulesQuery, GetMercanteSchedulesQueryVariables>;
export const ListMaritimePortsDocument = gql`
    query ListMaritimePorts($filters: FilterMaritimePortParams) {
  maritimePorts(
    filters: $filters
    pagination: {orderBy: [{field: NAME, order: ASC}]}
  ) {
    id
    name
    unlocode
  }
}
    `;

/**
 * __useListMaritimePortsQuery__
 *
 * To run a query within a React component, call `useListMaritimePortsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMaritimePortsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMaritimePortsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListMaritimePortsQuery(baseOptions?: Apollo.QueryHookOptions<ListMaritimePortsQuery, ListMaritimePortsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMaritimePortsQuery, ListMaritimePortsQueryVariables>(ListMaritimePortsDocument, options);
      }
export function useListMaritimePortsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMaritimePortsQuery, ListMaritimePortsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMaritimePortsQuery, ListMaritimePortsQueryVariables>(ListMaritimePortsDocument, options);
        }
// @ts-ignore
export function useListMaritimePortsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListMaritimePortsQuery, ListMaritimePortsQueryVariables>): Apollo.UseSuspenseQueryResult<ListMaritimePortsQuery, ListMaritimePortsQueryVariables>;
export function useListMaritimePortsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMaritimePortsQuery, ListMaritimePortsQueryVariables>): Apollo.UseSuspenseQueryResult<ListMaritimePortsQuery | undefined, ListMaritimePortsQueryVariables>;
export function useListMaritimePortsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMaritimePortsQuery, ListMaritimePortsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMaritimePortsQuery, ListMaritimePortsQueryVariables>(ListMaritimePortsDocument, options);
        }
export type ListMaritimePortsQueryHookResult = ReturnType<typeof useListMaritimePortsQuery>;
export type ListMaritimePortsLazyQueryHookResult = ReturnType<typeof useListMaritimePortsLazyQuery>;
export type ListMaritimePortsSuspenseQueryHookResult = ReturnType<typeof useListMaritimePortsSuspenseQuery>;
export type ListMaritimePortsQueryResult = Apollo.QueryResult<ListMaritimePortsQuery, ListMaritimePortsQueryVariables>;
export const GetAggregatedProcessCostsDocument = gql`
    query GetAggregatedProcessCosts($costModelId: Int!, $pathFilters: JSON) {
  aggregatedCosts(costModelId: $costModelId, pathFilters: $pathFilters) {
    processesCount
    costModel {
      id
      name
      hasPlannedCosts
      currency {
        code
        name
      }
    }
    rootModelExpenses {
      ...AggregatedCostChildrenModelExpenses
    }
    calculatedTotals {
      totalCosts
      plannedCosts
      deviation
    }
  }
}
    ${AggregatedCostChildrenModelExpensesFragmentDoc}`;

/**
 * __useGetAggregatedProcessCostsQuery__
 *
 * To run a query within a React component, call `useGetAggregatedProcessCostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregatedProcessCostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregatedProcessCostsQuery({
 *   variables: {
 *      costModelId: // value for 'costModelId'
 *      pathFilters: // value for 'pathFilters'
 *   },
 * });
 */
export function useGetAggregatedProcessCostsQuery(baseOptions: Apollo.QueryHookOptions<GetAggregatedProcessCostsQuery, GetAggregatedProcessCostsQueryVariables> & ({ variables: GetAggregatedProcessCostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAggregatedProcessCostsQuery, GetAggregatedProcessCostsQueryVariables>(GetAggregatedProcessCostsDocument, options);
      }
export function useGetAggregatedProcessCostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAggregatedProcessCostsQuery, GetAggregatedProcessCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAggregatedProcessCostsQuery, GetAggregatedProcessCostsQueryVariables>(GetAggregatedProcessCostsDocument, options);
        }
// @ts-ignore
export function useGetAggregatedProcessCostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAggregatedProcessCostsQuery, GetAggregatedProcessCostsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAggregatedProcessCostsQuery, GetAggregatedProcessCostsQueryVariables>;
export function useGetAggregatedProcessCostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAggregatedProcessCostsQuery, GetAggregatedProcessCostsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAggregatedProcessCostsQuery | undefined, GetAggregatedProcessCostsQueryVariables>;
export function useGetAggregatedProcessCostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAggregatedProcessCostsQuery, GetAggregatedProcessCostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAggregatedProcessCostsQuery, GetAggregatedProcessCostsQueryVariables>(GetAggregatedProcessCostsDocument, options);
        }
export type GetAggregatedProcessCostsQueryHookResult = ReturnType<typeof useGetAggregatedProcessCostsQuery>;
export type GetAggregatedProcessCostsLazyQueryHookResult = ReturnType<typeof useGetAggregatedProcessCostsLazyQuery>;
export type GetAggregatedProcessCostsSuspenseQueryHookResult = ReturnType<typeof useGetAggregatedProcessCostsSuspenseQuery>;
export type GetAggregatedProcessCostsQueryResult = Apollo.QueryResult<GetAggregatedProcessCostsQuery, GetAggregatedProcessCostsQueryVariables>;
export const GetCostModelsDocument = gql`
    query GetCostModels($filters: FilterCostModelParams) {
  costModels(filters: $filters) {
    id
    name
    hasPlannedCosts
    operations {
      id
    }
    versions {
      id
      version
    }
  }
}
    `;

/**
 * __useGetCostModelsQuery__
 *
 * To run a query within a React component, call `useGetCostModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCostModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCostModelsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCostModelsQuery(baseOptions?: Apollo.QueryHookOptions<GetCostModelsQuery, GetCostModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCostModelsQuery, GetCostModelsQueryVariables>(GetCostModelsDocument, options);
      }
export function useGetCostModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCostModelsQuery, GetCostModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCostModelsQuery, GetCostModelsQueryVariables>(GetCostModelsDocument, options);
        }
// @ts-ignore
export function useGetCostModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCostModelsQuery, GetCostModelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCostModelsQuery, GetCostModelsQueryVariables>;
export function useGetCostModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCostModelsQuery, GetCostModelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCostModelsQuery | undefined, GetCostModelsQueryVariables>;
export function useGetCostModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCostModelsQuery, GetCostModelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCostModelsQuery, GetCostModelsQueryVariables>(GetCostModelsDocument, options);
        }
export type GetCostModelsQueryHookResult = ReturnType<typeof useGetCostModelsQuery>;
export type GetCostModelsLazyQueryHookResult = ReturnType<typeof useGetCostModelsLazyQuery>;
export type GetCostModelsSuspenseQueryHookResult = ReturnType<typeof useGetCostModelsSuspenseQuery>;
export type GetCostModelsQueryResult = Apollo.QueryResult<GetCostModelsQuery, GetCostModelsQueryVariables>;
export const CreateLeadTimeModelDocument = gql`
    mutation CreateLeadTimeModel($params: CreateLeadTimeModelParams!) {
  createLeadTimeModel(params: $params) {
    id
    name
  }
}
    `;
export type CreateLeadTimeModelMutationFn = Apollo.MutationFunction<CreateLeadTimeModelMutation, CreateLeadTimeModelMutationVariables>;

/**
 * __useCreateLeadTimeModelMutation__
 *
 * To run a mutation, you first call `useCreateLeadTimeModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeadTimeModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeadTimeModelMutation, { data, loading, error }] = useCreateLeadTimeModelMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateLeadTimeModelMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeadTimeModelMutation, CreateLeadTimeModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeadTimeModelMutation, CreateLeadTimeModelMutationVariables>(CreateLeadTimeModelDocument, options);
      }
export type CreateLeadTimeModelMutationHookResult = ReturnType<typeof useCreateLeadTimeModelMutation>;
export type CreateLeadTimeModelMutationResult = Apollo.MutationResult<CreateLeadTimeModelMutation>;
export type CreateLeadTimeModelMutationOptions = Apollo.BaseMutationOptions<CreateLeadTimeModelMutation, CreateLeadTimeModelMutationVariables>;
export const CreatePlannedLeadTimeDocument = gql`
    mutation CreatePlannedLeadTime($params: CreatePlannedLeadTimeParams!) {
  createPlannedLeadTime(params: $params) {
    id
    name
    stages {
      id
      quantityHours
    }
  }
}
    `;
export type CreatePlannedLeadTimeMutationFn = Apollo.MutationFunction<CreatePlannedLeadTimeMutation, CreatePlannedLeadTimeMutationVariables>;

/**
 * __useCreatePlannedLeadTimeMutation__
 *
 * To run a mutation, you first call `useCreatePlannedLeadTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlannedLeadTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlannedLeadTimeMutation, { data, loading, error }] = useCreatePlannedLeadTimeMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreatePlannedLeadTimeMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlannedLeadTimeMutation, CreatePlannedLeadTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlannedLeadTimeMutation, CreatePlannedLeadTimeMutationVariables>(CreatePlannedLeadTimeDocument, options);
      }
export type CreatePlannedLeadTimeMutationHookResult = ReturnType<typeof useCreatePlannedLeadTimeMutation>;
export type CreatePlannedLeadTimeMutationResult = Apollo.MutationResult<CreatePlannedLeadTimeMutation>;
export type CreatePlannedLeadTimeMutationOptions = Apollo.BaseMutationOptions<CreatePlannedLeadTimeMutation, CreatePlannedLeadTimeMutationVariables>;
export const DeleteLeadTimeModelDocument = gql`
    mutation DeleteLeadTimeModel($id: Int!) {
  deleteLeadTimeModel(id: $id) {
    id
  }
}
    `;
export type DeleteLeadTimeModelMutationFn = Apollo.MutationFunction<DeleteLeadTimeModelMutation, DeleteLeadTimeModelMutationVariables>;

/**
 * __useDeleteLeadTimeModelMutation__
 *
 * To run a mutation, you first call `useDeleteLeadTimeModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLeadTimeModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLeadTimeModelMutation, { data, loading, error }] = useDeleteLeadTimeModelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLeadTimeModelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLeadTimeModelMutation, DeleteLeadTimeModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLeadTimeModelMutation, DeleteLeadTimeModelMutationVariables>(DeleteLeadTimeModelDocument, options);
      }
export type DeleteLeadTimeModelMutationHookResult = ReturnType<typeof useDeleteLeadTimeModelMutation>;
export type DeleteLeadTimeModelMutationResult = Apollo.MutationResult<DeleteLeadTimeModelMutation>;
export type DeleteLeadTimeModelMutationOptions = Apollo.BaseMutationOptions<DeleteLeadTimeModelMutation, DeleteLeadTimeModelMutationVariables>;
export const DeletePlannedLeadTimeDocument = gql`
    mutation DeletePlannedLeadTime($id: Int!) {
  deletePlannedLeadTime(id: $id) {
    id
  }
}
    `;
export type DeletePlannedLeadTimeMutationFn = Apollo.MutationFunction<DeletePlannedLeadTimeMutation, DeletePlannedLeadTimeMutationVariables>;

/**
 * __useDeletePlannedLeadTimeMutation__
 *
 * To run a mutation, you first call `useDeletePlannedLeadTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlannedLeadTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlannedLeadTimeMutation, { data, loading, error }] = useDeletePlannedLeadTimeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePlannedLeadTimeMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlannedLeadTimeMutation, DeletePlannedLeadTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlannedLeadTimeMutation, DeletePlannedLeadTimeMutationVariables>(DeletePlannedLeadTimeDocument, options);
      }
export type DeletePlannedLeadTimeMutationHookResult = ReturnType<typeof useDeletePlannedLeadTimeMutation>;
export type DeletePlannedLeadTimeMutationResult = Apollo.MutationResult<DeletePlannedLeadTimeMutation>;
export type DeletePlannedLeadTimeMutationOptions = Apollo.BaseMutationOptions<DeletePlannedLeadTimeMutation, DeletePlannedLeadTimeMutationVariables>;
export const GetLeadTimeModelDocument = gql`
    query GetLeadTimeModel($id: Int!) {
  leadTimeModel(id: $id) {
    id
    name
    ignoreTime
    markerPaths
    markerPathsLabels
    stages {
      id
      name
      color
      startEvent
      startEventLabel
      endEvent
      endEventLabel
    }
    operations {
      id
      title
    }
    referenceEvent
    referenceEventLabel
    plannedLeadTimes {
      id
      name
      stages {
        id
        days
        hours
        quantityHours
        leadTimeStageModel {
          id
          name
          color
        }
      }
    }
  }
}
    `;

/**
 * __useGetLeadTimeModelQuery__
 *
 * To run a query within a React component, call `useGetLeadTimeModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadTimeModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadTimeModelQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLeadTimeModelQuery(baseOptions: Apollo.QueryHookOptions<GetLeadTimeModelQuery, GetLeadTimeModelQueryVariables> & ({ variables: GetLeadTimeModelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadTimeModelQuery, GetLeadTimeModelQueryVariables>(GetLeadTimeModelDocument, options);
      }
export function useGetLeadTimeModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadTimeModelQuery, GetLeadTimeModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadTimeModelQuery, GetLeadTimeModelQueryVariables>(GetLeadTimeModelDocument, options);
        }
// @ts-ignore
export function useGetLeadTimeModelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLeadTimeModelQuery, GetLeadTimeModelQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadTimeModelQuery, GetLeadTimeModelQueryVariables>;
export function useGetLeadTimeModelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadTimeModelQuery, GetLeadTimeModelQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadTimeModelQuery | undefined, GetLeadTimeModelQueryVariables>;
export function useGetLeadTimeModelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadTimeModelQuery, GetLeadTimeModelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeadTimeModelQuery, GetLeadTimeModelQueryVariables>(GetLeadTimeModelDocument, options);
        }
export type GetLeadTimeModelQueryHookResult = ReturnType<typeof useGetLeadTimeModelQuery>;
export type GetLeadTimeModelLazyQueryHookResult = ReturnType<typeof useGetLeadTimeModelLazyQuery>;
export type GetLeadTimeModelSuspenseQueryHookResult = ReturnType<typeof useGetLeadTimeModelSuspenseQuery>;
export type GetLeadTimeModelQueryResult = Apollo.QueryResult<GetLeadTimeModelQuery, GetLeadTimeModelQueryVariables>;
export const GetLeadTimeModelsDocument = gql`
    query GetLeadTimeModels($pagination: LeadTimeModelPaginationParams) {
  leadTimeModels(pagination: $pagination) {
    id
    name
    ignoreTime
    markerPaths
  }
}
    `;

/**
 * __useGetLeadTimeModelsQuery__
 *
 * To run a query within a React component, call `useGetLeadTimeModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadTimeModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadTimeModelsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetLeadTimeModelsQuery(baseOptions?: Apollo.QueryHookOptions<GetLeadTimeModelsQuery, GetLeadTimeModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadTimeModelsQuery, GetLeadTimeModelsQueryVariables>(GetLeadTimeModelsDocument, options);
      }
export function useGetLeadTimeModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadTimeModelsQuery, GetLeadTimeModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadTimeModelsQuery, GetLeadTimeModelsQueryVariables>(GetLeadTimeModelsDocument, options);
        }
// @ts-ignore
export function useGetLeadTimeModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLeadTimeModelsQuery, GetLeadTimeModelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadTimeModelsQuery, GetLeadTimeModelsQueryVariables>;
export function useGetLeadTimeModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadTimeModelsQuery, GetLeadTimeModelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadTimeModelsQuery | undefined, GetLeadTimeModelsQueryVariables>;
export function useGetLeadTimeModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadTimeModelsQuery, GetLeadTimeModelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeadTimeModelsQuery, GetLeadTimeModelsQueryVariables>(GetLeadTimeModelsDocument, options);
        }
export type GetLeadTimeModelsQueryHookResult = ReturnType<typeof useGetLeadTimeModelsQuery>;
export type GetLeadTimeModelsLazyQueryHookResult = ReturnType<typeof useGetLeadTimeModelsLazyQuery>;
export type GetLeadTimeModelsSuspenseQueryHookResult = ReturnType<typeof useGetLeadTimeModelsSuspenseQuery>;
export type GetLeadTimeModelsQueryResult = Apollo.QueryResult<GetLeadTimeModelsQuery, GetLeadTimeModelsQueryVariables>;
export const GetLeadTimeModelsOptionsDocument = gql`
    query GetLeadTimeModelsOptions {
  leadTimeModels {
    id
    name
    ignoreTime
    operations {
      id
    }
  }
}
    `;

/**
 * __useGetLeadTimeModelsOptionsQuery__
 *
 * To run a query within a React component, call `useGetLeadTimeModelsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadTimeModelsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadTimeModelsOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLeadTimeModelsOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetLeadTimeModelsOptionsQuery, GetLeadTimeModelsOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadTimeModelsOptionsQuery, GetLeadTimeModelsOptionsQueryVariables>(GetLeadTimeModelsOptionsDocument, options);
      }
export function useGetLeadTimeModelsOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadTimeModelsOptionsQuery, GetLeadTimeModelsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadTimeModelsOptionsQuery, GetLeadTimeModelsOptionsQueryVariables>(GetLeadTimeModelsOptionsDocument, options);
        }
// @ts-ignore
export function useGetLeadTimeModelsOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLeadTimeModelsOptionsQuery, GetLeadTimeModelsOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadTimeModelsOptionsQuery, GetLeadTimeModelsOptionsQueryVariables>;
export function useGetLeadTimeModelsOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadTimeModelsOptionsQuery, GetLeadTimeModelsOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadTimeModelsOptionsQuery | undefined, GetLeadTimeModelsOptionsQueryVariables>;
export function useGetLeadTimeModelsOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadTimeModelsOptionsQuery, GetLeadTimeModelsOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeadTimeModelsOptionsQuery, GetLeadTimeModelsOptionsQueryVariables>(GetLeadTimeModelsOptionsDocument, options);
        }
export type GetLeadTimeModelsOptionsQueryHookResult = ReturnType<typeof useGetLeadTimeModelsOptionsQuery>;
export type GetLeadTimeModelsOptionsLazyQueryHookResult = ReturnType<typeof useGetLeadTimeModelsOptionsLazyQuery>;
export type GetLeadTimeModelsOptionsSuspenseQueryHookResult = ReturnType<typeof useGetLeadTimeModelsOptionsSuspenseQuery>;
export type GetLeadTimeModelsOptionsQueryResult = Apollo.QueryResult<GetLeadTimeModelsOptionsQuery, GetLeadTimeModelsOptionsQueryVariables>;
export const UpdateLeadTimeModelDocument = gql`
    mutation UpdateLeadTimeModel($id: Int!, $params: UpdateLeadTimeModelParams!) {
  updateLeadTimeModel(id: $id, params: $params) {
    id
  }
}
    `;
export type UpdateLeadTimeModelMutationFn = Apollo.MutationFunction<UpdateLeadTimeModelMutation, UpdateLeadTimeModelMutationVariables>;

/**
 * __useUpdateLeadTimeModelMutation__
 *
 * To run a mutation, you first call `useUpdateLeadTimeModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeadTimeModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeadTimeModelMutation, { data, loading, error }] = useUpdateLeadTimeModelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateLeadTimeModelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeadTimeModelMutation, UpdateLeadTimeModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeadTimeModelMutation, UpdateLeadTimeModelMutationVariables>(UpdateLeadTimeModelDocument, options);
      }
export type UpdateLeadTimeModelMutationHookResult = ReturnType<typeof useUpdateLeadTimeModelMutation>;
export type UpdateLeadTimeModelMutationResult = Apollo.MutationResult<UpdateLeadTimeModelMutation>;
export type UpdateLeadTimeModelMutationOptions = Apollo.BaseMutationOptions<UpdateLeadTimeModelMutation, UpdateLeadTimeModelMutationVariables>;
export const UpdatePlannedLeadTimeDocument = gql`
    mutation UpdatePlannedLeadTime($id: Int!, $params: UpdatePlannedLeadTimeParams!) {
  updatePlannedLeadTime(id: $id, params: $params) {
    id
  }
}
    `;
export type UpdatePlannedLeadTimeMutationFn = Apollo.MutationFunction<UpdatePlannedLeadTimeMutation, UpdatePlannedLeadTimeMutationVariables>;

/**
 * __useUpdatePlannedLeadTimeMutation__
 *
 * To run a mutation, you first call `useUpdatePlannedLeadTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlannedLeadTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlannedLeadTimeMutation, { data, loading, error }] = useUpdatePlannedLeadTimeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdatePlannedLeadTimeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlannedLeadTimeMutation, UpdatePlannedLeadTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlannedLeadTimeMutation, UpdatePlannedLeadTimeMutationVariables>(UpdatePlannedLeadTimeDocument, options);
      }
export type UpdatePlannedLeadTimeMutationHookResult = ReturnType<typeof useUpdatePlannedLeadTimeMutation>;
export type UpdatePlannedLeadTimeMutationResult = Apollo.MutationResult<UpdatePlannedLeadTimeMutation>;
export type UpdatePlannedLeadTimeMutationOptions = Apollo.BaseMutationOptions<UpdatePlannedLeadTimeMutation, UpdatePlannedLeadTimeMutationVariables>;
export const GetLeadTimeAggregatedAvailableQuickFiltersDocument = gql`
    query GetLeadTimeAggregatedAvailableQuickFilters($leadTimeModelId: Int!, $currentFilters: JSON, $search: String) {
  leadTimeAggregatedAvailableQuickFilters(
    leadTimeModelId: $leadTimeModelId
    currentFilters: $currentFilters
    search: $search
  ) {
    label
    path
    values {
      label
      value
    }
  }
}
    `;

/**
 * __useGetLeadTimeAggregatedAvailableQuickFiltersQuery__
 *
 * To run a query within a React component, call `useGetLeadTimeAggregatedAvailableQuickFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadTimeAggregatedAvailableQuickFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadTimeAggregatedAvailableQuickFiltersQuery({
 *   variables: {
 *      leadTimeModelId: // value for 'leadTimeModelId'
 *      currentFilters: // value for 'currentFilters'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetLeadTimeAggregatedAvailableQuickFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetLeadTimeAggregatedAvailableQuickFiltersQuery, GetLeadTimeAggregatedAvailableQuickFiltersQueryVariables> & ({ variables: GetLeadTimeAggregatedAvailableQuickFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadTimeAggregatedAvailableQuickFiltersQuery, GetLeadTimeAggregatedAvailableQuickFiltersQueryVariables>(GetLeadTimeAggregatedAvailableQuickFiltersDocument, options);
      }
export function useGetLeadTimeAggregatedAvailableQuickFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadTimeAggregatedAvailableQuickFiltersQuery, GetLeadTimeAggregatedAvailableQuickFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadTimeAggregatedAvailableQuickFiltersQuery, GetLeadTimeAggregatedAvailableQuickFiltersQueryVariables>(GetLeadTimeAggregatedAvailableQuickFiltersDocument, options);
        }
// @ts-ignore
export function useGetLeadTimeAggregatedAvailableQuickFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLeadTimeAggregatedAvailableQuickFiltersQuery, GetLeadTimeAggregatedAvailableQuickFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadTimeAggregatedAvailableQuickFiltersQuery, GetLeadTimeAggregatedAvailableQuickFiltersQueryVariables>;
export function useGetLeadTimeAggregatedAvailableQuickFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadTimeAggregatedAvailableQuickFiltersQuery, GetLeadTimeAggregatedAvailableQuickFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadTimeAggregatedAvailableQuickFiltersQuery | undefined, GetLeadTimeAggregatedAvailableQuickFiltersQueryVariables>;
export function useGetLeadTimeAggregatedAvailableQuickFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadTimeAggregatedAvailableQuickFiltersQuery, GetLeadTimeAggregatedAvailableQuickFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeadTimeAggregatedAvailableQuickFiltersQuery, GetLeadTimeAggregatedAvailableQuickFiltersQueryVariables>(GetLeadTimeAggregatedAvailableQuickFiltersDocument, options);
        }
export type GetLeadTimeAggregatedAvailableQuickFiltersQueryHookResult = ReturnType<typeof useGetLeadTimeAggregatedAvailableQuickFiltersQuery>;
export type GetLeadTimeAggregatedAvailableQuickFiltersLazyQueryHookResult = ReturnType<typeof useGetLeadTimeAggregatedAvailableQuickFiltersLazyQuery>;
export type GetLeadTimeAggregatedAvailableQuickFiltersSuspenseQueryHookResult = ReturnType<typeof useGetLeadTimeAggregatedAvailableQuickFiltersSuspenseQuery>;
export type GetLeadTimeAggregatedAvailableQuickFiltersQueryResult = Apollo.QueryResult<GetLeadTimeAggregatedAvailableQuickFiltersQuery, GetLeadTimeAggregatedAvailableQuickFiltersQueryVariables>;
export const GetLeadTimesAggregatedByPlannedDocument = gql`
    query GetLeadTimesAggregatedByPlanned($leadTimeModelId: Int!, $filters: FilterAggregatedLeadTimeParams, $pathFilters: JSON) {
  leadTimesAggregatedByPlanned(
    leadTimeModelId: $leadTimeModelId
    filters: $filters
    pathFilters: $pathFilters
  ) {
    countShipments
    plannedLeadTime {
      id
      name
      leadTimeModel {
        id
        ignoreTime
      }
    }
    leadTime {
      ...LeadTimesAggregatedData
    }
  }
}
    ${LeadTimesAggregatedDataFragmentDoc}`;

/**
 * __useGetLeadTimesAggregatedByPlannedQuery__
 *
 * To run a query within a React component, call `useGetLeadTimesAggregatedByPlannedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadTimesAggregatedByPlannedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadTimesAggregatedByPlannedQuery({
 *   variables: {
 *      leadTimeModelId: // value for 'leadTimeModelId'
 *      filters: // value for 'filters'
 *      pathFilters: // value for 'pathFilters'
 *   },
 * });
 */
export function useGetLeadTimesAggregatedByPlannedQuery(baseOptions: Apollo.QueryHookOptions<GetLeadTimesAggregatedByPlannedQuery, GetLeadTimesAggregatedByPlannedQueryVariables> & ({ variables: GetLeadTimesAggregatedByPlannedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadTimesAggregatedByPlannedQuery, GetLeadTimesAggregatedByPlannedQueryVariables>(GetLeadTimesAggregatedByPlannedDocument, options);
      }
export function useGetLeadTimesAggregatedByPlannedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadTimesAggregatedByPlannedQuery, GetLeadTimesAggregatedByPlannedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadTimesAggregatedByPlannedQuery, GetLeadTimesAggregatedByPlannedQueryVariables>(GetLeadTimesAggregatedByPlannedDocument, options);
        }
// @ts-ignore
export function useGetLeadTimesAggregatedByPlannedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLeadTimesAggregatedByPlannedQuery, GetLeadTimesAggregatedByPlannedQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadTimesAggregatedByPlannedQuery, GetLeadTimesAggregatedByPlannedQueryVariables>;
export function useGetLeadTimesAggregatedByPlannedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadTimesAggregatedByPlannedQuery, GetLeadTimesAggregatedByPlannedQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadTimesAggregatedByPlannedQuery | undefined, GetLeadTimesAggregatedByPlannedQueryVariables>;
export function useGetLeadTimesAggregatedByPlannedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadTimesAggregatedByPlannedQuery, GetLeadTimesAggregatedByPlannedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeadTimesAggregatedByPlannedQuery, GetLeadTimesAggregatedByPlannedQueryVariables>(GetLeadTimesAggregatedByPlannedDocument, options);
        }
export type GetLeadTimesAggregatedByPlannedQueryHookResult = ReturnType<typeof useGetLeadTimesAggregatedByPlannedQuery>;
export type GetLeadTimesAggregatedByPlannedLazyQueryHookResult = ReturnType<typeof useGetLeadTimesAggregatedByPlannedLazyQuery>;
export type GetLeadTimesAggregatedByPlannedSuspenseQueryHookResult = ReturnType<typeof useGetLeadTimesAggregatedByPlannedSuspenseQuery>;
export type GetLeadTimesAggregatedByPlannedQueryResult = Apollo.QueryResult<GetLeadTimesAggregatedByPlannedQuery, GetLeadTimesAggregatedByPlannedQueryVariables>;
export const GetLeadTimesAggregatedByProductDocument = gql`
    query GetLeadTimesAggregatedByProduct($leadTimeModelId: Int!, $filters: FilterAggregatedLeadTimeParams, $pathFilters: JSON) {
  leadTimesAggregatedByProduct(
    leadTimeModelId: $leadTimeModelId
    filters: $filters
    pathFilters: $pathFilters
  ) {
    countShipments
    product {
      id
      translatedDescription
      code
      internalCodes {
        id
        code
      }
    }
    leadTime {
      ...LeadTimesAggregatedData
    }
  }
}
    ${LeadTimesAggregatedDataFragmentDoc}`;

/**
 * __useGetLeadTimesAggregatedByProductQuery__
 *
 * To run a query within a React component, call `useGetLeadTimesAggregatedByProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadTimesAggregatedByProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadTimesAggregatedByProductQuery({
 *   variables: {
 *      leadTimeModelId: // value for 'leadTimeModelId'
 *      filters: // value for 'filters'
 *      pathFilters: // value for 'pathFilters'
 *   },
 * });
 */
export function useGetLeadTimesAggregatedByProductQuery(baseOptions: Apollo.QueryHookOptions<GetLeadTimesAggregatedByProductQuery, GetLeadTimesAggregatedByProductQueryVariables> & ({ variables: GetLeadTimesAggregatedByProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadTimesAggregatedByProductQuery, GetLeadTimesAggregatedByProductQueryVariables>(GetLeadTimesAggregatedByProductDocument, options);
      }
export function useGetLeadTimesAggregatedByProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadTimesAggregatedByProductQuery, GetLeadTimesAggregatedByProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadTimesAggregatedByProductQuery, GetLeadTimesAggregatedByProductQueryVariables>(GetLeadTimesAggregatedByProductDocument, options);
        }
// @ts-ignore
export function useGetLeadTimesAggregatedByProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLeadTimesAggregatedByProductQuery, GetLeadTimesAggregatedByProductQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadTimesAggregatedByProductQuery, GetLeadTimesAggregatedByProductQueryVariables>;
export function useGetLeadTimesAggregatedByProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadTimesAggregatedByProductQuery, GetLeadTimesAggregatedByProductQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadTimesAggregatedByProductQuery | undefined, GetLeadTimesAggregatedByProductQueryVariables>;
export function useGetLeadTimesAggregatedByProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadTimesAggregatedByProductQuery, GetLeadTimesAggregatedByProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeadTimesAggregatedByProductQuery, GetLeadTimesAggregatedByProductQueryVariables>(GetLeadTimesAggregatedByProductDocument, options);
        }
export type GetLeadTimesAggregatedByProductQueryHookResult = ReturnType<typeof useGetLeadTimesAggregatedByProductQuery>;
export type GetLeadTimesAggregatedByProductLazyQueryHookResult = ReturnType<typeof useGetLeadTimesAggregatedByProductLazyQuery>;
export type GetLeadTimesAggregatedByProductSuspenseQueryHookResult = ReturnType<typeof useGetLeadTimesAggregatedByProductSuspenseQuery>;
export type GetLeadTimesAggregatedByProductQueryResult = Apollo.QueryResult<GetLeadTimesAggregatedByProductQuery, GetLeadTimesAggregatedByProductQueryVariables>;
export const GetOperationTrashItemsDocument = gql`
    query GetOperationTrashItems($id: Int!) {
  operation(id: $id) {
    id
    title
    subtitle
    processes(
      filters: {status: [CANCELED, DELETED]}
      pagination: {orderBy: [{field: ID, order: DESC}]}
    ) {
      id
      referenceCode
      insertedAt
      canceledAt
      deletedAt
    }
    orders(
      filters: {status: [CANCELED, DELETED]}
      pagination: {orderBy: [{field: ID, order: DESC}]}
    ) {
      id
      referenceCode
      insertedAt
      canceledAt
      deletedAt
    }
  }
}
    `;

/**
 * __useGetOperationTrashItemsQuery__
 *
 * To run a query within a React component, call `useGetOperationTrashItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOperationTrashItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOperationTrashItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOperationTrashItemsQuery(baseOptions: Apollo.QueryHookOptions<GetOperationTrashItemsQuery, GetOperationTrashItemsQueryVariables> & ({ variables: GetOperationTrashItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOperationTrashItemsQuery, GetOperationTrashItemsQueryVariables>(GetOperationTrashItemsDocument, options);
      }
export function useGetOperationTrashItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOperationTrashItemsQuery, GetOperationTrashItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOperationTrashItemsQuery, GetOperationTrashItemsQueryVariables>(GetOperationTrashItemsDocument, options);
        }
// @ts-ignore
export function useGetOperationTrashItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOperationTrashItemsQuery, GetOperationTrashItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOperationTrashItemsQuery, GetOperationTrashItemsQueryVariables>;
export function useGetOperationTrashItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOperationTrashItemsQuery, GetOperationTrashItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOperationTrashItemsQuery | undefined, GetOperationTrashItemsQueryVariables>;
export function useGetOperationTrashItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOperationTrashItemsQuery, GetOperationTrashItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOperationTrashItemsQuery, GetOperationTrashItemsQueryVariables>(GetOperationTrashItemsDocument, options);
        }
export type GetOperationTrashItemsQueryHookResult = ReturnType<typeof useGetOperationTrashItemsQuery>;
export type GetOperationTrashItemsLazyQueryHookResult = ReturnType<typeof useGetOperationTrashItemsLazyQuery>;
export type GetOperationTrashItemsSuspenseQueryHookResult = ReturnType<typeof useGetOperationTrashItemsSuspenseQuery>;
export type GetOperationTrashItemsQueryResult = Apollo.QueryResult<GetOperationTrashItemsQuery, GetOperationTrashItemsQueryVariables>;
export const RestoreOrderDocument = gql`
    mutation RestoreOrder($id: Int!) {
  restoreOrder(id: $id) {
    id
  }
}
    `;
export type RestoreOrderMutationFn = Apollo.MutationFunction<RestoreOrderMutation, RestoreOrderMutationVariables>;

/**
 * __useRestoreOrderMutation__
 *
 * To run a mutation, you first call `useRestoreOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreOrderMutation, { data, loading, error }] = useRestoreOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreOrderMutation(baseOptions?: Apollo.MutationHookOptions<RestoreOrderMutation, RestoreOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreOrderMutation, RestoreOrderMutationVariables>(RestoreOrderDocument, options);
      }
export type RestoreOrderMutationHookResult = ReturnType<typeof useRestoreOrderMutation>;
export type RestoreOrderMutationResult = Apollo.MutationResult<RestoreOrderMutation>;
export type RestoreOrderMutationOptions = Apollo.BaseMutationOptions<RestoreOrderMutation, RestoreOrderMutationVariables>;
export const RestoreProcessDocument = gql`
    mutation RestoreProcess($id: Int!) {
  restoreProcess(id: $id) {
    id
  }
}
    `;
export type RestoreProcessMutationFn = Apollo.MutationFunction<RestoreProcessMutation, RestoreProcessMutationVariables>;

/**
 * __useRestoreProcessMutation__
 *
 * To run a mutation, you first call `useRestoreProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreProcessMutation, { data, loading, error }] = useRestoreProcessMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreProcessMutation(baseOptions?: Apollo.MutationHookOptions<RestoreProcessMutation, RestoreProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreProcessMutation, RestoreProcessMutationVariables>(RestoreProcessDocument, options);
      }
export type RestoreProcessMutationHookResult = ReturnType<typeof useRestoreProcessMutation>;
export type RestoreProcessMutationResult = Apollo.MutationResult<RestoreProcessMutation>;
export type RestoreProcessMutationOptions = Apollo.BaseMutationOptions<RestoreProcessMutation, RestoreProcessMutationVariables>;
export const GetOperationsDocument = gql`
    query GetOperations {
  operations {
    id
    type
    subType
    title
    subtitle
    ordersCountOverview {
      ...AlertLevelCountFragment
    }
    processesCountOverview {
      ...AlertLevelCountFragment
    }
    operationPhases {
      id
      position
      phase {
        id
        phase
      }
      processesCountOverview {
        ...AlertLevelCountFragment
      }
    }
    operationAccess {
      id
      canSeeOrders
    }
  }
}
    ${AlertLevelCountFragmentFragmentDoc}`;

/**
 * __useGetOperationsQuery__
 *
 * To run a query within a React component, call `useGetOperationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOperationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOperationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOperationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOperationsQuery, GetOperationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOperationsQuery, GetOperationsQueryVariables>(GetOperationsDocument, options);
      }
export function useGetOperationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOperationsQuery, GetOperationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOperationsQuery, GetOperationsQueryVariables>(GetOperationsDocument, options);
        }
// @ts-ignore
export function useGetOperationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOperationsQuery, GetOperationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOperationsQuery, GetOperationsQueryVariables>;
export function useGetOperationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOperationsQuery, GetOperationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOperationsQuery | undefined, GetOperationsQueryVariables>;
export function useGetOperationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOperationsQuery, GetOperationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOperationsQuery, GetOperationsQueryVariables>(GetOperationsDocument, options);
        }
export type GetOperationsQueryHookResult = ReturnType<typeof useGetOperationsQuery>;
export type GetOperationsLazyQueryHookResult = ReturnType<typeof useGetOperationsLazyQuery>;
export type GetOperationsSuspenseQueryHookResult = ReturnType<typeof useGetOperationsSuspenseQuery>;
export type GetOperationsQueryResult = Apollo.QueryResult<GetOperationsQuery, GetOperationsQueryVariables>;
export const CreateReportDocument = gql`
    mutation CreateReport($params: CreateReportParams!) {
  createReport(params: $params) {
    id
  }
}
    `;
export type CreateReportMutationFn = Apollo.MutationFunction<CreateReportMutation, CreateReportMutationVariables>;

/**
 * __useCreateReportMutation__
 *
 * To run a mutation, you first call `useCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMutation, { data, loading, error }] = useCreateReportMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportMutation, CreateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportMutation, CreateReportMutationVariables>(CreateReportDocument, options);
      }
export type CreateReportMutationHookResult = ReturnType<typeof useCreateReportMutation>;
export type CreateReportMutationResult = Apollo.MutationResult<CreateReportMutation>;
export type CreateReportMutationOptions = Apollo.BaseMutationOptions<CreateReportMutation, CreateReportMutationVariables>;
export const CreateReportRequestDocument = gql`
    mutation CreateReportRequest($params: CreateReportRequestParams!) {
  createReportRequest(params: $params) {
    id
  }
}
    `;
export type CreateReportRequestMutationFn = Apollo.MutationFunction<CreateReportRequestMutation, CreateReportRequestMutationVariables>;

/**
 * __useCreateReportRequestMutation__
 *
 * To run a mutation, you first call `useCreateReportRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportRequestMutation, { data, loading, error }] = useCreateReportRequestMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateReportRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportRequestMutation, CreateReportRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportRequestMutation, CreateReportRequestMutationVariables>(CreateReportRequestDocument, options);
      }
export type CreateReportRequestMutationHookResult = ReturnType<typeof useCreateReportRequestMutation>;
export type CreateReportRequestMutationResult = Apollo.MutationResult<CreateReportRequestMutation>;
export type CreateReportRequestMutationOptions = Apollo.BaseMutationOptions<CreateReportRequestMutation, CreateReportRequestMutationVariables>;
export const DeleteReportDocument = gql`
    mutation DeleteReport($reportId: Int!) {
  deleteReport(id: $reportId) {
    id
  }
}
    `;
export type DeleteReportMutationFn = Apollo.MutationFunction<DeleteReportMutation, DeleteReportMutationVariables>;

/**
 * __useDeleteReportMutation__
 *
 * To run a mutation, you first call `useDeleteReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportMutation, { data, loading, error }] = useDeleteReportMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useDeleteReportMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportMutation, DeleteReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportMutation, DeleteReportMutationVariables>(DeleteReportDocument, options);
      }
export type DeleteReportMutationHookResult = ReturnType<typeof useDeleteReportMutation>;
export type DeleteReportMutationResult = Apollo.MutationResult<DeleteReportMutation>;
export type DeleteReportMutationOptions = Apollo.BaseMutationOptions<DeleteReportMutation, DeleteReportMutationVariables>;
export const GetContainersTableRowsDocument = gql`
    query GetContainersTableRows($search: String, $filters: FilterContainerParams, $pagination: ContainerPaginationParams, $pathFilters: JSON, $processFilters: FilterProcessParams, $includeDocuments: Boolean!, $includeProcessLeadTime: Boolean!, $includeProcessBrazilianInvoiceInfo: Boolean!, $includeVesselScheduleCalculatedDates: Boolean!, $includeShipmentDuimps: Boolean!, $includeShipmentExportDeclarations: Boolean!, $includeShipmentImportDeclarations: Boolean!, $includeShipmentImportLicenses: Boolean!, $includeDemurrageAny: Boolean!, $includeDemurrage: Boolean!, $includeDemurrageCalculations: Boolean!) {
  containersPerProcessesCount(
    search: $search
    filters: $filters
    pathFilters: $pathFilters
    processFilters: $processFilters
  )
  containersPerProcesses(
    search: $search
    filters: $filters
    pagination: $pagination
    pathFilters: $pathFilters
    processFilters: $processFilters
  ) {
    container {
      ...ContainerFieldsFragment
      trackingApi
      trackingManual
      demurrageCalculations {
        costPerDayBrl
        costPerDayUsd
        daysPaid
        daysToPay
        emptyReturnDeadline
        estimatedCosts
        exceedingDays
        totalOwedBrl
        totalOwedUsd
        totalPaidBrl
        totalPaidUsd
        totalToPayBrl
        totalToPayUsd
      }
      transportable {
        id
        itemShipments {
          id
          purchaseOrderItem {
            id
            productTranslatedDescription
            product {
              id
              code
            }
          }
          salesOrderItem {
            id
            productTranslatedDescription
            product {
              id
              code
            }
          }
        }
        trips {
          id
          phases {
            id
            routePoint {
              id
              routeType
            }
            realizedAt
            estimatedRealizedAt
          }
        }
      }
    }
    process {
      ...ProcessesData
      foreignTradeShipment {
        ...DefaultForeignTradeShipmentData
        ...NationalRoadTranportsData
      }
    }
  }
}
    ${ContainerFieldsFragmentFragmentDoc}
${ProcessesDataFragmentDoc}
${DefaultForeignTradeShipmentDataFragmentDoc}
${NationalRoadTranportsDataFragmentDoc}`;

/**
 * __useGetContainersTableRowsQuery__
 *
 * To run a query within a React component, call `useGetContainersTableRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContainersTableRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContainersTableRowsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      pathFilters: // value for 'pathFilters'
 *      processFilters: // value for 'processFilters'
 *      includeDocuments: // value for 'includeDocuments'
 *      includeProcessLeadTime: // value for 'includeProcessLeadTime'
 *      includeProcessBrazilianInvoiceInfo: // value for 'includeProcessBrazilianInvoiceInfo'
 *      includeVesselScheduleCalculatedDates: // value for 'includeVesselScheduleCalculatedDates'
 *      includeShipmentDuimps: // value for 'includeShipmentDuimps'
 *      includeShipmentExportDeclarations: // value for 'includeShipmentExportDeclarations'
 *      includeShipmentImportDeclarations: // value for 'includeShipmentImportDeclarations'
 *      includeShipmentImportLicenses: // value for 'includeShipmentImportLicenses'
 *      includeDemurrageAny: // value for 'includeDemurrageAny'
 *      includeDemurrage: // value for 'includeDemurrage'
 *      includeDemurrageCalculations: // value for 'includeDemurrageCalculations'
 *   },
 * });
 */
export function useGetContainersTableRowsQuery(baseOptions: Apollo.QueryHookOptions<GetContainersTableRowsQuery, GetContainersTableRowsQueryVariables> & ({ variables: GetContainersTableRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContainersTableRowsQuery, GetContainersTableRowsQueryVariables>(GetContainersTableRowsDocument, options);
      }
export function useGetContainersTableRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContainersTableRowsQuery, GetContainersTableRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContainersTableRowsQuery, GetContainersTableRowsQueryVariables>(GetContainersTableRowsDocument, options);
        }
// @ts-ignore
export function useGetContainersTableRowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContainersTableRowsQuery, GetContainersTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetContainersTableRowsQuery, GetContainersTableRowsQueryVariables>;
export function useGetContainersTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContainersTableRowsQuery, GetContainersTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetContainersTableRowsQuery | undefined, GetContainersTableRowsQueryVariables>;
export function useGetContainersTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContainersTableRowsQuery, GetContainersTableRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContainersTableRowsQuery, GetContainersTableRowsQueryVariables>(GetContainersTableRowsDocument, options);
        }
export type GetContainersTableRowsQueryHookResult = ReturnType<typeof useGetContainersTableRowsQuery>;
export type GetContainersTableRowsLazyQueryHookResult = ReturnType<typeof useGetContainersTableRowsLazyQuery>;
export type GetContainersTableRowsSuspenseQueryHookResult = ReturnType<typeof useGetContainersTableRowsSuspenseQuery>;
export type GetContainersTableRowsQueryResult = Apollo.QueryResult<GetContainersTableRowsQuery, GetContainersTableRowsQueryVariables>;
export const GetInvoiceItemsTableRowsDocument = gql`
    query GetInvoiceItemsTableRows($search: String, $filters: FilterInvoiceItemParams!, $pagination: InvoiceItemPaginationParams, $pathFilters: JSON, $processFilters: FilterProcessParams, $includeDocuments: Boolean!, $includeProcessLeadTime: Boolean!, $includeProcessBrazilianInvoiceInfo: Boolean!, $includeVesselScheduleCalculatedDates: Boolean!, $includeShipmentDuimps: Boolean!, $includeShipmentExportDeclarations: Boolean!, $includeShipmentImportDeclarations: Boolean!, $includeShipmentImportLicenses: Boolean!, $includeContainers: Boolean!, $includeDemurrageAny: Boolean!, $includeDemurrage: Boolean!, $includeDemurrageCalculations: Boolean!) {
  invoiceItemsPerProcessesCount(
    search: $search
    filters: $filters
    pathFilters: $pathFilters
    processFilters: $processFilters
  )
  invoiceItemsPerProcesses(
    search: $search
    filters: $filters
    pagination: $pagination
    pathFilters: $pathFilters
    processFilters: $processFilters
  ) {
    invoiceItem {
      id
      quantity
      productSku
      productDescription
      batchNumber
      unitaryAmount
      batchValidityDate
      productionDate
      totalAmount
      totalGrossWeightKg
      orderReferenceCode
      orderItemLineReference
      product {
        ...ProductFields
      }
      invoice {
        id
        number
        emittedAt
        incoterm
        discount
        totalAmount
        finalValue
        totalGrossWeightKg
        currency {
          code
          name
        }
      }
      transportables(containerHidden: false) {
        id
        container {
          ...LinkedContainersData
        }
      }
    }
    process {
      ...ProcessesData
      foreignTradeShipment {
        ...DefaultForeignTradeShipmentData
        ...NationalRoadTranportsData
        ...ItemsData
        ...ContainersData
      }
    }
  }
}
    ${ProductFieldsFragmentDoc}
${LinkedContainersDataFragmentDoc}
${ProcessesDataFragmentDoc}
${DefaultForeignTradeShipmentDataFragmentDoc}
${NationalRoadTranportsDataFragmentDoc}
${ItemsDataFragmentDoc}
${ContainersDataFragmentDoc}`;

/**
 * __useGetInvoiceItemsTableRowsQuery__
 *
 * To run a query within a React component, call `useGetInvoiceItemsTableRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceItemsTableRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceItemsTableRowsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      pathFilters: // value for 'pathFilters'
 *      processFilters: // value for 'processFilters'
 *      includeDocuments: // value for 'includeDocuments'
 *      includeProcessLeadTime: // value for 'includeProcessLeadTime'
 *      includeProcessBrazilianInvoiceInfo: // value for 'includeProcessBrazilianInvoiceInfo'
 *      includeVesselScheduleCalculatedDates: // value for 'includeVesselScheduleCalculatedDates'
 *      includeShipmentDuimps: // value for 'includeShipmentDuimps'
 *      includeShipmentExportDeclarations: // value for 'includeShipmentExportDeclarations'
 *      includeShipmentImportDeclarations: // value for 'includeShipmentImportDeclarations'
 *      includeShipmentImportLicenses: // value for 'includeShipmentImportLicenses'
 *      includeContainers: // value for 'includeContainers'
 *      includeDemurrageAny: // value for 'includeDemurrageAny'
 *      includeDemurrage: // value for 'includeDemurrage'
 *      includeDemurrageCalculations: // value for 'includeDemurrageCalculations'
 *   },
 * });
 */
export function useGetInvoiceItemsTableRowsQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceItemsTableRowsQuery, GetInvoiceItemsTableRowsQueryVariables> & ({ variables: GetInvoiceItemsTableRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceItemsTableRowsQuery, GetInvoiceItemsTableRowsQueryVariables>(GetInvoiceItemsTableRowsDocument, options);
      }
export function useGetInvoiceItemsTableRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceItemsTableRowsQuery, GetInvoiceItemsTableRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceItemsTableRowsQuery, GetInvoiceItemsTableRowsQueryVariables>(GetInvoiceItemsTableRowsDocument, options);
        }
// @ts-ignore
export function useGetInvoiceItemsTableRowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvoiceItemsTableRowsQuery, GetInvoiceItemsTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoiceItemsTableRowsQuery, GetInvoiceItemsTableRowsQueryVariables>;
export function useGetInvoiceItemsTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoiceItemsTableRowsQuery, GetInvoiceItemsTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoiceItemsTableRowsQuery | undefined, GetInvoiceItemsTableRowsQueryVariables>;
export function useGetInvoiceItemsTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoiceItemsTableRowsQuery, GetInvoiceItemsTableRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoiceItemsTableRowsQuery, GetInvoiceItemsTableRowsQueryVariables>(GetInvoiceItemsTableRowsDocument, options);
        }
export type GetInvoiceItemsTableRowsQueryHookResult = ReturnType<typeof useGetInvoiceItemsTableRowsQuery>;
export type GetInvoiceItemsTableRowsLazyQueryHookResult = ReturnType<typeof useGetInvoiceItemsTableRowsLazyQuery>;
export type GetInvoiceItemsTableRowsSuspenseQueryHookResult = ReturnType<typeof useGetInvoiceItemsTableRowsSuspenseQuery>;
export type GetInvoiceItemsTableRowsQueryResult = Apollo.QueryResult<GetInvoiceItemsTableRowsQuery, GetInvoiceItemsTableRowsQueryVariables>;
export const GetLeadTimeStagesPerProcessesTableRowsDocument = gql`
    query GetLeadTimeStagesPerProcessesTableRows($search: String, $processFilters: FilterProcessParams!, $pagination: ProcessPaginationParams, $pathFilters: JSON, $includeDocuments: Boolean!, $includeProcessLeadTime: Boolean!, $includeProcessBrazilianInvoiceInfo: Boolean!, $includeVesselScheduleCalculatedDates: Boolean!, $includeShipmentDuimps: Boolean!, $includeShipmentExportDeclarations: Boolean!, $includeShipmentImportDeclarations: Boolean!, $includeShipmentImportLicenses: Boolean!, $includeContainers: Boolean!, $includeDemurrageAny: Boolean!, $includeDemurrage: Boolean!, $includeDemurrageCalculations: Boolean!) {
  leadTimeStagesPerProcesses(
    search: $search
    processFilters: $processFilters
    pagination: $pagination
    pathFilters: $pathFilters
  ) {
    data {
      process {
        ...ProcessesData
        foreignTradeShipment {
          ...DefaultForeignTradeShipmentData
          ...NationalRoadTranportsData
          ...ContainersData
          ...ItemsData
        }
        plannedLeadTime {
          id
          name
          leadTimeModel {
            id
            name
            ignoreTime
            referenceEvent
            referenceEventLabel
          }
        }
      }
      leadTime {
        status
        plannedDurationHours
        realizedOrEstimatedDurationHours
        differenceHours
        deviationPercentage
        conclusionDate
        startDate
        plannedConclusionDate
      }
      leadTimeStage {
        deviationPercentage
        model {
          id
          name
          startEventLabel
          endEventLabel
        }
        planned {
          startedAt
          endedAt
          durationHours
        }
        realized {
          startedAt
          endedAt
          durationHours
        }
        estimated {
          startedAt
          endedAt
          durationHours
        }
      }
    }
    totalCount
  }
}
    ${ProcessesDataFragmentDoc}
${DefaultForeignTradeShipmentDataFragmentDoc}
${NationalRoadTranportsDataFragmentDoc}
${ContainersDataFragmentDoc}
${ItemsDataFragmentDoc}`;

/**
 * __useGetLeadTimeStagesPerProcessesTableRowsQuery__
 *
 * To run a query within a React component, call `useGetLeadTimeStagesPerProcessesTableRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadTimeStagesPerProcessesTableRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadTimeStagesPerProcessesTableRowsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      processFilters: // value for 'processFilters'
 *      pagination: // value for 'pagination'
 *      pathFilters: // value for 'pathFilters'
 *      includeDocuments: // value for 'includeDocuments'
 *      includeProcessLeadTime: // value for 'includeProcessLeadTime'
 *      includeProcessBrazilianInvoiceInfo: // value for 'includeProcessBrazilianInvoiceInfo'
 *      includeVesselScheduleCalculatedDates: // value for 'includeVesselScheduleCalculatedDates'
 *      includeShipmentDuimps: // value for 'includeShipmentDuimps'
 *      includeShipmentExportDeclarations: // value for 'includeShipmentExportDeclarations'
 *      includeShipmentImportDeclarations: // value for 'includeShipmentImportDeclarations'
 *      includeShipmentImportLicenses: // value for 'includeShipmentImportLicenses'
 *      includeContainers: // value for 'includeContainers'
 *      includeDemurrageAny: // value for 'includeDemurrageAny'
 *      includeDemurrage: // value for 'includeDemurrage'
 *      includeDemurrageCalculations: // value for 'includeDemurrageCalculations'
 *   },
 * });
 */
export function useGetLeadTimeStagesPerProcessesTableRowsQuery(baseOptions: Apollo.QueryHookOptions<GetLeadTimeStagesPerProcessesTableRowsQuery, GetLeadTimeStagesPerProcessesTableRowsQueryVariables> & ({ variables: GetLeadTimeStagesPerProcessesTableRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadTimeStagesPerProcessesTableRowsQuery, GetLeadTimeStagesPerProcessesTableRowsQueryVariables>(GetLeadTimeStagesPerProcessesTableRowsDocument, options);
      }
export function useGetLeadTimeStagesPerProcessesTableRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadTimeStagesPerProcessesTableRowsQuery, GetLeadTimeStagesPerProcessesTableRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadTimeStagesPerProcessesTableRowsQuery, GetLeadTimeStagesPerProcessesTableRowsQueryVariables>(GetLeadTimeStagesPerProcessesTableRowsDocument, options);
        }
// @ts-ignore
export function useGetLeadTimeStagesPerProcessesTableRowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLeadTimeStagesPerProcessesTableRowsQuery, GetLeadTimeStagesPerProcessesTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadTimeStagesPerProcessesTableRowsQuery, GetLeadTimeStagesPerProcessesTableRowsQueryVariables>;
export function useGetLeadTimeStagesPerProcessesTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadTimeStagesPerProcessesTableRowsQuery, GetLeadTimeStagesPerProcessesTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadTimeStagesPerProcessesTableRowsQuery | undefined, GetLeadTimeStagesPerProcessesTableRowsQueryVariables>;
export function useGetLeadTimeStagesPerProcessesTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadTimeStagesPerProcessesTableRowsQuery, GetLeadTimeStagesPerProcessesTableRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeadTimeStagesPerProcessesTableRowsQuery, GetLeadTimeStagesPerProcessesTableRowsQueryVariables>(GetLeadTimeStagesPerProcessesTableRowsDocument, options);
        }
export type GetLeadTimeStagesPerProcessesTableRowsQueryHookResult = ReturnType<typeof useGetLeadTimeStagesPerProcessesTableRowsQuery>;
export type GetLeadTimeStagesPerProcessesTableRowsLazyQueryHookResult = ReturnType<typeof useGetLeadTimeStagesPerProcessesTableRowsLazyQuery>;
export type GetLeadTimeStagesPerProcessesTableRowsSuspenseQueryHookResult = ReturnType<typeof useGetLeadTimeStagesPerProcessesTableRowsSuspenseQuery>;
export type GetLeadTimeStagesPerProcessesTableRowsQueryResult = Apollo.QueryResult<GetLeadTimeStagesPerProcessesTableRowsQuery, GetLeadTimeStagesPerProcessesTableRowsQueryVariables>;
export const GetOrderItemsWithShipmentItemTableRowsDocument = gql`
    query GetOrderItemsWithShipmentItemTableRows($search: String, $filters: FilterOrderItemParams!, $pagination: OrderItemPaginationParams, $pathFilters: JSON, $processFilters: FilterProcessParams, $orderFilters: FilterOrderParams, $includeDocuments: Boolean!, $includeProcessLeadTime: Boolean!, $includeProcessBrazilianInvoiceInfo: Boolean!, $includeVesselScheduleCalculatedDates: Boolean!, $includeShipmentDuimps: Boolean!, $includeShipmentExportDeclarations: Boolean!, $includeShipmentImportDeclarations: Boolean!, $includeShipmentImportLicenses: Boolean!, $includeContainers: Boolean!, $includeDemurrageAny: Boolean!, $includeDemurrage: Boolean!, $includeDemurrageCalculations: Boolean!) {
  orderItemsWithShipmentItemsCount(
    search: $search
    filters: $filters
    pathFilters: $pathFilters
    processFilters: $processFilters
    orderFilters: $orderFilters
  )
  orderItemsWithShipmentItems(
    search: $search
    filters: $filters
    pagination: $pagination
    pathFilters: $pathFilters
    processFilters: $processFilters
    orderFilters: $orderFilters
  ) {
    foreignTradeItemShipment {
      ...ShipmentItemData
      transportables(containerHidden: false) {
        id
        container {
          ...LinkedContainersData
        }
      }
    }
    salesOrderItem {
      id
      lineNumber
      lineReference
      quantity
      balance
      ...SalesOrderItemAdditionalFieldsFragment
      product {
        ...ProductFields
      }
      salesOrder {
        id
        order {
          id
          referenceCode
        }
      }
    }
    purchaseOrderItem {
      id
      lineNumber
      lineReference
      quantity
      balance
      ...PurchaseOrderItemAdditionalFieldsFragment
      product {
        ...ProductFields
      }
      purchaseOrder {
        id
        order {
          id
          referenceCode
        }
      }
    }
    process {
      ...ProcessesData
      foreignTradeShipment {
        ...DefaultForeignTradeShipmentData
        ...NationalRoadTranportsData
        ...ContainersData
      }
    }
    order {
      ...OrdersData
    }
  }
}
    ${ShipmentItemDataFragmentDoc}
${LinkedContainersDataFragmentDoc}
${SalesOrderItemAdditionalFieldsFragmentFragmentDoc}
${ProductFieldsFragmentDoc}
${PurchaseOrderItemAdditionalFieldsFragmentFragmentDoc}
${ProcessesDataFragmentDoc}
${DefaultForeignTradeShipmentDataFragmentDoc}
${NationalRoadTranportsDataFragmentDoc}
${ContainersDataFragmentDoc}
${OrdersDataFragmentDoc}`;

/**
 * __useGetOrderItemsWithShipmentItemTableRowsQuery__
 *
 * To run a query within a React component, call `useGetOrderItemsWithShipmentItemTableRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderItemsWithShipmentItemTableRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderItemsWithShipmentItemTableRowsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      pathFilters: // value for 'pathFilters'
 *      processFilters: // value for 'processFilters'
 *      orderFilters: // value for 'orderFilters'
 *      includeDocuments: // value for 'includeDocuments'
 *      includeProcessLeadTime: // value for 'includeProcessLeadTime'
 *      includeProcessBrazilianInvoiceInfo: // value for 'includeProcessBrazilianInvoiceInfo'
 *      includeVesselScheduleCalculatedDates: // value for 'includeVesselScheduleCalculatedDates'
 *      includeShipmentDuimps: // value for 'includeShipmentDuimps'
 *      includeShipmentExportDeclarations: // value for 'includeShipmentExportDeclarations'
 *      includeShipmentImportDeclarations: // value for 'includeShipmentImportDeclarations'
 *      includeShipmentImportLicenses: // value for 'includeShipmentImportLicenses'
 *      includeContainers: // value for 'includeContainers'
 *      includeDemurrageAny: // value for 'includeDemurrageAny'
 *      includeDemurrage: // value for 'includeDemurrage'
 *      includeDemurrageCalculations: // value for 'includeDemurrageCalculations'
 *   },
 * });
 */
export function useGetOrderItemsWithShipmentItemTableRowsQuery(baseOptions: Apollo.QueryHookOptions<GetOrderItemsWithShipmentItemTableRowsQuery, GetOrderItemsWithShipmentItemTableRowsQueryVariables> & ({ variables: GetOrderItemsWithShipmentItemTableRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderItemsWithShipmentItemTableRowsQuery, GetOrderItemsWithShipmentItemTableRowsQueryVariables>(GetOrderItemsWithShipmentItemTableRowsDocument, options);
      }
export function useGetOrderItemsWithShipmentItemTableRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderItemsWithShipmentItemTableRowsQuery, GetOrderItemsWithShipmentItemTableRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderItemsWithShipmentItemTableRowsQuery, GetOrderItemsWithShipmentItemTableRowsQueryVariables>(GetOrderItemsWithShipmentItemTableRowsDocument, options);
        }
// @ts-ignore
export function useGetOrderItemsWithShipmentItemTableRowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrderItemsWithShipmentItemTableRowsQuery, GetOrderItemsWithShipmentItemTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderItemsWithShipmentItemTableRowsQuery, GetOrderItemsWithShipmentItemTableRowsQueryVariables>;
export function useGetOrderItemsWithShipmentItemTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderItemsWithShipmentItemTableRowsQuery, GetOrderItemsWithShipmentItemTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderItemsWithShipmentItemTableRowsQuery | undefined, GetOrderItemsWithShipmentItemTableRowsQueryVariables>;
export function useGetOrderItemsWithShipmentItemTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderItemsWithShipmentItemTableRowsQuery, GetOrderItemsWithShipmentItemTableRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderItemsWithShipmentItemTableRowsQuery, GetOrderItemsWithShipmentItemTableRowsQueryVariables>(GetOrderItemsWithShipmentItemTableRowsDocument, options);
        }
export type GetOrderItemsWithShipmentItemTableRowsQueryHookResult = ReturnType<typeof useGetOrderItemsWithShipmentItemTableRowsQuery>;
export type GetOrderItemsWithShipmentItemTableRowsLazyQueryHookResult = ReturnType<typeof useGetOrderItemsWithShipmentItemTableRowsLazyQuery>;
export type GetOrderItemsWithShipmentItemTableRowsSuspenseQueryHookResult = ReturnType<typeof useGetOrderItemsWithShipmentItemTableRowsSuspenseQuery>;
export type GetOrderItemsWithShipmentItemTableRowsQueryResult = Apollo.QueryResult<GetOrderItemsWithShipmentItemTableRowsQuery, GetOrderItemsWithShipmentItemTableRowsQueryVariables>;
export const GetOrderItemsTableRowsDocument = gql`
    query GetOrderItemsTableRows($search: String, $filters: FilterOrderItemParams!, $pagination: OrderItemPaginationParams, $pathFilters: JSON, $orderFilters: FilterOrderParams) {
  orderItemsCount(
    search: $search
    filters: $filters
    pathFilters: $pathFilters
    orderFilters: $orderFilters
  )
  orderItems(
    search: $search
    filters: $filters
    pagination: $pagination
    pathFilters: $pathFilters
    orderFilters: $orderFilters
  ) {
    salesOrderItem {
      id
      lineNumber
      lineReference
      quantity
      balanceShipped
      balance
      ...SalesOrderItemAdditionalFieldsFragment
      product {
        ...ProductFields
      }
    }
    purchaseOrderItem {
      id
      lineNumber
      lineReference
      quantity
      balanceShipped
      balance
      ...PurchaseOrderItemAdditionalFieldsFragment
      product {
        ...ProductFields
      }
    }
    order {
      ...OrdersData
    }
  }
}
    ${SalesOrderItemAdditionalFieldsFragmentFragmentDoc}
${ProductFieldsFragmentDoc}
${PurchaseOrderItemAdditionalFieldsFragmentFragmentDoc}
${OrdersDataFragmentDoc}`;

/**
 * __useGetOrderItemsTableRowsQuery__
 *
 * To run a query within a React component, call `useGetOrderItemsTableRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderItemsTableRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderItemsTableRowsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      pathFilters: // value for 'pathFilters'
 *      orderFilters: // value for 'orderFilters'
 *   },
 * });
 */
export function useGetOrderItemsTableRowsQuery(baseOptions: Apollo.QueryHookOptions<GetOrderItemsTableRowsQuery, GetOrderItemsTableRowsQueryVariables> & ({ variables: GetOrderItemsTableRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderItemsTableRowsQuery, GetOrderItemsTableRowsQueryVariables>(GetOrderItemsTableRowsDocument, options);
      }
export function useGetOrderItemsTableRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderItemsTableRowsQuery, GetOrderItemsTableRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderItemsTableRowsQuery, GetOrderItemsTableRowsQueryVariables>(GetOrderItemsTableRowsDocument, options);
        }
// @ts-ignore
export function useGetOrderItemsTableRowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrderItemsTableRowsQuery, GetOrderItemsTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderItemsTableRowsQuery, GetOrderItemsTableRowsQueryVariables>;
export function useGetOrderItemsTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderItemsTableRowsQuery, GetOrderItemsTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderItemsTableRowsQuery | undefined, GetOrderItemsTableRowsQueryVariables>;
export function useGetOrderItemsTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderItemsTableRowsQuery, GetOrderItemsTableRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderItemsTableRowsQuery, GetOrderItemsTableRowsQueryVariables>(GetOrderItemsTableRowsDocument, options);
        }
export type GetOrderItemsTableRowsQueryHookResult = ReturnType<typeof useGetOrderItemsTableRowsQuery>;
export type GetOrderItemsTableRowsLazyQueryHookResult = ReturnType<typeof useGetOrderItemsTableRowsLazyQuery>;
export type GetOrderItemsTableRowsSuspenseQueryHookResult = ReturnType<typeof useGetOrderItemsTableRowsSuspenseQuery>;
export type GetOrderItemsTableRowsQueryResult = Apollo.QueryResult<GetOrderItemsTableRowsQuery, GetOrderItemsTableRowsQueryVariables>;
export const GetOrdersTableRowsDocument = gql`
    query GetOrdersTableRows($pagination: OrderPaginationParams, $filters: FilterOrderParams, $pathFilters: JSON, $search: String) {
  ordersCount(filters: $filters, pathFilters: $pathFilters, search: $search)
  orders(
    pagination: $pagination
    filters: $filters
    pathFilters: $pathFilters
    search: $search
  ) {
    ...OrdersData
  }
}
    ${OrdersDataFragmentDoc}`;

/**
 * __useGetOrdersTableRowsQuery__
 *
 * To run a query within a React component, call `useGetOrdersTableRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersTableRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersTableRowsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *      pathFilters: // value for 'pathFilters'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetOrdersTableRowsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrdersTableRowsQuery, GetOrdersTableRowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersTableRowsQuery, GetOrdersTableRowsQueryVariables>(GetOrdersTableRowsDocument, options);
      }
export function useGetOrdersTableRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersTableRowsQuery, GetOrdersTableRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersTableRowsQuery, GetOrdersTableRowsQueryVariables>(GetOrdersTableRowsDocument, options);
        }
// @ts-ignore
export function useGetOrdersTableRowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrdersTableRowsQuery, GetOrdersTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrdersTableRowsQuery, GetOrdersTableRowsQueryVariables>;
export function useGetOrdersTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersTableRowsQuery, GetOrdersTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrdersTableRowsQuery | undefined, GetOrdersTableRowsQueryVariables>;
export function useGetOrdersTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersTableRowsQuery, GetOrdersTableRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrdersTableRowsQuery, GetOrdersTableRowsQueryVariables>(GetOrdersTableRowsDocument, options);
        }
export type GetOrdersTableRowsQueryHookResult = ReturnType<typeof useGetOrdersTableRowsQuery>;
export type GetOrdersTableRowsLazyQueryHookResult = ReturnType<typeof useGetOrdersTableRowsLazyQuery>;
export type GetOrdersTableRowsSuspenseQueryHookResult = ReturnType<typeof useGetOrdersTableRowsSuspenseQuery>;
export type GetOrdersTableRowsQueryResult = Apollo.QueryResult<GetOrdersTableRowsQuery, GetOrdersTableRowsQueryVariables>;
export const GetProcessCostsTableRowsDocument = gql`
    query GetProcessCostsTableRows($pagination: ProcessPaginationParams, $filters: FilterProcessParams, $pathFilters: JSON, $search: String, $includeDocuments: Boolean!, $includeProcessLeadTime: Boolean!, $includeProcessBrazilianInvoiceInfo: Boolean!, $includeVesselScheduleCalculatedDates: Boolean!, $includeShipmentDuimps: Boolean!, $includeShipmentExportDeclarations: Boolean!, $includeShipmentImportDeclarations: Boolean!, $includeShipmentImportLicenses: Boolean!, $includeContainers: Boolean!, $includeDemurrageAny: Boolean!, $includeDemurrage: Boolean!, $includeDemurrageCalculations: Boolean!) {
  processesCount(filters: $filters, pathFilters: $pathFilters, search: $search)
  processes(
    pagination: $pagination
    filters: $filters
    pathFilters: $pathFilters
    search: $search
  ) {
    ...ProcessesData
    foreignTradeShipment {
      ...DefaultForeignTradeShipmentData
      ...ItemsData
      ...NationalRoadTranportsData
      ...ContainersData
    }
    costModelVersion {
      id
      version
      costModel {
        id
        name
        hasPlannedCosts
        currency {
          code
          name
        }
      }
    }
    costPerExpenses {
      id
      cost
      plannedCost
      deviation
      costModelExpense {
        id
        costExpense {
          id
        }
      }
    }
  }
}
    ${ProcessesDataFragmentDoc}
${DefaultForeignTradeShipmentDataFragmentDoc}
${ItemsDataFragmentDoc}
${NationalRoadTranportsDataFragmentDoc}
${ContainersDataFragmentDoc}`;

/**
 * __useGetProcessCostsTableRowsQuery__
 *
 * To run a query within a React component, call `useGetProcessCostsTableRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessCostsTableRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessCostsTableRowsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *      pathFilters: // value for 'pathFilters'
 *      search: // value for 'search'
 *      includeDocuments: // value for 'includeDocuments'
 *      includeProcessLeadTime: // value for 'includeProcessLeadTime'
 *      includeProcessBrazilianInvoiceInfo: // value for 'includeProcessBrazilianInvoiceInfo'
 *      includeVesselScheduleCalculatedDates: // value for 'includeVesselScheduleCalculatedDates'
 *      includeShipmentDuimps: // value for 'includeShipmentDuimps'
 *      includeShipmentExportDeclarations: // value for 'includeShipmentExportDeclarations'
 *      includeShipmentImportDeclarations: // value for 'includeShipmentImportDeclarations'
 *      includeShipmentImportLicenses: // value for 'includeShipmentImportLicenses'
 *      includeContainers: // value for 'includeContainers'
 *      includeDemurrageAny: // value for 'includeDemurrageAny'
 *      includeDemurrage: // value for 'includeDemurrage'
 *      includeDemurrageCalculations: // value for 'includeDemurrageCalculations'
 *   },
 * });
 */
export function useGetProcessCostsTableRowsQuery(baseOptions: Apollo.QueryHookOptions<GetProcessCostsTableRowsQuery, GetProcessCostsTableRowsQueryVariables> & ({ variables: GetProcessCostsTableRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessCostsTableRowsQuery, GetProcessCostsTableRowsQueryVariables>(GetProcessCostsTableRowsDocument, options);
      }
export function useGetProcessCostsTableRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessCostsTableRowsQuery, GetProcessCostsTableRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessCostsTableRowsQuery, GetProcessCostsTableRowsQueryVariables>(GetProcessCostsTableRowsDocument, options);
        }
// @ts-ignore
export function useGetProcessCostsTableRowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProcessCostsTableRowsQuery, GetProcessCostsTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessCostsTableRowsQuery, GetProcessCostsTableRowsQueryVariables>;
export function useGetProcessCostsTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessCostsTableRowsQuery, GetProcessCostsTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessCostsTableRowsQuery | undefined, GetProcessCostsTableRowsQueryVariables>;
export function useGetProcessCostsTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessCostsTableRowsQuery, GetProcessCostsTableRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProcessCostsTableRowsQuery, GetProcessCostsTableRowsQueryVariables>(GetProcessCostsTableRowsDocument, options);
        }
export type GetProcessCostsTableRowsQueryHookResult = ReturnType<typeof useGetProcessCostsTableRowsQuery>;
export type GetProcessCostsTableRowsLazyQueryHookResult = ReturnType<typeof useGetProcessCostsTableRowsLazyQuery>;
export type GetProcessCostsTableRowsSuspenseQueryHookResult = ReturnType<typeof useGetProcessCostsTableRowsSuspenseQuery>;
export type GetProcessCostsTableRowsQueryResult = Apollo.QueryResult<GetProcessCostsTableRowsQuery, GetProcessCostsTableRowsQueryVariables>;
export const GetProcessesTableRowsDocument = gql`
    query GetProcessesTableRows($pagination: ProcessPaginationParams, $filters: FilterProcessParams, $pathFilters: JSON, $search: String, $includeDocuments: Boolean!, $includeProcessLeadTime: Boolean!, $includeProcessBrazilianInvoiceInfo: Boolean!, $includeVesselScheduleCalculatedDates: Boolean!, $includeShipmentDuimps: Boolean!, $includeShipmentExportDeclarations: Boolean!, $includeShipmentImportDeclarations: Boolean!, $includeShipmentImportLicenses: Boolean!, $includeContainers: Boolean!, $includeDemurrageAny: Boolean!, $includeDemurrage: Boolean!, $includeDemurrageCalculations: Boolean!) {
  processesCount(filters: $filters, pathFilters: $pathFilters, search: $search)
  processes(
    pagination: $pagination
    filters: $filters
    pathFilters: $pathFilters
    search: $search
  ) {
    ...ProcessesData
    foreignTradeShipment {
      ...DefaultForeignTradeShipmentData
      ...ItemsData
      ...NationalRoadTranportsData
      ...ContainersData
    }
  }
}
    ${ProcessesDataFragmentDoc}
${DefaultForeignTradeShipmentDataFragmentDoc}
${ItemsDataFragmentDoc}
${NationalRoadTranportsDataFragmentDoc}
${ContainersDataFragmentDoc}`;

/**
 * __useGetProcessesTableRowsQuery__
 *
 * To run a query within a React component, call `useGetProcessesTableRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessesTableRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessesTableRowsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *      pathFilters: // value for 'pathFilters'
 *      search: // value for 'search'
 *      includeDocuments: // value for 'includeDocuments'
 *      includeProcessLeadTime: // value for 'includeProcessLeadTime'
 *      includeProcessBrazilianInvoiceInfo: // value for 'includeProcessBrazilianInvoiceInfo'
 *      includeVesselScheduleCalculatedDates: // value for 'includeVesselScheduleCalculatedDates'
 *      includeShipmentDuimps: // value for 'includeShipmentDuimps'
 *      includeShipmentExportDeclarations: // value for 'includeShipmentExportDeclarations'
 *      includeShipmentImportDeclarations: // value for 'includeShipmentImportDeclarations'
 *      includeShipmentImportLicenses: // value for 'includeShipmentImportLicenses'
 *      includeContainers: // value for 'includeContainers'
 *      includeDemurrageAny: // value for 'includeDemurrageAny'
 *      includeDemurrage: // value for 'includeDemurrage'
 *      includeDemurrageCalculations: // value for 'includeDemurrageCalculations'
 *   },
 * });
 */
export function useGetProcessesTableRowsQuery(baseOptions: Apollo.QueryHookOptions<GetProcessesTableRowsQuery, GetProcessesTableRowsQueryVariables> & ({ variables: GetProcessesTableRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessesTableRowsQuery, GetProcessesTableRowsQueryVariables>(GetProcessesTableRowsDocument, options);
      }
export function useGetProcessesTableRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessesTableRowsQuery, GetProcessesTableRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessesTableRowsQuery, GetProcessesTableRowsQueryVariables>(GetProcessesTableRowsDocument, options);
        }
// @ts-ignore
export function useGetProcessesTableRowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProcessesTableRowsQuery, GetProcessesTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessesTableRowsQuery, GetProcessesTableRowsQueryVariables>;
export function useGetProcessesTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessesTableRowsQuery, GetProcessesTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessesTableRowsQuery | undefined, GetProcessesTableRowsQueryVariables>;
export function useGetProcessesTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessesTableRowsQuery, GetProcessesTableRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProcessesTableRowsQuery, GetProcessesTableRowsQueryVariables>(GetProcessesTableRowsDocument, options);
        }
export type GetProcessesTableRowsQueryHookResult = ReturnType<typeof useGetProcessesTableRowsQuery>;
export type GetProcessesTableRowsLazyQueryHookResult = ReturnType<typeof useGetProcessesTableRowsLazyQuery>;
export type GetProcessesTableRowsSuspenseQueryHookResult = ReturnType<typeof useGetProcessesTableRowsSuspenseQuery>;
export type GetProcessesTableRowsQueryResult = Apollo.QueryResult<GetProcessesTableRowsQuery, GetProcessesTableRowsQueryVariables>;
export const GetRoadTransportTripTableRowsDocument = gql`
    query GetRoadTransportTripTableRows($search: String, $filters: FilterRoadTransportTripParams, $pagination: RoadTransportTripPaginationParams, $pathFilters: JSON, $processFilters: FilterProcessParams, $includeDocuments: Boolean!, $includeProcessLeadTime: Boolean!, $includeProcessBrazilianInvoiceInfo: Boolean!, $includeVesselScheduleCalculatedDates: Boolean!, $includeShipmentDuimps: Boolean!, $includeShipmentExportDeclarations: Boolean!, $includeShipmentImportDeclarations: Boolean!, $includeShipmentImportLicenses: Boolean!, $includeDemurrageAny: Boolean!, $includeDemurrage: Boolean!, $includeDemurrageCalculations: Boolean!) {
  nationalRoadTransportTripsPerProcessesCount(
    search: $search
    filters: $filters
    pathFilters: $pathFilters
    processFilters: $processFilters
  )
  nationalRoadTransportTripsPerProcesses(
    search: $search
    filters: $filters
    pagination: $pagination
    pathFilters: $pathFilters
    processFilters: $processFilters
  ) {
    roadTransportTrip {
      id
      driverName
      trailerPlate
      vehiclePlate
      transportables(containerHidden: false) {
        id
        container {
          id
          code
        }
      }
      driver {
        id
        name
      }
      trailer {
        id
        plate
      }
      vehicle {
        id
        plate
      }
      phases {
        id
        departureAt
        estimatedRealizedAt
        realizedAt
        routePoint {
          id
          routeType
        }
      }
      nationalRoadTransport {
        id
        legSlug
        collectionScheduledAt
        deliveryPlannedAt
        loadType
        roadTransportType
        transportFeatures
        releasedForTransportAt
        transportCompletedAt
        route {
          id
          name
        }
        nationalRoadCarrier {
          id
          partnership {
            id
            nicknameWithFallback
            internalCode
          }
        }
      }
    }
    process {
      ...ProcessesData
      foreignTradeShipment {
        ...DefaultForeignTradeShipmentData
        ...ItemsData
      }
    }
  }
}
    ${ProcessesDataFragmentDoc}
${DefaultForeignTradeShipmentDataFragmentDoc}
${ItemsDataFragmentDoc}`;

/**
 * __useGetRoadTransportTripTableRowsQuery__
 *
 * To run a query within a React component, call `useGetRoadTransportTripTableRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoadTransportTripTableRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoadTransportTripTableRowsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      pathFilters: // value for 'pathFilters'
 *      processFilters: // value for 'processFilters'
 *      includeDocuments: // value for 'includeDocuments'
 *      includeProcessLeadTime: // value for 'includeProcessLeadTime'
 *      includeProcessBrazilianInvoiceInfo: // value for 'includeProcessBrazilianInvoiceInfo'
 *      includeVesselScheduleCalculatedDates: // value for 'includeVesselScheduleCalculatedDates'
 *      includeShipmentDuimps: // value for 'includeShipmentDuimps'
 *      includeShipmentExportDeclarations: // value for 'includeShipmentExportDeclarations'
 *      includeShipmentImportDeclarations: // value for 'includeShipmentImportDeclarations'
 *      includeShipmentImportLicenses: // value for 'includeShipmentImportLicenses'
 *      includeDemurrageAny: // value for 'includeDemurrageAny'
 *      includeDemurrage: // value for 'includeDemurrage'
 *      includeDemurrageCalculations: // value for 'includeDemurrageCalculations'
 *   },
 * });
 */
export function useGetRoadTransportTripTableRowsQuery(baseOptions: Apollo.QueryHookOptions<GetRoadTransportTripTableRowsQuery, GetRoadTransportTripTableRowsQueryVariables> & ({ variables: GetRoadTransportTripTableRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoadTransportTripTableRowsQuery, GetRoadTransportTripTableRowsQueryVariables>(GetRoadTransportTripTableRowsDocument, options);
      }
export function useGetRoadTransportTripTableRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoadTransportTripTableRowsQuery, GetRoadTransportTripTableRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoadTransportTripTableRowsQuery, GetRoadTransportTripTableRowsQueryVariables>(GetRoadTransportTripTableRowsDocument, options);
        }
// @ts-ignore
export function useGetRoadTransportTripTableRowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoadTransportTripTableRowsQuery, GetRoadTransportTripTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRoadTransportTripTableRowsQuery, GetRoadTransportTripTableRowsQueryVariables>;
export function useGetRoadTransportTripTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRoadTransportTripTableRowsQuery, GetRoadTransportTripTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRoadTransportTripTableRowsQuery | undefined, GetRoadTransportTripTableRowsQueryVariables>;
export function useGetRoadTransportTripTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRoadTransportTripTableRowsQuery, GetRoadTransportTripTableRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoadTransportTripTableRowsQuery, GetRoadTransportTripTableRowsQueryVariables>(GetRoadTransportTripTableRowsDocument, options);
        }
export type GetRoadTransportTripTableRowsQueryHookResult = ReturnType<typeof useGetRoadTransportTripTableRowsQuery>;
export type GetRoadTransportTripTableRowsLazyQueryHookResult = ReturnType<typeof useGetRoadTransportTripTableRowsLazyQuery>;
export type GetRoadTransportTripTableRowsSuspenseQueryHookResult = ReturnType<typeof useGetRoadTransportTripTableRowsSuspenseQuery>;
export type GetRoadTransportTripTableRowsQueryResult = Apollo.QueryResult<GetRoadTransportTripTableRowsQuery, GetRoadTransportTripTableRowsQueryVariables>;
export const GetShipmentExportDeclarationsTableRowsDocument = gql`
    query GetShipmentExportDeclarationsTableRows($search: String, $filters: FilterShipmentExportDeclarationParams!, $pagination: ShipmentExportDeclarationPaginationParams, $pathFilters: JSON, $processFilters: FilterProcessParams, $includeDocuments: Boolean!, $includeProcessLeadTime: Boolean!, $includeProcessBrazilianInvoiceInfo: Boolean!, $includeVesselScheduleCalculatedDates: Boolean!, $includeShipmentDuimps: Boolean!, $includeShipmentExportDeclarations: Boolean!, $includeShipmentImportDeclarations: Boolean!, $includeShipmentImportLicenses: Boolean!, $includeContainers: Boolean!, $includeDemurrageAny: Boolean!, $includeDemurrage: Boolean!, $includeDemurrageCalculations: Boolean!) {
  shipmentExportDeclarationsPerProcessesCount(
    search: $search
    filters: $filters
    pathFilters: $pathFilters
    processFilters: $processFilters
  )
  shipmentExportDeclarationsPerProcesses(
    search: $search
    filters: $filters
    pagination: $pagination
    pathFilters: $pathFilters
    processFilters: $processFilters
  ) {
    shipmentExportDeclaration {
      id
      exportDeclaration {
        id
        status
        statusResponse
        channel
        number
        registeredAt
        customsClearedAt
        endorsedAt
      }
    }
    process {
      ...ProcessesData
      foreignTradeShipment {
        ...DefaultForeignTradeShipmentData
        ...NationalRoadTranportsData
        ...ContainersData
        ...ItemsData
      }
    }
  }
}
    ${ProcessesDataFragmentDoc}
${DefaultForeignTradeShipmentDataFragmentDoc}
${NationalRoadTranportsDataFragmentDoc}
${ContainersDataFragmentDoc}
${ItemsDataFragmentDoc}`;

/**
 * __useGetShipmentExportDeclarationsTableRowsQuery__
 *
 * To run a query within a React component, call `useGetShipmentExportDeclarationsTableRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentExportDeclarationsTableRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentExportDeclarationsTableRowsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      pathFilters: // value for 'pathFilters'
 *      processFilters: // value for 'processFilters'
 *      includeDocuments: // value for 'includeDocuments'
 *      includeProcessLeadTime: // value for 'includeProcessLeadTime'
 *      includeProcessBrazilianInvoiceInfo: // value for 'includeProcessBrazilianInvoiceInfo'
 *      includeVesselScheduleCalculatedDates: // value for 'includeVesselScheduleCalculatedDates'
 *      includeShipmentDuimps: // value for 'includeShipmentDuimps'
 *      includeShipmentExportDeclarations: // value for 'includeShipmentExportDeclarations'
 *      includeShipmentImportDeclarations: // value for 'includeShipmentImportDeclarations'
 *      includeShipmentImportLicenses: // value for 'includeShipmentImportLicenses'
 *      includeContainers: // value for 'includeContainers'
 *      includeDemurrageAny: // value for 'includeDemurrageAny'
 *      includeDemurrage: // value for 'includeDemurrage'
 *      includeDemurrageCalculations: // value for 'includeDemurrageCalculations'
 *   },
 * });
 */
export function useGetShipmentExportDeclarationsTableRowsQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentExportDeclarationsTableRowsQuery, GetShipmentExportDeclarationsTableRowsQueryVariables> & ({ variables: GetShipmentExportDeclarationsTableRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentExportDeclarationsTableRowsQuery, GetShipmentExportDeclarationsTableRowsQueryVariables>(GetShipmentExportDeclarationsTableRowsDocument, options);
      }
export function useGetShipmentExportDeclarationsTableRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentExportDeclarationsTableRowsQuery, GetShipmentExportDeclarationsTableRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentExportDeclarationsTableRowsQuery, GetShipmentExportDeclarationsTableRowsQueryVariables>(GetShipmentExportDeclarationsTableRowsDocument, options);
        }
// @ts-ignore
export function useGetShipmentExportDeclarationsTableRowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetShipmentExportDeclarationsTableRowsQuery, GetShipmentExportDeclarationsTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetShipmentExportDeclarationsTableRowsQuery, GetShipmentExportDeclarationsTableRowsQueryVariables>;
export function useGetShipmentExportDeclarationsTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShipmentExportDeclarationsTableRowsQuery, GetShipmentExportDeclarationsTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetShipmentExportDeclarationsTableRowsQuery | undefined, GetShipmentExportDeclarationsTableRowsQueryVariables>;
export function useGetShipmentExportDeclarationsTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShipmentExportDeclarationsTableRowsQuery, GetShipmentExportDeclarationsTableRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShipmentExportDeclarationsTableRowsQuery, GetShipmentExportDeclarationsTableRowsQueryVariables>(GetShipmentExportDeclarationsTableRowsDocument, options);
        }
export type GetShipmentExportDeclarationsTableRowsQueryHookResult = ReturnType<typeof useGetShipmentExportDeclarationsTableRowsQuery>;
export type GetShipmentExportDeclarationsTableRowsLazyQueryHookResult = ReturnType<typeof useGetShipmentExportDeclarationsTableRowsLazyQuery>;
export type GetShipmentExportDeclarationsTableRowsSuspenseQueryHookResult = ReturnType<typeof useGetShipmentExportDeclarationsTableRowsSuspenseQuery>;
export type GetShipmentExportDeclarationsTableRowsQueryResult = Apollo.QueryResult<GetShipmentExportDeclarationsTableRowsQuery, GetShipmentExportDeclarationsTableRowsQueryVariables>;
export const GetShipmentImportDeclarationsTableRowsDocument = gql`
    query GetShipmentImportDeclarationsTableRows($search: String, $filters: FilterShipmentImportDeclarationParams!, $pagination: ShipmentImportDeclarationPaginationParams, $pathFilters: JSON, $processFilters: FilterProcessParams, $includeDocuments: Boolean!, $includeProcessLeadTime: Boolean!, $includeProcessBrazilianInvoiceInfo: Boolean!, $includeVesselScheduleCalculatedDates: Boolean!, $includeShipmentDuimps: Boolean!, $includeShipmentExportDeclarations: Boolean!, $includeShipmentImportDeclarations: Boolean!, $includeShipmentImportLicenses: Boolean!, $includeContainers: Boolean!, $includeDemurrageAny: Boolean!, $includeDemurrage: Boolean!, $includeDemurrageCalculations: Boolean!) {
  shipmentImportDeclarationsPerProcessesCount(
    search: $search
    filters: $filters
    pathFilters: $pathFilters
    processFilters: $processFilters
  )
  shipmentImportDeclarationsPerProcesses(
    search: $search
    filters: $filters
    pagination: $pagination
    pathFilters: $pathFilters
    processFilters: $processFilters
  ) {
    shipmentImportDeclaration {
      id
      importDeclaration {
        id
        status
        statusResponse
        channel
        number
        registeredAt
        customsClearedAt
      }
    }
    process {
      ...ProcessesData
      foreignTradeShipment {
        ...DefaultForeignTradeShipmentData
        ...NationalRoadTranportsData
        ...ContainersData
        ...ItemsData
      }
    }
  }
}
    ${ProcessesDataFragmentDoc}
${DefaultForeignTradeShipmentDataFragmentDoc}
${NationalRoadTranportsDataFragmentDoc}
${ContainersDataFragmentDoc}
${ItemsDataFragmentDoc}`;

/**
 * __useGetShipmentImportDeclarationsTableRowsQuery__
 *
 * To run a query within a React component, call `useGetShipmentImportDeclarationsTableRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentImportDeclarationsTableRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentImportDeclarationsTableRowsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      pathFilters: // value for 'pathFilters'
 *      processFilters: // value for 'processFilters'
 *      includeDocuments: // value for 'includeDocuments'
 *      includeProcessLeadTime: // value for 'includeProcessLeadTime'
 *      includeProcessBrazilianInvoiceInfo: // value for 'includeProcessBrazilianInvoiceInfo'
 *      includeVesselScheduleCalculatedDates: // value for 'includeVesselScheduleCalculatedDates'
 *      includeShipmentDuimps: // value for 'includeShipmentDuimps'
 *      includeShipmentExportDeclarations: // value for 'includeShipmentExportDeclarations'
 *      includeShipmentImportDeclarations: // value for 'includeShipmentImportDeclarations'
 *      includeShipmentImportLicenses: // value for 'includeShipmentImportLicenses'
 *      includeContainers: // value for 'includeContainers'
 *      includeDemurrageAny: // value for 'includeDemurrageAny'
 *      includeDemurrage: // value for 'includeDemurrage'
 *      includeDemurrageCalculations: // value for 'includeDemurrageCalculations'
 *   },
 * });
 */
export function useGetShipmentImportDeclarationsTableRowsQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentImportDeclarationsTableRowsQuery, GetShipmentImportDeclarationsTableRowsQueryVariables> & ({ variables: GetShipmentImportDeclarationsTableRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentImportDeclarationsTableRowsQuery, GetShipmentImportDeclarationsTableRowsQueryVariables>(GetShipmentImportDeclarationsTableRowsDocument, options);
      }
export function useGetShipmentImportDeclarationsTableRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentImportDeclarationsTableRowsQuery, GetShipmentImportDeclarationsTableRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentImportDeclarationsTableRowsQuery, GetShipmentImportDeclarationsTableRowsQueryVariables>(GetShipmentImportDeclarationsTableRowsDocument, options);
        }
// @ts-ignore
export function useGetShipmentImportDeclarationsTableRowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetShipmentImportDeclarationsTableRowsQuery, GetShipmentImportDeclarationsTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetShipmentImportDeclarationsTableRowsQuery, GetShipmentImportDeclarationsTableRowsQueryVariables>;
export function useGetShipmentImportDeclarationsTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShipmentImportDeclarationsTableRowsQuery, GetShipmentImportDeclarationsTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetShipmentImportDeclarationsTableRowsQuery | undefined, GetShipmentImportDeclarationsTableRowsQueryVariables>;
export function useGetShipmentImportDeclarationsTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShipmentImportDeclarationsTableRowsQuery, GetShipmentImportDeclarationsTableRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShipmentImportDeclarationsTableRowsQuery, GetShipmentImportDeclarationsTableRowsQueryVariables>(GetShipmentImportDeclarationsTableRowsDocument, options);
        }
export type GetShipmentImportDeclarationsTableRowsQueryHookResult = ReturnType<typeof useGetShipmentImportDeclarationsTableRowsQuery>;
export type GetShipmentImportDeclarationsTableRowsLazyQueryHookResult = ReturnType<typeof useGetShipmentImportDeclarationsTableRowsLazyQuery>;
export type GetShipmentImportDeclarationsTableRowsSuspenseQueryHookResult = ReturnType<typeof useGetShipmentImportDeclarationsTableRowsSuspenseQuery>;
export type GetShipmentImportDeclarationsTableRowsQueryResult = Apollo.QueryResult<GetShipmentImportDeclarationsTableRowsQuery, GetShipmentImportDeclarationsTableRowsQueryVariables>;
export const GetShipmentImportLicensesTableRowsDocument = gql`
    query GetShipmentImportLicensesTableRows($search: String, $filters: FilterShipmentImportLicenseParams!, $pagination: ShipmentImportLicensePaginationParams, $pathFilters: JSON, $processFilters: FilterProcessParams, $includeDocuments: Boolean!, $includeProcessLeadTime: Boolean!, $includeProcessBrazilianInvoiceInfo: Boolean!, $includeVesselScheduleCalculatedDates: Boolean!, $includeShipmentDuimps: Boolean!, $includeShipmentExportDeclarations: Boolean!, $includeShipmentImportDeclarations: Boolean!, $includeShipmentImportLicenses: Boolean!, $includeContainers: Boolean!, $includeDemurrageAny: Boolean!, $includeDemurrage: Boolean!, $includeDemurrageCalculations: Boolean!) {
  shipmentImportLicensesPerProcessesCount(
    search: $search
    filters: $filters
    pathFilters: $pathFilters
    processFilters: $processFilters
  )
  shipmentImportLicensesPerProcesses(
    search: $search
    filters: $filters
    pagination: $pagination
    pathFilters: $pathFilters
    processFilters: $processFilters
  ) {
    shipmentImportLicense {
      id
      importLicense {
        id
        status
        statusResponse
        number
        registeredAt
        approvedAt
      }
    }
    process {
      ...ProcessesData
      foreignTradeShipment {
        ...DefaultForeignTradeShipmentData
        ...NationalRoadTranportsData
        ...ContainersData
        ...ItemsData
      }
    }
  }
}
    ${ProcessesDataFragmentDoc}
${DefaultForeignTradeShipmentDataFragmentDoc}
${NationalRoadTranportsDataFragmentDoc}
${ContainersDataFragmentDoc}
${ItemsDataFragmentDoc}`;

/**
 * __useGetShipmentImportLicensesTableRowsQuery__
 *
 * To run a query within a React component, call `useGetShipmentImportLicensesTableRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentImportLicensesTableRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentImportLicensesTableRowsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      pathFilters: // value for 'pathFilters'
 *      processFilters: // value for 'processFilters'
 *      includeDocuments: // value for 'includeDocuments'
 *      includeProcessLeadTime: // value for 'includeProcessLeadTime'
 *      includeProcessBrazilianInvoiceInfo: // value for 'includeProcessBrazilianInvoiceInfo'
 *      includeVesselScheduleCalculatedDates: // value for 'includeVesselScheduleCalculatedDates'
 *      includeShipmentDuimps: // value for 'includeShipmentDuimps'
 *      includeShipmentExportDeclarations: // value for 'includeShipmentExportDeclarations'
 *      includeShipmentImportDeclarations: // value for 'includeShipmentImportDeclarations'
 *      includeShipmentImportLicenses: // value for 'includeShipmentImportLicenses'
 *      includeContainers: // value for 'includeContainers'
 *      includeDemurrageAny: // value for 'includeDemurrageAny'
 *      includeDemurrage: // value for 'includeDemurrage'
 *      includeDemurrageCalculations: // value for 'includeDemurrageCalculations'
 *   },
 * });
 */
export function useGetShipmentImportLicensesTableRowsQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentImportLicensesTableRowsQuery, GetShipmentImportLicensesTableRowsQueryVariables> & ({ variables: GetShipmentImportLicensesTableRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentImportLicensesTableRowsQuery, GetShipmentImportLicensesTableRowsQueryVariables>(GetShipmentImportLicensesTableRowsDocument, options);
      }
export function useGetShipmentImportLicensesTableRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentImportLicensesTableRowsQuery, GetShipmentImportLicensesTableRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentImportLicensesTableRowsQuery, GetShipmentImportLicensesTableRowsQueryVariables>(GetShipmentImportLicensesTableRowsDocument, options);
        }
// @ts-ignore
export function useGetShipmentImportLicensesTableRowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetShipmentImportLicensesTableRowsQuery, GetShipmentImportLicensesTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetShipmentImportLicensesTableRowsQuery, GetShipmentImportLicensesTableRowsQueryVariables>;
export function useGetShipmentImportLicensesTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShipmentImportLicensesTableRowsQuery, GetShipmentImportLicensesTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetShipmentImportLicensesTableRowsQuery | undefined, GetShipmentImportLicensesTableRowsQueryVariables>;
export function useGetShipmentImportLicensesTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShipmentImportLicensesTableRowsQuery, GetShipmentImportLicensesTableRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShipmentImportLicensesTableRowsQuery, GetShipmentImportLicensesTableRowsQueryVariables>(GetShipmentImportLicensesTableRowsDocument, options);
        }
export type GetShipmentImportLicensesTableRowsQueryHookResult = ReturnType<typeof useGetShipmentImportLicensesTableRowsQuery>;
export type GetShipmentImportLicensesTableRowsLazyQueryHookResult = ReturnType<typeof useGetShipmentImportLicensesTableRowsLazyQuery>;
export type GetShipmentImportLicensesTableRowsSuspenseQueryHookResult = ReturnType<typeof useGetShipmentImportLicensesTableRowsSuspenseQuery>;
export type GetShipmentImportLicensesTableRowsQueryResult = Apollo.QueryResult<GetShipmentImportLicensesTableRowsQuery, GetShipmentImportLicensesTableRowsQueryVariables>;
export const GetShipmentItemsTableRowsDocument = gql`
    query GetShipmentItemsTableRows($search: String, $filters: FilterShipmentItemParams!, $pagination: ShipmentItemPaginationParams, $pathFilters: JSON, $processFilters: FilterProcessParams, $includeDocuments: Boolean!, $includeProcessLeadTime: Boolean!, $includeProcessBrazilianInvoiceInfo: Boolean!, $includeVesselScheduleCalculatedDates: Boolean!, $includeShipmentDuimps: Boolean!, $includeShipmentExportDeclarations: Boolean!, $includeShipmentImportDeclarations: Boolean!, $includeShipmentImportLicenses: Boolean!, $includeContainers: Boolean!, $includeDemurrageAny: Boolean!, $includeDemurrage: Boolean!, $includeDemurrageCalculations: Boolean!) {
  shipmentItemsCount(
    search: $search
    filters: $filters
    pathFilters: $pathFilters
    processFilters: $processFilters
  )
  shipmentItems(
    search: $search
    filters: $filters
    pagination: $pagination
    pathFilters: $pathFilters
    processFilters: $processFilters
  ) {
    foreignTradeItemShipment {
      ...ShipmentItemData
      transportables(containerHidden: false) {
        id
        container {
          ...LinkedContainersData
        }
      }
      salesOrderItem {
        id
        productTranslatedDescription
        lineNumber
        lineReference
        salesOrder {
          id
          order {
            id
            referenceCode
          }
        }
        product {
          id
          code
          translatedDescription
        }
      }
      purchaseOrderItem {
        id
        productTranslatedDescription
        lineNumber
        lineReference
        purchaseOrder {
          id
          order {
            id
            referenceCode
          }
        }
        product {
          id
          code
          translatedDescription
        }
      }
    }
    process {
      ...ProcessesData
      foreignTradeShipment {
        ...DefaultForeignTradeShipmentData
        ...NationalRoadTranportsData
        ...ContainersData
      }
    }
  }
}
    ${ShipmentItemDataFragmentDoc}
${LinkedContainersDataFragmentDoc}
${ProcessesDataFragmentDoc}
${DefaultForeignTradeShipmentDataFragmentDoc}
${NationalRoadTranportsDataFragmentDoc}
${ContainersDataFragmentDoc}`;

/**
 * __useGetShipmentItemsTableRowsQuery__
 *
 * To run a query within a React component, call `useGetShipmentItemsTableRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentItemsTableRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentItemsTableRowsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      pathFilters: // value for 'pathFilters'
 *      processFilters: // value for 'processFilters'
 *      includeDocuments: // value for 'includeDocuments'
 *      includeProcessLeadTime: // value for 'includeProcessLeadTime'
 *      includeProcessBrazilianInvoiceInfo: // value for 'includeProcessBrazilianInvoiceInfo'
 *      includeVesselScheduleCalculatedDates: // value for 'includeVesselScheduleCalculatedDates'
 *      includeShipmentDuimps: // value for 'includeShipmentDuimps'
 *      includeShipmentExportDeclarations: // value for 'includeShipmentExportDeclarations'
 *      includeShipmentImportDeclarations: // value for 'includeShipmentImportDeclarations'
 *      includeShipmentImportLicenses: // value for 'includeShipmentImportLicenses'
 *      includeContainers: // value for 'includeContainers'
 *      includeDemurrageAny: // value for 'includeDemurrageAny'
 *      includeDemurrage: // value for 'includeDemurrage'
 *      includeDemurrageCalculations: // value for 'includeDemurrageCalculations'
 *   },
 * });
 */
export function useGetShipmentItemsTableRowsQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentItemsTableRowsQuery, GetShipmentItemsTableRowsQueryVariables> & ({ variables: GetShipmentItemsTableRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentItemsTableRowsQuery, GetShipmentItemsTableRowsQueryVariables>(GetShipmentItemsTableRowsDocument, options);
      }
export function useGetShipmentItemsTableRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentItemsTableRowsQuery, GetShipmentItemsTableRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentItemsTableRowsQuery, GetShipmentItemsTableRowsQueryVariables>(GetShipmentItemsTableRowsDocument, options);
        }
// @ts-ignore
export function useGetShipmentItemsTableRowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetShipmentItemsTableRowsQuery, GetShipmentItemsTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetShipmentItemsTableRowsQuery, GetShipmentItemsTableRowsQueryVariables>;
export function useGetShipmentItemsTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShipmentItemsTableRowsQuery, GetShipmentItemsTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetShipmentItemsTableRowsQuery | undefined, GetShipmentItemsTableRowsQueryVariables>;
export function useGetShipmentItemsTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShipmentItemsTableRowsQuery, GetShipmentItemsTableRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShipmentItemsTableRowsQuery, GetShipmentItemsTableRowsQueryVariables>(GetShipmentItemsTableRowsDocument, options);
        }
export type GetShipmentItemsTableRowsQueryHookResult = ReturnType<typeof useGetShipmentItemsTableRowsQuery>;
export type GetShipmentItemsTableRowsLazyQueryHookResult = ReturnType<typeof useGetShipmentItemsTableRowsLazyQuery>;
export type GetShipmentItemsTableRowsSuspenseQueryHookResult = ReturnType<typeof useGetShipmentItemsTableRowsSuspenseQuery>;
export type GetShipmentItemsTableRowsQueryResult = Apollo.QueryResult<GetShipmentItemsTableRowsQuery, GetShipmentItemsTableRowsQueryVariables>;
export const GetShipmentItemsWithOrderItemsTableRowsDocument = gql`
    query GetShipmentItemsWithOrderItemsTableRows($search: String, $filters: FilterOrderItemParams!, $pagination: OrderItemPaginationParams, $pathFilters: JSON, $processFilters: FilterProcessParams, $orderFilters: FilterOrderParams, $includeDocuments: Boolean!, $includeProcessLeadTime: Boolean!, $includeProcessBrazilianInvoiceInfo: Boolean!, $includeVesselScheduleCalculatedDates: Boolean!, $includeShipmentDuimps: Boolean!, $includeShipmentExportDeclarations: Boolean!, $includeShipmentImportDeclarations: Boolean!, $includeShipmentImportLicenses: Boolean!, $includeContainers: Boolean!, $includeDemurrageAny: Boolean!, $includeDemurrage: Boolean!, $includeDemurrageCalculations: Boolean!) {
  shipmentItemsWithOrderItemsCount(
    search: $search
    filters: $filters
    pathFilters: $pathFilters
    processFilters: $processFilters
    orderFilters: $orderFilters
  )
  shipmentItemsWithOrderItems(
    search: $search
    filters: $filters
    pagination: $pagination
    pathFilters: $pathFilters
    processFilters: $processFilters
    orderFilters: $orderFilters
  ) {
    foreignTradeItemShipment {
      ...ShipmentItemData
      transportables(containerHidden: false) {
        id
        container {
          ...LinkedContainersData
        }
      }
    }
    salesOrderItem {
      id
      lineNumber
      lineReference
      quantity
      balance
      ...SalesOrderItemAdditionalFieldsFragment
      product {
        ...ProductFields
      }
    }
    purchaseOrderItem {
      id
      lineNumber
      lineReference
      quantity
      balance
      ...PurchaseOrderItemAdditionalFieldsFragment
      product {
        ...ProductFields
      }
    }
    process {
      ...ProcessesData
      foreignTradeShipment {
        ...DefaultForeignTradeShipmentData
        ...NationalRoadTranportsData
        ...ContainersData
      }
    }
    order {
      ...OrdersData
    }
  }
}
    ${ShipmentItemDataFragmentDoc}
${LinkedContainersDataFragmentDoc}
${SalesOrderItemAdditionalFieldsFragmentFragmentDoc}
${ProductFieldsFragmentDoc}
${PurchaseOrderItemAdditionalFieldsFragmentFragmentDoc}
${ProcessesDataFragmentDoc}
${DefaultForeignTradeShipmentDataFragmentDoc}
${NationalRoadTranportsDataFragmentDoc}
${ContainersDataFragmentDoc}
${OrdersDataFragmentDoc}`;

/**
 * __useGetShipmentItemsWithOrderItemsTableRowsQuery__
 *
 * To run a query within a React component, call `useGetShipmentItemsWithOrderItemsTableRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentItemsWithOrderItemsTableRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentItemsWithOrderItemsTableRowsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      pathFilters: // value for 'pathFilters'
 *      processFilters: // value for 'processFilters'
 *      orderFilters: // value for 'orderFilters'
 *      includeDocuments: // value for 'includeDocuments'
 *      includeProcessLeadTime: // value for 'includeProcessLeadTime'
 *      includeProcessBrazilianInvoiceInfo: // value for 'includeProcessBrazilianInvoiceInfo'
 *      includeVesselScheduleCalculatedDates: // value for 'includeVesselScheduleCalculatedDates'
 *      includeShipmentDuimps: // value for 'includeShipmentDuimps'
 *      includeShipmentExportDeclarations: // value for 'includeShipmentExportDeclarations'
 *      includeShipmentImportDeclarations: // value for 'includeShipmentImportDeclarations'
 *      includeShipmentImportLicenses: // value for 'includeShipmentImportLicenses'
 *      includeContainers: // value for 'includeContainers'
 *      includeDemurrageAny: // value for 'includeDemurrageAny'
 *      includeDemurrage: // value for 'includeDemurrage'
 *      includeDemurrageCalculations: // value for 'includeDemurrageCalculations'
 *   },
 * });
 */
export function useGetShipmentItemsWithOrderItemsTableRowsQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentItemsWithOrderItemsTableRowsQuery, GetShipmentItemsWithOrderItemsTableRowsQueryVariables> & ({ variables: GetShipmentItemsWithOrderItemsTableRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentItemsWithOrderItemsTableRowsQuery, GetShipmentItemsWithOrderItemsTableRowsQueryVariables>(GetShipmentItemsWithOrderItemsTableRowsDocument, options);
      }
export function useGetShipmentItemsWithOrderItemsTableRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentItemsWithOrderItemsTableRowsQuery, GetShipmentItemsWithOrderItemsTableRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentItemsWithOrderItemsTableRowsQuery, GetShipmentItemsWithOrderItemsTableRowsQueryVariables>(GetShipmentItemsWithOrderItemsTableRowsDocument, options);
        }
// @ts-ignore
export function useGetShipmentItemsWithOrderItemsTableRowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetShipmentItemsWithOrderItemsTableRowsQuery, GetShipmentItemsWithOrderItemsTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetShipmentItemsWithOrderItemsTableRowsQuery, GetShipmentItemsWithOrderItemsTableRowsQueryVariables>;
export function useGetShipmentItemsWithOrderItemsTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShipmentItemsWithOrderItemsTableRowsQuery, GetShipmentItemsWithOrderItemsTableRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetShipmentItemsWithOrderItemsTableRowsQuery | undefined, GetShipmentItemsWithOrderItemsTableRowsQueryVariables>;
export function useGetShipmentItemsWithOrderItemsTableRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShipmentItemsWithOrderItemsTableRowsQuery, GetShipmentItemsWithOrderItemsTableRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShipmentItemsWithOrderItemsTableRowsQuery, GetShipmentItemsWithOrderItemsTableRowsQueryVariables>(GetShipmentItemsWithOrderItemsTableRowsDocument, options);
        }
export type GetShipmentItemsWithOrderItemsTableRowsQueryHookResult = ReturnType<typeof useGetShipmentItemsWithOrderItemsTableRowsQuery>;
export type GetShipmentItemsWithOrderItemsTableRowsLazyQueryHookResult = ReturnType<typeof useGetShipmentItemsWithOrderItemsTableRowsLazyQuery>;
export type GetShipmentItemsWithOrderItemsTableRowsSuspenseQueryHookResult = ReturnType<typeof useGetShipmentItemsWithOrderItemsTableRowsSuspenseQuery>;
export type GetShipmentItemsWithOrderItemsTableRowsQueryResult = Apollo.QueryResult<GetShipmentItemsWithOrderItemsTableRowsQuery, GetShipmentItemsWithOrderItemsTableRowsQueryVariables>;
export const UpdateReportDocument = gql`
    mutation UpdateReport($id: Int!, $params: UpdateReportParams!) {
  updateReport(id: $id, params: $params) {
    id
    columns
  }
}
    `;
export type UpdateReportMutationFn = Apollo.MutationFunction<UpdateReportMutation, UpdateReportMutationVariables>;

/**
 * __useUpdateReportMutation__
 *
 * To run a mutation, you first call `useUpdateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportMutation, { data, loading, error }] = useUpdateReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportMutation, UpdateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportMutation, UpdateReportMutationVariables>(UpdateReportDocument, options);
      }
export type UpdateReportMutationHookResult = ReturnType<typeof useUpdateReportMutation>;
export type UpdateReportMutationResult = Apollo.MutationResult<UpdateReportMutation>;
export type UpdateReportMutationOptions = Apollo.BaseMutationOptions<UpdateReportMutation, UpdateReportMutationVariables>;
export const ReportGroupsDocument = gql`
    query ReportGroups($includeCostModels: Boolean!) {
  reportGroups {
    id
    name
    position
    reference
    operations {
      id
      title
      subType
      acceptHourInNationalRoadTransports
      configProps {
        showExternalReferenceCode
        isMultipleNationalRoadTransport
        orderItemAdditionalFields
      }
      operationHandlers {
        id
        role
        bindingType
        showBusinessUnit
        showReference
        showSecondaryReference
      }
      operationPhases {
        id
        position
        phase {
          id
          phase
        }
        components {
          id
          name
          slug
          props
          title
          position
          extraFieldsDefinition
        }
      }
      orderComponents {
        id
        name
        slug
        props
        title
        position
        extraFieldsDefinition
      }
      costModels @include(if: $includeCostModels) {
        id
        name
        hasPlannedCosts
        versions {
          id
          version
          rootModelExpenses {
            ...CostModelExpenseFieldsForReportGroups
            childrenModelExpenses {
              ...CostModelExpenseFieldsForReportGroups
              childrenModelExpenses {
                ...CostModelExpenseFieldsForReportGroups
              }
            }
          }
        }
      }
    }
    reportGroupAccess {
      id
      type
    }
    reports {
      id
      name
      position
      filters
      columns
      sorting
    }
  }
}
    ${CostModelExpenseFieldsForReportGroupsFragmentDoc}`;

/**
 * __useReportGroupsQuery__
 *
 * To run a query within a React component, call `useReportGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportGroupsQuery({
 *   variables: {
 *      includeCostModels: // value for 'includeCostModels'
 *   },
 * });
 */
export function useReportGroupsQuery(baseOptions: Apollo.QueryHookOptions<ReportGroupsQuery, ReportGroupsQueryVariables> & ({ variables: ReportGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportGroupsQuery, ReportGroupsQueryVariables>(ReportGroupsDocument, options);
      }
export function useReportGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportGroupsQuery, ReportGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportGroupsQuery, ReportGroupsQueryVariables>(ReportGroupsDocument, options);
        }
// @ts-ignore
export function useReportGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportGroupsQuery, ReportGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<ReportGroupsQuery, ReportGroupsQueryVariables>;
export function useReportGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportGroupsQuery, ReportGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<ReportGroupsQuery | undefined, ReportGroupsQueryVariables>;
export function useReportGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportGroupsQuery, ReportGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportGroupsQuery, ReportGroupsQueryVariables>(ReportGroupsDocument, options);
        }
export type ReportGroupsQueryHookResult = ReturnType<typeof useReportGroupsQuery>;
export type ReportGroupsLazyQueryHookResult = ReturnType<typeof useReportGroupsLazyQuery>;
export type ReportGroupsSuspenseQueryHookResult = ReturnType<typeof useReportGroupsSuspenseQuery>;
export type ReportGroupsQueryResult = Apollo.QueryResult<ReportGroupsQuery, ReportGroupsQueryVariables>;
export const GetQuickFiltersConfigsDocument = gql`
    query GetQuickFiltersConfigs($id: Int!) {
  operation(id: $id) {
    id
    quickFiltersConfigs {
      label
      path
    }
  }
}
    `;

/**
 * __useGetQuickFiltersConfigsQuery__
 *
 * To run a query within a React component, call `useGetQuickFiltersConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickFiltersConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickFiltersConfigsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuickFiltersConfigsQuery(baseOptions: Apollo.QueryHookOptions<GetQuickFiltersConfigsQuery, GetQuickFiltersConfigsQueryVariables> & ({ variables: GetQuickFiltersConfigsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickFiltersConfigsQuery, GetQuickFiltersConfigsQueryVariables>(GetQuickFiltersConfigsDocument, options);
      }
export function useGetQuickFiltersConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickFiltersConfigsQuery, GetQuickFiltersConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickFiltersConfigsQuery, GetQuickFiltersConfigsQueryVariables>(GetQuickFiltersConfigsDocument, options);
        }
// @ts-ignore
export function useGetQuickFiltersConfigsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuickFiltersConfigsQuery, GetQuickFiltersConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuickFiltersConfigsQuery, GetQuickFiltersConfigsQueryVariables>;
export function useGetQuickFiltersConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuickFiltersConfigsQuery, GetQuickFiltersConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuickFiltersConfigsQuery | undefined, GetQuickFiltersConfigsQueryVariables>;
export function useGetQuickFiltersConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuickFiltersConfigsQuery, GetQuickFiltersConfigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuickFiltersConfigsQuery, GetQuickFiltersConfigsQueryVariables>(GetQuickFiltersConfigsDocument, options);
        }
export type GetQuickFiltersConfigsQueryHookResult = ReturnType<typeof useGetQuickFiltersConfigsQuery>;
export type GetQuickFiltersConfigsLazyQueryHookResult = ReturnType<typeof useGetQuickFiltersConfigsLazyQuery>;
export type GetQuickFiltersConfigsSuspenseQueryHookResult = ReturnType<typeof useGetQuickFiltersConfigsSuspenseQuery>;
export type GetQuickFiltersConfigsQueryResult = Apollo.QueryResult<GetQuickFiltersConfigsQuery, GetQuickFiltersConfigsQueryVariables>;
export const GetAvailableQuickFiltersDocument = gql`
    query GetAvailableQuickFilters($id: Int!, $currentFilters: JSON, $search: String) {
  operation(id: $id) {
    id
    availableQuickFilters(currentFilters: $currentFilters, search: $search) {
      label
      path
      values {
        label
        value
      }
    }
  }
}
    `;

/**
 * __useGetAvailableQuickFiltersQuery__
 *
 * To run a query within a React component, call `useGetAvailableQuickFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableQuickFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableQuickFiltersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      currentFilters: // value for 'currentFilters'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAvailableQuickFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableQuickFiltersQuery, GetAvailableQuickFiltersQueryVariables> & ({ variables: GetAvailableQuickFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableQuickFiltersQuery, GetAvailableQuickFiltersQueryVariables>(GetAvailableQuickFiltersDocument, options);
      }
export function useGetAvailableQuickFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableQuickFiltersQuery, GetAvailableQuickFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableQuickFiltersQuery, GetAvailableQuickFiltersQueryVariables>(GetAvailableQuickFiltersDocument, options);
        }
// @ts-ignore
export function useGetAvailableQuickFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAvailableQuickFiltersQuery, GetAvailableQuickFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableQuickFiltersQuery, GetAvailableQuickFiltersQueryVariables>;
export function useGetAvailableQuickFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableQuickFiltersQuery, GetAvailableQuickFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableQuickFiltersQuery | undefined, GetAvailableQuickFiltersQueryVariables>;
export function useGetAvailableQuickFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableQuickFiltersQuery, GetAvailableQuickFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableQuickFiltersQuery, GetAvailableQuickFiltersQueryVariables>(GetAvailableQuickFiltersDocument, options);
        }
export type GetAvailableQuickFiltersQueryHookResult = ReturnType<typeof useGetAvailableQuickFiltersQuery>;
export type GetAvailableQuickFiltersLazyQueryHookResult = ReturnType<typeof useGetAvailableQuickFiltersLazyQuery>;
export type GetAvailableQuickFiltersSuspenseQueryHookResult = ReturnType<typeof useGetAvailableQuickFiltersSuspenseQuery>;
export type GetAvailableQuickFiltersQueryResult = Apollo.QueryResult<GetAvailableQuickFiltersQuery, GetAvailableQuickFiltersQueryVariables>;
export const GetOperationDocument = gql`
    query GetOperation($id: Int!) {
  operation(id: $id) {
    id
    title
    subtitle
    subType
    type
    acceptHourInNationalRoadTransports
    actor {
      id
    }
    configProps {
      internationalModal
    }
    cardConfig {
      id
      color
    }
    operationPhases {
      id
      position
      phase {
        id
        phase
        sortingLabel
        sortingOrder
        sortingPath
      }
    }
    operationAccess {
      id
      type
      canCreateProcesses
      canCreateOrders
      canSeeOrders
    }
  }
}
    `;

/**
 * __useGetOperationQuery__
 *
 * To run a query within a React component, call `useGetOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOperationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOperationQuery(baseOptions: Apollo.QueryHookOptions<GetOperationQuery, GetOperationQueryVariables> & ({ variables: GetOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOperationQuery, GetOperationQueryVariables>(GetOperationDocument, options);
      }
export function useGetOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOperationQuery, GetOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOperationQuery, GetOperationQueryVariables>(GetOperationDocument, options);
        }
// @ts-ignore
export function useGetOperationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOperationQuery, GetOperationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOperationQuery, GetOperationQueryVariables>;
export function useGetOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOperationQuery, GetOperationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOperationQuery | undefined, GetOperationQueryVariables>;
export function useGetOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOperationQuery, GetOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOperationQuery, GetOperationQueryVariables>(GetOperationDocument, options);
        }
export type GetOperationQueryHookResult = ReturnType<typeof useGetOperationQuery>;
export type GetOperationLazyQueryHookResult = ReturnType<typeof useGetOperationLazyQuery>;
export type GetOperationSuspenseQueryHookResult = ReturnType<typeof useGetOperationSuspenseQuery>;
export type GetOperationQueryResult = Apollo.QueryResult<GetOperationQuery, GetOperationQueryVariables>;
export const GetOperationOrdersDocument = gql`
    query GetOperationOrders($search: String, $filters: FilterOrderParams, $pagination: OrderPaginationParams, $pathFilters: JSON) {
  ordersCount(filters: $filters, search: $search, pathFilters: $pathFilters)
  orders(
    filters: $filters
    pagination: $pagination
    search: $search
    pathFilters: $pathFilters
  ) {
    id
    alertLevel
    referenceCode
    type
    customer: handler(role: CUSTOMER) {
      id
      partnership {
        id
        nicknameWithFallback
      }
    }
    supplier: handler(role: SUPPLIER) {
      id
      partnership {
        id
        nicknameWithFallback
      }
    }
    ownerHandler {
      id
      partnership {
        id
        nicknameWithFallback
      }
    }
    processes(filters: {status: [ONGOING, FINISHED]}) {
      id
      finishedAt
    }
  }
}
    `;

/**
 * __useGetOperationOrdersQuery__
 *
 * To run a query within a React component, call `useGetOperationOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOperationOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOperationOrdersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      pathFilters: // value for 'pathFilters'
 *   },
 * });
 */
export function useGetOperationOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetOperationOrdersQuery, GetOperationOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOperationOrdersQuery, GetOperationOrdersQueryVariables>(GetOperationOrdersDocument, options);
      }
export function useGetOperationOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOperationOrdersQuery, GetOperationOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOperationOrdersQuery, GetOperationOrdersQueryVariables>(GetOperationOrdersDocument, options);
        }
// @ts-ignore
export function useGetOperationOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOperationOrdersQuery, GetOperationOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOperationOrdersQuery, GetOperationOrdersQueryVariables>;
export function useGetOperationOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOperationOrdersQuery, GetOperationOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOperationOrdersQuery | undefined, GetOperationOrdersQueryVariables>;
export function useGetOperationOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOperationOrdersQuery, GetOperationOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOperationOrdersQuery, GetOperationOrdersQueryVariables>(GetOperationOrdersDocument, options);
        }
export type GetOperationOrdersQueryHookResult = ReturnType<typeof useGetOperationOrdersQuery>;
export type GetOperationOrdersLazyQueryHookResult = ReturnType<typeof useGetOperationOrdersLazyQuery>;
export type GetOperationOrdersSuspenseQueryHookResult = ReturnType<typeof useGetOperationOrdersSuspenseQuery>;
export type GetOperationOrdersQueryResult = Apollo.QueryResult<GetOperationOrdersQuery, GetOperationOrdersQueryVariables>;
export const GetPhaseOrdersDocument = gql`
    query GetPhaseOrders($phaseId: Int!, $filters: FilterOrderParams, $pagination: OrderPaginationParams, $search: String) {
  operationPhase(id: $phaseId) {
    id
    phase {
      id
      trigger {
        label
      }
    }
    ordersCount(filters: $filters, search: $search)
    orders(filters: $filters, pagination: $pagination, search: $search) {
      id
      alertLevel
      referenceCode
      currentPhase {
        id
        phase
      }
      checkpoints {
        label
        fulfilledItemsCount
        itemsCount
      }
      route {
        id
        name
      }
      ownerHandler {
        id
        actor {
          id
          nickname
        }
      }
      leadTimeDatetimeReference
      salesOrder {
        id
        items {
          id
          quantity
          lineNumber
          balance
          productTranslatedDescription
          product {
            id
            code
          }
        }
      }
      purchaseOrder {
        id
        supplierOrderAcceptedAt
        supplierOrderSentAt
        items {
          id
          quantity
          lineNumber
          balance
          productTranslatedDescription
          product {
            id
            code
          }
        }
      }
      roadTransportOrder {
        id
        type
        roadTransportShipments {
          id
          vehicle {
            id
            plate
          }
          shipmentDrivers {
            id
            driver {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPhaseOrdersQuery__
 *
 * To run a query within a React component, call `useGetPhaseOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhaseOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhaseOrdersQuery({
 *   variables: {
 *      phaseId: // value for 'phaseId'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPhaseOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetPhaseOrdersQuery, GetPhaseOrdersQueryVariables> & ({ variables: GetPhaseOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPhaseOrdersQuery, GetPhaseOrdersQueryVariables>(GetPhaseOrdersDocument, options);
      }
export function useGetPhaseOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPhaseOrdersQuery, GetPhaseOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPhaseOrdersQuery, GetPhaseOrdersQueryVariables>(GetPhaseOrdersDocument, options);
        }
// @ts-ignore
export function useGetPhaseOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPhaseOrdersQuery, GetPhaseOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetPhaseOrdersQuery, GetPhaseOrdersQueryVariables>;
export function useGetPhaseOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPhaseOrdersQuery, GetPhaseOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetPhaseOrdersQuery | undefined, GetPhaseOrdersQueryVariables>;
export function useGetPhaseOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPhaseOrdersQuery, GetPhaseOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPhaseOrdersQuery, GetPhaseOrdersQueryVariables>(GetPhaseOrdersDocument, options);
        }
export type GetPhaseOrdersQueryHookResult = ReturnType<typeof useGetPhaseOrdersQuery>;
export type GetPhaseOrdersLazyQueryHookResult = ReturnType<typeof useGetPhaseOrdersLazyQuery>;
export type GetPhaseOrdersSuspenseQueryHookResult = ReturnType<typeof useGetPhaseOrdersSuspenseQuery>;
export type GetPhaseOrdersQueryResult = Apollo.QueryResult<GetPhaseOrdersQuery, GetPhaseOrdersQueryVariables>;
export const GetPhaseProcessesDocument = gql`
    query GetPhaseProcesses($operationPhaseId: Int!, $filters: FilterProcessParams, $pagination: ProcessPaginationParams, $search: String, $pathFilters: JSON) {
  operationPhase(id: $operationPhaseId) {
    id
    phase {
      id
      trigger {
        label
      }
      phase
    }
    processesCount(pathFilters: $pathFilters, filters: $filters, search: $search)
    processes(
      pathFilters: $pathFilters
      filters: $filters
      pagination: $pagination
      search: $search
    ) {
      id
      alertLevel
      referenceCode
      cardInfo {
        title
        subtitle
        headerLeft
        headerRight
        panelType
        panelValue
        panelLabel
        color
      }
      checkpoints {
        label
        fulfilledItemsCount
        itemsCount
      }
      foreignTradeShipment {
        id
        type
      }
    }
  }
}
    `;

/**
 * __useGetPhaseProcessesQuery__
 *
 * To run a query within a React component, call `useGetPhaseProcessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhaseProcessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhaseProcessesQuery({
 *   variables: {
 *      operationPhaseId: // value for 'operationPhaseId'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *      pathFilters: // value for 'pathFilters'
 *   },
 * });
 */
export function useGetPhaseProcessesQuery(baseOptions: Apollo.QueryHookOptions<GetPhaseProcessesQuery, GetPhaseProcessesQueryVariables> & ({ variables: GetPhaseProcessesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPhaseProcessesQuery, GetPhaseProcessesQueryVariables>(GetPhaseProcessesDocument, options);
      }
export function useGetPhaseProcessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPhaseProcessesQuery, GetPhaseProcessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPhaseProcessesQuery, GetPhaseProcessesQueryVariables>(GetPhaseProcessesDocument, options);
        }
// @ts-ignore
export function useGetPhaseProcessesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPhaseProcessesQuery, GetPhaseProcessesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPhaseProcessesQuery, GetPhaseProcessesQueryVariables>;
export function useGetPhaseProcessesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPhaseProcessesQuery, GetPhaseProcessesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPhaseProcessesQuery | undefined, GetPhaseProcessesQueryVariables>;
export function useGetPhaseProcessesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPhaseProcessesQuery, GetPhaseProcessesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPhaseProcessesQuery, GetPhaseProcessesQueryVariables>(GetPhaseProcessesDocument, options);
        }
export type GetPhaseProcessesQueryHookResult = ReturnType<typeof useGetPhaseProcessesQuery>;
export type GetPhaseProcessesLazyQueryHookResult = ReturnType<typeof useGetPhaseProcessesLazyQuery>;
export type GetPhaseProcessesSuspenseQueryHookResult = ReturnType<typeof useGetPhaseProcessesSuspenseQuery>;
export type GetPhaseProcessesQueryResult = Apollo.QueryResult<GetPhaseProcessesQuery, GetPhaseProcessesQueryVariables>;
export const ListAddressesDocument = gql`
    query ListAddresses($filters: FilterAddressesParams) {
  addresses(filters: $filters) {
    id
    city
    country
    latitude
    longitude
    name
    number
    postalCode
    state
    street
    neighborhood
    actor {
      id
      nickname
      partnershipAsPartner {
        id
        nicknameWithFallback
      }
    }
  }
}
    `;

/**
 * __useListAddressesQuery__
 *
 * To run a query within a React component, call `useListAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAddressesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListAddressesQuery(baseOptions?: Apollo.QueryHookOptions<ListAddressesQuery, ListAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAddressesQuery, ListAddressesQueryVariables>(ListAddressesDocument, options);
      }
export function useListAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAddressesQuery, ListAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAddressesQuery, ListAddressesQueryVariables>(ListAddressesDocument, options);
        }
// @ts-ignore
export function useListAddressesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAddressesQuery, ListAddressesQueryVariables>): Apollo.UseSuspenseQueryResult<ListAddressesQuery, ListAddressesQueryVariables>;
export function useListAddressesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAddressesQuery, ListAddressesQueryVariables>): Apollo.UseSuspenseQueryResult<ListAddressesQuery | undefined, ListAddressesQueryVariables>;
export function useListAddressesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAddressesQuery, ListAddressesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAddressesQuery, ListAddressesQueryVariables>(ListAddressesDocument, options);
        }
export type ListAddressesQueryHookResult = ReturnType<typeof useListAddressesQuery>;
export type ListAddressesLazyQueryHookResult = ReturnType<typeof useListAddressesLazyQuery>;
export type ListAddressesSuspenseQueryHookResult = ReturnType<typeof useListAddressesSuspenseQuery>;
export type ListAddressesQueryResult = Apollo.QueryResult<ListAddressesQuery, ListAddressesQueryVariables>;
export const OrdersDocument = gql`
    subscription Orders($operationId: Int!) {
  orders(operationId: $operationId) {
    data {
      id
    }
  }
}
    `;

/**
 * __useOrdersSubscription__
 *
 * To run a query within a React component, call `useOrdersSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOrdersSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersSubscription({
 *   variables: {
 *      operationId: // value for 'operationId'
 *   },
 * });
 */
export function useOrdersSubscription(baseOptions: Apollo.SubscriptionHookOptions<OrdersSubscription, OrdersSubscriptionVariables> & ({ variables: OrdersSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OrdersSubscription, OrdersSubscriptionVariables>(OrdersDocument, options);
      }
export type OrdersSubscriptionHookResult = ReturnType<typeof useOrdersSubscription>;
export type OrdersSubscriptionResult = Apollo.SubscriptionResult<OrdersSubscription>;
export const ProcessesDocument = gql`
    subscription Processes($operationId: Int!) {
  processes(operationId: $operationId) {
    data {
      id
      currentPhase {
        id
      }
      previousPhase {
        id
      }
    }
  }
}
    `;

/**
 * __useProcessesSubscription__
 *
 * To run a query within a React component, call `useProcessesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProcessesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessesSubscription({
 *   variables: {
 *      operationId: // value for 'operationId'
 *   },
 * });
 */
export function useProcessesSubscription(baseOptions: Apollo.SubscriptionHookOptions<ProcessesSubscription, ProcessesSubscriptionVariables> & ({ variables: ProcessesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ProcessesSubscription, ProcessesSubscriptionVariables>(ProcessesDocument, options);
      }
export type ProcessesSubscriptionHookResult = ReturnType<typeof useProcessesSubscription>;
export type ProcessesSubscriptionResult = Apollo.SubscriptionResult<ProcessesSubscription>;
export const GetOperationFieldsDocument = gql`
    query GetOperationFields($operationId: Int!, $includeOptions: Boolean!) {
  operation(id: $operationId) {
    id
    processesFields {
      label
      path
      type
      isList
      options @include(if: $includeOptions) {
        label
        value
      }
    }
    ordersFields {
      label
      path
      type
      isList
      options @include(if: $includeOptions) {
        label
        value
      }
    }
  }
}
    `;

/**
 * __useGetOperationFieldsQuery__
 *
 * To run a query within a React component, call `useGetOperationFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOperationFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOperationFieldsQuery({
 *   variables: {
 *      operationId: // value for 'operationId'
 *      includeOptions: // value for 'includeOptions'
 *   },
 * });
 */
export function useGetOperationFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetOperationFieldsQuery, GetOperationFieldsQueryVariables> & ({ variables: GetOperationFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOperationFieldsQuery, GetOperationFieldsQueryVariables>(GetOperationFieldsDocument, options);
      }
export function useGetOperationFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOperationFieldsQuery, GetOperationFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOperationFieldsQuery, GetOperationFieldsQueryVariables>(GetOperationFieldsDocument, options);
        }
// @ts-ignore
export function useGetOperationFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOperationFieldsQuery, GetOperationFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOperationFieldsQuery, GetOperationFieldsQueryVariables>;
export function useGetOperationFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOperationFieldsQuery, GetOperationFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOperationFieldsQuery | undefined, GetOperationFieldsQueryVariables>;
export function useGetOperationFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOperationFieldsQuery, GetOperationFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOperationFieldsQuery, GetOperationFieldsQueryVariables>(GetOperationFieldsDocument, options);
        }
export type GetOperationFieldsQueryHookResult = ReturnType<typeof useGetOperationFieldsQuery>;
export type GetOperationFieldsLazyQueryHookResult = ReturnType<typeof useGetOperationFieldsLazyQuery>;
export type GetOperationFieldsSuspenseQueryHookResult = ReturnType<typeof useGetOperationFieldsSuspenseQuery>;
export type GetOperationFieldsQueryResult = Apollo.QueryResult<GetOperationFieldsQuery, GetOperationFieldsQueryVariables>;
export const ProductsDocument = gql`
    query Products($search: String, $pagination: ProductPaginationParams) {
  products(search: $search, pagination: $pagination) {
    id
    additionalDetails
    c9Ratio
    category
    code
    contentCapacity
    contentCode
    contentMeasurementUnit
    contentPerPallet
    contentType
    cubagePerPackage
    description
    dumping
    extra
    family
    grossWeightPerPackage
    manufacturer
    mercosulCode
    multipleCode
    multiplePackageCapacity
    multiplePackageMeasurementUnit
    multiplePackagePerContainerFt20
    multiplePackagePerContainerFt40
    multiplePackagePerPallet
    multiplePackageType
    netWeightPerPackage
    packageCapacity
    packageCode
    packageMeasurementUnit
    packagesPerContainerFt20
    packagesPerContainerFt40
    packagesPerPallet
    packageType
    palletsPerContainerFt20
    palletsPerContainerFt40
    translatedDescription
    actor {
      id
      nickname
    }
    country {
      code
    }
    internalCodes {
      id
      code
      label
    }
    productForeignOperators {
      id
      nickname
      partnershipAsPartner {
        id
        nicknameWithFallback
      }
    }
  }
}
    `;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useProductsQuery(baseOptions?: Apollo.QueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
      }
export function useProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
// @ts-ignore
export function useProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductsQuery, ProductsQueryVariables>): Apollo.UseSuspenseQueryResult<ProductsQuery, ProductsQueryVariables>;
export function useProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductsQuery, ProductsQueryVariables>): Apollo.UseSuspenseQueryResult<ProductsQuery | undefined, ProductsQueryVariables>;
export function useProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryHookResult = ReturnType<typeof useProductsLazyQuery>;
export type ProductsSuspenseQueryHookResult = ReturnType<typeof useProductsSuspenseQuery>;
export type ProductsQueryResult = Apollo.QueryResult<ProductsQuery, ProductsQueryVariables>;
export const ProductsCountDocument = gql`
    query ProductsCount($search: String) {
  productsCount(search: $search)
}
    `;

/**
 * __useProductsCountQuery__
 *
 * To run a query within a React component, call `useProductsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsCountQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useProductsCountQuery(baseOptions?: Apollo.QueryHookOptions<ProductsCountQuery, ProductsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsCountQuery, ProductsCountQueryVariables>(ProductsCountDocument, options);
      }
export function useProductsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsCountQuery, ProductsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsCountQuery, ProductsCountQueryVariables>(ProductsCountDocument, options);
        }
// @ts-ignore
export function useProductsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductsCountQuery, ProductsCountQueryVariables>): Apollo.UseSuspenseQueryResult<ProductsCountQuery, ProductsCountQueryVariables>;
export function useProductsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductsCountQuery, ProductsCountQueryVariables>): Apollo.UseSuspenseQueryResult<ProductsCountQuery | undefined, ProductsCountQueryVariables>;
export function useProductsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductsCountQuery, ProductsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductsCountQuery, ProductsCountQueryVariables>(ProductsCountDocument, options);
        }
export type ProductsCountQueryHookResult = ReturnType<typeof useProductsCountQuery>;
export type ProductsCountLazyQueryHookResult = ReturnType<typeof useProductsCountLazyQuery>;
export type ProductsCountSuspenseQueryHookResult = ReturnType<typeof useProductsCountSuspenseQuery>;
export type ProductsCountQueryResult = Apollo.QueryResult<ProductsCountQuery, ProductsCountQueryVariables>;
export const CreateProductDocument = gql`
    mutation CreateProduct($params: CreateProductParams!) {
  createProduct(params: $params) {
    id
  }
}
    `;
export type CreateProductMutationFn = Apollo.MutationFunction<CreateProductMutation, CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, options);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<CreateProductMutation, CreateProductMutationVariables>;
export const DeleteProductDocument = gql`
    mutation DeleteProduct($id: Int!) {
  deleteProduct(id: $id) {
    id
  }
}
    `;
export type DeleteProductMutationFn = Apollo.MutationFunction<DeleteProductMutation, DeleteProductMutationVariables>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductMutation, DeleteProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductMutation, DeleteProductMutationVariables>(DeleteProductDocument, options);
      }
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = Apollo.MutationResult<DeleteProductMutation>;
export type DeleteProductMutationOptions = Apollo.BaseMutationOptions<DeleteProductMutation, DeleteProductMutationVariables>;
export const ProductDocument = gql`
    query Product($id: Int!) {
  product(id: $id) {
    id
    siscomexLastSyncType
    lastSyncErrorMessage
    siscomexProduct {
      id
      ncmCode
      description
      lastUpdatedAt
      insertedAt
    }
    additionalDetails
    c9Ratio
    category
    code
    contentCapacity
    contentCode
    contentMeasurementUnit
    contentPerPallet
    contentType
    cubagePerPackage
    description
    dumping
    family
    grossWeightPerPackage
    manufacturer
    mercosulCode
    multipleCode
    multiplePackageCapacity
    multiplePackageMeasurementUnit
    multiplePackagePerContainerFt20
    multiplePackagePerContainerFt40
    multiplePackagePerPallet
    multiplePackageType
    netWeightPerPackage
    packageCapacity
    packageCode
    packageMeasurementUnit
    packagesPerContainerFt20
    packagesPerContainerFt40
    packagesPerPallet
    packageType
    palletsPerContainerFt20
    palletsPerContainerFt40
    translatedDescription
    translatedDescriptions
    hasContainerization
    hasContent
    hasPalletization
    hasUnitization
    actor {
      id
      rootCnpjs
    }
    country {
      code
      iso3
    }
    internalCodes {
      id
      code
      label
    }
    productForeignOperators {
      id
      nickname
      officialName
      officialDocument
      openingDate
      partnershipAsPartner {
        id
        nicknameWithFallback
      }
    }
  }
}
    `;

/**
 * __useProductQuery__
 *
 * To run a query within a React component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductQuery(baseOptions: Apollo.QueryHookOptions<ProductQuery, ProductQueryVariables> & ({ variables: ProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
      }
export function useProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductQuery, ProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
        }
// @ts-ignore
export function useProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductQuery, ProductQueryVariables>): Apollo.UseSuspenseQueryResult<ProductQuery, ProductQueryVariables>;
export function useProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductQuery, ProductQueryVariables>): Apollo.UseSuspenseQueryResult<ProductQuery | undefined, ProductQueryVariables>;
export function useProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductQuery, ProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
        }
export type ProductQueryHookResult = ReturnType<typeof useProductQuery>;
export type ProductLazyQueryHookResult = ReturnType<typeof useProductLazyQuery>;
export type ProductSuspenseQueryHookResult = ReturnType<typeof useProductSuspenseQuery>;
export type ProductQueryResult = Apollo.QueryResult<ProductQuery, ProductQueryVariables>;
export const ProductsListActorsDocument = gql`
    query ProductsListActors($pagination: ActorPaginationParams) {
  actors(pagination: $pagination, filters: {hideOwnerActor: true}) {
    id
    nickname
    partnershipAsPartner {
      id
      nicknameWithFallback
    }
  }
}
    `;

/**
 * __useProductsListActorsQuery__
 *
 * To run a query within a React component, call `useProductsListActorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsListActorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsListActorsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useProductsListActorsQuery(baseOptions?: Apollo.QueryHookOptions<ProductsListActorsQuery, ProductsListActorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsListActorsQuery, ProductsListActorsQueryVariables>(ProductsListActorsDocument, options);
      }
export function useProductsListActorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsListActorsQuery, ProductsListActorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsListActorsQuery, ProductsListActorsQueryVariables>(ProductsListActorsDocument, options);
        }
// @ts-ignore
export function useProductsListActorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductsListActorsQuery, ProductsListActorsQueryVariables>): Apollo.UseSuspenseQueryResult<ProductsListActorsQuery, ProductsListActorsQueryVariables>;
export function useProductsListActorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductsListActorsQuery, ProductsListActorsQueryVariables>): Apollo.UseSuspenseQueryResult<ProductsListActorsQuery | undefined, ProductsListActorsQueryVariables>;
export function useProductsListActorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductsListActorsQuery, ProductsListActorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductsListActorsQuery, ProductsListActorsQueryVariables>(ProductsListActorsDocument, options);
        }
export type ProductsListActorsQueryHookResult = ReturnType<typeof useProductsListActorsQuery>;
export type ProductsListActorsLazyQueryHookResult = ReturnType<typeof useProductsListActorsLazyQuery>;
export type ProductsListActorsSuspenseQueryHookResult = ReturnType<typeof useProductsListActorsSuspenseQuery>;
export type ProductsListActorsQueryResult = Apollo.QueryResult<ProductsListActorsQuery, ProductsListActorsQueryVariables>;
export const ProductSiscomexSyncDocument = gql`
    subscription ProductSiscomexSync($id: Int!) {
  productSiscomexSyncSubscription(id: $id) {
    data {
      id
      siscomexLastSyncType
      lastSyncErrorMessage
      siscomexProduct {
        id
        ncmCode
        description
        lastUpdatedAt
        insertedAt
      }
    }
  }
}
    `;

/**
 * __useProductSiscomexSyncSubscription__
 *
 * To run a query within a React component, call `useProductSiscomexSyncSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProductSiscomexSyncSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSiscomexSyncSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductSiscomexSyncSubscription(baseOptions: Apollo.SubscriptionHookOptions<ProductSiscomexSyncSubscription, ProductSiscomexSyncSubscriptionVariables> & ({ variables: ProductSiscomexSyncSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ProductSiscomexSyncSubscription, ProductSiscomexSyncSubscriptionVariables>(ProductSiscomexSyncDocument, options);
      }
export type ProductSiscomexSyncSubscriptionHookResult = ReturnType<typeof useProductSiscomexSyncSubscription>;
export type ProductSiscomexSyncSubscriptionResult = Apollo.SubscriptionResult<ProductSiscomexSyncSubscription>;
export const TriggerProductSyncDocument = gql`
    mutation TriggerProductSync($id: Int!) {
  triggerProductSync(id: $id) {
    syncing
  }
}
    `;
export type TriggerProductSyncMutationFn = Apollo.MutationFunction<TriggerProductSyncMutation, TriggerProductSyncMutationVariables>;

/**
 * __useTriggerProductSyncMutation__
 *
 * To run a mutation, you first call `useTriggerProductSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerProductSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerProductSyncMutation, { data, loading, error }] = useTriggerProductSyncMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTriggerProductSyncMutation(baseOptions?: Apollo.MutationHookOptions<TriggerProductSyncMutation, TriggerProductSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerProductSyncMutation, TriggerProductSyncMutationVariables>(TriggerProductSyncDocument, options);
      }
export type TriggerProductSyncMutationHookResult = ReturnType<typeof useTriggerProductSyncMutation>;
export type TriggerProductSyncMutationResult = Apollo.MutationResult<TriggerProductSyncMutation>;
export type TriggerProductSyncMutationOptions = Apollo.BaseMutationOptions<TriggerProductSyncMutation, TriggerProductSyncMutationVariables>;
export const UpdateProductDocument = gql`
    mutation UpdateProduct($id: Int!, $params: UpdateProductParams!) {
  updateProduct(id: $id, params: $params) {
    id
  }
}
    `;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const CountRoutesDocument = gql`
    query CountRoutes($search: String) {
  routesCount(search: $search)
}
    `;

/**
 * __useCountRoutesQuery__
 *
 * To run a query within a React component, call `useCountRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountRoutesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCountRoutesQuery(baseOptions?: Apollo.QueryHookOptions<CountRoutesQuery, CountRoutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountRoutesQuery, CountRoutesQueryVariables>(CountRoutesDocument, options);
      }
export function useCountRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountRoutesQuery, CountRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountRoutesQuery, CountRoutesQueryVariables>(CountRoutesDocument, options);
        }
// @ts-ignore
export function useCountRoutesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountRoutesQuery, CountRoutesQueryVariables>): Apollo.UseSuspenseQueryResult<CountRoutesQuery, CountRoutesQueryVariables>;
export function useCountRoutesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountRoutesQuery, CountRoutesQueryVariables>): Apollo.UseSuspenseQueryResult<CountRoutesQuery | undefined, CountRoutesQueryVariables>;
export function useCountRoutesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountRoutesQuery, CountRoutesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountRoutesQuery, CountRoutesQueryVariables>(CountRoutesDocument, options);
        }
export type CountRoutesQueryHookResult = ReturnType<typeof useCountRoutesQuery>;
export type CountRoutesLazyQueryHookResult = ReturnType<typeof useCountRoutesLazyQuery>;
export type CountRoutesSuspenseQueryHookResult = ReturnType<typeof useCountRoutesSuspenseQuery>;
export type CountRoutesQueryResult = Apollo.QueryResult<CountRoutesQuery, CountRoutesQueryVariables>;
export const CreateRouteDocument = gql`
    mutation CreateRoute($params: CreateRouteParams!) {
  createRoute(params: $params) {
    id
  }
}
    `;
export type CreateRouteMutationFn = Apollo.MutationFunction<CreateRouteMutation, CreateRouteMutationVariables>;

/**
 * __useCreateRouteMutation__
 *
 * To run a mutation, you first call `useCreateRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRouteMutation, { data, loading, error }] = useCreateRouteMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateRouteMutation(baseOptions?: Apollo.MutationHookOptions<CreateRouteMutation, CreateRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRouteMutation, CreateRouteMutationVariables>(CreateRouteDocument, options);
      }
export type CreateRouteMutationHookResult = ReturnType<typeof useCreateRouteMutation>;
export type CreateRouteMutationResult = Apollo.MutationResult<CreateRouteMutation>;
export type CreateRouteMutationOptions = Apollo.BaseMutationOptions<CreateRouteMutation, CreateRouteMutationVariables>;
export const DeleteRouteDocument = gql`
    mutation DeleteRoute($id: Int!) {
  deleteRoute(id: $id) {
    id
  }
}
    `;
export type DeleteRouteMutationFn = Apollo.MutationFunction<DeleteRouteMutation, DeleteRouteMutationVariables>;

/**
 * __useDeleteRouteMutation__
 *
 * To run a mutation, you first call `useDeleteRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRouteMutation, { data, loading, error }] = useDeleteRouteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRouteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRouteMutation, DeleteRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRouteMutation, DeleteRouteMutationVariables>(DeleteRouteDocument, options);
      }
export type DeleteRouteMutationHookResult = ReturnType<typeof useDeleteRouteMutation>;
export type DeleteRouteMutationResult = Apollo.MutationResult<DeleteRouteMutation>;
export type DeleteRouteMutationOptions = Apollo.BaseMutationOptions<DeleteRouteMutation, DeleteRouteMutationVariables>;
export const RouteDocument = gql`
    query Route($id: Int!) {
  route(id: $id) {
    id
    name
    active
    points {
      id
      address {
        city
        complement
        country
        id
        latitude
        longitude
        neighborhood
        name
        number
        postalCode
        reference
        state
        street
      }
      position
      routeType
    }
  }
}
    `;

/**
 * __useRouteQuery__
 *
 * To run a query within a React component, call `useRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRouteQuery(baseOptions: Apollo.QueryHookOptions<RouteQuery, RouteQueryVariables> & ({ variables: RouteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RouteQuery, RouteQueryVariables>(RouteDocument, options);
      }
export function useRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RouteQuery, RouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RouteQuery, RouteQueryVariables>(RouteDocument, options);
        }
// @ts-ignore
export function useRouteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RouteQuery, RouteQueryVariables>): Apollo.UseSuspenseQueryResult<RouteQuery, RouteQueryVariables>;
export function useRouteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RouteQuery, RouteQueryVariables>): Apollo.UseSuspenseQueryResult<RouteQuery | undefined, RouteQueryVariables>;
export function useRouteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RouteQuery, RouteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RouteQuery, RouteQueryVariables>(RouteDocument, options);
        }
export type RouteQueryHookResult = ReturnType<typeof useRouteQuery>;
export type RouteLazyQueryHookResult = ReturnType<typeof useRouteLazyQuery>;
export type RouteSuspenseQueryHookResult = ReturnType<typeof useRouteSuspenseQuery>;
export type RouteQueryResult = Apollo.QueryResult<RouteQuery, RouteQueryVariables>;
export const ListRoutesDocument = gql`
    query ListRoutes($search: String, $pagination: RoutePaginationParams, $filters: FilterRoutesParams) {
  routes(search: $search, pagination: $pagination, filters: $filters) {
    id
    name
    active
    points {
      id
      position
      routeType
      address {
        id
        name
        formattedAddress
      }
    }
  }
}
    `;

/**
 * __useListRoutesQuery__
 *
 * To run a query within a React component, call `useListRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRoutesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListRoutesQuery(baseOptions?: Apollo.QueryHookOptions<ListRoutesQuery, ListRoutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListRoutesQuery, ListRoutesQueryVariables>(ListRoutesDocument, options);
      }
export function useListRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListRoutesQuery, ListRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListRoutesQuery, ListRoutesQueryVariables>(ListRoutesDocument, options);
        }
// @ts-ignore
export function useListRoutesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListRoutesQuery, ListRoutesQueryVariables>): Apollo.UseSuspenseQueryResult<ListRoutesQuery, ListRoutesQueryVariables>;
export function useListRoutesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListRoutesQuery, ListRoutesQueryVariables>): Apollo.UseSuspenseQueryResult<ListRoutesQuery | undefined, ListRoutesQueryVariables>;
export function useListRoutesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListRoutesQuery, ListRoutesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListRoutesQuery, ListRoutesQueryVariables>(ListRoutesDocument, options);
        }
export type ListRoutesQueryHookResult = ReturnType<typeof useListRoutesQuery>;
export type ListRoutesLazyQueryHookResult = ReturnType<typeof useListRoutesLazyQuery>;
export type ListRoutesSuspenseQueryHookResult = ReturnType<typeof useListRoutesSuspenseQuery>;
export type ListRoutesQueryResult = Apollo.QueryResult<ListRoutesQuery, ListRoutesQueryVariables>;
export const UpdateRouteDocument = gql`
    mutation UpdateRoute($id: Int!, $params: UpdateRouteParams!) {
  updateRoute(id: $id, params: $params) {
    id
  }
}
    `;
export type UpdateRouteMutationFn = Apollo.MutationFunction<UpdateRouteMutation, UpdateRouteMutationVariables>;

/**
 * __useUpdateRouteMutation__
 *
 * To run a mutation, you first call `useUpdateRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRouteMutation, { data, loading, error }] = useUpdateRouteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateRouteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRouteMutation, UpdateRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRouteMutation, UpdateRouteMutationVariables>(UpdateRouteDocument, options);
      }
export type UpdateRouteMutationHookResult = ReturnType<typeof useUpdateRouteMutation>;
export type UpdateRouteMutationResult = Apollo.MutationResult<UpdateRouteMutation>;
export type UpdateRouteMutationOptions = Apollo.BaseMutationOptions<UpdateRouteMutation, UpdateRouteMutationVariables>;
export const GetCurrentUserWorkspaceDocument = gql`
    query GetCurrentUserWorkspace {
  currentUser {
    id
    workspaces {
      client {
        id
        actor {
          id
          nickname
        }
      }
      accessGroups {
        id
        name
        slug
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserWorkspaceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserWorkspaceQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserWorkspaceQuery, GetCurrentUserWorkspaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserWorkspaceQuery, GetCurrentUserWorkspaceQueryVariables>(GetCurrentUserWorkspaceDocument, options);
      }
export function useGetCurrentUserWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserWorkspaceQuery, GetCurrentUserWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserWorkspaceQuery, GetCurrentUserWorkspaceQueryVariables>(GetCurrentUserWorkspaceDocument, options);
        }
// @ts-ignore
export function useGetCurrentUserWorkspaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserWorkspaceQuery, GetCurrentUserWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserWorkspaceQuery, GetCurrentUserWorkspaceQueryVariables>;
export function useGetCurrentUserWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserWorkspaceQuery, GetCurrentUserWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserWorkspaceQuery | undefined, GetCurrentUserWorkspaceQueryVariables>;
export function useGetCurrentUserWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserWorkspaceQuery, GetCurrentUserWorkspaceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserWorkspaceQuery, GetCurrentUserWorkspaceQueryVariables>(GetCurrentUserWorkspaceDocument, options);
        }
export type GetCurrentUserWorkspaceQueryHookResult = ReturnType<typeof useGetCurrentUserWorkspaceQuery>;
export type GetCurrentUserWorkspaceLazyQueryHookResult = ReturnType<typeof useGetCurrentUserWorkspaceLazyQuery>;
export type GetCurrentUserWorkspaceSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserWorkspaceSuspenseQuery>;
export type GetCurrentUserWorkspaceQueryResult = Apollo.QueryResult<GetCurrentUserWorkspaceQuery, GetCurrentUserWorkspaceQueryVariables>;
export const CreateCredentialDocument = gql`
    mutation CreateCredential($params: CreateCredentialParams!) {
  createCredential(params: $params) {
    id
  }
}
    `;
export type CreateCredentialMutationFn = Apollo.MutationFunction<CreateCredentialMutation, CreateCredentialMutationVariables>;

/**
 * __useCreateCredentialMutation__
 *
 * To run a mutation, you first call `useCreateCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCredentialMutation, { data, loading, error }] = useCreateCredentialMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateCredentialMutation(baseOptions?: Apollo.MutationHookOptions<CreateCredentialMutation, CreateCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCredentialMutation, CreateCredentialMutationVariables>(CreateCredentialDocument, options);
      }
export type CreateCredentialMutationHookResult = ReturnType<typeof useCreateCredentialMutation>;
export type CreateCredentialMutationResult = Apollo.MutationResult<CreateCredentialMutation>;
export type CreateCredentialMutationOptions = Apollo.BaseMutationOptions<CreateCredentialMutation, CreateCredentialMutationVariables>;
export const DeleteCredentialDocument = gql`
    mutation DeleteCredential($id: Int!) {
  deleteCredential(id: $id) {
    id
  }
}
    `;
export type DeleteCredentialMutationFn = Apollo.MutationFunction<DeleteCredentialMutation, DeleteCredentialMutationVariables>;

/**
 * __useDeleteCredentialMutation__
 *
 * To run a mutation, you first call `useDeleteCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCredentialMutation, { data, loading, error }] = useDeleteCredentialMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCredentialMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCredentialMutation, DeleteCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCredentialMutation, DeleteCredentialMutationVariables>(DeleteCredentialDocument, options);
      }
export type DeleteCredentialMutationHookResult = ReturnType<typeof useDeleteCredentialMutation>;
export type DeleteCredentialMutationResult = Apollo.MutationResult<DeleteCredentialMutation>;
export type DeleteCredentialMutationOptions = Apollo.BaseMutationOptions<DeleteCredentialMutation, DeleteCredentialMutationVariables>;
export const GetCredentialDocument = gql`
    query GetCredential($id: Int!) {
  credential(id: $id) {
    id
    name
    partnerships {
      id
      partner {
        id
        nickname
      }
    }
  }
}
    `;

/**
 * __useGetCredentialQuery__
 *
 * To run a query within a React component, call `useGetCredentialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCredentialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCredentialQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCredentialQuery(baseOptions: Apollo.QueryHookOptions<GetCredentialQuery, GetCredentialQueryVariables> & ({ variables: GetCredentialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCredentialQuery, GetCredentialQueryVariables>(GetCredentialDocument, options);
      }
export function useGetCredentialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCredentialQuery, GetCredentialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCredentialQuery, GetCredentialQueryVariables>(GetCredentialDocument, options);
        }
// @ts-ignore
export function useGetCredentialSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCredentialQuery, GetCredentialQueryVariables>): Apollo.UseSuspenseQueryResult<GetCredentialQuery, GetCredentialQueryVariables>;
export function useGetCredentialSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCredentialQuery, GetCredentialQueryVariables>): Apollo.UseSuspenseQueryResult<GetCredentialQuery | undefined, GetCredentialQueryVariables>;
export function useGetCredentialSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCredentialQuery, GetCredentialQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCredentialQuery, GetCredentialQueryVariables>(GetCredentialDocument, options);
        }
export type GetCredentialQueryHookResult = ReturnType<typeof useGetCredentialQuery>;
export type GetCredentialLazyQueryHookResult = ReturnType<typeof useGetCredentialLazyQuery>;
export type GetCredentialSuspenseQueryHookResult = ReturnType<typeof useGetCredentialSuspenseQuery>;
export type GetCredentialQueryResult = Apollo.QueryResult<GetCredentialQuery, GetCredentialQueryVariables>;
export const GetCredentialsDocument = gql`
    query GetCredentials($filters: FilterCredentialParams, $search: String) {
  credentials(filters: $filters, search: $search) {
    id
    type
    app
    name
    originalFilename
    ecpf {
      commonName
      cpf
      expiresAt
    }
    partnerships {
      id
      partner {
        id
        nickname
        partnershipAsPartner {
          id
          roles {
            id
            role
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCredentialsQuery__
 *
 * To run a query within a React component, call `useGetCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCredentialsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetCredentialsQuery(baseOptions?: Apollo.QueryHookOptions<GetCredentialsQuery, GetCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCredentialsQuery, GetCredentialsQueryVariables>(GetCredentialsDocument, options);
      }
export function useGetCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCredentialsQuery, GetCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCredentialsQuery, GetCredentialsQueryVariables>(GetCredentialsDocument, options);
        }
// @ts-ignore
export function useGetCredentialsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCredentialsQuery, GetCredentialsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCredentialsQuery, GetCredentialsQueryVariables>;
export function useGetCredentialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCredentialsQuery, GetCredentialsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCredentialsQuery | undefined, GetCredentialsQueryVariables>;
export function useGetCredentialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCredentialsQuery, GetCredentialsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCredentialsQuery, GetCredentialsQueryVariables>(GetCredentialsDocument, options);
        }
export type GetCredentialsQueryHookResult = ReturnType<typeof useGetCredentialsQuery>;
export type GetCredentialsLazyQueryHookResult = ReturnType<typeof useGetCredentialsLazyQuery>;
export type GetCredentialsSuspenseQueryHookResult = ReturnType<typeof useGetCredentialsSuspenseQuery>;
export type GetCredentialsQueryResult = Apollo.QueryResult<GetCredentialsQuery, GetCredentialsQueryVariables>;
export const UpdateCredentialDocument = gql`
    mutation UpdateCredential($id: Int!, $params: UpdateCredentialParams!) {
  updateCredential(id: $id, params: $params) {
    id
  }
}
    `;
export type UpdateCredentialMutationFn = Apollo.MutationFunction<UpdateCredentialMutation, UpdateCredentialMutationVariables>;

/**
 * __useUpdateCredentialMutation__
 *
 * To run a mutation, you first call `useUpdateCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCredentialMutation, { data, loading, error }] = useUpdateCredentialMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateCredentialMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCredentialMutation, UpdateCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCredentialMutation, UpdateCredentialMutationVariables>(UpdateCredentialDocument, options);
      }
export type UpdateCredentialMutationHookResult = ReturnType<typeof useUpdateCredentialMutation>;
export type UpdateCredentialMutationResult = Apollo.MutationResult<UpdateCredentialMutation>;
export type UpdateCredentialMutationOptions = Apollo.BaseMutationOptions<UpdateCredentialMutation, UpdateCredentialMutationVariables>;
export const CreateNotificationGroupDocument = gql`
    mutation CreateNotificationGroup($params: CreateNotificationGroupParams!) {
  createNotificationGroup(params: $params) {
    id
    name
    ccEmails
    insertedAt
    notificationGroupRoles {
      id
      role
    }
  }
}
    `;
export type CreateNotificationGroupMutationFn = Apollo.MutationFunction<CreateNotificationGroupMutation, CreateNotificationGroupMutationVariables>;

/**
 * __useCreateNotificationGroupMutation__
 *
 * To run a mutation, you first call `useCreateNotificationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationGroupMutation, { data, loading, error }] = useCreateNotificationGroupMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateNotificationGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotificationGroupMutation, CreateNotificationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotificationGroupMutation, CreateNotificationGroupMutationVariables>(CreateNotificationGroupDocument, options);
      }
export type CreateNotificationGroupMutationHookResult = ReturnType<typeof useCreateNotificationGroupMutation>;
export type CreateNotificationGroupMutationResult = Apollo.MutationResult<CreateNotificationGroupMutation>;
export type CreateNotificationGroupMutationOptions = Apollo.BaseMutationOptions<CreateNotificationGroupMutation, CreateNotificationGroupMutationVariables>;
export const CreateNotificationGroupRecipientDocument = gql`
    mutation CreateNotificationGroupRecipient($params: CreateNotificationGroupRecipientParams!) {
  createNotificationGroupRecipient(params: $params) {
    id
    emails
    language
    partnershipId
    notificationGroupRoleId
  }
}
    `;
export type CreateNotificationGroupRecipientMutationFn = Apollo.MutationFunction<CreateNotificationGroupRecipientMutation, CreateNotificationGroupRecipientMutationVariables>;

/**
 * __useCreateNotificationGroupRecipientMutation__
 *
 * To run a mutation, you first call `useCreateNotificationGroupRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationGroupRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationGroupRecipientMutation, { data, loading, error }] = useCreateNotificationGroupRecipientMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateNotificationGroupRecipientMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotificationGroupRecipientMutation, CreateNotificationGroupRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotificationGroupRecipientMutation, CreateNotificationGroupRecipientMutationVariables>(CreateNotificationGroupRecipientDocument, options);
      }
export type CreateNotificationGroupRecipientMutationHookResult = ReturnType<typeof useCreateNotificationGroupRecipientMutation>;
export type CreateNotificationGroupRecipientMutationResult = Apollo.MutationResult<CreateNotificationGroupRecipientMutation>;
export type CreateNotificationGroupRecipientMutationOptions = Apollo.BaseMutationOptions<CreateNotificationGroupRecipientMutation, CreateNotificationGroupRecipientMutationVariables>;
export const DeleteNotificationGroupDocument = gql`
    mutation DeleteNotificationGroup($id: Int!) {
  deleteNotificationGroup(id: $id) {
    id
  }
}
    `;
export type DeleteNotificationGroupMutationFn = Apollo.MutationFunction<DeleteNotificationGroupMutation, DeleteNotificationGroupMutationVariables>;

/**
 * __useDeleteNotificationGroupMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationGroupMutation, { data, loading, error }] = useDeleteNotificationGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNotificationGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationGroupMutation, DeleteNotificationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotificationGroupMutation, DeleteNotificationGroupMutationVariables>(DeleteNotificationGroupDocument, options);
      }
export type DeleteNotificationGroupMutationHookResult = ReturnType<typeof useDeleteNotificationGroupMutation>;
export type DeleteNotificationGroupMutationResult = Apollo.MutationResult<DeleteNotificationGroupMutation>;
export type DeleteNotificationGroupMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationGroupMutation, DeleteNotificationGroupMutationVariables>;
export const DeleteNotificationGroupRecipientDocument = gql`
    mutation DeleteNotificationGroupRecipient($id: Int!) {
  deleteNotificationGroupRecipient(id: $id) {
    id
  }
}
    `;
export type DeleteNotificationGroupRecipientMutationFn = Apollo.MutationFunction<DeleteNotificationGroupRecipientMutation, DeleteNotificationGroupRecipientMutationVariables>;

/**
 * __useDeleteNotificationGroupRecipientMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationGroupRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationGroupRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationGroupRecipientMutation, { data, loading, error }] = useDeleteNotificationGroupRecipientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNotificationGroupRecipientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationGroupRecipientMutation, DeleteNotificationGroupRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotificationGroupRecipientMutation, DeleteNotificationGroupRecipientMutationVariables>(DeleteNotificationGroupRecipientDocument, options);
      }
export type DeleteNotificationGroupRecipientMutationHookResult = ReturnType<typeof useDeleteNotificationGroupRecipientMutation>;
export type DeleteNotificationGroupRecipientMutationResult = Apollo.MutationResult<DeleteNotificationGroupRecipientMutation>;
export type DeleteNotificationGroupRecipientMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationGroupRecipientMutation, DeleteNotificationGroupRecipientMutationVariables>;
export const GetNotificationGroupByIdDocument = gql`
    query GetNotificationGroupById($id: Int!) {
  notificationGroup(id: $id) {
    id
    name
    ccEmails
    insertedAt
    notificationGroupRoles {
      id
      role
      notificationGroupRecipients {
        id
        emails
        language
        partnershipId
        notificationGroupRoleId
        partnership {
          id
          nicknameWithFallback
        }
      }
    }
  }
}
    `;

/**
 * __useGetNotificationGroupByIdQuery__
 *
 * To run a query within a React component, call `useGetNotificationGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationGroupByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNotificationGroupByIdQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationGroupByIdQuery, GetNotificationGroupByIdQueryVariables> & ({ variables: GetNotificationGroupByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationGroupByIdQuery, GetNotificationGroupByIdQueryVariables>(GetNotificationGroupByIdDocument, options);
      }
export function useGetNotificationGroupByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationGroupByIdQuery, GetNotificationGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationGroupByIdQuery, GetNotificationGroupByIdQueryVariables>(GetNotificationGroupByIdDocument, options);
        }
// @ts-ignore
export function useGetNotificationGroupByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationGroupByIdQuery, GetNotificationGroupByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationGroupByIdQuery, GetNotificationGroupByIdQueryVariables>;
export function useGetNotificationGroupByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationGroupByIdQuery, GetNotificationGroupByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationGroupByIdQuery | undefined, GetNotificationGroupByIdQueryVariables>;
export function useGetNotificationGroupByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationGroupByIdQuery, GetNotificationGroupByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationGroupByIdQuery, GetNotificationGroupByIdQueryVariables>(GetNotificationGroupByIdDocument, options);
        }
export type GetNotificationGroupByIdQueryHookResult = ReturnType<typeof useGetNotificationGroupByIdQuery>;
export type GetNotificationGroupByIdLazyQueryHookResult = ReturnType<typeof useGetNotificationGroupByIdLazyQuery>;
export type GetNotificationGroupByIdSuspenseQueryHookResult = ReturnType<typeof useGetNotificationGroupByIdSuspenseQuery>;
export type GetNotificationGroupByIdQueryResult = Apollo.QueryResult<GetNotificationGroupByIdQuery, GetNotificationGroupByIdQueryVariables>;
export const GetNotificationGroupsDocument = gql`
    query GetNotificationGroups($pagination: NotificationGroupPaginationParams, $filters: FilterNotificationGroupParams, $search: String) {
  notificationGroups(pagination: $pagination, filters: $filters, search: $search) {
    id
    name
    ccEmails
    insertedAt
    updatedAt
    notificationGroupRoles {
      id
      role
    }
  }
}
    `;

/**
 * __useGetNotificationGroupsQuery__
 *
 * To run a query within a React component, call `useGetNotificationGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationGroupsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetNotificationGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationGroupsQuery, GetNotificationGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationGroupsQuery, GetNotificationGroupsQueryVariables>(GetNotificationGroupsDocument, options);
      }
export function useGetNotificationGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationGroupsQuery, GetNotificationGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationGroupsQuery, GetNotificationGroupsQueryVariables>(GetNotificationGroupsDocument, options);
        }
// @ts-ignore
export function useGetNotificationGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationGroupsQuery, GetNotificationGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationGroupsQuery, GetNotificationGroupsQueryVariables>;
export function useGetNotificationGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationGroupsQuery, GetNotificationGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationGroupsQuery | undefined, GetNotificationGroupsQueryVariables>;
export function useGetNotificationGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationGroupsQuery, GetNotificationGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationGroupsQuery, GetNotificationGroupsQueryVariables>(GetNotificationGroupsDocument, options);
        }
export type GetNotificationGroupsQueryHookResult = ReturnType<typeof useGetNotificationGroupsQuery>;
export type GetNotificationGroupsLazyQueryHookResult = ReturnType<typeof useGetNotificationGroupsLazyQuery>;
export type GetNotificationGroupsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationGroupsSuspenseQuery>;
export type GetNotificationGroupsQueryResult = Apollo.QueryResult<GetNotificationGroupsQuery, GetNotificationGroupsQueryVariables>;
export const GetNotificationGroupsCountDocument = gql`
    query GetNotificationGroupsCount($filters: FilterNotificationGroupParams, $search: String) {
  notificationGroupsCount(filters: $filters, search: $search)
}
    `;

/**
 * __useGetNotificationGroupsCountQuery__
 *
 * To run a query within a React component, call `useGetNotificationGroupsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationGroupsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationGroupsCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetNotificationGroupsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationGroupsCountQuery, GetNotificationGroupsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationGroupsCountQuery, GetNotificationGroupsCountQueryVariables>(GetNotificationGroupsCountDocument, options);
      }
export function useGetNotificationGroupsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationGroupsCountQuery, GetNotificationGroupsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationGroupsCountQuery, GetNotificationGroupsCountQueryVariables>(GetNotificationGroupsCountDocument, options);
        }
// @ts-ignore
export function useGetNotificationGroupsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationGroupsCountQuery, GetNotificationGroupsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationGroupsCountQuery, GetNotificationGroupsCountQueryVariables>;
export function useGetNotificationGroupsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationGroupsCountQuery, GetNotificationGroupsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationGroupsCountQuery | undefined, GetNotificationGroupsCountQueryVariables>;
export function useGetNotificationGroupsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationGroupsCountQuery, GetNotificationGroupsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationGroupsCountQuery, GetNotificationGroupsCountQueryVariables>(GetNotificationGroupsCountDocument, options);
        }
export type GetNotificationGroupsCountQueryHookResult = ReturnType<typeof useGetNotificationGroupsCountQuery>;
export type GetNotificationGroupsCountLazyQueryHookResult = ReturnType<typeof useGetNotificationGroupsCountLazyQuery>;
export type GetNotificationGroupsCountSuspenseQueryHookResult = ReturnType<typeof useGetNotificationGroupsCountSuspenseQuery>;
export type GetNotificationGroupsCountQueryResult = Apollo.QueryResult<GetNotificationGroupsCountQuery, GetNotificationGroupsCountQueryVariables>;
export const UpdateNotificationGroupDocument = gql`
    mutation UpdateNotificationGroup($id: Int!, $params: UpdateNotificationGroupParams!) {
  updateNotificationGroup(id: $id, params: $params) {
    id
    name
    ccEmails
    insertedAt
    notificationGroupRoles {
      id
      role
    }
  }
}
    `;
export type UpdateNotificationGroupMutationFn = Apollo.MutationFunction<UpdateNotificationGroupMutation, UpdateNotificationGroupMutationVariables>;

/**
 * __useUpdateNotificationGroupMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationGroupMutation, { data, loading, error }] = useUpdateNotificationGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateNotificationGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationGroupMutation, UpdateNotificationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationGroupMutation, UpdateNotificationGroupMutationVariables>(UpdateNotificationGroupDocument, options);
      }
export type UpdateNotificationGroupMutationHookResult = ReturnType<typeof useUpdateNotificationGroupMutation>;
export type UpdateNotificationGroupMutationResult = Apollo.MutationResult<UpdateNotificationGroupMutation>;
export type UpdateNotificationGroupMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationGroupMutation, UpdateNotificationGroupMutationVariables>;
export const UpdateNotificationGroupRecipientDocument = gql`
    mutation UpdateNotificationGroupRecipient($id: Int!, $params: UpdateNotificationGroupRecipientParams!) {
  updateNotificationGroupRecipient(id: $id, params: $params) {
    id
    emails
    language
    partnershipId
    notificationGroupRoleId
  }
}
    `;
export type UpdateNotificationGroupRecipientMutationFn = Apollo.MutationFunction<UpdateNotificationGroupRecipientMutation, UpdateNotificationGroupRecipientMutationVariables>;

/**
 * __useUpdateNotificationGroupRecipientMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationGroupRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationGroupRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationGroupRecipientMutation, { data, loading, error }] = useUpdateNotificationGroupRecipientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateNotificationGroupRecipientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationGroupRecipientMutation, UpdateNotificationGroupRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationGroupRecipientMutation, UpdateNotificationGroupRecipientMutationVariables>(UpdateNotificationGroupRecipientDocument, options);
      }
export type UpdateNotificationGroupRecipientMutationHookResult = ReturnType<typeof useUpdateNotificationGroupRecipientMutation>;
export type UpdateNotificationGroupRecipientMutationResult = Apollo.MutationResult<UpdateNotificationGroupRecipientMutation>;
export type UpdateNotificationGroupRecipientMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationGroupRecipientMutation, UpdateNotificationGroupRecipientMutationVariables>;
export const CreateOrInviteUserDocument = gql`
    mutation CreateOrInviteUser($params: CreateUserParams!) {
  createOrInviteUser(params: $params) {
    ...GetUsersFragment
  }
}
    ${GetUsersFragmentFragmentDoc}`;
export type CreateOrInviteUserMutationFn = Apollo.MutationFunction<CreateOrInviteUserMutation, CreateOrInviteUserMutationVariables>;

/**
 * __useCreateOrInviteUserMutation__
 *
 * To run a mutation, you first call `useCreateOrInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrInviteUserMutation, { data, loading, error }] = useCreateOrInviteUserMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateOrInviteUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrInviteUserMutation, CreateOrInviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrInviteUserMutation, CreateOrInviteUserMutationVariables>(CreateOrInviteUserDocument, options);
      }
export type CreateOrInviteUserMutationHookResult = ReturnType<typeof useCreateOrInviteUserMutation>;
export type CreateOrInviteUserMutationResult = Apollo.MutationResult<CreateOrInviteUserMutation>;
export type CreateOrInviteUserMutationOptions = Apollo.BaseMutationOptions<CreateOrInviteUserMutation, CreateOrInviteUserMutationVariables>;
export const DeleteOrRemoveUserFromWorkspaceDocument = gql`
    mutation DeleteOrRemoveUserFromWorkspace($id: String!) {
  deleteOrRemoveUserFromWorkspace(id: $id) {
    ...GetUsersFragment
  }
}
    ${GetUsersFragmentFragmentDoc}`;
export type DeleteOrRemoveUserFromWorkspaceMutationFn = Apollo.MutationFunction<DeleteOrRemoveUserFromWorkspaceMutation, DeleteOrRemoveUserFromWorkspaceMutationVariables>;

/**
 * __useDeleteOrRemoveUserFromWorkspaceMutation__
 *
 * To run a mutation, you first call `useDeleteOrRemoveUserFromWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrRemoveUserFromWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrRemoveUserFromWorkspaceMutation, { data, loading, error }] = useDeleteOrRemoveUserFromWorkspaceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrRemoveUserFromWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrRemoveUserFromWorkspaceMutation, DeleteOrRemoveUserFromWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrRemoveUserFromWorkspaceMutation, DeleteOrRemoveUserFromWorkspaceMutationVariables>(DeleteOrRemoveUserFromWorkspaceDocument, options);
      }
export type DeleteOrRemoveUserFromWorkspaceMutationHookResult = ReturnType<typeof useDeleteOrRemoveUserFromWorkspaceMutation>;
export type DeleteOrRemoveUserFromWorkspaceMutationResult = Apollo.MutationResult<DeleteOrRemoveUserFromWorkspaceMutation>;
export type DeleteOrRemoveUserFromWorkspaceMutationOptions = Apollo.BaseMutationOptions<DeleteOrRemoveUserFromWorkspaceMutation, DeleteOrRemoveUserFromWorkspaceMutationVariables>;
export const GetUsersDocument = gql`
    query GetUsers($pagination: UserPaginationParams, $search: String) {
  usersTable(pagination: $pagination, search: $search) {
    totalCount
    users {
      ...GetUsersFragment
    }
  }
}
    ${GetUsersFragmentFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
// @ts-ignore
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersQuery | undefined, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($id: String!, $params: UpdateUserParams!) {
  updateUser(id: $id, params: $params) {
    ...GetUsersFragment
  }
}
    ${GetUsersFragmentFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const GetUserWorkspaceSettingsDocument = gql`
    query GetUserWorkspaceSettings {
  currentUser {
    id
    currentWorkspace {
      client {
        id
        actor {
          id
          nickname
          documentType
          officialName
          officialDocument
          logoUrl
          partnershipAsPartner {
            id
            roles {
              id
              role
            }
          }
          addresses {
            id
            name
            latitude
            longitude
            country
            state
            city
            street
            number
            postalCode
            neighborhood
            complement
            reference
            formattedAddress
            routePoints {
              id
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserWorkspaceSettingsQuery__
 *
 * To run a query within a React component, call `useGetUserWorkspaceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWorkspaceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWorkspaceSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserWorkspaceSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserWorkspaceSettingsQuery, GetUserWorkspaceSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserWorkspaceSettingsQuery, GetUserWorkspaceSettingsQueryVariables>(GetUserWorkspaceSettingsDocument, options);
      }
export function useGetUserWorkspaceSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserWorkspaceSettingsQuery, GetUserWorkspaceSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserWorkspaceSettingsQuery, GetUserWorkspaceSettingsQueryVariables>(GetUserWorkspaceSettingsDocument, options);
        }
// @ts-ignore
export function useGetUserWorkspaceSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserWorkspaceSettingsQuery, GetUserWorkspaceSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserWorkspaceSettingsQuery, GetUserWorkspaceSettingsQueryVariables>;
export function useGetUserWorkspaceSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserWorkspaceSettingsQuery, GetUserWorkspaceSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserWorkspaceSettingsQuery | undefined, GetUserWorkspaceSettingsQueryVariables>;
export function useGetUserWorkspaceSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserWorkspaceSettingsQuery, GetUserWorkspaceSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserWorkspaceSettingsQuery, GetUserWorkspaceSettingsQueryVariables>(GetUserWorkspaceSettingsDocument, options);
        }
export type GetUserWorkspaceSettingsQueryHookResult = ReturnType<typeof useGetUserWorkspaceSettingsQuery>;
export type GetUserWorkspaceSettingsLazyQueryHookResult = ReturnType<typeof useGetUserWorkspaceSettingsLazyQuery>;
export type GetUserWorkspaceSettingsSuspenseQueryHookResult = ReturnType<typeof useGetUserWorkspaceSettingsSuspenseQuery>;
export type GetUserWorkspaceSettingsQueryResult = Apollo.QueryResult<GetUserWorkspaceSettingsQuery, GetUserWorkspaceSettingsQueryVariables>;
export const UpdateSelfPartnershipDocument = gql`
    mutation UpdateSelfPartnership($partnerId: Int!, $params: UpdatePartnershipParams!) {
  updatePartnership(partnerId: $partnerId, params: $params) {
    id
  }
}
    `;
export type UpdateSelfPartnershipMutationFn = Apollo.MutationFunction<UpdateSelfPartnershipMutation, UpdateSelfPartnershipMutationVariables>;

/**
 * __useUpdateSelfPartnershipMutation__
 *
 * To run a mutation, you first call `useUpdateSelfPartnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSelfPartnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSelfPartnershipMutation, { data, loading, error }] = useUpdateSelfPartnershipMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateSelfPartnershipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSelfPartnershipMutation, UpdateSelfPartnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSelfPartnershipMutation, UpdateSelfPartnershipMutationVariables>(UpdateSelfPartnershipDocument, options);
      }
export type UpdateSelfPartnershipMutationHookResult = ReturnType<typeof useUpdateSelfPartnershipMutation>;
export type UpdateSelfPartnershipMutationResult = Apollo.MutationResult<UpdateSelfPartnershipMutation>;
export type UpdateSelfPartnershipMutationOptions = Apollo.BaseMutationOptions<UpdateSelfPartnershipMutation, UpdateSelfPartnershipMutationVariables>;
export const UpdateActorDocument = gql`
    mutation UpdateActor($id: Int!, $params: UpdateActorParams!) {
  updateActor(id: $id, params: $params) {
    id
    nickname
  }
}
    `;
export type UpdateActorMutationFn = Apollo.MutationFunction<UpdateActorMutation, UpdateActorMutationVariables>;

/**
 * __useUpdateActorMutation__
 *
 * To run a mutation, you first call `useUpdateActorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActorMutation, { data, loading, error }] = useUpdateActorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateActorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActorMutation, UpdateActorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActorMutation, UpdateActorMutationVariables>(UpdateActorDocument, options);
      }
export type UpdateActorMutationHookResult = ReturnType<typeof useUpdateActorMutation>;
export type UpdateActorMutationResult = Apollo.MutationResult<UpdateActorMutation>;
export type UpdateActorMutationOptions = Apollo.BaseMutationOptions<UpdateActorMutation, UpdateActorMutationVariables>;
export const UpdateUserPreferenceDocument = gql`
    mutation UpdateUserPreference($params: UpdateUserPreferenceParams!) {
  updateUserPreference(params: $params) {
    id
    userMetadata {
      userPreference {
        language
      }
    }
  }
}
    `;
export type UpdateUserPreferenceMutationFn = Apollo.MutationFunction<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>;

/**
 * __useUpdateUserPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateUserPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPreferenceMutation, { data, loading, error }] = useUpdateUserPreferenceMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateUserPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>(UpdateUserPreferenceDocument, options);
      }
export type UpdateUserPreferenceMutationHookResult = ReturnType<typeof useUpdateUserPreferenceMutation>;
export type UpdateUserPreferenceMutationResult = Apollo.MutationResult<UpdateUserPreferenceMutation>;
export type UpdateUserPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>;
export const TrailersCountDocument = gql`
    query TrailersCount($search: String) {
  trailersCount(search: $search)
}
    `;

/**
 * __useTrailersCountQuery__
 *
 * To run a query within a React component, call `useTrailersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrailersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrailersCountQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useTrailersCountQuery(baseOptions?: Apollo.QueryHookOptions<TrailersCountQuery, TrailersCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrailersCountQuery, TrailersCountQueryVariables>(TrailersCountDocument, options);
      }
export function useTrailersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrailersCountQuery, TrailersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrailersCountQuery, TrailersCountQueryVariables>(TrailersCountDocument, options);
        }
// @ts-ignore
export function useTrailersCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrailersCountQuery, TrailersCountQueryVariables>): Apollo.UseSuspenseQueryResult<TrailersCountQuery, TrailersCountQueryVariables>;
export function useTrailersCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrailersCountQuery, TrailersCountQueryVariables>): Apollo.UseSuspenseQueryResult<TrailersCountQuery | undefined, TrailersCountQueryVariables>;
export function useTrailersCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrailersCountQuery, TrailersCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrailersCountQuery, TrailersCountQueryVariables>(TrailersCountDocument, options);
        }
export type TrailersCountQueryHookResult = ReturnType<typeof useTrailersCountQuery>;
export type TrailersCountLazyQueryHookResult = ReturnType<typeof useTrailersCountLazyQuery>;
export type TrailersCountSuspenseQueryHookResult = ReturnType<typeof useTrailersCountSuspenseQuery>;
export type TrailersCountQueryResult = Apollo.QueryResult<TrailersCountQuery, TrailersCountQueryVariables>;
export const CreateTrailerDocument = gql`
    mutation CreateTrailer($params: CreateTrailerParams!) {
  createTrailer(params: $params) {
    id
  }
}
    `;
export type CreateTrailerMutationFn = Apollo.MutationFunction<CreateTrailerMutation, CreateTrailerMutationVariables>;

/**
 * __useCreateTrailerMutation__
 *
 * To run a mutation, you first call `useCreateTrailerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrailerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrailerMutation, { data, loading, error }] = useCreateTrailerMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateTrailerMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrailerMutation, CreateTrailerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrailerMutation, CreateTrailerMutationVariables>(CreateTrailerDocument, options);
      }
export type CreateTrailerMutationHookResult = ReturnType<typeof useCreateTrailerMutation>;
export type CreateTrailerMutationResult = Apollo.MutationResult<CreateTrailerMutation>;
export type CreateTrailerMutationOptions = Apollo.BaseMutationOptions<CreateTrailerMutation, CreateTrailerMutationVariables>;
export const DeleteTrailerDocument = gql`
    mutation DeleteTrailer($id: Int!) {
  deleteTrailer(id: $id) {
    id
  }
}
    `;
export type DeleteTrailerMutationFn = Apollo.MutationFunction<DeleteTrailerMutation, DeleteTrailerMutationVariables>;

/**
 * __useDeleteTrailerMutation__
 *
 * To run a mutation, you first call `useDeleteTrailerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrailerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrailerMutation, { data, loading, error }] = useDeleteTrailerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTrailerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTrailerMutation, DeleteTrailerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTrailerMutation, DeleteTrailerMutationVariables>(DeleteTrailerDocument, options);
      }
export type DeleteTrailerMutationHookResult = ReturnType<typeof useDeleteTrailerMutation>;
export type DeleteTrailerMutationResult = Apollo.MutationResult<DeleteTrailerMutation>;
export type DeleteTrailerMutationOptions = Apollo.BaseMutationOptions<DeleteTrailerMutation, DeleteTrailerMutationVariables>;
export const TrailerDocument = gql`
    query Trailer($id: Int!) {
  trailer(id: $id) {
    id
    plate
    type
    isRefrigerated
    trackerBrand
    trackerId
    speedLimitDry
    speedLimitWet
    tareWeightKg
    temperatureMax
    temperatureMin
  }
}
    `;

/**
 * __useTrailerQuery__
 *
 * To run a query within a React component, call `useTrailerQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrailerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrailerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrailerQuery(baseOptions: Apollo.QueryHookOptions<TrailerQuery, TrailerQueryVariables> & ({ variables: TrailerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrailerQuery, TrailerQueryVariables>(TrailerDocument, options);
      }
export function useTrailerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrailerQuery, TrailerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrailerQuery, TrailerQueryVariables>(TrailerDocument, options);
        }
// @ts-ignore
export function useTrailerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrailerQuery, TrailerQueryVariables>): Apollo.UseSuspenseQueryResult<TrailerQuery, TrailerQueryVariables>;
export function useTrailerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrailerQuery, TrailerQueryVariables>): Apollo.UseSuspenseQueryResult<TrailerQuery | undefined, TrailerQueryVariables>;
export function useTrailerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrailerQuery, TrailerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrailerQuery, TrailerQueryVariables>(TrailerDocument, options);
        }
export type TrailerQueryHookResult = ReturnType<typeof useTrailerQuery>;
export type TrailerLazyQueryHookResult = ReturnType<typeof useTrailerLazyQuery>;
export type TrailerSuspenseQueryHookResult = ReturnType<typeof useTrailerSuspenseQuery>;
export type TrailerQueryResult = Apollo.QueryResult<TrailerQuery, TrailerQueryVariables>;
export const TrailersDocument = gql`
    query Trailers($search: String, $pagination: TrailerPaginationParams) {
  trailers(search: $search, pagination: $pagination) {
    id
    plate
    type
    isRefrigerated
    trackerBrand
    trackerId
    speedLimitDry
    speedLimitWet
    tareWeightKg
    temperatureMax
    temperatureMin
  }
}
    `;

/**
 * __useTrailersQuery__
 *
 * To run a query within a React component, call `useTrailersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrailersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrailersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useTrailersQuery(baseOptions?: Apollo.QueryHookOptions<TrailersQuery, TrailersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrailersQuery, TrailersQueryVariables>(TrailersDocument, options);
      }
export function useTrailersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrailersQuery, TrailersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrailersQuery, TrailersQueryVariables>(TrailersDocument, options);
        }
// @ts-ignore
export function useTrailersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrailersQuery, TrailersQueryVariables>): Apollo.UseSuspenseQueryResult<TrailersQuery, TrailersQueryVariables>;
export function useTrailersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrailersQuery, TrailersQueryVariables>): Apollo.UseSuspenseQueryResult<TrailersQuery | undefined, TrailersQueryVariables>;
export function useTrailersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrailersQuery, TrailersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrailersQuery, TrailersQueryVariables>(TrailersDocument, options);
        }
export type TrailersQueryHookResult = ReturnType<typeof useTrailersQuery>;
export type TrailersLazyQueryHookResult = ReturnType<typeof useTrailersLazyQuery>;
export type TrailersSuspenseQueryHookResult = ReturnType<typeof useTrailersSuspenseQuery>;
export type TrailersQueryResult = Apollo.QueryResult<TrailersQuery, TrailersQueryVariables>;
export const UpdateTrailerDocument = gql`
    mutation UpdateTrailer($id: Int!, $params: UpdateTrailerParams!) {
  updateTrailer(id: $id, params: $params) {
    id
    plate
    type
    isRefrigerated
    trackerBrand
    trackerId
    speedLimitDry
    speedLimitWet
    tareWeightKg
    temperatureMax
    temperatureMin
  }
}
    `;
export type UpdateTrailerMutationFn = Apollo.MutationFunction<UpdateTrailerMutation, UpdateTrailerMutationVariables>;

/**
 * __useUpdateTrailerMutation__
 *
 * To run a mutation, you first call `useUpdateTrailerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrailerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrailerMutation, { data, loading, error }] = useUpdateTrailerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateTrailerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrailerMutation, UpdateTrailerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrailerMutation, UpdateTrailerMutationVariables>(UpdateTrailerDocument, options);
      }
export type UpdateTrailerMutationHookResult = ReturnType<typeof useUpdateTrailerMutation>;
export type UpdateTrailerMutationResult = Apollo.MutationResult<UpdateTrailerMutation>;
export type UpdateTrailerMutationOptions = Apollo.BaseMutationOptions<UpdateTrailerMutation, UpdateTrailerMutationVariables>;
export const VehiclesCountDocument = gql`
    query VehiclesCount($search: String) {
  vehiclesCount(search: $search)
}
    `;

/**
 * __useVehiclesCountQuery__
 *
 * To run a query within a React component, call `useVehiclesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehiclesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehiclesCountQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useVehiclesCountQuery(baseOptions?: Apollo.QueryHookOptions<VehiclesCountQuery, VehiclesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VehiclesCountQuery, VehiclesCountQueryVariables>(VehiclesCountDocument, options);
      }
export function useVehiclesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VehiclesCountQuery, VehiclesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VehiclesCountQuery, VehiclesCountQueryVariables>(VehiclesCountDocument, options);
        }
// @ts-ignore
export function useVehiclesCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VehiclesCountQuery, VehiclesCountQueryVariables>): Apollo.UseSuspenseQueryResult<VehiclesCountQuery, VehiclesCountQueryVariables>;
export function useVehiclesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VehiclesCountQuery, VehiclesCountQueryVariables>): Apollo.UseSuspenseQueryResult<VehiclesCountQuery | undefined, VehiclesCountQueryVariables>;
export function useVehiclesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VehiclesCountQuery, VehiclesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VehiclesCountQuery, VehiclesCountQueryVariables>(VehiclesCountDocument, options);
        }
export type VehiclesCountQueryHookResult = ReturnType<typeof useVehiclesCountQuery>;
export type VehiclesCountLazyQueryHookResult = ReturnType<typeof useVehiclesCountLazyQuery>;
export type VehiclesCountSuspenseQueryHookResult = ReturnType<typeof useVehiclesCountSuspenseQuery>;
export type VehiclesCountQueryResult = Apollo.QueryResult<VehiclesCountQuery, VehiclesCountQueryVariables>;
export const CreateVehicleDocument = gql`
    mutation CreateVehicle($params: CreateVehicleParams!) {
  createVehicle(params: $params) {
    id
  }
}
    `;
export type CreateVehicleMutationFn = Apollo.MutationFunction<CreateVehicleMutation, CreateVehicleMutationVariables>;

/**
 * __useCreateVehicleMutation__
 *
 * To run a mutation, you first call `useCreateVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVehicleMutation, { data, loading, error }] = useCreateVehicleMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateVehicleMutation(baseOptions?: Apollo.MutationHookOptions<CreateVehicleMutation, CreateVehicleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVehicleMutation, CreateVehicleMutationVariables>(CreateVehicleDocument, options);
      }
export type CreateVehicleMutationHookResult = ReturnType<typeof useCreateVehicleMutation>;
export type CreateVehicleMutationResult = Apollo.MutationResult<CreateVehicleMutation>;
export type CreateVehicleMutationOptions = Apollo.BaseMutationOptions<CreateVehicleMutation, CreateVehicleMutationVariables>;
export const DeleteVehicleDocument = gql`
    mutation DeleteVehicle($id: Int!) {
  deleteVehicle(id: $id) {
    id
  }
}
    `;
export type DeleteVehicleMutationFn = Apollo.MutationFunction<DeleteVehicleMutation, DeleteVehicleMutationVariables>;

/**
 * __useDeleteVehicleMutation__
 *
 * To run a mutation, you first call `useDeleteVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVehicleMutation, { data, loading, error }] = useDeleteVehicleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVehicleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVehicleMutation, DeleteVehicleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVehicleMutation, DeleteVehicleMutationVariables>(DeleteVehicleDocument, options);
      }
export type DeleteVehicleMutationHookResult = ReturnType<typeof useDeleteVehicleMutation>;
export type DeleteVehicleMutationResult = Apollo.MutationResult<DeleteVehicleMutation>;
export type DeleteVehicleMutationOptions = Apollo.BaseMutationOptions<DeleteVehicleMutation, DeleteVehicleMutationVariables>;
export const VehicleDocument = gql`
    query Vehicle($id: Int!) {
  vehicle(id: $id) {
    id
    plate
    type
    isRefrigerated
    trackerBrand
    trackerId
    speedLimitDry
    speedLimitWet
    tareWeightKg
    temperatureMax
    temperatureMin
  }
}
    `;

/**
 * __useVehicleQuery__
 *
 * To run a query within a React component, call `useVehicleQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVehicleQuery(baseOptions: Apollo.QueryHookOptions<VehicleQuery, VehicleQueryVariables> & ({ variables: VehicleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VehicleQuery, VehicleQueryVariables>(VehicleDocument, options);
      }
export function useVehicleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VehicleQuery, VehicleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VehicleQuery, VehicleQueryVariables>(VehicleDocument, options);
        }
// @ts-ignore
export function useVehicleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VehicleQuery, VehicleQueryVariables>): Apollo.UseSuspenseQueryResult<VehicleQuery, VehicleQueryVariables>;
export function useVehicleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VehicleQuery, VehicleQueryVariables>): Apollo.UseSuspenseQueryResult<VehicleQuery | undefined, VehicleQueryVariables>;
export function useVehicleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VehicleQuery, VehicleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VehicleQuery, VehicleQueryVariables>(VehicleDocument, options);
        }
export type VehicleQueryHookResult = ReturnType<typeof useVehicleQuery>;
export type VehicleLazyQueryHookResult = ReturnType<typeof useVehicleLazyQuery>;
export type VehicleSuspenseQueryHookResult = ReturnType<typeof useVehicleSuspenseQuery>;
export type VehicleQueryResult = Apollo.QueryResult<VehicleQuery, VehicleQueryVariables>;
export const VehiclesDocument = gql`
    query Vehicles($search: String, $pagination: VehiclePaginationParams) {
  vehicles(search: $search, pagination: $pagination) {
    id
    plate
    type
    isRefrigerated
    speedLimitDry
    speedLimitWet
    tareWeightKg
    temperatureMax
    temperatureMin
    trackerBrand
    trackerId
  }
}
    `;

/**
 * __useVehiclesQuery__
 *
 * To run a query within a React component, call `useVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehiclesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useVehiclesQuery(baseOptions?: Apollo.QueryHookOptions<VehiclesQuery, VehiclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VehiclesQuery, VehiclesQueryVariables>(VehiclesDocument, options);
      }
export function useVehiclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VehiclesQuery, VehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VehiclesQuery, VehiclesQueryVariables>(VehiclesDocument, options);
        }
// @ts-ignore
export function useVehiclesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VehiclesQuery, VehiclesQueryVariables>): Apollo.UseSuspenseQueryResult<VehiclesQuery, VehiclesQueryVariables>;
export function useVehiclesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VehiclesQuery, VehiclesQueryVariables>): Apollo.UseSuspenseQueryResult<VehiclesQuery | undefined, VehiclesQueryVariables>;
export function useVehiclesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VehiclesQuery, VehiclesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VehiclesQuery, VehiclesQueryVariables>(VehiclesDocument, options);
        }
export type VehiclesQueryHookResult = ReturnType<typeof useVehiclesQuery>;
export type VehiclesLazyQueryHookResult = ReturnType<typeof useVehiclesLazyQuery>;
export type VehiclesSuspenseQueryHookResult = ReturnType<typeof useVehiclesSuspenseQuery>;
export type VehiclesQueryResult = Apollo.QueryResult<VehiclesQuery, VehiclesQueryVariables>;
export const UpdateVehicleDocument = gql`
    mutation UpdateVehicle($id: Int!, $params: UpdateVehicleParams!) {
  updateVehicle(id: $id, params: $params) {
    id
    plate
    type
    isRefrigerated
    trackerBrand
    trackerId
    speedLimitDry
    speedLimitWet
    tareWeightKg
    temperatureMax
    temperatureMin
  }
}
    `;
export type UpdateVehicleMutationFn = Apollo.MutationFunction<UpdateVehicleMutation, UpdateVehicleMutationVariables>;

/**
 * __useUpdateVehicleMutation__
 *
 * To run a mutation, you first call `useUpdateVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVehicleMutation, { data, loading, error }] = useUpdateVehicleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateVehicleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVehicleMutation, UpdateVehicleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVehicleMutation, UpdateVehicleMutationVariables>(UpdateVehicleDocument, options);
      }
export type UpdateVehicleMutationHookResult = ReturnType<typeof useUpdateVehicleMutation>;
export type UpdateVehicleMutationResult = Apollo.MutationResult<UpdateVehicleMutation>;
export type UpdateVehicleMutationOptions = Apollo.BaseMutationOptions<UpdateVehicleMutation, UpdateVehicleMutationVariables>;
export const GetCurrentUserDashboardsDocument = gql`
    query GetCurrentUserDashboards {
  currentUser {
    id
    currentWorkspace {
      currentAccessGroup {
        id
        dashboardAccesses {
          dashboard {
            id
            label
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserDashboardsQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserDashboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserDashboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserDashboardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserDashboardsQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserDashboardsQuery, GetCurrentUserDashboardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserDashboardsQuery, GetCurrentUserDashboardsQueryVariables>(GetCurrentUserDashboardsDocument, options);
      }
export function useGetCurrentUserDashboardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserDashboardsQuery, GetCurrentUserDashboardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserDashboardsQuery, GetCurrentUserDashboardsQueryVariables>(GetCurrentUserDashboardsDocument, options);
        }
// @ts-ignore
export function useGetCurrentUserDashboardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserDashboardsQuery, GetCurrentUserDashboardsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserDashboardsQuery, GetCurrentUserDashboardsQueryVariables>;
export function useGetCurrentUserDashboardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserDashboardsQuery, GetCurrentUserDashboardsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserDashboardsQuery | undefined, GetCurrentUserDashboardsQueryVariables>;
export function useGetCurrentUserDashboardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserDashboardsQuery, GetCurrentUserDashboardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserDashboardsQuery, GetCurrentUserDashboardsQueryVariables>(GetCurrentUserDashboardsDocument, options);
        }
export type GetCurrentUserDashboardsQueryHookResult = ReturnType<typeof useGetCurrentUserDashboardsQuery>;
export type GetCurrentUserDashboardsLazyQueryHookResult = ReturnType<typeof useGetCurrentUserDashboardsLazyQuery>;
export type GetCurrentUserDashboardsSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserDashboardsSuspenseQuery>;
export type GetCurrentUserDashboardsQueryResult = Apollo.QueryResult<GetCurrentUserDashboardsQuery, GetCurrentUserDashboardsQueryVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  currentUser {
    id
    name
    registrationComplete
    featureAccesses {
      type
      slug
    }
    currentWorkspace {
      client {
        id
        actor {
          id
          nickname
        }
      }
      currentAccessGroup {
        id
        slug
      }
    }
    workspaces {
      client {
        id
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
// @ts-ignore
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserQuery | undefined, GetCurrentUserQueryVariables>;
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;